<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 612 369.3"
    style="enable-background: new 0 0 612 369.3"
    xml:space="preserve"
  >
    <g id="C1" :fill="fill">
      <path
        class="st3"
        d="M303,115.1c-0.9,0.4-1.4,1.1-1.5,2s0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8c0.1,0.1,0.2,0.1,0.2,0.2v-2.9V118
		v-4c-0.7,0.2-1.3,0.4-2,0.6c0,1,0,2.1,0,3.1c-0.3,0-0.6,0-0.9,0C303.2,116.9,303.1,116,303,115.1z"
      />
      <path
        class="st3"
        d="M250.2,139.8L250.2,139.8C250.1,139.7,250.1,139.8,250.2,139.8C250.1,139.8,250.2,139.8,250.2,139.8z"
      />
      <path
        class="st3"
        d="M106.4,307.1c0,0.1,0,0.2,0,0.3c0.1-0.2,0.2-0.3,0.3-0.4C106.6,307,106.5,307.1,106.4,307.1z"
      />
      <path
        class="st3"
        d="M107.4,309.8c0.7,0.6,1.6,1,2.6,1c0.3,0,0.7,0,1-0.1c1.8-0.4,3-1.8,3-3.4v-0.1
		C111.8,308.2,109.6,309,107.4,309.8z"
      />
      <path
        class="st3"
        d="M103.7,301.5c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3
		c0.9,0.1,1.4,0.6,2,1c0.5,0.4,1,0.6,1.5,0.7c0.2,0,0.4,0,0.6,0c0.8-0.4,1.5-0.9,2.3-1.3c1.2-0.6,2.6-1.1,3.8-1.7
		c-0.1,0-0.1,0-0.2,0s-0.1,0-0.2,0.1c-0.4,0.1-0.7,0.2-1.1,0.3c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5
		c0.2-1.1-0.4-2-1.2-2.7c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.1-0.9-0.2-1.5-0.2c0.2-0.4,0.3-0.7,0.6-1.2c0.4,0.5,0.7,0.9,1.1,1.2
		c0.1,0.1,0.3,0.1,0.4,0.2c0.4,0,0.7,0.1,1.1,0.1c1.2,0.1,2.2-0.3,2.9-1c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.5-0.1-0.9-0.3-1.3-0.4
		c-0.2,0.5-0.6,1-0.7,1.6C103.3,300.5,103.6,301,103.7,301.5z"
      />
      <path
        class="st3"
        d="M86.9,321.3c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.1,0-0.2,0-0.2,0c-0.2,0.7-0.4,1.3-0.8,1.7
		c-1.4,1.1-2.8,2.3-4.6,2.5c0.1,0.1,0.1,0.2,0.2,0.4c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1
		c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6c0.7-0.3,0.5-0.8,0.4-1.2C87,322.3,86.9,321.8,86.9,321.3z"
      />
      <path
        class="st3"
        d="M79.6,323c1.2-0.7,2.1-2,3.3-3.2c-0.1-0.2-0.2-0.4-0.4-0.6l-0.1-0.1c-0.5-0.5-1.4-0.6-2-0.2
		c-0.4,0.2-0.6,0.5-0.8,0.7c-0.7,0.8-0.4,1.7,0.7,2.4c0.1,0,0.1,0.1,0.2,0.2C80,322.6,79.8,322.8,79.6,323z"
      />
      <path
        class="st3"
        d="M167.3,274.2c1.3-0.8,2.5-1.5,3.8-2.3v-0.1c0.1-0.1,0.2-0.1,0.2-0.2c0.1-0.2,0.3-0.4,0.4-0.6l0.1-0.1
		c-0.4,0-0.9,0-1.4,0.1C168.3,271.6,167.3,272.7,167.3,274.2z"
      />
      <path
        class="st3"
        d="M171,271.9c-0.1,0.7,0,1.6-0.3,1.9c-1,0.7-2.1,1.4-3.2,2.1c0.7,1.3,2.5,2,4.3,1.5c2.2-0.5,3.6-2.3,3.2-4.1
		c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.2-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.8-0.5c-0.5,0.1-0.9,0-1.5-0.1
		c-0.2,0.2-0.4,0.3-0.5,0.5C171.2,271.7,171.2,271.8,171,271.9C171.1,271.9,171.1,271.9,171,271.9z"
      />
      <path
        class="st3"
        d="M179.7,278.4c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C179.9,278.9,179.9,278.6,179.7,278.4z"
      />
      <path
        class="st3"
        d="M98.7,310.6c1.2-0.7,2.3-1.4,3.4-2.1c0,0,0-0.1-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4
		c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.4,0.2-0.8,0.5-1.1,0.7
		c-0.4-0.3-0.7-0.6-1.1-0.7c-0.4-0.2-0.9-0.2-1.3,0c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6
		c0.3,0.1,0.5,0.2,0.8,0.2c0.1-0.1,0.3-0.2,0.4-0.2c1.4-0.5,2.9-0.9,4.4-1.4l0,0l0,0c0.1,0,0.1,0,0.2-0.1c0.1,0.1,0.2,0.1,0.2,0.2
		c-0.1-0.1-0.2-0.1-0.2-0.2C98.2,311,98.5,310.8,98.7,310.6z"
      />
      <path
        class="st3"
        d="M102.6,309.1c-1.2,0.6-2.3,1.2-3.5,1.8l0,0c-0.3,0.2-0.5,0.4-0.8,0.5c0.2,0.1,0.4,0.2,0.6,0.2
		c1.2,0.4,2.1,0.3,2.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.6
		c0-0.1,0-0.2,0-0.3C102.6,309.4,102.6,309.3,102.6,309.1C102.6,309.2,102.6,309.2,102.6,309.1z"
      />
      <path
        class="st3"
        d="M172.2,266.4c0.5,0.1,1,0.1,1.5,0c1.3-0.3,2.3-1.2,2.6-2.3c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8
		c-0.5-0.1-1.1-0.1-1.7,0c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9C170.1,265.5,171.1,266.2,172.2,266.4z"
      />
      <path
        class="st3"
        d="M148,337.3c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C151.1,337.9,149.6,337,148,337.3z"
      />
      <path
        class="st3"
        d="M247.6,239.5c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.1,0.2-0.1,0.4-0.2c0.3-0.2,0.6-0.3,1-0.5c0.1,0.3,0.1,0.5,0.1,0.7
		c1.1-0.2,1.8-0.4,2.2-0.7c0.3-0.3,0.4-0.7,0.4-1.1c-1.9-0.1-3.7,0-5.3,1.2C247.4,239.3,247.5,239.4,247.6,239.5z"
      />
      <path
        class="st3"
        d="M245.8,236.6c-0.6-0.6-1.4-0.5-2.2-0.2c-0.7,0.2-1.3,0.6-1.9,0.8c0.3,1.1,0.8,1.9,2.1,2.2
		c1,0.2,1.7-0.2,2.3-0.6c0-0.1-0.1-0.2-0.1-0.3l0,0c-0.6,0-1.3,0-2.6,0c1-0.6,1.9-1.1,2.8-1.6C246.1,236.8,245.9,236.7,245.8,236.6z
		"
      />
      <path
        class="st3"
        d="M232.8,294.9c0.6-1.2-0.1-2.4-1.5-2.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6
		c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2c-0.2,0.1-0.2,0.5-0.2,0.7l0,0c0.1,0.3,0.4,0.6,0.6,0.9c-0.2,0.4-0.4,0.8-0.5,1.2
		c-0.3,1.3,0.5,2.3,2,2.6C230.9,296.8,232.3,296.1,232.8,294.9z"
      />
      <path
        class="st3"
        d="M186.2,256.4c1.1,0.4,2.6,0,3.4-0.8c0.8-0.8,1-2,0.4-2.9c-0.3-0.4-0.7-0.7-0.9-1c-1.7-0.3-2.9,0.2-4,0.9
		c-0.1,0.4-0.3,0.8-0.4,1.2C184.3,255,184.9,256,186.2,256.4z"
      />
      <path
        class="st3"
        d="M194.3,257.8c-0.1-0.4-0.7-0.8-1.2-1c-0.4-0.1-0.9-0.2-1.3-0.3c0.3,0.9-0.6,1.5-1.4,2.1l0,0
		c-0.2,0.1-0.5,0.2-0.7,0.3c0.1-0.2,0.2-0.4,0.3-0.6c-0.6-0.1-1.3-0.2-2.1-0.3c0,0.3,0.1,0.6,0.3,0.9c0.3,0.5,1,0.7,1.9,0.5
		c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1s0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6
		C195,258.7,194.5,258.4,194.3,257.8z"
      />
      <path
        class="st3"
        d="M188.1,257.4c0.5-0.4,1-0.8,1.5-1.1c-0.5,0.1-0.9,0.3-1.2,0.7C188.2,257.1,188.1,257.3,188.1,257.4z"
      />
      <path
        class="st3"
        d="M225.9,294.5c-0.2-0.1-0.5-0.3-0.7-0.3c-0.5-0.1-1-0.2-1.5-0.3c0.2-0.7,0.3-1.2,0-1.7
		c-0.2-0.4-0.5-0.8-1.1-1.1c-0.4,0.4-0.6,0.8-0.6,1.1c-0.1,0.7,0.5,1.3,0.9,1.9c-0.4,0.4-0.8,0.7-1.1,1.1c0.3,0.9,0.9,1.5,1.5,2
		c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.8,0.1,1.3-0.3,1.6-0.9c0.1-0.1,0.1-0.2,0.2-0.4C227.3,296.2,226.9,295.1,225.9,294.5
		z"
      />
      <path
        class="st3"
        d="M91.4,307.2c0,0.3,0.2,0.6,0.3,0.9c0.3,0.5,0.9,0.8,1.6,0.9h0.1c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6
		c0.2-0.4,0.2-0.7,0.2-1.1c-0.2-1.2-1.6-2-3.1-1.7C92.2,304.8,91.2,306,91.4,307.2z"
      />
      <path
        class="st3"
        d="M188.1,263.8c-0.4-0.9-1.2-1.4-2.2-1.5c0.2,0.4-0.3,1-1,1.5s-1.3,1-1.9,1.5c0.2,0.5,0.5,0.9,1.1,1.2
		c1.1,0.5,2.2,0.3,3.2-0.5c0.5-0.4,1-0.8,1.7-1.3C188,264.8,188.2,264.2,188.1,263.8z"
      />
      <path
        class="st3"
        d="M90.1,299.9c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.7-1.8-1-2.9-0.7c0,0.2,0,0.3,0.1,0.5c-0.5,0.1-1.1,0.1-1.6,0.2H90c-0.1,0.4-0.3,0.8-0.4,1.1
		C89.5,298.8,89.7,299.4,90.1,299.9z"
      />
      <path
        class="st3"
        d="M1.2,311c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4
		c-0.3-0.6-0.8-1-1.4-1.1v1.1v1.5v0.8v0.7c0.1-0.1,0.3-0.1,0.4-0.2C0.7,311.5,1,311.3,1.2,311z"
      />
      <path
        class="st3"
        d="M90.9,314.7c-0.2,0-0.4,0-0.7,0c0.1-0.2,0.3-0.3,0.5-0.4l0,0c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3
		c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2
		c0.5,0.4,0.8,0.7,1.2,0.9c0.8,0.3,1.6,0.1,2.9-0.8c1.3,1,1.8,1.1,2.6,0.6C90.8,315.6,91,315.1,90.9,314.7z"
      />
      <path
        class="st3"
        d="M270.6,244.5c-0.1,0-0.1,0-0.1,0c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7
		c0.3,0,0.7,0,1,0h0.1c0.5-1.2,1-2.4,1.5-3.6C272.6,244.6,271.6,244.3,270.6,244.5z"
      />
      <path
        class="st3"
        d="M4.5,310.9c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.3-0.6,0.7-0.7,1.2
		c-0.1,0.2-0.1,0.5,0,0.7c0,0.1,0,0.1,0.1,0.2c0.2,0.8,1,1.3,2,1.4c0.3,0,0.6,0,0.9,0s0.5-0.2,0.7-0.3c-0.3-0.1-0.6-0.1-0.9-0.2
		c0.4-0.6,0.5-1,0.6-1c0.6-0.1,1.2-0.2,1.7-0.3c0-0.2,0.1-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3C7.2,311.3,5.9,310.6,4.5,310.9z"
      />
      <path
        class="st3"
        d="M87.1,297.3L87.1,297.3c1.1,0.4,1.9,0.2,2.8-0.3l0,0C89,297.1,88.1,297.2,87.1,297.3z"
      />
      <path
        class="st3"
        d="M87.5,293.7c-0.3,0-0.6,0.1-0.9,0.1c-0.6,0.1-1.2,0.1-1.8,0.2c-0.3,0.3-0.6,0.8-0.7,1.3c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0,0.1,0.1,0.1,0.1,0.2c1.5-0.3,2.9-0.5,4.4-0.5c-0.1-0.4-0.1-0.8-0.3-1.1C88.2,294.2,87.9,293.9,87.5,293.7z"
      />
      <path
        class="st3"
        d="M90,297L90,297C89.9,297,89.9,297.1,90,297C90,297.1,90,297.1,90,297L90,297L90,297z"
      />
      <path
        class="st3"
        d="M249.4,264.9c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C248.8,265.6,249.1,265.4,249.4,264.9z"
      />
      <path
        class="st3"
        d="M207.3,269c-0.5-0.7-0.1-1.2,0.2-1.8c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9
		c-0.9,0.1-1.4,0.6-2,1.2c0.2,0.5,0.3,0.9,0.5,1.3s0.4,0.8,0.7,1.2c0.2,0.3,0.6,0.5,0.9,0.5C206.1,270.6,207.6,269.4,207.3,269z"
      />
      <path
        class="st3"
        d="M108,311.7c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3c0.3,1.1,1.5,1.6,2.8,1.3
		c1.2-0.3,1.9-1.3,1.7-2.3C108.2,312.2,108.1,311.9,108,311.7z"
      />
      <path
        class="st3"
        d="M251.2,281.8c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.3,0.7-0.8,0.7-1.2c-0.8,0.7-1.6,1.4-2.5,2.1
		C250.2,282.3,250.8,282.1,251.2,281.8z"
      />
      <path
        class="st3"
        d="M249.4,282.5l0.1-0.1c0.5-1.1,0.9-2.4,1.6-3.3l0.1-0.1l0,0c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7
		C248.3,282.8,248.9,282.7,249.4,282.5z"
      />
      <path
        class="st3"
        d="M10.3,306c-0.4-0.2-1-0.3-1.5-0.2c-1.3,0.2-2.1,1.3-1.9,2.4c0.2,1,1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8
		s0.5-0.9,0.4-1.4C11.3,306.8,10.9,306.3,10.3,306z"
      />
      <path
        class="st3"
        d="M278.3,268.5c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C277.5,268.5,277.9,268.5,278.3,268.5z"
      />
      <path
        class="st3"
        d="M3.4,306.5c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.3-1-1.4-1.6-2.6-1.3c-0.8,0.2-1.4,0.7-1.7,1.4
		c-0.1,0.3-0.2,0.7-0.1,1v0.1C1.2,306.2,2.3,306.7,3.4,306.5z"
      />
      <path
        class="st3"
        d="M200.3,264.3c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C200.6,261.5,199.4,262.6,200.3,264.3z"
      />
      <path
        class="st3"
        d="M15,301.8L15,301.8v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9c0.2,0.2,0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3c0.1-0.1,0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C15.2,303,15.3,302.3,15,301.8z"
      />
      <path
        class="st3"
        d="M164.9,303.8c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C167.2,304.1,166,303.5,164.9,303.8z"
      />
      <path
        class="st3"
        d="M295.5,254.4h0.1c0.5-0.1,1-0.4,1.3-0.7c0.4-0.4,0.6-0.9,0.5-1.5c-0.1-0.4-0.4-0.8-0.8-1c-0.9,0-1.7,0-2.6,0.1
		c-0.6,0.4-0.9,1-0.8,1.7c0,0.2,0.1,0.3,0.1,0.4C293.7,254.1,294.6,254.6,295.5,254.4z"
      />
      <path
        class="st3"
        d="M256.9,249.9L256.9,249.9c-0.1-0.2-0.3-0.3-0.4-0.4c-0.3-0.3-0.6-0.5-1-0.7c-0.1,0-0.2-0.1-0.3-0.1
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c-0.5,0.5-0.6,1.1-0.4,1.7l0,0c0.1,0.3,0.3,0.5,0.6,0.7
		c0.2,0.1,0.4,0.2,0.6,0.3c0.3,0.1,0.5,0.1,0.8,0.1c0.2,0,0.5-0.1,0.7-0.2c0.1,0,0.2-0.1,0.3-0.2c0.1-0.1,0.3-0.2,0.4-0.3l0.1-0.1
		c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.1-0.1-0.2-0.1-0.2-0.2C257.2,250.2,257,250.1,256.9,249.9z"
      />
      <path
        class="st3"
        d="M196.9,250.8c-0.2,0.2-0.5,0.4-0.7,0.6h0.1C196.5,251.4,196.6,251.2,196.9,250.8z"
      />
      <path
        class="st3"
        d="M195,250.8c0.2,0,0.4,0.1,0.5,0.2l0,0c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1-0.7c0,0,0,0-0.1,0l0,0
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.4-1.3,0.3-1.8-0.5-2.2c-0.9-0.5-1.8-0.2-2.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		C192.4,250.3,192.7,250.7,195,250.8z"
      />
      <path
        class="st3"
        d="M283.4,249.2c-0.2-0.2-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.9-0.5s-0.8-0.2-1.3-0.1c-0.3,1.2-0.6,2.4-0.8,3.5
		c-0.1,0.4,0.4,0.9,0.9,0.6c0.9-0.4,1.8-0.9,2.6-1.5C283.8,250.3,283.7,249.6,283.4,249.2z"
      />
      <path
        class="st3"
        d="M247.5,244.6c-0.7-0.1-1.3-0.2-2-0.2c0.2,0.2,0.4,0.3,0.6,0.4C246.6,245.1,247.1,244.9,247.5,244.6z"
      />
      <path
        class="st3"
        d="M245.2,243.4c-0.1,0.3,0,0.6,0.1,0.8C245.3,244,245.3,243.7,245.2,243.4c0.9-0.9,1.7-1.8,2.6-2.7
		c-0.2-0.2-0.5-0.3-0.9-0.3c-0.1,0-0.1,0-0.2,0c-0.3,0.3-0.5,0.6-0.7,0.9C245.6,242.1,245.5,242.8,245.2,243.4z"
      />
      <path
        class="st3"
        d="M249,243.6c-0.2-0.5-0.3-0.9-0.5-1.4c-0.3,0.4-0.6,0.8-0.9,1.2C248,243.5,248.5,243.6,249,243.6
		C248.9,243.6,249,243.6,249,243.6z"
      />
      <path
        class="st3"
        d="M260.3,256.9h0.1c0.5-0.1,0.9-0.5,1.2-0.9c0.3-0.4,0.4-0.8,0.3-1.1l0,0c-0.2-0.9-1.3-1.5-2.4-1.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0.2-1,0.5-1.2,0.9c-0.1,0.3-0.2,0.6-0.1,1c0,0.2,0.1,0.3,0.2,0.4
		C258.5,256.8,259.4,257.2,260.3,256.9z"
      />
      <path
        class="st3"
        d="M244.6,254.5c0.3,0.3,0.6,0.5,1,0.7c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.6,0.2h0.1
		c0.6-0.2,1.1-0.3,1.7-0.4c0.6-0.2,1.1-0.4,1.7-0.8c-0.4,0-0.6,0.1-0.9,0.1c-0.2,0-0.4,0-0.6,0.1c-0.5-1-0.6-1.1-1.5-1.3
		c0,0,0,0-0.1,0s-0.2,0-0.4-0.1c-0.3,0-0.5-0.2-0.7-0.3c-0.7-0.6-1.3-0.3-2,0.1c0.1,0.5,0.3,1,0.6,1.4
		C244.5,254.3,244.5,254.4,244.6,254.5z"
      />
      <path
        class="st3"
        d="M41.2,332.3c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C43.3,332.5,42.3,332.1,41.2,332.3z"
      />
      <path
        class="st3"
        d="M36.6,338.3c-0.8,0.1-1.4,0.6-1.6,1.1h3.7C38.6,338.7,37.6,338.1,36.6,338.3z"
      />
      <path
        class="st3"
        d="M140,276c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C141,276.6,140.6,276.2,140,276z"
      />
      <path
        class="st3"
        d="M21.1,304.9c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0.1,0.7,0.7,1.1,1.5,1.1c0.2,0,0.4,0,0.6-0.1
		c1.1-0.2,1.7-1,1.5-1.9C21.1,305,21.1,305,21.1,304.9z"
      />
      <path
        class="st3"
        d="M8.4,298.1c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C9.1,298.6,8.8,298.3,8.4,298.1z"
      />
      <path
        class="st3"
        d="M176.2,289.8c-0.2-0.8-1.2-1.3-2.2-1c-0.9,0.2-1.5,1-1.4,1.7c0,0.1,0,0.1,0,0.2c0.2,0.8,1.2,1.3,2.2,1.1
		c0.5-0.1,0.9-0.4,1.2-0.8c0.1-0.1,0.2-0.3,0.2-0.4C176.3,290.3,176.3,290.1,176.2,289.8L176.2,289.8z"
      />
      <path
        class="st3"
        d="M276.4,255.6c0.1,0.8,1,1.3,1.9,1.2c1-0.2,1.9-1.2,1.7-2c-0.1-0.7-1.4-1.2-2.3-1
		C276.9,254.1,276.3,254.9,276.4,255.6z"
      />
      <path
        class="st3"
        d="M222.3,276c-0.2,0.4-0.4,0.9-0.6,1.3c0.8,1.3,0.8,1.3,2.4,1.5c0.8,0.1,1.3-0.3,1.1-1c-0.1-0.4-0.5-0.8-0.4-1.1
		c0.4-0.8-0.1-1.1-0.5-1.5c-1.1,0.3-0.6,0.8-0.6,1.3c-0.4-0.2-0.8-0.4-1.2-0.6C222.4,275.9,222.3,275.9,222.3,276z"
      />
      <path
        class="st3"
        d="M220.6,301.1c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C221.3,301,220.9,301,220.6,301.1z"
      />
      <path
        class="st3"
        d="M0.4,316.9c-0.1,0-0.3,0.1-0.4,0.2v2.6c0.4,0.1,0.8,0.2,1.2,0.1c0.9-0.2,1.6-1.1,1.3-1.8
		C2.3,317.1,1.3,316.6,0.4,316.9z"
      />
      <path
        class="st3"
        d="M272.9,264.7c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5c-0.2,0.2-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C272.2,264.3,272.5,264.6,272.9,264.7z"
      />
      <path
        class="st3"
        d="M286.4,288.1c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.2,0.9-1.1,1.5
		c0.1,0.8,0.9,1.3,1.8,1.1C285.8,289.7,286.6,288.9,286.4,288.1z"
      />
      <path
        class="st3"
        d="M213,315.3c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C211.6,316.3,212.3,315.9,213,315.3z"
      />
      <path
        class="st3"
        d="M278.3,289.4c-0.7,0.1-1.3,0.7-1.4,1.2c0,0.1,0,0.2,0,0.3c0.3,0,0.7,0.1,1,0.1c0,0.2,0,0.3,0,0.5
		c-0.3,0-0.5,0-0.8,0c0.2,0.3,0.6,0.5,1.1,0.6c0.2,0,0.5,0.1,0.8,0c0.9-0.2,1.4-1,1.3-1.7C280,289.6,279.3,289.2,278.3,289.4z"
      />
      <path
        class="st3"
        d="M111.7,314.7c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C113.5,314.9,112.5,314.4,111.7,314.7z"
      />
      <path
        class="st3"
        d="M211.7,317.1c-0.8,0.2-1.3,0.9-1.2,1.6s1,1.2,1.9,1s1.4-1,1.3-1.7C213.4,317.2,212.6,316.8,211.7,317.1z"
      />
      <path
        class="st3"
        d="M296.1,256.9c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C297.3,257.2,296.8,256.9,296.1,256.9z"
      />
      <path
        class="st3"
        d="M238,255.1C238,255.2,238,255.2,238,255.1c0.1,0.2,0.3,0.3,0.5,0.5s0.3,0.3,0.5,0.3c0.3,0.1,0.6,0.1,0.9-0.1
		c0.7-0.3,0.8-0.8,0.7-1.4c-0.1-0.2-0.3-0.5-0.5-0.7s-0.4-0.3-0.7-0.4C239,254,238.5,254.6,238,255.1z"
      />
      <path
        class="st3"
        d="M11.8,295.3c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C10.1,295.1,10.9,295.5,11.8,295.3z"
      />
      <path
        class="st3"
        d="M0,336.6v2.4c0.1,0,0.3,0,0.4,0c0.8-0.2,1.4-0.9,1.2-1.5C1.5,337,0.7,336.5,0,336.6z"
      />
      <path
        class="st3"
        d="M1.5,325.5c-0.1-0.3-0.3-0.5-0.6-0.7c-0.3-0.1-0.6-0.2-0.9-0.2v0.7v1.6c0.1,0,0.2,0,0.3,0
		C1,326.8,1.6,326.1,1.5,325.5z"
      />
      <path
        class="st3"
        d="M259.6,257.5c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C260.4,257.5,260,257.4,259.6,257.5z"
      />
      <path
        class="st3"
        d="M17.8,336.9L17.8,336.9c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3
		c0.6-0.2,1-0.4,1.2-0.7C18.4,338.3,18.4,337.7,17.8,336.9C17.9,336.9,17.8,336.9,17.8,336.9z"
      />
      <path
        class="st3"
        d="M278.4,285.7c-0.7,0.1-1.3,0.1-1.9,0.2c0,0.1,0,0.2,0.1,0.3c-0.6,0.1-1.2,0.3-1.8,0.4c0.5,0.7,1,0.9,1.8,0.7
		C277.6,287.2,278.2,286.7,278.4,285.7z"
      />
      <path
        class="st3"
        d="M286.7,292.4c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7c0.7-0.2,1.1-0.8,1-1.3
		C288.1,292.6,287.4,292.3,286.7,292.4z"
      />
      <path
        class="st3"
        d="M212.3,305.3c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0s0.5-0.2,0.7-0.4
		c0.3-0.2,0.4-0.6,0.3-0.9C213.6,305.5,213,305.2,212.3,305.3z"
      />
      <path
        class="st3"
        d="M13.8,310.5c0,0.2,0,0.4,0.1,0.5c0.7-0.3,1.3-0.8,2-1.2l0,0C15,309.5,14.3,309.9,13.8,310.5z"
      />
      <path
        class="st3"
        d="M216.3,312.3c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		C217.1,312,216.7,312.1,216.3,312.3z"
      />
      <path
        class="st3"
        d="M183.3,274c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2C184.6,274.1,184,273.8,183.3,274z"
      />
      <path
        class="st3"
        d="M262.2,268.7c-0.4,0.5-0.8,1-1.3,1.5v0.1c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7
		c-0.2-0.3-0.3-0.4-0.4-0.6C262.9,269,262.5,268.8,262.2,268.7z"
      />
      <path
        class="st3"
        d="M283.4,265.9c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1C283.4,266.1,283.4,266,283.4,265.9
		z"
      />
      <path
        class="st3"
        d="M158,309.3c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C159.4,309.5,158.6,309.2,158,309.3z"
      />
      <path
        class="st3"
        d="M197,265.8c-0.4,0.5-0.7,1.1-1.1,1.6c-0.4,0.1-0.8,0.2-1.3,0.3c0.3,0.5,0.6,0.9,0.9,1.5c0.8-0.9,1.5-1.5,2-2.2
		C197.9,266.4,197.9,266,197,265.8z"
      />
      <path
        class="st3"
        d="M217,271.1c0.4-0.4,0.9-0.9,1.3-1.3c-0.1-0.3-0.1-0.5-0.1-0.8c0-0.2-0.4-0.4-0.7-0.7c0.2,1.3,0.2,1.3-0.6,2.6
		C216.9,271,217,271.1,217,271.1z"
      />
      <path
        class="st3"
        d="M219,271.2c-0.2,0.1-0.3,0.2-0.4,0.4C218.8,271.6,218.9,271.4,219,271.2z"
      />
      <path
        class="st3"
        d="M86,319.5c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.5,0.1-0.9,0.6-1,1c0.3-0.2,0.7-0.3,1.1-0.4
		c-0.2,0.5-0.3,0.9-0.4,1.4C85.5,319.5,85.7,319.6,86,319.5z"
      />
      <path
        class="st3"
        d="M305.4,285.7c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.3,0.5,0.6,1,0.7c-0.1-0.2-0.1-0.5-0.2-0.7c0.5-0.1,1-0.2,1.5-0.3
		V286C306.3,285.8,305.9,285.6,305.4,285.7z"
      />
      <path
        class="st3"
        d="M212.8,269.8c0-0.1-0.6-0.1-0.9-0.1c-0.2,0.7-0.3,1.5,0.6,1.9c0.3-0.2,0.7-0.5,0.8-0.4c0.8,0.5,1-0.1,1.1-0.5
		c0.1-0.3-0.1-0.6-0.1-0.8C213.7,269.8,213.1,270.6,212.8,269.8z"
      />
      <path
        class="st3"
        d="M189.7,248.8c-0.6,0.3-0.7,0.8-0.6,1.2c0.1,0.5,0.3,1,1.2,0.8c0.3-0.7,0.6-1.4,0.9-2
		C190.8,248,190.2,248.5,189.7,248.8z"
      />
      <path
        class="st3"
        d="M233.7,285.4c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C234.5,285.2,233.9,285.2,233.7,285.4z"
      />
      <path
        class="st3"
        d="M231,273c0.2,0.3,0.4,0.6,0.6,0.8c0.5,0,0.9,0,1.2,0c1.1-0.8,0.5-1.3,0-1.8C232.1,272.2,231.3,272.2,231,273z"
      />
      <path
        class="st3"
        d="M88,309.4c0.4,0.7,1,0.8,1.7,0.5c0.3-0.1,0.5-0.2,0.6-0.4c0.4-0.3,0.6-0.8,0.5-1.5c-0.5,0.2-0.9,0.3-1.3,0.5
		c-0.3,0.1-0.5,0.2-0.8,0.4C88.5,309,88.2,309.2,88,309.4L88,309.4z"
      />
      <path
        class="st3"
        d="M167.9,301.1c-0.3-0.5-0.6-0.8-1-1.3c-0.5,0.5-0.8,0.9-1.2,1.2c0.3,0.5,0.5,0.9,0.9,1.6
		C167.1,302,167.5,301.6,167.9,301.1z"
      />
      <path
        class="st3"
        d="M248.7,321.1c0.2,0.8,0.6,1.5,0.8,2.3c0.1-1.3,0.2-2.6,0.3-4C248.7,320.2,248.5,320.4,248.7,321.1z"
      />
      <path
        class="st3"
        d="M229.3,273.8c0.1-0.3,0-0.6,0-0.9s0.1-0.7,0.2-1.1c-0.5,0-0.9,0-1.3-0.1c0.1-0.2,0.2-0.4,0.5-0.8
		c-0.5,0.2-0.8,0.3-1.1,0.4l0,0l0,0C227.8,272.3,228.4,273.1,229.3,273.8z"
      />
      <path
        class="st3"
        d="M201.4,259.6c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7c-0.2,0.4-0.1,0.8,0.3,0.9
		c0.4,0.1,0.9,0,1.3-0.2C201.2,260.4,201.2,260,201.4,259.6z"
      />
      <path
        class="st3"
        d="M203.5,243.3c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C202.1,243,202.1,243,203.5,243.3z"
      />
      <path
        class="st3"
        d="M74.9,326.3c-0.1,0.2-0.1,0.4-0.2,0.7c1-0.6,1.8-1.1,2.7-1.6c-0.4-0.2-0.8-0.3-1.1-0.3
		C75.8,325.5,75.3,325.9,74.9,326.3z"
      />
      <path
        class="st3"
        d="M27.9,336.7c1.5-0.5,1.7-0.8,1.2-1.9C27.9,335.5,27.9,335.5,27.9,336.7z"
      />
      <path
        class="st3"
        d="M210.3,268.2c-0.1,0.1-0.3,0.4-0.2,0.5c0.1,0.8,0.7,1.1,1.8,0.9c-0.2-0.5-0.5-1-0.8-1.5
		C211,268.1,210.5,268.1,210.3,268.2z"
      />
      <path
        class="st3"
        d="M216.9,295.6c0.6-0.1,0.9-0.4,0.9-0.8c0-0.6-0.5-0.9-1.1-0.8s-0.9,0.4-0.9,0.9
		C215.8,295.4,216.3,295.7,216.9,295.6z"
      />
      <path
        class="st3"
        d="M217.2,279.5c0.2,0.1,0.6,0.3,1,0.4c0.1-0.6,0-1.2-0.5-1.6c-0.2-0.2-0.4-0.3-0.8-0.5
		C216.6,278.7,216.6,279.2,217.2,279.5z"
      />
      <path
        class="st3"
        d="M251.6,283.2c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.2,0.1,0.3,0.3,0.4l0.1-0.1c0.2-0.2,0.5-0.5,0.7-0.7
		c-0.1,0.3-0.2,0.6-0.3,0.9c0.1,0,0.3,0,0.4-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5
		C251.8,283.1,251.7,283.1,251.6,283.2z"
      />
      <path
        class="st3"
        d="M232.2,298.2c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C233.2,298.8,232.7,298.6,232.2,298.2z"
      />
      <path
        class="st3"
        d="M227.4,273c-0.2-0.1-0.4-0.2-0.6-0.2c-0.5-0.2-0.9-0.3-1.4-0.5c-0.1,0-0.5,0.3-0.5,0.4
		c0.1,0.2,0.3,0.4,0.5,0.5l0,0c0.5,0.2,1.1,0.4,1.8,0.6C227.6,273.6,227.8,273.2,227.4,273z"
      />
      <path
        class="st3"
        d="M194.5,255.6c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1-0.1-0.3-0.2-0.4-0.3c0.2-0.2,0.4-0.5,0.6-0.7
		c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1c-0.1-0.1-0.5-0.3-0.7-0.2h-0.1c-0.3,0.1-0.6,0.5-0.6,0.7c0,0.4,0.2,0.8,0.6,1
		c0.4,0.3,0.9,0,1.3-0.5C194.6,255.7,194.6,255.7,194.5,255.6z"
      />
      <path
        class="st3"
        d="M137.6,283.5c0.1,0.9,0.1,0.9,0.8,1.3c0.6-0.2,1.2-0.6,0.9-1.2C139,283.2,138.3,283.2,137.6,283.5z"
      />
      <path
        class="st3"
        d="M233.5,279.8c1,0.3,1.1,1.7,2.7,1.1c-0.3-0.5-0.6-1-0.9-1.5C234.7,279.5,234.2,279.6,233.5,279.8z"
      />
      <path
        class="st3"
        d="M116,310c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6s0.9-0.5,0.8-0.9C117,310.1,116.4,309.8,116,310z"
      />
      <path
        class="st3"
        d="M30.2,303.1c-0.1-0.1-0.3-0.3-0.5-0.3c-0.1,0-0.3-0.1-0.4-0.1c-0.5,0-1,0.5-0.7,0.9c0.1,0.2,0.3,0.3,0.4,0.4
		s0.3,0.2,0.4,0.2C30.2,303.8,30.5,303.5,30.2,303.1z"
      />
      <path
        class="st3"
        d="M152.8,304.1c-0.3,0.2-0.7,0.6-0.6,0.8c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0.3-0.5,0.5-0.8,0.6-1C153.9,304.2,153.3,303.9,152.8,304.1z"
      />
      <path
        class="st3"
        d="M287.2,275.8c0.6,0.6,0.6,1.5,2.1,1.2C288.6,275.6,288.6,275.6,287.2,275.8z"
      />
      <path
        class="st3"
        d="M74.5,317c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C74.4,317.1,74.4,317.1,74.5,317z"
      />
      <path
        class="st3"
        d="M220.2,272.1c0.6,0.4-0.4,1.3,0.6,1.6h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C221.7,272.8,221.5,272.4,220.2,272.1z"
      />
      <path
        class="st3"
        d="M235.4,282.1c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C236.5,283.1,236.1,282.6,235.4,282.1z"
      />
      <path
        class="st3"
        d="M232.2,277.6c-0.1,0.2-0.1,0.3-0.2,0.4c-0.1,0.6,0.2,0.9,0.5,1.2c0.1,0.1,0.5,0.1,0.7,0c0,0,0,0,0.1,0
		s0.2-0.4,0.2-0.5C233.1,278.5,232.7,278.2,232.2,277.6z"
      />
      <path
        class="st3"
        d="M240.4,263.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C241.1,264.2,240,263.8,240.4,263.3z"
      />
      <path
        class="st3"
        d="M205.4,253.5c-0.2-0.6-0.5-1.2-0.9-2.2c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		c0.2,0.3,0.3,0.7,0.8,0.7C205,253.5,205.2,253.5,205.4,253.5z"
      />
      <path
        class="st3"
        d="M251.6,275c0.3-0.2,0.6-0.5,0.7-0.8c0-0.1-0.4-0.3-0.9-0.5c-0.3,0.4-0.6,0.7-0.6,1
		C250.9,274.8,251.5,275.1,251.6,275z"
      />
      <path
        class="st3"
        d="M249.1,234.8c-0.2,0.3-0.4,0.6-0.6,0.8c0.4-0.2,0.7-0.4,1.1-0.6h-0.1l0,0C249.4,234.9,249.3,234.9,249.1,234.8
		z"
      />
      <path
        class="st3"
        d="M78.6,331.5c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C79.3,331.7,78.9,331.6,78.6,331.5z"
      />
      <path
        class="st3"
        d="M305,230.2c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C305.8,230.3,305.5,230,305,230.2z"
      />
      <path
        class="st3"
        d="M207.8,250.8c-0.6-0.1-1.1-0.7-1.8,0.1C207,251.6,207,251.6,207.8,250.8z"
      />
      <path
        class="st3"
        d="M79.2,325.7c0-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.8,0.7-0.7,0.9c0.1,0.3,0.5,0.4,0.8,0.6
		C78.7,326.1,79.2,325.9,79.2,325.7z"
      />
      <path
        class="st3"
        d="M206.6,245c0.7-0.4,0.4-1,0.4-1.5C205.9,244,205.8,244.1,206.6,245z"
      />
      <path
        class="st3"
        d="M250.8,243.9c0.5-0.7,1.5-1.2,1.2-2.5C251.2,242.3,250.8,243,250.8,243.9L250.8,243.9z"
      />
      <path
        class="st3"
        d="M227.1,279.9c-0.3,0.3-0.5,0.5-0.7,0.8c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C227.8,280.2,227.4,280,227.1,279.9z"
      />
      <path
        class="st3"
        d="M233.3,245.2c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C233.8,245.4,233.6,245.3,233.3,245.2z"
      />
      <path
        class="st3"
        d="M241.7,258c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C242.5,257.3,242.1,257.6,241.7,258z"
      />
      <path
        class="st3"
        d="M46.1,327.4c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C46.7,327.5,46.4,327.4,46.1,327.4z"
      />
      <path
        class="st3"
        d="M12,327.3c0.7-0.7,0.8-1.2,0.2-1.9C11.4,326,11.5,326.5,12,327.3z"
      />
      <path
        class="st3"
        d="M226.6,290.9c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C226.1,290.6,226.3,290.7,226.6,290.9z"
      />
      <path
        class="st3"
        d="M113.8,302.5C113.8,302.5,113.9,302.5,113.8,302.5c0.2,0,0.3-0.1,0.4-0.2c0.2-0.1,0.3-0.2,0.5-0.4
		c-0.1-0.1-0.3-0.2-0.5-0.3C114.1,302,113.7,302.3,113.8,302.5z"
      />
      <path
        class="st3"
        d="M188.9,268.5c1.3-0.8,0.1-1.1,0.1-1.7C187.7,267.6,188.9,267.9,188.9,268.5z"
      />
      <path
        class="st3"
        d="M277.4,272.8c0.5,0.4,0.3,1.1,1.3,1.3C278.6,272.8,278.6,272.8,277.4,272.8z"
      />
      <path
        class="st3"
        d="M258.2,277.8c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C258.8,277.4,258.6,277.5,258.2,277.8z"
      />
      <path
        class="st3"
        d="M228.7,241.9c-0.5,0.4-0.8,0.6-1.2,0.9c0.2,0.1,0.3,0.2,0.4,0.3c0.1,0.1,0.3,0.3,0.4,0.4
		C229.2,243.1,228.9,242.6,228.7,241.9z"
      />
      <path
        class="st3"
        d="M90.5,317.1c0.3,0,0.5,0,0.8,0c0.3-0.2,0.7-0.5,0.9-0.7c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C91.6,316.4,91.1,316.7,90.5,317.1z"
      />
      <path
        class="st3"
        d="M248.7,245.3c-0.4,0.3-0.6,0.5-1,0.7c0.5,0.5,0.9,0.7,1.4,0.2C249.2,246.1,248.8,245.7,248.7,245.3z"
      />
      <path
        class="st3"
        d="M256.1,286c0.1,0.8,0.1,0.8,0.9,1.3C256.9,286.8,256.9,286.3,256.1,286z"
      />
      <path
        class="st3"
        d="M205.7,321.1c0,0.7,0.2,1.1,1,1.7C206.8,321.8,206.6,321.4,205.7,321.1z"
      />
      <path
        class="st3"
        d="M230.9,244.3c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C231.5,244.1,231.2,244.2,230.9,244.3
		L230.9,244.3z"
      />
      <path
        class="st3"
        d="M212.8,287.5c0-0.1-0.3-0.3-0.6-0.5c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4
		C212.5,288,212.7,287.8,212.8,287.5z"
      />
      <path
        class="st3"
        d="M81.9,328.6c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C82.2,328.1,82.1,328.4,81.9,328.6z"
      />
      <path
        class="st3"
        d="M289.1,270.6c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C288.9,270.9,289.1,270.7,289.1,270.6z"
      />
      <path
        class="st3"
        d="M252.3,261.2c-0.2-0.7-0.3-1.2-1.2-1.2C251,260.6,251.4,260.9,252.3,261.2z"
      />
      <path
        class="st3"
        d="M233.4,274.1c0.4,0.3,0.8,0.5,1.2,0.8c0.1-0.1,0.2-0.2,0.3-0.4C234.7,274,234.3,273.8,233.4,274.1z"
      />
      <path
        class="st3"
        d="M47.2,337.8c0.2-0.5,0.4-1,0.7-1.6C46.8,337,46.8,337,47.2,337.8z"
      />
      <path
        class="st3"
        d="M272.3,251.7c0.1,0.1,0.3,0.1,0.5,0.1c0.1,0,0.3-0.3,0.5-0.5c-0.2-0.1-0.3-0.1-0.5-0.2
		c-0.1,0.1-0.2,0.2-0.3,0.4C272.4,251.5,272.3,251.6,272.3,251.7z"
      />
      <path
        class="st3"
        d="M216.4,273.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0,0,0,0.1,0s0.3,0.1,0.5,0.1C216.6,273.4,216.5,273.3,216.4,273.1z"
      />
      <path
        class="st3"
        d="M215.7,272.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0.2,0,0.4,0.1,0.5C215.6,272.5,215.6,272.4,215.7,272.4z"
      />
      <path
        class="st3"
        d="M242.5,246.1c0.1-0.1-0.2-0.3-0.3-0.5l0,0c0.1,0.2,0.2,0.4,0.2,0.6C242.4,246.1,242.5,246.1,242.5,246.1z"
      />
      <path
        class="st3"
        d="M240.6,235.7c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C241.2,236,240.9,235.9,240.6,235.7z"
      />
      <path
        class="st3"
        d="M31.9,302.5c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C31.4,303.1,31.6,302.8,31.9,302.5z"
      />
      <path
        class="st3"
        d="M74.6,328.9c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C75.2,329,74.9,328.8,74.6,328.9z"
      />
      <path
        class="st3"
        d="M16.8,301c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2
		C16.5,301.3,16.6,301.2,16.8,301z"
      />
      <path
        class="st3"
        d="M29.3,322.4c0.8-0.2,0.9-0.5,0.6-1.2C29.4,321.5,29,321.8,29.3,322.4z"
      />
      <path
        class="st3"
        d="M208.6,255.1c0-0.3,0.1-0.6,0.1-0.8c0.1-0.3,0.2-0.5,0.3-0.8c-0.2,0-0.4,0.1-0.6,0.1
		C208.2,254.3,208.2,254.3,208.6,255.1z"
      />
      <path
        class="st3"
        d="M210,276c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1c-0.1,0.4-0.1,0.8-0.2,1.2C209.8,276,209.9,276,210,276
		z"
      />
      <path
        class="st3"
        d="M233,295.9c0,0.1,0,0.3,0.1,0.4c0.1,0.4,0.4,0.7,1,1.1c0-0.2,0-0.3-0.1-0.4C233.9,296.4,233.6,296,233,295.9z"
      />
      <path
        class="st3"
        d="M89.7,320.7c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C90.2,321.1,89.9,321,89.7,320.7z"
      />
      <path
        class="st3"
        d="M182.3,281.1c0.6-0.2,1.1-0.5,0.7-1.3C182.7,280.4,182.5,280.8,182.3,281.1z"
      />
      <path
        class="st3"
        d="M203.2,239.7c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C202.9,238.8,203,239.2,203.2,239.7z"
      />
      <path
        class="st3"
        d="M202.2,241.2c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C201.6,241.9,202.1,241.9,202.2,241.2z"
      />
      <path
        class="st3"
        d="M194.8,252.3C194.8,252.4,194.7,252.4,194.8,252.3c0,0.1,0,0.1,0.1,0.1C194.9,252.4,194.8,252.4,194.8,252.3z"
      />
      <path
        class="st3"
        d="M193.1,252c0.6,0.2,1,0.3,1.6,0.4c0,0,0-0.1,0.1-0.1C194.3,251.7,193.9,251.6,193.1,252z"
      />
      <path
        class="st3"
        d="M184.2,259c0.4,0.2,0.8,0.4,1.5,0.8C185.3,259,184.9,258.9,184.2,259z"
      />
      <path
        class="st3"
        d="M213.5,289.7c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C213.6,289,213.6,289.4,213.5,289.7z"
      />
      <path
        class="st3"
        d="M252.7,254.4c0.7-0.1,1.1-0.1,1.9-0.2C253.8,254,253.4,253.7,252.7,254.4z"
      />
      <path
        class="st3"
        d="M180.2,288.2c0.3-0.5,0.4-0.8,0.6-1.1C180.3,287.3,179.8,287.6,180.2,288.2z"
      />
      <path
        class="st3"
        d="M195.5,252.6c0.4-0.2,0.4-0.2,0.4-0.5c0-0.1,0-0.2-0.1-0.3c-0.2,0.4-0.4,0.6-0.6,0.9
		C195.4,252.7,195.4,252.6,195.5,252.6z"
      />
      <path
        class="st3"
        d="M292.2,237.8L292.2,237.8c0,0.1-0.1,0.1-0.1,0.2c0,0.1,0.1,0.3,0.2,0.3c0.6,0.1,0.6-0.3,0.7-0.6
		C292.8,237.7,292.4,237.5,292.2,237.8z"
      />
      <path
        class="st3"
        d="M216.4,276.5c0.1,0,0.3-0.2,0.7-0.7c-0.4,0-0.7-0.1-0.9,0s-0.3,0.3-0.3,0.5C216,276.3,216.3,276.5,216.4,276.5
		z"
      />
      <path
        class="st3"
        d="M44.9,320.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C45.3,320.4,45,320.3,44.9,320.3z"
      />
      <path
        class="st3"
        d="M31,337.8c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C31.6,337.2,31.3,337.5,31,337.8z"
      />
      <path
        class="st3"
        d="M254.1,255.9c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C254.8,256.1,254.5,256,254.1,255.9z"
      />
      <path
        class="st3"
        d="M289.8,256.1c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C289.4,255.6,289.6,255.8,289.8,256.1z"
      />
      <path
        class="st3"
        d="M78.6,319.8c0.2-0.1,0.4-0.3,0.3-0.5c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.3,0.3-0.5,0.5
		C78.3,319.7,78.5,319.9,78.6,319.8z"
      />
      <path
        class="st3"
        d="M250.8,245.8c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C250,246.5,250.4,246.1,250.8,245.8z"
      />
      <path
        class="st3"
        d="M67.5,323.4c-0.3-0.3-0.5-0.5-0.7-0.7C66.5,323.5,66.5,323.5,67.5,323.4z"
      />
      <path
        class="st3"
        d="M272.3,265.1c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C272.7,265.6,272.6,265.4,272.3,265.1C272.4,265.2,272.4,265.1,272.3,265.1z"
      />
      <path
        class="st3"
        d="M221.5,311.5c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C221.8,311.2,221.7,311.4,221.5,311.5z"
      />
      <path
        class="st3"
        d="M82.6,334.5c0,0-0.3,0.2-0.3,0.3c0,0.2,0.2,0.3,0.4,0.5c0.2-0.3,0.4-0.5,0.4-0.6
		C83.1,334.6,82.8,334.6,82.6,334.5z"
      />
      <path
        class="st3"
        d="M204.1,249.7L204.1,249.7L204.1,249.7c-0.3,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8c0.3-0.2,0.5-0.3,0.6-0.4
		v0.1l0,0c0.1,0.2,0.1,0.4,0.2,0.6c1.1-0.9,1.1-0.9,0.5-1.4C204.4,249.4,204.3,249.6,204.1,249.7z"
      />
      <path
        class="st3"
        d="M205.5,242.9l0.2,0.1c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.3,0-0.4-0.1C205.6,242.7,205.5,242.8,205.5,242.9z"
      />
      <path
        class="st3"
        d="M252.5,256.9c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C253,256.5,252.8,256.7,252.5,256.9z"
      />
      <path
        class="st3"
        d="M93.1,317.8c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C93.2,317.5,93,317.7,93.1,317.8z"
      />
      <path
        class="st3"
        d="M303,281.8c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C303.3,281.6,303.2,281.7,303,281.8z"
      />
      <path
        class="st3"
        d="M245.7,240.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.1,0.9-0.2c0-0.2,0.1-0.3,0.2-0.7
		C246.4,240.1,246.1,240.3,245.7,240.5z"
      />
      <path
        class="st3"
        d="M10.4,296.3c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C10.1,296.1,10.2,296.2,10.4,296.3z"
      />
      <path
        class="st3"
        d="M200.4,278.3c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C200.5,277.8,200.5,278,200.4,278.3z"
      />
      <path
        class="st3"
        d="M299.5,272.4c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C299.9,272.5,299.6,272.5,299.5,272.4z"
      />
      <path
        class="st3"
        d="M209.6,270.2c0,0.1,0.1,0.3,0.2,0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1,0-0.2,0-0.3,0
		C209.7,270.1,209.6,270.2,209.6,270.2z"
      />
      <path
        class="st3"
        d="M238,245.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0.1-0.3,0.2-0.4,0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0
		c0.2,0,0.4-0.2,0.5-0.5C238,245.7,238,245.6,238,245.5z"
      />
      <path
        class="st3"
        d="M234.6,247.2c0.3-0.1,0.6-0.2,0.9-0.3c0-0.1-0.1-0.2-0.1-0.4c-0.3,0.2-0.6,0.3-0.9,0.5
		C234.6,247,234.6,247.1,234.6,247.2z"
      />
      <path
        class="st3"
        d="M214.4,280.6c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C214.5,280.1,214.4,280.3,214.4,280.6z"
      />
      <path
        class="st3"
        d="M305,237c0,0.3,0,0.6,0,0.9C305.4,237.6,305.5,237.3,305,237z"
      />
      <path
        class="st3"
        d="M305,237.9L305,237.9c-0.1,0.1-0.1,0.1-0.1,0.1C305,238,305,238,305,237.9L305,237.9z"
      />
      <path
        class="st3"
        d="M25.4,329.8c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C25.5,329.7,25.5,329.7,25.4,329.8z"
      />
      <path
        class="st3"
        d="M245,249.5c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
		C245.3,249.4,245.1,249.5,245,249.5z"
      />
      <path
        class="st3"
        d="M199.4,251.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6
		C199.7,251.5,199.5,251.4,199.4,251.4z"
      />
      <path
        class="st3"
        d="M83.6,317c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1C83.7,317.4,83.6,317.2,83.6,317z
		"
      />
      <path
        class="st3"
        d="M205.9,257.5c0.1,0.1,0.3,0.2,0.4,0.1c0.1,0,0.2-0.2,0.3-0.4c-0.2-0.1-0.4-0.1-0.5-0.1
		C206,257.2,205.8,257.4,205.9,257.5z"
      />
      <path
        class="st3"
        d="M265.8,245.8c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C265.9,245.9,265.8,245.9,265.8,245.8z"
      />
      <path
        class="st3"
        d="M265.3,246.4c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0S265.3,246.4,265.3,246.4z"
      />
      <path
        class="st3"
        d="M230,270.6c-0.1,0.1-0.3,0.2-0.3,0.3c0,0.1,0.2,0.2,0.4,0.3c0.1-0.2,0.2-0.3,0.1-0.4
		C230.3,270.6,230.1,270.5,230,270.6z"
      />
      <path
        class="st3"
        d="M201,330.8c0.2,0.2,0.4,0.4,0.6,0.6C201.6,331.1,201.9,330.8,201,330.8z"
      />
      <path
        class="st3"
        d="M201.6,331.4C201.6,331.4,201.6,331.5,201.6,331.4c0,0.1,0.1,0.1,0.1,0.1C201.7,331.5,201.6,331.5,201.6,331.4
		L201.6,331.4z"
      />
      <path
        class="st3"
        d="M93.1,301.5c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C93,301.7,93.2,301.5,93.1,301.5z"
      />
      <path
        class="st3"
        d="M229.1,314.4c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C229.2,314.2,229.1,314.3,229.1,314.4z"
      />
      <path
        class="st3"
        d="M303.1,234.9c-0.1,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.2,0.1h0.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4
		C303.2,234.8,303.2,234.9,303.1,234.9z"
      />
      <path
        class="st3"
        d="M213.7,278.7c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C213.5,278.9,213.6,278.8,213.7,278.7z"
      />
      <path
        class="st3"
        d="M306.2,232.2v-0.5c-0.1,0-0.1,0-0.2,0s-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2
		C306.1,232.3,306.1,232.3,306.2,232.2z"
      />
      <path
        class="st3"
        d="M204.2,256.7c0.1,0,0.1,0,0.2,0c0.1-0.2,0.2-0.4,0.3-0.5c-0.1,0-0.2-0.1-0.3-0.1
		C204.3,256.3,204.2,256.5,204.2,256.7z"
      />
      <path
        class="st3"
        d="M202.1,269.1c0.2,0,0.3,0.1,0.5,0c0.1,0,0.2-0.2,0.5-0.4c-0.4,0-0.5,0-0.6,0.1
		C202.3,268.9,202.2,269,202.1,269.1z"
      />
      <path
        class="st3"
        d="M304.7,233.2c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5c-0.1,0.3-0.2,0.5-0.2,0.6S304.6,233.2,304.7,233.2z"
      />
      <path
        class="st3"
        d="M204.9,280.7c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0
		C205,280.2,204.9,280.5,204.9,280.7z"
      />
      <path
        class="st3"
        d="M183.9,283.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C184.1,283.5,184,283.4,183.9,283.3z"
      />
      <path
        class="st3"
        d="M30.2,310.7c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2,0.1-0.3c-0.1,0-0.2,0-0.3,0C30.3,310.6,30.3,310.7,30.2,310.7z"
      />
      <path
        class="st3"
        d="M213.1,278.6C213.1,278.6,213,278.6,213.1,278.6c-0.1-0.1-0.1-0.1-0.1-0.1v0.1
		C213,278.6,213,278.6,213.1,278.6z"
      />
      <path
        class="st3"
        d="M244.2,260.5l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1h-0.1c-0.1,0-0.2,0-0.4,0
		C244.3,260.5,244.3,260.5,244.2,260.5z"
      />
      <path
        class="st3"
        d="M198.1,274.4l0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.3c0,0-0.1-0.1-0.2-0.2C198.2,274.1,198.1,274.2,198.1,274.4z"
      />
      <path
        class="st3"
        d="M248.5,251.5c-0.1,0.1-0.2,0.2-0.2,0.4c0,0,0.2,0.1,0.4,0.2c0.1-0.2,0.2-0.3,0.2-0.4
		C248.8,251.6,248.5,251.5,248.5,251.5z"
      />
      <path
        class="st3"
        d="M90.4,312.2c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C90.5,312,90.4,312.2,90.4,312.2z"
      />
      <path
        class="st3"
        d="M203.7,241.2c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C203.9,241.3,203.8,241.3,203.7,241.2z"
      />
      <path
        class="st3"
        d="M238.7,290.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C238.8,290.4,238.7,290.5,238.7,290.6z"
      />
      <path
        class="st3"
        d="M290.9,255.5c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C291,255.6,291,255.6,290.9,255.5z"
      />
      <path
        class="st3"
        d="M58.7,312.1c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C58.9,312.1,58.8,312.1,58.7,312.1z"
      />
      <path
        class="st3"
        d="M58.7,312.5C58.6,312.5,58.6,312.5,58.7,312.5c-0.1,0.1-0.1,0.1-0.1,0.2h0.1C58.7,312.6,58.7,312.5,58.7,312.5
		z"
      />
      <path
        class="st3"
        d="M238.2,246.6C238.3,246.6,238.2,246.5,238.2,246.6c-0.2-0.1-0.4-0.1-0.6-0.1c0,0.1,0,0.2,0,0.3
		C237.9,246.8,238.1,246.7,238.2,246.6z"
      />
      <path
        class="st3"
        d="M297.5,236.6c0.1-0.2,0.1-0.3,0.1-0.4c0-0.1-0.1-0.1-0.2-0.1C297.5,236.2,297.5,236.3,297.5,236.6z"
      />
      <path
        class="st3"
        d="M129.9,335c-0.1,0-0.2,0.1-0.2,0.1c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C130,335.1,130,335,129.9,335z"
      />
      <path
        class="st3"
        d="M108.7,277.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C108.9,277.1,108.8,277.2,108.7,277.3z"
      />
      <path
        class="st3"
        d="M67.2,310.8c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C67.2,310.6,67.2,310.7,67.2,310.8z"
      />
      <path
        class="st3"
        d="M205.7,256.9c0.1,0,0.2-0.1,0.4-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		C205.5,256.8,205.6,256.9,205.7,256.9z"
      />
      <path
        class="st3"
        d="M230.7,271.4c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.4,0.1
		C230.5,271.6,230.6,271.5,230.7,271.4z"
      />
      <path
        class="st3"
        d="M248.2,250.9c-0.6,0.2-0.8,0.3-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C247.6,251.4,247.8,251.3,248.2,250.9z"
      />
      <path
        class="st3"
        d="M292.5,256.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C292.6,256.2,292.5,256.2,292.5,256.1z"
      />
      <path
        class="st3"
        d="M304.9,238c-0.1,0.1-0.3,0.3-0.4,0.4c0.1,0,0.2,0.1,0.3,0.1C304.8,238.4,304.9,238.2,304.9,238z"
      />
      <path
        class="st3"
        d="M162.2,310.7C162.2,310.7,162.3,310.7,162.2,310.7c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C162.3,310.6,162.3,310.6,162.2,310.7z"
      />
      <path
        class="st3"
        d="M251.6,254.2L251.6,254.2c0.1,0.2,0.1,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2l0,0c-0.1-0.1-0.1-0.2-0.2-0.2
		C251.7,254,251.6,254.1,251.6,254.2z"
      />
      <path
        class="st3"
        d="M62.5,321c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C62.7,320.7,62.6,320.9,62.5,321z"
      />
      <path
        class="st3"
        d="M209.4,266.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C209.6,266.7,209.5,266.7,209.4,266.8z"
      />
      <path
        class="st3"
        d="M195.7,272.9c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C195.7,272.7,195.6,272.8,195.7,272.9z"
      />
      <path
        class="st3"
        d="M297.9,255.5c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C298.1,255.5,298,255.5,297.9,255.5z"
      />
      <path
        class="st3"
        d="M291.9,256.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C292.1,257.1,292,257,291.9,256.9z"
      />
      <path
        class="st3"
        d="M293.8,282.7c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C293.8,282.4,293.8,282.6,293.8,282.7z"
      />
      <path
        class="st3"
        d="M249.2,266L249.2,266C249.3,266,249.3,266,249.2,266C249.3,265.9,249.2,266,249.2,266L249.2,266z"
      />
      <path
        class="st3"
        d="M249,266.3c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C248.9,266.2,248.9,266.2,249,266.3z"
      />
      <path
        class="st3"
        d="M249.2,240.3c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1C249.3,240.4,249.3,240.3,249.2,240.3z"
      />
      <path
        class="st3"
        d="M40,311.2c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0S40,311.3,40,311.2z"
      />
      <path
        class="st3"
        d="M201.8,331.9c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.2C201.7,331.7,201.8,331.8,201.8,331.9z"
      />
      <path
        class="st3"
        d="M231.3,243.3C231.3,243.3,231.3,243.4,231.3,243.3c0,0.1,0.1,0.1,0.1,0.1v-0.1
		C231.4,243.3,231.3,243.3,231.3,243.3z"
      />
      <path
        class="st3"
        d="M227.9,243.9c0.1-0.1,0.2-0.2,0.4-0.3c-0.2,0-0.3,0.1-0.5,0.1C227.8,243.8,227.9,243.9,227.9,243.9z"
      />
      <path
        class="st3"
        d="M228.3,243.6h0.1C228.4,243.5,228.4,243.5,228.3,243.6C228.3,243.5,228.3,243.5,228.3,243.6
		C228.3,243.5,228.3,243.6,228.3,243.6z"
      />
      <path
        class="st3"
        d="M242.3,240.3c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c0.1,0,0.2,0,0.3,0C242.2,240.5,242.3,240.4,242.3,240.3z"
      />
      <path
        class="st3"
        d="M259,241.3l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C259.2,241.3,259.1,241.3,259,241.3z"
      />
      <path
        class="st3"
        d="M253.5,236.3l0.1,0.1c0.1,0,0.1,0,0.2,0c-0.1,0-0.1-0.1-0.2-0.1H253.5z"
      />
      <path
        class="st3"
        d="M198,247.4c-0.1,0-0.1,0-0.2,0c0,0.1,0,0.1,0,0.2C197.9,247.5,198,247.5,198,247.4
		C198,247.5,198,247.4,198,247.4z"
      />
      <path
        class="st3"
        d="M192.7,248.3c0,0,0.1,0.1,0.1,0.2l0,0l0,0C192.7,248.4,192.7,248.3,192.7,248.3z"
      />
      <path
        class="st3"
        d="M114.6,296.9l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C114.4,297,114.5,296.9,114.6,296.9z"
      />
      <path
        class="st3"
        d="M10.7,316.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2L11,316C10.9,316.1,10.8,316.1,10.7,316.2z"
      />
      <path
        class="st3"
        d="M207,243.1v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C207.1,243.2,207,243.1,207,243.1z"
      />
      <path
        class="st3"
        d="M200.9,240.8l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C201.1,240.8,201,240.8,200.9,240.8z"
      />
      <path
        class="st3"
        d="M144.2,292.6l0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C144.4,292.5,144.3,292.6,144.2,292.6z"
      />
      <path
        class="st3"
        d="M121.9,297.8c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C121.9,297.8,121.8,297.8,121.9,297.8z"
      />
      <path
        class="st3"
        d="M204.3,310.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C204.4,310,204.3,310.1,204.3,310.1z"
      />
      <path
        class="st3"
        d="M181.3,285.9c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C181.3,285.8,181.3,285.8,181.3,285.9z"
      />
      <path
        class="st3"
        d="M188.9,260.6c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C188.8,260.7,188.9,260.7,188.9,260.6z"
      />
      <path
        class="st3"
        d="M225.8,277.1c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4
		C225.9,277.1,225.9,277.1,225.8,277.1z"
      />
      <path
        class="st3"
        d="M88.2,307.3c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C88.4,307.4,88.2,307.3,88.2,307.3
		z"
      />
      <path
        class="st3"
        d="M236.1,275.7c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C236.1,275.5,236.1,275.6,236.1,275.7z"
      />
      <path
        class="st3"
        d="M254.3,259.6c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1c0,0,0-0.1-0.1-0.1C254.5,259.5,254.4,259.6,254.3,259.6z"
      />
      <path
        class="st3"
        d="M230.1,278.8C230.1,278.8,230,278.8,230.1,278.8c-0.1,0.1,0,0.1,0,0.2l0,0l0,0
		C230.1,278.9,230.1,278.8,230.1,278.8L230.1,278.8z"
      />
      <path
        class="st3"
        d="M240.2,262.1c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0C240.3,262,240.3,262,240.2,262.1
		C240.3,262,240.3,262.1,240.2,262.1z"
      />
      <path
        class="st3"
        d="M201.8,270.6c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C201.9,270.6,201.8,270.6,201.8,270.6z"
      />
      <path
        class="st3"
        d="M195.3,272.2c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C195.3,272,195.3,272.1,195.3,272.2z"
      />
      <path
        class="st3"
        d="M25.2,308.9v0.1l0.1,0.1l0.1-0.1C25.3,308.9,25.2,308.9,25.2,308.9L25.2,308.9z"
      />
      <path
        class="st3"
        d="M161.9,310.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1
		C161.9,309.9,161.9,310,161.9,310.1z"
      />
      <path
        class="st3"
        d="M267.4,246.7l-0.1,0.1c0.1,0,0.2,0,0.3,0.1l0.1-0.1C267.6,246.7,267.5,246.7,267.4,246.7z"
      />
      <path
        class="st3"
        d="M216.1,283.8c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C216.1,283.7,216.1,283.8,216.1,283.8z"
      />
      <path
        class="st3"
        d="M243.1,252.7c0,0,0-0.1,0.1-0.1c0,0,0-0.1-0.1-0.1c0,0-0.1,0.1,0,0.1C243,252.6,243.1,252.7,243.1,252.7z"
      />
      <path
        class="st3"
        d="M238.2,289.9c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C238.3,289.7,238.2,289.8,238.2,289.9z"
      />
      <path
        class="st3"
        d="M277.8,245.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1
		C277.9,245.8,277.9,245.7,277.8,245.7z"
      />
      <path
        class="st3"
        d="M222.6,282.8v-0.1h-0.1C222.5,282.7,222.5,282.7,222.6,282.8C222.5,282.8,222.5,282.8,222.6,282.8z"
      />
      <path
        class="st3"
        d="M223.1,283.4c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0C223,283.5,223,283.4,223.1,283.4z"
      />
      <path
        class="st3"
        d="M50.9,321.9L51,322c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0L50.9,321.9z"
      />
      <path
        class="st3"
        d="M198.5,264.1c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C198.6,264,198.5,264,198.5,264.1z"
      />
      <path
        class="st3"
        d="M252.2,252.3L252.2,252.3c-0.5,0-0.6,0-0.8,0c0,0.1,0,0.1,0,0.2C251.6,252.6,251.8,252.5,252.2,252.3
		L252.2,252.3z"
      />
      <path
        class="st3"
        d="M243.2,255.2L243.2,255.2c0.2,0.1,0.4,0.1,0.6,0.1c0-0.1,0-0.1,0-0.2C243.5,255,243.4,255.1,243.2,255.2z"
      />
      <path
        class="st3"
        d="M279.6,273c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0L279.6,273z"
      />
      <path
        class="st3"
        d="M268.4,250c0,0,0,0.1,0.1,0.1l0.1,0.1c0,0,0-0.1-0.1-0.1L268.4,250z"
      />
      <path
        class="st3"
        d="M268.3,249.9c-0.4-0.2-0.9-0.5-1.3-0.7c-0.7-0.3-1.5-0.3-2.2-0.1c-0.3,0.1-0.5,0.2-0.7,0.4
		c-0.9,0.6-1.1,1.6-0.6,2.5c0.2,0.4,0.6,0.7,0.8,1.1c0.4,0,0.7-0.1,1-0.1c1.5-0.1,2.3-0.7,2.7-1.8c0-0.2,0.1-0.3,0.1-0.5
		C268,250.5,268.2,250.2,268.3,249.9C268.3,250,268.3,250,268.3,249.9C268.3,250,268.3,249.9,268.3,249.9L268.3,249.9z"
      />
      <path
        class="st3"
        d="M260.6,277.9h-0.1C260.5,277.9,260.5,277.9,260.6,277.9c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C260.9,278.1,260.8,278,260.6,277.9z"
      />
      <path
        class="st3"
        d="M261.2,278.5c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C261.1,278.3,261.2,278.4,261.2,278.5z"
      />
      <polygon class="st3" points="60.1,322.3 60.2,322.3 60.2,322.2 	" />
      <path
        class="st3"
        d="M204.5,265.7c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		C204.6,265.8,204.6,265.7,204.5,265.7z"
      />
      <path
        class="st3"
        d="M97.2,314c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C97.3,314.1,97.2,314.1,97.2,314
		C97.2,314.1,97.2,314,97.2,314z"
      />
      <path
        class="st3"
        d="M269.2,252l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C269.2,251.9,269.2,252,269.2,252z"
      />
      <path
        class="st3"
        d="M2,311.1L2,311.1C2.1,311.2,2.1,311.2,2,311.1L2,311.1c0.1,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C2.1,311,2,311,2,311.1z"
      />
      <path
        class="st3"
        d="M89.6,292.4C89.6,292.3,89.6,292.3,89.6,292.4c-0.1,0-0.1,0-0.2,0C89.5,292.4,89.6,292.4,89.6,292.4z"
      />
      <path
        class="st3"
        d="M25.3,303.4l-0.1-0.1c0,0.1,0,0.1,0,0.2C25.2,303.4,25.3,303.4,25.3,303.4z"
      />
      <path
        class="st3"
        d="M12.9,304.8L12.9,304.8L12.9,304.8c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C13,304.7,13,304.7,12.9,304.8z"
      />
      <path
        class="st3"
        d="M196.7,264.8v0.1V264.8c0.1,0,0.1-0.1,0.1-0.1C196.7,264.7,196.7,264.8,196.7,264.8z"
      />
      <path
        class="st3"
        d="M45.1,295.9c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2H45C45,296,45.1,296,45.1,295.9z"
      />
      <polygon class="st3" points="246.1,260.6 245.9,260.5 245.9,260.6 	" />
      <polygon class="st3" points="193.5,261.6 193.6,261.6 193.5,261.5 	" />
      <path
        class="st3"
        d="M90.2,294.9c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0.1C90,294.9,90.1,294.9,90.2,294.9z"
      />
      <path
        class="st3"
        d="M272.3,243.7C272.3,243.7,272.3,243.8,272.3,243.7C272.3,243.8,272.3,243.8,272.3,243.7
		c0.1-0.1,0.2-0.2,0.3-0.4l0,0l0,0l0,0C272.5,243.5,272.4,243.6,272.3,243.7L272.3,243.7z"
      />
      <path
        class="st3"
        d="M272.2,244c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C272.1,243.9,272.2,243.9,272.2,244z"
      />
      <path
        class="st3"
        d="M272.7,243.1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1C272.8,243.2,272.7,243.2,272.7,243.1z"
      />
      <path
        class="st3"
        d="M246.2,248.5C246.2,248.5,246.2,248.4,246.2,248.5C246.3,248.4,246.3,248.4,246.2,248.5
		C246.3,248.4,246.2,248.4,246.2,248.5L246.2,248.5z"
      />
      <path
        class="st3"
        d="M246.3,248.3c0,0,0,0.1-0.1,0.1C246.3,248.4,246.3,248.4,246.3,248.3L246.3,248.3z"
      />
      <path
        class="st3"
        d="M207.6,256.4l0.1,0.1l0.1-0.1l-0.1-0.1C207.6,256.3,207.6,256.3,207.6,256.4z"
      />
      <polygon class="st3" points="290.8,252.7 290.8,252.8 290.9,252.7 	" />
      <polygon class="st3" points="304.5,234.5 304.5,234.4 304.3,234.4 	" />
      <path
        class="st3"
        d="M240.9,264.7c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C240.8,264.9,240.8,264.8,240.9,264.7z"
      />
      <polygon class="st3" points="9,297.5 9.1,297.5 9,297.4 	" />
      <path
        class="st3"
        d="M199.9,274l0.1,0.1l0.1-0.1l-0.1-0.1C200,273.9,199.9,273.9,199.9,274z"
      />
      <path
        class="st3"
        d="M45.9,307.9c0,0.1,0,0.1,0,0.2L46,308C46,307.9,46,307.9,45.9,307.9z"
      />
      <polygon class="st3" points="200.4,274.5 200.5,274.6 200.5,274.5 	" />
      <path
        class="st3"
        d="M194.3,256.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C194.3,256.6,194.3,256.7,194.3,256.7z"
      />
      <path
        class="st3"
        d="M290.4,255.1c-0.1,0-0.2,0-0.3,0C290.2,255.2,290.3,255.2,290.4,255.1c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C290.7,255.3,290.6,255.2,290.4,255.1z"
      />
      <path
        class="st3"
        d="M208.3,253.4C208.3,253.5,208.4,253.5,208.3,253.4C208.4,253.5,208.4,253.5,208.3,253.4c0.1,0.1,0.1,0,0.1,0
		C208.4,253.5,208.3,253.5,208.3,253.4z"
      />
      <polygon class="st3" points="296.4,234 296.3,233.9 296.3,234 	" />
      <polygon class="st3" points="42.2,310 42.3,310.1 42.3,310 	" />
      <path
        class="st3"
        d="M290.3,256.4C290.3,256.4,290.3,256.5,290.3,256.4C290.2,256.5,290.3,256.5,290.3,256.4
		C290.3,256.5,290.3,256.5,290.3,256.4C290.3,256.5,290.3,256.5,290.3,256.4L290.3,256.4z"
      />
      <path
        class="st3"
        d="M290.2,256.5C290.2,256.5,290.3,256.4,290.2,256.5c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C290,256.3,290.1,256.4,290.2,256.5z"
      />
      <path
        class="st3"
        d="M240.6,267.5l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C240.5,267.4,240.5,267.5,240.6,267.5z"
      />
      <path
        class="st3"
        d="M234,246.2c0,0-0.1-0.1-0.2-0.1l0,0l0,0C233.9,246.2,234,246.2,234,246.2z"
      />
      <path
        class="st3"
        d="M249.3,265.9c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C249.3,265.8,249.3,265.9,249.3,265.9z"
      />
      <path
        class="st3"
        d="M141.4,263.2l0.1,0.1l0.1-0.1l-0.1-0.1C141.5,263,141.5,263.1,141.4,263.2z"
      />
      <path
        class="st3"
        d="M240,240l0.1-0.1l-0.1-0.1l-0.1,0.1C239.9,240,239.9,240,240,240z"
      />
      <path
        class="st3"
        d="M262.8,234.6c0,0.1,0,0.2,0.1,0.2l0.1-0.1C263,234.6,262.9,234.6,262.8,234.6z"
      />
      <path
        class="st3"
        d="M201.3,246.6l-0.1,0.1c0,0,0.1,0,0.1,0.1l0.1-0.1C201.4,246.7,201.4,246.6,201.3,246.6z"
      />
      <path
        class="st3"
        d="M253.6,234.9L253.6,234.9L253.6,234.9c-0.1,0.1-0.1,0.1-0.1,0.1C253.6,235,253.6,235,253.6,234.9L253.6,234.9z
		"
      />
      <path
        class="st3"
        d="M253.5,235C253.4,235,253.5,235.1,253.5,235C253.5,235.1,253.5,235,253.5,235L253.5,235z"
      />
      <polygon class="st3" points="203.5,244.7 203.6,244.7 203.6,244.6 	" />
      <path
        class="st3"
        d="M220.7,273.8l0.1,0.1C220.8,273.9,220.8,273.8,220.7,273.8L220.7,273.8z"
      />
      <path
        class="st3"
        d="M220.8,274C220.8,274,220.8,273.9,220.8,274L220.8,274c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C221.1,273.9,221,274,220.8,274z"
      />
      <path
        class="st3"
        d="M114.7,297.8l0.1,0.1l0.1-0.1l-0.1-0.1C114.7,297.7,114.7,297.7,114.7,297.8z"
      />
      <polygon class="st3" points="85.2,306.1 85.3,306 85.2,306 	" />
      <polygon class="st3" points="179.8,286.8 179.9,286.8 179.9,286.7 	" />
      <polygon class="st3" points="181.7,286.7 181.9,286.7 181.9,286.6 	" />
      <path
        class="st3"
        d="M235.9,275c-0.1,0-0.2,0.1-0.3,0.1l0.1,0.1C235.8,275.1,235.8,275,235.9,275z"
      />
      <path
        class="st3"
        d="M292,265.7l0.1,0.1l0.1-0.1l-0.1-0.1C292.1,265.6,292,265.6,292,265.7z"
      />
      <polygon class="st3" points="69.9,314.8 70,314.7 69.9,314.7 	" />
      <path
        class="st3"
        d="M292.6,266.3l-0.1,0.1l0.1,0.1l0.1-0.1C292.7,266.4,292.7,266.3,292.6,266.3z"
      />
      <polygon class="st3" points="237.7,279 237.8,279 237.8,278.9 	" />
      <polygon
        class="st3"
        points="172.1,302.2 172.2,302.3 172.2,302.2 172.3,302.2 172.2,302.2 	"
      />
      <path
        class="st3"
        d="M278,283.4c0.1,0,0.2,0.1,0.2,0.1h0.1c0,0,0,0,0-0.1C278.1,283.5,278.1,283.5,278,283.4z"
      />
      <path
        class="st3"
        d="M44.1,334.7c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C44.1,334.6,44.1,334.7,44.1,334.7z"
      />
      <path
        class="st3"
        d="M224.9,298.6L224.9,298.6c0.1-0.1,0.1-0.1,0.1-0.1l0,0L224.9,298.6z"
      />
      <path
        class="st3"
        d="M296.9,289.1c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.1,0-0.2c0,0,0,0.1-0.1,0.1C296.9,288.9,296.9,289,296.9,289.1z"
      />
      <path
        class="st3"
        d="M203.7,316.1l0.1,0.1l0.1-0.1C203.9,316,203.8,316,203.7,316.1C203.8,316,203.7,316,203.7,316.1z"
      />
      <path
        class="st3"
        d="M229.4,313.7l-0.1-0.1l-0.1,0.1l0.1,0.1C229.3,313.8,229.3,313.8,229.4,313.7z"
      />
      <polygon class="st3" points="193.8,333.6 193.9,333.6 193.9,333.5 	" />
      <path
        class="st3"
        d="M228.1,268c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C228.2,267.8,228.2,267.9,228.1,268z"
      />
      <path
        class="st3"
        d="M60,144.6c1.9-0.5,3.2-2,3.1-3.6c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6c0.1-0.2,0.3-0.4,0.4-0.6
		c0.2-0.4,0.3-0.7,0.4-1.1c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7c-1-0.1-2,0-2.9,0.4
		c-0.1,0.1-0.2,0.1-0.4,0.2c-0.4,0.2-0.7,0.4-0.9,0.6c-0.4,0.3-0.7,0.7-0.9,1.1v0.1c-0.4,0.9-0.4,2,0,3.5c-0.7,0-1.2-0.1-1.7-0.1
		c-1,0.1-1.9,0.4-2.6,1c-0.1,1.2-0.3,2.4-0.4,3.7c0.5,0.4,1,0.9,1.5,1.3C58.3,144.8,59.1,144.8,60,144.6z"
      />
      <path
        class="st3"
        d="M124.4,133.8C124.4,133.7,124.5,133.7,124.4,133.8c0.1-0.3,0.1-0.7,0.2-1c0.5,0,0.9,0.1,1.3,0.2
		c0.2-0.1,0.5-0.3,0.7-0.4c-0.2,0.1-0.3,0.3-0.4,0.5c0.8,0.3,1.6,0.6,2.4,0.9c0.1,0,0.1,0.4,0.1,0.7c-0.8-0.3-1.4-0.5-2.3-0.9
		c0.2,0.4,0.3,0.8,0.4,1.3c0.1-0.2,0.3-0.4,0.5-0.6c1,0.7,1.7,1.7,2.7,2c0.4,0.1,0.8,0.4,1.3,0.7c0-0.1,0-0.3,0-0.5s0.1-0.4,0.2-0.7
		c1.8,0.5,3.7,1.1,5.6,1.7c0-0.4,0.1-0.5,0-0.6c-0.1-0.2-0.3-0.5-0.4-0.7c-0.2,0-0.4-0.1-0.6-0.1c-0.5-2.6-0.5-2.6-2.9-2.6
		c-0.6,0.2-1.2,0.2-1.8,0.1c-0.4-0.1-0.8-0.2-1.2-0.3c-1.5-0.4-2.9-1.1-4.4-1.8c0.6-0.2,0.9-0.3,1.7-0.6c-0.5-0.1-1-0.2-1.5-0.3
		c-0.5,0.9-1.4,1.5-2.3,2.1c-0.2,0.1-0.3,0.3-0.5,0.4c0.2-0.1,0.3-0.3,0.5-0.4C124,133.2,124.2,133.5,124.4,133.8z"
      />
      <path
        class="st3"
        d="M124.4,130.7c0.2,0,0.3,0,0.5-0.1c-0.2,0-0.4-0.1-0.5-0.1C124.4,130.6,124.4,130.6,124.4,130.7z"
      />
      <path
        class="st3"
        d="M126.2,138.5c-0.3,0.2-0.5,0.4-0.6,0.6c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,1,1.2,1.9,1.1
		C127,140.2,126.5,139.3,126.2,138.5z"
      />
      <path
        class="st3"
        d="M121.3,136.1c0.8-0.3,1.6-0.5,2.4-0.9c0.5-0.3,0.7-0.6,0.7-1c-0.1-0.1-0.1-0.1-0.2-0.2l0,0l0,0
		c-0.3-0.2-0.5-0.4-0.8-0.6c-1.1,0.2-2.1,0.3-3.4,0.5c0.2,0.6,0.4,1.1,0.5,1.5C120.7,135.6,121,135.8,121.3,136.1z"
      />
      <path
        class="st3"
        d="M124.2,134C124.2,134,124.3,133.9,124.2,134C124.3,133.9,124.2,134,124.2,134z"
      />
      <path
        class="st3"
        d="M127.9,136.8c0,2.8,0,3.5,0.9,3.6c0.4-0.5,0.5-1.2,0.3-2.2c0.1,0,0.2,0,0.3,0
		C128.9,137.8,128.4,137.4,127.9,136.8z"
      />
      <path
        class="st3"
        d="M4.6,180.4c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.4-0.1,0.9-0.1,1.3-0.2
		c0,0,0,0,0-0.1h0.1c0.2-0.1,0.4-0.1,0.5-0.2c0.9-0.5,1.8-1.3,2.6-1.8c0,0.3,0,0.6,0.1,0.9c0,0.1,0,0.3,0,0.4c0.1,0,0.2,0,0.3,0
		c0.1-0.1,0.2-0.3,0.2-0.4c0-0.1,0-0.2,0-0.4c-0.1-0.6-0.1-1.2-0.2-1.8c0-0.1,0-0.2,0-0.3c-1.3,0.1-2.3-0.3-2.8-2.3
		c0.7,0.1,1.5,0.2,2.2,0.3c-0.4-0.6-0.9-1-1.6-1.4c-0.1,0-0.1,0-0.2-0.1c-2.4-1.1-5.4-0.3-6.6,1.9C4.1,179,4.1,179.7,4.6,180.4
		C4.6,180.3,4.6,180.4,4.6,180.4z"
      />
      <path
        class="st3"
        d="M82.9,122c0.4,2,2.4,3.1,4.8,2.6s3.9-2.3,3.6-4.3c-0.4-1.9-2.6-3.1-4.9-2.6C83.8,118.3,82.5,120.3,82.9,122z"
      />
      <path
        class="st3"
        d="M193.3,109.8c0.8,0.9,1.6,1.9,3.1,2c0.2,0,0.4,0.2,0.5,0.3c0,0.8-0.3,1.3-1.1,1.8c-1.2,0.8-1.3,2-0.3,2.8
		c0.8,0.7,1.9,0.6,2.8-0.2c0.9-0.8,0.9-1.7,0.1-2.3c-0.4-0.3-0.8-0.5-1.3-0.8c0.4-0.9,0.9-1.6,1.6-2.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.4-0.2,0.7-0.6,1-1l0.1-0.1l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.7,0.3-1.7-0.3-2.1c-0.6-0.5-1.4-1-2.2-1.3
		c-1-0.4-2.1-0.3-3.2,0.1c-1,0.4-1.6,1.4-1.7,2.3C192.9,109.1,193,109.5,193.3,109.8z"
      />
      <path
        class="st3"
        d="M188.7,122.5c-0.3,0.4-0.2,0.7-0.1,1c0.1-0.4,0.1-0.8,0.2-1.2C188.7,122.4,188.7,122.5,188.7,122.5z"
      />
      <path
        class="st3"
        d="M187.4,116.5c-0.1-0.2-0.3-0.3-0.6-0.4c0.2,0.3,0.4,0.7,0.6,1.2c0.2,0.7,0.2,1.5,0.2,1.6c-0.1,0-0.3,0-0.4,0
		c0.4,0.7,0.8,1.3,1.3,1.9c0.2,0.2,0.3,0.5,0.3,0.7c0-0.1,0-0.1,0-0.2c0.9,0.3,1.4,0.7,1.7,1.1c0-0.1-0.1-0.2-0.1-0.3
		c0.6,0.4,0.6,0.5,0.8,1.4c-0.2-0.2-0.4-0.4-0.5-0.6c0.1,0.7-0.1,1.4-0.3,2.1c0.2,0,0.3,0,0.5-0.1c0.1-0.4,0.2-0.9,0.3-1.3
		c0.2,0,0.4,0,0.8,0.1c0-0.4,0.2-0.8,0-1c-0.4-0.8-0.3-2-1.6-2.3c-0.2-0.8-0.8-1.4-1.7-1.8c-0.1,0,0.1-0.3,0.1-0.4
		C188.1,117.9,187.9,117.2,187.4,116.5z"
      />
      <path
        class="st3"
        d="M180.8,110c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.5,0,1.1-0.1,1.6c-0.1,0.2,0,0.5,0.1,1c0.3-0.7,0.4-1.1,0.6-1.6
		c0.5,0.6,0.4,1.1,0.3,1.7c0,0.1,0,0.2,0,0.2c-0.1,0.5-0.2,1,0,1.5c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1
		c0.4,0.3,0.7,0.5,1,0.8c0.4-0.4,0.8-0.7,1.2-0.9c-0.5-0.3-0.9-0.7-1-1.2c-0.2-0.7-0.6-1.3-0.9-2c-0.1-0.3-0.4-0.6-0.4-0.8
		c0.3-1.3-0.6-2.1-1.4-2.9c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C180.7,109,180.5,109.5,180.8,110z"
      />
      <polygon class="st3" points="185.5,116.5 185.6,116.7 185.7,116.5 	" />
      <path
        class="st3"
        d="M95.8,125.2c-1.7-1.7-3.5-2.1-5.3-1.1c-1.6,0.8-2.4,2.5-1.9,3.8c0.6,1.5,2.4,2.4,4.3,2c2-0.4,3.1-1.8,3.2-4.2
		c0.3-0.1,0.6-0.3,0.9-0.4c0-0.1-0.1-0.2-0.1-0.2C96.5,125.1,96.1,125.2,95.8,125.2z"
      />
      <path
        class="st3"
        d="M65.8,148.9c2-0.4,3.5-2.1,3.2-3.8c-0.3-1.8-2.3-2.8-4.4-2.4c-2.1,0.5-3.4,2.1-3,3.8
		C61.8,148.2,63.7,149.3,65.8,148.9z"
      />
      <path
        class="st3"
        d="M231.2,136.5c-0.1,0-0.2,0-0.3,0c0,0.2-0.1,0.3-0.1,0.5h0.1c0.1-0.1,0.1-0.2,0.2-0.3
		C231.1,136.7,231.1,136.6,231.2,136.5z"
      />
      <path
        class="st3"
        d="M225.3,136.8c0.2,0.4,0.5,0.7,1,0.9c0.3,0.1,0.6,0.3,1,0.3c0.7-0.4,1.4-0.8,2.2-1.2c-1.1-0.7-2.1-1.4-3.2-2.1
		C225.9,135.4,225.6,136.1,225.3,136.8z"
      />
      <path
        class="st3"
        d="M230.7,135c0.3,0,0.6,0,0.9,0v-0.1c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0.1-0.2,0.1-0.5,0.2-0.7c-0.4-0.3-0.8-0.6-1.2-0.8c0,0,0,0-0.1,0c-0.1-0.1-0.2-0.1-0.3-0.1c-0.5,0-1.1,0-1.8,0
		C229.2,133.7,229.9,134.9,230.7,135z"
      />
      <path
        class="st3"
        d="M96.7,123.7c0.8,0.9,1.9,1.1,3.1,1c1.1-0.2,2.5-1.5,3.2-2.5c-1.7-0.7-3-1.3-4.3-1.8c0.1-0.3,0.2-0.6,0.3-1
		c-1,0.1-1.7,0.6-2.3,1.4C95.9,121.6,95.9,122.8,96.7,123.7z"
      />
      <path
        class="st3"
        d="M296.5,113.9c0.1,0.2,0.2,0.4,0.4,0.6c0.2-0.8,0.5-1.5,0.7-2.3C297.2,112.8,296.9,113.3,296.5,113.9z"
      />
      <path
        class="st3"
        d="M300.1,114c0,0.1,0.1,0.2,0.2,0.2c0-0.2,0-0.3-0.1-0.5C300.1,113.8,300,113.9,300.1,114z"
      />
      <path
        class="st3"
        d="M300.3,110.1c-0.6,0.1-1.2,0.2-1.9,0.4c0.5,0.2,1.1,0.5,1.6,0.7C300.1,110.8,300.2,110.4,300.3,110.1z"
      />
      <path
        class="st3"
        d="M302.8,113.2c0-0.3-0.1-0.7-0.1-1c0-0.1-0.1-0.2-0.2-0.3c-0.4,0.3-0.4,0.6-0.4,0.9c-0.1,0.6-0.1,1.2-0.2,1.6
		C302.3,114.1,302.6,113.7,302.8,113.2C302.8,113.3,302.8,113.2,302.8,113.2z"
      />
      <path
        class="st3"
        d="M100.5,131.2c-0.5-1.2-2.1-1.8-3.6-1.5c-1.8,0.4-3,1.9-2.6,3.4c0.3,1.3,2.1,2.2,3.7,1.9c1-0.2,1.9-0.8,2.4-1.6
		c0.3-0.5,0.5-1.1,0.4-1.7C100.6,131.5,100.6,131.4,100.5,131.2z"
      />
      <path
        class="st3"
        d="M104,124.9c-1.7,0.4-2.8,1.8-2.6,3.2c0.3,1.5,1.9,2.4,3.7,2c0.3-0.1,0.5-0.2,0.7-0.3c0-1.8-0.1-3.5-0.5-5.1
		C104.8,124.8,104.4,124.8,104,124.9z"
      />
      <path
        class="st3"
        d="M107.1,125.7c0.2,0.5,0.3,1,0.3,1.5c0,0.4,0,0.8,0.1,1.2c0.3-0.5,0.4-1,0.3-1.6
		C107.7,126.4,107.4,126,107.1,125.7z"
      />
      <path
        class="st3"
        d="M220.4,116.2c1.3-0.3,2.2-1.2,2.5-2.2c-1.5-0.9-3-1.8-4.5-2.6c0,0,0,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2
		c-1,0.6-1.5,1.6-1.3,2.7C216.8,115.7,218.6,116.6,220.4,116.2z"
      />
      <path
        class="st3"
        d="M88.7,139.6c0.6,0.3,1.4,0.4,2.1,0.2c1-0.2,1.9-0.9,2.3-1.7c0.3-0.5,0.4-1,0.2-1.6c-0.3-1.3-1.7-2.1-3.4-1.9
		c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6c-0.9,0.6-1.4,1.6-1.1,2.6C87.4,138.7,88,139.3,88.7,139.6z"
      />
      <path
        class="st3"
        d="M35.6,160.4c0.3,1,1.2,1.4,3.2,1.2c0.2,0.2,0.4,0.3,0.6,0.5c1.1,0,2.3-0.1,3.4-0.1c0.3-0.3,0.4-0.6,0.5-1l0,0
		c0-0.2,0-0.4,0-0.6c0-0.2-0.1-0.3-0.2-0.5c-0.2-0.4-0.7-0.6-1.3-0.7c-0.1,0-0.3,0-0.5-0.1c-0.3,0-0.6,0-1,0c-0.5-0.5-1-0.8-1.5-1
		c-0.5,0-1.1,0-1.6,0c-0.1,0-0.2,0-0.3,0.1C35.9,158.6,35.3,159.5,35.6,160.4z M40.1,159.3c0.6,0.1,1.2,0.1,1.8,0.2
		c0,0.1,0,0.3,0,0.4c-0.6,0-1.3,0-1.9,0C40,159.7,40.1,159.5,40.1,159.3z"
      />
      <path
        class="st3"
        d="M109.9,130.8c-1,0.1-1.7,0.5-2.2,1.1c0,1.3,0,2.7,0,4.1c0.2-0.2,0.4-0.5,0.5-0.7c0.7,0.1,1.2,0.2,1.8,0.1
		c0.3,0,0.6-0.1,0.9-0.2c1.1-0.4,1.7-1.2,1.7-2.2c0-0.6-0.3-1.2-0.7-1.5C111.3,131,110.6,130.8,109.9,130.8z"
      />
      <path
        class="st3"
        d="M105.3,135.5c0,0.4,0.2,0.8,0.7,0.9c-0.1-0.6-0.1-1.2-0.1-1.8C105.5,134.7,105.3,135,105.3,135.5z"
      />
      <path
        class="st3"
        d="M295.4,110.8c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C295.5,110.7,295.5,110.8,295.4,110.8z"
      />
      <path
        class="st3"
        d="M297.6,109.3c0.1-0.3,0.1-0.7,0.1-1.1c-1.1,0.3-2.3,0.8-3.8,1.5C295.1,109.6,296.3,109.4,297.6,109.3z"
      />
      <path
        class="st3"
        d="M297.1,106.4c-0.4-0.1-0.8-0.3-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c0,0.1,0,0.1,0,0.2
		c1.8-0.3,3.7-0.7,5.5-1C297.3,106.7,297.2,106.4,297.1,106.4z"
      />
      <polygon class="st3" points="227.8,109.3 227.6,109.5 227.8,109.5 	" />
      <polygon class="st3" points="225.8,108.7 225.5,108.7 225.5,108.9 	" />
      <path
        class="st3"
        d="M26.7,133.4c0.2,1.3,0.2,2.6,0.3,4c0.6,0.2,1.2,0.3,1.8,0.2c1.4-0.3,2.5-1.7,2.3-2.9s-1.8-2-3.2-1.7
		C27.4,133,27,133.2,26.7,133.4z"
      />
      <path
        class="st3"
        d="M97.3,144.4c0.4-0.3,0.6-0.6,0.8-1c0.1-0.3,0.2-0.6,0.1-1c0-0.4-0.2-0.8-0.5-1.2c-0.1-0.1-0.3-0.3-0.4-0.4
		c-0.8-0.6-2-0.6-3-0.1h-0.1c-0.2,0.1-0.4,0.2-0.6,0.4s-0.4,0.3-0.5,0.5c-0.2,0.3-0.3,0.6-0.4,0.9c0,0.1,0,0.1,0,0.2
		c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0.1,0.6,0.4,1.1,0.6,1.8c0.1,0,0.1-0.1,0.1-0.1c1.1-1.1,2.1-2.2,3.2-3.4
		C97.6,142.9,97.6,143.7,97.3,144.4z"
      />
      <path
        class="st3"
        d="M100.5,136.7c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5-0.4,1.1-0.3,1.6c0.3,1.2,1.8,1.9,3.2,1.5
		c0.3-0.1,0.6-0.2,0.8-0.3c0.5-0.3,0.9-0.7,1.1-1.2c0.2-0.4,0.2-0.8,0.1-1.2c-0.2-0.9-1.1-1.5-2.1-1.6c-0.3,0-0.7,0-1,0.1
		s-0.6,0.2-0.8,0.3C101,136.3,100.8,136.5,100.5,136.7z"
      />
      <path
        class="st3"
        d="M35,143.7c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1.5,0.4-2.5,1.8-2.1,3C31.8,143.6,33.5,144.3,35,143.7z"
      />
      <path
        class="st3"
        d="M59.2,133.9c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1,0.2-1.7,0.8-2.1,1.5
		c0.3,0.8,0.5,1.6,0.5,2.5C57.5,133.8,58.3,134,59.2,133.9z"
      />
      <path
        class="st3"
        d="M246.1,74.9c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C245.9,73.3,246,74.2,246.1,74.9z"
      />
      <path
        class="st3"
        d="M299.2,123.5c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1-1.1-1.6-2.2-1.7c0,0.2,0,0.4,0,0.6c-0.8,0.1-1.6,0.2-2.5,0.3
		c-0.2,0.2-0.3,0.4-0.4,0.6c-0.2,0.3-0.2,0.7-0.2,1c0,0.1,0,0.1,0,0.2C296.3,123.2,297.7,123.9,299.2,123.5z"
      />
      <path
        class="st3"
        d="M212.5,100.6C212.5,100.6,212.4,100.6,212.5,100.6c-0.5,0-1,0.2-1.5,0.4c-0.2,0.1-0.4,0.3-0.6,0.5
		c0.9-0.3,1.8-0.5,2.6-0.8C212.8,100.7,212.7,100.6,212.5,100.6z"
      />
      <path
        class="st3"
        d="M97.7,147.6c0.1-0.1,0.3-0.2,0.4-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.3,0.1
		C97.6,147.4,97.6,147.5,97.7,147.6z"
      />
      <path
        class="st3"
        d="M100.5,145.3c-0.9-0.2-1.4,0.1-2.3,1.3c0.1,0.2,0.3,0.4,0.4,0.5c0.8-0.4,1.6-0.9,2.3-1.5
		C100.9,145.5,100.8,145.3,100.5,145.3z"
      />
      <path
        class="st3"
        d="M102.9,148.8c0.1-0.3,0.1-0.6,0-0.9c-1.3,0.6-2.8,1-4.5,1.1c0.1,0.2,0.2,0.4,0.4,0.6c0.5,0.7,1.3,0.8,2.2,0.7
		C102,150.1,102.6,149.6,102.9,148.8z"
      />
      <path
        class="st3"
        d="M16.8,161.4c0.9-0.4,1.7-0.8,2.6-1.2c0-0.1,0-0.3,0.1-0.5c0.2-0.4-0.2-0.8-0.8-0.8c-0.6,0-1.1,0.4-1,0.8
		c0.2,0.6-0.2,0.9-0.6,1.3C16.9,161.1,16.8,161.3,16.8,161.4C16.7,161.4,16.8,161.4,16.8,161.4L16.8,161.4z"
      />
      <path
        class="st3"
        d="M69.1,178.8c0-0.1,0-0.2,0.1-0.2c0-0.1,0-0.2,0-0.3c-0.1-0.7-0.8-0.9-1.4-1.2c0,0,0,0-0.1,0l0,0
		c-0.1,0-0.1-0.1-0.2-0.1c0,0,0,0,0.1-0.1c-0.3-0.3-0.6-0.5-1-0.8c0.1-0.2,0.2-0.5,0.3-0.7c0.5,0.1,0.9,0.3,1.4,0.4
		c0-0.2-0.1-0.4-0.3-0.8l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1c-0.3-0.2-0.7-0.4-1.1-0.5h-0.1
		c-0.6-0.1-1.3,0.4-1.1,0.8c0.1,0.2,0.2,0.5,0.2,0.8c0.1,0.6,0.1,1.3,0.6,1.8c0.1,0.1,0.2,0.2,0.4,0.3c0.1,0.1,0.3,0.1,0.5,0.2
		l-0.1,0.1c-0.9,1-1.3,1.6-0.9,2.3c0.2,0.4,0.7,0.8,1.5,1.2c0.8-0.3,1.2-0.8,1.4-1.4c-0.2,0-0.4,0-0.6,0c0-0.2,0.1-0.4,0.1-0.6
		C68.7,178.6,68.9,178.7,69.1,178.8z"
      />
      <path
        class="st3"
        d="M74.3,170.1c0,0-0.1,0.1-0.1,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1-0.1,0.1-0.2,0.1-0.3
		C74.5,170.1,74.4,170.1,74.3,170.1z"
      />
      <path
        class="st3"
        d="M233.7,106c-0.6-0.3-1.2-0.5-1.8-0.8C232.3,105.7,233,105.9,233.7,106z"
      />
      <path
        class="st3"
        d="M247.5,99.9c-0.1,0-0.2,0-0.2-0.1C247.3,99.9,247.4,99.9,247.5,99.9l0.1,0.1L247.5,99.9z"
      />
      <path
        class="st3"
        d="M105.3,140.4c0.5,1.1,1,1.9,0.4,3c-0.1,0.1-0.1,0.3-0.1,0.4c0.5,0.1,1.1,0.2,1.7,0.5c0.7-0.7,1.1-1.9,2-2.3
		c-0.1-0.1-0.2-0.1-0.3-0.2c-0.3-0.1-0.6-0.2-0.9-0.2c-0.2,0-0.3-0.1-0.5-0.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		c0-0.1-0.1-0.2-0.1-0.2C106.9,140.5,106.7,140.5,105.3,140.4z"
      />
      <path
        class="st3"
        d="M107.3,145.4c0.2,0,0.3,0,0.5,0c-0.1-0.3-0.2-0.6-0.4-0.8c-0.2,0.2-0.5,0.4-0.7,0.6
		C106.9,145.3,107.1,145.4,107.3,145.4z"
      />
      <path
        class="st3"
        d="M108.9,145.1L108.9,145.1c0.2-0.1,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.2,0.2-0.3l0,0
		C109.3,144.8,109.1,144.9,108.9,145.1z"
      />
      <path
        class="st3"
        d="M238.3,111.5c0.4,0.1,0.8,0.2,1.2,0.1c0.8-0.1,1.5-0.7,1.8-1.3c-1.2-0.8-2.3-1.5-3.5-2.3
		c-0.4,0.3-0.8,0.6-0.9,1.1c-0.2,0.4-0.2,0.7-0.1,1.1C237,110.7,237.6,111.3,238.3,111.5z"
      />
      <polygon class="st3" points="239.5,108 239.3,107.9 239.3,108.1 	" />
      <path
        class="st3"
        d="M269.4,91.7c-0.2-1.1-0.5-1.6-0.9-2.2c-0.5-0.6-1.2-0.7-1.9-0.5c-0.3,0.1-0.6,0.2-0.8,0.4
		c0.3,0.2,0.6,0.4,0.9,0.5l0,0c0.3,0.2,0.6,0.4,0.8,0.6c0.5,0.4,1,0.9,1.5,1.3C269.1,91.8,269.3,91.7,269.4,91.7z"
      />
      <path
        class="st3"
        d="M267.5,92.6c0.5-0.2,1-0.5,1.5-0.7c-0.6-0.3-1.2-0.7-1.8-1c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.2-0.2-0.5-0.5-0.7-0.7c-0.6,0-1.1,0-1.7-0.1c-0.1,0.1-0.2,0.2-0.3,0.4C265.4,91.1,266.5,91.9,267.5,92.6L267.5,92.6z"
      />
      <path
        class="st3"
        d="M264.9,92.3c0.4,0.2,0.8,0.4,1.3,0.5C265.8,92.7,265.3,92.5,264.9,92.3z"
      />
      <path
        class="st3"
        d="M126,110c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C125.2,109.5,125.5,109.9,126,110z"
      />
      <path
        class="st3"
        d="M65.1,128.2c1.3-0.3,2.1-1.4,1.8-2.4c-0.3-1-1.6-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C62.6,127.9,63.8,128.5,65.1,128.2z"
      />
      <path
        class="st3"
        d="M82.2,117.5c1.2-0.3,2.1-1.4,1.9-2.4s-1.5-1.6-2.8-1.3c-1.2,0.3-2.1,1.5-1.8,2.5
		C79.8,117.1,81,117.7,82.2,117.5z"
      />
      <path
        class="st3"
        d="M282.8,128.3c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1c0.2-0.7,0.7-1.4-0.1-2.1c-0.8-0.6-1.6-0.1-2.5,0.1
		c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1C281.3,127,282,127.7,282.8,128.3z"
      />
      <path
        class="st3"
        d="M68.5,131.5c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c1.3-0.2,2.2-1.3,1.9-2.4c-0.2-1-1.3-1.6-2.6-1.3
		c-1.3,0.2-2.1,1.1-2,2.2C68.4,131.2,68.4,131.3,68.5,131.5z"
      />
      <path
        class="st3"
        d="M93.4,151.4L93.4,151.4c-1.1,0.2-1.9,0.9-2,1.7c0,0.1,0,0.3,0,0.4c0.8-0.7,1.5-1.4,2.2-2.1
		C93.5,151.5,93.4,151.5,93.4,151.4z"
      />
      <path
        class="st3"
        d="M94.4,151.5L94.4,151.5c0.1,0.8,0.8,1.5,1.2,2.3c0-0.1,0.1-0.2,0.1-0.3c0-0.2,0.1-0.4,0-0.6
		C95.7,152.2,95.2,151.7,94.4,151.5z"
      />
      <path
        class="st3"
        d="M255.9,99.8c-0.1-0.2-0.3-0.4-0.6-0.8c0.7-0.8,0.9-1,0.7-1.3c-0.6-0.2-1.2-0.4-1.8-0.5c0.4,0,0.8-0.1,1.2-0.1
		c-0.2-0.2-0.3-0.3-0.5-0.5c-0.7,0.2-1.5,0.4-2.2,0.4c-0.2,0-0.5,0-0.7,0c-0.1,0.4-0.1,0.7,0,1C253.2,98.6,254.5,99.2,255.9,99.8z"
      />
      <path
        class="st3"
        d="M286.2,121.7c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.5-0.5,0.7-1.2,0.6-1.8c-1.3,0.2-2.6,0.3-4,0.5
		c0-0.3,0-0.6-0.1-0.9c-0.3,0.2-0.5,0.5-0.8,0.7C285.9,121.4,286.1,121.5,286.2,121.7z"
      />
      <path
        class="st3"
        d="M28.2,146.6c-0.2-0.9-1.3-1.5-2.4-1.4c-0.3,0.9-0.5,1.7-0.9,2.5c-0.2-0.7-0.3-1.3-0.4-2
		c-0.6,0.5-1,1.2-0.9,1.8c0.2,1,1.4,1.5,2.6,1.3C27.6,148.6,28.4,147.6,28.2,146.6z"
      />
      <path
        class="st3"
        d="M78.6,124.1c-0.7,0.6-1.1,1.3-0.9,2.2c0.3,1.3,1.3,1.9,3.1,1.8C80.7,125.4,80.4,124.6,78.6,124.1z"
      />
      <path
        class="st3"
        d="M30.4,152.3c0.1,0,0.2,0,0.3,0.1C30.6,152.3,30.6,152.2,30.4,152.3C30.5,152.1,30.4,152.2,30.4,152.3z"
      />
      <path
        class="st3"
        d="M34.1,152.9c-0.1-0.5-0.5-0.9-1-1.1c0.1,0.4,0.2,0.8,0.1,1.4c0,0.4,0.2,0.9,0.4,1.3
		C34,154,34.2,153.5,34.1,152.9z"
      />
      <path
        class="st3"
        d="M32.2,153.9c-0.7,0.3-1.4,0.5-2.1,0.7c0.5,0.5,1.3,0.7,2,0.6C32.1,154.8,32.2,154.3,32.2,153.9z"
      />
      <path
        class="st3"
        d="M43.3,156.3c0.1,0.2,0.2,0.3,0.2,0.4c1.2-0.7,2.3-1.4,3.3-2c-0.3-0.4-0.8-0.7-1.2-1c-0.9,0.4-1.6,0.7-2.4,1.1
		C43.3,155.3,43.3,155.8,43.3,156.3z"
      />
      <path
        class="st3"
        d="M43.5,158c0.1,0.3,0.2,0.6,0.3,0.9c0.2-0.3,0.4-0.6,0.5-0.9C44,158,43.7,158,43.5,158z"
      />
      <path
        class="st3"
        d="M87.2,131.2c-0.2-0.9-1.3-1.5-2.4-1.3c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2
		C86.6,133.1,87.4,132.1,87.2,131.2z"
      />
      <path
        class="st3"
        d="M2.2,133C2,132.1,1,131.6,0,131.7v3.6c0.2,0,0.3,0,0.5-0.1C1.7,135,2.5,134,2.2,133z"
      />
      <path
        class="st3"
        d="M270.8,120.4L270.8,120.4c0.3,0.3,0.5,0.6,0.8,0.8c0.3-0.2,0.5-0.3,0.8-0.5c-0.3-0.3-0.6-0.7-0.9-1l0,0
		c-0.3-0.4-0.5-0.8-0.8-1.2c-0.2,0.6-0.3,1.3-0.5,1.9l0,0l0.3-0.1L270.8,120.4z"
      />
      <path
        class="st3"
        d="M88.8,145.8c-0.4,0.3-0.8,0.5-1.1,0.8c0.9,0.8,1.8,1.5,2.4,2C89.9,147.6,89.9,146.6,88.8,145.8z"
      />
      <path
        class="st3"
        d="M87.1,148.5c0.2-0.9,0.4-1.5,0.5-1.9c-0.1,0.1-0.3,0.2-0.3,0.3c0,0-0.1,0.1-0.1,0.2c-0.2,0.3-0.4,0.8-0.3,1.1
		C86.9,148.2,87,148.4,87.1,148.5z"
      />
      <path
        class="st3"
        d="M70.9,141.9c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2c0.2-0.1,0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		c-0.4-0.4-1.1-0.7-1.7-0.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		C70.4,141.9,70.6,141.9,70.9,141.9z"
      />
      <path
        class="st3"
        d="M58.5,172.2c0.5,0.4,1.2,0.5,2,0.2c0-0.3-0.2-0.6-0.4-0.8c-0.6,0.1-1.2,0.1-1.9,0.2
		C58.3,171.9,58.4,172.1,58.5,172.2z"
      />
      <path
        class="st3"
        d="M60.5,168.8c-0.3,0-0.8,0-0.8,0.2c-0.2,0.4-0.5,0.5-1,0.6c-0.2,0-0.3,0.1-0.4,0.2c1.3,0.1,2.6,0.2,3.8,0.2
		C61.9,169.3,61.3,168.9,60.5,168.8z"
      />
      <path
        class="st3"
        d="M143.4,128.5c0-0.4,0-0.7,0-1.1l0,0c0,0.1-0.2,0.3-0.3,0.4C143.1,128,143.2,128.3,143.4,128.5
		C143.3,128.5,143.3,128.5,143.4,128.5z"
      />
      <path
        class="st3"
        d="M145.3,127.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.4-1-0.7-0.8-2,0.5c0.8,0.3,1.6,0.5,2.4,0.8c0-0.1,0-0.1-0.1-0.2
		c-0.3-0.1-0.6-0.3-0.8-0.3c0-0.1,0-0.2,0.1-0.3C145.2,127.3,145.2,127.3,145.3,127.2z"
      />
      <path
        class="st3"
        d="M191.7,99.2c1-0.2,1.7-0.8,1.5-1.3c-0.3-1.1-1.2-1.6-2.5-1.3c-1.1,0.3-1.6,0.8-1.5,1.5
		C189.4,99,190.4,99.5,191.7,99.2z"
      />
      <path
        class="st3"
        d="M248,106.5c0.2,0.8,1.2,1.2,2.1,1c0.4-0.1,0.7-0.3,1-0.5c-0.9-0.5-1.9-1-2.8-1.6
		C248,105.8,247.9,106.1,248,106.5z"
      />
      <path
        class="st3"
        d="M249.4,104.5C249.4,104.5,249.4,104.6,249.4,104.5c0.7,0.5,1.4,0.9,2.2,1.4c0-0.1,0-0.2,0-0.3
		C251.4,104.8,250.4,104.3,249.4,104.5z"
      />
      <path
        class="st3"
        d="M136.6,100.2c0.5-0.3,1-0.7,1.5-1c0.4,0.9,1.2,1.3,2.3,1.4c0.2-0.2,0.5-0.4,0.5-0.6c0.1-0.3,0-0.7-0.2-0.8
		c-0.8-0.5-1.7-0.8-2.5-1.2c-0.3,0.3-0.5,0.5-0.7,0.8c-0.7-0.1-1.4-0.3-2.3-0.5C135.2,99.3,135.6,99.8,136.6,100.2z"
      />
      <path
        class="st3"
        d="M276.2,122.1c-0.2,0-0.3,0-0.5,0c0,0.1,0,0.1,0,0.2c0.2,0,0.3,0,0.5,0C276.2,122.2,276.2,122.1,276.2,122.1z"
      />
      <path
        class="st3"
        d="M275.8,125c-0.1,0-0.1,0-0.2,0v0.1C275.7,125,275.7,125,275.8,125z"
      />
      <path
        class="st3"
        d="M121.3,143.1c0.3,0.5,0.5,1.1,0.6,1.8c0.2-0.3,0.3-0.6,0.2-0.9C121.9,143.6,121.6,143.2,121.3,143.1z"
      />
      <path
        class="st3"
        d="M118.7,145.2c0.2,0.3,0.5,0.5,0.9,0.6c-0.1-0.5-0.2-0.9-0.3-1.6C119,144.6,118.8,144.9,118.7,145.2z"
      />
      <path
        class="st3"
        d="M58.7,126.6c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C56.7,126.2,57.7,126.8,58.7,126.6z"
      />
      <path
        class="st3"
        d="M300.5,87.6c0.1,0.1,0.2,0.3,0.4,0.4c0.9-0.3,1.8-0.6,2.9-0.9c0.1-0.2,0.1-0.4,0-0.6c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C300.3,87.4,300.4,87.5,300.5,87.6z"
      />
      <path
        class="st3"
        d="M23.8,165.2c-0.1,0-0.2,0-0.3-0.1c0,0,0,0-0.1,0C23.5,165.2,23.6,165.3,23.8,165.2
		C23.7,165.3,23.7,165.3,23.8,165.2z"
      />
      <path
        class="st3"
        d="M280.4,132.8c0.5,1,0.9,2,1.4,2.9c0.5,0.1,0.8-0.1,1.6-0.6c-0.2-0.6-0.5-1.3-0.8-2c-0.7-0.1-1.3,0-1.8-0.4
		C280.6,132.6,280.5,132.7,280.4,132.8z"
      />
      <path
        class="st3"
        d="M111.3,149.5c0.1,0.8,0.9,1.3,1.9,1.2c0.1,0,0.1,0,0.1,0c0.4-0.1,0.6-0.2,0.9-0.4c-0.6-0.8-1.2-1.6-1.8-2.4
		C111.8,148.1,111.2,148.8,111.3,149.5z"
      />
      <path
        class="st3"
        d="M42.6,135.9c0.8,0.6,1.7,0.8,2.8,0.3c0-2-0.8-2.7-3.2-2.7C41.5,134.4,41.8,135.2,42.6,135.9z"
      />
      <path
        class="st3"
        d="M193.8,113.9c-0.9,0.5-1.6,0.8-2.1,1.2c-0.7,0.4-1.1,1-1.1,1.7c0.1,0.8,0.8,1.1,1.6,0.8
		c0.6-0.3,1.1-0.7,1.6-0.9C193.8,115.8,193.8,115,193.8,113.9z"
      />
      <path
        class="st3"
        d="M22.5,160c0.1-0.2,0.2-0.5,0.3-0.7c0.2,0,0.3,0.1,0.5,0.1c0.1,0.4,0.1,0.8,0.2,1c0.2,0,0.4,0,0.6,0h0.1
		c0.9-0.3,1.5-1,1.3-1.8c-0.1-0.5-0.5-0.8-1-0.9c-0.4,0-0.8,0-1.2,0c-0.9,0.2-1.5,1-1.3,1.8C22.1,159.6,22.3,159.8,22.5,160z"
      />
      <path
        class="st3"
        d="M51.2,142.6c0.3-1.9-0.6-2.7-3-2.8C47.5,141.8,48.4,142.8,51.2,142.6z"
      />
      <path
        class="st3"
        d="M75.3,130c1-0.2,1.6-1,1.4-1.8c-0.2-0.7-1-1.1-1.9-0.9c-1,0.2-1.6,1-1.4,1.8C73.6,129.8,74.4,130.2,75.3,130z"
      />
      <path
        class="st3"
        d="M94.5,117.7c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C92.7,117.5,93.6,117.9,94.5,117.7z"
      />
      <path
        class="st3"
        d="M72.3,174.8c0.4-0.1,0.8-0.2,1.2-0.3c-0.5-0.3-0.9-0.6-1.4-0.8c-0.5,0.2-0.8,0.2-1,0.4l0,0
		c-0.3,0.2-0.6,0.5-1,0.8c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0v0.1c0.1,0,0.2,0.1,0.3,0.1h0.1l0,0c0,0,0,0,0,0.1l0,0l0,0l0,0l0,0
		c0.5,0,1.1,0,1.6,0c0.4,0,0.7,0,0.9-0.1c0.6-0.1,0.8-0.4,1.2-1.2C73.2,175,72.7,174.9,72.3,174.8z"
      />
      <path
        class="st3"
        d="M69.8,176.3c-0.1,0-0.2,0.1-0.3,0.1c0,0.1-0.1,0.2-0.1,0.3l0.3,0.1c0.1-0.1,0.2-0.3,0.2-0.4l0,0
		C69.9,176.3,69.8,176.3,69.8,176.3L69.8,176.3z"
      />
      <path
        class="st3"
        d="M105.4,118.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C105.9,117.1,105.3,117.8,105.4,118.6z"
      />
      <path
        class="st3"
        d="M104.2,115C104.2,115,104.3,115,104.2,115c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3
		c-0.2-0.6-0.9-0.9-1.7-0.8c-0.9,0.1-1.6,1-1.5,1.7C102.5,114.7,103.3,115.2,104.2,115z"
      />
      <polygon
        class="st3"
        points="246.4,125 246.3,125.1 246.5,125.1 246.5,125.1 	"
      />
      <path
        class="st3"
        d="M245.8,123.3c0.2,0,0.5-0.1,0.7-0.1c-0.2-0.1-0.5-0.3-0.7-0.4C245.7,123,245.7,123.2,245.8,123.3z"
      />
      <path
        class="st3"
        d="M31.5,165.3c-0.6,0.1-1.3,0.1-1.9,0.2c-0.3,0-0.6,0.1-0.9,0.1c0.5,0.4,1,0.7,1.6,1.1
		C31.1,166.3,31.5,165.8,31.5,165.3z"
      />
      <path
        class="st3"
        d="M134,98.3c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C133.7,100.3,134.2,99.3,134,98.3z"
      />
      <path
        class="st3"
        d="M271.4,93.8c0.6,0.3,1.3,0.2,1.8-0.3c0.3-0.2,0.5-0.5,0.8-0.8c-0.5-0.4-1-0.8-1.5-1.2c-0.2,0-0.4,0.1-0.6,0.2
		c-0.4,0.2-0.7,0.4-0.9,0.7c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C270.9,93.5,271.1,93.7,271.4,93.8z"
      />
      <path
        class="st3"
        d="M38.7,147.3c-0.1-0.2-0.3-0.4-0.4-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.3-0.4,0.5-0.6,0.8
		c-0.3,0.6-0.4,1.1-0.2,1.6C38,148.5,38.4,148,38.7,147.3z"
      />
      <path
        class="st3"
        d="M40.5,150c-0.2-0.2-0.3-0.5-0.5-0.7c0,0.3,0,0.5,0.1,0.8C40.2,150,40.3,150,40.5,150z"
      />
      <path
        class="st3"
        d="M38.5,150c0.4,0.2,0.9,0.2,1.6,0.1C39.5,149.9,38.9,149.8,38.5,150z"
      />
      <path
        class="st3"
        d="M153,141.6c0.1-0.2,0.1-0.4,0.2-0.6c-0.1-0.6-0.3-1.2-0.6-1.7c0,0.1-0.1,0.1-0.1,0.1c-0.2,0.4-0.7,0.4-0.9,0.7
		c-0.3,0.3-0.7,0.7-0.7,1s0.4,0.5,0.7,0.7C152.1,141.8,152.6,141.7,153,141.6z"
      />
      <path
        class="st3"
        d="M70.8,148.9c-0.4,0.1-0.7,0.4-0.9,0.6c-0.2,0.3-0.3,0.6-0.2,1c0,0.1,0.1,0.1,0.1,0.2c0.9-0.4,1.8-0.7,2.7-1.1
		C72.3,149.1,71.5,148.7,70.8,148.9z"
      />
      <path
        class="st3"
        d="M295.8,101c0.8-0.1,1.4-0.8,1.3-1.5s-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4C294.2,100.7,295,101.2,295.8,101
		z"
      />
      <path
        class="st3"
        d="M255.8,111.8c-0.1,0-0.2,0-0.4,0c-0.7,0-1.1,0.4-0.8,0.9v0.1c0.4-0.1,0.8-0.3,1.3-0.8l0,0
		c0.4,0.2,0.8,0.3,1.2,0.5C257,112,256.6,111.8,255.8,111.8C255.9,111.8,255.8,111.8,255.8,111.8z"
      />
      <path
        class="st3"
        d="M131.2,144.8c0,0.1,0.1,0.2,0.1,0.3c0.2-0.3,0.4-0.7,0.5-1C131.6,144.3,131.4,144.5,131.2,144.8z"
      />
      <path
        class="st3"
        d="M59.2,158.8c-0.3,0.9,0,1.5,0.8,1.9c0.7,0.4,1.5,0.5,2.3-0.1C61.9,158.9,61.4,158.6,59.2,158.8z"
      />
      <path
        class="st3"
        d="M38.2,165.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.7-0.4-1.2-0.3c-0.7,0.1-1.1,0.5-1.2,1.1
		c-0.1,0.9,0.7,1.2,1.6,1.3c0.1-0.1,0.2-0.2,0.3-0.2C38.3,166.5,38.5,166.1,38.2,165.6z"
      />
      <path
        class="st3"
        d="M140.6,134.6c0,0.6-0.2,1.1-0.4,1.4c0.3-0.1,0.6-0.2,0.8-0.2c0.1-0.8,0.1-1.5,0.2-2.3
		c-0.6,0.3-1.1,0.5-1.6,0.7C140,134.4,140.3,134.5,140.6,134.6z"
      />
      <path
        class="st3"
        d="M124,149.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.3,0.4,0.5,0.5C124.1,150.2,124,149.9,124,149.7z"
      />
      <path
        class="st3"
        d="M10.1,187.8c0.1-0.2,0.2-0.5,0.2-0.7c0.2-0.6,0.2-1.4,0.1-1.7c-0.1-0.2-0.1-0.4-0.3-0.5
		c-0.3-0.2-0.8-0.4-1.1-0.3c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2C9,187.1,9.3,187.6,10.1,187.8z"
      />
      <path
        class="st3"
        d="M18.6,168.3c-0.2,0-0.4,0.1-0.6,0.3c0.6,0,1.2,0,1.8,0C19.6,168.3,19.1,168.2,18.6,168.3z"
      />
      <path
        class="st3"
        d="M65.9,164.8c0.6,0.4,1.3,0.5,2,0.3c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.4-1.2-0.9-1.6-2.1-1.6
		c-0.3,0.1-0.6,0.1-0.9,0.2C64.9,164,65.3,164.5,65.9,164.8z"
      />
      <path
        class="st3"
        d="M264.9,80.7c0,0.2-0.1,0.3-0.1,0.5c0.8-0.1,1.6-0.2,2.5-0.2C266.5,80.8,265.7,80.8,264.9,80.7z"
      />
      <path
        class="st3"
        d="M111,139.3c0.3-0.3,0.4-0.6,0.3-1c0-0.1-0.1-0.1-0.1-0.1c-0.2-0.5-0.9-0.8-1.6-0.6s-1.1,0.7-1,1.3
		c0.1,0.7,0.8,1,1.6,0.8C110.6,139.7,110.8,139.5,111,139.3z"
      />
      <path
        class="st3"
        d="M86.2,151.6c0,0,0,0.1,0.1,0.1C86.2,151.7,86.2,151.6,86.2,151.6C86.5,151.7,86.4,151.6,86.2,151.6z"
      />
      <path
        class="st3"
        d="M86.4,150c-0.3-0.2-0.7-0.3-1.1-0.2c-0.8,0.1-1.3,0.8-1.2,1.4c0.1,0.5,0.5,0.8,1.1,0.9
		c0.3-0.2,0.6-0.3,0.9-0.5C86.4,150.8,86.5,150.3,86.4,150z"
      />
      <path
        class="st3"
        d="M245.1,111.8c-0.4-0.2-0.7-0.4-1.1-0.5c0,0.2,0,0.4,0,0.6c0.3,0,0.7,0,1,0C245,111.9,245,111.8,245.1,111.8z"
      />
      <path
        class="st3"
        d="M244.2,112.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.3-0.2-0.4-0.3l0,0c-0.2-0.1-0.4-0.3-0.6-0.4c0,0.1,0,0.2,0,0.2
		C243.5,112,243.8,112.2,244.2,112.3z"
      />
      <path
        class="st3"
        d="M132.1,121.4c-0.3-0.4-0.6-0.6-0.9-0.7c-0.4-0.2-0.7-0.1-1.1,0c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.2,0.2-0.3,0.4c-0.3,0.5,0.1,1.1,1.1,1.6c0.2-0.1,0.4-0.2,0.6-0.3C131.6,122.4,132,122,132.1,121.4z"
      />
      <path
        class="st3"
        d="M203.1,107.2c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.3-0.2,0.5-0.5,0.5-0.8
		c-0.1,0-0.2,0-0.3-0.1c-0.5-0.1-1-0.5-1.4-0.9C203.4,106.1,203,106.7,203.1,107.2z"
      />
      <path
        class="st3"
        d="M207.2,111.1c0.1,0,0.2,0,0.3,0.1c0.2,0,0.4,0.1,0.7,0.1c0.8-1.1,0.9-1.5,0.3-1.9l0,0
		c-0.4-0.3-0.8-0.4-1.3-0.2h-0.1c-0.5,0.2-0.8,0.5-0.8,1C206.3,110.6,206.5,110.9,207.2,111.1z"
      />
      <path
        class="st3"
        d="M110.1,111.7c0.7-0.2,1.1-0.8,0.9-1.4c-0.2-0.5-0.9-0.9-1.5-0.7c-0.7,0.2-1.1,0.8-1,1.4S109.4,112,110.1,111.7
		z"
      />
      <path
        class="st3"
        d="M263.8,78.5c-0.1-0.5-0.9-0.9-1.5-0.8c-0.3,0.2-0.7,0.5-1,0.7c0,0.1-0.1,0.1-0.1,0.2
		C262.1,78.6,262.9,78.7,263.8,78.5C263.8,78.6,263.8,78.5,263.8,78.5z"
      />
      <path
        class="st3"
        d="M17,173.7C16.9,173.7,16.9,173.7,17,173.7c-0.1-0.1-0.2-0.1-0.2-0.1C16.8,173.7,16.9,173.7,17,173.7z"
      />
      <path
        class="st3"
        d="M110.5,122.5c-0.1,0.2-0.1,0.4,0,0.5c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3
		c-0.1-0.3-0.4-0.6-0.8-0.7c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1C110.9,121.9,110.6,122.2,110.5,122.5z"
      />
      <path
        class="st3"
        d="M26.5,110.8c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.6-0.7-0.9-1.4-0.8c-0.7,0.1-1.2,0.7-1.1,1.3
		C25.2,110.5,25.9,110.9,26.5,110.8z"
      />
      <path
        class="st3"
        d="M139.6,124.2c-0.7,0.2-1.3,0.5-1.3,1.2c0.5,0.5,1,0.9,1.5,1.5c0.7,0,1.1-0.3,1-0.8
		C140.6,125.5,140.4,124.7,139.6,124.2z"
      />
      <path
        class="st3"
        d="M145.7,133.9c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.1,0-0.3,0.1-0.4,0.1
		c0.5,0.2,1,0.9,1.5,1.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2,0,0.3,0C146.2,134.8,146.3,134.2,145.7,133.9z"
      />
      <path
        class="st3"
        d="M146.2,135.4L146.2,135.4C146.1,135.3,146.1,135.3,146.2,135.4C146.1,135.4,146.1,135.4,146.2,135.4
		C146.1,135.4,146.2,135.4,146.2,135.4z"
      />
      <path
        class="st3"
        d="M100.6,97.9c0.7-0.1,1.1-0.7,1-1.3c-0.1-0.6-0.9-0.9-1.5-0.7c-0.6,0.2-1,0.7-0.9,1.2
		C99.2,97.6,99.9,98,100.6,97.9z"
      />
      <path
        class="st3"
        d="M243.5,132c0.4-0.3,1.1-0.5,1.6-0.6c-0.3-0.2-0.6-0.3-0.8-0.2C243.9,131.2,243.6,131.6,243.5,132z"
      />
      <path
        class="st3"
        d="M76.6,121.6c0.6,0,1.2,0,1.8,0.2c0.4-0.2,0.6-0.6,0.5-1c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C76.5,121.4,76.5,121.5,76.6,121.6z"
      />
      <path
        class="st3"
        d="M208.6,108c0.4-0.1,0.6-0.2,0.8-0.4c-0.7-0.2-1.3-0.3-2-0.5c-0.1,0.2-0.1,0.4,0,0.5
		C207.7,107.9,208.3,108.1,208.6,108z"
      />
      <path
        class="st3"
        d="M146.8,135.9c0.5,0.1,0.9,0.2,1.1,0.6c0.2,0.4,0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2s-1.1-0.6-1.7-0.9
		c-0.4,0.2-0.7,0.4-1.1,0.6C146.4,135.6,146.6,135.9,146.8,135.9z"
      />
      <path
        class="st3"
        d="M84.5,177.6c0.1-0.2,0.3-0.3,0.4-0.5c-0.1,0-0.2-0.1-0.2-0.1l0,0c-0.5-0.1-1-0.3-1.5-0.4l-0.1,0.1
		C83,177.4,83.7,177.5,84.5,177.6z"
      />
      <path
        class="st3"
        d="M85.4,176.4c0.1-0.3,0-0.7-0.2-0.9c0,0,0,0-0.1,0c-0.2-0.1-0.8-0.1-0.9,0l-0.1,0.1c-0.3,0.2-0.6,0.5-0.7,0.8
		c0.5,0.2,0.9,0.4,1.4,0.6c0.1,0,0.2,0,0.3,0.1C85.2,176.9,85.3,176.7,85.4,176.4z"
      />
      <path
        class="st3"
        d="M23.8,130c0,0.2-0.1,0.5-0.1,0.7c0.1-0.1,0.2-0.1,0.3-0.2C23.9,130.3,23.8,130.1,23.8,130z"
      />
      <path
        class="st3"
        d="M24.1,127.1c0,0.2,0,0.4-0.1,0.6c0.4,0.5,0.7,1,1,1.5C25.4,128.4,25.1,127.8,24.1,127.1z"
      />
      <path
        class="st3"
        d="M238.8,133.5C238.8,133.5,238.7,133.4,238.8,133.5C238.7,133.5,238.7,133.5,238.8,133.5L238.8,133.5z"
      />
      <path
        class="st3"
        d="M136.8,150.4L136.8,150.4c-0.3,0.5-0.1,1.1,0.5,1.2c0.7,0.2,1.2-0.1,1.9-1.4c-0.2-0.1-0.4-0.1-0.6-0.2
		c-0.3-0.1-0.5-0.1-0.7-0.1s-0.3,0-0.4,0C137.2,149.9,137,150.1,136.8,150.4z"
      />
      <path
        class="st3"
        d="M2.8,184.7c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C2.8,184.6,2.8,184.7,2.8,184.7z"
      />
      <path
        class="st3"
        d="M48.3,153.9c0.1,0,0.1-0.1,0.2-0.1c-0.3-1-0.4-1.2-1.4-1.5c0,0.2,0,0.3,0,0.5c-0.3-0.2-0.6-0.5-0.8-0.7l0,0
		C46.3,153.6,46.9,154.1,48.3,153.9z"
      />
      <path
        class="st3"
        d="M246.7,70.8c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C245.6,70.5,246.1,70.9,246.7,70.8z"
      />
      <path
        class="st3"
        d="M136.1,103.3c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2S135.4,103.2,136.1,103.3z"
      />
      <path
        class="st3"
        d="M128.9,101.4c0.1,0.5,0.7,0.9,1.2,0.8s0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8
		C129.2,100.2,128.8,100.9,128.9,101.4z"
      />
      <path
        class="st3"
        d="M82.5,173.4c-0.5-0.1-0.9-0.3-1.4-0.4c0,0.3,0.2,0.5,0.6,1C82.1,173.8,82.3,173.6,82.5,173.4z"
      />
      <path
        class="st3"
        d="M180.3,105.2c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C181,106,181,105.6,180.3,105.2z"
      />
      <path
        class="st3"
        d="M210.4,107.9c-0.2,0.2-0.4,0.5-0.4,1c0.8-0.2,1.5-0.2,2.2-0.4C211.6,108.3,211,108.1,210.4,107.9z"
      />
      <path
        class="st3"
        d="M92.7,163.7c0-0.1,0-0.2,0-0.2c0-0.1-0.1-0.2-0.1-0.3c-0.2-0.3-0.5-0.4-0.9-0.3c-0.4,0.1-0.7,0.3-0.9,0.5
		c-0.1,0.1-0.2,0.3-0.2,0.5s0.2,0.4,0.4,0.6c0.2,0.2,0.5,0.3,0.9,0.2C92.2,164.6,92.7,164.1,92.7,163.7z"
      />
      <path
        class="st3"
        d="M289.6,113.6L289.6,113.6c0-0.2,0-0.4,0-0.6c0,0.1-0.1,0.2-0.1,0.3C289.5,113.4,289.5,113.5,289.6,113.6z"
      />
      <path
        class="st3"
        d="M94,157.3c0.1-0.1,0.2-0.1,0.3-0.2c-0.3,0-0.6,0.1-0.8,0.1c-0.1,0-0.2,0-0.3,0c0.1,0.1,0.2,0.2,0.4,0.3
		C93.7,157.5,93.8,157.4,94,157.3z"
      />
      <path
        class="st3"
        d="M262.8,87.7c0.4,0.3,0.9,0.5,1.3,0.8v-0.1C264,87.9,263.4,87.5,262.8,87.7z"
      />
      <path
        class="st3"
        d="M262,88.5c0,0.1,0,0.2,0,0.3c0.1,0.4,0.6,0.6,1,0.6C262.7,89.1,262.3,88.8,262,88.5z"
      />
      <path
        class="st3"
        d="M39.4,128.7c-0.1-0.9-0.7-1.4-1.9-1.6C37.1,128.8,37.7,129.3,39.4,128.7z"
      />
      <path
        class="st3"
        d="M187.6,110.2c0.5-0.1,1.1-0.7,0.8-1.1c-0.2-0.3-0.7-0.5-1.1-0.6c-0.5-0.1-1,0.5-0.9,1
		C186.5,110,187.1,110.3,187.6,110.2z"
      />
      <path
        class="st3"
        d="M179.1,112.4c-0.2,0-0.6,0-0.8,0c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.4,0.5,0.8,0.8,1.2c0.2-0.1,0.4-0.2,0.5-0.4
		c0.2-0.3,0.2-0.7,0.1-1C179.2,112.4,179.2,112.4,179.1,112.4z"
      />
      <path
        class="st3"
        d="M201.3,103.1c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C201.7,102,201.2,102.6,201.3,103.1z"
      />
      <path
        class="st3"
        d="M186.1,122.8c0.3-0.3,0.6-0.6,0.7-0.9c0.2-0.8,0.2-1.5-1-2.2C185.9,120.9,185.1,121.8,186.1,122.8z"
      />
      <path
        class="st3"
        d="M87.3,144.3c-0.1-0.4-0.7-0.7-1.2-0.6c-0.5,0.1-1,0.7-0.8,1.1c0.2,0.3,0.7,0.5,1.1,0.6
		C86.9,145.4,87.4,144.7,87.3,144.3z"
      />
      <path
        class="st3"
        d="M261.3,119.9L261.3,119.9c0-0.8,0-1.7,0-2.7c-0.4-0.2-0.8-0.3-1.2,0.2l0,0C260.5,118.2,260.9,119,261.3,119.9z
		"
      />
      <path
        class="st3"
        d="M50.5,158.2c-0.3,0.3-0.4,0.6-0.2,0.8c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6
		c-0.1-0.4-0.8-0.7-1.3-0.6C50.8,157.9,50.6,158.1,50.5,158.2z"
      />
      <path
        class="st3"
        d="M278.8,121c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.2,0.2-0.3,0.3-0.5,0.5c0,0.5,0,1,0,1.5C278.7,121,278.7,121,278.8,121z"
      />
      <path
        class="st3"
        d="M170.1,101.7c-0.2-0.9-0.8-1.3-2.1-1.1C168.5,102.1,168.7,102.2,170.1,101.7z"
      />
      <path
        class="st3"
        d="M176.3,130.4c0.1,0.3,0.2,0.5,0.3,0.6s0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		c-0.1-0.5-0.6-0.4-1.7,0C176.3,130.1,176.3,130.2,176.3,130.4z"
      />
      <path
        class="st3"
        d="M107.2,103.7c-1.3,0.9-1.3,0.9-0.8,2C108,104.6,108,104.6,107.2,103.7z"
      />
      <path
        class="st3"
        d="M149.4,134.7c-0.1-0.4-0.2-0.8-0.2-1.2c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0.2-0.7,0.5-0.3,0.9
		C148.7,134.8,149,134.9,149.4,134.7z"
      />
      <path
        class="st3"
        d="M114.9,110.9c-0.3-0.7-0.8-1-1.5-1c-0.2,0-0.5,0.1-0.6,0.3c-0.1,0.1-0.1,0.4,0,0.6
		C113.2,111.3,113.7,111.3,114.9,110.9z"
      />
      <path
        class="st3"
        d="M286.5,133.9c0.1-0.6-0.2-0.9-1.1-1c-0.1,0.4-0.3,0.8-0.4,1.2c0.2,0.2,0.4,0.5,0.5,0.7
		C286.1,134.6,286.4,134.3,286.5,133.9z"
      />
      <path
        class="st3"
        d="M246.2,82.2c0.3-0.5,0.7-0.8,0.7-1.2c0-0.4-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C245.4,81.8,245.8,81.9,246.2,82.2z"
      />
      <path
        class="st3"
        d="M265.7,117c-0.1,0-0.1,0-0.2,0c0,0.4,0,0.9,0,1.3c0.2-0.1,0.4-0.1,0.7-0.2C266.4,117.8,266.1,117.4,265.7,117z
		"
      />
      <path
        class="st3"
        d="M246.1,105.7c0.4,0.3,0.7,0.5,1.1,0.8c0-0.2,0-0.5-0.1-0.6C246.8,105.5,246.5,105.5,246.1,105.7z"
      />
      <path
        class="st3"
        d="M129.4,129.8c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C128.4,129.5,128.9,130,129.4,129.8z"
      />
      <path
        class="st3"
        d="M1.3,173c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1v1.3c0.2,0.1,0.5,0.3,0.7,0.5
		C1,173.7,1.3,173.3,1.3,173z"
      />
      <path
        class="st3"
        d="M128.7,88.9c0.5-1.1,0.5-1.1-0.8-1.8C127.5,88.5,127.5,88.5,128.7,88.9z"
      />
      <path
        class="st3"
        d="M2.5,122.3c0.6-0.1,0.8-0.5,0.7-0.9c-0.2-0.4-0.6-0.7-1.1-0.5c-0.3,0.2-0.7,0.6-0.7,1
		C1.5,122.3,1.9,122.5,2.5,122.3z"
      />
      <path
        class="st3"
        d="M186.7,115c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C186.2,114.2,186,114.7,186.7,115z"
      />
      <path
        class="st3"
        d="M138.4,97.5c0.2-0.3,0.4-0.5,0.7-0.9c-0.4-0.3-0.7-0.6-1-0.6c-0.4-0.1-0.8,0.6-0.6,0.9
		C137.7,97.2,138.1,97.3,138.4,97.5z"
      />
      <path
        class="st3"
        d="M274.8,141c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1c0.5-0.1,1.1,0,1.4-0.7c-0.3-0.5-0.8-0.6-1.5-0.5
		c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.2,0,0.4,0.1,0.7c-0.1-0.1-0.2-0.2-0.4-0.2l-0.1,0.1C274.4,140.7,274.7,140.9,274.8,141z"
      />
      <path
        class="st3"
        d="M54.6,155.6c0.2,0,0.4,0,0.5,0c0.1-0.3,0.3-0.6,0.4-0.9c-0.3-0.2-0.7-0.4-1.2-0.4c0,0.2,0,0.3-0.1,0.5
		C54.4,155.2,54.4,155.5,54.6,155.6z"
      />
      <path
        class="st3"
        d="M119.3,106.8c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C117.8,106.4,118.3,106.6,119.3,106.8z"
      />
      <path
        class="st3"
        d="M179.6,109.7c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C178.4,109.6,179,109.5,179.6,109.7z"
      />
      <path
        class="st3"
        d="M177,118.9c0.1-0.2,0.3-0.3,0.4-0.5c-0.1-0.3-0.1-0.7-0.2-1h-0.1c-0.4,0-0.8,0.3-1.1,0.8v0.1
		C176.4,118.5,176.7,118.6,177,118.9z"
      />
      <path
        class="st3"
        d="M128.1,117.6L128.1,117.6c-0.3-0.2-0.5-0.4-0.8-0.4c-0.4,0-0.8,0.2-1.3,0.3c0.3,0.2,0.5,0.5,0.7,0.6
		c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.7,0,1-0.2C128.1,118,128.2,117.7,128.1,117.6z"
      />
      <path
        class="st3"
        d="M129.5,104.6c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3c-0.1-0.1-0.7-0.1-0.9,0s-0.2,0.6-0.1,0.8
		C128.6,104.1,129.1,104.3,129.5,104.6z"
      />
      <path
        class="st3"
        d="M281.5,129.1c0.1,0.1,0.1,0.1,0.2,0.2c0.4-0.1,0.9-0.2,1.3-0.3c-0.1-0.2-0.2-0.3-0.2-0.5c0-0.1,0-0.2-0.1-0.2
		C282.2,128.5,281.7,128.5,281.5,129.1z"
      />
      <path
        class="st3"
        d="M13.2,165.7c0.5-0.6,0.7-0.9,0.5-1.1c-0.4,0-0.8,0-1.2,0C12.5,165.1,12.7,165.5,13.2,165.7z"
      />
      <path
        class="st3"
        d="M121.7,100.5c0.3-1.1,0.3-1.1-1.3-1.4C120.4,99.8,120.6,100.3,121.7,100.5z"
      />
      <path
        class="st3"
        d="M231.9,79c0-0.7,0-1.4-0.7-1.8c-0.1,0.8-0.1,1.6-0.2,2.4C231.5,79.4,231.9,79.2,231.9,79z"
      />
      <path
        class="st3"
        d="M0.9,152.8c-0.7,1.2-0.6,1.5,0.7,1.6C1.8,153.7,1.9,153,0.9,152.8z"
      />
      <path
        class="st3"
        d="M24.4,154.9L24.4,154.9c0.1,0,0.2,0,0.2,0c0.2-0.3,0.5-0.5,0.5-0.8c0-0.4-0.4-0.6-0.9-0.5s-0.7,0.5-0.5,0.8
		C23.7,154.7,24,154.8,24.4,154.9z"
      />
      <path
        class="st3"
        d="M74.6,173.7c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9C73.9,173.3,73.8,173.6,74.6,173.7z"
      />
      <path
        class="st3"
        d="M101.1,151.5c-0.1,0-0.2,0.4-0.1,0.5c0.1,0.3,0.3,0.5,0.6,0.5c0.1-0.4,0.2-0.7,0.4-0.9l-0.1-0.1
		C101.7,151.4,101.3,151.4,101.1,151.5z"
      />
      <path
        class="st3"
        d="M124.8,120.5c0-0.1,0-0.3-0.1-0.4c-0.7-0.3-1.1,0-1.5,0.8C123.9,121.1,124.5,121.2,124.8,120.5z"
      />
      <path
        class="st3"
        d="M5.1,201.1c-0.4-0.2-0.7-0.5-0.9-0.4c-0.2,0.1-0.6,0.5-0.5,0.7c0,0.2,0.4,0.3,0.7,0.5
		C4.6,201.6,4.8,201.4,5.1,201.1z"
      />
      <path
        class="st3"
        d="M154.4,99.9c0.4-0.5,0.8-0.9,0.2-1.4C153.7,99.3,153.7,99.3,154.4,99.9z"
      />
      <path
        class="st3"
        d="M165.6,117.3c0.2,0.1,0.4,0.2,0.6,0.3c0-0.3,0-0.5,0-0.7c-0.2-0.2-0.5-0.3-0.7-0.5l0,0
		c-0.4,0.4-0.5,0.6-0.2,0.8C165.4,117.2,165.5,117.3,165.6,117.3z"
      />
      <path
        class="st3"
        d="M135,139.1c0-0.1,0-0.2,0-0.2c-0.6-0.2-1.1-0.4-1.9-0.6c0.2,0.6,0.4,0.9,0.8,1
		C134.2,139.3,134.6,139.2,135,139.1z"
      />
      <path
        class="st3"
        d="M117.6,108.2c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.7-0.6-0.7-1.5-0.5C116.6,108,116.9,108.4,117.6,108.2z"
      />
      <path
        class="st3"
        d="M258.6,117.2c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-0.4-0.1-0.7-0.2-0.8c-0.2,0.1-0.4,0.2-0.6,0.2
		c0.1,0.1,0.2,0.3,0.2,0.4C258.5,117,258.6,117.1,258.6,117.2z"
      />
      <path
        class="st3"
        d="M201.8,116.5c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3-0.2,0.5-0.3C202.2,116.4,202,116.4,201.8,116.5z"
      />
      <path
        class="st3"
        d="M202.3,83c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C201.7,83.6,202,83.4,202.3,83z"
      />
      <path
        class="st3"
        d="M94.3,137.9c0.2-0.2,0.3-0.4,0.4-0.6c0.2-0.2,0.4-0.5,0.5-0.7h-0.1c-0.1,0-0.2-0.1-0.3-0.1
		C93.9,137,93.9,137,94.3,137.9z"
      />
      <path
        class="st3"
        d="M123.3,110.9c0.2,0.3,0.5,0.4,0.8,0.7c0.2-0.2,0.6-0.4,0.5-0.5c-0.1-0.3-0.4-0.5-0.7-0.9
		C123.6,110.5,123.3,110.8,123.3,110.9z"
      />
      <path
        class="st3"
        d="M132.6,96.9c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4
		C131.9,96.4,131.9,96.8,132.6,96.9z"
      />
      <path
        class="st3"
        d="M125.1,141.5c-0.5-0.1-0.8-0.3-1.2-0.3c0,0-0.4,0.5-0.3,0.6c0.2,0.2,0.5,0.4,0.8,0.4
		C124.5,142.2,124.7,141.9,125.1,141.5z"
      />
      <path
        class="st3"
        d="M33,168.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.2,0.1L33,169C33,169,32.9,168.9,33,168.9z"
      />
      <path
        class="st3"
        d="M65.6,157.8c0,0.3,0,0.5,0,0.6c0.2,0.3,0.6,0.4,1.2,0.4c0-0.6-0.3-0.8-0.8-1C66,157.8,65.8,157.8,65.6,157.8z"
      />
      <path
        class="st3"
        d="M122.4,94.4c0.4-0.9-0.2-1.1-1-1.3C121.4,93.8,121.4,94.4,122.4,94.4z"
      />
      <path
        class="st3"
        d="M183.4,122.4c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C183.6,122,183.3,122.3,183.4,122.4z"
      />
      <path
        class="st3"
        d="M285.9,119.4c-0.2-0.3-0.4-0.6-0.8-1.1C284.6,119.2,285,119.4,285.9,119.4z"
      />
      <path
        class="st3"
        d="M184.7,120.3c-0.2-0.1-0.6-0.3-0.7-0.2c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C184.3,120.8,184.5,120.5,184.7,120.3z"
      />
      <path
        class="st3"
        d="M26,176.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.1,0.1-0.3,0.3-0.5,0.4C25.4,176.2,25.7,176.2,26,176.1
		C26,176.2,26,176.2,26,176.1z"
      />
      <path
        class="st3"
        d="M24.5,177c0.3,0,0.5,0,0.7,0c-0.2-0.1-0.3-0.1-0.5-0.2C24.6,176.8,24.5,176.9,24.5,177z"
      />
      <path
        class="st3"
        d="M135.7,124.6c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0c-0.1,0.1-0.1,0.3-0.1,0.4
		C134.9,125.1,135.3,124.9,135.7,124.6z"
      />
      <path
        class="st3"
        d="M188.6,80.1c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C187.9,80.1,188.2,80.2,188.6,80.1z"
      />
      <path
        class="st3"
        d="M138.3,138.4c0.3-0.1,0.7-0.3,1-0.4c0,0,0,0,0-0.1c-0.3,0-0.7-0.1-1-0.1C138.3,138,138.3,138.2,138.3,138.4
		L138.3,138.4z"
      />
      <path
        class="st3"
        d="M130.9,111c0.1,0,0.4-0.1,0.4-0.2c0.2-0.5-0.1-0.7-0.8-0.8C130.4,110.5,130.3,110.9,130.9,111z"
      />
      <path
        class="st3"
        d="M157.1,99.1c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C156.6,99,156.9,99,157.1,99.1z"
      />
      <path
        class="st3"
        d="M169.5,105.3c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2c0.3-0.2,0.5-0.4,0.8-0.7C169.9,105.4,169.6,105.2,169.5,105.3z
		"
      />
      <path
        class="st3"
        d="M87.1,145.9c-0.7-0.2-1-0.1-1.3,0.3c0.1,0.1,0.2,0.1,0.3,0.2c-0.2,0-0.2,0.1-0.4,0.1
		C86.4,146.8,86.8,146.6,87.1,145.9z"
      />
      <path
        class="st3"
        d="M135.1,128c0.2-0.1,0.4-0.3,0.7-0.5c-0.3-0.1-0.6-0.3-0.7-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		C134.6,127.7,135,128,135.1,128z"
      />
      <path
        class="st3"
        d="M134.6,115.9L134.6,115.9c-0.2-0.1-0.5-0.2-0.7-0.2s-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3
		c0.1,0,0.2,0,0.3,0s0.3,0,0.4-0.1C134.6,116.2,134.7,115.9,134.6,115.9z"
      />
      <path
        class="st3"
        d="M7.6,168.7c0-0.2-0.1-0.4-0.1-0.7c-0.2,0-0.3,0-0.5,0.1c-0.2,0.3-0.2,0.5-0.1,0.8
		C7.1,168.8,7.4,168.7,7.6,168.7z"
      />
      <path
        class="st3"
        d="M192.7,122.7c0.1-0.2,0.3-0.4,0.4-0.6l0,0C192.8,122.2,192.7,122.5,192.7,122.7L192.7,122.7z"
      />
      <path
        class="st3"
        d="M164.1,110.4c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C163.9,109.8,164,110.1,164.1,110.4z"
      />
      <path
        class="st3"
        d="M170.3,120.1c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.3,0.3-0.6,0.2-1C170.2,119,169.9,119.5,170.3,120.1z"
      />
      <path
        class="st3"
        d="M267.6,76c-0.2-0.3-0.4-0.6-0.6-0.9c0,0,0,0-0.1,0c-0.1,0.1-0.3,0.1-0.4,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C267.3,76.1,267.4,76,267.6,76z"
      />
      <path
        class="st3"
        d="M159.1,108.9c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C158.7,108.7,159,108.8,159.1,108.9z"
      />
      <path
        class="st3"
        d="M252.8,110.1c-0.2,0.1-0.4,0.3-0.6,0.5c0,0.1,0.2,0.2,0.5,0.4c0.3-0.3,0.4-0.5,0.6-0.7
		C253.2,110.3,252.9,110.1,252.8,110.1z"
      />
      <path
        class="st3"
        d="M86.9,173.6c-0.2-0.2-0.5-0.4-0.7-0.5l-0.1,0.1c0.1,0,0.1,0.1,0.2,0.1C86.4,173.4,86.6,173.5,86.9,173.6z"
      />
      <path
        class="st3"
        d="M272.4,139.7c0.2-0.1,0.3-0.3,0.3-0.4c-0.2-0.1-0.4-0.3-0.6-0.4C272,139.1,272.1,139.4,272.4,139.7z"
      />
      <path
        class="st3"
        d="M131.3,125.8c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.4,0.4-0.3,0.4
		C130.7,125.5,131,125.6,131.3,125.8z"
      />
      <path
        class="st3"
        d="M264.6,104.3c0.1,0,0.2,0.1,0.4,0.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5
		c0,0,0,0.1,0.1,0.1C264.3,104.1,264.5,104.2,264.6,104.3z"
      />
      <path
        class="st3"
        d="M174.3,115.4c0.1-0.1,0.1-0.3,0.2-0.4c0-0.3,0-0.6,0-0.9c-0.1,0-0.2,0.1-0.3,0.1s-0.1,0.1-0.1,0.1l0,0
		c-0.1,0.2,0,0.5,0.2,0.9C174.3,115.4,174.3,115.4,174.3,115.4z"
      />
      <path
        class="st3"
        d="M234.2,129.6c-0.1,0.1-0.1,0.2-0.2,0.2h0.1C234.2,129.8,234.2,129.7,234.2,129.6z"
      />
      <path
        class="st3"
        d="M237.9,131.3c-0.3-0.1-0.5-0.2-0.8-0.3c-0.7,0.2-1.3,0.4-1.9,0.7c0.1,0,0.1,0,0.2,0c0.4,0,0.7-0.2,1.1-0.3v0.1
		c0,0,0,0,0.1,0C237,132.2,237,132.2,237.9,131.3z"
      />
      <path
        class="st3"
        d="M32.6,170.8c-0.1,0.2-0.2,0.4-0.3,0.6c0.3,0,0.6,0,0.9-0.1C33.1,171.2,32.9,171.1,32.6,170.8z"
      />
      <path
        class="st3"
        d="M95.3,99.6c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C95,100,95.1,99.8,95.3,99.6z"
      />
      <path
        class="st3"
        d="M27.3,172.8l-0.1-0.1c-0.1,0-0.1-0.1-0.1-0.1c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.1-0.2,0.1-0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3C26.9,173.3,27.1,173,27.3,172.8z"
      />
      <path
        class="st3"
        d="M247.1,116.1c0.3,0,0.5,0,0.8,0c-0.2-0.3-0.5-0.5-1.1-0.5C246.8,115.9,247,116,247.1,116.1z"
      />
      <path
        class="st3"
        d="M104.5,131.6c0.3,0.4,0.4,0.7,0.7,1.2C105.5,132,105.4,131.6,104.5,131.6z"
      />
      <path
        class="st3"
        d="M241.2,130.3c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2C241.4,130.3,241.3,130.3,241.2,130.3z"
      />
      <path
        class="st3"
        d="M128.3,114.1C128.2,114.1,128.2,114.1,128.3,114.1c-0.1,0-0.1,0.1-0.1,0.1S128.2,114.2,128.3,114.1
		C128.2,114.2,128.3,114.1,128.3,114.1z"
      />
      <path
        class="st3"
        d="M128.3,114.1c0.6-0.1,1.1-0.2,1.7-0.4C129.2,113.3,129.1,113.3,128.3,114.1z"
      />
      <path
        class="st3"
        d="M131.1,123.9c0-0.1-0.2-0.3-0.4-0.5c-0.3,0.3-0.4,0.5-0.6,0.7c0.2,0.1,0.4,0.3,0.6,0.2
		C130.8,124.3,131.1,124.1,131.1,123.9z"
      />
      <path
        class="st3"
        d="M111.6,147.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4
		c0.1,0.1,0.1,0.1,0.2,0.2C111,147.6,111.3,147.5,111.6,147.3z"
      />
      <path
        class="st3"
        d="M29,175.3c-0.4,0.3-0.5,0.6-0.1,0.9c0.5-0.1,0.7-0.3,0.6-0.8C29.4,175.4,29.1,175.3,29,175.3z"
      />
      <path
        class="st3"
        d="M176.2,128.3c0,0.2,0,0.4,0,0.6v0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.3-0.3,0.3-0.4
		C176.6,128.4,176.4,128.3,176.2,128.3z"
      />
      <path
        class="st3"
        d="M56.2,152.2c0.1,0,0.2,0,0.4,0s0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2c-0.4,0-0.8,0-1.3,0.1c-0.1,0-0.2,0-0.3,0
		c0,0.1,0,0.2,0,0.3C55.9,152.2,56,152.2,56.2,152.2z"
      />
      <path
        class="st3"
        d="M283.3,123.9c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C282.6,124.2,282.9,124.1,283.3,123.9z"
      />
      <path
        class="st3"
        d="M63.7,175.8c0.3,0.3,0.7,0.6,1,1c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.3-0.6-0.6-0.9-1
		C63.9,175.6,63.8,175.7,63.7,175.8z"
      />
      <path
        class="st3"
        d="M234.4,128.3c0-0.1-0.1-0.2-0.2-0.3c-0.1,0.2-0.1,0.4-0.2,0.6c0.1,0.1,0.2,0.1,0.3,0.2
		C234.4,128.6,234.4,128.4,234.4,128.3z"
      />
      <path
        class="st3"
        d="M126.4,88.7c-0.1-0.2-0.2-0.5-0.3-0.7c-0.2,0-0.3,0.1-0.5,0.1c0.1,0.2,0.3,0.4,0.4,0.7
		C126.2,88.8,126.3,88.8,126.4,88.7z"
      />
      <path
        class="st3"
        d="M79.5,179.5c0-0.1-0.1-0.2-0.1-0.2c-0.3,0.1-0.7,0.2-1,0.3C78.9,179.7,79.3,180,79.5,179.5z"
      />
      <path
        class="st3"
        d="M76.6,177.5C76.6,177.4,76.6,177.4,76.6,177.5c-0.1-0.2-0.3-0.2-0.5-0.2H76C76.1,177.3,76.4,177.4,76.6,177.5
		L76.6,177.5z"
      />
      <path
        class="st3"
        d="M76.7,177.2c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C76.7,177.3,76.7,177.2,76.7,177.2z"
      />
      <path
        class="st3"
        d="M267.5,113.3c-0.1,0-0.1,0-0.2,0.1c-0.1,0.3-0.1,0.6-0.2,0.9c0.1,0,0.2,0,0.4,0c0.1-0.3,0.1-0.7,0.2-1
		C267.6,113.3,267.5,113.3,267.5,113.3z"
      />
      <path
        class="st3"
        d="M130.1,113.8L130.1,113.8C130,113.7,130,113.8,130.1,113.8C130,113.8,130,113.8,130.1,113.8
		C130,113.8,130.1,113.8,130.1,113.8z"
      />
      <path
        class="st3"
        d="M130.1,115.1c0.5-0.5,0.7-1,0-1.3c0.1,0.2,0.1,0.4,0.1,0.7C130.2,114.7,130.1,114.9,130.1,115.1z"
      />
      <path
        class="st3"
        d="M142.6,129.1c-0.3-0.2-0.4-0.4-0.6-0.6c0,0-0.4,0.2-0.4,0.3C141.5,129.3,141.9,129.3,142.6,129.1z"
      />
      <path
        class="st3"
        d="M167.5,111.8c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C167.2,112.1,167.4,111.9,167.5,111.8z"
      />
      <path
        class="st3"
        d="M114.3,106.3c0.4,0.2,0.7,0.4,1.2,0.7C115.4,106.1,115.1,106,114.3,106.3z"
      />
      <path
        class="st3"
        d="M178.2,88.2c0-0.1,0-0.2-0.1-0.3c-0.5-0.2-0.7,0-0.9,0.5C177.6,88.6,178,88.6,178.2,88.2z"
      />
      <path
        class="st3"
        d="M218.3,116.9l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1c0.1,0.1,0.2,0.1,0.4,0.2
		C217.7,117.5,218,117.3,218.3,116.9C218.2,117,218.2,116.9,218.3,116.9z"
      />
      <path
        class="st3"
        d="M178.1,121.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0C178,121.8,178.1,121.8,178.1,121.7z"
      />
      <path
        class="st3"
        d="M177.5,122.9c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C177.5,122.1,177.4,122.5,177.5,122.9z"
      />
      <path
        class="st3"
        d="M135.4,132C135.5,132,135.5,132,135.4,132c0.3,0,0.5-0.2,0.6-0.3l0,0c0-0.1-0.2-0.2-0.4-0.4
		c-0.2,0.2-0.4,0.4-0.5,0.5C135.1,131.8,135.3,132,135.4,132z"
      />
      <path
        class="st3"
        d="M136.7,133L136.7,133c0.1,0,0.1-0.2,0.1-0.3c-0.2,0-0.4,0.1-0.6,0.1C136.3,132.9,136.5,133,136.7,133z"
      />
      <path
        class="st3"
        d="M179.9,124.8c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0-0.1,0.1c0.2,0,0.3,0,0.5,0C180.1,124.9,180,124.8,179.9,124.8z
		"
      />
      <path
        class="st3"
        d="M179.6,125.4c0-0.1,0-0.2,0-0.3c0,0.1-0.1,0.1-0.1,0.2C179.5,125.3,179.5,125.4,179.6,125.4z"
      />
      <path
        class="st3"
        d="M279.5,115.9c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1
		c0,0,0,0.1,0.1,0.1C279.2,115.5,279.4,115.7,279.5,115.9z"
      />
      <path
        class="st3"
        d="M288.7,125.7c0.4,0.2,0.6,0.3,1,0.4C289.4,125.6,289.4,125.6,288.7,125.7z"
      />
      <path
        class="st3"
        d="M141.7,126.3c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C141.4,126.2,141.6,126.4,141.7,126.3z"
      />
      <path
        class="st3"
        d="M144.8,103.2c-0.1-0.3-0.1-0.6-0.2-0.8c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.8
		C144.5,103.2,144.7,103.2,144.8,103.2z"
      />
      <path
        class="st3"
        d="M124,98c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5C123.9,98.2,124,98.1,124,98z"
      />
      <path
        class="st3"
        d="M127,94.3c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C126.8,94.4,127,94.3,127,94.3z"
      />
      <path
        class="st3"
        d="M236.9,132.4c0-0.1,0.1-0.1,0.1-0.1c-0.1,0.1-0.2,0.1-0.3,0.2C236.8,132.4,236.8,132.4,236.9,132.4z"
      />
      <path
        class="st3"
        d="M235.7,133.1c0.4-0.1,0.6-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2C236.2,132.7,236,132.9,235.7,133.1z"
      />
      <path
        class="st3"
        d="M33.3,160.3c-0.1,0-0.2,0-0.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c0.2,0,0.3,0,0.5,0C33.3,160.9,33.3,160.6,33.3,160.3
		z"
      />
      <path
        class="st3"
        d="M82.8,166.3L82.8,166.3c0-0.3,0-0.5,0-0.7c-0.1,0.2-0.3,0.4-0.4,0.5C82.5,166.2,82.6,166.3,82.8,166.3
		L82.8,166.3z"
      />
      <path
        class="st3"
        d="M189.2,113.3c0,0.1,0.2,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.2-0.1-0.4-0.2-0.5-0.2
		C189.3,113.1,189.2,113.2,189.2,113.3z"
      />
      <path
        class="st3"
        d="M127.4,90c0-0.3,0.1-0.4,0.1-0.6c0-0.1-0.2-0.1-0.4-0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		C126.8,89.8,127.1,89.9,127.4,90z"
      />
      <path
        class="st3"
        d="M233.2,133.2c-0.3,0.1-0.7,0.1-1,0.2v0.1c0.3-0.1,0.7-0.1,1-0.2C233.3,133.3,233.2,133.3,233.2,133.2z"
      />
      <path
        class="st3"
        d="M163.8,103.7c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C163.6,104,163.6,103.8,163.8,103.7z"
      />
      <path
        class="st3"
        d="M155.9,76.1c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3
		C155.7,76,155.8,76.1,155.9,76.1z"
      />
      <path
        class="st3"
        d="M289.5,108.6c0.1-0.2,0.2-0.5,0.3-0.7c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.1,0,0.2,0
		C289.4,108.6,289.4,108.6,289.5,108.6z"
      />
      <path
        class="st3"
        d="M196.2,68.4h-0.4C195.9,68.4,196,68.5,196.2,68.4C196.1,68.5,196.2,68.5,196.2,68.4z"
      />
      <path
        class="st3"
        d="M171,112.1c0.1-0.1,0.2-0.3,0.2-0.4c-0.1,0-0.1,0-0.2-0.1C171,111.8,171,112,171,112.1z"
      />
      <path
        class="st3"
        d="M153.6,104.6c0.1,0,0.3-0.2,0.3-0.3c0-0.1-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1
		c0.2,0,0.3,0.1,0.4,0.1C153.5,104.6,153.5,104.6,153.6,104.6z"
      />
      <path
        class="st3"
        d="M127.7,97.4c0,0.1,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2
		C127.8,97.2,127.7,97.3,127.7,97.4z"
      />
      <path
        class="st3"
        d="M271.9,128.2c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.4c0.2,0,0.3,0,0.5,0
		C272.2,128.5,272.1,128.4,271.9,128.2z"
      />
      <path
        class="st3"
        d="M134.1,96.9c-0.1-0.3-0.1-0.7-0.7-0.7C133.5,96.5,133.5,96.9,134.1,96.9z"
      />
      <path
        class="st3"
        d="M263.3,102.4C263.3,102.3,263.3,102.3,263.3,102.4C263.3,102.3,263.3,102.3,263.3,102.4c-0.1,0-0.2,0-0.2,0
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0C263.4,102.8,263.3,102.6,263.3,102.4z"
      />
      <path
        class="st3"
        d="M129.7,115.9c-0.3-0.2-0.5-0.3-0.7-0.5C129,115.7,129,116.1,129.7,115.9z"
      />
      <path
        class="st3"
        d="M128.7,115.2L128.7,115.2l0.1,0.2C128.9,115.4,128.9,115.3,128.7,115.2C128.8,115.3,128.8,115.2,128.7,115.2z"
      />
      <path
        class="st3"
        d="M83.2,142.3l0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.3l0,0C83.1,142,83.1,142.1,83.2,142.3
		C83.2,142.2,83.2,142.3,83.2,142.3z"
      />
      <path
        class="st3"
        d="M77.5,109.3c-0.3-0.1-0.5-0.2-0.6-0.2s-0.2,0.1-0.3,0.2c0.1,0.1,0.2,0.3,0.4,0.3
		C77.1,109.6,77.2,109.4,77.5,109.3z"
      />
      <path
        class="st3"
        d="M212.2,81.3c0.1-0.2,0.2-0.3,0.2-0.4s-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C211.9,81.1,212,81.1,212.2,81.3z"
      />
      <path
        class="st3"
        d="M273.9,118.8c0.1-0.1,0.3-0.2,0.4-0.3l0,0c-0.1-0.1-0.2-0.1-0.3-0.2l-0.1,0.1
		C273.9,118.6,273.9,118.7,273.9,118.8z"
      />
      <path
        class="st3"
        d="M145.6,130.3l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C145.7,130.6,145.7,130.5,145.6,130.3
		C145.7,130.3,145.7,130.3,145.6,130.3z"
      />
      <path
        class="st3"
        d="M131.8,115.6c-0.1,0-0.2,0.2-0.3,0.3c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3
		C132.1,115.8,131.9,115.6,131.8,115.6z"
      />
      <path
        class="st3"
        d="M161,94.8c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.2,0.2-0.1,0.2
		C160.7,94.6,160.8,94.7,161,94.8z"
      />
      <path
        class="st3"
        d="M75.9,174.3c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2
		C75.8,174.1,75.9,174.2,75.9,174.3z"
      />
      <path
        class="st3"
        d="M171.3,91.8c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C171.2,91.9,171.2,91.9,171.3,91.8z"
      />
      <path
        class="st3"
        d="M158.6,96.1c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C158.4,96.3,158.5,96.2,158.6,96.1z"
      />
      <path
        class="st3"
        d="M78.3,174c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.2l0.1-0.1C78.5,174.1,78.4,174.1,78.3,174z"
      />
      <path
        class="st3"
        d="M231,76.7c0.1,0.1,0.1,0.2,0.2,0.4c0-0.1,0-0.3,0-0.4C231.1,76.6,231.1,76.6,231,76.7z"
      />
      <path
        class="st3"
        d="M126.5,103.8c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1
		C126.2,103.6,126.3,103.7,126.5,103.8z"
      />
      <path
        class="st3"
        d="M235.2,110.1c0.2-0.1,0.4-0.1,0.6-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.7,0.2
		C235.1,109.9,235.1,110,235.2,110.1C235.1,110.1,235.2,110.1,235.2,110.1z"
      />
      <path
        class="st3"
        d="M270.3,130.8c-0.1-0.1-0.2-0.2-0.3-0.4c0,0.2,0,0.3,0,0.4C270.1,130.8,270.2,130.8,270.3,130.8z"
      />
      <path
        class="st3"
        d="M267.8,117.9C267.7,117.9,267.7,117.9,267.8,117.9c0.1,0,0.1,0,0.2,0C267.9,117.9,267.8,117.8,267.8,117.9z"
      />
      <path
        class="st3"
        d="M25.6,172.9c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.1,0.2,0.2,0.2
		C25.4,173.1,25.5,173,25.6,172.9z"
      />
      <path
        class="st3"
        d="M124.5,137c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C124.6,137.1,124.6,137.1,124.5,137z"
      />
      <path
        class="st3"
        d="M0.4,203.1c-0.1,0-0.1-0.1-0.2-0.1s-0.1,0-0.2,0.1v0.1c0.1,0.1,0.2,0.1,0.3,0.2C0.3,203.2,0.4,203.1,0.4,203.1
		z"
      />
      <path
        class="st3"
        d="M0.3,202.2c-0.1-0.2-0.1-0.3-0.2-0.5H0v0.2c0,0.1,0.1,0.2,0.1,0.3C0.2,202.2,0.3,202.2,0.3,202.2z"
      />
      <path
        class="st3"
        d="M178.8,121c-0.1,0-0.2,0-0.3,0c-0.1,0.2-0.1,0.3-0.2,0.5c0,0.1-0.1,0.1-0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C178.4,121.3,178.6,121.1,178.8,121z"
      />
      <path
        class="st3"
        d="M185.7,124.1L185.7,124.1c-0.1,0-0.1,0-0.2,0l0,0C185.6,124.2,185.7,124.1,185.7,124.1z"
      />
      <path
        class="st3"
        d="M173,108.7c0-0.1,0-0.2,0-0.3l0,0C172.9,108.5,173,108.6,173,108.7L173,108.7z"
      />
      <path
        class="st3"
        d="M276.5,141.2c0-0.1,0-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1L276.5,141.2z"
      />
      <path
        class="st3"
        d="M74.6,143.3c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C74.5,143.2,74.6,143.2,74.6,143.3z"
      />
      <path
        class="st3"
        d="M75.1,143c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1C75.2,142.9,75.2,142.9,75.1,143z"
      />
      <path
        class="st3"
        d="M189.7,117.8c-0.2,0-0.4,0-0.5,0.1s-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.5-0.1C189.6,118.1,189.6,117.9,189.7,117.8
		z"
      />
      <path
        class="st3"
        d="M31.6,158.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.2-0.2
		C31.7,158.6,31.6,158.5,31.6,158.5z"
      />
      <path
        class="st3"
        d="M159.9,113.6l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1
		C160,113.3,159.9,113.4,159.9,113.6C159.8,113.5,159.8,113.6,159.9,113.6z"
      />
      <path
        class="st3"
        d="M200.2,114.1c-0.1,0-0.3-0.1-0.4-0.1l-0.1,0.2c0,0.1,0.2,0.2,0.3,0.3C200,114.4,200.1,114.3,200.2,114.1z"
      />
      <path
        class="st3"
        d="M120.9,108.8c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1
		C120.9,108.7,120.8,108.8,120.9,108.8z"
      />
      <path
        class="st3"
        d="M120.6,130.9C120.5,130.9,120.5,130.9,120.6,130.9l-0.2,0.1C120.5,131,120.5,131,120.6,130.9z"
      />
      <path
        class="st3"
        d="M238.3,135.4c-0.1-0.1-0.2-0.1-0.2-0.1c-0.1,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C238.2,135.5,238.2,135.5,238.3,135.4z"
      />
      <path
        class="st3"
        d="M114.9,112.7c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.4,0.1l0,0l0.1-0.1l-0.1-0.1
		C115,112.8,115,112.7,114.9,112.7z"
      />
      <path
        class="st3"
        d="M220,89.9c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C220,90.3,220,90.1,220,89.9z"
      />
      <path
        class="st3"
        d="M81,162.6c0.1,0,0.1,0,0.3,0.1c0,0,0,0,0-0.1C81.1,162.6,81.1,162.6,81,162.6z"
      />
      <path
        class="st3"
        d="M234.4,134.5c0,0,0,0.1-0.1,0.2c0,0,0,0,0.1,0s0.2,0,0.3,0c0-0.1,0-0.1,0-0.2
		C234.7,134.5,234.5,134.5,234.4,134.5z"
      />
      <path
        class="st3"
        d="M185.5,110c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.3,0C185.7,110.4,185.6,110.2,185.5,110z"
      />
      <path
        class="st3"
        d="M141.6,137.6L141.6,137.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2
		C141.4,137.5,141.5,137.6,141.6,137.6z"
      />
      <path
        class="st3"
        d="M166.4,103.5h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C166.4,103.7,166.4,103.6,166.4,103.5z"
      />
      <path
        class="st3"
        d="M241.2,132.2c0,0,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.1C241.2,132,241.2,132.1,241.2,132.2L241.2,132.2z"
      />
      <path
        class="st3"
        d="M270.9,109.4c0.1,0,0.1,0,0.2-0.1c0,0,0,0,0-0.1C271,109.4,270.9,109.4,270.9,109.4z"
      />
      <path
        class="st3"
        d="M23.4,178.5c-0.1,0-0.1,0-0.2,0.1c0,0.1,0.1,0.2,0.1,0.2l0,0c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.1,0-0.2
		C23.4,178.6,23.4,178.5,23.4,178.5z"
      />
      <path
        class="st3"
        d="M23.5,179C23.5,178.9,23.5,178.9,23.5,179c-0.1-0.1-0.1-0.1-0.2-0.1c0,0.1,0,0.1,0.1,0.2
		C23.4,179,23.5,179,23.5,179z"
      />
      <path
        class="st3"
        d="M188.1,100.7c0.1,0,0.3,0.1,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0-0.2-0.1-0.3-0.1
		C188.2,100.5,188.1,100.6,188.1,100.7z"
      />
      <path
        class="st3"
        d="M150.5,137.1c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c0,0.1-0.1,0.1-0.1,0.2l0,0C150.2,137.2,150.3,137.2,150.5,137.1
		C150.5,137.2,150.5,137.2,150.5,137.1z"
      />
      <path
        class="st3"
        d="M168.6,118.4c0.1,0,0.2,0,0.2-0.1c-0.1-0.2-0.2-0.3-0.2-0.5h-0.1C168.5,118.1,168.5,118.2,168.6,118.4z"
      />
      <path
        class="st3"
        d="M140.7,123.7L140.7,123.7C140.8,123.7,140.8,123.7,140.7,123.7C140.8,123.7,140.8,123.6,140.7,123.7
		C140.8,123.6,140.7,123.6,140.7,123.7z"
      />
      <path
        class="st3"
        d="M141.8,122.5c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C142,122.6,141.9,122.5,141.8,122.5z"
      />
      <path
        class="st3"
        d="M241.2,99.3c0-0.1,0.1-0.2,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1-0.1,0.2-0.1,0.2
		C241,99.2,241.1,99.3,241.2,99.3z"
      />
      <path
        class="st3"
        d="M165.7,119.5c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2C165.8,119.6,165.8,119.6,165.7,119.5z"
      />
      <path
        class="st3"
        d="M84.1,137.9c0-0.1,0.1-0.1,0.1-0.2C84.2,137.7,84.1,137.8,84.1,137.9c-0.1,0-0.2,0.1-0.2,0.1
		C84,137.9,84,137.9,84.1,137.9z"
      />
      <path
        class="st3"
        d="M183.4,109.5c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2C183.7,109.4,183.6,109.4,183.4,109.5
		C183.4,109.4,183.4,109.5,183.4,109.5z"
      />
      <path
        class="st3"
        d="M76,141l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C75.9,141.2,75.9,141.1,76,141z"
      />
      <path
        class="st3"
        d="M75.5,142.5c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2c0.1-0.1,0.1-0.1,0.1-0.2V142.5z"
      />
      <path
        class="st3"
        d="M75.1,166.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.3c0,0.1-0.1,0.2-0.1,0.2
		C75,166.2,75.1,166.2,75.1,166.3z"
      />
      <path
        class="st3"
        d="M196.7,104.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C196.6,104.8,196.6,104.8,196.7,104.8z"
      />
      <path
        class="st3"
        d="M171.3,123.2L171.3,123.2c0.1,0,0.1,0,0.2,0C171.5,123.2,171.5,123.1,171.3,123.2
		C171.4,123.1,171.3,123.1,171.3,123.2C171.3,123.1,171.3,123.2,171.3,123.2z"
      />
      <path
        class="st3"
        d="M112,120.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2C111.7,120.8,111.8,120.8,112,120.7
		C111.9,120.8,112,120.7,112,120.7z"
      />
      <path
        class="st3"
        d="M132.6,115.3c0,0,0.1,0,0.2,0C132.8,115.3,132.8,115.2,132.6,115.3C132.6,115.2,132.6,115.2,132.6,115.3
		C132.5,115.2,132.5,115.3,132.6,115.3z"
      />
      <path
        class="st3"
        d="M171.3,125.3c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C171.3,125.2,171.3,125.3,171.3,125.3z"
      />
      <path
        class="st3"
        d="M139.9,113.4c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C140.1,113.4,140,113.4,139.9,113.4z"
      />
      <path
        class="st3"
        d="M261.6,107.1L261.6,107.1c0,0.1,0.1,0.1,0.1,0.1l0,0L261.6,107.1z"
      />
      <path
        class="st3"
        d="M163.2,107.7c0.1,0,0.2,0,0.3,0s0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C163.3,107.6,163.3,107.7,163.2,107.7z"
      />
      <path
        class="st3"
        d="M275,141.4c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C274.9,141.1,275,141.2,275,141.4z"
      />
      <path
        class="st3"
        d="M290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3c-0.1,0.2-0.1,0.3-0.1,0.3
		C290.8,102.6,290.9,102.5,290.9,102.3C290.9,102.4,290.9,102.4,290.9,102.3z"
      />
      <path
        class="st3"
        d="M291,102c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C291.1,102,291.1,102,291,102z"
      />
      <path
        class="st3"
        d="M30.6,159.6l-0.1,0.1c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C30.7,159.7,30.7,159.6,30.6,159.6z"
      />
      <path
        class="st3"
        d="M118.5,141.2c0.1,0,0.2,0.1,0.3,0.1c0,0,0.1-0.1,0.1-0.2C118.8,141.1,118.7,141.1,118.5,141.2
		C118.6,141.1,118.6,141.1,118.5,141.2z"
      />
      <path
        class="st3"
        d="M273.2,140.2c0,0.1-0.1,0.2-0.1,0.2l0.1,0.1c0.1-0.1,0.1-0.1,0.2-0.2C273.4,140.2,273.3,140.2,273.2,140.2z"
      />
      <path
        class="st3"
        d="M31.7,160.8c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C31.7,160.9,31.7,160.8,31.7,160.8z"
      />
      <path
        class="st3"
        d="M122.4,115.4c0,0.1,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1
		C122.5,115.2,122.4,115.3,122.4,115.4z"
      />
      <path
        class="st3"
        d="M245.4,115c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0S245.4,114.9,245.4,115z"
      />
      <path
        class="st3"
        d="M109.8,146C109.8,145.9,109.9,145.9,109.8,146c0.1-0.1,0.1-0.1,0.2-0.1c-0.1,0-0.2,0-0.3,0l0,0l0,0l-0.1,0.1
		C109.7,145.9,109.7,146,109.8,146L109.8,146z"
      />
      <path
        class="st3"
        d="M10,167.8H9.9v0.1c0.1,0,0.1,0,0.2,0C10,167.9,10,167.9,10,167.8z"
      />
      <path
        class="st3"
        d="M33.6,131.4v0.1C33.7,131.5,33.7,131.5,33.6,131.4C33.7,131.5,33.7,131.4,33.6,131.4z"
      />
      <path
        class="st3"
        d="M220.1,90.6l-0.1-0.1c0,0,0,0,0-0.1v0.1C220,90.6,220.1,90.6,220.1,90.6z"
      />
      <path
        class="st3"
        d="M220.4,90.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4C220.4,91,220.4,90.9,220.4,90.9z"
      />
      <path
        class="st3"
        d="M248.6,82.8c-0.1,0-0.2,0-0.3,0.1c0,0,0,0.1,0.1,0.1C248.4,83,248.5,82.9,248.6,82.8
		C248.6,82.9,248.6,82.8,248.6,82.8z"
      />
      <path
        class="st3"
        d="M160.1,97.8c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C160,98,160.1,97.9,160.1,97.8z"
      />
      <path
        class="st3"
        d="M26.8,125.9l-0.1,0.1c0.1,0,0.2,0,0.3,0l0.1-0.1C27,125.9,26.9,125.9,26.8,125.9z"
      />
      <path
        class="st3"
        d="M277.9,132.6c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C277.8,132.7,277.9,132.7,277.9,132.6z"
      />
      <path
        class="st3"
        d="M144.5,100.2c0,0.1,0,0.1,0,0.2c0,0,0.1,0,0.1-0.1C144.5,100.3,144.5,100.3,144.5,100.2z"
      />
      <path
        class="st3"
        d="M27.7,125.4c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C27.6,125.2,27.7,125.3,27.7,125.4z"
      />
      <path
        class="st3"
        d="M27.5,124.9C27.5,125,27.5,125,27.5,124.9c0.1,0.1,0.1,0.1,0.1,0.1C27.6,125.1,27.6,125,27.5,124.9
		C27.5,125,27.5,125,27.5,124.9z"
      />
      <path
        class="st3"
        d="M144.3,99.1l-0.1-0.1l-0.1,0.1l0.1,0.1C144.3,99.1,144.3,99.1,144.3,99.1z"
      />
      <path
        class="st3"
        d="M11.3,188.5c0,0,0.1,0,0.1-0.1v-0.1c-0.1,0-0.1,0.1-0.2,0.1C11.2,188.4,11.3,188.5,11.3,188.5z"
      />
      <path
        class="st3"
        d="M96.6,107.9c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C96.5,107.9,96.5,107.9,96.6,107.9z"
      />
      <path
        class="st3"
        d="M96.3,107.7L96.3,107.7L96.3,107.7C96.2,107.6,96.2,107.6,96.3,107.7C96.3,107.6,96.3,107.7,96.3,107.7z"
      />
      <path
        class="st3"
        d="M172.9,90.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C172.8,90.2,172.9,90.1,172.9,90.1z"
      />
      <path
        class="st3"
        d="M69,174.6c0,0,0-0.1-0.1-0.1L69,174.6c-0.1,0-0.1,0.1,0,0.1C69,174.7,69,174.7,69,174.6z"
      />
      <path
        class="st3"
        d="M269.9,130.1C269.9,130.1,269.9,130,269.9,130.1c0-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C269.7,130.1,269.8,130.1,269.9,130.1z"
      />
      <path
        class="st3"
        d="M119.9,101.1c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C119.9,100.8,119.8,100.9,119.9,101.1
		C119.7,101,119.8,101.1,119.9,101.1z"
      />
      <path
        class="st3"
        d="M239.7,127.5c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.1,0.1c0-0.1,0.1-0.2,0.1-0.3
		C239.8,127.5,239.7,127.5,239.7,127.5z"
      />
      <path
        class="st3"
        d="M286,125c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3C285.9,124.9,286,124.9,286,125z"
      />
      <path
        class="st3"
        d="M107.1,97.4L107.1,97.4c-0.1-0.1-0.2-0.1-0.2,0C106.9,97.4,106.9,97.5,107.1,97.4
		C107,97.4,107,97.4,107.1,97.4z"
      />
      <path
        class="st3"
        d="M183.5,74.2C183.5,74.2,183.4,74.2,183.5,74.2c-0.1,0.1-0.1,0.2-0.1,0.2C183.5,74.4,183.5,74.4,183.5,74.2
		C183.6,74.3,183.5,74.2,183.5,74.2z"
      />
      <path
        class="st3"
        d="M26.2,174.6c0.1,0,0.1,0.1,0.2,0.1l0,0C26.3,174.7,26.3,174.6,26.2,174.6C26.3,174.6,26.2,174.6,26.2,174.6z"
      />
      <path
        class="st3"
        d="M154.8,75.1c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C154.7,75.3,154.8,75.2,154.8,75.1z"
      />
      <path
        class="st3"
        d="M65.2,89.5c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.1,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C65.2,89.7,65.3,89.6,65.2,89.5z"
      />
      <path
        class="st3"
        d="M14.3,177.6c0,0-0.1,0-0.2,0.1c0,0.1-0.1,0.2-0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.2
		C14.2,177.7,14.3,177.7,14.3,177.6z"
      />
      <path
        class="st3"
        d="M18.3,176.8v0.1c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C18.4,176.8,18.4,176.7,18.3,176.8L18.3,176.8z"
      />
      <path
        class="st3"
        d="M139.8,150.8c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C139.7,150.7,139.7,150.8,139.8,150.8z"
      />
      <path
        class="st3"
        d="M2.1,207.7c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0l0,0l0,0C2.1,207.9,2.1,207.8,2.1,207.7z"
      />
      <path
        class="st3"
        d="M0.5,200.2c0,0.1-0.1,0.2-0.1,0.2c0.1-0.1,0.2-0.1,0.2-0.2C0.6,200.2,0.6,200.2,0.5,200.2z"
      />
      <path
        class="st3"
        d="M0.3,200.5v0.1C0.4,200.6,0.4,200.5,0.3,200.5C0.4,200.5,0.4,200.4,0.3,200.5C0.4,200.4,0.4,200.4,0.3,200.5z"
      />
      <path
        class="st3"
        d="M76.9,180.1L76.9,180.1C76.8,180.1,76.8,180.1,76.9,180.1C76.8,180.2,76.9,180.2,76.9,180.1L76.9,180.1z"
      />
      <path
        class="st3"
        d="M76.9,179.9c0,0.1,0,0.1,0,0.2c0.1,0,0.1-0.1,0.2-0.1C77.1,180,77,179.9,76.9,179.9z"
      />
      <path
        class="st3"
        d="M70.4,179.3L70.4,179.3C70.4,179.2,70.3,179.2,70.4,179.3C70.3,179.2,70.3,179.2,70.4,179.3
		C70.3,179.3,70.3,179.3,70.4,179.3z"
      />
      <path
        class="st3"
        d="M77.7,177c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C77.8,176.9,77.8,176.9,77.7,177z"
      />
      <path
        class="st3"
        d="M8.3,187.1h0.1l0.1-0.1l-0.1-0.1C8.3,187,8.3,187,8.3,187.1z"
      />
      <polygon class="st3" points="32.6,175.6 32.5,175.5 32.4,175.5 	" />
      <path
        class="st3"
        d="M86.5,158.1c-0.1,0-0.2,0-0.2-0.1h-0.1c0,0,0,0,0.1,0.1C86.3,158.1,86.4,158.1,86.5,158.1z"
      />
      <path
        class="st3"
        d="M85.9,157.8l-0.1,0.1c0.1,0,0.2,0,0.3,0.1C86.1,158,86,157.9,85.9,157.8z"
      />
      <path
        class="st3"
        d="M75.5,157.7l0.1,0.1l0.1-0.1l-0.1-0.1C75.6,157.6,75.5,157.7,75.5,157.7z"
      />
      <polygon class="st3" points="246.2,115.5 246.2,115.4 246.1,115.4 	" />
      <path
        class="st3"
        d="M290.3,103.7c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C290.2,103.7,290.3,103.7,290.3,103.7z"
      />
      <path
        class="st3"
        d="M178.4,126c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1C178.4,126.1,178.4,126,178.4,126z"
      />
      <polygon class="st3" points="103.4,141.3 103.3,141.3 103.4,141.4 	" />
      <path
        class="st3"
        d="M182.7,122.9c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C182.6,123,182.6,122.9,182.7,122.9z"
      />
      <path
        class="st3"
        d="M74.5,142.4c0,0-0.1,0-0.1,0.1v0.1C74.4,142.5,74.4,142.5,74.5,142.4L74.5,142.4z"
      />
      <path
        class="st3"
        d="M74.6,142.3c0,0,0,0.1-0.1,0.1C74.5,142.4,74.5,142.4,74.6,142.3L74.6,142.3z"
      />
      <path
        class="st3"
        d="M94.3,135.1c0,0-0.1,0.1,0,0.1l0.1,0.1C94.4,135.2,94.4,135.2,94.3,135.1C94.4,135,94.4,135.1,94.3,135.1z"
      />
      <polygon class="st3" points="27.3,149.6 27.3,149.7 27.4,149.7 	" />
      <path
        class="st3"
        d="M242.4,102.8L242.4,102.8c-0.1,0-0.1,0-0.1,0v0.1L242.4,102.8z"
      />
      <polygon class="st3" points="127.1,124.3 127.2,124.3 127.2,124.2 	" />
      <path
        class="st3"
        d="M128.7,116.9l0.1-0.1l-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2C128.6,116.8,128.6,116.9,128.7,116.9z"
      />
      <polygon class="st3" points="132.3,114.3 132.1,114.4 132.3,114.4 	" />
      <path
        class="st3"
        d="M195.1,100.3C195.1,100.3,195,100.3,195.1,100.3c-0.1,0.1-0.1,0.2-0.1,0.3C195,100.5,195,100.4,195.1,100.3
		L195.1,100.3z"
      />
      <path
        class="st3"
        d="M195.2,100c0,0.1-0.1,0.2-0.1,0.2C195.2,100.1,195.3,100.1,195.2,100C195.3,100.1,195.2,100,195.2,100z"
      />
      <polygon class="st3" points="139.8,112.2 139.9,112.2 139.8,112.1 	" />
      <polygon class="st3" points="226.5,93 226.4,93.1 226.6,93.1 	" />
      <path
        class="st3"
        d="M115.2,116.9L115.2,116.9v-0.2V116.9C115.1,116.9,115.2,116.9,115.2,116.9z"
      />
      <polygon class="st3" points="2.6,141.3 2.6,141.2 2.5,141.3 	" />
      <path
        class="st3"
        d="M70.4,120.8L70.4,120.8L70.4,120.8v0.2C70.4,121,70.4,120.9,70.4,120.8z"
      />
      <path
        class="st3"
        d="M106.5,110.2C106.5,110.2,106.6,110.2,106.5,110.2h0.2H106.5C106.5,110.1,106.5,110.2,106.5,110.2z"
      />
      <path
        class="st3"
        d="M159.2,97.6l-0.1-0.1l-0.1,0.1l0.1,0.1C159.2,97.7,159.2,97.6,159.2,97.6z"
      />
      <polygon class="st3" points="121.2,105.4 121.2,105.6 121.3,105.5 	" />
      <polygon class="st3" points="139.2,101 139.3,101 139.2,100.9 	" />
      <path
        class="st3"
        d="M157.1,96.5l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C157,96.5,157,96.5,157.1,96.5z"
      />
      <path
        class="st3"
        d="M96,107.5L96,107.5c0.1,0.1,0.1,0.1,0.2,0.1C96.1,107.5,96.1,107.5,96,107.5z"
      />
      <path class="st3" d="M155.9,92.6l0.1-0.1v-0.1L155.9,92.6L155.9,92.6z" />
      <polygon class="st3" points="134.6,97.2 134.6,97.3 134.7,97.3 	" />
      <path
        class="st3"
        d="M218.2,247.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C218.4,247,218.3,247,218.2,247.1z"
      />
      <path
        class="st3"
        d="M239.9,231.1c0,0-0.1,0-0.1-0.1l0,0l0,0C239.8,231.1,239.9,231.1,239.9,231.1z"
      />
      <path
        class="st3"
        d="M607.6,49.8c-0.1,0.9,0.4,1.6,1.3,2.1c1.1,0.6,2.2,1.1,3.2,1.8l0,0v-6.9c-0.9,0.3-1.9,0.5-2.8,0.9
		C608.3,48.1,607.7,48.8,607.6,49.8z"
      />
      <path
        class="st3"
        d="M104.3,153.3c0.7-0.2,1.4-0.4,2-0.6c0-0.1,0-0.1-0.1-0.2c-0.3,0-0.5,0-0.8,0.1
		C105,152.7,104.6,153,104.3,153.3z"
      />
      <path
        class="st3"
        d="M97.4,159.3C97.5,159.3,97.5,159.3,97.4,159.3c1,0.3,1.9,0.6,2.8,1c0.1-0.2,0.2-0.5,0.3-0.7
		c-0.5-0.3-1.1-0.6-1.6-0.9c0.7-0.1,1.8-0.6,2.1-0.3c2.9,2.7,5.9,1.1,8.8,0.3c1.5-0.4,2.8-1.4,4.2-2c0.3-0.1,0.7,0.3,1.1,0.5l0,0
		c0.4-0.1,0.8-0.3,1.5-0.5c-0.1,0.8-0.1,1.5-0.2,2.1c1.7-1.2,3.5-2.3,5.2-3.5c-0.1-0.3-0.2-0.7-0.3-1c-5.4,0.5-10.8,0.8-16.2,1.4
		c-0.5,0-0.9,0.1-1.4,0.2c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.1,0.1,0.4,0.2,0.7c-1.2,0-2.5-1-3.5,0.5c-0.3-0.1-0.7-0.2-1-0.2
		s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2c-0.2,0.1-0.5,0.3-0.7,0.6c-0.1,0.1-0.1,0.1-0.1,0.2c-0.3,0.4-0.3,0.8-0.1,1.2
		C97.1,159.4,97.3,159.3,97.4,159.3z"
      />
      <path
        class="st3"
        d="M157.6,138.8h0.1H157.6L157.6,138.8c0.1,0.1,0.1,0.4,0.1,0.7c0.2-0.1,0.4-0.1,0.7-0.2c0.1,0.1,0.2,0.2,0.1,0.2
		c-0.4,0.6-0.8,1.2-0.8,1.9c0.3,0.1,0.8,0,1.7-0.4c1.5,2.3,3.7-0.2,5.4,0.7l0,0c0.4,0.3,1,0.5,1.2,1s0.1,1.2,0.2,1.8
		c0.7-0.9,1.4-1.8,2.1-2.7c-0.4-0.4-0.9-0.7-1.2-1.1c-0.6-0.6-1-1.3-1.6-2c0.8-0.3,1.6-0.5,2.3-0.8c0.3-0.2,0.4-0.7,0.8-1.3
		c0.5,1.1,0.7,1.6,1.2,2.7c0.5-1.4,0.8-2.2,1-2.9c-0.9-0.9-1.7-1.7-2.6-2.4c-0.4,0.2-0.8,0.8-1.1,0.7c-4.7-1.8-7.9-0.7-10.1,3.4
		C156.9,138,157.3,138.5,157.6,138.8z M163.4,137.5c-0.3,0.8-0.6,1.7-1.1,3.1c-1.1-1.4-1.9-2.3-2.9-3.5
		C161,137.2,162.1,137.4,163.4,137.5z"
      />
      <path
        class="st3"
        d="M118.8,152.2c-0.9,0.2-1.9,0.4-2.8,0.6c0,0.1,0,0.1-0.1,0.2c1.9,0.6,2.4,0.7,2.6,0c-0.1,0-0.1,0-0.2,0
		c0.1,0,0.1-0.1,0.2-0.1C118.7,152.8,118.7,152.6,118.8,152.2z"
      />
      <path
        class="st3"
        d="M169.9,126.6c-0.1,0-0.2-0.1-0.2-0.1c-1.6,0.9-1.7,0.9-1.3,3c1.4-1.8,1.9,1.7,3.2,0.5c0,0.3,0.1,1,0.1,1
		c-1,0.4-2.1,0.6-3.3,1c-0.1,0.5-0.2,1.2-0.3,1.8c4.1,0.2,4.1,0.1,4.2-3.9c0-0.2,0-0.4,0-0.5l0,0c-0.3,0.1-0.7,0.1-1.1,0.2
		c0.5-0.5,0.8-0.7,1-0.9c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5l0,0c0-0.6,0-1.2,0.1-1.9c-0.3,0.1-0.5,0.2-0.8,0.2
		c-0.2,0.1-0.4,0.1-0.6,0.2C170.8,126.4,170.4,126.5,169.9,126.6z M171.5,127.8c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1,0-0.2-0.1-0.2-0.2
		c0.2-0.1,0.4-0.2,0.6-0.3C171.3,127.5,171.4,127.7,171.5,127.8z"
      />
      <path
        class="st3"
        d="M88.1,168c1,0,1.9,0,2.9,0c-0.1-0.1-0.2-0.2-0.3-0.2c-0.5,0-1.1,0-1.6,0C88.8,167.8,88.4,167.9,88.1,168
		L88.1,168L88.1,168C88.1,167.9,88.1,167.9,88.1,168z"
      />
      <path
        class="st3"
        d="M174.5,125.7c0-0.2,0-0.4,0-0.6c-0.2,0.1-0.4,0.2-0.6,0.2c0,0.5,0,1,0,1.5c0.1-0.2,0.3-0.4,0.3-0.7
		C174.3,126,174.4,125.8,174.5,125.7z"
      />
      <path
        class="st3"
        d="M555.7,180.6c0,0,0,0.1-0.1,0.1c0,0,0.1,0,0.2,0c0-0.2,0.1-0.3,0.2-0.5C555.9,180.3,555.8,180.4,555.7,180.6z"
      />
      <path
        class="st3"
        d="M124.1,162.3c-5.3,0.4-10.4,1.1-15.5,1.1c-3.9,0-7.8-0.5-11.6-0.8v0.1c0,0.1,0.1,0.2,0.1,0.3s0.1,0.2,0.1,0.3
		s0.1,0.2,0.2,0.3c0.2,0.3,0.5,0.7,0.7,1c8.7-0.5,17.4-0.4,26.2-0.5C124.2,163.7,124.1,162.8,124.1,162.3z"
      />
      <path
        class="st3"
        d="M159.7,146.7c-0.5,0.5-1,1-1.5,1.7c-0.5,0.1-1.1,0.1-2.2,0.2c0.5-0.5,0.7-0.7,1-0.9c0.3-0.1,0.7-0.1,0.9-0.3
		s0.4-0.5,0.5-0.7c-0.8,0-1.5,0.1-2.3,0.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2-0.2-0.3-0.3-0.4-0.5c-4.3,0.2-8.6,0.3-12.9,0.5
		c-0.7,0-1.5,0.1-2.2,0.2c0.1,0.2,0.2,0.4,0.4,0.6c0.1,0.1,0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4
		c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c-0.1,0.3-0.3,0.6-0.4,0.8c-0.5-0.1-1-0.3-1.5-0.5h-0.1c-1.3-0.5-2.4-1.1-3.5-1.8
		c-0.3-0.2-0.7-0.4-1-0.7c-0.7,0.7-1.3,1.3-2,1.9c-0.8-0.2-1.5-0.4-2-0.8c-1,0.8-2,1.6-2.9,2.5c1,0.1,1.7,0.3,2.4,0.3
		c11.4,0,22.8,0,34.2,0c0.8,0,1.8,0.1,2.4-0.2c5.2-2.9,10.4-5.8,15.8-8.9C174.3,146.1,167,146.4,159.7,146.7z"
      />
      <polygon class="st3" points="291.8,136.4 291.7,136.3 291.6,136.5 	" />
      <path
        class="st3"
        d="M360.3,212.6c0.1,0.1,0.3,0.3,0.4,0.4l0,0l0,0c-0.1-0.1-0.2-0.2-0.2-0.4H360.3z"
      />
      <path
        class="st3"
        d="M312.8,135c-0.1,0-0.2,0-0.3,0c0.1,0.1,0.1,0.3,0.2,0.4C312.8,135.2,312.9,135.1,312.8,135z"
      />
      <path
        class="st3"
        d="M318.3,133c0-0.3-0.1-0.7-0.1-1c-2.5,0.8-3.2-1.8-5.7-3.1c0.2,1.5,0.4,2.5,0.6,3.7c0.8,0,1.7-0.2,2.4,0.4
		C316.5,133,317.4,133,318.3,133z"
      />
      <path
        class="st3"
        d="M118.1,149.2c-0.1-0.7-0.2-1.4-0.4-2.1c0-0.1,0-0.2-0.1-0.3v-0.1c-0.1,0.2-0.2,0.4-0.4,0.6
		c-0.2-1.2-0.4-2.1-0.6-3.2c-0.6,0.5-1.1,1-1.7,1.6c0.1,0.1,0.2,0.2,0.4,0.4c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2
		c0,0.2,0,0.5-0.1,0.7C116.5,148.4,117.3,148.8,118.1,149.2z"
      />
      <path
        class="st3"
        d="M114.8,140.7c0,0.2,0.1,0.4,0.1,0.6c0.6,0,1.2-0.1,1.8-0.1c-0.1-0.9,0-1.8,0.7-2.7c0.2,0,0.4,0.1,0.6,0
		c0.3-0.1,0.6-0.3,0.8-0.5c-0.2-0.3-0.4-0.6-0.7-0.7c-0.1-0.1-0.5,0.1-0.7,0.1c-0.4,0-0.6,0-0.8-0.1c0.3,0.3,0.5,0.6,0.8,1
		c-1.5,0.9-2.5,1.6-3.5,2.2C114.3,140.6,114.6,140.7,114.8,140.7z"
      />
      <path
        class="st3"
        d="M185.1,127.3c0,0.1-0.1,0.1-0.2,0.2c0.3,0.2,0.6,0.4,0.8,0.6c-0.2-0.3-0.3-0.7-0.5-1
		C185.2,127.2,185.2,127.2,185.1,127.3z"
      />
      <path
        class="st3"
        d="M170,120.2c-0.1-0.1-0.1-0.3-0.2-0.5c-0.5,0.4-1.1,0.7-1.5,1.1c0.1-0.1,0.2-0.1,0.4-0.2c0.1,0.3,0.3,0.7,0.4,1
		c0.4-0.5,0.8-1,1.2-1.5C170.2,120.1,170.1,120.1,170,120.2z M169.7,120.8l-0.3-0.1c0.1-0.1,0.1-0.3,0.2-0.4
		c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2C169.9,120.6,169.8,120.7,169.7,120.8z"
      />
      <path
        class="st3"
        d="M289.7,132.4v0.1c0.1,0.7,0.2,1.4,0.4,2.1c0.3,1-0.1,2.2-0.2,3.5c-0.3-0.1-0.5-0.2-0.7-0.4
		c-0.1,1.2-1.2,0.9-2.1,1c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0.5,0,0.9,0,1.4l0.1-0.1l0,0c0,0,0,0,0,0.1c1.1-0.5,2.3-0.9,3.4-1.4
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-2.4,0-4.9,0-7C290.4,131.8,290,132.1,289.7,132.4z"
      />
      <path
        class="st3"
        d="M278.9,137.6c0-0.3-0.1-0.5-0.1-0.8c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.2-0.3-0.3-0.7-0.4-1.1c-0.2,0.7-0.3,1.4-0.1,1.5C278.1,135.2,278.6,136.4,278.9,137.6z"
      />
      <path
        class="st3"
        d="M303.1,130.3c-0.2,0.8-0.3,1.6-0.3,2.4c-0.1,0-0.1,0-0.2,0.1c0.3,0.4,0.6,0.8,1,1.3c0.6,0,1.6-0.1,2.6-0.1
		v-2.1c-0.9-0.5-1.8-1-2.7-1.4C303.3,130.4,303.2,130.4,303.1,130.3z"
      />
      <path
        class="st3"
        d="M285.7,138.8c0.5,0,0.9,0,1.4,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.8,0-1.6,0-2.4c-0.4-0.3-0.8-0.5-1.3-0.7
		C286.1,136.6,285.9,137.6,285.7,138.8C285.7,138.7,285.7,138.8,285.7,138.8L285.7,138.8z"
      />
      <path
        class="st3"
        d="M308.6,132.2c0.3,0.1,0.5,0.3,0.8,0.4c0-0.1,0.1-0.3,0.3-0.7c0.3,0.1,0.6,0.1,0.9,0.2
		c-0.4-0.3-1.2-0.6-1.7-0.9C308.7,131.5,308.7,131.8,308.6,132.2z"
      />
      <path
        class="st3"
        d="M277.1,132.1c0,0.1,0,0.1-0.1,0.2c0.1-0.1,0.2-0.2,0.3-0.2C277.3,132,277.2,132,277.1,132.1z"
      />
      <path
        class="st3"
        d="M95.4,180.4L95.4,180.4l0.1-0.1C95.5,180.3,95.4,180.3,95.4,180.4z"
      />
      <path
        class="st3"
        d="M87.8,175.8c-0.1,0.1-0.3,0.2-0.4,0.3s-0.2,0.2-0.3,0.3c0.3,0.4,0.4,0.8,0.4,1.2c1.2,0.3,2.3,0.5,3.5,0.8
		l0.1,0.1l-0.1-0.1C90.1,177.3,89,176.5,87.8,175.8z"
      />
      <path
        class="st3"
        d="M321.9,121.8c0,0.1,0.1,0.2,0.1,0.3c0.1,0.4,0.2,0.7,0.4,1c0.3-0.2,0.5-0.5,0.8-0.8c-0.5-0.4-1-0.7-1.4-1
		C321.8,121.5,321.9,121.7,321.9,121.8z"
      />
      <path
        class="st3"
        d="M357,98.9c-0.2-0.1-0.4-0.1-0.6-0.2c-0.7,2.2-1.4,4.3-2.4,7.2c1.8-0.6,3.6-1.2,5.2-1.7
		c-0.1-0.1-0.2-0.3-0.2-0.5c0.1-0.1,0.1-0.2,0.2-0.2c0.3-0.3,0.7-0.5,0.9-0.8c0.7-0.8,1.7-1.4,2.1-2.4c0.2-0.3,0.2-0.7,0.2-1.1
		c0-1.3-0.6-2-1.8-2.1c-1.3,1.6-2.6,3.2-4.2,5.1C356.6,101,356.8,100,357,98.9z"
      />
      <path
        class="st3"
        d="M357.8,96.4c0.1-1.4-0.8-2.4-2-3.2c-1.2-0.9-2.7-0.5-4,0c-1.1,0.3-1.9,0.9-2.4,1.6c0.2,1.4,0.4,2.7,0.6,4
		c3.5-0.6,6.8-1.1,10.2-1.6c-0.1,0-0.2,0-0.3,0c-0.6,0-1.2,0.1-1.9,0.1C357.9,96.9,357.8,96.7,357.8,96.4z"
      />
      <path
        class="st3"
        d="M278.6,129.6c0,0.3,0,0.6,0,0.9c0.4-0.2,0.7-0.3,1-0.4C279.3,129.9,279,129.8,278.6,129.6z"
      />
      <path
        class="st3"
        d="M160.2,129.7c0.1-0.3,0.2-0.5,0.3-0.8c-0.3,0-0.7,0-1,0.1C159.7,129.3,159.9,129.5,160.2,129.7z"
      />
      <path
        class="st3"
        d="M280.1,140.5c-0.1-0.1-0.1-0.2-0.2-0.3s-0.1-0.2-0.2-0.2c-0.1-0.2-0.3-0.5-0.4-0.7c-0.2-0.4-0.3-0.7-0.4-1.1
		c0.2,1.1,0.2,2.2,0.4,3.3c0.1,0.3,0.3,0.5,0.6,0.9C280.1,141.9,280.1,141.1,280.1,140.5z"
      />
      <path
        class="st3"
        d="M288.3,131c-0.4,0.4-0.8,0.6-0.8,0.8c0,0.1,0,0.2,0,0.3c0.3,0,0.6-0.1,0.9-0.2
		C288.4,131.5,288.4,131.3,288.3,131z"
      />
      <path
        class="st3"
        d="M348.4,103.5c-0.6,1.2-1.3,2.3-2.2,4C349.3,106.9,347.8,104.7,348.4,103.5z"
      />
      <path
        class="st3"
        d="M329.9,119.8c0.4,0.2,0.7,0.4,1.1,0.6l0,0c-0.2-0.3-0.5-0.7-0.7-1C330.1,119.5,330,119.7,329.9,119.8z"
      />
      <path
        class="st3"
        d="M156.4,135.2c0.3-0.3,0.5-0.6,0.8-0.9c-0.2-0.1-0.4-0.1-0.5-0.2C156.5,134.5,156.4,134.9,156.4,135.2z"
      />
      <path
        class="st3"
        d="M354.3,99.8c-0.1,0-0.2-0.1-0.4-0.1c-0.1,0.4-0.2,0.8-0.3,1.2c0.1,0,0.3,0.1,0.4,0.1
		C354.1,100.6,354.2,100.2,354.3,99.8z"
      />
      <path
        class="st3"
        d="M328.1,123.2c0.1,0,0.2,0.1,0.2,0.1C328.3,123.3,328.2,123.3,328.1,123.2c0-0.2,0-0.5,0-0.7l0,0
		c-0.7,0-1.4,0-2.1,0l0,0C326.7,122.8,327.4,123,328.1,123.2z"
      />
      <path
        class="st3"
        d="M112.8,139c0,0.1,0,0.1,0,0.2c0.2-0.5,0.4-1.1,0.6-1.6C113,137.9,112.7,138.4,112.8,139z"
      />
      <path
        class="st3"
        d="M143.4,144.5c0.6,0.2,1.2,0.5,1.7,0.7c0.4-1.5,0.8-2.9,1.1-4.2l-0.1,0.1V141c-1.6-0.5-1.8-1.8-1.6-3.2
		C144.2,139.9,143.8,142.2,143.4,144.5C143.4,144.4,143.5,144.4,143.4,144.5C143.5,144.5,143.4,144.5,143.4,144.5z"
      />
      <path
        class="st3"
        d="M364.2,146.6c0.3,0.8,0.7,1.6,1.1,2.5c0.6-0.2,1.2-0.3,1.8-0.5c0.2-1.8,0.5-3.5,0.8-5.5c-1.2,0-2,0-2.9,0
		C364.7,144.2,366.1,145.8,364.2,146.6z"
      />
      <path
        class="st3"
        d="M313.8,137.9L313.8,137.9c0.1,0,0.2,0.1,0.2,0.1c0.1-0.9,0.3-1.7,0.4-2.6c-0.2-0.1-0.3-0.2-0.5-0.2
		C313.8,136,313.8,136.9,313.8,137.9z"
      />
      <path
        class="st3"
        d="M158.7,132.2c-0.1,0-0.1,0-0.2,0c0,0.3,0,0.6,0,0.9c0.1,0,0.1,0,0.2,0C158.7,132.8,158.7,132.5,158.7,132.2z"
      />
      <path
        class="st3"
        d="M349.7,101.1c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3
		C349.8,101.2,349.7,101.1,349.7,101.1z"
      />
      <path
        class="st3"
        d="M161.2,132.4c0.4-0.7,0.8-1.3,1.2-2c-0.3-0.1-0.5-0.2-0.8-0.3C161.5,130.9,161.3,131.6,161.2,132.4z"
      />
      <path
        class="st3"
        d="M160,144.8c0.1,0,0.1,0.1,0.2,0.1c0.6,0,1.3,0,1.9,0c0-0.1,0-0.1,0-0.2C161.4,144.7,160.7,144.7,160,144.8
		C160,144.7,160,144.7,160,144.8z"
      />
      <polygon class="st3" points="165.7,124.2 165.6,124.4 165.8,124.3 	" />
      <path
        class="st3"
        d="M324.6,124.8L324.6,124.8c0.2,0.5,0.5,0.9,0.7,1.2c0.1,0,0.1,0,0.2,0.1c-0.1,0-0.1,0-0.2-0.1
		c-0.2-0.4-0.3-0.9-0.5-1.3C324.8,124.7,324.7,124.8,324.6,124.8z"
      />
      <path
        class="st3"
        d="M142.7,144.5c0,0.4-0.1,0.8-0.1,1.1c0.3-0.4,0.6-0.7,0.8-1.1l0,0c0,0,0,0,0-0.1
		C143.2,144.4,143,144.4,142.7,144.5C142.8,144.4,142.8,144.5,142.7,144.5L142.7,144.5z"
      />
      <path
        class="st3"
        d="M329.7,115.7c-0.7,0.4-1.5,0.8-2.2,1.2c0.8,0,1.7-0.1,2.5-0.1C329.8,116.5,329.8,116.1,329.7,115.7z"
      />
      <path
        class="st3"
        d="M310.2,136.7c0-0.1-0.1-0.2-0.2-0.3c0,0.1-0.1,0.1-0.1,0.2C310,136.7,310.1,136.7,310.2,136.7z"
      />
      <path
        class="st3"
        d="M189.3,144.2c0.2,0,0.3,0,0.5,0c-0.1-0.4-0.2-0.7-0.3-1.1C189.4,143.5,189.3,143.9,189.3,144.2z"
      />
      <path
        class="st3"
        d="M198.7,142.2c0.1-0.5,0.2-1,0.3-1.5c-0.6,0.1-1.1,0.2-1.7,0.2c-0.8,1-1.6,2-2.4,3.1
		C196.9,145.2,197.3,142.7,198.7,142.2z"
      />
      <path
        class="st3"
        d="M162.5,122.4c0.9-0.5,1.6-0.9,2.3-1.2c-0.2-0.1-0.4-0.3-0.4-0.5c-0.1-0.8-0.9-1-1.5-1.4
		c0.2-0.3,0.4-0.7,0.7-1.2c-0.6,0.1-1,0.1-1.6,0.1c0.5-0.4,0.9-0.6,1.3-1c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.2-0.1
		c-0.4-0.1-0.7-0.3-0.9-0.4s-0.6-0.1-0.6-0.2c0-0.3-0.2-0.5-0.4-0.6c-0.1,0-0.3,0-0.4,0.1C161.5,118.1,162,120.2,162.5,122.4z"
      />
      <path
        class="st3"
        d="M174.5,129.3c-0.1,0-0.2,0-0.3,0c0.1-0.2,0.1-0.4,0.2-0.5h0.1c0-0.3,0-0.6,0-1c-0.1-0.1-0.2-0.1-0.3-0.2
		c-0.1,0.3-0.1,0.5-0.3,0.7c0,4.5,0,9,0,13.5c0.2,0,0.4,0,0.6,0C174.5,137.7,174.5,133.5,174.5,129.3z"
      />
      <path
        class="st3"
        d="M167.2,144.7c-0.4-0.1-0.7-0.1-1.1-0.2c0.3,0.1,0.7,0.3,1,0.4C167.2,144.9,167.2,144.8,167.2,144.7z"
      />
      <path
        class="st3"
        d="M285.9,128.8c1,0,2.1,0.1,3.2,0.4c0.2,0.1,0.5,0,0.8,0.1c-0.3-0.8-1-1.2-2.2-1.2c-0.4,0-0.7,0.1-1.1,0.1
		l0.1-0.1l0,0l0,0C286.3,128.4,286.1,128.6,285.9,128.8z"
      />
      <path
        class="st3"
        d="M148.3,137.9c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.4-0.4,0.7-0.5,1.1c0.2,0.6,0.3,1.2,0.5,1.9c0.5-0.5,1-1,1.5-1.5
		C148.4,138,148.3,138,148.3,137.9z"
      />
      <path
        class="st3"
        d="M308.1,136.5L308.1,136.5L308.1,136.5c-0.1,0.1-0.1,0.1-0.2,0.1c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2v0.1c0.8-0.2,1.3-0.5,1.4-1.1C308.6,136.3,308.4,136.4,308.1,136.5L308.1,136.5z"
      />
      <path
        class="st3"
        d="M323.2,117.4c-0.3,0.3-0.5,0.6-0.7,0.9c0,0,0,0,0,0.1l0,0C323.3,118,323.5,117.7,323.2,117.4z"
      />
      <path
        class="st3"
        d="M319.8,123.4c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0-0.1-0.1l0,0c0,0.1,0,0.1,0.1,0.2
		C319.7,123.4,319.7,123.4,319.8,123.4z"
      />
      <path
        class="st3"
        d="M147.4,145.5c0.1-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1c0,0.1,0,0.2,0,0.3
		C147.3,145.5,147.4,145.5,147.4,145.5z"
      />
      <path
        class="st3"
        d="M145.1,137.1c0,0.1,0,0.1,0,0.2c0.3,0.2,0.6,0.3,1.2,0.7c0-0.1,0-0.1-0.1-0.2
		C145.8,137.5,145.5,137.3,145.1,137.1L145.1,137.1z"
      />
      <path
        class="st3"
        d="M137.3,141.5c0,0.1-0.1,0.2-0.1,0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.4,0.7,0,1.2-0.4,1.6c0.3,0.7,0.7,1.5,1.1,2.2
		c1-0.5,1.9-1,2.9-1.6c0,0,0,0-0.1,0l0,0c-0.8-1.1-1.5-2.2-2.3-3.4c-0.5,0.2-1,0.3-1.4,0.4C137.5,141,137.4,141.2,137.3,141.5z"
      />
      <path
        class="st3"
        d="M188.8,141.6c-0.3,0.4-0.5,0.8-0.8,1.1c0.4,0.1,1,0.1,1.5,0.2l0,0c0.9-0.7,1.8-1.4,2.7-2l0,0h0.1
		c-1,0-1.9,0-2.9,0.1l0,0c-0.2-0.1-0.3-0.3-0.2-0.5c-1.1-0.1-2.2-0.3-3.3-0.4c0,0.2-0.1,0.5-0.1,0.7
		C186.8,141,187.7,141.3,188.8,141.6L188.8,141.6z"
      />
      <path
        class="st3"
        d="M165.7,122.2c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.2,0.3C165.7,122.6,165.7,122.4,165.7,122.2z"
      />
      <path class="st3" d="M154.7,120.3c0,0,0.1,0.1,0.1,0.2L154.7,120.3z" />
      <path
        class="st3"
        d="M149.5,142.4c0.1,0.1,0.2,0.1,0.2,0.2c0-0.1,0-0.2,0.1-0.3c0.3-0.1,0.6-0.1,0.8-0.2l0,0
		c-0.1-0.2-0.1-0.5-0.1-0.8s0-0.6,0.1-0.9c0-0.1,0-0.2-0.1-0.4c0,0,0,0,0,0.1c-0.1,0.7-0.5,1.4-0.7,2.2
		C149.7,142.4,149.6,142.4,149.5,142.4z"
      />
      <path
        class="st3"
        d="M290.6,138.8c0.7,1.5,1.4,3.1,2.1,4.6c-0.3,0.2-0.5,0.4-0.8,0.7c-1-0.4-2.1-0.8-3.3-1.3
		c0.9-0.5,1.4-0.8,1.9-1.1c-0.1-0.2-0.1-0.4-0.2-0.6c-1,0.2-2,0.4-3.1,0.6c0,0,0,0,0,0.1h-0.1c0,1.2,0,2.4-0.1,3.6l0,0l0,0
		c2.8-0.6,2.9-0.5,3.1,2.3c-1.2-0.9-2.2-1.6-3.1-2.3h-0.1l0,0c-1.6,0.8-3.3,0.2-3-1.2c0.4-1.8,1.1-3.5,1.7-5.2l0,0v-0.1
		c-0.5-0.5-1-0.9-1.4-1.4l0,0l0,0l0,0l0,0c0-0.1-0.1-0.2-0.1-0.3c-0.2,0.4-0.4,0.7-0.6,1.1c-0.1,0-0.3,0.1-0.5,0.2
		c0,0.1,0.1,0.1,0.1,0.2c-0.3,0.2-0.6,0.4-0.9,0.6l0,0c0,0.1,0,0.1,0,0.2c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2
		c-0.3,0.4-0.6,0.7-1,0.9l0,0c-0.3,0.3-0.6,0.6-0.9,0.9c-0.1-0.2-0.1-0.4-0.2-0.5c-0.1,0-0.1,0-0.2,0c0.1,1.8,0.2,3.6,0.3,5.4
		c-1.4-1.1-2.9-2.3-4.4-3.6c0,0.3,0.1,0.5,0.1,0.8c-0.3,0-0.5,0-0.7,0c1.5,1.2,2.8,2.7,3.3,5.1c-1-0.2-1.8-0.1-2.3-0.4
		c-1.3-1.2-2.8-2.5-3.6-4c-1.3-2.4-2.7-3-5.2-1.1c0.4-1,1-1.7,1.7-2.1l-0.1-0.1c-0.2-0.1-0.2-0.3-0.3-0.4c-0.1-0.3,0.2-0.7,0.1-1
		c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.2-0.2-0.3-0.2l0,0l0,0c-1.4,1.5-2.8,3-4.2,4.5c-0.6,0.6-1.5,1-2.6,1.6c0.6,0.7,1.2,1.4,1.9,2c-4.1-1-6.3,1.5-8.3,4.1
		l0,0c0.7,0.8,1.4,1.6,2.1,2.5c1.1,0.1,2.3,0.2,3.5,0.3c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-1.2-0.5-1.7-1.8-1.4c0-0.9-0.2-1.9-0.1-2.8
		c0.1-0.6,0.7-1.1,1.3-2c0.7,2.3,1.2,3.8,1.6,5.3c0,0.2-0.7,0.5-1.1,0.8v0.1l0,0c0.7,2.2,1.4,4.4,2.2,7.2c-2.1-1-3.5-1.7-4.3-2.1
		c-0.1-1.4,0.1-2.3-0.2-2.7c-0.7-0.7-1.7-1.1-2.5-1.6c0.3,1.7,0.7,3.4,1.1,5.2c-0.5-0.2-1.2-0.5-2.1-0.9c-0.2,0.8-0.3,1.5-0.6,2.6
		c4,0,7.6,0,11.3,0c0,0.3,0,0.7,0,1c-9.9-0.3-19.8-0.6-30.2-0.9c0.8,1.6-1.8,3.5,1.2,4.1c-1.1-1.7-0.4-3,1.5-3
		c1.5,0,2.9,0.9,4.9,1.5c-2,0.9-3.5,1.6-4.9,2.3l0,0c-0.8,0.4-1.7,0.9-2.6,1.3c0,2,0,3.9,0,6.1c12.4,1.3,24.6,2.6,37.1,3.9
		c0-1.9,0-3.4,0-5.1c-1.3,0-3.6,1.1-2.7-1.9c-0.2,0-0.5,0-0.7,0c-0.9,0.8-1.8,1.7-2.9,2.8c-0.3-1.7-0.5-2.6-0.6-3.5l0,0
		c-0.9,0.8-1.8,1.5-2.7,2.3c-0.2-0.2-0.5-0.5-0.7-0.7c0.4-0.6,0.7-1.2,1.1-1.8l0,0c0.3-0.2,0.6-0.3,0.9-0.5c0-0.6,0-1.1,0-2
		c-5.2,0-10.5,0-15.7,0c0-0.3,0-0.6,0-0.9c7.9,0,15.9,0,23.9,0c0-1.8,0-3,0-4.5c-1.4-0.1-2.7-0.2-3.9-0.3c0,0,0,0,0,0.1H271
		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.1-0.1-0.1-0.3-0.2-0.4c0.3,0,0.5,0,0.8,0c0,0,0.1,0,0.1-0.1l0,0c-0.5-0.7-1-1.4-1.4-2.1
		c0-0.1,0-0.1,0.1-0.2c0,0.1,0,0.1-0.1,0.2c-1-0.5-1.9-1-2.9-1.5c0.1-0.3,0.1-0.6,0.2-0.8c3.1,1.2,6.5-2.5,9.5,1.5
		c-1-0.3-2-0.6-3.2-0.9c-0.4,0.9-0.7,1.8-1.1,2.8c3.4,0.3,6.6,0.4,9.4,0.4c-2-2.9-3.5-5.1-5-7.4c1.6-1,2.7-0.9,3.3,1.1
		c0.5,1.7,1.2,2,3.2,1.5c3.1-0.7,6.5-0.2,9.8-0.1c4.3,0.1,4.3,0.1,4.7-4.2c1.1-0.1,2.1-0.1,3.2-0.2c0-0.3,0-0.6,0-0.9
		c-2.2-0.3-4.5-0.5-6.7-0.8c0-0.3,0-0.7,0-1c3.4-0.1,6.7-0.1,10.1-0.2c0-0.3,0-0.6,0.1-0.9c-0.7-0.5-1.4-1-2.5-1.8
		c1.1-0.4,1.8-0.9,2.4-0.8c1.2,0.1,2.5,1,3.3-0.7l-0.1,0.1v-0.1c-1.2-0.5-2.4-1-3.4-1.4c0.2-1.7,0.3-3.2,0.5-4.7c0.2,0,0.4,0,0.7,0
		c0.8,2,1.5,4.1,2.3,6.1c0,0,0,0,0.1,0c0.3-1.1,1-1.9,1.8-2.6c-0.2-0.1-0.4-0.3-0.6-0.4h-0.1c-0.8-0.2-1.4-0.4-1.9-0.8v-3.2
		c-0.4-0.4-0.8-0.9-1.1-1.2c-1,0.6-1.9,1.1-2.8,1.7c-0.2-0.9-0.3-1.9-0.6-2.7c-0.3-0.7-0.8-1.5-1.5-2c-0.9-0.6-2.1-1-3.4-1.6
		c0.5,1.2,0.9,2.2,1.4,3.4c-1-0.3-1.9-0.6-3.1-0.9c0-0.3,0-1.3,0-2.5c-0.9,1.2-1.6,2.1-2.7,3.6C292.6,135.6,293.8,137.8,290.6,138.8
		C290.6,138.7,290.6,138.8,290.6,138.8L290.6,138.8z M283.7,139.4L283.7,139.4C283.7,139.3,283.8,139.3,283.7,139.4
		C283.8,139.3,283.8,139.4,283.7,139.4z M242.8,166.3c-0.1-0.3-0.1-0.6-0.2-0.9c0.8-0.1,1.6-0.2,2.4-0.4c0,0.2,0.1,0.4,0.1,0.6
		C244.4,165.8,243.6,166,242.8,166.3z M264.1,167.1c0.2,0.2,0.5,0.4,0.7,0.5c-0.6,0.8-1.2,1.7-1.9,2.5c-0.2-0.2-0.5-0.4-0.7-0.6
		C262.9,168.8,263.5,168,264.1,167.1z M260.9,167.6c0.2,0.2,0.4,0.3,0.6,0.5c-0.3,0.4-0.6,0.7-0.9,1.1c-0.1-0.1-0.3-0.2-0.4-0.3
		C260.4,168.5,260.7,168,260.9,167.6z M266,155c-0.2-0.6-0.4-1.3-0.7-2.2c4,0.1,4,0.1,4.4,2.7C268.5,155.3,267.3,155.1,266,155z
M274.4,155c-1.2-0.9-2-1.5-2.9-2.1c0.8-0.9,1.5-1.6,2.9-3.1C274.4,151.9,274.4,153.3,274.4,155z M274,149
		c-0.8-1.2-1.6-2.4-2.3-3.5c-1,0.3-2,0.7-3,1c0,0,0,0,0,0.1l0,0c1.2,1.2,2.5,2.3,3.8,3.6c-0.3,0.1-1,0.3-1.7,0.5l0,0
		c-1.7,1.7-3.8,0.8-6.7-3c1.6-0.4,3.1-0.8,4.6-1.2c0,0,0,0-0.1,0l0,0c-0.4-0.6-0.8-1.2-1.3-1.9c1.9-0.4,3.4-0.7,5.1-1.1
		c0.9,1.7,1.8,3.3,2.6,4.8C274.8,148.6,274.4,148.8,274,149z M276.5,149.8c-0.1-0.2-0.2-0.5-0.2-0.6c0.4-0.3,0.8-0.5,1.2-0.7
		c0.1,0.2,0.2,0.5,0.4,0.7C277.4,149.5,276.9,149.7,276.5,149.8z M281,151.8c0.7-1.2-0.2-3.9,2.4-3.4c3.8,0.6,1.4,3.8,2.3,5.9
		C284,153.3,282.6,152.6,281,151.8z M292,154.5c-1.6-0.7-3.3-1.4-5.2-2.2c1-0.8,1.4-1.2,1.8-1.5c0,0,0,0,0-0.1
		c-0.8-0.4-1.5-0.7-2.6-1.2c3.2-2.3,3.8-2.1,5.3,1.2c-0.9-0.4-1.6-0.7-2.3-1.1c-0.2,0.4-0.3,0.7-0.5,1.1l0,0l-0.1,0.1
		c1.4,0.9,2.7,1.8,4.1,2.8C292.3,153.9,292.1,154.2,292,154.5z M298,146c0-0.4,0.1-0.8,0.1-1.2c0.6,0.1,1.2,0.1,1.8,0.3
		c0.1,0,0.1,0.6,0.1,0.9C299.4,145.9,298.7,146,298,146z M299.8,135.9L299.8,135.9c0,0.1-0.1,0.2-0.1,0.3l0,0l0,0
		c-0.1,0.1-0.1,0.2,0,0C299.7,136.1,299.8,136,299.8,135.9c-0.4-0.4-0.8-0.8-1.6-1.4C300.2,134.7,300.2,134.7,299.8,135.9z
M296,134.8c0.7,2.3,1.2,3.8,1.7,5.4c0.2-0.2,0.4-0.3,0.6-0.5c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0,0,0.1,0c0.6-0.4,1.1-0.8,1.7-1.3
		c0.4,0.8,0.8,1.6,1.3,2.4c-0.2,0.1-0.4,0.3-0.6,0.4c-0.8-0.5-1.6-1-2.4-1.5l0,0c-0.1,0.1-0.2,0.1-0.2,0.2c-0.1,0.2-0.3,0.4-0.4,0.6
		c-1.9,1.9-2.1-1.2-3.2-0.9C295.1,137.8,295.5,136.4,296,134.8z M294.2,139.9c1.1,1,2.3,2,3.4,3l0,0h0.1c2.2-1.8,3.1-1.7,4.8,1
		c-2-0.4-3.4-0.7-4.8-1c0,0,0,0-0.1,0c0,0,0,0-0.1-0.1c-0.8,0.5-1.6,1.1-2.4,1.6c0.8,0.6,2.8,0.6,1.3,2.6c-1.1-0.5-2.1-1.1-3.6-1.8
		c0.9-0.5,1.4-0.8,1.8-1C292.1,143.3,294.7,141.4,294.2,139.9z M296.4,152.8c-0.2,0.2-0.3,0.5-0.5,0.7c-2.3,0-2.3,0-3.1-2.6
		C294.3,151.8,295.4,152.3,296.4,152.8z"
      />
      <path
        class="st3"
        d="M332.6,113.8c0.5-0.4,0.9-0.8,1.4-1.3c0-0.1,0-0.1,0-0.2s0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1
		c-0.3,0.5-0.7,0.9-0.9,1.4C332.7,113.5,332.7,113.6,332.6,113.8z"
      />
      <path
        class="st3"
        d="M300.6,130.2c0.2,0.2,0.3,0.4,0.5,0.6c0-0.1,0.1-0.2,0.1-0.2c0-0.1-0.1-0.4-0.2-0.4
		C300.9,130.2,300.8,130.2,300.6,130.2z"
      />
      <path
        class="st3"
        d="M141.3,143.8c0.5,0.2,0.9,0.5,1.4,0.7l0,0c0,0,0,0,0.1,0c0-0.7,0-1.3,0-2C142.2,142.9,141.7,143.3,141.3,143.8
		C141.3,143.7,141.3,143.7,141.3,143.8L141.3,143.8z"
      />
      <path
        class="st3"
        d="M200.5,136.9c-0.1-0.3-0.2-0.7-0.2-1c-0.8,0.3-1.5,0.6-2.3,0.9C198.8,136.7,199.7,136.8,200.5,136.9z"
      />
      <path
        class="st3"
        d="M321,127.6c-0.1,0.3-0.3,0.6-0.4,0.8c0.6,0.1,1.2,0.2,1.8,0.3C321.9,128.4,321.4,128,321,127.6z"
      />
      <path
        class="st3"
        d="M323.8,121.2c0.4,0.2,0.7,0.5,1.1,0.7c0.4-0.7,0.7-1.4,1.1-2.1l0,0c-0.1-0.1-0.2-0.1-0.2-0.2s0.1-0.2,0.1-0.4
		v-0.1c-0.8,0-1.6,0-2.3,0.1C323.7,119.7,323.7,120.5,323.8,121.2z"
      />
      <path
        class="st3"
        d="M150,138.9C149.9,138.9,149.9,138.9,150,138.9c0,0.1,0.1,0.3,0.2,0.4c0-0.1,0.1-0.2,0.3-0.4
		c0.1-0.1-0.3-0.6-0.6-1.2C149.9,138.2,149.9,138.5,150,138.9z"
      />
      <path
        class="st3"
        d="M182.4,130.3c0.1-0.6,0.3-1.2,0.4-1.7c-0.3,0-0.6-0.1-1-0.1c0.3-0.2,0.8-0.1,1.1-0.2c0.1-0.4,0.2-0.8,0.2-1.1
		c-0.8-0.2-1.4-0.4-2-0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2-0.2-0.5-0.4-0.9-0.7c-0.1,0-0.2,0-0.3-0.1c-0.2,0.5-0.3,0.9-0.3,1.3
		C180.3,128.3,181.2,129.2,182.4,130.3z"
      />
      <path
        class="st3"
        d="M325.6,115.3c0.4-0.2,0.9-0.3,1.3-0.5c-0.2,0-0.5-0.1-0.8-0.2C325.9,115,325.7,115.1,325.6,115.3z"
      />
      <path
        class="st3"
        d="M331.2,114.3c0.1,0.1,0.3,0.2,0.4,0.4c0.2-0.2,0.4-0.3,0.6-0.5c-0.2,0.1-0.4,0.2-0.7,0.2
		C331.4,114.3,331.3,114.3,331.2,114.3z"
      />
      <path
        class="st3"
        d="M166.1,129.7c0.5,1.7,1.2,1.3,2,0.1C167.4,129.7,166.7,129.6,166.1,129.7C166.1,129.6,166.1,129.6,166.1,129.7
		C166.1,129.6,166.1,129.7,166.1,129.7z"
      />
      <path
        class="st3"
        d="M198.7,142.3c-0.2,0.8-0.6,1.5-0.7,2.3c0,0.3,0.4,0.7,0.6,1.1C198.6,144.6,198.6,143.5,198.7,142.3z"
      />
      <path
        class="st3"
        d="M314.5,122.7c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9c-0.3,0-0.7-0.1-1-0.1
		c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-0.4,0.1-0.8,0.3-1.2,0.4c-0.2,0.1-0.4,0.1-0.7,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0.2-0.2,0.4-0.3,0.6v0.3v0.2c-0.6,0-1.1,0-1.6-0.4
		c-0.1-0.1-0.3-0.2-0.5-0.1c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.3,0.3-0.6,0.7-0.8,1
		c2.2-0.3,4.4-0.6,6.6-0.7c2-0.2,4.2-0.1,5.8,1.6c-0.1-2.3-0.2-4.5-0.3-6.8c-0.3,0.1-0.6,0.1-1,0.3
		C315.3,122.4,315,122.5,314.5,122.7z M305.8,126.7c-0.1,0.1-0.3,0.1-0.4,0.2c0-0.1,0.1-0.3,0.1-0.4c0.1-0.1,0.3,0,0.4,0
		C305.9,126.5,305.8,126.7,305.8,126.7z M313.6,122.5L313.6,122.5l0.1-0.1L313.6,122.5z"
      />
      <path class="st3" d="M197.2,139.5L197.2,139.5l0.1-0.1L197.2,139.5z" />
      <path
        class="st3"
        d="M318.9,129.6c-0.2-0.6-0.5-1.2-0.7-1.9c-0.5,0.5-0.9,0.9-1.3,1.3c-0.1,0.3-0.2,0.6-0.3,1
		C317.4,129.8,318.1,129.7,318.9,129.6z"
      />
      <path
        class="st3"
        d="M168.1,124c0.2-0.7,0.4-1.3,0.6-2c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2-0.4-0.4-0.7-0.5-1.1
		c-0.2,0.3-0.4,0.6-0.4,1.1c-0.5,0-0.9-0.3-1.3-0.5c0.3,0.9,0.6,1.7,0.9,2.5C167.7,123.9,167.9,124,168.1,124z"
      />
      <path
        class="st3"
        d="M200.3,146.9c-0.3-0.1-0.5-0.2-0.8-0.3c0.1,0.3,0.3,0.5,0.4,0.8C200,147.3,200.1,147.1,200.3,146.9z"
      />
      <path
        class="st3"
        d="M195.9,140.9c0.4,0,0.9,0,1.3,0c0-0.5,0-0.9-0.1-1.4C196.7,140,196.3,140.4,195.9,140.9z"
      />
      <path
        class="st3"
        d="M307.5,130.3c-0.4-0.3-0.9-0.6-1.3-0.8c-0.1,0.2-0.3,0.5-0.3,0.5c0.4,0.3,0.9,0.6,1.3,0.9
		C307.3,130.7,307.4,130.5,307.5,130.3z"
      />
      <path
        class="st3"
        d="M459.7,42.5h0.1c-0.1,0-0.1-0.1-0.2-0.1C459.7,42.5,459.7,42.5,459.7,42.5z"
      />
      <path
        class="st3"
        d="M537.8,121.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.2,0-0.3
		C538,121.5,537.9,121.6,537.8,121.6z"
      />
      <path
        class="st3"
        d="M256.7,138.9c-0.3,0.3-0.7,0.5-0.6,1c0.5-0.1,0.9-0.3,1.3-0.4C257.1,139.3,256.8,139.1,256.7,138.9z"
      />
      <path
        class="st3"
        d="M528.1,203.4c0.1,0.3,0.3,0.6,0.7,0.6c0.9,0,0.9-0.6,1.2-1c-0.7-0.3-1.5-0.4-2.3-0.4
		C527.9,202.9,528,203.2,528.1,203.4z"
      />
      <path
        class="st3"
        d="M386.7,127.4c-0.4-0.2-0.8-0.4-1.2-0.6c0,0.2,0,0.4,0,0.7c0.3,0.2,0.7,0.5,1,0.7
		C386.5,127.9,386.8,127.4,386.7,127.4z"
      />
      <path
        class="st3"
        d="M434.3,86.5c0.1-0.8,0.2-1.6,0.2-2.4c-0.1,0-0.1,0.1-0.2,0.1h-0.1C434.2,85,434.2,85.7,434.3,86.5
		c-0.3,0.5-0.5,1.1-0.7,1.6c0.2,0,0.3,0.1,0.5,0.1C434.2,87.6,434.2,87.1,434.3,86.5z"
      />
      <path
        class="st3"
        d="M476.1,59.3c-0.1-0.1-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3,0-0.6c0.1-0.3,0.2-0.7,0.2-1.1c0-0.1,0.1-0.3,0.1-0.4
		c-2.3,0.8-4.7,1.6-7.1,2.4c0.3,3.5,0.5,6.9,0.8,11c9.1-1.9,17.9-3.8,26.7-5.7c0-0.7,0-1.4,0-2c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.2-0.2-0.5-0.4-0.7c0,0,0.2-0.1,0.4-0.3l0,0
		c0.4-0.4,0.5-0.7,0-1s-1-0.1-1.3,0.5c-0.7,1.2-1.7,1.6-3.4,1.1c0.5-0.3,1.4,0.1,1.5-0.7c0-0.3,0-0.5,0-0.8c-0.1-0.3-0.2-0.7-0.3-1
		c-0.2-0.4-0.8-0.5-1.2-0.1c0,0,0,0-0.1,0.1c-0.3,0.3-0.6,0.6-0.8,0.9c-0.3-0.2-0.6-0.4-1.1-0.8c-0.3,0.8-0.5,1.4-0.2,2
		c0.4,0.7,0.7,1.4-0.6,1.9c-0.1,0.9-0.7,1.4-1.4,1.9c-0.6,0.4-1.2,0.7-1.6,1.2c-0.2-0.1-0.5-0.2-0.8-0.3c0.3-0.3,0.5-0.6,0.8-0.8
		c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2-0.1-0.3-0.1c0.1-0.8,0.2-1.6,0.3-2.4c-0.5,0-0.9,0-1.2,0c0.1-0.2,0.1-0.4,0.2-0.5
		c0.3-0.2,0.7-0.3,1-0.5c-0.4-0.2-0.7-0.4-1.3-0.7c-0.2,1-0.8,1.4-1.8,1.6c-0.3,0.1-0.7,0.1-1.1,0.2c0.5-0.5,0.8-0.7,1-0.9
		c-0.3-0.1-0.6-0.2-1.2-0.3c0.7-0.2,1-0.3,1.3-0.5c0.1-0.1,0.3-0.1,0.4-0.2c0.7-0.3,1.3-0.7,1.4-1.5c0.1-0.4,0.4-0.7,0.8-1.2
		c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.1,0.1-0.2,0.1c-1,0.4-1.7,0.7-2.4,1c-0.3,0.1-0.5,0.2-0.8,0.2c-0.2,0.1-0.4,0.1-0.6,0.2
		C476.9,59.1,476.5,59.2,476.1,59.3z"
      />
      <path
        class="st3"
        d="M421.2,65.6c0,1.1-0.1,2.1-0.1,3.2c0.4-0.1,0.9-0.3,1.3-0.4c-0.1-1-0.2-2.1-0.3-3.2
		C421.8,65.3,421.5,65.5,421.2,65.6z"
      />
      <path
        class="st3"
        d="M475.9,52.4c-0.7,0.5-1.5,0.9-1.8,1.7c0.9-0.3,1.8-0.5,2.7-0.8c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1,0-0.2,0-0.4,0
		C476.1,52.7,476,52.6,475.9,52.4z M475.8,53.5l-0.3-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.1,0.2-0.1,0.3-0.1c0,0.1,0.1,0.2,0.1,0.2
		C476.1,53.3,476,53.4,475.8,53.5z"
      />
      <path
        class="st3"
        d="M416.8,93.1c1.6-0.9,3.1-1.6,4.4-2.6c1.4-1,2.6-2.3,3.9-3.4c0,0,0,0,0,0.1c0.1,0.3,0.2,0.6,0.4,1
		c0.1-0.4,0.2-0.7,0.2-1c0,0,0,0,0-0.1c0.6-0.3,1.1-0.5,2-0.9c-0.4,0-0.7,0-1.1,0c-0.7-0.1-1.3-0.2-2.1-0.4c0.4-0.2,0.7-0.2,0.9-0.4
		c0.6-0.3,0.7-0.8,0.3-1.2c-0.3-0.3-0.6-0.6-0.9-0.8c-0.6-0.3-1.2-0.2-1.9,0.9c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.4-0.4,0.8-0.6,1.2
		l0,0c-0.6,0.8-1.3,1.7-1.9,2.5c-0.3-0.2-0.6-0.4-0.9-0.6c0.1-0.2,0.1-0.5,0.2-0.7l0,0c-0.7-0.2-1.5-0.3-2.3-0.3
		C416.3,88.2,416.1,90.3,416.8,93.1z"
      />
      <path
        class="st3"
        d="M464.6,47C464.7,47,464.7,47,464.6,47c0.2-0.1,0.2-0.2,0.3-0.3c-0.1-0.2-0.2-0.6-0.3-0.9
		c-0.1-0.7-0.3-1.2-1.5-1.1c-0.3,0.1-0.7-0.2-1.1-0.4c0.3,0.6,0.6,1.3,1.1,1.7l0,0C463.7,46.3,464.3,46.5,464.6,47z"
      />
      <path
        class="st3"
        d="M421,73.4c0.2,1,0.4,1.8,0.6,2.7c0,0.3-0.1,0.7-0.3,1c-0.3,0.6-0.5,0.8-0.3,1c0.1,0.2,0.3,0.3,0.6,0.6
		c0.3,0.3,0.4,0.7,0.4,1.2c0,0.1,0,0.1,0,0.2c0,0.8-0.1,1.7-0.2,2.6c0.9-0.2,1.7-0.4,2.6-0.5c-0.1-0.8-0.3-1.6-0.4-2.3
		c0-0.1,0-0.2-0.1-0.3c-0.1-0.2-0.1-0.5-0.1-0.7c0.1-0.4,0.1-0.7,0.1-1.1c0-0.9-0.3-1.8-0.6-2.7c-0.5-1.2-0.6-2.4,0.4-3.7
		c-0.1,0-0.3,0.1-0.4,0.1c-1.3,0.4-2.7,0.7-4,1C419.5,73,420.2,73.3,421,73.4z"
      />
      <path
        class="st3"
        d="M432.6,85.5c0-0.2,0-0.4,0-0.6c-0.6,0.2-1.5,0.5-1.8,0.6h-0.1c0.1,0.1,0.2,0.1,0.4,0.2c-0.1,0.7-0.2,1.4-0.3,2
		C431.5,87,432.5,86.3,432.6,85.5z"
      />
      <path
        class="st3"
        d="M465.9,47.9c-0.1,0.1-0.2,0.2-0.3,0.3c1.1,1.2,2.4,1.6,3.8,1.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.2-0.1
		c-0.4-0.1-0.7-0.3-0.9-0.4c-0.2-0.1-0.6-0.1-0.6-0.2c-0.1-0.8-0.8-0.9-1.5-1.1C466.2,48,466.1,47.9,465.9,47.9z"
      />
      <path
        class="st3"
        d="M520.8,188L520.8,188c-0.4-0.1-0.9-0.1-1.3-0.1v0.1C520,188,520.4,188,520.8,188z"
      />
      <path
        class="st3"
        d="M531.5,203.8c-0.2-0.1-0.4-0.2-0.5-0.3c0.2,0.2,0.4,0.4,0.5,0.6C531.5,203.9,531.5,203.9,531.5,203.8z"
      />
      <path
        class="st3"
        d="M456.1,81.6c-0.1,0.3-0.3,0.6-0.4,1c0.1,0,0.2,0,0.3,0.1C456,82.3,456,81.9,456.1,81.6z"
      />
      <path
        class="st3"
        d="M443.3,74.8c0,0.2,0,0.5,0,0.6c0.3,0.6,0.6,1.2,0.9,1.8c2.7-0.5,5.2-1,7.7-1.5c1.6-0.5,3.2-1,4.9-1.4
		c0-0.1,0-0.1,0-0.2c0-0.3,0-0.6,0.1-0.9c0.1-0.5-1-0.9-0.2-1.5c0.1-0.1-0.3-0.7-0.6-1.2H456c-0.4-0.1-1,0.8-1.5,0.2
		c-0.4-0.4-0.8-0.8-1.3-1.4c-0.2,0.5-0.4,0.9-0.7,1.3c-0.4-0.3-0.8-0.5-1.2-0.7c-0.3-0.2-0.7-0.3-1.3-0.6c0.1,0.6,0.2,0.9,0.3,1.2
		c0,0,0,0,0,0.1c-1.1,0.5-2.1,0.9-3.2,1.4c-0.1,0-0.4-0.2-0.7-0.2c-0.4,0-0.9,0-1.2,0.1c-0.6,0.2-1.4,1.4-1.8,2.4
		C443.4,74.4,443.3,74.6,443.3,74.8z"
      />
      <path
        class="st3"
        d="M465.7,79.7c0.4,1.5,0.6,2.5,0.9,3.7c0.8-0.3,1.5-0.6,2.7-1c-1.3-1-2.2-1.8-3.5-2.8
		C465.8,79.6,465.7,79.6,465.7,79.7z"
      />
      <path
        class="st3"
        d="M427.3,89.2c1.1-1.2,2.1-2.4,3.2-3.6c-0.9,0.3-1.8,0.5-2.7,0.6C427.7,87.3,427.5,88.3,427.3,89.2z"
      />
      <path
        class="st3"
        d="M409.3,92.3c0-0.9,0-1.8,0-2.7c-0.1,0-0.2,0-0.4-0.1c0,0.9,0,1.8,0,2.7C409.1,92.3,409.2,92.3,409.3,92.3z"
      />
      <path
        class="st3"
        d="M456.7,40.1C456.7,40.1,456.7,40.2,456.7,40.1C456.8,40.2,456.8,40.2,456.7,40.1
		C456.8,40.1,456.8,40.1,456.7,40.1z"
      />
      <path
        class="st3"
        d="M455.7,41.2c-0.1,0-0.1,0-0.2-0.1c-0.6-1.3-1.2-2.6-1.8-3.9c-0.1,0-0.2,0-0.2,0.1c-0.2-0.2-0.4-0.5-0.6-0.7
		c-0.1,0-0.2,0-0.4,0c1,1.5,2,3,3,4.5C455.6,41.2,455.6,41.2,455.7,41.2z"
      />
      <path
        class="st3"
        d="M423.9,71.3c0.1,0,0.3,0.1,0.5,0c0.3-0.1,0.6-0.3,0.8-0.5l0,0C424.7,71,424.3,71.1,423.9,71.3z"
      />
      <path
        class="st3"
        d="M461.7,48c-0.7-1.8-1.4-3.6-2-5.4c-0.2-0.1-0.5-0.2-0.7-0.3c-0.1,0-0.2,0.1-0.4,0.1h-0.1
		c0.9,1.9,1.8,3.9,2.6,5.8C461.3,48.2,461.5,48.1,461.7,48z"
      />
      <path
        class="st3"
        d="M238.1,158.1c-4.6,1.6-4.6,1.6-7.2-2.3c0.9,0.4,2,0.5,2.7,1.1c1.1,1.1,2.1,1.3,3.3,0.3c0,0,0,0,0-0.1
		c-0.6-0.2-1.3-0.3-2.2-0.6c1.7-1.5,2.1-0.8,2.2,0.6h0.1l-0.1,0.1c1.1-0.4,2.3-0.7,3.4-1.1c-0.1-0.2-0.1-0.5-0.2-0.7
		c-1.5-0.1-3.1-0.3-5.1-0.4c1.7-3.7,5.3-0.2,7.6-2.5c1.5-1.5,5.1,1.2,7.5-0.5c0-0.3,0-0.6,0-0.8c-2.6,0-5.3,0-7.9,0
		c-0.1-0.3-0.1-0.6-0.2-0.9c2-0.6,4-1.2,6.3-2c-1.3-0.2-2.3-0.4-3.8-0.6c1-0.8,1.5-1.3,1.9-1.6c-0.1-1.6-0.2-3.2-0.3-5.3
		c2.3,1.9,3.8,3.2,5.6,4.6c-0.2-1.1-0.4-2.2-0.6-3.3c-0.9-0.4-2.1-0.2-3.1-0.3c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3
		c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5c-0.1,0-0.2-0.1-0.3-0.2c-0.6,0.1-1.1,0.1-1.5,0.2c-1.4,1.3-2.5,2.3-3.5,3.3
		c-0.4-0.2-0.8-0.4-1.2-0.5c2.4-1.3,2.3-2.5,0.6-3.7l0,0c-0.7,1-1.4,2-2.2,3c-0.9,1-3.4-0.2-3.5,2.5c0,0,0,0,0.1,0c0,0,0,0,0,0.1
		c1.4-0.1,2.8-0.1,2.2,2c0.3,0.4,0.5,0.9,0.8,1.3c0.6-0.2,1.1-0.4,1.7-0.6c0.1,0.3,0.1,0.6,0.2,0.9c-0.8,0-1.5,0-2.3,0
		c-0.3-0.5-0.5-0.9-0.8-1.4c-0.4,0.5-0.7,1-1.1,1.5c-0.2,0-0.5-0.1-0.7-0.1c0-1.2,0-2.4,0-3.6h-0.1c0,0,0,0,0-0.1
		c-0.8-0.2-1.4-0.1-1.9,0.2l0,0l0.1,0.1c0.2,0.1,0.2,0.6,0.1,0.8c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6c-0.6,0-0.6-0.4-0.6-0.7
		c-0.1,0.2-0.2,0.4-0.3,0.7c0.5,0.4,1,0.9,1.6,1.4c-0.1,0.2-0.1,0.4-0.2,0.6c-0.8-0.3-1.6-0.6-2.4-0.9c-0.1,0.4-0.1,0.7-0.2,1.1
		c-0.2-0.4-0.3-0.7-0.5-1.1c-0.7,0.2-1.4,0.5-2.1,0.7l0,0c-0.2,0.2-0.5,0.5-0.7,0.7l0,0c-1.2,1.3-2.3,2.6-3.5,3.7
		c-1,0.9-3,1.1-2.4,3.3c0.1,0.2-1.6,0.9-2.9,1.5c0.7,0.9,1.5,1.8,2.4,2.8c-4.3,0-8.8,0-13.6,0c0.2,1.3,0.3,2.2,0.3,2.7
		c2.6,0.7,4.9,1.4,7.2,2c0,0.2,0,0.5,0,0.7c-0.9,0.4-1.8,0.8-3.1,1.3c-0.1-1.1-0.1-1.8-0.1-2.4c-0.3-0.2-0.5-0.4-0.8-0.6
		c-0.4,1.1-0.9,2.2-1.3,3.3c-0.3-0.2-0.6-0.4-0.9-0.6c-0.3-0.5-0.5-0.9-0.8-1.4c-0.2,0-0.3,0-0.5,0c-0.1,1.9-0.2,3.7-0.4,5.8
		c5.7,0.4,11.1,0.8,16.4,1c1,0,2-0.7,3.1-1.2c0.2,0.3,0.6,0.9,1.1,1.6c1-2.5,5.3-3.1,2.6-7.2c-3.5,0-7.4,0-11.3,0c0-0.3,0-0.7,0-1
		c3.8-0.3,7.6-0.6,11.8-1c0-0.3,0.1-1.2,0.2-2.2c-2.1-0.2-4-0.4-5.9-0.6c0-0.3,0-0.6,0-0.9c5.1,0,10.2,0,15.5,0
		C240.8,157.7,239.6,157.6,238.1,158.1z M243.2,148.5c-0.2,0.1-0.5-0.2-0.9-0.4c0.4-0.3,0.6-0.7,0.8-0.7s0.4,0.3,0.7,0.4
		C243.6,148.1,243.5,148.4,243.2,148.5z M243.9,143.5c-0.1,1.3-0.1,2.1-0.2,3.5c-0.9-0.9-1.4-1.5-1.9-2
		C242.4,144.6,243,144.2,243.9,143.5z M236.5,150.3c1,0,2,0,3,0c0,0.3,0,0.5,0,0.8c-1,0-2,0-3,0
		C236.5,150.8,236.5,150.6,236.5,150.3z M234.2,150.8c0.1-0.1,0.4,0.1,0.5,0.2c-0.1,0.2-0.1,0.5-0.2,0.5c-0.2,0-0.4-0.1-0.6-0.2
		C234,151.1,234,150.8,234.2,150.8z M223.1,159.4c-0.1-0.3-0.2-0.5-0.3-0.8c0.8-0.3,1.5-0.6,2.3-0.9c0.2,0.3,0.3,0.6,0.5,0.9
		C224.8,158.8,224,159.1,223.1,159.4z M226.8,156.6c-0.5,0.1-0.9,0.1-1.4,0.2c0-0.3,0-0.6,0-0.9c0.5,0,1,0.1,1.4,0.2V156.6z
M226.7,154.6c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.1,0.3-0.4,0.4-0.4c0.3,0.1,0.5,0.3,0.7,0.4C227.2,154,227,154.2,226.7,154.6z
M229.1,158.5c-0.4,0-0.7,0.1-1.1,0.1c0-0.3,0-0.5,0-0.8c0.4,0.1,0.7,0.1,1.1,0.2C229.1,158.2,229.1,158.4,229.1,158.5z
M233.2,152.9c0.1,0.3,0.3,0.9,0.3,0.9c-0.7,0.3-1.3,0.5-2,0.7c-0.1-0.3-0.3-0.6-0.4-1C231.7,153.4,232.4,153.1,233.2,152.9z
M229.2,150.9c0.5,0,1.1,0,1.6,0c0,0.2,0,0.3,0,0.5c-0.5,0-1.1,0-1.6,0C229.2,151.2,229.2,151.1,229.2,150.9z"
      />
      <path
        class="st3"
        d="M523.7,198.6c0.5-0.4,0.9-0.6,1.7-0.8c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5
		c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6s1.3-0.2,0.8,0.7c-0.1,0.1,0.1,0.2,0.2,0.2c0.9-0.1,1.9-0.1,2.8-0.1
		c1.7,0.1,3.3,0.1,5,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4c0.1,0.1,0.2,0.2,0.2,0.3
		c1.3-0.2,2.1-0.8,2.6-1.9c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1c-0.2,0.4-0.3,0.7-0.2,0.9
		c1.8,0.1,3.5,0.2,5.3,0.3c-0.1-0.2-0.2-0.4-0.2-0.5c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8c-0.3,0-0.6-0.1-1.1-0.1
		c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1c0.7,0.1,1.4-0.3,1.3-0.8
		c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7c0.9-1-0.2-0.8-0.3-1.2
		c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.2,0.1-0.5,0.2-0.7c-0.4,0-0.8,0-1.1,0
		c0-0.1,0-0.3,0-0.4c0.5,0,1,0,1.6,0c0.8-0.5,1.1-0.4,3.1,0.3c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4
		c-0.9,0-1.8,0.3-2.6-0.1c-0.3-0.2-1.2,0.3-1.9,0.6s-1.3,0.5-1.8,0l0,0l0,0c0.3-0.3,0.5-0.4,0.6-0.6c0,0,0,0-0.1-0.1l0.2-0.1
		l-0.1,0.1c-2.1,0.5-4.2,0.9-6.3,1.4v0.1c-0.1,0-0.2,0-0.3,0c-0.5,0.1-0.9,0.1-1.4,0.2c-4.8-0.3-9.7-0.6-14-0.8
		c-0.5,0.1-0.8,0.4-1.2,0.6c0,0.1,0,0.2-0.1,0.3c-0.1,0-0.2,0-0.3,0c-0.2,0.1-0.4,0.1-0.7,0.1s-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1
		c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3
		c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5
		c0.2,0.1,0.3,0.3,0.4,0.5C522.4,199.2,522.8,199.3,523.7,198.6z M527.5,200c0.1,0.1,0.2,0.1,0.2,0.2c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.1-0.1-0.1-0.1-0.2-0.2C527.2,200.4,527.4,200.2,527.5,200z M517.6,194.8c0.3-0.3,0.5-0.6,0.7-0.9
		C518.6,194.7,518.6,194.7,517.6,194.8z"
      />
      <path
        class="st3"
        d="M536.3,73c-0.2,0-0.4,0.1-0.6,0.2c0.2,0.3,0.4,0.5,0.5,0.7c0.3,0.4,0.6,0.8,0.9,1.2c0.1-0.1,0.2-0.1,0.3-0.2
		c0.2,0.4,0.4,0.8,0.5,1.1c0.6-0.3,0.7-0.9,1.1-1.3c0.1-0.2,0.3-0.3,0.7-0.2c0.5,0.5,0.6,1,0.7,1.6v0.1c0,0.2,0.1,0.3,0.2,0.5
		c1.3-0.5,2.6-1.1,3.9-1.6C542.4,72.4,539,72.6,536.3,73z"
      />
      <path
        class="st3"
        d="M553.9,92.1C553.9,92.2,553.8,92.2,553.9,92.1c0,0.5,0,0.9,0,1.4c0,0,0,0,0.1,0l-0.1,0.1l0.3-0.1h0.3l0,0
		c0-0.5,0.1-0.9,0.1-1.4c0,0,0,0-0.1,0c0,0,0,0,0-0.1C554.3,92.1,554.1,92.1,553.9,92.1L553.9,92.1z"
      />
      <path
        class="st3"
        d="M509.3,117.6c-0.1-0.1-0.1-0.1-0.1-0.1L509.3,117.6z"
      />
      <path
        class="st3"
        d="M546,131.7c0.1,0.1,0.1,0.1,0.1,0.1l0,0C546.2,131.8,546.1,131.8,546,131.7z"
      />
      <path
        class="st3"
        d="M546,75.9L546,75.9c-1.4,1.3-3,1.8-4.7,2c0,0.1,0,0.2-0.1,0.3c-0.1,0.3-0.5,0.6-0.6,1s-0.3,0.6-0.7,0.6
		c-0.6,0-0.6-0.4-0.6-0.8c0-0.2,0.1-0.4,0.2-0.6c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2,0-0.2,0c-0.6,0-1.3,0.1-1.7,0.5
		c-0.6,0.5-1.1,0.3-1.6,0.3c0-0.7,0.1-1.4-0.2-2c-0.5,0.2-1,0.4-1.5,0.6c-0.1,0.1-0.2,0.1-0.2,0.2h-0.1c-1.4,1.2-2.8,2.4-4.1,3.5
		c-0.5,1.4-1,2.8-1.5,4.3l0.1-0.1c0,0,0,0,0,0.1c0.2,0,0.4,0,0.6,0c0,0,0,0,0-0.1c0.3-0.2,0.6-0.4,0.9-0.5c1.5-1.1,3.1-2.1,4.6-3.2
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.3-0.1,0.5-0.1,0.7-0.2c-0.1,0.2-0.3,0.3-0.4,0.5c-1.7,0.9-3.3,1.9-5,2.8
		c-0.3,0.2-0.6,0.4-0.9,0.6l0,0c0.4,0.5,0.8,1.1,1.2,1.6c-0.3,0.1-0.5,0.3-0.8,0.4c-0.3-0.7-0.7-1.4-1-2.1h-0.1
		c-0.6,1.1-1.4,2.1-1.8,3.2c-0.6,1.6,0.5,1.7,1.7,1.6c0.1,0.1,0.2,0.2,0.3,0.4c-0.1-0.1-0.2-0.2-0.3-0.4c0.5-0.2,0.9-0.5,1.4-0.7
		c3.5-2,4-2.1,5.6-1.1c-1.7,0.4-3.5,0.9-5.3,1.4l0,0c-0.5,0.3-0.9,0.5-1.4,0.8c-1.3,0.8-3.6,0.8-2.9,3.3c0.4,0,0.8,0,1.2,0
		c0,0,0,0,0.1-0.1c0.1,0,0.1,0,0.2-0.1c0.1-0.2,0.3-0.3,0.4-0.5c0.1,0.1,0.2,0.2,0.2,0.3c-0.2,0.1-0.4,0.2-0.7,0.3l-0.1,0.1h-0.1
		c-0.5,0.6-1,1.1-1.5,1.7c0.8,0.6,2.5,1,0.1,1.9l0,0c-0.5-0.2-0.9-0.5-1.4-0.7l0,0c-0.2,0.5-0.5,0.9-0.7,1.4
		c-2.3,0.1-3.8,1.3-4.9,3.3c-0.5,0.9-1.4,1.6-2.2,2.4c-1.2,4.7-4.1,8.3-7.1,12c0,0.5,0,0.9,0,1.4v0.1c0,0,0-0.1,0,0
		c0.2,0,0.4,0,0.6,0c0.4-0.4,0.8-0.7,1.2-1.1c0.1,0.1,0.2,0.3,0.3,0.4c-0.4,0.3-0.9,0.6-1.3,0.9l-0.1-0.1c0.1,0.1,0.1,0.1,0.1,0.1
		c-0.3,0.2-0.5,0.4-0.8,0.7c-1,0.7-2,1.3-2.9,2l0,0c1-1.4,1.9-2.9,2.9-4.3c0,0,0,0,0,0.1c0.1-2.1,0.3-4.1,0.4-6.2
		c-5.9,6.9-18.6,27.6-18.3,30.9c1.5-1.4,2.7-2.5,3.7-3.7c1.5-1.8,1.7-4.5,4.3-5.5l0,0c2.4,0.7,4.8,1.6,7.2,2
		c9.1,1.4,18.2,2.6,27.3,4c5.2,0.8,10.4,1.7,15.7,2.6c0.6-0.9,1.4-2,2.1-3.2c0,0-0.1-0.1-0.2-0.2c-0.1,0-0.2,0-0.3-0.1
		c-1.1,0.7-2.2,1.3-3.2,2c-0.3-0.3-0.6-0.6-0.9-0.9c1.1-1.5,2.1-3.1,3.2-4.6c1.1-1.4,2.4-2.8,3.5-4.1c0.3,0.2,0.5,0.5,0.8,0.7
		c-1.9,2.2-3.8,4.5-6.1,7.2c1.3-0.3,1.8-0.5,2.3-0.6c0.9-0.3,1.8-0.5,2.6-0.8c0.1,0.2,0.3,0.5,0.4,0.7c-0.8,1-1.6,1.9-2.2,2.9
		c-0.2,0.3,0.5,1,0.7,1.5l0,0c0.2-0.2,0.4-0.4,0.7-0.7l0,0c0,0,0,0,0.1,0l0,0l0,0c0.7-0.3,1.5-0.6,2.2-1c0.1,0.2,0.3,0.4,0.4,0.6
		c-0.7,0.9-1.3,1.8-2.2,3c1.4,0.2,2.7,0.4,4.3,0.7c-0.2,0.4,0.1,0.1,0.1-0.1c0.1-5.8,0.1-11.6,0.2-17.4c0.2-10.7,0.4-21.3,0.6-32
		c0.1-3.9,0.2-7.7,0.1-11.6c0-3.9-1.9-5.2-5.8-4.4l0,0l0,0l0,0c-0.2,0.5-0.5,0.9-0.7,1.4s-0.5,1-0.7,1.4h-0.1h0.1l0,0
		c0.5,2.3-1.1,4.9-3.5,5.6c0.1-0.1,0.2-0.3,0.3-0.4c-0.1,0.1-0.3,0.2-0.4,0.3c-0.4,0-0.8,0-1.9,0.1c1.5-1.3,2.4-2.1,3.5-3.1
		c-0.6-0.2-1-0.3-1.4-0.5l0,0c-0.1,0-0.1,0-0.2,0c-0.4,0.2-0.8,0.4-1.2,0.5c0-0.2-0.1-0.4-0.1-0.5c0.5,0,0.9,0,1.4,0h0.1h0.1
		c1.1-0.7,2.3-1.4,3.4-2.1c0,0,0,0,0-0.1c0.2-0.5,0.5-1,0.7-1.4l0,0l0,0c0.2-0.5,0.5-0.9,0.7-1.4c-0.9-0.7-1.8-1.5-2.9-1.9
		C548.5,75.7,547.2,75.9,546,75.9z M529.7,92.2C529.7,92.1,529.8,92.1,529.7,92.2C529.8,92.1,529.8,92.1,529.7,92.2L529.7,92.2
		c0.5-0.3,1-0.5,1.4-0.8c0.1,0,0.2-0.1,0.3-0.1c-0.1,0-0.2,0.1-0.2,0.1C530.8,91.7,530.3,91.9,529.7,92.2
		C529.8,92.1,529.8,92.1,529.7,92.2s-0.1,0.3-0.2,0.4c-0.1-0.1-0.2-0.2-0.3-0.3C529.4,92.3,529.6,92.2,529.7,92.2z M527.8,107.8
		c0.1,0,0.2,0.1,0.2,0.2c-0.2,0.1-0.4,0.2-0.6,0.2c-0.1,0-0.2-0.1-0.2-0.2C527.5,108,527.6,107.9,527.8,107.8z M525.4,100.8
		c0-0.1,0.1-0.1,0.1-0.2c0,0,0.1,0,0.1-0.1s0-0.1,0-0.2c0,0,0.1,0,0.2,0c-0.1,0.1-0.2,0.1-0.2,0.2v0.1
		C525.5,100.7,525.5,100.7,525.4,100.8c-0.3,0.4-0.5,0.8-0.8,1.2c-0.1-0.1-0.3-0.2-0.4-0.4C524.6,101.3,525,101,525.4,100.8z
M521.8,99.7c0.1,0.1,0.2,0.2,0.3,0.3C522,99.9,521.9,99.8,521.8,99.7c0.3-0.4,0.6-0.8,0.9-1.2c0.5,0,1,0,1.4,0l0,0l0,0
		c-0.7,0.5-1.3,1-2,1.5c-1,1-2.1,2-3.1,3c-0.2-0.3-0.5-0.6-0.7-0.9C519.5,101.3,520.7,100.5,521.8,99.7z M501.3,131.3
		c-0.1-0.3-0.3-0.7-0.4-1c1.5-0.9,3.1-1.8,4.3-2.5c0.2,1,0.4,1.7,0.6,2.6C504.4,130.6,502.9,131,501.3,131.3z M501.5,127.5
		L501.5,127.5c0.4-0.5,0.9-1,1.4-1.4h-0.1l0,0c-0.7-2.1,0.5-3.3,2.1-4.2l0,0c-0.5,1.2-1,2.4-1.5,3.6l0.1-0.1c0,0,0,0-0.1,0.1
		c1.6-0.8,3.2-1.5,4.8-2.3c1-0.9,2.1-1.9,3.1-2.8c0.2-0.2,0.4-0.4,0.6-0.6l0.1,0.1c-0.2,0.2-0.4,0.4-0.6,0.6c-0.9,1-1.9,2.1-2.8,3.1
		C506.4,124.9,504.7,127.5,501.5,127.5z M508,129.5c0,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.2-0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.1
		C508,129.2,508,129.3,508,129.5z M512.9,130.3L512.9,130.3c-0.1,0.1-0.2,0.1-0.2,0c-1.7,0.8-3.5,1.5-5.2,2.3
		c-0.1-0.3-0.2-0.6-0.3-1c1.3-2.5,3.5-1.5,5.5-1.3h0.1H512.9c0.3-0.2,0.5-0.4,0.8-0.6c0.1,0.2,0.1,0.4,0.2,0.5
		C513.6,130.2,513.3,130.3,512.9,130.3z M516.3,133.9c-1.7-0.6-0.4-1.8,0.2-2.8c0.2-0.3,0.3-0.6,0.4-0.9c-0.6-0.4-1.1-0.7-1.5-1
		c0.1-0.2,0.1-0.4,0.2-0.5c0.9,0.2,1.8,0.4,3,0.7c-0.5,1.1-0.8,2-1.3,2.5C516.7,132.5,518.2,134.5,516.3,133.9z M517.7,113.3
		c-0.2-0.2-0.4-0.4-0.7-0.7c0.5-0.3,1-0.5,1.4-0.8l0,0c0.2-0.3,0.4-0.6,0.6-0.8c0.5-0.4,1.1-0.8,1.6-1.2l0,0c0.1,0,0.1-0.1,0.2-0.1
		c0.2-0.2,0.3-0.4,0.5-0.6c0.1,0,0.2-0.1,0.3-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.1-0.1,0.1-0.1,0.2
		c-0.4,0.5-0.8,1.1-1.2,1.6l0,0c-0.3,0.2-0.5,0.4-0.8,0.6C518.3,112.5,518,112.9,517.7,113.3z M521.1,118.1
		c-0.1,0.1-0.3,0.1-0.4,0.2v0.1c-0.3,0.1-0.6,0.2-0.8,0.4c-0.2,0.1-0.4,0.2-0.6,0.3l0,0c-0.1,0.2-0.2,0.3-0.2,0.5
		c-0.1-0.1-0.2-0.2-0.3-0.3c0.2-0.1,0.3-0.2,0.5-0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.5-0.3,0.8-0.4h0.1c0-0.1,0.1-0.3,0.1-0.4
		C520.9,117.9,521,118,521.1,118.1z M525.6,135.2c-0.5-0.1-1-0.2-1.4-0.3c0-0.2,0.1-0.4,0.1-0.6c0.5,0.1,0.9,0.2,1.4,0.4
		C525.7,134.7,525.7,135,525.6,135.2z M524.3,129.8c-2.3,2.1-2.3,2.1-2.4,4.2c-0.5-0.6-1.1-1.5-0.8-1.8c0.8-1,1.9-1.9,2.9-2.7
		c0.7-0.9,1.4-1.8,2.1-2.7C526.8,128.6,525.9,129.4,524.3,129.8z M525.8,121.4L525.8,121.4c-0.5,0.1-1.1,0.3-1.6,0.4l0,0
		c-0.2,0.2-0.5,0.5-0.7,0.7l0,0h-0.1c-0.4,0.3-0.8,0.5-1.2,0.8l-0.2-0.2l0.2,0.2c-0.4,0.3-0.9,0.6-1.3,0.9c-0.5,0.4-1,0.9-1.5,1.3
		c0,0.5-0.1,1-0.1,1.4c-0.2,0-0.6-0.1-0.6-0.1c0.1-0.6,0.2-1.1,0.3-1.7l0,0c0.5-0.5,1-0.9,1.5-1.4c0.1,0.1,0.2,0.3,0.4,0.4
		c-0.1-0.1-0.2-0.3-0.4-0.4c0.5-0.2,1-0.4,1.5-0.7c0.5-0.2,0.9-0.4,1.4-0.5c0,0,0.1,0,0.1-0.1c0.2-0.2,0.5-0.5,0.7-0.7l0,0l0,0
		c0.4-0.3,0.8-0.6,1.2-0.9c0.4-0.4,0.9-0.9,1.3-1.3c0.1,0.2,0.3,0.3,0.4,0.5C526.7,120.5,526.2,121,525.8,121.4z M531.2,111.9
		c-0.2,0.2-0.5,0.5-0.7,0.7l0,0l0,0c-0.7,0.5-1.4,0.9-2.1,1.4c-0.1,0-0.1,0-0.2,0.1c-0.4,0.2-0.8,0.4-1.2,0.7l0,0
		c-0.5,0.2-0.9,0.4-1.4,0.6c0,0-0.1,0-0.1,0.1c-0.5,0.2-0.9,0.5-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.3c-0.2,0-0.5,0-0.7,0
		c0.3-0.1,0.6-0.2,1-0.3c0,0,0,0,0,0.1c0.5-0.2,0.9-0.5,1.4-0.7l0,0h0.1c0.4-0.3,0.8-0.5,1.2-0.8c0.4-0.2,0.9-0.3,1.3-0.5
		c0.1,0,0.1-0.1,0.2-0.1l0,0c0.7-0.5,1.4-1,2.1-1.4C530.7,112.4,530.9,112.1,531.2,111.9c0.1-0.1,0.3-0.2,0.5-0.3
		C531.6,111.8,531.4,111.8,531.2,111.9z M530.6,107c-0.4,0.2-0.8,0.4-1.2,0.6c-0.1-0.2-0.1-0.3-0.2-0.5c0.4-0.2,0.8-0.3,1.1-0.5
		c0.7-0.4,1.4-0.8,2.1-1.2c0.1,0.2,0.2,0.4,0.3,0.6C532,106.4,531.3,106.7,530.6,107z M535.1,79.4C535.1,79.4,535.1,79.3,535.1,79.4
		C535.2,79.3,535.2,79.3,535.1,79.4C535.2,79.3,535.1,79.4,535.1,79.4z M540.3,84.2c0,0.1-0.1,0.2-0.1,0.3c0,0-0.2,0-0.2-0.1
		s0-0.2,0-0.3C540,84.2,540.1,84.2,540.3,84.2z M540.5,117.1c-0.1,2.6,0,5.2-0.3,7.7c-0.2,1.3-1.2,2.5-1.9,3.9
		c0.2,0.2,0.9,0.7,1.5,1.2c-0.1,0.2-0.2,0.4-0.3,0.6c-1-0.4-2-0.8-3.1-1.3c0-5.6,0-11.1,0-16.6C540.4,113.2,540.6,113.4,540.5,117.1
		z M553.2,126.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.7,0.6-1.5,1.3-2.2,1.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3
		c-0.3,0.2-0.5,0.4-0.8,0.6c-0.9,0.7-1.8,1.5-2.7,2.2l0,0c-0.3,0.2-0.6,0.4-0.8,0.6l0,0c-0.2,0.2-0.5,0.5-0.7,0.7
		c-0.7,0.8-1.3,1.5-2,2.3c-0.1,0.1-0.2,0.3-0.3,0.4l0,0c0.1-0.1,0.2-0.2,0.3-0.4c0.6-0.8,1.1-1.7,1.7-2.5c0.1,0.1,0.2,0.2,0.3,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.3c0.2-0.2,0.5-0.5,0.7-0.7c0-0.2,0-0.3,0.1-0.5c-0.4-0.3-0.9-0.5-1.3-0.8l0,0c-0.2,0-0.4,0-0.7-0.1
		c0,0,0,0,0,0.1c0,0-0.1,0-0.1,0.1c0,0.2,0,0.3,0,0.5c-0.1-0.1-0.3-0.1-0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.3v-0.1c0,0,0,0,0.1,0
		c-0.3-4.8-0.7-9.7-1-14.5c3.3-0.2,4.1,0.4,4,3.2c-0.1,4-0.5,8-0.8,12h-0.1h0.1c0.2-0.1,0.4-0.1,0.6-0.1c0.9-0.7,1.8-1.5,2.7-2.2
		l0,0c0.3-0.2,0.5-0.4,0.8-0.6c0.8-0.5,1.7-1.1,2.5-1.6C552.8,126.3,553,126.2,553.2,126.1l0.1-0.2L553.2,126.1z M556.4,113.4
		c-0.2,0-0.4,0-0.6,0c-0.1-1-0.1-1.9-0.2-2.9c0.3,0,0.6,0,0.9,0C556.4,111.6,556.4,112.5,556.4,113.4z M556.8,101.9
		c0,0.1,0,0.1,0,0.2c-0.2,0.4-0.4,0.7-0.6,1.1c-0.3,0.6-0.6,1.1-0.8,1.7c-0.1,0.8-0.1,1.5-0.2,2.3c-0.3-0.1-0.5-0.1-0.8-0.2
		c0.3-0.7,0.6-1.4,0.9-2.1c0.3-0.5,0.6-1.1,0.9-1.6c0.2-0.4,0.4-0.8,0.6-1.1C556.7,102,556.8,102,556.8,101.9c0-0.5,0-1,0-1.5
		c0.2,0,0.4,0.1,0.6,0.1C557.2,101,557,101.5,556.8,101.9z M553.8,83c0-0.1,0-0.1,0-0.2c0,0,0-0.1,0.1-0.1c0-0.8,0-1.7,0-2.5
		c0.3,0.1,0.7,0.2,1,0.2c-0.3,0.8-0.7,1.5-1,2.3C553.9,82.8,553.9,82.8,553.8,83C553.8,82.9,553.8,83,553.8,83c0,0.4,0,0.7,0,1.1
		c-0.2,0-0.3-0.1-0.5-0.1C553.5,83.6,553.6,83.3,553.8,83z M552.7,84.6c0.6,1,0.8,1.3,1.1,1.7c0.4-2,1.4-3.5,4.3-4.6
		c-0.6,1.6-1,2.4-1.3,3.3l0,0c-0.1,0.2-0.2,0.4-0.2,0.6c-0.6,2.1-1.3,4.3-1.9,6.4c0,0,0,0,0.1,0l0,0l0,0l0,0l0,0
		c0.9-0.3,1.8-0.7,3.3-1.2c-0.9,1.9-1.7,3.4-2.4,4.9c-0.3,0.5-0.5,1.1-0.8,1.6c0,0.1-0.1,0.2-0.1,0.4c0.7,0.4,1.4,0.8,2.1,1.2
		c-0.8,0.6-1.7,1.2-2.5,1.8c-0.2-0.2-0.4-0.3-0.6-0.5c0.3-0.9,0.7-1.7,1-2.6h-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.2-0.6,0.3-1.3,0.5-1.9
		c0-0.7,0-1.4,0-2c-0.1,0.1-0.3,0.2-0.4,0.2c-1.1,1.8-2.1,3.5-3.2,5.3c-0.3-0.1-0.6-0.3-0.9-0.4c0.8-1.7,1.7-3.4,2.5-5l-0.1-0.1h0.1
		c0.2-0.4,0.4-0.9,0.6-1.3V92c0,0,0,0,0.1,0c0.9-2.1,1.7-4.3,2.6-6.4c0.1-0.2,0.1-0.4,0.2-0.6c-0.4-0.1-1-0.4-1.1-0.2
		c-0.6,0.5-1,1.2-1.4,1.9c-0.3,0.4-0.6,0.8-0.9,1.2l0,0c-0.9,2.1-1.8,4.1-2.7,6.2c-0.4-0.2-0.8-0.3-1.1-0.5
		C550.3,90.8,551.3,88.1,552.7,84.6z M547.8,92.3c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0,0.2-0.1,0.3-0.1c-0.1,0-0.1,0.1-0.2,0.1
		C548.1,92.2,547.9,92.3,547.8,92.3c-1,0.7-2,1.4-2.9,2.1l0,0c-0.5,0.2-1,0.5-1.4,0.7c-0.4,0.3-0.9,0.5-1.3,0.8
		c-0.1-0.2-0.2-0.3-0.3-0.5c0.4-0.2,0.9-0.4,1.3-0.7c0.1,0.1,0.2,0.2,0.3,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.4-0.3,0.8-0.6,1.2-0.9
		C545.5,93.4,546.7,92.9,547.8,92.3z M550.1,78.8c-0.3,0.3-0.7,0.5-1,0.8c-1.9,0.9-3.8,1.8-5.7,2.7c-0.1-0.1-0.2-0.2-0.3-0.4
		c0.1,0.1,0.2,0.2,0.3,0.4c-0.4,0.2-0.9,0.3-1.3,0.5c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c0.1-0.1,0.3-0.2,0.4-0.4
		c0.1,0,0.2-0.1,0.2-0.1c0.3-0.3,0.7-0.5,1-0.8c1.9-0.9,3.8-1.8,5.7-2.7l0,0C549.2,79.1,549.6,79,550.1,78.8z"
      />
      <path
        class="st3"
        d="M462.5,84c1-0.6,1.9-0.8,1.9-1.1c0-0.7,0.1-1.3,0.1-2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,0-0.9,0.1-1.7,0.2
		C462.6,82.2,462.6,83.1,462.5,84z"
      />
      <path
        class="st3"
        d="M463.9,78.4c-0.3,0-0.7,0.1-1,0.3c0,0.7-0.1,1.3-0.1,2c0.2-0.2,0.3-0.3,0.4-0.3c0.3-0.1,0.7-0.1,0.9-0.3
		c0.3-0.3,0.6-0.7,0.6-1C464.6,78.9,464.2,78.5,463.9,78.4z"
      />
      <path
        class="st3"
        d="M456,76.6c0.6-0.4,1-0.9,0.8-1.6c-1.6,0.3-3.1,0.7-4.7,1c0.1,0.2,0,0.4-0.2,0.4c1.3,0.3,1.3,0.3,0,2
		c0.4,0,0.8,0,1.3,0c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4,1.1-0.8,2.2-1.2,3.3c0.2,0.1,0.4,0.2,0.7,0.3
		c1-1.4,2-2.8,3.4-4.7C456.2,77.3,456.1,77,456,76.6z"
      />
      <path
        class="st3"
        d="M457.5,83l0.1-0.1c1.3-1.2,2.2-2.5,2.9-3.9c-0.3,0-0.7,0.2-1.5,0.5c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.4
		c0-0.2,0-0.4-0.1-0.7c-0.2,0-0.4,0-0.4,0.1c-0.3,0.6-0.9,0.8-1.7,1c-0.1-0.4-0.2-0.7-0.3-1.1V78c-0.1,1.4-0.2,2.4-0.3,3.2
		c0.8-1,1.6-2,2.4-3c0.1,0,0.3,0.1,0.4,0.1c-0.5,1.5-0.9,3-1.4,4.5L457.5,83z"
      />
      <path
        class="st3"
        d="M530.5,63.3c-0.2,0.6-0.4,1.2-0.7,1.8c0.2,0,0.3-0.1,0.5-0.1c0.5-0.2,1-0.6,1.4-0.9c0.3-0.6,0.6-1.2,0.9-1.8
		c0-0.2,0-0.4,0-0.6c-0.1-0.5-0.5-1-1-1.5C531.2,61.1,530.8,62.1,530.5,63.3z"
      />
      <polygon class="st3" points="545.5,126.4 545.7,126.5 545.7,126.3 	" />
      <path
        class="st3"
        d="M555.4,93.3C555.4,93.3,555.4,93.4,555.4,93.3c0,0.1,0.1,0,0.2,0C555.5,93.3,555.4,93.3,555.4,93.3z"
      />
      <path
        class="st3"
        d="M539.2,118.2c0.1,0,0.2,0,0.3,0.1c0-0.5,0-1.1,0-1.6c-0.1,0-0.1,0-0.1,0C539.2,117.2,539.2,117.7,539.2,118.2z
		"
      />
      <path
        class="st3"
        d="M454.3,65.7c0.1,0.1,0.1,0.2,0.2,0.3c0.3-0.5,0.6-0.8,0.8-1.2c0,0,0-0.1,0.1-0.1l0,0c0.9-0.1,1.9,0.5,2.8-0.3
		c0.1-0.4,0.2-0.9,0.3-1.4c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4
		c-0.3,0.3-0.5,0.6-0.6,1c-0.2,0.5-0.6,1.1-1.1,1.8c0.1,0.1,0.1,0.3,0.2,0.5s0.2,0.4,0.4,0.6c0.3,0.4,0.7,0.8,0.7,1.3
		c0.1,0.7,0.7,1.1,1.5,1c0.6-0.1,1,0,1.3,0.2c0.1-0.9,0.1-1.8,0.1-2.7c0.3,0,0.6,0.1,0.9,0.1c-0.1,1.1-0.1,2.1-0.2,3.2
		c0.1,0.1,0.2,0.2,0.3,0.4c0.3-0.1,0.6-0.2,0.9-0.3c0.1,0.1,0.2,0.2,0.1,0.2c-0.5,0.6-0.9,1.2-0.8,2c0,0.2-0.2,0.4-0.3,0.5
		c-0.1-0.1-0.3-0.1-0.4-0.2c0,0.2,0,0.5,0,0.7c0.6-0.1,1.2-0.1,1.8-0.2c0.2-4.4,0.4-8.8,0.6-13.2c-0.3,0-0.5,0-0.8-0.1
		c-0.3,1.1-0.6,2.3-0.9,3.4c-0.2,0-0.3,0-0.5,0c-0.1-1.6-0.3-3.2-0.5-5.6c-2.4,0.8-4.8,1.5-7.2,2.3v0.1c0,0.3,0,0.6,0,1
		c0.1,0.5-0.2,1-0.3,1.4c-0.5,0.1-0.9,0.2-1.5,0.3C453.9,65,454.1,65.3,454.3,65.7z M457.7,62L457.7,62L457.7,62L457.7,62z"
      />
      <path
        class="st3"
        d="M462.5,42.6c-0.6-0.4-0.9,0.1-1.3,0.3c0.3,0.3,0.6,0.6,0.8,1C462.1,43.4,462.3,43,462.5,42.6z"
      />
      <path
        class="st3"
        d="M545.5,123.6c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.2-0.1-0.3-0.2
		C545.5,123.4,545.5,123.5,545.5,123.6z"
      />
      <path
        class="st3"
        d="M545.6,120.1c0,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.2-0.1-0.3-0.1
		C545.6,119.9,545.6,120,545.6,120.1z"
      />
      <path
        class="st3"
        d="M522.4,190.2c0.8,0,1.6,0,2.3,0c0-0.1,0-0.2,0-0.2c-0.8,0-1.6,0-2.3,0C522.4,190.1,522.4,190.1,522.4,190.2z"
      />
      <path
        class="st3"
        d="M510.3,53.6c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.3-0.2-0.6-0.5-0.9-0.6
		c-0.2-0.1-2.2,0.5-2.3,0.6c-0.4,0.6-0.1,1.3,0.8,1.9l0,0c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.4,0.4-0.6c0.1-0.1,0.1-0.2,0.2-0.4
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.2,0.1,0.5,0.1,0.6,0.2c-0.3,0.9-0.5,1.7-0.8,2.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.5,0.2-1,0.4-1.4,0.8
		c0.1,1.4,0.1,2.8,0.2,4.3c11-2.5,21.5-4.9,32.5-7.5c-0.3-0.2-0.7-0.4-1.1-0.5c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4
		c0-0.1,0.1-0.1,0.1-0.2c0.2-0.4,0.4-0.8,0.5-1.2c0.4-0.1,0.9-0.2,1.4-0.3c0.1-2.5,0.2-5.1,0.2-7.6c-1.8-0.3-3.7,0.3-4.9,1.6
		c-0.3,0.3-0.5,0.6-0.7,0.9c-0.5,0.7-1.2,1.2-2.1,1.4c0,0.1,0.1,0.1,0.1,0.2c0.2,0.2,0.3,0.3,0.4,0.4c0.2,0,0.4-0.2,0.9-0.5
		c0.1,0.4,0.2,0.8,0.4,1.3c-0.2,0-0.4,0-0.6,0c-0.4,0-0.7,0-1,0c-1.1,0-2,0.2-2.8,0.5c-0.8,0.4-1.4,0.9-1.8,1.6l-0.1,0.1
		c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2
		c-0.1-0.1-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1
		c-0.3,0.1-0.7,0.1-1.1,0v-0.1c0-1.3-0.5-2.4-2.1-2.9s-2.9,0.2-4,1.1c-0.2,0.2-0.4,0.3-0.6,0.5c0,0.4-0.1,0.9-0.1,1.4
		c-0.3-0.1-0.5-0.1-0.8-0.2c-0.1,0.1-0.2,0.2-0.3,0.3c-0.5,0.5-0.9,1-1.4,1.5c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2
		C511.3,53.1,510.8,53.3,510.3,53.6z"
      />
      <path
        class="st3"
        d="M258.8,143.6c0.4-0.5,1.1-1,1.1-1.4c-0.2-1.3-0.5-2.6-0.9-3.9c-0.4-0.1-0.8-0.3-1.2-0.4c0,0.6,0,1.2,0,2.2
		c-0.1-0.1-0.2-0.2-0.3-0.3c-0.5,0.8-1.1,1.8-2,1.7c-0.1,0.1-0.2,0.1-0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.3-0.2-0.4-0.3
		c-0.4,0.3-0.3,0.6-0.2,1c0,0.1,0.3,0.1,0.6,0.1c-0.3,0.2-0.6,0.3-0.9,0.5c0.4,0.6,0.9,1.3,1.4,1.9c-0.5-1.5,0.9-1.3,1.7-1.6
		C258,142.3,258.7,142.3,258.8,143.6z"
      />
      <path
        class="st3"
        d="M448.4,79.4c-0.2,0-0.5,0-0.7,0l0,0c0-0.2,0-0.4,0-0.7c-0.4,0.4-0.9,0.9-1.3,1.3c0.2,0,0.5,0,0.7,0l0,0
		c-0.2,0.2-0.3,0.3-0.5,0.5c0.1,0.1,0.1,0.3,0.2,0.4s0.1,0.2,0.2,0.3c0.2,0.3,0.3,0.6-0.2,0.9c-0.1,0.1-0.1,0.3,0,0.4
		c0.4,0.6,0.1,1.3-0.1,2c-0.1,0.4,0,0.9-0.1,1.3c0,0.1-0.1,0.2-0.1,0.2c2.5-1.6,3.8-4.6,5.3-7.3C450.7,79.1,450.1,81.9,448.4,79.4z"
      />
      <path
        class="st3"
        d="M262.7,122.8c0-0.1,0.1-0.2,0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0.1-0.1,0.2-0.1,0.2
		C262.6,122.7,262.7,122.8,262.7,122.8z"
      />
      <path
        class="st3"
        d="M497.3,75.4c0.3,0,0.7,0,1,0c0.3-4.5,0.4-9.1,0.3-13.7c0,0,0,0.1-0.1,0.1c-0.3-1-0.4-1.5,0-2.8
		c0-0.5,0-1,0-1.5c0,0.1-0.1,0.2-0.1,0.4c-0.1,0.2-0.2,0.5-0.4,0.7C497.8,64.3,497.5,69.8,497.3,75.4z"
      />
      <path
        class="st3"
        d="M542.7,183.9c0.2-0.5,0.6-0.9,1.1-1.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2-0.3,0.3-0.6,0.4-0.9
		c0.1-0.3-0.7-0.7-0.8-0.5s-0.2,0.4-0.4,0.5c-0.2,0.3-0.4,0.5-0.6,0.8c-0.2,0.7-0.3,1.3-0.6,2.4c0.1,0,0.3,0,0.4,0
		C542.5,184.3,542.6,184.1,542.7,183.9z"
      />
      <path
        class="st3"
        d="M445.7,86.5c-0.3-0.1-0.7-0.2-1-0.3h-0.1c-1.1-0.5-2.2-1-3.2-1.7c-0.3,0.9-0.6,1.7-0.9,2.7
		C442.6,87.4,444.3,87.1,445.7,86.5z"
      />
      <path
        class="st3"
        d="M532.5,58.9c0.4,0.6,0.9,1.2,1.5,1.5c0.4-0.4,0.8-0.8,1.3-1.1c-0.1,0.5-0.3,0.9-0.4,1.4
		c0.3,0.1,0.5,0.1,0.8,0.2c0.2,0,0.4,0,0.6,0h0.1c0.2-0.2,0.3-0.3,0.5-0.5v-0.1h0.2l-0.2,0.1c0,0,0,0-0.1,0.1c0,0.1,0,0.3-0.1,0.4
		c0.7-0.1,1.3-0.3,1.9-0.6c0.1-1.2,0.3-2.5,0.4-3.7C535.8,56.5,533.8,57.2,532.5,58.9z"
      />
      <path
        class="st3"
        d="M263.2,137.6c-0.2,0.2-0.5,0.3-0.8,0.5c0-0.3,0.1-0.6,0.1-0.8c-0.5-0.2-1.1-0.5-1.7-0.8c0,0.1,0,0.1,0,0.2
		c0.2,0.3,0.4,0.5,0.5,0.6c-0.1,0.1-0.3,0.2-0.5,0.3c0,0.1,0,0.3,0,0.4c0.3,0,0.6,0,0.9-0.1c-0.3,0.4-0.6,0.6-0.7,0.8
		c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c1.3-0.3,2.5-0.5,4.2-0.8C264.5,138.1,263.8,137.8,263.2,137.6z M261.5,137.4L261.5,137.4
		C261.5,137.4,261.6,137.4,261.5,137.4C261.6,137.4,261.5,137.4,261.5,137.4z"
      />
      <polygon class="st3" points="266.4,169.4 266.1,169.4 266.3,169.6 	" />
      <path
        class="st3"
        d="M98.1,241.3C98.2,241.4,98.2,241.4,98.1,241.3L98.1,241.3z"
      />
      <path
        class="st3"
        d="M360.1,211.5c-0.1,0.1-0.2,0.2-0.3,0.3C359.9,211.7,360,211.6,360.1,211.5L360.1,211.5z"
      />
      <path
        class="st3"
        d="M369.8,225.9l0.2-0.1l0,0C369.9,225.8,369.8,225.8,369.8,225.9z"
      />
      <path
        class="st3"
        d="M223.4,228L223.4,228c-0.2,0.2-0.4,0.4-0.7,0.7l0,0c0,0,0,0-0.1,0.1c0.2,0,0.5,0,0.7,0l0,0l0,0l0,0l0,0
		C223.4,228.4,223.4,228.2,223.4,228L223.4,228z"
      />
      <path
        class="st3"
        d="M365.8,220c-0.1,0.1-0.2,0.2-0.3,0.3l0,0C365.6,220.2,365.7,220.1,365.8,220z"
      />
      <path
        class="st3"
        d="M143.4,229.3C143.4,229.3,143.5,229.4,143.4,229.3L143.4,229.3z"
      />
      <path
        class="st3"
        d="M450.6,200c-7.5-0.4-15-0.9-22.5-1.3c0-0.2,0-0.4,0-0.5c2.4,0,4.8,0,7.3,0c-3.3-0.3-6.6-0.3-9.8-0.3
		c-0.7,0-1.4,0.2-2-0.1c-2.7-1.2-5.4-1.8-8.3-0.9h0.1c0.5,0,1,0.1,1.5,0.1c0,0.2-0.1,0.3-0.1,0.5c-0.5-0.2-0.9-0.4-1.4-0.6
		c-0.1,0-0.1,0-0.2,0v-0.1c-12.5,0-25,0-37.5,0c0-0.3,0-0.6,0-0.8c9.8-0.2,19.6-0.4,29.4-0.6c-1.9-0.3-3.9-0.6-5.8-0.8
		c-6.6-0.8-13.1-1.6-19.7-2.3c-2.9-0.3-5.8,0-8.7,0c0,0.1,0,0.2,0,0.2c2.2,0.5,4.3,1,6.5,1.4c0.2,0,0.3,0,0.5,0c0.1,0,0.1,0,0.2,0
		c1.3-0.1,2.6-0.1,3.9-0.2c0,0.4-0.1,0.7-0.1,1.1c-1.3-0.3-2.6-0.6-3.8-0.9c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3-0.1-0.5-0.1
		c-5.4-0.4-10.9-0.8-16.3-1.3c-7.8-0.8-15.6-2-23.4-2.6c-6.5-0.5-13-1.3-18.5-3.3c-0.6,0.5-1,1.1-1.3,1.1c-3.3,0-6.7,0-10-0.2
		c-7.9-0.6-15.9-1.4-23.8-2.2c-1.7-0.2-3.4-0.9-5.1-1.4c0.1-0.2,0.1-0.5,0.2-0.7c4.6,0.3,9.1,0.7,13.7,0.9c7,0.3,14,0.4,21,0.7
		c0.1,0,0.2,0,0.4,0c11.3,1.4,22.5,3.1,33.9,4.2c13.3,1.2,26.7,1.6,40.1,2.9c8.3,0.8,16.7,0.8,24.7,3.3c1.2,0.4,2.6,0,3.8-0.1
		c0.9-0.1,1.9-0.5,2.7-0.4c8.6,0.9,17.2,2,25.8,2.7c0.7,0.1,1.5,0.1,2.2,0.1c-0.3-0.2-0.7-0.3-1.2-0.4c-0.3-0.1-0.9,0-1-0.2
		c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.5-0.1-0.7-0.1h-0.1c0-0.1,0-0.1,0-0.2c0.1-1,1.5-1.3,2.1-2.2
		c-0.5,0.1-0.9,0.2-1.3,0.3c-0.8-0.6-1.1-1.3-0.6-2.1c-0.3-0.3-0.6-0.5-1-0.6c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3
		l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.1-0.1,0.3-0.2,0.4-0.3c-8.9-0.6-17.7-1.1-26.6-1.7c-4.5-0.3-9-0.1-13.4-0.9
		c-6.3-1.1-12.5-1.8-18.9-1.9c-10.3-0.1-20.6-0.9-30.9-1.3c-7.5-0.3-15.1-0.1-22.6-0.4c-5.5-0.2-11.1-0.9-16.6-1.4
		c0.6-1.2,1-2.1,1.5-2.9c0.3-0.4,1-0.5,1.4-0.7c0.1,0.5,0.2,1,0.3,1.5c1.5-0.4,2.9-0.9,4.4-1.1c1.5-0.1,3.1,0.2,4.6,0.3
		c0,0.2-0.1,0.4-0.1,0.7c-2.4,0.2-4.7,0.3-7.1,0.5c0,0.3,0,0.6,0.1,0.9c4.9,0.3,9.8,0.6,14.7,1c0-4.9,0-9.2,0-13.6
		c-3-0.2-5.7-0.4-8.5-0.5c0-0.2,0-0.5,0-0.7c2.7-0.3,5.3-0.6,8.4-0.9c0.1-1.7,0.2-3.4,0.3-5.5c-17.6-0.6-34.7,1.3-52.3,1.6
		c0.3,1.4,0.6,2.5,0.8,3.5c0.1,0.1,0.2,0.2,0.3,0.3c-0.1-0.1-0.2-0.2-0.3-0.3c0.9-0.6,1.7-1.3,2.3-1.7c1.8,0.3,3.3,0.6,4.8,0.9
		c0-0.5,0-1,0-1.4c1.8,0.3,3.3,0.6,5.1,1c-2.1,1.2-3.9,2.3-5.9,3.4c10.2-0.3,20.4-0.7,30.5-1c0,0.3,0,0.5,0,0.8
		c-12.4,0.6-24.8,1.2-37.3,1.8c-0.1,0.8-0.2,1.4-0.2,2c-0.2,7.2-0.1,7.3,7.3,7.6c3.2,0.1,6.4-0.2,9.6,0c2.3,0.2,4.6,0.9,6.8,1.4
		c1.8-3.1,1.8-3.1,3.8-2.8l0.1-0.1c0,0,0,0,0,0.1c0.9,0,1.8,0.1,2.7,0.1c-0.4,0.5-0.7,1-1.1,1.5c0.7,2.2,1.9-0.9,3,0.7
		c-0.9,0.5-1.7,1.3-2.5,1.3c-5.1,0-10.3-0.4-15.4-0.3c-2.9,0-6-1.3-8.8,1c-1.2-2.4-3.6-1.6-5.6-2l0,0c-1.5,0.2-3.1,0.8-4.6,0.6
		c-8.3-1-16.5-2.4-24.7-3.3c-7.9-0.9-15.9-1.3-23.9-1.9c-4.2-0.3-8.4-0.7-12.6-0.9c-4-0.1-8,0.2-12,0c-7.3-0.4-14.5-1.1-21.7-1.7
		c-1.5-0.1-2.9-0.5-4.4-0.7c0-0.2,0-0.4,0-0.6c1.2-0.1,2.5-0.2,3.7-0.4c-2.1-0.3-4.2-0.3-6.2-0.3c-4.5,0-9,0-13.6-0.2
		c-14.1-0.6-28.2-1.3-42.3-2c-1.3-0.1-2.6-0.6-3.8-0.9c0,0,0,0-0.1,0c-2.4,0.3-4.8,0.5-7.2,0.8c2.6,0.3,5.2,0.1,7.8,0.4
		c4.8,0.5,9.5,1.1,14.3,1.7h0.1c1.2,0,2.3-0.2,3.5-0.1c5.2,0.6,10.2,3,15.6,1.9c0.6-0.1,1.9,0.3,1.9,0.5c0,1.6,1.1,0.9,1.8,0.9
		c3-0.2,6.1-0.8,9.1-0.7c4.6,0.1,9.3,0.6,13.9,0.9c0,0.3,0,0.6,0,0.9c-1.3,0.1-2.5,0.1-4.1,0.2c2.8,0.7,5.2,1.4,7.7,2
		c-0.1,0.3-0.1,0.5-0.2,0.8c-4.1-0.8-8.2-1.7-12.5-2.6c0.4-0.4,0.7-0.6,1.1-1c-4.1,0-7.9,0-11.4,0c3.4,0.9,6.9,1.9,10.6,2.8
		c3.3,0.8,6.5,2.6,10.1,2c0.4-0.1,1,0.2,1.2,0.5c1.2,2.5,2.8,0.9,3.6,0.7c1.3,0.8,2.1,1.2,2.9,1.7c1.6,0.9,3.1,1.9,4.7,2.8
		c0.2-1.4,0.7-2.6,2.4-1.8c1.4,0.7,2.7,1.7,4,2.5c2.5,0.8,5.7,0.4,7.1,3.5c7.8,1.9,10.9,4.2,12.4,9.6c-2.1-1.7-4.5-1.9-6-4
		c-1.7-2.6-2.6-2.7-5-1.9c1.9,3.2,3.8,6.5,5.7,9.7c0.2,0,0.3,0.1,0.5,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1
		c0.1-0.2,0.3-0.4,0.4-0.5c0.1,0.1,0.1,0.1,0.2,0.2c-0.2,0.1-0.4,0.2-0.7,0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0-0.1,0-0.2-0.1
		c-0.2,0-0.4,0-0.6,0c-1.9,0.4-1.3,1.5-0.8,2.7c0.2-0.2,0.4-0.4,0.5-0.6c0.1,0.1,0.2,0.2,0.2,0.2c-0.2,0.2-0.3,0.4-0.5,0.6
		c-1.1,3.6-4.1,5.5-7.1,7.2c-6.2,3.5-12.4,6.9-18.7,10.2c-3.8,2-7.8,3.5-11.8,5.3c0-0.3,0-0.6-0.1-0.9c0,0,0,0,0,0.1
		c0,0.3,0,0.5,0.1,0.8c-0.3,0.3-0.5,0.9-0.8,0.9c-1.6,0-3.2-0.1-4.8-0.2l0,0c-0.7,0.2-1.4,0.5-2.2,0.7l-0.1-0.1
		c-1.2,0.8-2.4,1.6-3.7,2.3c-3.9,2.1-8.7,1.9-12,5.3c-0.3,0.3-0.9,0.2-1.3,0.3c-1.7,0.2-3.3,0.5-5,0.7c1.4-3,2.9-6.2,4.7-9.9
		c-2.3,0-4.2-0.5-5.4,0.1c-2.4,1.1-3.4-0.1-4.6-1.6h-0.1H137c-0.8,0.1-1.6,0.2-2.4,0.4c0-0.3,0.1-0.7,0.1-1c0.8,0.2,1.5,0.4,2.3,0.6
		c0.1,0,0.1,0,0.2,0c0,0,0,0,0,0.1c1.1,0,2.2,0,3.4,0c-0.1,0.1-0.2,0.2-0.3,0.4c0.1-0.1,0.3-0.2,0.4-0.3c1.2,0,2.4,0,3.5-0.1l0,0
		c0.6-0.5,1.2-0.9,1.9-1.5c0.2,4,2.7,1.1,4.2,1.8c0.1,0.6,0.2,1.2,0.3,1.9c0,0,0,0-0.1,0c0,0.5,0.1,1.1-0.1,1.3
		c-1,1-2.2,1.8-3.3,2.6c0.2,0.3,0.4,0.5,0.5,0.8c1.5-0.7,3-1.4,4.5-2.1c0.1,0.3,0.3,0.8,0.8,2.1c0.5-2.7,0.8-4.6,1.2-6.5
		c1-0.4,2-0.7,2.9-1s1.8-0.7,2.7-1c-0.7,1.4-1.7,2.3-2.8,3.1s-2.8,1.2-2.3,3.3c1.2-0.8,2.7-2.2,3.2-1.9c2,1,2.9-0.8,4.3-1.1
		c1.3-0.3,2.6-1.1,3.5-1.6c-0.3-0.2-0.9-0.6-1.4-1c0.1-0.2,0.1-0.5,0.2-0.7c1.7,0,3.4,0,5.2,0c1.3-1.8,2.5-3.6,4-5.7
		c0.2,0.2,0.9,0.9,1.6,1.6c0,0,0,0,0.1,0l0.1,0.1h0.1c0,0,0,0.1,0.1,0.2c-0.1-0.1-0.1-0.1-0.2-0.2h-0.1l0,0
		c-0.4,0.3-0.9,0.6-1.3,0.9c0.1,0.3,0.2,0.5,0.4,0.8c1.6-0.5,3.3-1,4.9-1.5c0.1-0.2,0.1-0.5,0.2-0.7c-2.4-1.1-2.5-2.6-0.8-4.4
		c-1,0.2-1.7,0.5-2.5,0.7c-0.9,0.3-2.4,1-2.8,0.7c-1.8-1.8-4-0.2-5.5-1.1c-0.4,0.8-0.8,1.4-0.8,2.1c-0.2,2-0.9,3.6-3,4.2
		c0,0,0,0.2,0,0.3c0.5,0.1,1,0.3,1.5,0.4c-0.1,0.3-0.3,0.6-0.4,0.8c-0.4-0.4-0.9-0.7-1.3-1.1c-1.6,0.5-3.2,1-4.8,1.3
		c-0.1,0-0.5-1.2-0.7-1.8c1.4-0.3,2.7-1.9,4.2-0.3l0,0c0.9-1,1.7-2,3-3.4c-1.3-0.3-2.2-0.5-3-0.7c-0.4,0.8-0.8,1.6-1.4,2.7
		c-0.8-1.4-1.4-2.3-2-3.3c-5.2,2.2-5.2,2.2-7.8,0.5c0,0,0,0-0.1,0h-0.1c-1.3,0.6-2.6,1.2-3.9,1.8c-0.2-0.3-0.4-0.6-0.6-0.9
		c0.5-0.6,1-1.2,1.5-1.9c0-0.2,0-0.4,0.3-0.5c0-0.1,0-0.1,0.1-0.2c0,0.1,0,0.1-0.1,0.2c-1.9-0.2-3.8-0.5-5.7-0.7c0,0,0,0,0,0.1h-0.1
		c-0.8,0.8-1.7,1.5-2.5,2.3c-0.3,0.7-0.6,1.4-0.8,2c-0.4-0.2-0.7-0.5-1.1-0.7c0.5-0.5,1-1.1,1.5-1.6c0.4-0.9,0.7-1.8,1.1-2.6
		c0.7,0.2,1.3,0.4,1.9,0.6l0,0l0,0c-1.1-1.6,0.1-2,1.3-2.1c1.6-0.1,3.1-0.2,4.7-0.2c0.7,0,1.8-0.2,2,0.2c1.9,2.6,4,1.6,6.1,0.6
		c0.4-0.2,0.9,0.1,1.3,0.1c-1-2.6-3.1,0.1-4.7-1.1c0.9-0.6,1.7-1.2,2.5-1.7c-0.1-0.1-0.1-0.2-0.2-0.4c-6.5,0.8-13,1.6-19.6,2.4
		c1.3,0.2,2.6,0.5,3.9,0.7c0,0.2,0,0.3,0,0.5c-2,0.4-4,0.7-5.9,1.1l0,0c-2.3,2.1-2.8,2.1-4.9,0l0,0c-0.2,0.2-0.5,0.5-0.7,0.7
		c0,0-0.1,0-0.1,0.1c-0.2,0.2-0.3,0.5-0.5,0.7c-1.5,3.1-5,0.6-7.2,3.5c0.2-1.7,0.3-2.4,0.3-3.4c-2.2,0.6-2.4,4.2-5.3,3
		c1.1-1.4,2.2-2.8,3.7-4.8c-2.7,0.7-4.6,1.3-7,1.9c1.4,0.2,2.2,0.3,3.5,0.5c-2.6,1.8-4.3,0.7-5.2-0.2c-3,0.3-5.3,0.4-7.5,0.8
		c-0.7,0.1-1.1,1.3-1.6,2l0,0c0,0,0,0,0,0.1c1,0,2.1,0,3.7,0c-3.1,1.7-3.1,1.8-3.7,0h-0.1l0,0c-1.1,0.8-2.2,1.5-3.3,2.3
		c-0.2,2-1.8,2.1-3.2,2c-0.2,0-0.3-0.9-0.5-1.4c0-0.1,0-0.1,0-0.2c0,0.1,0,0.1-0.1,0.2c-0.9,0.2-1.9,0.5-2.8,0.7
		c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c-2.7,0.3-5.5,1.3-8,0.8c-1.2-0.2-2.4,2.4-3.3-0.1c0,0,0,0-0.1,0.1l0,0
		c-0.7,0.4-1.4,0.9-2.1,1.3c-0.2-0.1-0.3-0.3-0.5-0.4c0.7-1.3,1.5-2.7,2.3-4.2c-0.6-0.5-1.3-1.1-1.9-1.6c-1.4,1.1-2.7,2.1-3.9,3
		c-0.2-0.1-0.3-0.3-0.5-0.4c0.3-0.6,0.6-1.1,1.2-2.3c-1.7,0.7-2.8,1.6-3.7,1.5c-2.7-0.5-3.7,1.1-4.6,3c-0.2,0.4-0.7,0.7-1.5,1.4
		c0-2,0-3.3,0-4.7c-1.9-0.1-3.5-0.3-4,2l0.1-0.1c0,0,0,0,0,0.1c0.2,0.1,0.3,0.1,0.5,0.2c-0.1,0.2-0.3,0.4-0.4,0.6
		c-2.3,0.8-4.5,1.6-7.1,2.5c0.1-1.4,0.1-2.2,0.2-3.1c1,0.2,1.8,0.3,2.6,0.5l0,0h0.1c0.4-0.2,0.9-0.4,1.3-0.6c0,0,0,0,0-0.1
		c-2.7-1-6-1.6-7.7,0.4c-2,2.4-4.7,2.7-7,3.9c-0.9,0.5-1.7,1.4-2.6,1.5c-1.9,0.2-1.4-0.9-0.6-1.9l0,0c0.2-0.2,0.5-0.5,0.7-0.7
		c0.5-0.8,1.1-1.7,1.6-2.5c-1.8,0.6-3.7,1.3-5.8,2c0.4-0.9,0.7-1.5,0.9-2.1l0,0c-2.6,0.3-5.3-0.2-7.7,1.7c-0.8,0.7-2.6,0.6-3.9,0.3
		c-2.8-0.7-5.2-0.4-7.4,1.7c-0.7,0.6-2,0.8-3,0.8C12,228,8.1,227.6,4,227.4c-0.3-1.9,1.2-2.1,2.5-2.3c2.9-0.5,5.7-0.9,8.6-1.4
		c1-1.8,2,0,3-0.1c4-0.2,8-0.7,11.9-1.2c2.3-0.3,4.6-1.2,6.9-1.1c1.5,0.1,3.1,1.4,4.6,0.1c1.9-1.5,4-1.5,6.2-1.4l0.2-0.1l-0.1,0.2
		c1.2,0.3,2.5,0.6,4.3,1.1c-0.8-1.2-1.2-1.7-2-2.8c2.9,0.1,5.2,0.2,7.5,0.3c0,0,0,0,0-0.1c1.7,0,3.3,0,5,0l0,0
		c0.4-0.2,0.7-0.3,1.1-0.5c0.1-0.1,0.2-0.1,0.4-0.2c1.8-2.1,2.4-2.1,3.7-0.1c1.4-0.6,2.8-1.2,4.2-1.8c0.8,0.3,1.6,0.7,2.5,1
		c0.7-0.5,1.4-1,2.1-1.5c0.2,0.3,0.4,0.7,0.5,1c-0.7,0.3-1.5,0.6-2.2,1c2,1.6,6.9,0.7,7.9-1.4c0.4-0.8,1-1.5,1.6-2.1
		c0-0.1,1,0.5,1,0.6c-0.2,0.8-0.5,1.6-0.8,2.8c1-0.2,1.9-0.5,2.8-0.7c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0-0.1,0-0.2
		c0,0.1,0.1,0.2,0.1,0.3l0.1,0.1l-0.1,0.1c0.9-0.1,1.7-0.3,2.7-0.4c-0.7-0.9-1.2-1.6-1.7-2.2c4.1-2,6.8,2.7,10.7,2.3
		c-0.1-0.9-0.2-1.5-0.3-2.4c1.1,0.4,2,1,2.8,0.9c2.8-0.5,5.6-1.2,8.4-1.9c0.7-1.5,1.5-1.1,2.7-0.5c0.7,0.4,2.1,0.6,2.3,0.3
		c1.6-2.3,3.8-1.4,5.9-1.5c2.7-0.1,5.3,0.5,8.1-0.9c1.9-1,4.7-0.3,7.1-0.3l0,0c2.4-1.1,4.8-2.2,7.2-3.2c1.6-0.7,3.1-0.4,4.1,1.1
		c4.3-1.2,8.6-2.4,12.9-3.7c0.1,0-0.1-0.8-0.1-1.2c0,0,0,0-0.1,0.1l0.1-0.1c-1-0.4-1.9-0.9-2.9-1.3c-1.7-0.7-3.3-1.4-5-2.1l0,0
		c-0.3-0.2-0.6-0.4-1-0.6c-0.1-0.1-0.3-0.1-0.4-0.2l0.1-0.1l-0.1,0.1l-0.1-0.1c-0.3-0.1-0.7-0.1-1-0.2c0.1-0.1,0.1-0.3,0.2-0.4
		c0.3,0.2,0.5,0.4,0.8,0.6c0.1,0,0.1,0,0.2,0c0.1,0.1,0.2,0.1,0.3,0.2c0.4,0.1,0.7,0.3,1.1,0.4c1.9,0.5,3.7,1,5.6,1.5l0.1-0.1
		c0,0,0,0-0.1,0.1c1,0.5,1.9,0.9,2.9,1.4c5.1,1.2,10.1,2.4,15.5,3.7c-0.9-1.5-1.5-2.6-2.1-3.7c0-0.1,0-0.1,0-0.2c0,0.1,0,0.1,0,0.2
		c-1.2-0.2-2.5-0.2-3.7-0.6c-2.5-0.9-5-2.1-7.5-3c-1.2-0.4-2.7-0.2-4.2-0.3c-1.5-2.5-4.4-2.6-7.2-3.2c-0.9,0.2-1.8,0.5-2.7,0.7
		c-0.8,0.2-1.5,0.5-2.3,0.7c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.2-0.7,0.5-1,0.7l0,0c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.1-0.9,0.2-1.4,0.3
		c0-0.4,0.1-0.8,0.1-1.2c0.4,0.2,0.7,0.5,1.1,0.7l0.1,0.1c0-0.1-0.1-0.1-0.1-0.1c0.5-0.2,1-0.4,1.4-0.7c0.4-0.2,0.8-0.3,1.3-0.5
		c0.1-0.1,0.2-0.1,0.2-0.2c0,0,0,0.1,0.1,0.1v-0.1c0.8-0.2,1.6-0.4,2.3-0.6c0.9-0.3,1.7-0.5,2.6-0.8c-2.9-1.2-5.7-3.1-9.1-2.1l0,0
		c0.1,0,0.2,0,0.2,0.1v0.2c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1,0l0,0c-0.7-0.4-1.5-0.7-2.2-1.1c0.1-0.3,0.3-0.7,0.4-1
		c2.5,0.6,4.9,1.1,7.4,1.7c2.1,0.5,4.3,1.3,6.3-0.3c-0.4-0.2-0.9-0.4-1.3-0.6c0,0,0,0,0.1,0.1c-1.4-0.4-2.8-0.8-4.1-1.2
		c0.1-0.2,0.1-0.4,0.2-0.6c0.8-0.3,1.6-0.6,2.4-1c-0.3-0.2-0.6-0.4-0.9-0.5c-0.2-0.1-0.3-0.1-0.5-0.2c-0.5-0.2-0.9-0.5-1.4-0.7l0,0
		c-0.8,0.1-1.7,0.4-2.4,0.2c-3-0.7-5.9-1.4-8.9-0.3c-0.9,0.3-1.7,0.5-2.5,0.6c1.1,0.4,2.3,0.7,3.4,1.1c-0.2,0.5-0.4,1-0.5,1.5
		c-1.1-0.5-2.3-1-3.4-1.4c0.1-0.4,0.3-0.8,0.4-1.2c-3.4,0.3-6.3-1.4-9.2-3.3c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0-0.1
		c-2.8-0.9-5.6-1.8-8.4-2.6c0.1-0.2,0.1-0.3,0.2-0.5c2.9,0.5,5.9,1.1,8.8,1.6c1.2-0.4,2.4-0.8,3.8-1.2c-1.3-0.5-2.5-1-3.7-1.4
		c-3.3-1.2-6.7-2.5-10-3.7l0.2-0.1h-0.1c-1.1,0-2.3,0.1-3.4,0.1v0.1c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0-0.2,0-0.2,0V177
		c0,0-0.1,0-0.1-0.1l0.1-0.1c-4-2.5-5.2-2.5-7.8,0.1c0.8,0.2,1.5,0.4,2.3,0.5c1.1,0.5,2.2,1.1,3.3,1.6v0.1V179
		c0.7,0.2,1.4,0.4,2.2,0.7l0.1,0.1c0.3,0,0.6,0.1,0.9,0.1c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2-0.2-0.5-0.4-0.7-0.6c-0.1,0-0.1,0-0.2,0
		c-0.7-0.2-1.4-0.5-2.2-0.7c-1.1-0.5-2.2-1.1-3.3-1.6c-0.8-0.2-1.5-0.4-2.3-0.5l0.1-0.1c-0.7-0.2-1.4-0.5-2-0.7l0.1-0.1l-0.1,0.1
		c-2.7-0.6-5.4-1.3-8.1-1.9c-1.4-0.3-2.8-0.7-4.2-1c0,0.2-0.1,0.3-0.1,0.5c1.9,0.8,3.9,1.6,5.8,2.4c0.1,0,0.2,0,0.2,0s0,0,0,0.1
		c0.6,0.2,1.3,0.4,1.9,0.6c0.1,0,0.1,0,0.2,0v0.1v-0.1c0.7,0.2,1.4,0.5,2.1,0.7c0,0,0,0,0.1,0c1.1,0.2,2.3,0.4,3.4,0.7
		c-0.1,0.3-0.2,0.6-0.2,0.8c-1.1-0.5-2.1-1-3.2-1.5c0,0,0,0-0.1,0c-0.7-0.2-1.4-0.5-2.1-0.7c-0.1,0-0.1,0-0.2-0.1
		c-0.6,0-1.3,0-1.9,0c0,0,0,0,0,0.1l0,0l0,0c0,0,0,0-0.1,0c0,0.2,0,0.4,0,0.7l0,0c0.5,0.2,1,0.4,1.6,0.5c0.3,0.3,0.7,0.5,1,0.8
		c0.1,0,0.2,0.1,0.3,0.1v0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.4-0.2-0.8-0.3-1.2-0.5c-0.5-0.3-0.9-0.5-1.4-0.8l0,0l0,0
		c-0.5,0-1-0.1-1.5-0.1c0-0.2,0-0.4,0-0.5c0.5,0,1,0,1.5,0c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.2,0-0.4,0-0.6c0,0,0,0-0.1,0l0,0
		c-0.1,0-0.1-0.1-0.2-0.1c-2.4-0.2-4.9-0.4-7.7-0.7c1.8,1,3.2,2,4.8,2.7c4.1,1.9,8.3,3.8,12.4,5.6c-0.1,0.1-0.2,0.2-0.3,0.3
		c0.1-0.1,0.2-0.2,0.3-0.3c0.5,0.2,1,0.5,1.4,0.7c1.2,0.4,2.4,0.8,3.7,1.1c1.3,0.3,2.6,0.4,3.9,0.5c0,0,0,0,0-0.1
		c0.2-0.2,0.5-0.4,0.7-0.7l0.1-0.1l-0.1,0.1l0,0c-0.2,0.2-0.5,0.5-0.7,0.7l0,0c0.5,0.7,1,1.4,1.4,2.1c2.4,0.9,4.8,1.8,7.2,2.7l0,0
		c0.4,0.2,0.7,0.5,1.1,0.7c0.1,0,0.2,0.1,0.2,0.1c0.2,0.2,0.5,0.5,0.7,0.7l0,0c0,0.1,0.1,0.2,0.1,0.3c0-0.1-0.1-0.2-0.1-0.2
		c-0.2-0.2-0.5-0.5-0.7-0.7l0,0l0,0c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.2-0.9-0.3-1.3-0.5c-2.3-1-4.6-2-7-3c-3.1-1.1-6.2-2.2-9.4-3.3
		c0.1-0.1,0.2-0.2,0.3-0.4c-0.1,0.1-0.2,0.2-0.3,0.4c-0.5-0.2-1-0.5-1.4-0.7c-0.6-0.1-1.3-0.1-1.9-0.2l0,0c-0.5,0.3-1.2,0.8-1.6,0.7
		c-2.3-1.1-4.6-2.3-6.9-3.5l0,0c-0.6-0.1-1.3-0.2-1.9-0.4c0.7-2.6-1.4-1.4-2.3-1.8c0,0.2,0,0.4-0.1,0.6l0,0c0,0,0.1,0,0.1,0.1
		c0.4,0,0.7,0,1.1,0c-0.1,0.2-0.1,0.4-0.2,0.5c-0.3-0.2-0.6-0.4-0.9-0.5h-0.1c0,0,0,0,0-0.1c-1.2-0.4-2.3-0.8-3.5-1.1
		c0,0.3,0,0.5,0,0.8c-0.3,0.1-0.6,0.1-1,0.2c0-0.3,0-0.5,0-0.7c-0.9-0.3-1.5-0.3-1.9-0.1c-0.3,0.2-0.6,0.5-0.9,1.1
		c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.1-0.9,0.3c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.1,0.1,0.2,0.1
		c5,0.8,9.4,2.7,13.7,5.1c-0.1,0.3-0.2,0.6-0.4,0.9c-4.6-1.9-9.1-3.8-13.7-5.7c-0.1,0-0.1,0-0.2-0.1c0,0.1-0.1,0.1-0.1,0.2
		c-0.1,0.5-0.3,0.6-0.8,0.9c-0.5,0.3-0.7,0.7-0.7,1.2c0.3,0.1,0.6,0.3,0.9,0.4c0.9-0.3,1.8-0.3,2.5,0.4l0,0c0,0,0,0,0.1,0.1h-0.1
		c0,0,0,0-0.1,0c-0.4,0.1-0.9,0-1.3,0.1c1.3,0.5,2.5,1,3.8,1.5c-0.1,0.3-0.3,0.6-0.4,0.9c-1.3-0.7-2.5-1.3-3.8-2
		c-0.2-0.1-0.3-0.1-0.5-0.2c-0.1,0.1-0.3,0.1-0.4,0.2l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.1-0.2-0.2-0.3-0.4-0.5
		c-1.4-0.5-2.7-1-4.1-1.6h-0.1l-0.1-0.1c-0.9-0.4-1.8-0.7-2.8-1.1c-0.3,0.1-0.5,0.3-0.8,0.5c-0.5,0.5-0.8,1.1-1.8,0.8
		c0,0.1,0.1,0.3,0.1,0.4c0.6,0.2,1.2,0.5,1.7,0.7c0.1,0,0.1,0,0.2,0l-0.1,0.1c0.2,0.1,0.4,0.2,0.6,0.2c0.6,0.2,1.1,0.5,1.7,0.7
		c0.1,0,0.2,0.1,0.3,0.1c0.5,0.2,1,0.5,1.4,0.7c0,0-0.1,0.1,0,0.1l0.1-0.1c0.7,0.3,1.3,0.5,2,0.8c0.1,0,0.2,0,0.3,0
		c-0.1,0-0.2,0-0.4,0c-0.7-0.2-1.3-0.5-2-0.7c-0.5-0.2-0.9-0.5-1.4-0.7l0,0l0,0c-0.1,0-0.2-0.1-0.3-0.1c-0.6-0.2-1.2-0.4-1.8-0.6
		c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6
		c-0.4-0.5-0.7-1-1.1-1.6c-0.3-0.4-0.6-0.8-1.1-1.1c-0.8,0.1-1.5,0-2.1-0.3c-0.5-0.2-0.9-0.5-1.3-0.9c-0.5,0.4-0.9,0.8-1.3,1.2
		c0-0.8,0.3-1.4,1-1.9c-1.6-0.6-3.2-1.3-4.8-1.9c0.1-0.1,0.2-0.3,0.4-0.4c-0.1,0.1-0.3,0.3-0.4,0.4c-0.5-0.3-0.9-0.5-1.4-0.8
		c-0.9-0.5-1.9-1-2.8-1.4c-0.8-0.3-1.7-0.6-2.5-0.9c0.1-0.3,0.3-0.5,0.4-0.8c0.8,0.5,1.6,1,2.3,1.5c1,0.4,2,0.8,3,1.2
		c-0.1,0.1-0.2,0.3-0.4,0.4c0.1-0.1,0.2-0.3,0.4-0.4c0.5,0.3,0.9,0.5,1.4,0.8c1.7,0.8,3.4,1.6,5.1,2.4c0.1-0.1,0.1-0.2,0.1-0.3
		s-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0c-0.2-0.8-0.7-1.4-1.4-1.7c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2
		c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1c0.1-0.1,0.2-0.3,0.4-0.4c0.1-0.1,0.3-0.2,0.5-0.3s0.5-0.2,0.8-0.3
		c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7c1.1,0.2,1.4-0.7,2.2-1.1c-0.2-0.1-0.4-0.3-0.7-0.4c-0.9,0-1.9,0.1-2.8,0.1
		c0.1,0.1,0.1,0.2,0.2,0.3c-0.3,0.5-0.7,0.9-1.4,0.9h-0.1c-0.4,0-1,0.4-1.4,0.7c-0.5,0.4-1.1,0.6-1.4,0.2c-0.7-0.8-1.8-1.1-2.8-1.3
		c-2.3,0.4-4.6,0.4-6.8,0.6c-1.5,0.3-3,0.6-4.5,0.9c0-0.4-0.1-0.8-0.1-1.1c1.5,0,3,0,4.4,0c0.4-0.4,0.8-0.7,1.8-1.6
		c-5.2,0.5-9.6,0.9-14.1,1.3c0,0.2,0.1,0.3,0.1,0.5c2.6,1.1,5.1,2.2,7.7,3.3c0.1,0,0.3,0.1,0.4,0.1c0.7,0.2,1.4,0.5,2.1,0.7v0.1
		v-0.1c2.6,0.9,5.2,1.9,7.8,2.8c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.7,0.3,1,0.4c1.1,0.5,2.2,0.9,3.4,1.4h0.1
		c0.3,0.1,0.6,0.3,0.8,0.4c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0c0.1-0.1,0.2-0.1,0.3-0.2c-0.3-0.1-0.5-0.3-0.8-0.4c0,0-0.1,0-0.1-0.1
		c-1.2-0.4-2.3-0.9-3.5-1.3l0,0c-0.3-0.2-0.6-0.4-0.9-0.6c-0.2-0.1-0.3-0.1-0.5-0.2l0,0c-2.6-1-5.2-1.9-7.8-2.9
		c-0.7-0.2-1.4-0.5-2.2-0.7l0,0l0,0c-0.1-0.1-0.2-0.1-0.4-0.2c-3.1-0.7-6.1-1.4-9.2-2c-0.3,0.9,0,1.8,0.8,2.7c-0.2,0-0.4,0-0.6,0
		c0.1,0,0.1,0,0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.2c0.4,0.1,0.7,0.3,1.1,0.4c1.9,0.7,3.8,1.4,5.7,2.1l0,0c0.4,0.3,0.8,0.5,1.2,0.8H43
		l0,0c0.1,0,0.1,0.1,0.2,0.1c2.7,0.9,5.4,1.7,8.2,2.6c-0.1,0.4-0.3,0.7-0.4,1.1c-2.6-1.2-5.2-2.5-7.7-3.7c-0.1,0-0.1,0-0.2-0.1
		c0,0-0.1,0-0.1-0.1c-0.5-0.2-1-0.3-1.5-0.5c-1.8-0.8-3.7-1.5-5.5-2.3l0,0l0,0c-0.3-0.2-0.6-0.4-1-0.6c-0.2-0.1-0.3-0.1-0.5-0.2
		l0.1-0.1l-0.1,0.1c-0.1,0-0.2-0.1-0.3-0.1c-0.9,0.1-1.7,0.3-2.3,0.7c0.1,0,0.3,0.1,0.4,0.1c5,2,9.9,4.1,14.9,6.2
		c2.9,1.2,5.8,2.6,8.6,3.9c0.7,0.3,1.2,1,1.8,1.5c-1,0.2-1.6,0-2.3-0.3c-9.1-3.6-18.2-7.1-27.4-10.7c-0.1,0.2-0.1,0.4-0.1,0.6l0,0
		c0,0.3,0.2,0.6,0.5,0.9c0.7,0.5,1.3,0.1,1.8-0.4c0.1,0.4,0.1,0.7,0.3,1.1c0.1,0.3,0.2,0.7,0.4,1c0.1,0.3,0.3,0.6,0.6,0.9
		c0.8,0.3,1.5,0.6,2.3,0.9c0,0,0,0,0.1,0l0,0c2.8,1.3,5.7,2.7,8.5,4c0.2,0.1,0.4,0.1,0.7,0.2l-0.1,0.1l0.1-0.1l0.1,0.1
		c0.2,0.1,0.4,0.2,0.7,0.3c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.4-0.2-0.6-0.3
		c-2.9-1-5.7-1.9-8.6-2.9c-0.1,0.2,0.2,0.4,0.3,0.7c0.1,0.2,0.1,0.3,0.1,0.5c0,0.4-0.1,0.7-0.9,0.9c-0.3-0.6-0.8-1.1-1-1.7
		c-0.2-0.5-0.4-0.8-0.6-1.1c-0.5-0.1-0.9-0.3-1.4-0.4c0,0,0,0-0.1,0c0,0,0,0,0-0.1c-0.3-0.1-0.6-0.2-0.8-0.3c-0.5,0.1-1,0.3-1.6,0.6
		c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.2-0.3-0.3-0.5c-0.2-0.3-0.3-0.5-0.5-0.8c0-0.1-0.1-0.2-0.1-0.3c-0.6-0.2-1.1-0.4-1.7-0.6
		c-0.1,0-0.2,0-0.3,0c-0.5,0-0.9-0.1-1.3-0.4c-0.2-0.1-0.3-0.2-0.4-0.4c-0.3-0.1-0.6-0.2-0.8-0.3c-0.2,0.5-0.2,1.1,0.2,1.7
		c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.1-0.4,0.2-0.6,0.3c-0.1-0.3-0.2-0.5-0.3-0.9c-0.3-0.1-0.8-0.1-1.3-0.2c-0.4,0.8-1,1.3-1.7,1.8
		c-0.2,0.1-0.4,0.3-0.6,0.4c2.8,0.9,5.6,1.7,8.4,2.6c0.5,0.2,1.1,0.4,1.6,0.6c0.2,0,0.3,0.1,0.5,0.1v0.1v-0.1c0.1,0,0.1,0,0.2,0.1
		c0.9,0,1.8,0,2.7,0l-0.1-0.1c0,0,0,0,0.1,0c-0.1-0.2-0.1-0.4-0.2-0.6c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.1-0.2-0.2-0.4-0.3-0.6c0.2,0.1,0.5,0.2,0.7,0.3c0.4,0.3,0.8,0.6,1.2,0.9h0.1l0,0c3.2,1.2,6.5,2.4,9.7,3.6
		c-0.1,0.4-0.3,0.7-0.4,1.1c-2.9-1.1-5.8-2.2-8.7-3.3l0,0c-1.6-0.5-3.1-0.9-4.7-1.4c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.1-0.5-0.2
		c-0.6-0.1-1.2-0.3-1.8-0.4c-3-0.7-6.1-1.4-9.1-2c-0.2,0.2-0.5,0.5-0.6,0.7c-0.4,0.7-0.5,1.6-0.6,2.3c0,0.3,0.1,0.7,0.2,1
		c0,0.1,0.1,0.2,0.1,0.3c0.2,0.8,0.6,1.4,1.3,1.9c0.4,0.3,0.8,0.5,1.3,0.7c-0.1,0.3-0.2,0.6-0.4,1c-0.2-0.3-0.4-0.5-0.6-0.7
		c-0.5,0.4-0.4,0.7-0.3,1.1c0.1,0.3,0.2,0.6,0.1,0.8c-0.3,0.1-0.5,0.3-0.7,0.4c-0.1,0.1-0.2,0.1-0.3,0.2l0,0h-0.1
		c-0.1,0.1-0.2,0.1-0.3,0.2c0-0.1-0.1-0.3-0.1-0.4c0-0.1,0-0.2-0.1-0.3c0-0.2-0.1-0.4-0.1-0.5c-0.1-0.5-0.1-0.9-0.7-1.1
		c-0.2-0.1-0.3-0.4-0.4-0.6c-0.4-0.6-0.6-1.2-1.1-1.7c-0.2-0.2-0.4-0.4-0.5-0.5s-0.2-0.2-0.4-0.3c-0.2-0.2-0.5-0.3-0.7-0.3
		c-0.7-0.2-1.4-0.1-2.5,0.3c-0.3,0.1-0.5,0.2-1.1,0.4c0.3-1,0.1-1.6-0.8-2.2c-0.1,0.3-0.1,0.5-0.2,0.7c-0.3,0.9-0.4,1-1.4,0.9
		c-0.3,0-0.7-0.1-1-0.1c-0.5-0.1-1-0.4-1.2-1.1c-0.2,0.5-0.3,0.7-0.4,1c-1,0.3-1.9,0.6-2.7,0.9c-0.3,0.3-0.3,0.7-0.6,1v0.3v6.7
		c1.1,0.6,2.2,1.1,3.2,1.7c0-0.1,0.1-0.3,0.3-0.7c0.7,0.1,1.5,0.3,2.1,0.4c0.4,1,0.2,2.1,1.1,3.1c0.3-1.1-1.2-1.7-0.1-2.8
		c0.9,0.2,2.2-0.4,3,0.7c0,0.1,0.1,0.1,0.1,0.2c0,0-0.1,0-0.1,0.1c-0.6,0.3-1.2,0.7-1.9,1.1c0,1-0.1,2.1-0.1,3.2c0,0.1,0,0.1,0,0.2
		c-0.5,0-1.1,0-1.6,0c-0.6,0-1.3,0-1.9,0c0-0.4,0.1-0.8,0-1.2c-0.1-0.5-0.7-0.7-1.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3l0,0c0,0,0,0-0.1,0
		c0,0-0.1,0-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3s-0.1,0.1-0.1,0.2c0,0.1,0,0.1-0.1,0.2c0,0.3,0.2,0.6,0.5,0.8c0.6,0.4,1.2,0.6,1.9,0.4
		c0.1,0.8,0.5,1.2,1.2,1.4c0.3,0.1,0.7,0.1,1.1,0c-0.1,0.4-0.2,0.7-0.3,1c-0.3,0.6-1,0.7-2.3,0.4c-0.2,0.2-0.3,0.3-0.4,0.4
		c-0.2-0.4-0.6-0.7-1-1c-0.8-0.2-1.5-0.5-2-0.9v2.5v2.1v0.7v3v82.1c0.5,0.3,1.1,0.6,2,0.2c1-0.4,1.2-1.2,1.2-2c0.7-0.3,1.3-0.6,2-1
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.2,0.1,0.4,0.1,0.6c-0.1,0.1-0.2,0.2-0.4,0.4c-0.1,0.1-0.2,0.3-0.3,0.5c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.2,0.7,0,1.6,1.2,1.8
		c0.1,0,0.1,0.3,0.1,0.4v0.1c0,0.6,0.3,1.1,1.1,1.2c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.2,0.3-0.3
		c0.3,0.1,0.6,0.1,0.9,0.1c1.2,0,2-0.7,2.7-1.5c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0
		c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6
		c-0.1,0.2,0.8,0.1,0.9,0.7c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3
		c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3s0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.8,0.2
		c0.1,0,0.2-0.1,0.3-0.1c0.2-0.1,0.4-0.2,0.6-0.3c0.3-0.1,0.6-0.2,0.9-0.3c0.1-0.1,0.3-0.2,0.4-0.3c0.3-0.2,0.6-0.4,1.1-0.5
		c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7
		c0.2-0.4,0.6-0.7,0.6-0.9c-0.1-0.3-0.1-0.6-0.1-0.9c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.1,0.1-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5
		c-0.3-0.1-0.6-0.2-1-0.2c0.5-0.2,0.8-0.5,1-0.8c0.5-0.5,0.8-1,1.6-1.1c0,0.4-0.1,0.8-0.2,1.2c0.2,0,0.4-0.1,0.6-0.2
		c0.4-0.2,0.7-0.4,1-0.7c0.3-0.3,0.6-0.6,0.9-0.8c1.8,1.8,1.8,1.8,4.5,1.3c0.1,0,0.3-0.1,0.4-0.1c0.3-0.1,0.6-0.3,0.9-0.5
		c0.1,0,0.1-0.1,0.2-0.1h0.1c0.4-0.2,0.9-0.5,1.6-0.1c-0.6,0.4-1.1,0.8-1.7,1.3c-0.1,0.1-0.1,0.1-0.2,0.2c0.4,0.5,0.8,1.1,1.4,1.5
		c7.1-0.4,12.7-4.2,19.4-4.4c-1.1,1.1-2.4,1.8-3.7,2.3c-3.3,1.3-6.8,2.3-10,3.8c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.6,0.4,1.3,0.2,2
		c-0.7,0-1.3,0.1-1.8,0.2c0.8,0,1.5,0,2.3,0c0,0,0,0,0.1-0.1c0.1,0,0.1,0,0.2,0c0.3-0.2,0.6-0.3,0.9-0.5c0,0.1,0.1,0.3,0.1,0.4
		c-0.4,0-0.7,0-1.1,0c0,0-0.1,0-0.1,0.1h-0.1c-0.3,0.3-0.6,0.8-1,0.9c-0.5,0.1-1-0.2-1.5-0.3c0-0.2,0-0.4,0.1-0.6
		c-1.1,0.3-1.7,0.9-1.9,1.8c-0.1,0.6,0,1.1,0.4,1.5c0.1,0,0.2,0,0.2,0c0.8-0.2,1.6-0.5,2.3-0.7c0.1,0.1,0.2,0.2,0.3,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.3c3-0.6,6.1-1.1,9.1-1.7c0.5-0.1,1.1-0.2,1.6-0.4c0.1,0,0.1,0,0.2,0c0.9-0.3,1.7-0.5,2.6-0.8
		c0,0.3,0.1,0.6,0.1,0.9c-0.9,0-1.8-0.1-2.7-0.1c-0.1,0-0.1,0-0.2,0.1c-0.5,0.1-1.1,0.2-1.6,0.3c-2.9,0.7-5.9,1.3-8.8,2
		c-0.9,0.1-1.7,0.3-2.6,0.4c-0.1,0-0.1,0-0.2,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4
		c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2
		c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.2,0.1,0.2,0.1c0.8,0,1.6-0.1,2.4-0.1
		c3.1,0,6.2,0.1,9.3,0.1c0-0.2-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0
		c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7
		c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6c0-0.8,0.9-1.5,0.9-2.4c0.6,0.1,1,0.2,1.5,0.3c0.1,0,0.1,0,0.2,0
		c0.2-0.7,0.4-1.4,0.4-2c0-0.3,0-0.6,0-0.9s-0.1-0.7-0.1-1c0.1-0.1,0.1-0.2,0.2-0.3c-0.5,0.2-0.9,0.3-1.4,0.5c0-0.3-0.1-0.6-0.1-0.8
		c0.6,0,1.2,0,1.8,0c0.1-0.1,0.1-0.2,0.2-0.2c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8c0.1,0.1,0.1,0.1,0.2,0.2l0,0
		c2.7-0.6,5.3-1.5,8-2.1c-0.2-0.2-0.4-0.4-0.5-0.7c-0.1-0.2-0.2-0.3-0.4-0.4c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.2,0.1-0.4,0.3-0.6,0.5
		c0.3,0.1,0.6,0.1,0.9,0.2c0,0.1,0,0.2,0,0.2c-3.1,0-6.2,0-9.3,0c0-0.3,0-0.7,0-1c1.3-0.1,2.5-0.1,3.8-0.2l-0.1-0.1
		c0.1,0,0.2,0,0.3,0c0.6-0.3,1.1-0.6,1.7-0.7c1.3-0.2,2.7-0.4,4-0.6c0.7-0.2,1.3-0.6,1.5-1.3c0-0.1,0.4-0.1,0.6-0.2
		c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2l0,0c-0.3,0-0.5-0.1-0.8-0.1c0.9-0.8,1.7-1.3,2.5-1.6
		c0.1-0.1,0.2-0.3,0.3-0.4c0.3-0.5,0.7-0.8,1.4-0.9c0.4,0,0.9-0.5,1.4-0.8c0.1,0.4,0.3,0.9,0.4,1.5c-0.1,0-0.2,0.1-0.2,0.1
		c0.4,0,0.9,0,1.3,0c1.2-0.1,2.4-0.2,3.6-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.1,0,0.2,0,0.2,0c0.6-0.3,1.2-0.7,1.9-0.8
		c5.9-0.7,11.9-1.3,17.9-2c-0.2-0.2-0.2-0.4-0.1-0.7c0-0.1,0-0.1,0.1-0.2c-0.6,0-1.2-0.1-1.8-0.1c-0.5,0.5-0.9,1-1.6,1.3
		c-0.1-0.3-0.2-0.6-0.3-0.9c-0.1-0.2-0.1-0.3-0.2-0.5c-3.7-0.2-7.4-0.4-11.2-0.6c0-0.3,0-0.5-0.1-0.7c2.8-0.4,5.5-0.8,8.3-1.2
		l0.1-0.1c0.1,0,0.2,0,0.3,0l-0.1-0.1c-0.8-0.8-0.5-1.4,0.2-2.2c-0.3-0.2-0.5-0.3-0.8-0.5c-0.2,0.4-0.3,0.8-0.6,1
		c-0.9,0.4-1.9,0.7-2.8,1.1c-0.1-0.3-0.2-0.5-0.2-0.6l0,0c0.1-0.6,0.1-1.2-0.2-1.7c-0.2-0.3-0.6-0.6-1.2-0.7c-0.1,0-0.2-0.1-0.3-0.2
		c-2.1,0.9-4.4,1.5-6.6,2.3c-0.1-0.3-0.3-0.7-0.4-1c1.4-0.5,2.9-1.1,4.3-1.6c-0.4-0.1-0.9-0.1-1.3-0.1c-0.2,0-0.3,0-0.5,0
		c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0,0.7,0c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3
		c-0.5,0.1-0.9,0.4-1.3,0.6c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0
		c0.3-0.2,0.5-0.4,0.7-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.5-0.3,0.9-0.5c-0.5-0.1-0.8-0.2-1.1-0.3c0.4-0.5,0.1-1.2,1-1.7
		c0.2,0.4,0.3,0.7,0.6,1c0.7,0.8,2,0.9,2.7,0.1s1.5-1.1,2.5-1.6c0.5,0.5,0.9,1,1.4,1.5c-0.6,0.8-1.9,1.3-1.7,2.4
		c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.6,0.4,1.3,0.6,2.3,0.3h0.1c0.8-0.3,1.7-0.6,2.5-1c0-0.1,0.1-0.1,0.1-0.1
		c0.1,0,0.1,0,0.2,0c1.1-0.5,2.1-1.1,3.2-1.6c1.5-1.1,3-2.1,4.5-3.2c2.1-1.7,4.5-2.4,6.8-1.6c-3,1.9-5.9,3.8-8.9,5.7
		c0.3,0.2,0.5,0.3,0.8,0.5c-0.1,0.1-0.2,0.2-0.2,0.2c-0.3-0.1-0.5-0.3-0.8-0.4c-0.4-0.1-0.8-0.2-1.2-0.2c0,0,0,0,0.1,0.1l-0.1-0.1
		c0,0.6,0.1,1.6-0.2,1.8c-0.2,0.1-0.4,0.2-0.5,0.3c0.3,0.3,0.8,0.5,1,0.4c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3
		c0.1,0,0.1,0.4,0.1,0.5c-0.1,0.4-0.1,0.7,0,1c2.5-0.2,5-0.4,7.5-0.7c0.5-0.4,1-0.8,1.6-1.1c0.4,0.3,0.7,0.6,0.9,0.9
		c0.5,0,1-0.1,1.5-0.1c0-0.1,0-0.3,0-0.4c0.1-1.4,0.7-1.5,2.9-2c1.1-0.3,2.2-0.5,3.4-1.1c-0.4,0-0.8,0-1.3-0.1c0-0.1-0.1-0.2,0-0.2
		c0.4-0.3,0.8-0.6,1.2-0.9c1.3,1,1.9,1.1,2.6,0.5c0.7-0.7,0.4-1.1-1-2c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0
		c0.1-0.1,0.3-0.2,0.4-0.3c1-0.9,1.1-1.1,2.1-0.8c0.2,0,0.4,0.1,0.6,0.2c1.3,0.4,2.5,0.2,3.6-0.7c1-0.8,1.3-2,0.8-3
		c-0.4-0.9-1.2-1.3-2.3-1.5c-0.3-0.1-0.9,0-1-0.2c-0.1-0.3-0.2-0.5-0.4-0.6c-0.3-0.3-0.8-0.4-1.3-0.5c-0.2,0-0.3,0-0.5-0.1
		c-0.3,0.2-0.5,0.3-0.8,0.5c-0.9,0.4-1.8,0.8-2.6,1.2c-0.1-0.2-0.2-0.5-0.3-0.7c0.8-0.3,1.7-0.6,2.5-0.9l0,0c0.3-0.2,0.7-0.3,1-0.5
		c0.3-0.8,1.4-1.2,2-2c-0.5,0.1-0.9,0.2-1.3,0.3c-0.4-0.3-0.7-0.7-0.8-1l0,0l0,0c-1.9,1-3.8,1.9-5.7,2.9l0,0c-2.1,1-4.2,1.9-6.3,2.9
		c-0.1-0.3-0.3-0.6-0.4-0.9c2.3,1,1.2-4.6,4.5-1.6c1.2-1.4,1.9-3.7,4.6-2.8c0.4,0.1,1-0.8,1.6-1.2c0.3-0.3,0.7-0.5,1-0.7h-0.1
		c-0.3-0.1-0.6-0.2-0.9-0.4c-0.6-0.3-1.2-0.6-1.5-1.3l0.1-0.1c0.4-0.3,0.7-0.6,1.1-0.9l0,0c0.2-0.2,0.5-0.4,0.7-0.6
		c-0.2-0.2-0.5-0.3-0.8-0.5c-0.2-0.1-0.4-0.3-0.5-0.5c0-0.1,0-0.1-0.1-0.2c-0.2-0.4-0.1-0.9-0.2-1.5c0.9,0.2,1.5,0.5,2.2,0.5
		s1.5-0.2,2.1-0.5c0.1,0,0.2-0.1,0.3-0.1c0.2-0.2,0.2-0.3-0.3-0.5c0-0.2,0-0.4,0.1-0.8c0.1,0.1,0.3,0.1,0.4,0.2
		c0.4,0.2,0.9,0.3,1.2,0.5c0.6,0.3,1.1,0.7,1.3,1.4c-0.5,0.2-1,0.3-1.4,0.5c-0.5,0.2-0.8,0.6-0.4,1c0.3,0.4,0.2,0.6-0.1,1
		c-0.1,0.2-0.2,0.4-0.3,0.5c0.2-0.1,0.3-0.2,0.5-0.3c1.8-0.8,3.1-3.4,5.7-1.7v-0.1c2.6-1.1,5.2-2.3,7.8-3.4c0.1,0,0.1,0,0.2,0
		c-0.1,0-0.1,0-0.2-0.1c1.4-0.3,2.8-0.5,4.2-0.8c0.6-3.2,3.5-3.2,5.8-4.1l-0.1-0.1h0.1c4.9-2.6,9.8-5.2,14.6-7.8
		c-0.6,0-1.1-0.1-2.2-0.2c4.7-2.3,8.9-4.2,13.1-6.3c2.6-1.3,4.3-4.1,7.5-4.2c-0.7-1.1-0.6-1.8,0.8-2l0,0c0.2,0,0.3,0,0.5,0.1
		c0.1,0,0.2,0,0.3,0v0.1c0.4-0.1,0.7-0.2,1.1-0.3l0.1-0.3l0,0c-0.1-0.2-0.3-0.4-0.4-0.5c0.3,0,0.5,0.1,0.8,0.1
		c0.4-0.4,0.8-0.8,1.3-1.2l0,0h0.1c3-2.4,6-4.7,9-7.1c3.5-2.8,4.8-6.5,3.9-10.7c0-0.2,0.3-0.4,0.4-0.6c0.3-0.9,0.6-1.8,0.8-2.6l0,0
		l0,0l0,0h0.1c-0.2-0.7-0.4-1.4-0.6-2.1l0,0c0.3-2.6,0.8-2.8,3.6-2c-0.5,1.1-1,2.2-1.6,3.3l0,0l-0.1,0.1l0.1-0.1l0.1,0.1
		c0.1,0,0.1,0,0.2,0c0,0,0,0.1,0.1,0.2c-0.1-0.1-0.1-0.2-0.2-0.2H218l0,0c-0.5,0.3-1,0.5-1.4,0.8c0,0,0,0,0,0.1c1,0.7,1.9,1.4,2.9,2
		l0,0c0,0,0-0.1,0.1-0.1c0-0.2,0-0.3,0-0.5c0,0,0,0-0.1-0.1l-0.1-0.1h-0.1c-0.1,0-0.1-0.1-0.1-0.2c0.1,0.1,0.2,0.1,0.2,0.2
		c0.1,0,0.1,0,0.2,0v0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.1,0,0.2c0,0,0,0-0.1,0c-3.1,2-0.2,3.9-0.2,5.8
		c1.4-0.1,2.5-0.1,3.6-0.2c0,0,0.1,0,0.1-0.1c1.9-0.2,3.8-0.4,5.7-0.6c0.1,0,0.1,0,0.2,0c0.6-0.4,1.3-0.9,1.9-1.3
		c0.1,0.4,0.2,0.7,0.3,1.1c-0.8,0.1-1.5,0.2-2.3,0.3l-0.1,0.1c-1.9,0.2-3.8,0.4-5.7,0.6c0,0-0.1,0-0.2,0c-0.7,0.5-1.4,1.2-2.2,1.2
		c-3.7,0.4-5.3,3.3-7.3,5.8c0.6-0.2,1.3-0.4,1.9-0.6c0.2,0.3,0.4,0.6,0.6,0.9c-2.7,2.1-5.5,4.2-8.2,6.3c-0.9,1.3-1.7,2.6-3.8,1.8
		c0.4-0.6,0.6-0.9,0.8-1.3c0,0,0,0-0.1,0c0,0,0.1,0,0.1-0.1c-0.4,0.1-0.9,0.1-1.3,0.2c-0.7,0.5-1.4,1-2,1.5
		c-0.5,0.6-1.1,1.2-1.6,1.8l0,0l0,0c0,0,0,0,0,0.1c0.2,0,0.4,0.1,0.5,0.1c-0.1,0.2-0.2,0.5-0.3,0.7c-2,1.5-4,3-6.1,4.5
		c-0.8,0.6-1.7,0.7-2-0.5c-3,2.2-6.1,4.3-9.1,6.5l0,0c-0.6,0.5-1.3,1-1.9,1.5l0,0c-0.5,0.2-1,0.4-1.6,0.6c-0.9,0.8-1.8,1.5-2.7,2.3
		c-0.3,0.3-0.6,0.5-0.9,0.8c-0.1-0.1-0.2-0.3-0.3-0.4c0.3-0.2,0.6-0.4,0.9-0.6c0.3-0.4,0.5-0.8,0.8-1.2c-2.1,0-3.8,0.7-5.5,2
		c-1.5,1.2-3.4,1.9-5.1,2.8l0,0c0,0,0,0-0.1,0c-2.3,1.2-4.7,2.4-7,3.6c-4.5,1.9-8.9,3.8-13.4,5.7c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0.1-0.4,0.2-0.6,0.3c0.1-0.2,0.2-0.4,0.4-0.6c-0.5,0-1.4,0-1.5,0.2c-0.3,1.5-1.1,2.4-2.1,3
		c0.6,0.3,1.5,0.4,2.2,0.1c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2
		c-0.1,0.3-0.2,0.6-0.3,0.9c0.9-0.7,1.8-1.2,3.1-1.1c-1.2,0.8-2.5,1.6-3.7,2.4c-0.2,0.4-0.3,0.7-0.5,1.1c-0.3,0.6-0.5,1.3-0.7,1.9
		c-0.4-0.5-0.5-1.2-1-1.7c-0.2,0.1-0.5,0.3-0.7,0.4c0.2,1.2,1.3,2.2,1.1,3.5c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7
		c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0
		c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9c-1,1.7-2.2,3.3-1.3,5.2c-0.5,0.1-0.9,0.2-1.4,0.3
		c-1.7,0.5-2.7,1.8-2.5,3.2c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0.1-0.3,0.2-0.7,0.3-1.1c0.6-0.1,0.9,0.1,0.9,0.6
		c0,0.8,0.1,1.5,0.1,2.4c-1.3,0.5-2.5,1.3-3,2.8c-0.4-0.5-0.7-0.8-1-1.1c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7
		c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4
		c0.1,0.4,0.2,0.7,0.4,1.1c-1.4,0.7-2.5,1.7-2.1,3.2c0.3,0.9,1,1.5,2.1,1.6c0.6,0.1,1.1,0,1.6-0.2c0-0.3,0.2-0.6,0.8-1.1
		c2.5-2,5-4.3,8.4-4.8c1.5-2.8,4.5-3.5,7-5l0,0c0.3-0.1,0.5-0.3,0.8-0.4c0.2-0.5,0.2-1.1,0.1-1.7c1.3-0.3,2.5-0.6,3.7-0.9
		c1-0.6,2-1.3,3-1.9c0.1-0.2,0.2-0.5,0.3-0.7c0.3-1.1-0.2-1.9-1.1-2.5c-1.1-0.8-2.3-1.5-3.5-2.3c-0.1,0-0.1-0.1-0.2-0.1
		c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1
		c0.5-0.1,0.9-0.4,1.3-0.7c0.4-0.3,0.8-0.6,1.3-0.8c1.2,0.4,1.3,1.2,1.1,2.1c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6
		c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4c1-0.1,1.9-0.1,2.7,0.5c0.9,0.7,2.1,0.4,3.1-0.2c0.4-0.2,0.6-0.4,1.2-0.3
		c1.2,0.1,2.4-1,2.4-1.9c0,0,0,0,0-0.1c0-1-0.8-1.5-2-1.5c-0.2,0-0.4,0-0.6,0.1c-0.5,0.1-0.8,0.1-1.2-0.1c-1.4-0.6-2.6-0.3-3.6,0.8
		c-0.3,0.3-0.6,0.4-0.8,0c0.7-0.8,1.9-1.1,2.5-2.1c0.4-0.8,1-1.5,1.4-2.3c-0.2,0-0.3,0-0.5,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1,0-0.2,0
		c-2.2,1.4-4.4,1.1-6.7,0.1c-0.1,0-0.1,0-0.2,0c0,0,0,0,0-0.1c-0.7,0.1-1.3,0.1-2,0.2c-1.4,0.7-2.9,1.4-4.3,2.1
		c-0.5,0.2-0.9,0.5-1.4,0.7c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.3-1,0.4c0-0.2-0.1-0.3-0.1-0.5c0.4,0,0.7,0.1,1.1,0.1h0.1
		c0.5-0.2,0.9-0.5,1.4-0.7c1.4-0.8,2.8-1.5,4.1-2.3c1-0.7,2.1-1.5,3.1-2.2c0.1,0.2,0.2,0.3,0.4,0.5c-0.4,0.6-0.9,1.2-1.3,1.8l0,0
		c0,0,0.1,0,0.1,0.1c2.2,0,4.4-0.1,6.7-0.1c0,0,0.1,0,0.1-0.1c0.1,0,0.1,0,0.2,0c0.2,0,0.4-0.1,0.6-0.1c0,0,0,0,0-0.1
		c0.2-0.4,0.3-0.9,0.4-1.4c-1.4,0.2-2.9,0.2-4.5,0c2.2-1,4.2-1.6,6.2-1.8c0.1,0,0.2-0.1,0.3-0.1c0,0,0,0,0,0.1
		c1.3-0.1,2.5-0.1,3.8-0.1c0,0,0.1,0,0.1-0.1c1.2-0.2,2.4-0.4,3.6-0.6c0.1,0,0.2,0,0.3-0.1c0.6-0.3,1.2-0.5,1.7-0.8
		c-2.5-0.5-4.9-1-7.4-1.4c0-0.2-0.1-0.3-0.1-0.5c2.8-0.2,5.6-0.5,8.4-0.7c0,0,0,0,0-0.1c0.2,0,0.3,0,0.5,0c1.2-0.2,2.3-0.5,3.5-0.7
		v-0.1l0.1,0.1c1.3-0.3,2.7-0.5,4-0.8c0,0.3,0.1,0.7,0.1,1c-1.2,0.1-2.4,0.2-3.6,0.2c1.1,0.8,2.1,1.6,3.3,2.4c0.5,0.4,1,0.7,1.5,1.1
		c0.3-0.7,0.8-1.3,1.3-1.9c0.4-0.5,0.7-1.1,0.6-1.8c0.5,0.1,0.8,0.2,1.2,0.3c1-0.8,1.1-1.1,0.7-1.5c-0.4-0.4-0.7-0.4-2,0.2
		c-0.6-0.4-0.8-0.8,0-1.2c1-0.6,1.9-1.3,3.2-0.7c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9c0,0.6,0,1.1,0.4,1.6
		c0.4-0.3,0.8-0.6,1.2-0.9c-0.1-0.3,0-0.7,0.2-1.1c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3
		c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1
		c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.3,0.2-0.2,0.6-0.2,0.9
		c0.3,0,0.6-0.1,0.9-0.1c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2,0.2-0.5,0.4-0.7,0.6c0.3,0.4,0.6,0.7,0.8,1.1c0.2,0.3,0.5,0.7,0.5,1.1
		c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7
		c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4
		c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2c-0.9,0.4-1.3,1.1-1.7,1.8c-0.5,0.7-0.9,1.2-1.9,1.4c0.5,0.5,0.8,0.8,1.2,1.2
		c-0.4,0.7-0.8,1.4-1.2,2.1c-0.1,0.2-0.2,0.4-0.4,0.6c0.3-0.1,0.6-0.1,0.9-0.2c0.1,0.2,0.2,0.4,0.3,0.7c-0.9,0.2-1.3,1-2.3,1
		c-0.3,0-0.7,0-1,0c-0.2,0-0.4-0.1-0.5-0.1c-0.9,0.5-1.7,1-2.5,1.4c0.2,0.8,0.4,1.3,1.2,1.6c0.7,0.3,1.3,0.9,1.6,1.5
		c0.5,0.9,1.9,0.4,2.5,1.2c0.1,0.2,1.1-0.2,1.7-0.3c-0.1-0.4-0.1-0.9-0.2-1.4c0.5-0.1,0.8-0.1,1.2-0.2c0,0.2,0.1,0.4,0.1,0.5
		c0.3,1.3,0.5,1.4,2.2,1.6c0.4,0,0.7,0.3,1,0.5c0.2,0.1,0.3,0.3,0.4,0.5c0.7,0.7,1.1,0.7,2,0.1c0.5-0.4,0.9-0.6,1.7-0.8
		c0.1,0.2,0.1,0.5,0.3,0.7c0.1,0.2,0.4,0.2,0.9,0.5c-1,0.1-1.6,0.2-2.3,0.3c0.3,0.8,0.7,1.6,1.5,1.6c0.1,0,0.3,0,0.4,0
		c0.3-0.3,0.5-0.5,0.8-0.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.3-0.2,0.4-0.4c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.1-0.3,0.2-0.4,0.3l0,0
		c-0.3,0.4-0.5,0.8-0.8,1.2c0.3,0.1,0.9,0,0.5,0.6c0.2,0,0.4,0.1,0.5,0.2c0.1-0.1,0.3-0.2,0.4-0.4c0.2-0.2,0.5-0.5,0.7-0.7
		c0.2-0.3,0.4-0.5,0.7-0.8c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.1,0.5-0.3,0.8-0.4l0.1-0.1l0.1,0.1l-0.1-0.1c0.1-0.1,0.2-0.3,0.4-0.4
		c0.6-0.8,1.1-1.7,1.7-2.5c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.2,0.5-0.4,0.8-0.6c0-0.1,0.1-0.2,0.1-0.3h0.2c-0.1,0.1-0.2,0.2-0.4,0.4
		l0,0l0,0c-0.2,0.3-0.4,0.6-0.5,0.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0.3-0.4,0.5-0.7,0.8
		c-0.7,0.7-1.3,1.5-2,2.2c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.2-0.3,0.5-0.5,0.7c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0.2-0.5,0.5-0.7,0.7l0,0c-0.2,0.2-0.5,0.4-0.7,0.7c-0.2,0.2-0.4,0.5-0.7,0.7
		c-0.1-0.1-0.2-0.2-0.2-0.3c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.3,0.3,0.6,0.7,0.6
		c1.1,0,0.8-1.1,1.5-1.2c0.4,0.5,0.9,0.9,1.3,1.4c0.1,0.2,0.3,0.3,0.4,0.5c0.6-0.3,1.1-0.5,1.6-0.7c0,0,0,0,0-0.1
		c0.1-0.2,0.1-0.4,0.3-0.5c0.3-0.2,0.7-0.4,1.3-0.6c-0.4-0.4-0.8-0.7-1-1.1c-0.3-0.4-0.5-0.9-0.6-1.3c0-0.1,0.3-0.2,0.5-0.4
		c0.1,0.1,0.2,0.2,0.2,0.3c1.3-0.2,2.1-0.8,2.6-1.9c0.5,0.1,1.1,0.2,0.7,0.7c-0.2,0.3-0.2,0.5-0.1,0.8c0.2,0.5-0.1,0.9-0.7,1.1
		c-0.4,0.9-0.4,0.9,0.3,2.1c1.3-0.4,2,0,2.3,1.1c0.2,0.6,0.6,0.8,1.5,1l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.2-0.1,0.7-0.5,0.9-0.5
		c0.9,0.3,1.5-0.1,2-0.8c0.3,0.4,0.5,0.6,0.7,0.8c-0.3,0.2-0.6,0.4-0.9,0.6c-0.2,0.5,0.6,1.5,1.1,1.4c1-0.3,1.6,0.1,2.2,0.6
		c0.2,0.2,0.7,0.1,1.2,0.1c-0.3-1-0.6-1.7-1.8-1.9c-0.6-0.1-1-0.5-0.9-1.1c0-0.3-0.3-0.6-0.5-1c-0.4,0.2-0.7,0.3-1,0.4
		c-0.5-0.2-0.4-1.1-1.4-0.7c-0.1,0.2-0.2,0.4-0.4,0.8c-0.2-0.4-0.4-0.6-0.4-0.8c0-0.4,0.2-0.9,0.3-1.4c0.1-1.3-0.2-1.6-1.7-1.8
		c-0.3,0-0.6-0.1-1.1-0.1c0.5-0.6,0.9-1.2,1.4-1.9c0.4,0.3,0.7,0.5,0.8,0.7c0.4,0.5,0.8,0.9,1.6,1.1c0.8,0.3,1.4,0.9,2.2,1
		c0.7,0.1,1.4-0.3,1.3-0.8c-0.1-0.5-0.3-1.1-1-1.2c-1-0.1-1.6-0.4-2-1.2c-0.3-0.6-1-0.6-1.8-0.2c-0.4,0.2-0.8,0.4-1.6,0.7
		c0.9-1-0.2-0.8-0.3-1.2c0.2-0.1,0.4-0.2,0.8-0.3c-0.3-0.4-0.5-0.8-0.8-1.3c0.2-0.1,0.5-0.2,0.7-0.3c0.1-0.3,0.1-0.7,0.3-0.9
		c1.1-0.8,1.1-0.7,3.4,0c0.3-0.4,0.6-0.9,0.9-1.4c-0.3-0.4-0.5-0.9-0.8-1.4c-0.9,0-1.8,0.3-2.6-0.1c-0.2-0.1-0.8,0.1-1.3,0.3
		c-0.4,0.3-0.7,0.7-1.1,1c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.3,0.2-0.5,0.4-0.8,0.6c0,0,0,0-0.1-0.1l0.1,0.1
		c-0.2,0.1-0.4,0.3-0.6,0.4c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0-0.2,0.1-0.3,0.1c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.1-0.1,0.2-0.1
		c0.2-0.2,0.3-0.4,0.5-0.6s0.5-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.5,0.1-0.9,0.2-1.3-0.2l0,0l0,0c0.5-0.4,0.7-0.6,0.7-0.8
		c0-0.1,0-0.2,0-0.3c0-0.1,0-0.2,0-0.2c-0.6,0.4-1.1,0.8-1.7,1.3v0.1c-0.2,0.3-0.5,0.5-0.7,0.8c-0.1,0-0.2,0.1-0.3,0.1
		c-0.3,0.2-0.7,0.5-1,0.7c-0.3,0.4-0.6,0.8-1,1.2c-0.2-0.2-0.4-0.3-0.5-0.5c0.4-0.3,0.9-0.6,1.3-0.9l0.1,0.1
		c-0.1-0.1-0.1-0.1-0.1-0.1c0.4-0.1,0.8-0.3,1.2-0.5c0.1-0.1,0.2-0.1,0.2-0.2c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1
		c0.3-2.9,3.1-3.8,4.8-5.7c1-1.1,2-2.2,3-3.4c-0.1-0.3-0.7-0.6-0.7-0.4c-0.3,0.9-1.5,0.6-2,1.2c-0.1,0.1-0.2,0.3-0.4,0.4
		c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8c-0.1,1-0.8,1.8-2.1,2.4c0.3-0.8,0.7-1.6,1-2.4
		c-0.8-0.7,1.2-1.7-0.2-2.4c-0.7,0.2-0.3,0.8-0.5,1.2c-0.5,0.2-1.1,0.4-1.6,0.6c0-0.1-0.1-0.1-0.1-0.2c0.4-0.2,0.8-0.4,1.2-0.6
		c-0.1-0.1-0.2-0.2-0.4-0.3c-0.6-0.1-1.3-0.2-2.2-0.2c-0.2,0.2-0.7,0.5-1.1,0.8c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1
		c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0c-0.3,0-0.7-0.1-1-0.1
		c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4c-0.6-0.2-1.1-0.3-1.5-0.4
		c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3v-0.1c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.4,0.2,0.7,0.4c0.2-0.1,0.4-0.1,0.5-0.2
		c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0c0.6-0.4,0.7-0.9,0.8-1.4
		c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4c-0.6-0.5-0.4-1.3-0.1-1.9
		c0.3-0.6,1.3-1,2.1-1.6c0.2,0,0.7,0.1,1.4,0.2c0-1,0-2,0-2.9c0.5,0,1.1,0,1.6,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3
		c0.8,0.3,1.1-0.1,1.4-0.6c1.2,0.7,0.9,1.7,0.4,2.8c-0.7,0.2-1.6,0.5-2.5,0.8c0-0.3,0-0.6-0.5-0.5c-0.1,0.3-0.3,0.8,0.4,0.5
		c0,0.2-0.1,0.5-0.1,0.7c0.1,0.8,0.3,1.3,0.6,1.7c0.6,0.7,1.7,0.9,3.5,0.9c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3
		c1,0.4,2.3,0,2.7-1.1c0.4-0.9,0.3-1.7-0.5-2.2c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7
		c-0.2-0.3-0.5-0.6-0.7-0.9c0.2-0.4,0.3-0.7,0.5-1.1c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3
		c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2c0.6-0.1,1.1-0.2,2-0.4c0.1,0,0.4,0.2,0.8,0.5c0.4-0.2,0.9-0.5,1.4-0.7
		c-0.1-0.5-0.1-0.9-0.2-1.3c0.3,0.1,0.7,0.1,0.9,0.3c0.4,0.3,0.7,0.7,1,1c-1.6,0.4-2.9,1.2-3.9,3c1-0.5,1.8-0.8,2.4-1.3
		c1.2-0.9,1.9-1.2,3.3-1.4c1-0.1,1.6-0.4,2.3-1.3c0.2-0.6,0.4-1.2,0.7-1.6c1.5-2.2,2.8-4.4,2.8-7.2c0-1.1-0.2-2.2-0.3-3.3
		c0.3-0.1,0.6-0.2,0.9-0.3c0.3,0.9,0.9,1.8,0.8,2.7c-0.2,3.5-1.1,6.8-3.2,9.7c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.2,0.4-0.4,0.7-0.6l0,0
		l0,0c0,0,0,0,0.1,0c0.1-0.1,0.1-0.2,0.2-0.3c0,0.1,0,0.1,0,0.2c0,0-0.1,0.1-0.2,0.1c0,0,0,0,0,0.1c-0.2,0.2-0.4,0.4-0.6,0.6
		c0.2,0.1,0.5,0.1,0.8,0.1c0.2,0,0.4,0.4,0.5,0.7s0,0.6,0,0.9c0,0.1-0.1,0.2-0.1,0.4l0,0c0.1-0.1,0.2-0.2,0.3-0.2
		c0,0,0.1,0.1,0.2,0.1c1-0.2,2.1-0.4,3.1-0.6c0.1,0,0.2,0,0.2,0c0.2-0.1,0.4-0.2,0.7-0.2c0-0.4,0-0.8,0-1.2c0.7-0.5,1.2-0.3,1.5,0.3
		c-0.2,0.2-0.4,0.4-0.6,0.5c0.2-0.1,0.3-0.1,0.5-0.2c0,0.2,0.1,0.5,0.1,0.7c-0.4,0-0.8,0-1.2,0c-0.1,0.1-0.3,0.2-0.4,0.4
		c0-0.1,0-0.2,0-0.4c-0.2,0-0.4,0-0.6,0c-0.1,0-0.1,0-0.2,0.1c-1,0.2-2.1,0.4-3.1,0.6c0,0,0.1,0.1,0,0.1c-0.1,0.3-0.3,0.5-0.5,0.8
		c0.3,0,0.5,0,0.7,0c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.2-0.2,0.3-0.4,0.5c-0.1,0.3-0.2,0.7-0.2,1.1c0.1,0,0.3,0.1,0.4,0.1
		c0.1,0,0.1,0,0.2-0.1c0,0,0,0.1,0.1,0.1c0.4,0.1,0.8,0.2,1.2,0.3c0.2-0.1,0.3-0.3,0.5-0.4c0.3-0.2,0.6-0.5,0.9-0.7l0,0
		c0.6-0.5,1-0.9,0.6-1.5l-0.1-0.1c0,0,0.3-0.3,0.5-0.5c0.1,0.2,0.1,0.5,0.3,0.6c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0-0.2-0.4-0.3-0.6-0.5c0.1-0.3,0.2-0.7,0.3-1.1c1.3,0.2,2.5-0.1,3.3-1c0.1-0.1,0.3-0.3,0.4-0.5h0.1c1.6,0.5,3,1.1,4.9-0.3
		c-0.2,0.7-0.3,1.2-0.4,1.6c0.1,0,0.2-0.1,0.3-0.1h0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.1,0.1,0.2,0.2,0.3,0.3c-0.1,0-0.3,0.1-0.4,0.1v0.1
		c-0.1,0-0.3,0-0.4,0.1c0,0.1,0,0.1-0.1,0.2c-0.1,0-0.2,0-0.4-0.1c-1.6,0.5-3.2,1-4.8,1.5c-0.3,1.1,0.2,2.1,1.8,2.9
		c-0.4,0.3-0.8,0.6-1.1,0.8c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3c-0.7-0.4-1.5-0.5-2.3-0.3
		c-1.1,0.2-1.8,0.7-2.4,1.4c-0.2,0.2-0.3,0.4-0.5,0.6c-0.1,0.2-0.2,0.4-0.3,0.6c0,0,0,0,0,0.1c1.1,0.1,1.3,0.6,1,1.9
		c0.7,0.6,1.5,1.1,2.7,0.9c-0.3,0.9-0.6,1.7-0.8,2.4c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.3,0.3-0.4
		c0.4-0.3,0.6-0.7,0.6-1.1c0-0.2,0-0.3-0.1-0.5c-0.2-0.5-0.8-0.7-1.5-0.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.3,0.2-0.6,0.5-0.7,0.9
		c-0.3,1.1-0.3,1.2-0.7,1.6c0,0,0,0.1-0.1,0.1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.3-0.3-0.5-0.5-0.8c-0.1,0-0.3,0.1-0.4,0.2
		c-0.4,0.2-0.6,0.4-0.6,0.7c0,0.1,0,0.1,0,0.2c0.7,0.1,1.4,0.2,2.1,0.2c-0.1,0.4-0.1,0.8-0.2,1.2c-0.5-0.1-1-0.1-1.6-0.2
		c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.3,0.4,0.5l0.1,0.1c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		c-0.5,0.2-1,0.4-1.5,0.6c-0.5,0.2-1,0.5-1.2,1c0,0,0,0.1-0.1,0.1c0.1,0,0.4,0,0.7,0c-0.1,0.2-0.3,0.5-0.4,0.7c0.4,0,0.8,0,1.2,0.1
		c-0.4,0.3-0.7,0.6-1.1,0.9c0.2,0.3,0.4,0.6,0.7,0.7c0.2,0.1,0.6,0,0.8-0.1c0.1,0,0.1-0.1,0.1-0.1c0.2-0.8,1-1.3,1.4-2l0.1-0.1
		c0.1-0.2,0.1-0.4,0.1-0.7V248l0,0c1.4,0.5,2.5-0.2,3.6-0.9c0.2,0.8,0.4,1.4,0.6,2.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.1,0.1,0.2,0.1
		c0.4,0.1,0.7,0.3,1.1,0.4c0.1,0,0.2,0.1,0.4,0.1c0.8,0.3,1.6,0.3,2.4,0.1c1-0.2,1.9-0.7,2.5-1.5c0.4-0.6,0.8-1.2,1.2-1.8
		c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4
		c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.6,0.3-1.3,0.1-2c-0.1-0.4-0.2-0.7,0.4-1c0.3,0.2,0.7,0.4,1,0.6c0.4,0.2,0.8,0.4,1.3,0.7
		c-0.3,0.3-0.6,0.5-0.8,0.7c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8c0.3-0.1,0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9
		c0.5-1.1,0.9-2.3,1.2-3.5c1.5-4.6,4.7-8.6,4.8-13.8c0-1.2,1.2-2.3,2.8-1.3l0,0c0-1.2,0-2.4,0-3.6c-0.5,0.6-0.9,1.3-1.4,2
		c-0.5-2.3-1.7-4.5-1.3-6.4c0.6-3.2-1.8-4.8-2.6-7.3c-1.4-4.1-4.7-1.4-7.2-1.5c-0.2,0-0.5,0-0.7,0.1c-1.5,0.3-3,0.7-4.6,1
		c-0.2,0.1-0.4,0.1-0.5,0.2c-0.1,0-0.2,0.1-0.4,0.1c-0.5,0.3-1.1,0.5-1.6,0.8c0.5,0.3,1,0.5,1.9,1c-2.2-0.2-2.2-0.2-2.2-1.3
		c0.6-0.2,1.2-0.3,1.8-0.5c0.1-0.1,0.2-0.1,0.3-0.2c0.2,0,0.4-0.1,0.6-0.1c1.4-0.5,2.8-1,4.2-1.5c1.5-0.6,3.1-1.1,4.6-1.7
		c-0.4-0.5-0.7-1-1-1.5c-3.4,0.4-6.8,0.8-10.3,1.3c-0.1,0-0.2,0.1-0.2,0.1c-0.2,0.2-0.5,0.5-0.7,0.7l0,0c-0.2,0.1-0.3,0.2-0.5,0.3
		c0.2-0.1,0.3-0.2,0.5-0.3l0,0l0,0c0.2-0.2,0.5-0.5,0.7-0.7l0.1,0.1l-0.1-0.1c0.1,0,0.2,0,0.3,0c2.1-0.9,4.3-1.8,7-2.9
		c-1-0.7-1.8-1.3-2.5-1.8c-2.8,0.2-5.6,0.5-8.5,0.7c1.2-0.7,2.5-1.2,3.8-1.8c0.3-0.1,0.3-0.8,0.5-1.2c-1.3-0.2-2.5-0.6-3.8-0.6
		c-1.5,0-3,0.3-4.5,0.5l-0.1,0.1c0,0-0.1,0-0.1,0.1c-0.3,0.4-0.6,0.8-0.9,1.3c-0.2-0.2-0.4-0.5-0.6-0.7c0.5-0.2,1-0.4,1.5-0.5
		l0.1-0.1h0.1c0.7-0.8,1.5-1.6,2.8-3c-2.7-0.2-4.6-0.4-6.4-0.5c0,0,0,0,0,0.1c0,0,0,0-0.1,0c-0.2,0.7-0.5,1.3-0.9,2.3
		c-0.5-0.5-0.9-1-1.3-1.4c0.7-0.3,1.4-0.6,2.1-0.9v-0.1l0,0c-0.3-2.4-1.6-3-4.2-1.8c0.5,0.2,1.1,0.4,1.7,0.6
		c-0.1,0.2-0.1,0.4-0.2,0.7c-1.3-0.3-2.5-0.5-4-0.9c0.7-1.1,1-1.7,1.4-2.3c-2.3,0-4.3,0-6.5,0c0.1-0.9,0.3-1.5,0.3-2
		c-4.3-1.6-8.5-3.2-12.7-4.8l0,0c-0.7-0.2-1.5-0.5-2.2-0.7c-0.2,0-0.4-0.1-0.5-0.1c-0.7-0.2-1.5-0.4-2.2-0.6v-0.1
		c0.7,0.2,1.5,0.4,2.2,0.6l0,0l0,0c0.2,0.1,0.3,0.1,0.5,0.2c0.8,0.1,1.6,0.3,2.4,0.4c5.4,1.5,10.8,2.9,16.2,4.4c1,0.3,2,0.5,3,0.8
		c3.4,1,6.9,1.9,10.3,2.9c0.3,0.1,0.7,0.5,0.7,0.7c-0.1,2.8,2.3,2.5,3.8,3.3l-0.1-0.1c0,0,0,0,0.1,0c-1-1-1.9-2-2.9-3.1
		c0.2-0.2,0.3-0.4,0.5-0.6c2.5,1.4,4.9,2.7,7.4,4.1c-0.1,0.2-0.1,0.4-0.2,0.5c-1.1-0.1-2.2-0.2-3.3-0.3l0.1,0.1l0,0
		c0.3,0.4,0.6,0.8,0.9,1.2c1.4,0.7,2.9,1.4,4.3,2.1c1.1-0.4,1.5-0.9,0.4-1.8l0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2
		c-0.1-0.2-0.3-0.4-0.4-0.6c0.2,0.1,0.4,0.2,0.6,0.3c1.7,0.2,3.3,0.4,5.1,0.6c-2.7,2-0.3,3,0.7,4.2c0.9,0.7,1.9,1.4,2.6,2.2
		c1.9,2.3,3.8,4.8,5.6,7.2h0.1c0.2-0.5,0.3-1,0.5-1.5c1-0.4,2-0.8,3-1.1c0.2-0.1,0.4-0.2,0.6-0.3c1-0.2,2-0.4,3-0.5
		c0.1,0,0.2,0,0.3,0c2.7-0.9,5.5-1.9,8.2-2.8l0,0c-1.4-0.6-2.8-1.7-4.2-1.7c-3.7,0.1-7.4,0.6-11,1c-0.1,0-0.2,0.1-0.3,0.1
		c-0.1,0-0.3,0.1-0.4,0.1c-0.5,0.2-1.1,0.4-1.6,0.7c-0.1,0.3-0.2,0.6-0.3,0.9c0,0-0.4-0.1-0.5-0.2c0.2-0.4,0.4-0.7,0.6-1.1
		c0.7-0.1,1.3-0.3,2-0.4c0.1,0,0.2-0.1,0.4-0.1c0.1,0,0.2,0,0.3,0c2.4-0.9,4.8-1.7,7.2-2.6c0.1-0.1,0.2-0.2,0.4-0.4
		c-0.1,0.1-0.2,0.2-0.4,0.4c-0.2-0.3-0.4-0.5-0.6-0.8c-1.1-0.8-2.3-1.5-3.4-2.3v0.1c-0.1,0-0.1,0-0.2,0c-2.9,0.8-5.8,1.6-8.7,2.4
		c2.4-2.6,5.4-3,8.7-2.4h0.1c-9.5-5.6-20-8.4-30.6-11.1c-4-1-8-2.1-12-3.1l0,0c-4.4-0.5-8.6-1.7-12.5-3.9c3.9,0.4,7.8,1.1,11.6,2.1
		c7.6,2.1,15.4,3.4,22.8,6.3c5.5,2.2,11.3,2.2,17,3.1c-1.2,0.1-2.5,0.1-3.7,0.2c7.6,5.2,17.1,7.2,22.7,15.3
		c-0.8-0.6-1.6-1.2-2.4-1.8c0.2,0.9,0.5,1.7,0.7,2.6c0.2,0.2,0.5,0.5,0.7,0.7s0.5,0.5,0.7,0.7c2.3,3.2,5.6,5.8,6,10.2
		c0.1,0.6,0.5,1.2,0.8,1.8c0.2-0.3,0.3-0.6,0.5-0.8c0.2,0.3,0.4,0.5,0.6,0.8c0.6,1.7,1.1,3.5,1.6,5.2c0.4-0.2,0.8-0.4,1.2-0.6
		c0.4-0.2,0.8-0.4,1.3-0.4c0.1,0,0.3,0,0.4,0.1c0.1,0,0.1,0,0.2,0c0.3,0,0.8-0.2,0.8-0.4c0.2-0.9,1.1-1,1.8-1.2
		c0.8-0.3,1.6-0.6,2.5-0.7c0.5-0.1,0.8-0.3,1.2-0.6c0.9-0.7,1.8-0.6,2.4,0.2c0.1,0.1,0.2,0.3,0.2,0.4c0.2,1,0.5,2.1,0.7,3.2
		c0,0.1,0,0.1,0,0.2c2.5-0.5,5.1-1,7.9-1.5c-1-1.5-1.6-2.5-2.3-3.4c0.1-0.1,0.3-0.3,0.4-0.4c-0.1,0.1-0.3,0.3-0.4,0.4
		c0-0.4,0.1-0.7,0.1-1.1c-1.2-1.8-2.3-3.6-3.5-5.4l0,0c-0.2-0.5-0.5-0.9-0.7-1.4c-0.3-0.2-0.5-0.4-0.8-0.7l0.1-0.1l-0.1,0.1
		c-0.1-0.2-0.1-0.4-0.2-0.5c0.2,0.1,0.3,0.2,0.5,0.3c0.2,0,0.4,0,0.6,0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0.1c0.1-0.2,0.3-0.5,0.4-0.5
		c2.5,0.8,4.8,5.6,4,8.4l0,0c0,0.1,0,0.3,0,0.4c1.2,1.5,2.8,2.9,3.5,4.6c0.7,1.6,1.5,3.1,2,4.8c0.2-0.2,0.3-0.3,0.5-0.5
		c0.3-0.4,0.6-0.8,1-1.1c0.2,0.1,0.3,0.2,0.5,0.3c0,0,0,0,0.1,0c0.6,0.4,1.2,0.8,0.9,1.7c0,0.1,0,0.2,0.1,0.2
		c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2,0,0.2,0c0.3,0,0.4,0,0.5,0.1s0.1,0.3-0.1,0.6c-0.1,0.2,0.8,0.1,0.9,0.7
		c0.1,0.6,0.5,1.2,0.7,1.9c0.1,0.2,0.2,0.4,0.6,0.6c0-0.2,0-0.3,0.1-0.5c0-0.1,0-0.2,0-0.3c0-0.3,0.1-0.5,0.1-0.8c0-0.1,0-0.2,0-0.2
		c0.1,0.1,0.3,0.1,0.5,0.2c0.4,0.2,0.7,0.4,1,0.3c0.3-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6,0,0.9,0.2c0.3-0.6,1.1-0.3,1.5-0.6
		c0.2-0.2,0.4-0.3,0.6-0.5c0.3-0.2,0.6-0.4,1.1-0.5c0.2,0,0.3-0.6,0.5-0.8c0.3-0.2,0.6-0.3,1-0.5c-0.1-0.2-0.1-0.5,0-0.8
		s0.3-0.6,0.8-0.9c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.2-0.4,0.6-0.7,0.6-0.9c-0.1-0.3-0.1-0.6-0.1-0.9
		c0-0.5,0.1-0.9,0.1-1.3c0-0.3-0.3-0.5-0.4-0.7c-0.1,0.1-0.3,0.2-0.4,0.3s-0.3,0.2-0.4,0.3s-0.2,0.1-0.3,0.3c0,0-0.1,0-0.1-0.1
		c-0.1,0-0.2-0.1-0.2-0.1c-0.7-0.5-1.4-1.1-2.5-1.5c-0.3-0.1-0.6-0.2-1-0.2c0.5-0.2,0.8-0.5,1-0.8c0.3-0.3,0.6-0.7,1-0.9
		c-1.3-0.3-2.7-0.7-4-1.1c-0.2-0.1-0.2-1-0.2-1.5l0,0c0.5-0.1,0.9-0.3,1.4-0.4c0.1,0,0.1-0.1,0.2-0.1h0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.4,0.3-0.7,0.5-1.1,0.8c-0.1-0.1-0.1-0.2-0.2-0.2c0.1,0.1,0.1,0.2,0.2,0.2c2.3,0.5,4.5,1.1,6.8,1.6l0.1-0.1
		c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.1,0.6,0.1,0.9,0.2c1.4,0.2,2.8,0.4,4.2,0.6c0.2-0.1,0.3-0.2,0.5-0.2c0.1,0,0.1-0.1,0.2-0.1h0.1
		c0.4-0.2,0.9-0.5,1.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c2.1,0.2,4.2,0.5,6.2,0.7c0,0.2,0,0.5-0.1,0.7c-0.4,0-0.9,0.2-1.3,0.1
		c-1.9-0.2-3.8-0.4-5.7-0.6c0.5,0.6,1,1.3,1.7,1.6c0.2,0.1,0.5,0.1,0.7,0.1c0.7,0,1.4-0.1,2.2-0.2c0.4,0.2,1,0.5,1.8,0.8
		c0.2,0.8,0.7,1.7,0.4,2.7c-2.6,0.2-3.6,0.7-3.9,2.1c-0.2,0.8,0.1,1.4,0.8,1.9c0.1,0.1,0.3,0.2,0.4,0.2c0.3,0.1,0.6,0.3,1,0.4
		c0.1,0,0.3,0.1,0.4,0.1c-0.2,0.4-0.4,0.7-0.7,1.1c-0.3-0.2-0.5-0.4-0.8-0.5c0,0-0.1,0-0.1-0.1c-0.2-0.1-0.5-0.2-0.7-0.2
		c-0.4-0.1-0.7-0.1-1.1-0.1c-0.3,0-0.7,0.1-1.1,0.3c0,0-0.1,0-0.1,0.1c-0.4,0.2-0.6,0.4-0.9,0.6c-0.4,0.4-0.7,0.8-0.9,1.3
		c-0.1,0.2-0.1,0.4-0.1,0.5c-0.1,0.4-0.1,0.8-0.2,1.2c0.2,0.1,0.3,0.2,0.5,0.3c0.3,0.2,0.6,0.3,0.9,0.5c0.8,0.3,1.6,0.5,2.7,0.3
		c0.2,0,0.3,0,0.5-0.1c0,0.2,0,0.3,0,0.5l0,0c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8c-1.1,1-1.5,2.3-0.9,3.4
		c0.6,1.1,2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2
		c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5c1.7-0.7,2.4-2.2,1.7-3.6
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.7-0.5-0.7-0.2-1.4c0.4,0.4,0.9,0.8,1.3,1.2l0,0c0.3,0.3,0.7,0.7,1,1c0.5-0.5,1-1,1.6-1.5
		c0.2,0.3,0.4,0.5,0.6,0.7c0.8,0.7,1.8,1,2.7,0.7c0.8-0.2,1.6-0.8,2-1.7c0-0.1,0.1-0.2,0.1-0.3c-0.1-0.2-0.2-0.4-0.1-0.6
		c0-0.8,0.9-1.5,0.9-2.4c0.2,0,0.4,0.1,0.6,0.1c-0.2-0.3-0.4-0.6-0.6-0.8c-0.1-0.1,0.1-0.4,0.2-0.7l0.1-0.1
		c-0.1,0.1-0.1,0.1-0.1,0.1c-0.1-0.1-0.3-0.3-0.4-0.4c0.2,0.1,0.4,0.1,0.7,0.2c0.4,0.6,0.9,1.2,1.3,1.8c0.2-0.7,0.3-1.3,0.4-1.9
		c0-0.3,0-0.6,0-0.9c0-0.3-0.1-0.7-0.1-1c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.6,0.6-0.9c0.2,0.3,0.5,0.6,0.8,0.8
		c0.3,0.4,0.7,0.8,1.1,1.2l0,0c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8c2.4,0.8,5,0.3,7.5-1.1
		l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5l0,0c-1.2,0.3-2.4,0.5-3.6,0.8l0,0
		c-0.2,0.1-0.4,0.3-0.6,0.4c0.1-0.2,0.2-0.4,0.4-0.6c1.1-0.4,2.3-0.9,3.4-1.3c-0.5-0.6-1.5-0.8-3-0.8c-0.2-0.1-0.3-0.2-0.4-0.3
		c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6c0-0.2,0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.4,0-2-0.5
		l0,0c-0.2-0.1-0.4-0.3-0.6-0.4c-0.2-0.1-0.5-0.3-0.7-0.4c-0.3-0.2-0.5-0.4-0.6-0.8c-0.1-0.2-0.2-0.3-0.4-0.4
		c-0.4-0.2-1.1-0.2-1.7,0.1l0,0c-0.3,0.1-0.5,0.4-0.8,0.6l-0.1,0.1c0-0.1,0-0.1,0-0.2c-0.1-0.4-0.1-0.8-0.2-1.4
		c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.2,0-0.5,0-0.8c0-0.1,0-0.1,0-0.2c1-0.3,2-0.6,2.3-1.6c0-0.1,0.4-0.1,0.6-0.2
		c0.3-0.2,0.7-0.4,0.8-0.6c0.1-0.2,0.1-0.4,0.2-0.5c0-0.1,0.1-0.1,0.1-0.2c0,0,0-0.1,0.1-0.1c0.3-0.5,0.8-0.9,1.3-1.3
		c0.3-0.2,0.4-0.5,0.6-0.8c0.3-0.5,0.7-0.8,1.4-0.9c-2.5-1.8-5-3.5-7.5-5.3c-1.8,0.2-3.7,0.4-5.5,0.5c0,0,0,0,0,0.1
		c-0.1,0-0.1,0-0.2,0c-0.9,0.3-1.7,0.6-2.6,0.8c0-0.3-0.1-0.6-0.1-1c0.9,0,1.8,0.1,2.7,0.1c0.1,0,0.1,0,0.2-0.1l0,0
		c0-0.2,0-0.4-0.1-0.7c-0.3-0.4-0.5-0.8-1.3-1.8c2.9,0.7,4.9,1.2,7,1.7c0.7,0.1,1.4,0.1,2.2,0.2c0,0,0,0-0.1,0l0,0
		c-0.6-0.6-1.1-1.3-1.7-1.9c0.1-0.1,0.2-0.3,0.4-0.4c-0.1,0.1-0.3,0.3-0.4,0.4c-0.4-0.3-0.7-0.6-1.1-0.8c-0.1,0-0.1,0-0.2-0.1
		l-0.1-0.2l0.1,0.1l0.1,0.1c0.5,0.1,1,0.3,1.4,0.4c1,0.5,2.6,0.6,1.3,2.3c0,0,0,0,0.1,0.1l0,0l0,0c1.7,1.3,3.4,2.7,5.1,4
		c0.3,0.2,0.7,0.6,1,0.9c0.2-0.1,0.3-0.2,0.5-0.3c0.1,0.2,0.1,0.4,0.2,0.6c2.4-0.6,3.1,1,4,2.4c0.6-0.4,1.3-0.4,2-0.6
		c0.4,0.5,0.5,1,0.4,1.4c0.1,0,0.2,0,0.3,0c-0.1,0.1-0.2,0.2-0.2,0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.2,0.2,0.5,0.5,0.7,0.7
		c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.2,0.3,0.4,0.4,0.6c-0.2,0.1-0.3,0.2-0.5,0.3c0,0.2,0,0.4-0.1,0.6l0,0
		c0.2,0.2,0.5,0.5,0.7,0.7l0,0l0,0c0.5,0.2,0.9,0.4,1.4,0.7l0,0c0,0,0,0.1,0.1,0.1c0,0,0.1,0,0.1,0.1c0.1-0.2,0.1-0.4,0.2-0.6
		c0.4-0.9,0.3-1.7-0.2-2.5c0.9,0,1.6-0.1,2.1,0c1,0.1,1.5,0.4,2.2,1.4c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-0.8,0.4-1.3,1.1-1.8,1.7c1.5,1,3,2,4.5,3
		c0.5-0.6,1.1-1.1,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7
		c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3
		c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1
		c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1
		c0.3-0.1,0.9-0.1,1.2,0.1c0.8,0.7,1.8,0.3,2.8,0.6c-0.1-0.4-0.2-0.7-0.3-1c0.8-0.1,1.5-0.1,2.2-0.2c-0.2-0.4-0.5-0.7-0.8-1.2
		c0.2-0.1,0.4-0.2,0.7-0.3c-3.1-1.5-6.2-2.9-9.3-4.3c-0.4,0.1-1.1,0.1-2.2,0c0.2-0.3,0.4-0.5,0.6-0.8c-0.7-0.3-1.4-0.7-2.1-1
		c-6-2.7-12-5.1-17.9-7.8c-2.1-0.9-3.9-2.2-5.9-3.4c1.1-0.7,2-1,2.9-0.8c3.6,0.5,7.3,0.9,10.8,1.9c0.1,0,0.2,0,0.3,0.1
		c0-0.2-0.1-0.4-0.2-0.6c-0.2-0.3-0.6-0.6-1.2-0.7c-0.5-0.1-0.8-0.9-1.1-1.3c-0.6,1.4-2,0.7-3.2,0.7c-0.2,0-0.3,0-0.5,0
		c0-0.3-0.1-0.8-0.1-1.2c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0.1,0.7,0s0.3-0.3,0.5-0.4c-0.2-0.1-0.5-0.4-0.6-0.3c-0.5,0.1-0.9,0.4-1.3,0.6
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.4,0.2-0.9,0.4-1.3,0.6c-1.3-0.5-0.7-1.2-0.1-1.9c-0.5,0-0.9,0-1.7,0c0.3-0.2,0.5-0.4,0.7-0.5
		c0.1,0,0.1-0.1,0.2-0.1l0,0c0.2-0.1,0.4-0.2,0.6-0.3c-1.3-0.2-2.7-0.3-4-0.5c0-0.3,0-0.6,0-0.9c2.8-0.7,5.5-1.5,8.3-2.2
		c-0.2-0.4-0.3-0.8-0.5-1.2h-0.1c-0.1,0-0.3-0.1-0.4-0.1c-2.2-0.2-4.3-0.6-6.5-0.5c-5.3,0.1-10.6,0.4-15.8,0.6
		c-2.1,0.1-4-0.5-5.8-1.4c2.8-0.1,5.4,0.2,8.1,0.2c4.8,0,9.7-0.3,14.5-0.2c1.9,0.1,3.7,0.8,5.6,1.3c0.2,0,0.3,0,0.5,0.1v0.1
		c0.4,0.1,0.8,0.3,1.3,0.4c-0.1,0.4-0.3,0.7-0.4,1.1c-0.2,0.9-0.1,1.2,0.1,1.3c0.4-0.2,0.8-0.4,1.3-0.6c0.1,0.1,0.2,0.2,0.2,0.2
		c4.4-0.5,8.9-1.1,13.3-1.7c0.1,0,0.3-0.1,0.4-0.1c0.2,0,0.4-0.1,0.6-0.1c2.7-0.7,5.4-1.4,8-2.2c0.1,0.3,0.1,0.7,0.2,1
		c-2.7,0.4-5.5,0.8-8.2,1.2c-0.2,0-0.4,0.1-0.5,0.1c-0.2,0-0.3,0-0.5,0.1c-3.1,0.9-6.1,1.8-9.3,2.6c-1,0.2-2,0.2-3,0.2
		c0.1,0.1,0.1,0.1,0.2,0.2c-0.6,0.8-1.9,1.3-1.7,2.4c0.3,0.3,0.6,0.5,1,0.8c0,0,0.1,0,0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2
		c0-0.1,0-0.2,0-0.3c2.1-0.2,4.2-0.4,6.3-0.6c0,0.2,0.1,0.5,0.1,0.7c0.3,0,0.6,0.1,0.9,0.1c-0.2-0.4-0.3-0.6-0.5-0.9
		c0-0.1,0.1-0.2,0.1-0.2c0.4-0.4,0.9-0.8,1.2-1.2c0.4-0.4,0.9-0.5,1.3-0.2c0.3,0.3,0.2,0.6-0.3,0.9c-0.3,0.2-0.6,0.4-0.8,0.6
		c-0.4,0.5-0.5,1-0.2,1.4c0.3,0.3,0.9,0.7,1.3,0.6c1.2-0.3,2.4,0.1,3.5,0c0,0.8-0.9,1.8,0.5,2.3c0.1,0,0.1,0.4,0.1,0.5
		c-0.1,0.2-0.1,0.4-0.1,0.5c2,0.2,4,0.5,6.1,0.7c1.1-0.4,2-1.4,3.1-2c0.9,0.7,1.6,1.5,1,2.5c0.3,0,0.6,0.1,0.9,0.1s0.5,0.1,0.8,0.1
		c-0.1-0.3-0.2-0.6-0.2-0.8c-0.1-0.7-0.1-1.2-0.1-1.6c0.1-1.4,0.7-1.5,2.9-2c0.8-0.2,1.6-0.4,2.4-0.7c-1,0-1.9,0-2.9-0.1
		c-0.1-0.3-0.1-0.6-0.2-0.9c1.1-0.4,2.2-0.8,3.3-1.3l0,0c0.7-0.2,1.5-0.4,2.2-0.6c0.1,0,0.1,0,0.2-0.1c-0.1,0-0.1-0.1-0.2-0.1
		c0.7-1,0.7-1,0.4-2.5c0.6,0,1.2,0,1.8,0l0,0c0.1-0.1,0.3-0.2,0.4-0.3c0.8-0.7,1-1,1.6-0.9l0,0c0.7,0,1.4,0,2.1,0c0,0.2,0,0.3,0,0.5
		c-0.1,0-0.1,0-0.2,0c1,0.1,2-0.1,2.8-0.8C450.1,201.2,450.5,200.6,450.6,200z M329.3,177.5c0.9-0.2,1.8-0.4,2.7-0.5
		c0,0.4,0,0.8,0,1.2c-0.8-0.1-1.6-0.1-2.4-0.2c-0.3,0.1-0.7,0.1-1,0.2C328.9,177.9,329.1,177.7,329.3,177.5z M181.2,173.8
		c0-0.2,0.1-0.5,0.1-0.7c4.4,0.5,8.8,0.9,13.3,1.4c-0.1,0.3-0.2,0.7-0.3,1C189.9,174.9,185.6,174.4,181.2,173.8z M188.9,179.1
		c-0.2-0.1-0.4-0.1-0.6-0.2c0.1-0.2,0.3-0.4,0.4-0.6c0.2,0.1,0.4,0.2,0.5,0.4C189.2,178.7,189,178.9,188.9,179.1z M189.8,177
		c-0.1,0-0.2,0-0.3,0c0,0-0.1,0-0.1-0.1c-0.4,0-0.8,0-1.3,0c0-0.2,0.1-0.3,0.1-0.5c0.4,0.2,0.8,0.3,1.2,0.5c0.1,0,0.1,0,0.2,0l0,0
		l0,0C189.6,177,189.7,177,189.8,177c1.4,0.2,2.8,0.5,4.2,0.7c-0.1,0.3-0.2,0.6-0.3,1C192.4,178.1,191.1,177.6,189.8,177z
M194.6,180.4c-0.3-0.2-0.5-0.4-0.8-0.5c-0.1,0-0.1,0-0.2,0c-0.1,0-0.1-0.1-0.2-0.1c-0.5,0-1-0.1-1.5-0.1c0.1-0.2,0.1-0.4,0.2-0.5
		c0.4,0.2,0.9,0.4,1.3,0.7c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0.1c0.3,0,0.6,0,0.9,0.1C194.7,180.1,194.6,180.3,194.6,180.4z
M170.1,215.4c0.4,1.6,1.3,3.1,0.8,3.8c-0.6,0.9-2.1,1.3-3.8,2.2C168.3,219.1,169,217.6,170.1,215.4z M162.5,223.7
		c0.2,0.2,0.4,0.3,0.7,0.5c-0.5,0.7-1,1.3-1.5,2c-0.2-0.2-0.5-0.5-0.7-0.7C161.4,224.9,162,224.3,162.5,223.7z M154.9,223
		c0.4,0.1,0.8,0.2,1.1,0.3c-0.2,0.2-0.3,0.5-0.5,0.7C155.3,223.6,155.1,223.3,154.9,223C154.9,223,154.8,223,154.9,223
		c-0.3,0-0.6,0-0.8,0c-0.1,0-0.1,0-0.2,0c-0.7,0.5-1.4,0.9-2.1,1.4c-0.1-0.3-0.2-0.6-0.3-0.9c0.8-0.1,1.6-0.3,2.4-0.4l0.1-0.1
		C154.3,222.9,154.6,222.9,154.9,223C154.9,222.9,154.9,222.9,154.9,223z M154.1,218.7c-1,3-1.8,3.9-4,4c-0.3,0-0.7-0.7-0.8-0.8
		C151.1,220.8,152.6,219.8,154.1,218.7z M146.7,221.2c0.3,0.3,0.6,0.6,0.9,1c0.1,0,0.1,0,0.2,0.1c0,0.1,0,0.1,0,0.2
		c0.2,0.3,0.4,0.5,0.6,0.8c-0.2,0.1-0.3,0.2-0.5,0.3c0-0.3-0.1-0.7-0.1-1l-0.1-0.1l-0.1-0.1c-0.4-0.1-0.8-0.3-1.2-0.4
		C146.4,221.6,146.6,221.4,146.7,221.2z M146,211.8c0.2,0,0.4,0.1,0.5,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2,0-0.3-0.1-0.5-0.2
		C145.8,211.9,145.9,211.8,146,211.8z M140.2,220.2c0,0,0.1,0.4,0.1,0.7c-0.8,0.1-1.5,0.2-2.3,0.3c-0.1-0.2-0.1-0.4-0.2-0.6
		C138.7,220.4,139.5,220.3,140.2,220.2z M148.5,197.1v0.2h-0.2L148.5,197.1z M146.1,189.4l-0.2,0.1v-0.2L146.1,189.4z M143.2,188.5
		c0.4,0.2,0.8,0.5,1.2,0.7c-0.1,0.1-0.2,0.3-0.2,0.4c-0.4-0.2-0.8-0.4-1.2-0.6C143,188.9,143.1,188.7,143.2,188.5z M134.6,201.7
		c0.5,0.1,1,0.1,1.4,0.2c0,0.2,0,0.3,0,0.5c-0.5,0-1,0.1-1.4,0.1C134.6,202.2,134.6,202,134.6,201.7z M122.1,179.8L122.1,179.8
		c0.1,0,0.2,0,0.2,0.1c0.4,0.1,0.7,0.1,1.1,0.2c-0.1,0.2-0.2,0.3-0.3,0.5c-0.3-0.2-0.6-0.4-0.8-0.6
		C122.3,179.9,122.2,179.9,122.1,179.8C122.2,179.8,122.1,179.8,122.1,179.8c-0.1,0-0.1,0-0.2-0.1c0,0,0-0.1,0-0.2
		C122,179.6,122.1,179.7,122.1,179.8z M120.5,179.1l0.2,0.2c-0.1,0.1-0.2,0.3-0.4,0.3c-0.1,0-0.3-0.2-0.4-0.3
		C120.1,179.3,120.3,179.2,120.5,179.1z M106.1,181.9c-0.2-0.4-0.5-0.9-0.7-1.3l-0.1-0.1c-0.7-0.2-1.4-0.4-2.1-0.7
		c-0.5-0.2-1-0.5-1.5-0.7c0-0.1,0-0.2-0.1-0.3c0,0.1,0.1,0.1,0.1,0.2c0.5,0.2,1,0.4,1.5,0.7c0.7,0.2,1.4,0.4,2.1,0.7l0.1,0.1
		c0.4,0.3,0.8,0.6,1.2,0.8C106.4,181.6,106.3,181.7,106.1,181.9z M107.3,179c-0.2,0-0.3-0.1-0.5-0.2c0.2-0.1,0.3-0.2,0.5-0.2
		c0,0,0.1,0.1,0.2,0.2C107.4,178.9,107.3,179,107.3,179z M112.4,184.5c-1.4-0.8-2.8-1.7-4.2-2.5c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1-0.1
		c-0.1,0-0.1,0-0.2,0c0,0,0-0.1-0.1-0.2c0.1,0.1,0.1,0.2,0.2,0.2h0.1l0,0l0,0c0.1,0,0.1,0.1,0.2,0.1c1.6,0.4,3.1,0.8,4.7,1.1
		C112.8,183.6,112.6,184.1,112.4,184.5z M116.3,180.3c-0.3,0-0.7,0-1,0c0-0.1,0-0.2,0-0.3c0.3,0,0.7,0,1,0
		C116.3,180.1,116.3,180.2,116.3,180.3z M104.7,204.4c1,0.1,1.9,0.1,2.9,0.2c0,0.2,0,0.4,0,0.6c-1,0-1.9,0-2.9,0
		C104.7,204.9,104.7,204.7,104.7,204.4z M86.6,180.6c-0.3-0.7,0.9-1.1,1-1.8c0.6,0.3,1.3,0.6,1.3,1.4
		C88.2,180.3,87.5,180.5,86.6,180.6z M79.4,195.3c0.6,0.3,1.2,0.7,1.7,1c-0.1,0.1-0.1,0.2-0.2,0.4c-0.6-0.3-1.2-0.6-1.8-0.8
		C79.2,195.6,79.3,195.5,79.4,195.3z M74.2,193.5c0.1,0,0.2,0,0.3,0.1c0,0.1,0,0.2-0.1,0.2s-0.2-0.1-0.3-0.1
		C74.1,193.6,74.1,193.5,74.2,193.5z M70.2,186.4c0.1,0.1,0.1,0.3,0.2,0.4h0.1l0.1,0.1c0.3,0,0.5,0.1,0.8,0.1c0,0.1-0.1,0.2-0.1,0.3
		c-0.2-0.1-0.4-0.3-0.6-0.4c-0.1,0-0.1,0-0.2,0v-0.1c-0.2-0.1-0.3-0.1-0.5-0.2C70,186.6,70.1,186.5,70.2,186.4z M69.9,191.2
		c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.3,0.3-0.4,0.3s-0.2-0.2-0.4-0.3C69.5,191.4,69.7,191.3,69.9,191.2z M61.2,173.3L61.2,173.3
		L61.2,173.3L61.2,173.3z M64.9,192.6C64.9,192.6,64.9,192.5,64.9,192.6L64.9,192.6l-0.1-0.1c-1.7-0.6-3.5-1.2-5.2-1.8
		c0.2-0.4,0.3-0.7,0.5-1.1c1.6,1,3.1,1.9,4.7,2.9C64.8,192.5,64.8,192.5,64.9,192.6l0.1,0.1C65,192.6,64.9,192.6,64.9,192.6z
M66.7,184.8c0.3,0.2,0.6,0.4,1,0.6h0.1l0.1,0.1l-0.1-0.1c0,0-0.1,0-0.1-0.1c-0.4,0-0.7-0.1-1.1-0.1
		C66.6,185.1,66.7,184.9,66.7,184.8z M57.8,186.2c-1.2-0.5-2.3-1-3.5-1.5l0,0l-0.1-0.1c-0.3,0-0.6,0-0.9-0.1
		c0.1-0.2,0.1-0.3,0.2-0.5c0.2,0.2,0.5,0.3,0.7,0.5c0.1,0,0.1,0,0.2,0C55.5,185.2,56.7,185.7,57.8,186.2c0.5,0.2,1,0.4,1.5,0.6
		c0.5,0.2,0.9,0.5,1.4,0.7s0.9,0.5,1.4,0.7l0,0l0,0c1.2,0.5,2.4,0.9,3.5,1.4c0.5,0.3,0.9,0.5,1.4,0.8l0.1,0.1c0.3,0,0.7,0.1,1,0.1
		c-0.1,0.2-0.1,0.3-0.2,0.5c-0.3-0.2-0.6-0.4-0.8-0.6c-0.1,0-0.1,0-0.2,0c-0.5-0.3-0.9-0.5-1.4-0.8l0.1-0.1l-0.1,0.1
		c-1.2-0.5-2.3-1-3.5-1.4c-0.5-0.2-1-0.5-1.4-0.7v-0.1v0.1c-0.5-0.2-0.9-0.5-1.4-0.7v-0.1v0.1C58.7,186.7,58.2,186.5,57.8,186.2z
M25,194.5v-0.2c0.3-0.1,0.7-0.1,1-0.2c0,0.2,0,0.3,0,0.5C25.7,194.5,25.3,194.5,25,194.5z M17.4,187.7
		C17.4,187.7,17.3,187.6,17.4,187.7c-0.2-0.2-0.4-0.2-0.5-0.3c0.1-0.1,0.2-0.2,0.3-0.3C17.2,187.3,17.3,187.4,17.4,187.7
		C17.4,187.6,17.4,187.6,17.4,187.7c0.6,0.2,1.1,0.4,1.6,0.6c0.2,0.1,0.5,0.2,0.7,0.3c1,0.3,2,0.7,3,1l0,0l0,0
		c0.5,0.2,1,0.4,1.5,0.6c4.5,1.6,8.8,3.7,13,5.7c-0.1,0.4-0.3,0.7-0.4,1.1c-3-0.6-5.9-1.1-8.9-1.7c0-0.3,0.1-0.5,0.1-0.8
		c1.2,0,2.4,0,3.6,0c-2.6-1.3-5.2-2.7-7.8-4c-0.5-0.2-0.9-0.5-1.4-0.7c-0.9-0.4-1.8-0.8-2.7-1.2c-0.2-0.1-0.5-0.2-0.7-0.2
		C18.4,188.1,17.9,187.9,17.4,187.7z M7.4,189.8L7.4,189.8l0.1-0.1L7.4,189.8z M59.7,298.9c-0.1-0.3-0.3-0.6-0.4-0.8
		c2-1.1,4-2.1,6-3.2c0.2,0.4,0.4,0.8,0.6,1.2C63.8,297,61.7,297.9,59.7,298.9z M102.8,278.9c0.1,0.2,0.1,0.4,0.2,0.6
		c-0.7,0.3-1.5,0.5-2.2,0.8c-0.1-0.2-0.2-0.5-0.2-0.7C101.3,279.4,102,279.1,102.8,278.9z M136.1,222.2c0.1,0.2,0.2,0.5,0.4,0.7
		c-1.2,0.5-2.4,1-3.6,1.5c-0.1-0.3-0.2-0.5-0.3-0.8C133.7,223.2,134.9,222.7,136.1,222.2z M132.9,229.2c-0.6,0.3-1.2,0.6-1.8,1
		c-0.1-0.3-0.3-0.5-0.4-0.8c0.7-0.2,1.4-0.5,2.1-0.7C132.8,228.8,132.9,229,132.9,229.2z M128.3,219c0.8-0.1,1.5-0.2,2.3-0.2
		c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0.5-2.8,1.7-1.1,2.8-0.8c0,0.3,0,0.5,0.1,0.8c-0.9,0-1.9,0-2.8,0c0,0,0,0,0,0.1h-0.1
		c-0.4,1.1-0.9,2.3-1.3,3.4l0,0c0,0,0,0,0,0.1c0.9-0.1,1.9-0.2,2.8-0.2c0.1,0.2,0.1,0.5,0.2,0.7c-1.1,0.4-2.2,0.8-3.9,1.4
		c0.5-1,0.7-1.4,0.9-1.8l0,0v-0.1C127.1,221.8,128.8,220,128.3,219z M130.4,225.9c0,0.2-0.1,0.5-0.1,0.7c-1.1-0.2-2.2-0.4-3.4-0.5
		c0.1-0.3,0.1-0.7,0.2-1C128.2,225.3,129.3,225.6,130.4,225.9z M119.8,233.5c-0.2,0-0.5-0.8-1-1.5c3.2-0.2,5.9-0.4,8.5-0.6
		c0,0.4,0.1,0.8,0.1,1.2C125,233,122.4,233.3,119.8,233.5z M123.7,235.6l-0.1,0.2l0,0h-0.1c-0.6,1.5-1.6,1.7-2.8,1.2
		c-0.1-0.3-0.1-0.6-0.2-0.9c1-0.1,2-0.2,2.9-0.3c0,0,0,0,0-0.1L123.7,235.6z M119.3,240.1c-0.1,0.2-0.4,0.4-0.6,0.6
		c-0.1-0.2-0.2-0.4-0.4-0.6c0.3-0.2,0.5-0.3,0.8-0.5C119.2,239.7,119.4,240,119.3,240.1z M123.6,229c0,0.5,0,1,0,1.5
		c-0.2,0-0.4,0-0.5,0c0-0.5,0-1,0-1.5C123.2,229,123.4,229,123.6,229z M123.1,226.8c0-0.3,0-0.7,0-1c0.1,0,0.2,0,0.3,0
		c0,0.3,0,0.7,0,1C123.3,226.8,123.2,226.8,123.1,226.8z M120.7,222.2c1.2-3.2,3.2-2.9,7.1,0.2c-1.7,0.3-2.6,0.4-3.6,0.6l0.2-0.1
		l-0.1,0.1c-0.8-1.6-2.1-0.5-3.2-0.5c0.5,0.3,1,0.7,1.8,1.2C120.4,223.7,120.4,223.7,120.7,222.2z M119.2,219.9L119.2,219.9
		c0.5-0.1,0.9-0.2,1.4-0.3c-0.3,0.3-0.6,0.5-1,0.8c-0.8,0.3-1.6,0.5-2.3,0.8c-0.1-0.2-0.1-0.5-0.2-0.7
		C117.7,220.2,118.4,220.1,119.2,219.9z M118.8,225.8c-1,0.3-1.8,0.5-2.8,0.8C116.9,224.4,116.9,224.4,118.8,225.8z M113.8,221.2
		c0.8,0.7,1.6,1.3,2.7,2.2C113.2,223.8,112.9,223.5,113.8,221.2z M115.2,232.1c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1-0.2-0.1-0.4-0.2-0.6
		c0.2-0.1,0.4-0.1,0.5-0.2C115.1,231.7,115.3,232,115.2,232.1z M110.2,224.9c1.7,0.2,2.7,0.3,3.8,0.4
		C112.3,227.5,112.3,227.5,110.2,224.9z M111.8,233.2c-0.2,0.1-0.4,0.3-0.5,0.3c-0.2-0.1-0.2-0.3-0.3-0.5c0.1-0.1,0.4-0.3,0.4-0.3
		C111.5,232.8,111.6,233,111.8,233.2z M111.4,220.6c0.3,0.3,0.7,0.7,1,1c-0.6,0.6-1.2,1.2-1.8,1.7c-0.3-0.3-0.7-0.6-1-1
		C110.3,221.8,110.8,221.2,111.4,220.6z M107.3,218.7c0.7-0.4,1.4-0.7,2-1.1c0.1,0.3,0.2,0.6,0.3,0.8c-0.7,0.1-1.5,0.2-2.2,0.4
		c-0.2,0.1-0.4,0.1-0.7,0.2C107,218.9,107.2,218.8,107.3,218.7z M108.9,220.1c0.1,0.2,0.3,0.5,0.4,0.7c-0.7,0.4-1.5,0.9-2.2,1.3
		c-0.2-0.3-0.3-0.5-0.5-0.8C107.4,221,108.1,220.5,108.9,220.1z M108.5,225.8c-0.5,0-1,0-1.5,0c0-0.2,0-0.3,0-0.5c0.5,0,1,0,1.5,0
		C108.5,225.4,108.5,225.6,108.5,225.8z M105.7,236.2c0.7-0.7,1.5-1.3,2.6-2.4c0.1,1.4,0.2,2.1,0.3,3.3c2.4-1.4,4.6-2.5,7-1.2
		c0.7,0.4,1.7,1.1,1.7,1.6c-0.1,2.8-3,4-5.8,1.8c2.5,1.1,3.9,0.5,4.5-2.7c-2.3,0.3-4.5,0.5-6.5,1c-1.5,0.4-2.7,0.7-3.5-1
		c-0.2,0.1-0.5,0.2-0.7,0.3C105.5,236.6,105.6,236.4,105.7,236.2z M109.4,239.5c-0.3,0.4-0.5,0.9-0.8,1.3c-0.2-0.1-0.3-0.2-0.5-0.3
		c0.3-0.4,0.6-0.9,0.8-1.3C109.1,239.3,109.3,239.4,109.4,239.5z M104.8,221.7c-0.2,0.5-0.4,0.8-0.4,0.8c-0.3-0.1-0.6-0.3-0.9-0.5
		C103.9,221.9,104.2,221.8,104.8,221.7z M103.7,225.2C103.7,225.1,103.7,225.1,103.7,225.2c0.2-0.1,0.2-0.1,0.3-0.2
		c0.2-0.2,0.3-0.4,0.5-0.7c0.3-0.2,0.5-0.4,0.8-0.6l0,0l0,0l0.2-0.1l-0.2,0.1l0,0c-0.2,0.3-0.4,0.5-0.6,0.8l0,0
		c-0.2,0.2-0.4,0.3-0.7,0.5c0,0.1-0.1,0.1-0.1,0.2C103.8,225.2,103.8,225.1,103.7,225.2c0.1-0.1,0.2,0,0.2,0
		C103.8,225.2,103.7,225.2,103.7,225.2c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1-0.2-0.1-0.3-0.2-0.5C103,225.2,103.3,225.2,103.7,225.2z
M104,239.4c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0.1-0.4,0.2-0.6,0.4
		c0.1-0.2,0.2-0.5,0.3-0.7c0.3-0.2,0.5-0.4,0.8-0.6c0.1-0.2,0.3-0.3,0.4-0.5C104.1,238.9,104,239.2,104,239.4
		C104,239.4,103.9,239.4,104,239.4C103.9,239.4,104,239.4,104,239.4z M103.7,232.3c0,0-0.4,0.1-0.5,0c-0.1-0.2-0.1-0.4-0.1-0.6
		c0-0.1,0.3-0.2,0.6-0.4C103.7,231.7,103.7,232,103.7,232.3z M103.2,234.1c-0.4,0.8-0.6,1.2-0.8,1.6l0,0c0.4,0.3,0.8,0.6,1.2,0.9
		c-0.1,0.2-0.2,0.5-0.3,0.7c-1-1.3-3.6,2.3-3.7-1.7c0,0,0,0-0.1,0l0,0c-0.4,0.4-0.8,0.9-1.5,1.7c0-1-0.1-1.7,0.1-2.2
		c0.1-0.4,0.7-0.5,1.3-0.9c0.1,0.7,0.1,1.1,0.2,1.4c0,0,0,0,0.1-0.1l0,0C100.7,235.2,101.7,234.8,103.2,234.1z M98.8,225.2
		c0,0,0-0.1,0.1-0.1s0.1,0,0.2-0.1c0.6-0.5,1.2-1,1.8-1.5c0.2,0.3,0.3,0.5,0.5,0.8c-0.7,0.3-1.5,0.5-2.2,0.8l-0.1,0.1
		C98.8,225.1,98.8,225.2,98.8,225.2c-0.2,0.6-0.5,1.2-0.7,1.8c-0.3-0.2-0.5-0.4-0.8-0.5C97.8,226,98.3,225.6,98.8,225.2z
M96.3,236.9c0.1,0.1,0.3,0.2,0.3,0.3s-0.2,0.3-0.3,0.4c-0.1-0.2-0.2-0.3-0.2-0.5C96.1,237,96.3,236.9,96.3,236.9z M98,241.2
		L98,241.2C98.1,241.3,98,241.2,98,241.2c0.4-0.1,0.8-0.3,1.2-0.4c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.2l-0.1,0.2c-0.1,0-0.2,0.1-0.3,0.1
		c-0.3,0.2-0.7,0.4-1,0.6c-1.4,2.7-3.9-0.8-5.5,1.1C94.1,240.1,95.8,239.7,98,241.2z M93,247c-0.3,0.4-0.5,0.9-0.8,1.3
		c-0.2-0.2-0.5-0.3-0.7-0.5c0.4-0.4,0.8-0.8,1.1-1.2C92.8,246.8,92.9,246.9,93,247z M93.6,225.9c0.3,0.1,0.6,0.2,0.9,0.4
		c-0.3,0.5-0.5,0.9-0.8,1.4c-0.2-0.1-0.3-0.2-0.5-0.3C93.3,226.8,93.4,226.4,93.6,225.9z M94.9,233.5c0.2,0.2,0.4,0.4,0.5,0.6
		c-0.8,0.7-1.5,1.4-2.3,2.1c-0.2-0.2-0.4-0.5-0.6-0.7C93.3,234.8,94.1,234.1,94.9,233.5z M92.5,245.2c-1.4,1-2.5,1.9-3.7,2.8
		C89.6,246.5,90,244.4,92.5,245.2z M87.8,242.5c-0.2-0.3-0.4-0.7-0.6-1c0.7-0.5,1.5-0.9,2.2-1.4c0.2,0.3,0.4,0.7,0.6,1
		C89.3,241.5,88.6,242,87.8,242.5z M91.1,234.8c-0.2,0.5-0.5,0.9-0.7,1.4c-0.2-0.2-0.4-0.3-0.6-0.5c0.3-0.4,0.6-0.8,0.9-1.2
		C90.9,234.6,91,234.7,91.1,234.8z M90,226.9c0.2,0.3,0.4,0.6,0.6,0.9c-0.6,0.4-1.1,0.7-1.7,1.1c-0.2-0.2-0.3-0.5-0.5-0.7
		C88.9,227.7,89.5,227.3,90,226.9z M87.5,224.2c0.2,0.3,0.4,0.6,0.4,0.8c0,0.1-0.4,0.3-0.5,0.3c-0.3-0.1-0.5-0.3-0.7-0.5
		C86.9,224.6,87.1,224.4,87.5,224.2z M87.7,234.2c0.1,0.2,0.2,0.5,0.3,0.7c-0.6,0.3-1.2,0.5-1.8,0.8c-0.1-0.3-0.2-0.5-0.3-0.8
		C86.5,234.7,87.1,234.4,87.7,234.2z M86.2,239.5c0.4-0.1,0.8-0.1,1.3-0.1c0,0,0,0,0-0.1c0,0,0,0,0.1,0c0-0.7-0.1-1.4-0.2-2.7
		c0.9,0.8,1.3,1.2,1.8,1.7c-0.7,0.4-1.2,0.7-1.7,1v0.1h-0.1c-0.4,0.9-0.8,1.8-1.5,3.4c-0.8-1.2-1.2-1.9-1.7-2.7
		C85,239.9,85.6,239.6,86.2,239.5z M82.1,235.2c0.4,0.1,0.7,0.3,1,0.5c-0.2,0.2-0.3,0.7-0.5,0.7c-0.4,0-0.7-0.2-1.3-0.3
		C81.7,235.6,82,235.2,82.1,235.2z M78.3,241.3C78.4,241.4,78.4,241.4,78.3,241.3c0.5-0.2,0.9-0.4,1.4-0.7c-0.1-0.6-0.3-1.7-0.2-1.7
		c1.1-0.4,2.3-0.6,3.5-0.8C82,240.6,81.3,242.9,78.3,241.3C78.4,241.4,78.4,241.4,78.3,241.3L78.3,241.3
		C78.4,241.4,78.4,241.4,78.3,241.3c0,0.1-0.1,0.1-0.2,0.1C78.2,241.4,78.3,241.4,78.3,241.3z M82,245.4c-0.6,0.9-0.8,1.5-0.9,1.4
		c-0.5-0.1-0.9-0.4-1.4-0.6C80.2,246,80.8,245.8,82,245.4z M78,239.6c-0.2,0.1-0.3,0.3-0.5,0.3s-0.3-0.2-0.5-0.3
		c0.2-0.1,0.3-0.3,0.5-0.3C77.6,239.3,77.8,239.5,78,239.6z M77,223.7c-1.6,2.9-1.6,2.9-3.2,1.8C74.7,225,75.6,224.5,77,223.7z
M76.2,236.8c0.1-0.3,0.3-0.5,0.5-0.8c0,0.4,0.1,0.7,0.2,1.4C76.5,237.1,76.2,236.9,76.2,236.8z M76.5,247.6
		c-0.1,0.3-0.3,0.6-0.5,0.7c-0.2,0.1-0.5-0.2-1-0.4c0.7-0.5,1-0.7,1.2-0.8C76.2,247.1,76.5,247.5,76.5,247.6z M75.4,236.1
		c-0.1,1.2-0.2,1.8-0.1,2.4c0,0.6,0.2,1.2,0.3,1.8c-1.1-1.1-2.6,2.1-3.6-0.3c-0.5-0.3-0.9-0.5-1.6-0.9
		C72.2,238,73.6,237.1,75.4,236.1z M74.3,246.6c-0.2,0.4-0.6,0.8-1,1.1c-0.3-0.3-0.5-0.6-0.9-1.1c0.5-0.4,0.8-0.9,1.1-0.9
		C73.8,245.8,74.3,246.4,74.3,246.6z M69.3,223.9c0.2,0.2,0.5,0.4,0.7,0.6c-0.6,0.7-1.2,1.4-1.7,2.1c-0.2-0.2-0.5-0.4-0.7-0.6
		C68.1,225.2,68.7,224.5,69.3,223.9z M62.9,238.8c0.4-0.1,0.8-0.2,1.2-0.3c0,0.2,0.1,0.5,0.1,0.7c-0.4,0.1-0.8,0.1-1.2,0.2
		C62.9,239.2,62.8,238.8,62.9,238.8z M65.5,244.9c0.1-1.9,1.4-1.8,2.7-1.3c0.8,0.3,1.6,0.6,2.7,1c0.2,2.6-0.2,3-3.1,2.6l0,0
		c-0.6,0-1.1,0-1.7,0c-0.2,0.1-0.4,0-0.6-0.2l0.1,0.1l0,0l-0.1,0.1v-0.1c-1.4-0.6-2.9-1.1-4.5-1.8C62.4,242.9,63.9,243.3,65.5,244.9
		z M60.7,248.3c0.5,0.6,1.1,1.3,1.6,2c-0.5,0.3-1.1,0.5-1.9,0.9c0-1.1,0-1.7,0-2.4c-0.5,0.1-1.1,0.1-1.6,0.2c0-0.3,0-0.6,0-0.8
		C59.5,248.2,60.1,248.3,60.7,248.3L60.7,248.3z M59.6,243.9c0.2,0.2,0.3,0.4,0.5,0.5c-0.4,0.4-0.9,0.8-1.3,1.2
		c-0.2-0.2-0.3-0.3-0.5-0.5C58.8,244.7,59.2,244.3,59.6,243.9z M56.4,248.7c0,0,0.2,0.1,0.3,0.1c-0.2,0.3-0.3,0.7-0.5,1
		c-0.2-0.1-0.3-0.2-0.5-0.3C56,249.2,56.2,248.9,56.4,248.7z M55.5,254.7c0.1,0,0.1,0,0.2,0c1.4-0.5,2.8-1.1,4.6-1.8
		c-1.2,2.6-3,1.8-4.6,1.8C55.7,254.7,55.7,254.7,55.5,254.7c0,0.1,0,0.1,0,0.1c-0.2,0.7-0.4,1.4-0.5,2.1c0,0,0,0,0.1,0L55,257
		c0.6-0.3,1.2-0.6,1.9-0.9c-0.1,2.6-0.1,2.6-2.6,1.5c0,0,0,0-0.1,0.1v-0.1c-0.7,0.3-1.3,0.5-2,0.8c-0.1-0.2-0.3-0.5-0.4-0.7
		C53,256.7,54.3,255.8,55.5,254.7C55.5,254.8,55.5,254.7,55.5,254.7z M58.3,257c-0.1,0-0.2,0-0.4-0.1c0-0.1,0.1-0.2,0.1-0.3
		c0.1,0,0.2,0,0.2,0.1C58.3,256.8,58.3,256.9,58.3,257z M54.1,259.6c0.2-0.1,0.5-0.2,0.7-0.3c-0.1,0.2-0.2,0.5-0.3,0.7
		c-0.7,0.7-1.5,1.4-2.2,2c-0.2-0.3-0.4-0.6-0.6-0.8C52.5,260.6,53.3,260.1,54.1,259.6c0.1,0.1,0.2,0.2,0.3,0.3
		C54.3,259.8,54.2,259.7,54.1,259.6z M54.1,248.9c0.2-0.1,0.5-0.2,0.7-0.3c-0.1,0.2-0.3,0.5-0.4,0.7l0,0c-0.4,0-0.7,0.1-1.1,0.1
		c0-0.5-0.1-1-0.1-1.5c0.2,0.3,0.4,0.7,0.6,1l0,0H54.1z M52.7,246.1c0.2,0,0.4,0.1,0.6,0.2c-0.2,0.2-0.4,0.4-0.5,0.7
		c-0.1-0.1-0.3-0.2-0.4-0.4C52.4,246.4,52.5,246.2,52.7,246.1z M48.9,246.9c0.1,0.2,0.2,0.3,0.3,0.5c0,0-0.2,0.1-0.2,0.2
		c-0.1-0.2-0.2-0.3-0.3-0.5C48.8,247.1,48.8,247,48.9,246.9z M46.1,251.1c-0.5,0.4-1,0.7-1.5,1.1c0.5,0.6-0.1,2.4,1.7,1.7
		c1.2-0.8,2.5-1.7,4.1-2.8c-0.2,1.1-0.2,1.7-0.3,2.3c0,0,0,0,0.1,0c0,0,0,0,0,0.1c0.6,0.2,1.2,0.3,2.2,0.6c-0.6,0.8-1.2,1.6-1.7,2.3
		c-0.3-0.1-0.6-0.2-0.9-0.4c0.2-0.8,0.3-1.7,0.5-2.5c0,0,0,0-0.1,0l0,0c-1.2,0.3-2.3,0.5-3.5,0.8c0.3,0.4,0.6,0.8,0.9,1.2
		c-1.2,0.4-2.3,0.8-4.2,1.5c0.9-2.3-1.5-3.9,0.9-5.1c0.6-0.4,1.1-0.7,1.7-1.1C46,250.8,46,251,46.1,251.1z M50.4,259.2
		c0,0-0.2,0.3-0.5,0.6c-0.2-0.3-0.4-0.5-0.5-0.8c0-0.1,0.2-0.3,0.3-0.5C49.9,258.7,50.2,258.9,50.4,259.2z M45.8,258.2
		c-0.5,0.7-1,1.5-1.5,2.2c-0.2-0.1-0.4-0.3-0.6-0.4c0.5-0.7,1-1.5,1.5-2.2C45.4,258,45.6,258.1,45.8,258.2z M44.1,243.2
		c0.2,0.3,0.4,0.7,0.6,1c-0.4,0.2-0.9,0.4-1.3,0.6c-2,0.5-4.5-0.4-6,1.8c-0.2-0.6-0.5-1.1-0.7-1.7c0,0,0,0-0.1,0l-0.1-0.1
		c-0.3-0.1-0.5-0.1-0.8-0.2c0.1-0.1,0.1-0.2,0.2-0.3c0.2,0.2,0.4,0.3,0.6,0.5c0.1,0,0.1,0,0.2,0l0,0
		C39.2,244.3,41.6,243.8,44.1,243.2z M39.5,254.9c0.8,0.2,1.4,0.4,2,0.6l0,0l0.1-0.1l-0.1,0.1c0,0,0,0-0.1,0
		C40.3,256.2,40.2,256.2,39.5,254.9z M40.7,259.1c-0.1,0.3-0.3,0.6-0.4,0.9c-0.3,0.4-0.6,0.9-1,1.3c-0.2-0.1-0.3-0.2-0.5-0.3
		c0.4-0.5,0.7-0.9,1.1-1.4C40.2,259.4,40.5,259.3,40.7,259.1z M41.5,263.8c0.1-0.2,0.3-0.2,0.5-0.4c0.1,0.2,0.1,0.4,0.2,0.6
		c-0.2,0.1-0.3,0.2-0.5,0.3C41.6,264.1,41.5,263.9,41.5,263.8z M41.7,246.9c-0.1-0.1-0.3-0.3-0.3-0.4c0.1-0.3,0.3-0.5,0.5-0.8
		c0.2,0.3,0.4,0.5,0.3,0.6C42.1,246.6,41.9,246.7,41.7,246.9z M36.5,254.1c-0.9,0.5-1.7,1.1-2.6,1.6c-2.1,2.6-5,2.2-7.9,1.9
		c2.5-0.8,5-1.5,7.5-2.3C34.1,253.8,35.1,253.5,36.5,254.1L36.5,254.1c0.1,0,0.2,0,0.2,0c0.6-0.2,1.3-0.4,1.9-0.6c0,0.3,0,0.6,0.1,1
		c-0.7-0.1-1.3-0.2-2-0.3h-0.1C36.6,254.1,36.5,254.1,36.5,254.1z M35.1,259.2c0.3-0.8,0.6-1.5,0.9-2.4
		C36.9,258.7,36.9,258.7,35.1,259.2z M33.9,258.5c-0.2,0.3-0.4,0.7-0.7,1c0.1-0.5,0.1-0.9,0.2-1.4c0.3-0.2,0.6-0.4,0.8-0.6
		C34.2,257.9,34.1,258.2,33.9,258.5L33.9,258.5z M32.9,261.7c0,0.2-0.1,0.4-0.2,0.6c-0.1-0.1-0.2-0.2-0.3-0.4
		c0.1-0.1,0.2-0.3,0.3-0.4C32.8,261.6,32.9,261.7,32.9,261.7z M33.7,245.9c0,0-0.3,0.2-0.5,0.3c-0.1-0.4-0.2-0.8-0.4-1.2
		c-0.5-1.1-0.5-1.1,1.5-1.6c-0.4,0.5-0.8,0.9-1.2,1.4C33.4,245.2,33.6,245.5,33.7,245.9z M36.3,240.4c0.3,0,0.5,0,0.8,0
		c0.4,1,0.8,1.9,1.3,3.2c-0.8-0.3-1.2-0.4-1.6-0.5c-0.3,0.1-0.7,0.2-1,0.3c0.2-0.3,0.3-0.6,0.5-0.9
		C36.3,241.8,36.3,241.1,36.3,240.4z M35.6,224.6c0.1-0.1,0.4,0.1,0.5,0.2c-0.1,0.2-0.2,0.4-0.3,0.5s-0.3-0.1-0.4-0.1
		C35.4,225,35.4,224.7,35.6,224.6z M32.9,226.4c0.2-0.5,0.3-1,0.5-1.5c0.2,0.1,0.3,0.2,0.5,0.2c-0.2,0.5-0.5,1-0.7,1.5l0,0
		c-0.1,0.6-0.2,1.2-0.3,1.8c0.8-0.2,1.5-0.3,2.2-0.4c0,0,0,0,0.1-0.1c0.2-0.1,0.4-0.2,0.6-0.3c-0.2,0.1-0.3,0.2-0.5,0.3l-0.1-0.1
		l0.1,0.1h-0.1c-1,1.5-2.2,2.4-4.6,1.7C31.4,228.4,32.2,227.4,32.9,226.4z M29.9,226.6c0.1,0.1,0.2,0.1,0.2,0.2
		c0,0.1-0.1,0.2-0.2,0.2c-0.1-0.1-0.2-0.1-0.2-0.2C29.7,226.8,29.8,226.7,29.9,226.6z M28.3,244.7c1.6-0.8,2.5-0.4,2.5,1.6
		c-1.4,0.6-2.5,0.4-3-1.2c-1.1,0.2-2.1,0.5-3.1,0.7C25.7,243.3,26.5,243,28.3,244.7z M25.2,226.6c0,0,0-0.1,0.1-0.1l0.1-0.1
		c0.1-0.2,0.2-0.4,0.2-0.6c0.1,0.1,0.2,0.1,0.2,0.2c-0.2,0.1-0.3,0.3-0.5,0.4v0.1C25.3,226.6,25.2,226.6,25.2,226.6
		c-0.8,1.3-1.6,2.7-2.6,4.4C21.9,228.1,23.8,227.5,25.2,226.6z M23.1,244.4c0.2-0.4,0.3-0.8,0.5-1.2c0.1,0.1,0.3,0.3,0.4,0.4
		c-0.1-0.1-0.3-0.3-0.4-0.4c0.2,0,0.4-0.1,0.6-0.1c-0.1,0.2-0.1,0.4-0.2,0.5c-0.1,0.3-0.2,0.6-0.4,0.9
		C23.6,244.6,23.3,244.5,23.1,244.4z M23.6,268c-0.7,0.4-1.4,0.8-2.1,1.2c-0.1-0.2-0.3-0.5-0.4-0.7c0.7-0.4,1.5-0.7,2.2-1.1
		C23.4,267.6,23.5,267.8,23.6,268z M22.2,245.4c0.1,0.3,0.3,0.7,0.4,1c-0.8,0.2-1.7,0.5-2.5,0.7c-0.1-0.2-0.1-0.4-0.2-0.7
		C20.6,246.1,21.4,245.7,22.2,245.4z M17.8,245c0,0.2,0,0.3,0,0.5c0,0-0.2,0.1-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.4
		C17.4,245.1,17.6,245,17.8,245z M18.4,265.7c0.2,0.2,0.5,0.4,0.7,0.6c-0.9,0.9-1.7,1.8-2.6,2.8c-0.2-0.2-0.3-0.3-0.5-0.5
		C16.8,267.7,17.6,266.7,18.4,265.7z M15.3,246.4c0.2,0.1,0.5,0.2,0.7,0.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.2-0.1-0.4-0.1-0.5-0.3
		C15.1,246.9,15.3,246.6,15.3,246.4z M13.5,262.6c0.4,0.1,0.9,0.1,1.3,0.2c0,0.2,0,0.3-0.1,0.5c-0.4-0.1-0.9-0.1-1.3-0.2
		C13.5,262.9,13.5,262.8,13.5,262.6z M10.2,270.2c0.4-0.8,0.7-1.6,1.1-2.4c0.2,0.1,0.5,0.2,0.7,0.4c-0.5,0.8-0.9,1.6-1.4,2.4l0,0
		c-0.2,0.1-0.5,0.2-0.7,0.3C10,270.6,10.1,270.4,10.2,270.2z M6.4,272.7c-0.2-0.2-0.3-0.3-0.5-0.5C6.1,272.4,6.2,272.6,6.4,272.7
		c-0.2,0.9-0.3,1.7-0.5,2.6c-0.3-0.1-0.7-0.2-1-0.3c0.3-0.9,0.7-1.8,1-2.7c0.3-0.2,0.6-0.4,0.9-0.6C6.7,272,6.6,272.4,6.4,272.7z
M41.6,291.2c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1C43.1,290.8,43,291,41.6,291.2z M73.2,292.4
		c-0.3,0.3-0.7,0.6-1,0.9c-1,0.4-2,0.8-3,1.2c-0.1-0.3-0.2-0.5-0.3-0.8c1-0.3,1.9-0.5,2.9-0.8c0.1,0.1,0.2,0.3,0.3,0.4
		c-0.1-0.1-0.2-0.3-0.3-0.4C72.3,292.7,72.8,292.6,73.2,292.4l0.1-0.1l0,0C73.3,292.4,73.3,292.4,73.2,292.4z M75.7,291.5
		c-0.1,0-0.1,0.1-0.2,0.1s-0.2,0-0.2,0c0.1,0,0.1-0.1,0.2-0.1C75.6,291.6,75.7,291.5,75.7,291.5c0.9-0.5,1.8-1,2.7-1.4
		c0.1,0.3,0.2,0.7,0.3,1C77.8,291.2,76.7,291.4,75.7,291.5z M95,282.9c0.3-0.2,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.6-0.3
		c-0.2,0.1-0.3,0.2-0.5,0.3l0,0l0,0C95.7,282.6,95.4,282.7,95,282.9c-1.7,0.9-3.5,1.7-5.2,2.6c-1.3,0.7-2.6,1.3-4,2
		c-0.1-0.3-0.2-0.6-0.3-0.9c1.3-0.5,2.7-0.9,4-1.4C91.4,284.4,93.2,283.6,95,282.9z M93.5,279.5c0.1,0.2,0.3,0.5,0.4,0.7
		c-0.7,0.3-1.4,0.6-2,0.9c-4,2-7.9,4.2-12,6.1c-1.6,0.8-3.4,1.1-5.1,1.6c-0.1,0-0.1,0-0.2,0c0.1,0,0.1,0,0.2,0.1
		c-0.5,0-0.9,0-1.4,0.1c0.6-0.7,1.1-1.8,1.8-2.1c2.7-1.1,5.5-1.8,8.3-2.8c2.7-1,5.4-2.1,8.1-3.1C92.2,280.4,92.9,279.9,93.5,279.5z
M130.7,275.9c0-0.1,0-0.1,0-0.2c0.1,0,0.1,0,0.2,0v0.1C130.8,275.9,130.8,275.9,130.7,275.9z M127.1,267.4l0.1,0.1
		C127.1,267.5,127.1,267.4,127.1,267.4c0.4-0.2,0.9-0.3,1.3-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0l0,0c0.7-0.5,1.4-0.9,2.1-1.4
		c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c0,0.1,0,0.2,0,0.2h-0.1l-0.1,0.1c-0.7,0.5-1.4,0.9-2.1,1.4c-0.1,0-0.2,0.1-0.2,0.1
		c-0.4,0.2-0.7,0.5-1.1,0.7c-2.1,1-4.1,2-6.2,3l0,0c-0.5,0.2-1,0.5-1.4,0.7c-0.8,0.4-1.5,0.8-2.3,1.2c-0.2,0.1-0.5,0.3-0.7,0.4
		c0.2-0.2,0.3-0.4,0.5-0.7c0.7-0.5,1.4-0.9,2.2-1.4c0.5-0.2,0.9-0.5,1.4-0.7C122.8,269.3,124.9,268.3,127.1,267.4z M141.7,235.2
		c-1.3,1.2-2.3,2.1-3.3,3c-0.8,0.7-1.7,1.3-2.6,1.7c-2.7,1-5.7,1-8,3.1c-1,0.9-2.5,1.3-3.9,1.7c-5.1,1.3-10.4,2.3-15.4,3.8
		c-4.3,1.3-8.4,3.2-12.7,4.7c-2.7,0.9-5.5,1.8-8.3,2.3c-1.1,0.2-2.4-1-3.7-1.1c-2.5-0.2-5-0.1-7.5-0.1c-1.9,2.1-4.4,2.2-7,2.1
		c-0.2-0.1-0.3-0.3-0.5-0.4c0.2,0.1,0.3,0.3,0.5,0.4c-0.3,0.2-0.5,0.5-0.8,0.7c2.4,1.1,5.2-0.9,7.6,1c0.1,0.1,0.8-0.5,1.2-0.8
		c2.1-1.7,4.5-2.4,7.3-1.3c-0.7,0.7-1.5,1.3-2.3,1.5c-2.1,0.6-4.4,1-6.4,1.7c-1,0.3-1.7,1.7-2.6,2c-4.2,1.1-8.6,1.9-12.8,2.9
		c-4.2,0.9-8.4,1.8-12.5,2.7c-0.6,2.1-1.8,3.4-4.2,3.1c-3.1-0.4-5.9,0-8.6,1.7c-0.4,0.3-1.3-0.3-2-0.5c-0.9,0.6-1.7,1.6-2.8,1.8
		c-7.2,2-14.5,3.9-21.8,5.8c-0.5,0.1-1.1-0.2-1.9-0.4c3-2.9,4.5-7.2,9.6-7.2c-0.3,1-0.5,1.7-1.1,3.3c2.5-1.4,4.3-2.5,6.3-3.7
		c0.2,0.2,0.5,0.6,0.9,1.1c0.9-0.8,1.9-1.6,3-2.5c0.3,0.8,0.6,1.3,0.8,1.8c0.5-0.5,1.3-1.4,1.4-1.3c1.9,1.6,2.8-0.3,4-1
		c1.6-2.2,2-0.8,2.5,0.7c0.3,0,1,0.1,1,0c1-2.8,4.3-2.1,5.9-4c0.2-0.3,1.1-0.1,2.2-0.2c-1,1.1-1.7,1.8-2.8,3.1
		c1.9-0.5,3.2-0.9,3.7-1c0.2-1.6,0.3-2.8,0.5-3.9l0,0c0-0.1,0-0.2,0.1-0.3l0,0l0,0l0,0c0.8-0.3,1.6-0.7,2.8-1.2
		c-0.3,1.2-0.5,1.6-0.5,1.7c7.2-0.4,13.9-2.7,21.1-6.3c-1.4-0.3-2.2-0.4-2.9-0.5l0,0l0,0c-1.6,1.2-3,2.9-5.4,1.2
		c1.5-1,2.8-2,4.2-2.9c0.5,0.6,0.9,1.2,1.2,1.7l0,0c0,0,0,0,0.1,0c1.6-2.3,4.7-3.5,7.1-2.8l0,0c0.8-0.7,1.2-2.7,2.8-0.8l0.2-0.1
		l-0.1,0.2c0.4,0.2,0.8,0.3,1.2,0.5c1.4-2.2,3.7-1.6,5.8-1.9c0,0,0,0,0.1,0c1.8-0.8,3.5-1.9,5.4-2.3c1.8-0.4,3.8-0.1,5.9-0.1
		c0.1,0.4,0.1,1.1,0.2,1.7c0.8-0.9,1.6-1.9,2.7-3.2c1.1,0.4,2.5,0.8,4.2,1.3c0.1-0.1,0.6-0.4,1-0.8c0.5-0.5,0.8-1.1,1.2-1.6l0,0
		c-0.4,0-0.9,0-1.3,0.1c-0.1,0.1-0.2,0.2-0.3,0.2c0.1-0.1,0.2-0.2,0.2-0.3c0.5,0,1,0,1.5,0c2.7-2.1,3.1-2,3.6,1.2
		c0.8-1,1.4-1.8,2-2.5l0,0c0-0.1,0-0.1,0-0.2c-0.4-0.4-0.9-0.8-1.3-1.2c0.3-0.2,0.5-0.3,0.8-0.5c0.2,0.6,0.3,1.1,0.5,1.7l0.1,0.1
		l0,0c2-0.4,4.3-1.8,5.8-1.8c3.3,0,5.6-2.4,8.7-2.6c1-0.1,1.2-1.5,0.5-2.5l-0.2-0.2l0.2,0.2c-0.6,0.3-1.3,0.7-1.9,1
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.3,0.2-0.5,0.3c0.2-0.1,0.3-0.2,0.5-0.3c0.1-0.1,0.3-0.2,0.4-0.2c0.6-0.4,1.1-0.8,1.7-1.2
		c2.9-1.4,2.9-1.4,5.7,2.9c1.7-1.8,3.3-3.6,4.9-5.3c0.5,0.2,1,0.5,1.6,0.7c0-1.4,0-2.7,0-3.9c0,0,0,0-0.1,0l0,0
		c-0.8,0.7-1.5,1.3-2,1.7c-1.6-0.5-2.8-0.8-4.4-1.3c2.1-0.7,3.8-1.4,5.5-1.8c0.1,0,0.5,0.9,0.8,1.4c0,0,0,0,0.1-0.1c0,0,0,0,0,0.1
		c0.9,0,1.2-2.6,2.8-0.5c0.5,0.6,2.5,0.1,3.9,0.1C141.7,233.7,141.7,234.7,141.7,235.2z M130.8,236.4c-0.4,1.1-0.8,1.9-1.2,2.8
		C128.2,237.6,128.2,237.6,130.8,236.4z M141.2,230.4c-0.5-0.3-1.3,0-2-0.1c-1.2-0.1-2.3-0.3-3.5-0.4c0-0.4,0-0.8,0-1.2
		c1.8-0.1,3.5-0.3,5.3-0.3c0.8,0,1.6,0.6,2.4,0.9l0,0l0,0c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0.1-0.2,0.3-0.3,0.4
		C143,230.3,142.6,231.3,141.2,230.4z M167.9,229.2c0,0-0.2,0.1-0.3,0s-0.2-0.2-0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.1
		C167.9,228.9,167.9,229.1,167.9,229.2z M194.1,224.2c-0.1,0-0.2-0.1-0.2-0.1c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0
		C194.3,224,194.2,224.1,194.1,224.2z M196.1,224.2c-0.1,0-0.1-0.1-0.2-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0.1,0.1,0.1,0.2,0.2
		C196.3,224.1,196.2,224.2,196.1,224.2z M213,205.4c0.1,0,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.3s-0.3-0.2-0.4-0.3
		C212.6,205.5,212.8,205.4,213,205.4z M213,209.6C213,209.6,212.9,209.6,213,209.6c-0.3,0.1-0.6,0.2-0.5,0.2c-0.1,0,0.2-0.1,0.4-0.2
		C212.9,209.6,212.9,209.6,213,209.6c0.4-0.2,0.9-0.5,1.3-0.7c0.1,0.2,0.2,0.5,0.2,0.7C214,209.6,213.5,209.6,213,209.6z M164.8,257
		c-0.3,0-0.7,0.1-1,0.1C164.2,256.5,164.5,256.7,164.8,257z M180.4,242c0-0.3-0.1-0.7-0.1-1c2.9-0.4,5.8-0.7,8.7-1.1
		c0,0.2,0,0.4,0,0.5C186.1,240.9,183.2,241.4,180.4,242z M207.3,240.6c-0.1-0.2-0.2-0.4-0.4-0.7c0.2-0.2,0.4-0.3,0.6-0.5
		c0.1,0.2,0.3,0.4,0.3,0.6C207.8,240.2,207.5,240.4,207.3,240.6z M211.4,262.1c0.3-0.3,0.5-0.6,0.7-0.9
		C212.5,262,212.5,262,211.4,262.1z M224.2,263.5c0.4-0.7,0.8-1.5,1.3-2.2c0.1,0.1,0.3,0.3,0.4,0.4
		C225.3,262.3,224.8,262.9,224.2,263.5c-0.3,0.6-0.7,1.2-1,1.7c-0.1-0.1-0.2-0.2-0.3-0.4C223.3,264.4,223.8,263.9,224.2,263.5z
M254.6,235.6L254.6,235.6C254.6,235.6,254.6,235.5,254.6,235.6C254.6,235.5,254.6,235.6,254.6,235.6z M269.2,210.2
		c2.4,0.1,4.8,0.3,7.2,0.4c0,0.4,0,0.7,0.1,1.1c-1.4,0.2-2.7,0.5-4.1,0.7c0,0,0,0.1-0.1,0.1h-0.1c-0.3,0.8-0.6,1.7-0.9,2.6
		c-0.7-0.4-1.3-0.7-2-1.1c0-0.3-0.1-0.6-0.1-0.9c1-0.2,2-0.4,3-0.6v-0.1h0.1c0.3-0.5,0.6-0.9,0.9-1.5c-1.5-0.1-2.8-0.1-4.2-0.2
		C269.2,210.6,269.2,210.4,269.2,210.2z M287.1,206.9c0.2,0,0.4,0.1,0.6,0.2c-0.1,0.1-0.1,0.3-0.2,0.3c-0.2,0-0.4-0.1-0.6-0.2
		C286.9,207,287,206.8,287.1,206.9z M278.7,197.4c0,0.2,0,0.5,0.1,0.7c-1.1,0.1-2.1,0.1-3.2,0.2c0-0.3-0.1-0.5-0.1-0.8
		C276.5,197.5,277.6,197.4,278.7,197.4z M426.1,228.7c0.8,0.1,1.6,0.2,2.4,0.2c0,0.2,0,0.4-0.1,0.6c-0.8-0.1-1.6-0.1-2.3-0.2
		C426.1,229.1,426.1,228.9,426.1,228.7z M375.6,196.2c0,0.1,0,0.3,0,0.4c-1.1,0-2.2,0-3.3,0c0-0.1,0-0.3,0-0.4
		C373.4,196.2,374.5,196.2,375.6,196.2z M328.4,191.8c1.4,0.1,2.8,0.1,4.1,0.4c2.9,0.7,5.8,2.2,8.7,2.2c4.9,0,8.8,3,13.4,3.7
		c0.5,0.1,1,0.7,1.4,1c-0.1,0.2-0.2,0.4-0.3,0.7c-2.6-0.8-5.3-1.7-7.9-2.5c-1.8-0.6-3.5-1.4-5.3-1.8c-4.1-0.9-8.3-1.6-12.5-2.5
		c-0.6-0.1-1.2-0.5-1.8-0.8C328.3,192.1,328.3,191.9,328.4,191.8z M354.7,202.8c-0.1,0.1-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.4-0.3
		c0.2-0.1,0.4-0.2,0.6-0.2C354.5,202.6,354.6,202.7,354.7,202.8z M350.4,202.6c0.7,0,1.4,0,2.2,0c0,0.1,0,0.3,0,0.4
		c-0.7,0-1.4,0-2.2,0C350.4,202.9,350.4,202.8,350.4,202.6z M350.1,200.9c0,0-0.1-0.1-0.2-0.2c0.1-0.1,0.2-0.2,0.2-0.2
		c0.2,0.1,0.3,0.2,0.5,0.2C350.5,200.8,350.3,200.9,350.1,200.9z M346.9,199.8c-0.1,0.1-0.1,0.3-0.2,0.4c-0.1-0.1-0.2-0.1-0.3-0.2
		c0.1-0.1,0.1-0.2,0.2-0.2S346.8,199.8,346.9,199.8z M343,198.5c0-0.1,0-0.2,0-0.3c-0.5-0.2-1-0.4-1.5-0.6c-0.6-0.1-1.2-0.3-1.8-0.4
		c0-0.1,0-0.2,0.1-0.3c0.7,0.2,1.3,0.3,2,0.5c0.4,0.3,0.9,0.5,1.3,0.8C343,198.3,343,198.4,343,198.5c0,0.2,0.1,0.4,0.1,0.6H343
		l-0.1,0.1c0,0-0.1,0-0.2,0c0.1,0,0.2-0.1,0.3-0.1l0.1-0.1C343,198.8,343,198.7,343,198.5z M337.3,196.9c0,0.2-0.1,0.4-0.1,0.6
		c-1-0.1-2.1-0.2-3.1-0.3c0.1-0.3,0.1-0.7,0.2-1C335.3,196.5,336.3,196.7,337.3,196.9z M318,190.1c1.6,0.4,3.2,0.8,4.7,1.2
		c-0.1,0.3-0.1,0.6-0.2,0.9c-1.6-0.4-3.2-0.8-4.8-1.1C317.9,190.7,318,190.4,318,190.1z M306.8,189.1c1.7,0,3.3,0,5,0
		c0,0.4-0.1,0.9-0.1,1.3c-1.7-0.2-3.3-0.4-5-0.6C306.7,189.6,306.8,189.3,306.8,189.1z M300.1,187.7c0.4,0.1,0.9,0.2,1.3,0.4
		c-0.1,0.2-0.1,0.4-0.2,0.6c-0.4-0.1-0.9-0.3-1.3-0.4C300,188.1,300,187.9,300.1,187.7z M197.4,181.3c0,0-0.1,0-0.1-0.1L197.4,181.3
		C197.3,181.2,197.3,181.3,197.4,181.3c0.1,0,0.1,0,0.2,0.1c0,0,0,0.1,0,0.2C197.5,181.5,197.4,181.4,197.4,181.3z M207,175.7
		c-4.5,1.2-7.1,0.9-8.9-0.7C200.9,175.3,203.6,175.5,207,175.7z M208.5,179.2c-0.1,0.3-0.1,0.6-0.2,0.9c-2.1-0.5-4.3-1-6.4-1.5
		c0.1-0.3,0.2-0.7,0.2-1C204.3,178.1,206.4,178.7,208.5,179.2z M198.7,178.8c0.6,0.3,1.3,0.7,1.9,1c0.1,0,0.1,0,0.2,0
		c0.1,0,0.1,0,0.2,0.1c0.8,0,1.5,0,2.3,0c-0.1,0.3-0.1,0.5-0.2,0.8c-0.7-0.3-1.4-0.5-2.1-0.8c-0.1,0-0.1,0-0.2,0l-0.1-0.1
		c-0.7,0-1.5-0.1-2.2-0.1C198.5,179.4,198.6,179.1,198.7,178.8z M204.2,184c-0.2-0.2-0.5-0.3-0.7-0.5c-0.8-0.4-1.5-0.9-2.3-1.3
		c-0.2-0.1-0.3-0.1-0.5-0.2l0,0c0,0,0,0-0.1-0.1c-0.3,0-0.5,0-0.8-0.1c0.1-0.1,0.1-0.3,0.2-0.4c0.2,0.2,0.4,0.3,0.6,0.5h0.1
		c0.1,0.1,0.3,0.2,0.4,0.2c0.8,0.4,1.7,0.7,2.5,1.1l-0.1,0.1c0.1-0.1,0.1-0.1,0.1-0.1c0.2,0.2,0.5,0.4,0.7,0.5
		C204.3,183.9,204.2,184,204.2,184z M221.6,206.8c-0.2-0.1-0.3-0.4-0.5-0.6c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.2,0.3,0.3,0.4,0.4
		C221.9,206.5,221.7,206.8,221.6,206.8z M227.1,205.3c0,0-0.1,0-0.1,0.1c-0.1,0-0.2,0-0.3,0c-0.9,0.3-1.7,0.5-2.6,0.8
		c0-0.3-0.1-0.5-0.1-0.8c0.9,0,1.8,0,2.7,0c0.1,0,0.1,0,0.2-0.1C226.9,205.3,227,205.3,227.1,205.3c0.4-0.2,0.8-0.4,1.2-0.6
		c0.1,0.2,0.1,0.4,0.2,0.6C228,205.3,227.5,205.3,227.1,205.3z M229.6,212.8c0,0.4,0.1,0.8,0.1,1.2c-2,0.2-4,0.4-5.9,0.5
		c0-0.2,0-0.4,0-0.5C225.7,213.7,227.6,213.2,229.6,212.8z M225.3,216.5c-1.3,2.4-3.2,2.2-5.3,1.7
		C221.8,217.7,223.6,217.1,225.3,216.5z M218,212.8c0.1,0.1,0.2,0.1,0.2,0.2c-0.1,0.1-0.2,0.3-0.3,0.4c0-0.1-0.1-0.2-0.1-0.3
		C217.9,213,218,212.9,218,212.8z M218.3,215.4c0.1,0,0.1-0.1,0.2-0.1c0.1,0,0.2,0,0.2,0c0.5-0.2,1.1-0.5,1.6-0.7
		c0.1,0.2,0.1,0.4,0.2,0.6c-0.6,0.1-1.2,0.1-1.8,0.2c-0.1,0-0.1,0.1-0.2,0.1C218.5,215.3,218.4,215.3,218.3,215.4
		c-0.5,0.3-1.1,0.7-1.6,1c-0.1-0.2-0.1-0.4-0.2-0.6C217.1,215.6,217.7,215.5,218.3,215.4z M214,247.5L214,247.5
		c0-0.1,0.1-0.1,0.1-0.1C214.1,247.5,214,247.5,214,247.5z M218.5,235.9c0,0-0.3-0.2-0.4-0.3c0.1-0.2,0.2-0.4,0.4-0.5
		s0.4,0.1,0.6,0.1C218.8,235.5,218.7,235.7,218.5,235.9z M229.3,229.8c-0.1-0.1-0.2-0.3-0.3-0.4c0.3-0.2,0.6-0.5,1-0.7
		c0.1,0.1,0.2,0.2,0.3,0.4C229.9,229.3,229.6,229.6,229.3,229.8z M231.8,229.1c-0.1-0.3-0.1-0.6-0.2-1c3.5,0.7,6.1-2.8,9.6-1.8
		c0.1,0.5,0.1,0.9,0.2,1.4C238.3,228.2,235.1,228.6,231.8,229.1z M239,203c0,0.3-0.1,0.5-0.1,0.8c-1,0-1.9,0-2.9,0
		c0-0.3,0-0.5,0-0.8C237,203,238,203,239,203z M235.5,199.9c-0.1-0.2-0.1-0.4-0.2-0.6c1-0.4,2.1-0.8,3.1-1.2
		c0.1,0.2,0.3,0.5,0.4,0.7C237.7,199.1,236.6,199.5,235.5,199.9z M237.9,212.9c-0.3,0-0.6,0.1-1,0.1l0,0l-0.1,0.1l0.1-0.1
		c0,0,0,0,0.1,0c0.3-0.2,0.5-0.3,0.8-0.5C237.8,212.7,237.8,212.8,237.9,212.9z M238.1,223.7c0.1,0.3,0.1,0.5,0.2,0.8
		c-1.5,0.4-3.1,0.9-4.6,1.3c-0.1-0.3-0.2-0.7-0.3-1C235,224.4,236.6,224.1,238.1,223.7z M236.8,220.7c0.2-0.3,0.4-0.6,0.5-0.8
		c0.4-0.2,0.9-0.3,1.3-0.5c0.1,0.2,0.1,0.3,0.2,0.5c-0.4,0.1-0.8,0.2-1.1,0.4C237.4,220.4,237.1,220.6,236.8,220.7z M236.7,226.1
		c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0-0.1-0.1-0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2C236.6,226,236.7,226.1,236.7,226.1z M240.2,224
		c0.1-0.1,0.2-0.2,0.2-0.2c0.2,0.1,0.4,0.2,0.5,0.3c-0.2,0.1-0.4,0.2-0.6,0.2C240.4,224.3,240.3,224.1,240.2,224z M242.1,230.4
		c-0.5-0.3-1-0.1-1.1,0.4c-0.2,0.5-0.2,1.1-0.3,1.7c-0.9,0.2-1.7,0.4-2.9,0.6c0.9-0.9,1.5-1.5,2.1-2.1c0.6-1.1,1.9-1.3,3-1.9
		c0.2,0.7,0.3,1.4,0.5,2.3C242.7,230.9,242.4,230.6,242.1,230.4z M243,223.6c-0.1,0-0.2-0.2-0.3-0.3c0.2-0.1,0.3-0.2,0.5-0.2
		c0.1,0,0.1,0.1,0.2,0.2C243.2,223.4,243.1,223.6,243,223.6z M243.5,232l0.1-0.1c0,0.1,0.1,0.1,0.1,0.2
		C243.7,232,243.6,232,243.5,232z M244.8,222.7l0.2-0.1v0.2L244.8,222.7z M240.6,219.7c0-0.2-0.1-0.5-0.1-0.7
		c1.7-0.3,3.4-0.5,5.2-0.8c0,0.2,0.1,0.5,0.1,0.7C244,219.1,242.3,219.4,240.6,219.7z M236.7,215.8c0-0.4,0-0.9,0.1-1.3
		c4.9,0.2,9.9,0.5,14.8,0.7c0,0.2,0,0.4,0,0.6C246.6,215.8,241.7,215.8,236.7,215.8z M244,201.7c-1.1,0.1-2.3,0.1-3.4,0.2l0,0
		c-0.4,0.2-0.9,0.4-1.3,0.5c-0.1-0.2-0.1-0.3-0.2-0.5c0.4-0.1,0.8-0.3,1.2-0.4C241.5,200.7,242.7,200.3,244,201.7z M240.6,197.9
		c0.2-0.2,0.4-0.4,0.5-0.6c0.3,0.2,0.4,0.3,0.6,0.4c-0.2,0.2-0.4,0.4-0.6,0.5C240.9,198.2,240.7,198,240.6,197.9z M244.3,211.2
		c0,0.3,0.1,0.7,0.1,1c-0.9,0-1.8,0-2.7,0c0-0.1,0.1-0.2,0.1-0.4C242.6,211.5,243.5,211.4,244.3,211.2z M247,210.5
		c0.1,0,0.2-0.1,0.3-0.1c0,0.1,0,0.3,0.1,0.4c-0.1,0-0.2,0-0.3,0C247,210.7,247,210.6,247,210.5z M249.5,210.4l0.1-0.2
		c0.2-0.1,0.4-0.1,0.5-0.2c-0.2,0.1-0.3,0.2-0.5,0.3L249.5,210.4z M248.5,218.7c-0.1-0.3-0.2-0.6-0.3-0.9c1.3-0.3,2.6-0.6,3.9-1
		c0.1,0.2,0.1,0.4,0.2,0.5C251,217.8,249.7,218.2,248.5,218.7z M254.6,233.4C254.6,233.4,254.6,233.3,254.6,233.4
		c0-0.1,0-0.1,0.1-0.1l0.1,0.1C254.7,233.4,254.7,233.4,254.6,233.4z M255.7,233.1C255.7,233,255.7,233,255.7,233.1
		C255.7,233,255.7,233,255.7,233.1C255.7,233,255.7,233,255.7,233.1z M259.6,227.7c0.2-0.3,0.5-0.6,0.7-0.9c0.1-0.1,0.2-0.3,0.3-0.4
		c0.1-0.1,0.1-0.1,0.2-0.2c0.4-0.3,0.9-0.2,1.4-0.2c0.1,0.4,0.1,0.9-0.5,1.1c-0.5,0.2-0.9,0.4-1.2,0.7c0.8,0.1,1.5,0.2,2.3,0.3
		c0,0.2-0.1,0.4-0.1,0.7c-0.9-0.1-1.8-0.2-2.8-0.2c-0.2,0.4-0.3,0.9-0.3,1.5c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.6-0.5-0.3-1-0.2c0.3-1,0.5-2,2-2.4c0.7-0.2,1.3-0.8,1.9-1.3c0.1-0.1,0.2-0.3,0.3-0.4
		c-0.4,0-0.8-0.1-1.1-0.1c0-0.3,0-0.6,0.1-0.8C258.5,227.6,259,227.6,259.6,227.7z M255.4,226.5c0-0.1,0.2-0.2,0.3-0.4
		c0.1,0.2,0.2,0.4,0.2,0.6c0,0.1-0.1,0.2-0.2,0.2C255.6,226.8,255.4,226.7,255.4,226.5z M256.6,223.1l0.1-0.1v-0.1
		c0-1.3,0-2.5,0-3.8c0.3,0,0.7,0.1,1,0.1c-0.3,1.2-0.7,2.4-1,3.6v0.1L256.6,223.1z M236.5,189.2c0.1,0,0.2,0,0.3-0.1
		c0,0.1,0,0.2-0.1,0.4c-0.1,0-0.2-0.1-0.3-0.1C236.5,189.4,236.5,189.3,236.5,189.2z M227.9,186.3c0.2,2.5,2.7,2.2,4.7,2.6l0.1,0.2
		l-0.1-0.1c0.2-0.5,0.5-0.9,0.5-0.9c1.6,1.4,3,2.6,4.4,3.8c0.5,0.4,1.1,0.8,1.6,1.2c-0.1,0.1-0.1,0.1-0.2,0.2
		c0.1-0.1,0.1-0.1,0.2-0.2c0.4,0.3,0.9,0.5,1.3,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2,0.2,0.5,0.5,0.7,0.7
		c2.9,1.5,6.6,2.1,7.1,6.3c0.2,0.5,0.4,1,0.7,1.5c0.3-0.4,0.6-0.9,1.1-1.6c0.9,1.2,1.6,2.1,2.3,3.1c0,0,0,0,0.1,0
		c0.2,0.5,0.5,1,0.7,1.5l0,0c0,0.1,0,0.1,0,0.2c0.3,0.6,0.6,1.2,0.9,1.8c0.4,0.8,0.8,1.5,1.2,2.3l0,0l0,0c0.2,0.2,0.5,0.5,0.7,0.7
		l0,0c0.2,0.5,0.5,0.9,0.7,1.4l0,0l0,0c0,0.1,0,0.1,0,0.2c0.5,1.1,0.9,2.1,1.4,3.2c-0.3,0.1-0.7,0.2-1,0.3c-0.1-1.2-0.2-2.3-0.4-3.5
		c0,0,0-0.1-0.1-0.1c-0.2-0.5-0.4-0.9-0.7-1.4l0,0c-0.2-0.2-0.5-0.5-0.7-0.7c-0.2,0-0.5,0-0.7-0.1l0.1,0.1c0,0,0,0-0.1,0
		c0,0.7,0,1.4-0.1,2v0.1c0,0.1,0,0.2,0,0.3c0.3,1.5,0.6,3,1,4.4c-0.3,0-0.6,0.1-1,0.1c0-1.5,0-3,0-4.5c0-0.1,0-0.1,0-0.2
		c0-0.1,0-0.1,0-0.2c-0.2-0.7-0.4-1.4-0.6-2c0,0,0,0-0.1,0l0.1-0.1c-0.5-0.6-1.1-1.3-1.6-1.9c0.1-0.1,0.2-0.2,0.3-0.3
		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.2-0.2-0.4-0.3-0.7c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0,0.4,0.1,0.6,0.1h-0.1c0,0,0,0,0.1,0
		c0-0.6,0-1.3,0-1.9c0,0,0-0.1-0.1-0.1c-0.2-0.5-0.4-1-0.7-1.5l0,0c-1.7,1-2.8,0.2-3.6-1.3c0,0,0.1-0.1,0.2-0.2
		c-0.1,0.1-0.2,0.2-0.2,0.2c-0.3-0.4-0.6-0.8-0.9-1.2c-2.3-2.2-4.6-4.3-6.9-6.5c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.3-0.2-0.5-0.4-0.8-0.6c-0.5-0.2-0.9-0.5-1.4-0.7l0,0c-1.3,0.2-2.7,0.3-4,0.5l0.1,0.1c-0.1,0-0.2,0-0.3,0.1
		c-1,0.6-2.1,1.2-3.1,1.8c-0.1-0.3-0.3-0.7-0.4-1c1.2-0.2,2.3-0.5,3.5-0.7c0.1,0,0.1-0.1,0.2-0.1c-0.9-0.4-1.9-0.7-2.9-1.1
		c0.7-0.3,1.3-0.5,2-0.8c0-0.3,0.1-0.6,0.1-0.9c-2.6-1.1-5.3-2-7.8-3.2s-4.8-1.3-7.3-0.2c0.6,1.1,1.2,2.1,1.9,3.2l0,0
		c0.5,0.2,0.9,0.5,1.4,0.7c2-0.4,4-0.8,6.7-1.3c-1.6,1.4-2.7,2.4-3.8,3.4l0,0c0.3,0.2,0.5,0.4,0.8,0.7l0,0c0.7,0.7,1.4,1.4,2.1,2.1
		l0,0c0.2,0.3,0.4,0.5,0.7,0.8c1,1.1,1.8,2.4,2.9,3.3c2.4,2,3.6,4.4,3.3,7.5c-0.5-0.9-1-1.8-1.4-2.7c0,2.5,0,5,0,7.5
		c0.3,0,0.6,0.1,1,0.1c0.1-1.7,0.3-3.3,0.4-5c0.2,1.6,1.3,3.7,0.6,4.6c-1.7,2.3-1.4,5.1-2.7,7.4l0,0c-0.7,0.9-1.4,1.8-2.1,2.7v0.1
		c-0.7,0.9-1.4,1.9-2.1,2.8c-0.3,0-0.5,0-0.8,0c0,0,0,0,0-0.1c-0.9,0.5-1.8,1-2.7,1.6c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.1,0.1,0.2,0.2,0.3,0.3c-0.2,0.2-0.5,0.5-0.7,0.7l0,0c-0.3,0.2-0.5,0.4-0.8,0.6l0,0l0,0l0,0c-0.2,0.3-0.4,0.6-0.5,0.9
		c-0.5,0.5-0.9,0.9-1.4,1.4l0,0c-0.3,0.2-0.5,0.3-0.8,0.5c0,0,0,0.1-0.1,0.1l0,0h-0.1c-3.6,3.3-7.2,6.6-10.8,9.9
		c-0.3-0.2-0.6-0.4-0.8-0.7c0.4-1.1,0.4-2.5,1.2-3.1c2.1-1.7,4.5-3.2,6.9-4.6c1.1-0.7,2.4-1,3.6-1.5l0.1-0.1c0,0,0.1,0,0.1-0.1
		c0.2-0.2,0.3-0.5,0.5-0.7c0.2-0.7,0.4-1.5,0.6-2.2c1.9-1.6,3.8-3.3,5.7-4.9c0.2-0.3,0.4-0.5,0.6-0.8c0.9-1.8,1.8-3.5,2.8-5.3
		c3-5.5,1-10.5-0.8-15.6c-3,0-5.7,0-8.3,0c0-0.3,0-0.6,0-0.8c2.5,0,5,0,7.7,0c-0.6-1.4-0.9-2.3-1.3-3.3l0,0
		c-0.2-0.2-0.5-0.5-0.7-0.7c-0.7-0.7-1.4-1.4-2.1-2.1l0,0c-0.2-0.2-0.4-0.5-0.7-0.7c-1-0.7-1.9-1.3-2.9-2c0.1-0.1,0.2-0.3,0.3-0.4
		c-0.1,0.1-0.2,0.3-0.3,0.4c-0.4-0.3-0.9-0.6-1.3-0.9c-4.7-2.3-9.5-4.6-14.2-6.9c0.1-0.2,0.2-0.5,0.3-0.7c3,1.3,6.1,2.5,9.1,3.9
		c1,0.5,1.8,1.1,2.6-0.1c0.1-0.6,0.1-1.3,0.2-1.9h-0.1c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1-0.1-0.1-0.3-0.2-0.4c0.4,0,0.7-0.1,1.1-0.1
		c0,0,0.1,0,0.1-0.1c-0.5-0.4-1.1-0.8-1.6-1.2c0.1-0.1,0.2-0.2,0.2-0.3c-0.1,0.1-0.2,0.2-0.2,0.3c-2.8-0.7-5.6-1.4-8.4-2
		c0.1-0.4,0.2-0.8,0.4-1.1c2.8,1,5.5,1.9,8.3,2.9C220.6,184.8,224.1,185.5,227.9,186.3z M221.7,189.4h-0.2l0.1-0.2L221.7,189.4z
M210.1,180.1c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.1,0.1,0.2,0.2c-0.1,0.1-0.2,0.1-0.3,0.2C210.2,180.3,210.1,180.2,210.1,180.1z
M214,181.2c0.1-0.3,0.1-0.5,0.2-0.8c1.5,0.4,2.9,0.8,4.4,1.2c-0.1,0.2-0.1,0.4-0.2,0.7C216.9,181.9,215.5,181.5,214,181.2z
M232.9,179.8c-8.2-1-16.6-0.5-24.8-2.6c0-0.4,0.1-0.8,0.1-1.2c8.3,1,16.5,2,24.8,3C233,179.3,232.9,179.6,232.9,179.8z
M238.1,180.2c11.5-1.1,22.7,1.2,34,2.4c1.9,0.1,3.9,0.3,5.8,0.5c-1.9-0.1-3.9-0.3-5.8-0.5C260.7,181.9,249.3,182.8,238.1,180.2z
M249.3,183.9c-0.9,0-1.8,0-2.7,0c0-0.2,0-0.3,0-0.5c0.9,0,1.8,0,2.7,0C249.3,183.6,249.3,183.8,249.3,183.9z M270.7,190.1
		c-0.6-0.3-1.3-0.7-1.9-1h-0.1h0.1h0.1c0.7,0,1.5,0,2.2,0C270.9,189.4,270.8,189.8,270.7,190.1z M281.7,191.3
		c-0.6-0.2-1.2-0.5-1.7-0.7c-0.7-0.1-1.3-0.2-2-0.3c0.1-0.2,0.1-0.4,0.2-0.6c0.7,0.2,1.3,0.4,2,0.7c0.6,0.1,1.2,0.2,1.8,0.3
		C281.8,190.8,281.8,191,281.7,191.3z M280.5,187.8c-9-1.1-18-2.2-27-3.3c0-0.3,0.1-0.5,0.1-0.8c3.6,0.3,7.2,0.4,10.8,0.9
		c5.5,0.8,11,1.8,16.6,2.7c2.5,0.3,4.9,0.7,7.4,1c0,0.3-0.1,0.6-0.1,0.9C285.6,188.8,283,188.3,280.5,187.8z M286.4,196.2
		c-0.3-0.2-0.8-0.5-0.8-0.8s0.5-0.6,1-1.2c0.2,0.8,0.4,1.1,0.4,1.4C287,195.9,286.5,196.3,286.4,196.2z M287.1,193.6
		c-0.9-0.5-1.7-1.1-2.6-1.6c-0.1,0-0.2,0-0.2-0.1l-0.1-0.1c-0.3,0-0.7-0.1-1-0.1c0.1-0.1,0.2-0.3,0.3-0.4c0.3,0.2,0.5,0.4,0.8,0.6
		c0.1,0,0.1,0,0.2,0s0.1,0.1,0.2,0.1c1,0.2,2,0.5,3,0.7C287.4,193,287.2,193.3,287.1,193.6z M288.6,195c-0.2-0.2-0.5-0.4-0.7-0.6
		c0.5-0.6,0.9-1.2,1.4-1.7c0.3,0.2,0.6,0.5,0.9,0.7C289.7,194,289.2,194.5,288.6,195z M291.4,188.9c0.9,0.2,1.7,0.4,2.6,0.6
		c-0.1,0.2-0.1,0.5-0.2,0.7c-0.8-0.2-1.6-0.4-2.4-0.6C291.3,189.4,291.3,189.2,291.4,188.9z M294.3,197.4c-0.2-0.1-0.4-0.2-0.6-0.3
		c0.1-0.1,0.1-0.2,0.2-0.2c0.2,0,0.4,0.1,0.6,0.1C294.4,197.2,294.3,197.3,294.3,197.4z M295.2,195.6c-1-0.3-2-0.7-3-1
		c0.1-0.3,0.1-0.5,0.2-0.8c1,0.1,2,0.3,3,0.4C295.4,194.7,295.3,195.1,295.2,195.6z M309.8,221.6h-0.1c-0.1-0.2-0.2-0.4-0.3-0.6
		c-0.7-1.2-1.3-2.3-2-3.5c-0.2-0.3-0.3-0.7-0.5-1c0.3,0.2,0.6,0.5,0.8,0.7c0.6,1.3,1.1,2.6,1.7,3.8
		C309.5,221.2,309.6,221.4,309.8,221.6L309.8,221.6h0.1c0,0,0,0.1,0.1,0.2C309.9,221.8,309.9,221.7,309.8,221.6z M309.5,216.7
		c-0.2-0.3-0.3-0.5-0.5-0.8c0.8-0.3,1.5-0.5,2.3-0.8c0.1,0.2,0.1,0.3,0.2,0.5C310.8,216.1,310.2,216.4,309.5,216.7z M317.1,223.7
		c-0.1,0-0.1,0-0.2,0.1c-0.7,0.2-1.5,0.4-2.2,0.6l-0.1,0.1c-0.3,0.4-0.5,0.8-0.8,1.2c-0.1-0.2-0.3-0.3-0.4-0.5
		c0.4-0.2,0.8-0.5,1.2-0.7l0.1-0.1c0.7-0.2,1.5-0.4,2.2-0.6C316.9,223.7,317,223.7,317.1,223.7c0.7-0.3,1.4-0.5,2.1-0.8
		c0.1,0.3,0.1,0.5,0.2,0.8C318.6,223.7,317.8,223.7,317.1,223.7z M321.3,217.6c-2.4,0.7-4.8,1.3-7.2,2c-0.4,0.5-0.8,1.1-1.2,1.6
		c-0.2-0.1-0.3-0.3-0.5-0.4c0.5-0.5,0.9-1,1.4-1.6c2.4-0.7,4.7-1.4,7.1-2.1c0-0.1,0-0.3,0.1-0.4c-0.8,0-1.6-0.1-2.4-0.1
		c0.1-0.3,0.1-0.6,0.2-0.8c0.8,0.3,1.7,0.5,2.5,0.8l0,0c0.3,0.1,0.6,0.3,0.9,0.4C321.8,217.1,321.5,217.4,321.3,217.6z M313.7,216.2
		l0.3,0.1l-0.2,0.2L313.7,216.2z M316.3,216.3c0.2-0.1,0.4-0.2,0.6-0.2c0.1,0,0.2,0.1,0.2,0.2c-0.2,0.1-0.4,0.2-0.6,0.2
		C316.5,216.5,316.4,216.4,316.3,216.3z M325.6,221.6c0.1,0.3,0.1,0.7,0.2,1c-1.2,0.2-2.4,0.3-3.5,0.5c0-0.3-0.1-0.5-0.1-0.8
		C323.3,222,324.5,221.8,325.6,221.6z M324.8,204.4c-0.2,0-0.4-0.1-0.6-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.2,0,0.4,0.1,0.6,0.2
		C324.9,204.3,324.9,204.4,324.8,204.4z M326.1,200.4c-2.2,0.6-4.5,0.9-6.8,1.3c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0.2-1.4,0.5-2.1,0.7
		l0,0c-0.2,2.1,0.3,3.9,2.3,5.1c1.1,0.7,1.9,1.7,2.9,2.6l0,0c0.2,0.3,0.3,0.5,0.5,0.8h0.1l0,0c0.2,0.2,0.5,0.5,0.7,0.7l0,0l0,0
		l0.1,0.1h0.1c0,0,0,0.1,0.1,0.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1-0.1l0,0c-0.2-0.2-0.5-0.5-0.7-0.7l0,0c0,0,0,0,0-0.1
		c-0.3-0.1-0.6-0.3-0.9-0.4c-0.1,0.4-0.3,0.7-0.4,1.1l-0.2,0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0.2,0.3,0.4,0.4,0.6
		c-0.2-0.1-0.4-0.3-0.6-0.4c-2.3-2-4.7-4-6.9-6.2c-0.8-0.8-1.1-2-1.6-3l0,0c-0.3-0.2-0.5-0.4-0.8-0.6c-0.3,0.2-0.6,0.7-0.8,0.6
		c-2.8-0.8-5.8-1.6-7.7-4.2c-0.4-0.3-0.8-0.6-1.1-1c0,0,0,0-0.1,0l0,0c-1.9,0-3.9,0-6,0c0.9-1.4,1.6-2.5,2.3-3.6c1.1,0,2.2,0,3.5,0
		c-0.2,0.6-0.4,0.9-0.4,1.1c2.5,0.4,5,0.8,7.4,1.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0.1,0c0.1-0.8,0.3-1.6,0.5-2.5
		c-4.7-0.6-9.3-1.2-14-1.9c0.1-0.3,0.1-0.7,0.2-1c6.2,0.6,12.4,0.9,18.3,3.3c0,0,0,0,0.1,0l0,0c3.9,0.8,7.7,1.8,11.6,2.5
		c10.1,1.9,19.1,6.4,28.2,10.9c0.9,0.5,1.7,1.1,2.9,1.8c-0.8,0.4-1.3,0.7-1.7,1l0.1,0.1l0,0l0,0c0,0,0,0-0.1,0
		c0.3,0.4,0.6,0.9,0.8,1.3c0.3,0.2,0.5,0.4,0.8,0.6c0.2,0.2,0.3,0.5,0.5,0.7c-0.2-0.1-0.5-0.3-0.7-0.4c-0.3-0.2-0.6-0.4-0.8-0.6
		c-1-0.5-2.6-0.5-1.9-2.3l0,0h0.1c-0.7-0.6-1.3-1.4-2.1-1.8c-2.3-1.1-4.6-2.1-6.6-3c-0.8,0.4-1.6,0.9-2.5,1.3c0,0,0,0,0,0.1
		c-0.1,0-0.1,0-0.2,0c-0.2,0.2-0.5,0.3-0.7,0.5c0-0.1-0.1-0.2-0.1-0.4c0.3,0,0.6-0.1,0.9-0.1c0,0,0.1,0,0.1-0.1l0,0
		c-0.3-1.9-1.9-1.3-3-1.4c-2.5-0.1-5.1,0-7.7,0c0-0.3,0-0.6,0-0.9c3.1,0,6.2,0,9.3,0c-1-0.9-2-1.2-2.9-1.8
		C334.4,199.7,330.4,199.2,326.1,200.4z M321.6,204.4c-0.9,0-1.9,0-2.8,0c0-0.1,0-0.3,0-0.4c0.9,0,1.9,0,2.8,0
		C321.6,204.2,321.6,204.3,321.6,204.4z M350.9,210.4c-0.1,0-0.2,0-0.3,0c-1.5,0.5-3,1-4.6,1.5c-0.1-0.4-0.1-0.7-0.2-1.1
		c1.6-0.1,3.2-0.2,4.8-0.3h0.1c-3.4-0.3-6.9-0.7-10.5-1c0.4-0.2,0.7-0.5,1-0.5c3-0.1,6.1-0.2,9.1-0.1c0.5,0,1,0.9,1.6,1.3
		C351.5,210.2,351.2,210.2,350.9,210.4L350.9,210.4z M343.8,211.8c0,0.2,0,0.3,0,0.5c-0.6-0.1-1.1-0.1-1.7-0.2c0-0.2,0-0.3,0-0.5
		C342.7,211.7,343.2,211.8,343.8,211.8z M337.8,207c-0.1,0.1-0.3,0.3-0.4,0.3s-0.3-0.2-0.4-0.3c0.2-0.1,0.4-0.2,0.6-0.2
		C337.6,206.8,337.7,206.9,337.8,207z M335.4,207.9c-1.3,0.4-2.3,0.7-3.2,1c-0.1-0.2-0.2-0.4-0.3-0.7c0.9-0.3,1.7-0.6,2.6-0.8
		C334.7,207.4,334.9,207.6,335.4,207.9z M328.5,204.4c-0.1,0-0.2-0.1-0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2s0.2,0.1,0.2,0.2
		C328.6,204.3,328.6,204.4,328.5,204.4z M329.1,210c0.1-0.3,0.1-0.6,0.2-0.9c2.7,0.2,5.3,0.5,8,0.7c0,0.2,0,0.4-0.1,0.6
		C334.6,210.2,331.9,210.1,329.1,210z M346.9,221.3c0.2-0.1,0.3-0.4,0.4-0.4c0.2,0,0.5,0.2,0.7,0.4c-0.2,0.1-0.4,0.2-0.6,0.3
		C347.3,221.5,347.1,221.4,346.9,221.3z M347.8,223.9c-0.1,0-0.1,0-0.2,0c0.1-0.1,0.1-0.1,0.2-0.2c0.3-0.3,0.7-0.7,1-1.1
		C349.3,223.5,349.2,223.7,347.8,223.9z M351.9,220.2c0-0.2,0-0.5-0.1-0.7c0.5,0,1,0.1,1.5,0.1c0,0.2,0,0.3,0,0.5
		C352.8,220.1,352.4,220.1,351.9,220.2z M358.1,217.7c-0.2-0.3-0.5-0.6-0.7-0.9c-0.1-0.1-0.2-0.1-0.3-0.2c0,0-0.1,0-0.1-0.1
		c-7.6,0.1-15.2,0.1-22.8,0.1c-0.6,0-1.1-0.5-1.7-0.8c-0.1,0-0.1,0-0.2,0h0.1c-0.3-0.3-0.5-0.6-0.8-0.9c1.1-0.5,2.3-0.9,3.4-1.4
		c0,0.2,0.1,0.3,0.1,0.5c-0.9,0.6-1.8,1.2-2.8,1.8h0.1c7.5,0,15-0.1,22.5-0.1c0.7,0,1.4,0.5,2,0.8c0.1,0,0.1,0,0.2,0
		c0.1,0.1,0.1,0.2,0.2,0.2c0.3,0.2,0.6,0.4,1,0.6C358.3,217.5,358.2,217.6,358.1,217.7z M365.1,227.8c-0.2,0-0.4-0.1-0.6-0.2
		c0.1-0.1,0.2-0.1,0.2-0.2c0.2,0.1,0.4,0.2,0.6,0.2C365.2,227.6,365.2,227.8,365.1,227.8z M368.5,230.4c-0.5-0.6-1.1-1.3-1.6-2
		c0.3-0.2,0.6-0.4,0.8-0.5c0.4,0.8,0.8,1.6,1.2,2.4C368.8,230.3,368.7,230.4,368.5,230.4z M370.5,227.2c0-0.1-0.1-0.2-0.1-0.3
		c-0.2-0.3-0.4-0.7-0.7-1c-0.5-0.7-1-1.4-1.5-2c-0.7-0.9-1.4-1.9-2.1-2.8c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3
		c-0.2-0.3-0.5-0.5-0.7-0.7l0,0c-0.2-0.3-0.4-0.5-0.6-0.8c-1.7-1.5-3.4-3.1-5.2-4.6c-1.3-1.1-1-1.9,0.1-2.8c0-0.1,0-0.3,0.1-0.4
		c-0.7-0.5-1.3-1-2-1.5l0,0c-0.2-0.1-0.3-0.1-0.5-0.2c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.2,0.2,0.3,0.2,0.5l0,0l0,0
		c0.8,0.4,1.5,0.9,2.3,1.3l0,0c0.3,0.2,0.5,0.4,0.8,0.6c0.5,0.4,1,0.7,1.6,1.1c-0.1,0.1-0.2,0.2-0.2,0.4c-0.5-0.2-1-0.4-1.6-0.6v0.1
		c0,0,0,0,0-0.1c0.4,1.9,1.7,2.7,3.5,2.8l0,0c0.3,0,0.6,0,0.9-0.1c-0.1,0.7-0.1,1.5-0.2,2.2v0.1c0.1,0.4,0.1,0.8,0.2,1.2l0,0
		c0.2,0.2,0.5,0.5,0.7,0.7s0.5,0.5,0.7,0.7c0.7,0.9,1.4,1.9,2.2,2.8l0,0c0.4,0.7,0.9,1.5,1.3,2.2l0,0c0.2,0.4,0.3,0.8,0.5,1.2
		C370.5,227,370.5,227.1,370.5,227.2l0.2,0.1L370.5,227.2z M366.7,213.1c-0.1-0.1-0.3-0.3-0.4-0.4c0.4-0.4,0.8-0.9,1.1-1.3
		c0.2,0.2,0.4,0.4,0.6,0.7C367.5,212.4,367.1,212.7,366.7,213.1z M369.3,213.1c0,0.2,0,0.5,0.1,0.7c-0.5,0-1-0.1-1.4-0.1
		c0-0.1,0-0.3,0-0.4C368.4,213.2,368.9,213.1,369.3,213.1z M366,209c-0.6-0.2-1.3-0.4-1.9-0.6c0.1-0.3,0.3-0.6,0.4-0.9
		c0.6,0.3,1.2,0.7,1.8,1C366.2,208.6,366.1,208.8,366,209z M376.9,231.5c-0.5,0.5-1,1.1-1.5,1.6l0,0c-2,0.7-2.2,0.5-2.5-1.4
		c-0.3-1.6-0.8-3.2-1.1-4.8c-0.4-1.2-0.8-2.4-1.1-3.6l-0.1-0.1l0,0c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4-0.5-0.8-1-1.1-1.5
		c-0.5-0.7-1-1.4-1.5-2.2c-0.2-0.2-0.4-0.5-0.6-0.7c-0.1-0.2-0.2-0.3-0.2-0.5c0.1,0.2,0.2,0.3,0.3,0.5l-0.1,0.1l0.1-0.1
		c0.2,0.3,0.4,0.5,0.5,0.8c0.5,0.7,1.1,1.3,1.6,2l0,0c0.3,0.5,0.6,1.1,1,1.6c0.1,0.2,0.3,0.4,0.4,0.5l0,0l0,0v0.1
		c0.7,0.6,1.5,1.2,2.2,1.8c-0.1,0.2-0.2,0.3-0.3,0.5c0.1-0.2,0.2-0.3,0.3-0.5c0.2,0.3,0.3,0.6,0.5,0.8c0,0,0.1,0,0.1,0.1h-0.1
		C374.6,227.7,375.8,229.6,376.9,231.5L376.9,231.5c0.1,0.3,0.1,0.6,0.2,1C377.1,232.1,377,231.8,376.9,231.5z M371.5,210.7
		c-0.1,0-0.2,0-0.3,0.1c0-0.1,0-0.2,0.1-0.4c0.1,0,0.2,0.1,0.3,0.1C371.6,210.6,371.6,210.7,371.5,210.7z M371.7,213.5
		c1.9,0.1,3.8,0.3,5.7,0.4c-0.1,0.3-0.1,0.5-0.2,0.8c-1.9-0.2-3.8-0.4-5.7-0.5C371.6,213.9,371.6,213.7,371.7,213.5z M380.6,222.2
		C380.6,222.2,380.5,222.3,380.6,222.2c-0.3,0.3-0.5,0.5-0.8,0.8l0,0h-0.1c-0.5,0.2-0.9,0.4-1.4,0.6c0-0.2-0.1-0.5-0.1-0.7
		c0.5,0,1,0.1,1.5,0.1h0.1C380,222.7,380.2,222.5,380.6,222.2L380.6,222.2C380.5,222.2,380.5,222.2,380.6,222.2
		c0.1-0.1,0.2-0.3,0.3-0.4c0.1,0.1,0.2,0.2,0.2,0.3C380.9,222.1,380.7,222.2,380.6,222.2z M386.8,220.9c0,0.2,0.1,0.4,0.1,0.5
		c-1.2,0.3-2.4,0.6-3.6,0.9c-0.1-0.2-0.1-0.5-0.2-0.7C384.4,221.4,385.6,221.1,386.8,220.9z M383.1,217.4c0,0.2,0,0.3,0,0.5
		c-2.6,0-5.3,0-7.9,0c0-0.2,0-0.3,0-0.5C377.9,217.4,380.5,217.4,383.1,217.4z M380.4,211.1L380.4,211.1L380.4,211.1
		c1-0.5,1.9-2,2.9-0.1c0,0,0,0,0.1,0c0.1,0.2,0.1,0.3,0.2,0.5c-0.1-0.2-0.2-0.3-0.3-0.5l0,0c-0.4,0.2-0.8,0.4-1.2,0.5
		c0.2,0.3,0.5,0.5,0.7,0.8c0.1,0.2,0.1,0.4,0.2,0.6c-0.1-0.1-0.3-0.3-0.4-0.4c-0.2-0.3-0.4-0.5-0.7-0.8
		C381.4,211.5,380.9,211.3,380.4,211.1L380.4,211.1L380.4,211.1c-0.8-0.3-1.6-0.5-2.4-0.8c0.1-0.2,0.2-0.4,0.3-0.6
		C379,210,380.7,208.5,380.4,211.1z M377.5,207.2c0.7,0.3,1.3,0.7,2,1c-0.1,0.2-0.2,0.4-0.2,0.5c-0.7-0.3-1.4-0.5-2-0.8
		C377.3,207.7,377.4,207.4,377.5,207.2z M376,209c0,0.2-0.1,0.5-0.1,0.7c-1.9,0-3.8,0-5.7,0c0-0.2,0-0.4,0-0.6
		c1.3-0.3,2.6-0.6,3.9-0.9l0,0c-0.7-0.3-1.3-0.6-2.7-1.2c1.3-0.1,1.7-0.2,2.1-0.2c0,0,0,0,0-0.1l0,0c-0.1-0.2-0.1-0.4-0.1-0.6
		c-0.4-0.2-0.8-0.4-1.1-0.6c-0.1,0-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1-0.1c-1.1,0-2.3,0-3.4,0.1c0.1-0.1,0.2-0.2,0.2-0.3
		c-0.1,0.1-0.2,0.2-0.2,0.3c-0.4-0.3-0.9-0.5-1.3-0.8c-0.7,0-1.4,0-2,0l0.1,0.1c-0.1,0-0.1,0-0.2,0c-0.5,0.2-1,0.4-1.5,0.6
		c0-0.2-0.1-0.4-0.1-0.6c0.5,0,1.1,0,1.6,0h0.1c-0.9-0.5-1.9-0.9-2.8-1.4l0,0h-0.1c-0.2,1.6-0.9,2.5-2.6,2c-0.2,0-0.1-0.9-0.1-1.4
		c0,0,0,0-0.1,0s-0.1-0.1-0.2-0.1c-0.7-0.1-1.4-0.3-2.1-0.4c0.1-0.2,0.2-0.5,0.3-0.7c0.6,0.4,1.2,0.7,1.8,1.1c0.1,0,0.1,0,0.2,0l0,0
		c0.9-0.2,1.8-0.4,2.8-0.6v-0.1c0,0,0,0,0.1,0c0-0.2,0-0.5,0-0.7l0,0l-0.1-0.1c-0.5,0-1-0.1-1.4-0.1c0.1-0.2,0.1-0.4,0.2-0.6
		c0.4,0.2,0.9,0.5,1.3,0.7c0.1,0,0.1,0,0.2,0v0.1c1.6,0.4,3.2,0.9,4.8,1.3c-0.1-0.2,0-0.4,0.1-0.6l0,0V203c-0.1-0.1-0.2-0.1-0.2-0.2
		c0.1,0,0.2,0,0.2,0s0,0.1,0,0.2c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c1.6,0.7,3.1,1.4,4.7,2.1c0.1,0,0.1,0,0.2,0s0.2,0.1,0.3,0.1
		c0.5,0.1,0.9,0.3,1.4,0.4l0,0c0.4,0.1,0.8,0.2,1.8,0.6c-1.1,0.1-1.5,0.2-1.9,0.2c0,0,0,0,0,0.1l0,0l0,0c0.3,0.4,0.5,0.8,0.8,1.2
		C374.8,208.3,375.4,208.6,376,209z M385,198.2c-0.7,0-1.4-0.1-2.1-0.1c0-0.1,0-0.3,0-0.4c0.7,0,1.4,0,2.1,0
		C385,197.9,385,198,385,198.2z M417.4,207.3c0-0.1,0-0.3,0-0.4c0.7,0,1.4,0,2.2,0c0,0.1,0,0.3,0,0.4
		C418.9,207.3,418.2,207.3,417.4,207.3z M439.9,200.5c0.1,0.1,0.2,0.2,0.4,0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.1-0.3-0.2
		C439.7,200.7,439.8,200.5,439.9,200.5z M435.7,201.8c-0.9,0.2-1.9,0.5-2.8,0.7h-0.1c-0.4,0.4-0.8,0.8-1.1,1.2
		c0.3,0.2,0.6,0.4,0.9,0.5c0,0.2-0.1,0.4-0.1,0.6c-2.1,0.1-4.3,0.3-5.5,0.4c-2.3,0.7-3.8,1.2-5.3,1.7c-0.1-0.4-0.3-0.8-0.4-1.2
		c3.5-2,7.5-2.7,11.5-3.1c0,0,0-0.1,0.1-0.1C433.7,202.2,434.7,201.9,435.7,201.8c0-0.1,0.1-0.1,0.2-0.1c0.7-0.2,1.3-0.4,2-0.6
		c0,0.2,0.1,0.4,0.1,0.6c-0.7,0-1.4,0-2.1,0C435.8,201.7,435.8,201.8,435.7,201.8z M436.5,204c0-0.2-0.1-0.4-0.1-0.7
		c1.8-0.4,3.5-0.7,5.3-1.1c0.1,0.3,0.3,0.5,0.4,0.8C440.3,203.4,438.4,203.7,436.5,204z"
      />
      <path
        class="st3"
        d="M36.6,177.7l0.1-0.1C36.6,177.7,36.6,177.7,36.6,177.7z"
      />
      <path
        class="st3"
        d="M393.2,236.4l0.1,0.1l0,0C393.3,236.5,393.2,236.4,393.2,236.4z"
      />
      <path
        class="st3"
        d="M162,274.8c-0.1-0.1-0.3-0.3-0.4-0.4l0,0C161.8,274.5,161.9,274.7,162,274.8z"
      />
      <path
        class="st3"
        d="M226.9,184.1L226.9,184.1L226.9,184.1C226.8,184.2,226.9,184.2,226.9,184.1z"
      />
      <path
        class="st3"
        d="M321,211.7C321,211.8,320.9,211.8,321,211.7L321,211.7z"
      />
      <path
        class="st3"
        d="M200.9,224.2c-0.1,0.1-0.3,0.3-0.4,0.4l0,0C200.7,224.5,200.8,224.4,200.9,224.2z"
      />
      <path
        class="st3"
        d="M127.1,267.5C127.2,267.5,127.2,267.6,127.1,267.5L127.1,267.5z"
      />
      <path
        class="st3"
        d="M321.5,210.5c0.1-0.1,0.2-0.2,0.4-0.3l0,0C321.8,210.2,321.7,210.3,321.5,210.5z"
      />
      <polygon class="st3" points="125.8,191.8 125.8,191.8 125.7,191.9 	" />
      <path class="st3" d="M127.3,267.7c0,0,0,0-0.1-0.1L127.3,267.7z" />
      <path
        class="st3"
        d="M224.7,194.1c0.1-0.1,0.2-0.2,0.3-0.3l0,0C224.9,193.9,224.8,194,224.7,194.1z"
      />
      <path
        class="st3"
        d="M220.4,191.3c0.1-0.1,0.2-0.2,0.2-0.3l0,0C220.6,191.1,220.5,191.2,220.4,191.3z"
      />
      <path
        class="st3"
        d="M540.3,50.4c0.7-0.3,1.3-0.7,1.8-1.3c0,0,0-0.1,0.1-0.1c0.1-1.4,0.2-2.8,0.2-4.2c-0.2-0.3-0.4-0.5-0.6-0.7l0,0
		c-0.1-0.1-0.2-0.1-0.3-0.2C540.8,46.1,540.5,48.2,540.3,50.4z"
      />
      <path
        class="st3"
        d="M473.1,54.4c-0.5-0.2-0.9-0.5-1.5-0.3c-0.1,0-0.3,0-0.5-0.1c-0.4,0.4-0.7,0.9-0.9,1.3
		C471.2,54.9,472.1,54.6,473.1,54.4z"
      />
      <path
        class="st3"
        d="M239.8,125.1c0-0.1,0.1-0.2,0.1-0.3c0.2-0.6-0.2-0.9-0.8-1.2c-0.8-0.4-1.5-0.2-2.2,0c-0.4,0.5-0.7,1.1-0.9,1.9
		C237.1,126.3,238.6,124.9,239.8,125.1z"
      />
      <path
        class="st3"
        d="M270.6,123.4C270.6,123.4,270.7,123.4,270.6,123.4C270.7,123.3,270.7,123.3,270.6,123.4
		C270.7,123.4,270.6,123.4,270.6,123.4z"
      />
      <path
        class="st3"
        d="M249,130.3c-0.1,0-0.2-0.1-0.3-0.1c-0.3,0.2,0,0.8-0.9,0.6c-0.4-0.1-0.7,0.3-0.8,0.7
		C247.7,131.4,248.4,131,249,130.3z"
      />
      <path
        class="st3"
        d="M244.6,136.7c-0.7,0.4-1.4,1.1-2,2.1c1.5-0.2,3-0.4,4.5-0.6c-0.2-0.5-0.2-1-0.4-1.5
		C246,136.6,245.1,137,244.6,136.7z"
      />
      <path
        class="st3"
        d="M250.6,139.2c-0.2,0-0.5,0.1-0.8,0.1l0.1,0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.3-0.2,0.5-0.4
		C250.7,139.3,250.6,139.2,250.6,139.2z"
      />
      <path
        class="st3"
        d="M239.6,138.8c0.2-0.6,0.4-1.2,0.7-1.8c-0.5-0.1-1-0.1-1.5-0.2c-0.1,0.1-0.1,0.2-0.2,0.2
		C238.9,137.6,239.3,138.2,239.6,138.8z"
      />
      <path
        class="st3"
        d="M217.2,132.8c-2.2-0.8-3.8-1.3-5.7-1.9c0.8,1.1,1.4,2,2.1,2.9c0.1,0.1,0.3,0.3,0.4,0.4c-0.2,0-0.4-0.1-0.7-0.1
		c-0.8,0.1-1.5,0.5-2.3,0.4c-2-0.2-2,0.9-1.7,2.3l0,0c0.9,0,1.8,0,2.7,0v-0.1c2.7-0.6,0.7,1.6,1.4,2.4c0.4-0.5,0.8-1,1.1-1.4
		c0.6,0.4,1.2,0.8,1.7,1.2l0,0c0.9-0.7,1.9-1.4,2.8-2.1c0.2-0.2,0.4-0.4,0.6-0.6c-0.4-0.1-0.9-0.1-1.4-0.2c0.1-0.4,0.2-0.8,0.3-1.2
		c0-0.1,0.1-0.2,0.1-0.3c-0.2,0.3-0.5,0.7-0.7,1c-0.2-0.1-0.5-0.2-0.7-0.3c0-1.5,0-3,0-4.5c-0.5-0.9-0.9-1.9-1.4-2.8
		c0.2-0.1,0.4-0.2,0.6-0.3c0.4,0.9,0.9,1.7,1.3,2.6c0.4-0.6,1.2-1.4,1.1-1.8c-0.6-1.7-1.5-3.4-2.3-5
		C213.5,126,213.5,127,217.2,132.8z"
      />
      <path
        class="st3"
        d="M229.7,128.1c-0.5-0.2-0.9-0.5-1.4-0.7c-0.1,0.1-0.2,0.3-0.2,0.4c0.4,0.2,0.9,0.3,1.4,0.3
		C229.5,128.2,229.6,128.2,229.7,128.1L229.7,128.1z"
      />
      <path
        class="st3"
        d="M224.6,127.2c-0.6,1.8-1.1,3.4-1.7,4.9c0.2,0.1,0.4,0.2,0.6,0.3c0.2,0,0.4-0.1,0.6-0.2
		c0.2-0.1,0.4-0.2,0.5-0.3c0.5-0.4,0.9-0.8,1.4-1.3c0.3-0.5,0.4-0.9,0.4-1.4C225.9,128.6,225.3,128,224.6,127.2z"
      />
      <path
        class="st3"
        d="M236.2,137.7c-0.9,0.5-1.7,0.8-2.6,1c0,0.1,0,0.2,0,0.2c-0.1,0-0.2,0-0.3,0c-1.4,0.1-2.6,0.6-3.9,1.4
		c0.2,0.3,0.4,0.6,0.6,0.9c0.5,0.6,0.9,1.3,1.4,1.9c0.3,0,0.5,0,0.8,0c0.2-0.2,0.3-0.5,0.5-0.7c-0.3-0.5-0.5-1-0.8-1.5v0.1v-0.1
		l0.1,0.1c1.4-0.2,2.7-0.4,4.1-0.5c1.2-0.4,0.3-2.2,1.1-3.2c-0.1,0-0.1,0-0.2-0.1c-0.2,0-0.4,0.2-0.6,0.3l0,0
		c-0.2,0.1-0.5,0.2-0.7,0.1c-0.5-0.1-0.8-0.1-1.1-0.1C235.1,137.6,235.6,137.6,236.2,137.7z M236.4,138c0-0.2-0.1-0.4-0.1-0.6
		C236.7,137.6,237,137.7,236.4,138z"
      />
      <path
        class="st3"
        d="M398.6,112.9c0.1-1.1,0.1-2.1,0.2-3.3c-1-0.4-2-0.8-3-1.2c0-0.2,0-0.5,0-0.7c1.3-0.2,2.6-0.3,4.1-0.5
		c0.4,1,0.9,2,1.3,2.9c1.5-2.8,1.5-4.1-0.2-6l0,0c-0.2,0.3-0.6,1-0.7,1c-0.8-0.4-1.7-0.8-2.7-1.4c0.6-0.5,1.1-1,1.9-1.7
		c-0.8-0.4-1.5-0.8-2.1-1.2c0.2-2.2,2.5-1.4,3.8,1c0.1,0.2,0.3,0.3,0.4,0.5c1.1,0.3,3-1.6,3.3,2.1c1-1.8,1.5-2.9,2.3-4.3
		c-1.8-0.2-3-0.3-4.2-0.5c0-0.2,0-0.3,0-0.5c-0.4,0.1-0.8,0.1-1.3-0.2c-0.4-0.2-0.8-0.1-1,0.4c-0.2,0.6-0.5,0.7-0.9,0.1
		c-0.2-0.3-1.1,0.2-1-0.6c0.1-0.1,0.3-0.2,0.4-0.3c-0.2,0-0.3,0-0.5,0v-0.1c0-0.1,0-0.1,0-0.2c0-0.3,0.1-0.6-0.3-0.7
		c-0.3,0.1-0.6,0.1-0.9,0.2l-0.1,0.1c-0.2,0.2-0.1,0.5-0.1,0.8c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2,0.1-0.3,0.2-0.4,0.3
		c-0.2,0.2-0.2,0.3-0.2,0.4s0.1,0.2,0.1,0.3l0,0c0,0.1,0,0.2,0,0.3c0,0.2-0.1,0.4-0.5,0.4c-0.5,0.1-0.9,0.1-1.5,0.1l0,0l0,0
		c0.6,0.7,1.4,0.7,2.2,1c-0.1,0.3-0.2,0.6-0.4,0.8c0.9,1.4,1.7,2.9,2.5,4.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.9-0.6-1.8-1.1-2.8-1.7
		c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0.1-0.2,0.2-0.4,0.4c0.3,0.4,0.6,0.7,0.9,1c0.1,0.3,0,0.6-0.2,0.9c-0.3,0.4-0.8,0.8-1.2,1.2l0,0
		c0.5,0.7,1.1,1.5,1.8,2.1C396.2,111.8,397.4,112.2,398.6,112.9z M398.7,98.8c0,0.1,0,0.2,0.1,0.2c-0.2,0-0.3-0.1-0.5-0.1
		C398.4,98.9,398.5,98.9,398.7,98.8z"
      />
      <path
        class="st3"
        d="M406.5,90.2c-0.3-0.1-0.7-0.2-1-0.2s-0.6-0.1-0.9,0c-0.2,0-0.3,0.1-0.5,0.2l-0.1,0.1c0.5-0.1,1.1-0.1,1.8,0.5
		c-0.2,1.3-0.4,2.4-0.6,3.5c1.3-1.5,2-3,2.4-4.8C407.2,89.5,406.8,89.7,406.5,90.2z"
      />
      <path
        class="st3"
        d="M404.3,97.4c0.2,0.3,0.5,0.6,0.9,1c-0.1,0.1-0.2,0.1-0.4,0.2c0.7-0.1,1.4-0.2,2.1-0.1c1.7,0.2,2.3-0.5,2.6-1.9
		c-1.9,0.2-3.7,0.2-5.6,0.4C404.1,97,404.2,97.2,404.3,97.4z"
      />
      <path
        class="st3"
        d="M245.8,129.8c0.4,0.1,0.9,0.1,1.4-0.1c1,0.6,1.8-0.3,2.7-0.5c0.1-0.1,0.1-0.1,0.2-0.2
		C248.6,129.4,247.2,129.6,245.8,129.8L245.8,129.8z"
      />
      <path
        class="st3"
        d="M218.4,138.1c0.2-0.2,0.5-0.5,0.7-0.7C218.9,137.7,218.7,137.9,218.4,138.1L218.4,138.1z"
      />
      <path
        class="st3"
        d="M219.8,136.7c-0.2,0-0.4,0-0.6,0c0,0.2,0,0.5-0.1,0.7c0,0,0,0,0.1-0.1l-0.1,0.1c0.3,0,0.5,0,0.8,0
		C219.8,137.2,219.7,136.9,219.8,136.7z"
      />
      <path
        class="st3"
        d="M248.6,126.3L248.6,126.3c0.4-0.1,0.9-0.3,1.3-0.5c-0.1-0.2-0.2-0.4-0.3-0.6c-0.4,0.2-0.7,0.4-1.1,0.6
		C248.5,126,248.6,126.1,248.6,126.3z"
      />
      <path
        class="st3"
        d="M307.3,154.8c0.2,0.2,0.3,0.3,0.5,0.5l0,0C307.7,155.1,307.5,155,307.3,154.8z"
      />
      <path
        class="st3"
        d="M340.3,153.2c0.2,0,0.4,0.3,0.5,0.5c0.5,5.3,4.3,3.1,8.1,3.6c-1.2-1.6-1.9-2.6-2.8-3.8
		c1.1-0.4,2.2-0.8,3.4-1.2c0.5-2.4-1.4-2.7-3.5-3.3c4.1-1.6,4.3,1.2,5,3.3c1.1-0.1,2.2-0.2,3.2-0.3c0.5,1.7,0.9,3.1,1.5,5.3
		c1.1-0.7,2-1.3,2.9-1.9c-0.8-0.6-1.6-1.2-2.7-2.1c0.4-1.3,1-2.9,1.5-4.6c-0.3,2.9,3.1,3.6,3.7,6.1c2.3-1.3,3-3.2,2.2-5.4
		c-0.2-0.7-2-0.8-3.1-1.2L360,148c0.9-2.3,2.7-1.5,4.3-1.3c-0.2-0.8-0.1-2-0.7-2.4c-1.2-1.1-4.1-0.3-5.6,1.1
		c-0.3,0.3-1.1-0.1-2.4-0.3c1.1,1,1.9,1.4,2.1,2c0.2,0.5-0.3,1.2-0.5,1.8c-0.8-0.2-1.5-0.7-2.3-0.7s-1.7,0.5-2.5,0.7
		c0.1,0.6,0.3,1.2,0.4,1.8c-0.3,0-0.6,0.1-0.9,0.1c0-0.8,0-1.5,0-2.3c1.1-0.9,2.1-1.8,3.2-2.7c-2-2.1-4.1-4.3-6.2-6.5
		c4.2-2.7,4.9,3.9,9.2,3.2c-0.9-1.5-1.5-2.7-2.2-3.8c2-0.6,2-0.6,2.7,1.8c0.8,2.7,1.9,3,4,1.3c-0.7-1.1-1.5-2.2-2.2-3.2
		c0.2-0.2,0.5-0.4,0.7-0.6c0.5,0.3,1.2,0.4,1.3,0.8c0.3,0.9,0.2,1.9,0.3,2.9c0.7,0.5,1.4,1,2.1,1.4l0,0c0.9-0.7,1.9-1.7,2.9-1.8
		c0.6-0.1,1.3,1.5,2.1,2.5c0.8-0.8,1.8-1.9,3.1-3.3c-1.5-0.8-2.7-1.4-4-2.1c0.3-0.5,0.6-1,0.9-1.6l0,0v-0.1c-1.6-2.5-3.2-5-4.8-7.6
		c3.9-1.7,2.8,2.7,4.3,4c1.4-0.1,3.1-1.7,4.1,0.7c-1.4,0.9-3.9,0.3-3.6,2.9c0,0,0,0,0,0.1l0,0c2.3-0.3,3.8,0.5,4.3,2.8l-0.2,0.1h0.1
		c0.2-0.1,0.4-0.1,0.7-0.2c0.1-0.7-0.1-1.6,0.3-2c1.4-1.5,3-2.9-0.6-3.6c0.3-2.4-1.4-4-2.9-6.1c1-0.1,1.7-0.2,2.5-0.3c0,0,0,0,0-0.1
		l0,0c-0.7-1.1-1.4-2.1-2.1-3.2c2.1-1.4,2.6-1,3.4,3.2c-0.4,0-0.9,0-1.3,0c0,0,0,0,0,0.1l0,0c1.3,2.1,2.6,4.2,3.9,6.5
		c0.8-0.6,1.6-1.1,2.4-1.6c0-1.8-0.1-3.7-0.1-5.5c-1-0.9-2-1.8-3.2-2.9c1.6-1.7,2.7-1.4,3.4,0.2c0.3,0.7,0.1,1.6,0.1,2.4
		c0.7,0.7,1.4,1.3,2.1,1.9c0.4-0.2,1.2-0.7,2-1.1l0,0c0.2-0.2,0.4-0.4,0.7-0.7l0,0c0.4-2.3-1.1-3.3-3.1-3.9c3.5-1.8,3.9-1.8,5,0.7
		c4-3.3,4.1-5,0.6-6.4c2.4-1.7,2.8-1.6,4.5,1.3c0.9-1.3,1.7-2.4,2.7-3.8c-1.3-0.7-2.2-1.2-3.1-1.7c0.3-0.7,0.3-1.5,0.2-2.3
		c-0.6-0.1-1-0.1-1.3,0.1s-0.6,0.5-0.9,1.1c-0.2,0-0.3-0.1-0.5-0.1c-0.2,0.6-0.4,1.1-0.5,1.6c0,0,0,0,0-0.1
		c-0.9,0.3-1.8,0.6-2.5,0.8c-0.2,0.4-0.2,0.9-0.1,1.4c0.1,0,0.2-0.1,0.2-0.1c1.2-0.5,2.2-0.5,3,0.2l0,0c0,0,0,0,0.1,0.1h-0.1
		c0,0,0,0-0.1,0c-0.8,0.2-1.8-0.2-2.6,0.4l0,0c-0.2,0.1-0.9-0.1-1.2-0.6c-0.4-0.7-1.3-1.1-1.8-1.8c-0.2-0.2-0.7,0-0.9-0.1
		c-0.1,0-0.2-0.1-0.1-0.4l0,0c0-0.2,0.1-0.4,0.1-0.5v-0.1c-0.2,0-0.5,0-0.6,0.2c0,0.1,0,0.1,0,0.2c-0.4,0.1-0.8,0.3-1.2,0.4
		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.2-0.5-0.6-0.8-1-1c-0.7-0.3-1.6-0.1-2.4,0.6c-0.5,0.5-0.8,1.1-1.8,0.8c0.1,0.5,0.2,0.8,0.3,1.3
		c0.5-0.1,1-0.1,1.8-0.2c-0.2,0.2-0.3,0.3-0.4,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.3,0.3-0.5,0.6-0.8,1.1c-0.3-0.2-0.5-0.4-0.7-0.6
		c-0.4-0.5-0.7-1-1.1-1.6c-0.3-0.4-0.6-0.8-1.1-1.1c-0.6,0.1-1.2,0-1.8-0.2c-0.3,0.1-0.6,0.2-0.8,0.4c-0.1-0.2-0.2-0.5-0.3-0.7
		c0.1,0,0.2-0.1,0.3-0.1c-0.3-0.2-0.6-0.3-0.8-0.6c-0.5,0.4-0.9,0.8-1.3,1.2c0-0.9,0.3-1.5,1.1-2c0,0,0.1,0,0.1-0.1l0,0
		c0.1,0.1,0.1,0.3,0.2,0.4c0.2-0.2,0.4-0.4,0.4-0.6c0-0.1-0.1-0.2-0.3-0.3l0,0c-0.1-0.1-0.3-0.2-0.3-0.3l0,0
		c-0.2-0.8-0.7-1.4-1.4-1.6c-0.4-0.1-0.8-0.2-1.3-0.2c0-0.1,0-0.1,0-0.2c0.1-0.3,0.1-0.5,0.2-0.7c0.1-0.3,0.2-0.7,0.3-1l0.1-0.1
		c-0.5-0.3-1.1-0.7-1.6-1c-0.5,0.3-0.9,0.4-1.2,0c-0.1-0.1-0.2-0.1-0.2-0.2c-0.4,1.1-0.6,1.7-0.8,2.3l0,0l0,0
		c2.9,1.7,3.6,3.3,2.9,6.6c0.1,0,0.1-0.1,0.2-0.1c0.4-0.2,0.7-0.4,1.2-0.7c-0.3,0.6-0.6,1-0.8,1.4c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1-0.1-0.2-0.2-0.3-0.2c-0.2-0.1-0.4-0.3-0.5-0.4l0,0h0.1c-1.6-1.6-2.9-3-4.2-4.3c0.6-0.9,1.2-1.7,1.8-2.5l0,0l0,0
		c-0.9-0.4-1.8-0.8-2.6-1.2c-0.1-0.1-0.3-0.3-0.4-0.4c0.1,0.1,0.3,0.3,0.4,0.4c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.3,0.1-0.5,0.1-0.8
		c1.2-0.2,2.4-0.5,3.8-0.7c-0.6-0.5-1.3-0.8-2.1-1c-3.5,0.8-7,1.8-10.3,2.7c-0.3,4.3,4.6,3.7,5.6,6.6c-2.9,0.7-4.4,0-5.9-2.7
		c-1.1-2-3.5-3-5.1-2.1c-0.4,0.2-0.4,1-0.5,1.5c1.9-0.9,1.9,0.5,1.9,1.6c0,0,0,0,0.1,0c0,0,0,0,0,0.1c1.7-0.3,2.9-0.1,2.8,2
		c0,0,0,0,0.1,0l-0.1,0.1c0,0,0,0,0-0.1c-1.2-0.2-2.3-0.5-3.5-0.7l0,0c0.7,0.3,1.4,0.7,2.4,1.2c-1.7,0.9-2.4,1.2-3,1.6v0.1
		c0.2,0.4,0.4,0.7,0.6,1.1c-0.4,0-0.8,0.1-1.2,0.1c0.2-0.4,0.4-0.8,0.5-1.2c0,0,0,0,0-0.1l0.1-0.1c-0.9-0.7-1.9-1.5-2.6-2
		c0.6-1.4,1.1-2.4,1.6-3.4c-2.4-0.6-3.5,1.3-4.8,2.7c0,0.1,0,0.1-0.1,0.2c0-0.1,0-0.1,0.1-0.2c1.7-0.5,2.2,0.5,2.6,2.5
		c-1.5-0.7-2.8-0.8-3.9-0.6c0.2,0.1,0.3,0.3,0.5,0.4c0.2,0.2,0.5,0.5,0.7,0.7c-0.4,0.4,0,0.6,0.1,0.9v0.1c0.1,0,0.1,0,0.2,0
		c0.5,0,1.1,0.2,1.6,0.3c0,0.2,0,0.5,0,0.7c-0.7,0.1-1.4,0.1-2.1,0.2c-0.1,0.1-0.3,0.2-0.5,0.2c-0.3-0.6-0.8-1.1-1-1.7
		s-0.5-1-0.7-1.3c-1.1,0.5-2.1,1.5-3,2.6c0.6,0.1,1.2,0.2,1.8,0.3c-0.1,0.3-0.2,0.6-0.3,0.9c-0.6-0.3-1.2-0.6-1.8-0.9
		c-1.1,1.2-2.2,2.5-3.3,3.7c1-0.1,2.1-0.2,3.7-0.3c-2.7,1.3-5,2.5-7.3,3.6c0,0.1,0,0.1-0.1,0.2c0-0.1,0-0.1,0.1-0.2
		c1.1,0.2,2.3,0.4,3.4,0.5c0,0.3,0,0.5,0,0.8c-2.4,0.6-6.4-1.2-6.7,3.1c-2.5,2.3-4.9,4.6-7.4,7c0.5,0.3,0.9,0.6,2.1,1.3
		c-2.2,0.3-3.5,0.5-4.9,0.7c-0.7,0.7-1.4,1.4-2.1,2.1c0.5,0.4,1,0.8,2.1,1.6c-1.4,0.3-2.4,0.3-3.1,0.7c-0.6,0.4-1,1.1-2,2.3
		c2.4,0,4.2,0,6,0c-0.1-1.5-0.2-2.8-0.2-3.9c1.5-0.1,2.6-0.1,3.8-0.2c2.1-0.2,2.8,0.5,2.6,3l0,0c0,0.2,0,0.5,0,0.7l0,0l0,0l0,0
		c0.4,0.9,0.8,1.8,1.1,2.7c-0.2,0-0.4,0.1-0.5,0.1c-0.9-0.8-1.8-1.6-3.1-2.8c1.2,0,1.9,0,2.5,0l0,0c0-0.2,0-0.5,0-0.7l0,0l0,0l0,0
		c-0.7-0.5-1.4-1-2.1-1.6c-2.9,2.3-2.9,4.4,0.1,6c1.6,0.8,2.3,1.7,1.2,3.3c0,0,0,0,0.1,0.1c0,0,0,0-0.1,0c0.3,1.5,1.4,3.2-0.9,4.6
		c-0.7-1.4-1.3-2.5-2.1-3.9c1.2-0.3,2.1-0.5,2.9-0.7v-0.1l0,0c-1.9-1.7-3.7-3.4-5.6-5c-0.4-0.3-1.3-0.2-1.9-0.1
		c-0.4,0.1-1.1,0.6-1.3,0.5c-3.6-2.5-5.1,0.2-6.8,2.6l0.1-0.1c0,0,0,0,0,0.1c0.6,0,1.3,0,2.1,0c-1.5,1.5-1.6,1.5-2.1,0
		c0,0,0,0-0.1,0c-1.1,1.5-3.3,2.6-1.9,5.2c-1.6,0.8-3.1,1.5-4.6,2.2c0.1,0.3,0.1,0.6,0.2,0.9c11.4-0.7,22.7-1.4,34.6-2.1
		c-0.8-1.1-1.5-2-2.2-3c1.3-1.4,2.3-0.8,2.9,0.6c1.5,3.2,1.5,3.2,5.4,2.6c-1.1-3.3-6.3-7.4-8.8-6.8c-0.6-1.5-1.2-3-2-4.9
		c2.7,1.3,5.1,2.5,7.6,3.7C337.9,150.5,337.5,153,340.3,153.2z M380.5,121.4c-0.3-0.9-0.7-1.8-1-2.8c0.3-0.1,0.6-0.3,0.9-0.4
		c0.4,0.9,0.9,1.7,1.3,2.6C381.3,121,380.9,121.2,380.5,121.4z M386.1,117.1c-0.3,1.3-0.7,2.5-1.2,4.4c-1.1-2.4-1.9-4.1-2.9-6.2
		c-0.7,0-1.4,0-2.7,0C383.6,111.5,383.8,117.7,386.1,117.1z M378.7,126.9c0.1,0.3,0.1,0.6,0.2,0.9c-0.6,0.2-1.2,0.3-1.8,0.5
		c-0.1-0.3-0.2-0.9-0.1-1C377.5,127.2,378.1,127.1,378.7,126.9z M378,118.1c0.2,0.2,0.3,0.5,0.5,0.7c-0.6,0.3-1.3,0.6-1.9,0.9
		c-0.1-0.2-0.2-0.3-0.3-0.5C376.9,118.8,377.5,118.5,378,118.1z M375.3,118.4c-1.4-0.7-2.8-1.4-4.1-2
		C373.5,114.9,374.5,115.4,375.3,118.4z M373.6,122.1c-1.1-0.6-2.3-1.3-3.4-1.9C371.9,119.7,373.6,119,373.6,122.1z M340.9,117.1
		C340.9,117.1,340.9,117,340.9,117.1h0.1H340.9z M310.8,157c-1.2-0.7-2.1-1.2-3-1.6l0,0c-0.3,0.1-0.5,0.2-0.8,0.3
		c0.1-0.3,0.2-0.5,0.2-0.8c0.9-0.5,1.7-1,2.5-1.4c-0.5-0.7-1.2-1.5-1.8-2.4c1.9-0.1,3.4-0.2,5-0.3c-0.5,1.1-1.3,2.2-1.4,3.4
		C311.4,155.3,312.3,156.7,310.8,157z M315.6,157c-0.9-0.9-1.9-1.8-2.9-2.8C315.7,153.7,316.4,154.3,315.6,157z M335.8,141.2
		c2.6-0.7,3.2,0.7,3.3,2.6C338.1,143,337.1,142.2,335.8,141.2z M343.8,139.6c-1.1-1-1.6-1.6-2.3-2c-0.6-0.4-2-0.1-1.4-1.5l0,0V136
		c-1.5-1-3-2.1-4.7-3.2c3.7-0.8,4.7,0,4.7,3.2c0,0,0,0,0.1,0c0,0,0,0,0,0.1C342.6,135.6,343.3,137,343.8,139.6z M336.1,136.5
		c0.6,1,1.2,2.1,1.8,3.1c-0.3,0.2-0.6,0.4-0.8,0.5c-0.7-1-1.3-2-2-3C335.4,136.9,335.8,136.7,336.1,136.5z M343.7,147.8
		c-0.2,0.1-0.4,0.3-0.6,0.4c-1-1.1-2-2.2-3.2-3.6C343.2,144,343.4,146,343.7,147.8z M339.9,149.3c3.4-0.6,4,0,3.6,3
		C342.4,151.3,341.3,150.4,339.9,149.3z M341.7,153.8c2.6-1.3,2.9-1.1,3.9,2.5C343.1,157.2,342.9,154.9,341.7,153.8z M349.1,144.4
		c0.7,0.5,1,1.4,1.5,2.2c-0.3,0.3-0.7,0.5-1,0.8c-1.5-1.6-3.1-3.1-4.6-4.7c-0.2,0.4-0.5,0.7-0.8,1.2c-0.6-1.4-1-2.5-1.5-3.6
		c1.8-0.5,2.8,0,2.7,1.9C346.6,142.9,348,143.5,349.1,144.4z M346.2,132.7c-1.5,0.4-2.8,0.8-4.1,1.1c-0.7-0.7-1.3-1.4-2-2H340
		c0,0,0-0.1,0.1-0.1c-0.6-1-1.1-2.1-1.7-3.1c0.3-0.2,0.5-0.5,0.8-0.7c0.8,0.3,1.7,0.6,2.6,0.9c-0.8,1.2-1.3,2.1-1.8,2.9l0,0l0,0
		c0.5-0.1,1-0.3,1.5-0.3c0.7,0,1.4,0.2,2,0.3c-0.1-0.6-0.3-1.3-0.3-1.9c0.1-0.8,0.3-1.6,0.6-3c2.3,3.9,4.2,7.1,6,10.2
		C346.6,137.7,346.3,135.2,346.2,132.7z M350.2,131c2.4-0.3,3.2,0.6,2.9,3.2C352,133,351.2,132.1,350.2,131z M355.3,137.2
		c-1.1-0.8-2.3-1.5-3.4-2.3c0.2-0.3,0.4-0.6,0.6-0.8c1.1,0.8,2.2,1.6,3.4,2.3C355.7,136.7,355.5,136.9,355.3,137.2z M359.6,137.2
		c-0.7-0.9-1.5-2-2.2-3C360.6,133.8,360.8,134.2,359.6,137.2z M365.9,140.3c-0.4-0.6-0.7-1.2-1.3-2.1
		C367,138.5,367,138.5,365.9,140.3z M369.1,128.6c-1.5-1.1-2.5-1.9-3.5-2.7c0-0.3,0.1-0.5,0.1-0.8c1-0.2,2-0.4,3.4-0.7
		C369.1,126,369.1,126.9,369.1,128.6z M366.6,116.5c1,0,2.1-0.2,3.1,0.1c0.3,0.1,0.3,1.4,0.4,2.7c-1.6-0.9-2.5-1.4-3.5-1.9
		C366.6,117.1,366.6,116.8,366.6,116.5z M365.8,120.2c1,0.7,1.8,1.8,2.6,2.8c-3.7,0-5.7-2.5-8.1-4.3c0.1-0.3,0.2-0.6,0.4-0.9
		C362.4,118.5,364.2,119.2,365.8,120.2z M362.9,126.2c0,0.2-0.4,0.4-0.7,0.8c-0.2-0.4-0.5-0.6-0.5-0.8c0-0.3,0.3-0.5,0.5-0.7
		C362.5,125.6,362.8,125.9,362.9,126.2z M361.3,120.7c0,1.5,0,2.3,0,3.5c-1.4-0.7-2.6-1.3-3.7-1.9c0-0.2,0-0.4,0.1-0.6
		C358.7,121.4,359.7,121.1,361.3,120.7z M357.3,111.1c-0.7-1.1-1.5-2.1-2.3-3.3c2.9-0.5,7,4.1,6.4,7.9c-0.6,0-1.3-0.1-2-0.1
		c0.5-1.7,1.5-3.5-1.4-3.6C357.8,111.8,357.5,111.4,357.3,111.1z M355.8,120.3c0.2,0.3,0.5,0.7,0.6,1c0,0-0.3,0.2-0.4,0.4
		c-0.2-0.4-0.3-0.8-0.5-1.1c-0.6-0.2-1.1-0.5-1.7-0.7c0.2-0.2,0.4-0.5,0.7-0.7C355,119.5,355.4,119.9,355.8,120.3
		c-0.1,0.1-0.2,0.2-0.3,0.2C355.6,120.5,355.7,120.4,355.8,120.3z M355.4,115.7c0.1,0.2,0.2,0.4,0.2,0.5c-0.5,0.3-1,0.5-1.5,0.8
		c-0.1-0.2-0.3-0.5-0.4-0.7C354.3,116.1,354.9,115.9,355.4,115.7z M349.6,117.1c0.2,0.2,0.4,0.5,0.4,0.5c-0.2,0.2-0.4,0.4-0.6,0.5
		c0,0-0.4-0.3-0.3-0.3C349.1,117.6,349.3,117.4,349.6,117.1z M352.1,123.2C352.2,123.2,352.2,123.2,352.1,123.2
		c0.1,0.1,0.1,0.1,0.1,0.1c0.8-0.3,1.6-0.6,2.3-0.9c0.1,0.2,0.2,0.4,0.2,0.6c-0.4,0.3-0.8,0.7-1.3,1h0.1v0.1
		c0.8,0.7,1.6,1.9,2.4,1.9c4.6,0.4,4.8,4.2,6.1,7.2c0,0,0,0,0.1-0.1l-0.1,0.1c3.6,0.1,3.7,0.2,3.2,2.7c-1.2-0.6-2.5-1.3-3.9-2l0,0
		v-0.1c-1.2-1.2-2.4-2.4-3.7-3.8c0.6-1.5-0.5-2.3-3.3-2.1c-0.6-0.8-1.1-1.3-1.5-1.8l0,0c-0.1,0.4-0.2,0.8-0.3,1.2
		c-0.2-0.1-0.3-0.2-0.5-0.2c0.2-0.3,0.5-0.6,0.7-1l0,0l0,0l0,0c-0.1-0.2-0.1-0.4-0.1-0.6C352.4,124.8,352.2,124,352.1,123.2
		C352.1,123.3,352.1,123.3,352.1,123.2C352.1,123.2,352.1,123.2,352.1,123.2c-1.4-0.7-2.7-1.4-4.1-2.1
		C350.7,119.1,350.8,119.1,352.1,123.2z M346.5,123.1c0,0,0.1,0,0.1,0.1c0,0,0,0-0.1,0.1c0.7,0.7,1.5,1.4,2.2,2.2
		c1.2,1.3,0.9,2.2-0.3,2.7c-1.2-1-2.2-1.8-3.5-2.8c0.5-0.6,1-1.3,1.6-2.1l0,0C346.5,123.2,346.5,123.1,346.5,123.1
		c-1.3-0.5-2.7-1.1-4.4-1.7C345.1,119.6,345.7,121.7,346.5,123.1z M339.1,121.9c0,0.2,0.1,0.4,0.1,0.6c-0.6,0.1-1.1,0.3-1.7,0.4
		c-0.1-0.3-0.1-0.6-0.2-0.9C338,122,338.5,121.9,339.1,121.9z M341.5,124.7C341.5,124.7,341.6,124.7,341.5,124.7
		c0.1-0.1,0.1-0.1,0.1-0.2c0.1-0.4,0.1-0.7,0.2-1.1c0.2,0.1,0.3,0.2,0.5,0.2c-0.2,0.3-0.5,0.6-0.7,0.9c0,0.1,0,0.1,0,0.2
		C341.6,124.7,341.6,124.7,341.5,124.7c-1.2,1.9-2.6,3-4.9,0.4C338.5,125,340,124.9,341.5,124.7z M335.6,128.6
		c0.4,0.4,0.8,0.8,1.1,1.3c-0.3,0.2-0.5,0.4-0.8,0.6c-0.3-0.5-0.6-1-0.9-1.5C335.2,128.8,335.5,128.6,335.6,128.6z M334.9,127.1
		c-0.8-0.2-1.6-0.4-2.5-0.6C333.6,124.4,334.4,124.9,334.9,127.1z M334.5,135.3c-1.5-0.7-2.7-1.2-3.9-1.7c0.2-0.4,0.3-0.7,0.5-1.1
		C333.3,131.6,334,132.9,334.5,135.3z M325.2,133c1.4-0.8,2.8-0.6,3.7,0.9c-1.3,0.5-2.4,1-4.5,1.9
		C324.8,134.5,324.7,133.3,325.2,133z M321.2,139.8c-0.4-1-0.6-1.8-1-2.7c5.9,0.7,5.9,0.7,6.5,3.8c-1.1-0.9-2-1.6-3-2.4
		C323,138.8,322.2,139.2,321.2,139.8z M327.6,144.1c-1.4-0.5-2.8-1-4.6-1.7C326.5,141.1,326.6,141.1,327.6,144.1z M328.9,151.6
		c-1.7-0.7-2.9-1.2-3.6-1.5c0.2-1.5,0.3-2.8,0.4-4.1c0.2-0.1,0.3-0.2,0.5-0.3C327,147.6,327.9,149.4,328.9,151.6z M323.5,154.6
		c2.1-1.5,2.9-0.6,3.8,1.5C325.9,155.5,324.9,155.1,323.5,154.6z M331.2,155.5c0,0.4,0.1,0.9,0.1,1.3c-0.2-0.3-0.4-0.6-0.6-0.9
		c-0.8-0.6-1.7-1.3-2.5-1.9c0.2-0.3,0.5-0.5,0.7-0.8C329.7,154,330.5,154.8,331.2,155.5z M328.4,132.1c0.3-2.7,0.3-2.7,3.1-2.1
		C330.5,130.7,329.6,131.3,328.4,132.1z M330.3,142.2c0.8-0.9,1.3-1.4,1.7-1.8c-0.9-1.1-1.8-2.1-2.6-3.1c0.3-0.3,0.6-0.7,0.9-1
		c0.8,0.6,2.1,1.1,2.2,1.8c0.5,2.1,2.1,4.2,0.4,6.7C333.2,142.9,332.3,142.2,330.3,142.2z M336.7,146.9c-1-0.3-1.8-0.6-3.1-1
		c1.4-1.8,2.4-1.9,3.1-0.2C336.9,146,336.8,146.3,336.7,146.9z"
      />
      <path
        class="st3"
        d="M258.4,124.4c0.1-0.1,0.2-0.4,0.2-0.6c0-0.1-0.1-0.3-0.3-0.5c-0.2,0.3-0.3,0.6-0.5,0.9
		C258,124.3,258.3,124.4,258.4,124.4z"
      />
      <path
        class="st3"
        d="M250.7,120c0-0.2,0-0.5,0-0.7c-0.1-0.3-0.4-0.6-1.3-0.4l0,0c-1.4,0.3-2.2,0.6-2.8,1.1c0,0.1,0,0.1,0,0.2
		c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1
		c0,0,0,0,0,0.1c0.3-0.1,0.7-0.1,1-0.2C250.2,121.7,250.4,120.9,250.7,120z"
      />
      <path
        class="st3"
        d="M242.2,118.7c0.1-0.1,0.2-0.2,0.2-0.2c0-0.1,0.1-0.2,0.1-0.3c-0.5-0.1-1-0.3-1.4-0.4
		C241.5,118.1,241.8,118.4,242.2,118.7z"
      />
      <path
        class="st3"
        d="M261.3,122.4c-0.3,0.1-0.6,0.1-0.9,0.2c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.2-0.1,0.4-0.2
		c-0.2,0-0.4-0.1-0.6-0.1c-0.2,0.8-0.4,1.6-0.5,2.4c0.4,0.1,0.8,0.2,1.1,0.2C261.2,123.4,261.2,122.9,261.3,122.4z"
      />
      <path
        class="st3"
        d="M384.8,127.5c0.1,0.4,0.1,0.8,0.3,1.6c0.2-0.7,0.3-1.2,0.4-1.6C385.2,127.5,385,127.5,384.8,127.5z"
      />
      <path
        class="st3"
        d="M256,118.7c-0.4-0.3-0.8-0.6-1.2-1c0,1.2,0,2.4,0,3.7c1.6-0.4,3.1-0.7,4.7-1.1c-0.1,0-0.3-0.2-0.3-0.3
		c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3C256.7,118,256.3,118.4,256,118.7z"
      />
      <path
        class="st3"
        d="M251.8,124.2c0.2,0,0.4,0,0.5,0.1c0-0.4,0-0.7,0-1.1c-0.1-0.1-0.1-0.1-0.1-0.2
		C252,123.4,251.9,123.8,251.8,124.2z"
      />
      <path
        class="st3"
        d="M244.9,118.3c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1,0.1-0.1,0.3-0.2,0.4c0.2,0.1,0.4,0.1,0.6,0.2
		C244.8,118.5,244.8,118.4,244.9,118.3z"
      />
      <path
        class="st3"
        d="M253,120.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2,0-0.3-0.1v0.1C252.8,120,252.9,120.1,253,120.2z"
      />
      <path
        class="st3"
        d="M253.8,153.7L253.8,153.7c-2.2,1.9-4.4,3.8-7.1,6.1c2.9,0,5.2,0,7.9,0c-0.2-0.7-0.5-1.4-0.8-2.3
		c0.8-0.5,1.6-1,2.5-1.6C255.4,155.1,254.6,154.4,253.8,153.7z M250.9,158.4c-0.1-0.3-0.1-0.5-0.2-0.8c0.7-0.2,1.4-0.4,2.1-0.5
		c0.1,0.3,0.1,0.6,0.2,0.9C252.3,158.1,251.6,158.3,250.9,158.4z"
      />
      <path
        class="st3"
        d="M229.1,145.7c0-0.4,0-0.7-0.2-1c-0.7-0.1-1.3-0.1-2-0.2c0.2,0.5,0.4,0.9,0.7,1.4
		C228.2,145.8,228.6,145.7,229.1,145.7z"
      />
      <path
        class="st3"
        d="M285,157.2L285,157.2c-0.3,0.2-0.7,0.5-0.7,0.5c-2.2-1.8-2.4-0.1-2.8,2.3c5.6-0.1,9.6-1,10.5-2.4
		C289.5,157.3,287,160.2,285,157.2z"
      />
      <path
        class="st3"
        d="M271.5,169.9c0.2-0.2,0.5-0.5,0.7-0.7l0,0c0.3-0.6,0.6-1.2,1.2-2.3C272,167.9,270.1,167.8,271.5,169.9z"
      />
      <path
        class="st3"
        d="M256.7,150.9L256.7,150.9c-0.9,0.9-1.9,1.8-2.8,2.7c1.4,0,2.8,0,4.2,0C257.6,152.7,257.1,151.8,256.7,150.9z"
      />
      <path
        class="st3"
        d="M258.8,136.7c0,0.2,0,0.3,0,0.5c0.1-0.1,0.1-0.2,0.2-0.4C259,136.9,258.9,136.8,258.8,136.7z"
      />
      <path
        class="st3"
        d="M266.6,136.7c0.1-0.1,0.2-0.3,0.3-0.4c-0.1,0.1-0.3,0.2-0.4,0.3C266.5,136.6,266.5,136.6,266.6,136.7
		c0,0.1,0,0.1-0.1,0.2C266.5,136.8,266.6,136.7,266.6,136.7z"
      />
      <path
        class="st3"
        d="M221.2,117.9l-0.1,0.1c-0.3,0.7-0.5,1.5-0.3,2.4c0,0.2,0.2,0.4,0.2,0.6c0,0.4-0.6,0.7-0.9,0.5
		c-0.5-0.3-1-0.7-1.4-1c-0.1-0.1-0.2-0.1-0.3-0.2s-0.3-0.2-0.4-0.3l-0.1-0.1c0,0,0-0.1,0.1-0.1c0.4-0.5,0.8-1,1-1.4
		c0.1-0.1-0.2-0.3-0.3-0.6c-0.6,0.3-1.1,0.8-1.6,1c0.5,1.3,1,2.5,1.4,3.8l0,0c2,0.9,4.2,2.8,5.9,2.4c3.3-0.7,5.1,1.1,7.2,2.7
		c0.8-2.3,1.3-4,1.3-5.4l0,0c-0.4-0.3-0.9-0.5-1.4-0.7c-0.4-0.1-0.8-0.2-1.1-0.4c0.2-0.4,0.4-0.9,0.6-1.4c0-0.1,0.1-0.1,0.1-0.2
		c0.2-0.3,0.3-0.7,0.5-1c-0.6-0.6-1.5-1.1-2.5-1.7l0,0l-0.1-0.1c0.7,0.9,1.3,1.7,2,2.6c-0.2,0.2-0.3,0.3-0.5,0.5
		c-1.3-1.2-2.6-2.4-3.9-3.5c-0.3-0.2-0.7-0.4-1-0.7c-1,0-1.9,0.2-2.7,0.5C222.2,116.6,221.6,117.2,221.2,117.9z"
      />
      <path
        class="st3"
        d="M352.6,155.9c0.1-0.6-0.5-1.4-0.9-2.1c-0.3-0.5-0.6-1-0.9-1.5c-0.5,0-0.9,0-1.4,0c0.3,1.5,0.6,3.1,1,5.2
		C351.5,156.8,352.5,156.4,352.6,155.9z"
      />
      <path
        class="st3"
        d="M375.5,140.6c0-0.4-0.4-0.7-0.7-1.1c-0.1,0.6-0.3,1.2-0.5,2.5C375,141.2,375.5,140.9,375.5,140.6z"
      />
      <path
        class="st3"
        d="M380.5,132.5c0.1,0.4,0.1,0.7,0.2,1.1c0.1-0.1,0.3-0.2,0.4-0.2C380.9,133.1,380.7,132.8,380.5,132.5z"
      />
      <path
        class="st3"
        d="M367.1,148.9C367.2,149,367.2,149.1,367.1,148.9L367.1,148.9z"
      />
      <path
        class="st3"
        d="M448.9,77.4c-0.4,0.4-0.8,0.9-1.1,1.3l0,0c0.2,0.2,0.4,0.4,0.7,0.7c0.3-0.6,0.6-1.1,0.9-1.7
		C449.2,77.6,449,77.5,448.9,77.4z"
      />
      <path
        class="st3"
        d="M255.3,144.5c-0.3,0.4-0.7,0.8-1.1,1.4c0.7-0.1,1.5-0.1,2.2-0.2c0-0.2,0.1-0.4,0.1-0.6
		C256.1,144.9,255.7,144.7,255.3,144.5z"
      />
      <path
        class="st3"
        d="M231.2,113.3c0.4,0,0.8,0,1.3,0c-0.6-0.4-1.3-0.8-1.9-1.2C230.8,112.5,231,112.9,231.2,113.3L231.2,113.3z"
      />
      <path
        class="st3"
        d="M216.4,139.4c0.5-0.2,0.9-0.4,1.4-0.7c-0.5,0-0.9,0-1.4,0C216.4,139,216.4,139.2,216.4,139.4z"
      />
      <path
        class="st3"
        d="M214.9,140.9c0.2,0,0.4,0,0.6,0c0-0.2,0-0.4,0-0.6C215.4,140.5,215.2,140.7,214.9,140.9z"
      />
      <path
        class="st3"
        d="M226.5,114.8c-0.2-0.2-0.4-0.3-0.6-0.5h-0.1c0.1,0.2,0.3,0.4,0.4,0.5C226.3,114.9,226.4,114.8,226.5,114.8z"
      />
      <path
        class="st3"
        d="M228.2,112.4L228.2,112.4c0,0.1,0,0.1,0.1,0.1C228.2,112.5,228.2,112.4,228.2,112.4z"
      />
      <path
        class="st3"
        d="M235.4,116.9c-0.2,0-0.3,0-0.5,0c0.1,0.1,0.2,0.1,0.3,0.2C235.3,117,235.3,117,235.4,116.9z"
      />
      <path
        class="st3"
        d="M234.6,116.8c-0.1-0.1-0.1-0.2-0.2-0.2c0,0.1,0,0.2,0,0.2C234.5,116.8,234.6,116.8,234.6,116.8z"
      />
      <path
        class="st3"
        d="M210.4,151.8c0.1-0.1,0.3-0.3,0.4-0.4l0,0C210.7,151.5,210.6,151.6,210.4,151.8z"
      />
      <path
        class="st3"
        d="M212.5,159.8c0-0.3,0-0.6,0-0.9c-1.1,0.2-2.2,0.3-3.3,0.5c-0.1-0.3-0.1-0.6-0.2-0.8c2.1-0.4,4.2-0.8,6.6-1.2
		c-0.5-0.8-0.8-1.3-1.4-2.2c1.3,0,2.3,0,3.3,0c-1.4-0.7-2.8-1.3-4.3-2.1c0.2-0.5,0.5-1.6,0.8-3c1.2,1.2,2.3,2.4,4,4.2
		c-0.4-3.3,0-5,3.1-3.8c0.6,0.2,1.6-0.6,2.5-0.9c-0.7-0.7-1.3-1.3-1.9-2c0-0.1,0.5-0.6,0.8-0.9c-0.1-0.6-0.3-1.2-0.4-1.9l0,0
		c-0.5-0.1-1-0.2-1.5-0.3c-0.1,0-0.1,0-0.2,0v-0.1v0.1l0,0c-0.7,0.3-1.5,0.7-2.6,1.2c1.2-2.7,1.2-2.8,2.6-1.2c0,0,0,0,0.1,0
		s0.1,0,0.2,0c0.4-0.1,0.7-0.1,1.1-0.2c2.3-2,2.1,0.6,2.8,1.6c0.8-0.5,1.5-1,2.3-1.5c-0.3-0.3-0.6-0.7-1.2-1.3c0.1,0,0.2,0,0.3,0
		c-0.3-0.1-0.6-0.2-1-0.3s-1,0.1-1.4,0.2c-0.9,0.2-1.7,0.3-2.6-0.4c0.8-0.2,1.5-0.5,2-1c-0.4-0.1-0.9-0.2-1.4-0.4
		c0.7-0.1,1.3-0.2,2-0.3c0-0.1,0.1-0.2,0.2-0.3c0.2-0.5,0.2-1.2,0.1-1.6c-0.1-0.4-0.4-0.7-0.8-1c-0.3-0.2-0.7-0.3-1.1-0.4
		c-0.4-0.1-0.9-0.1-1.4,0c-0.1,1.8,2.8,0.4,2.7,2.6c-2.5,0.2-5.1,0.4-7.6,0.7c0,0.2,0,0.5,0,0.7c-0.2,0-0.5,0-0.7,0l0,0
		c0.2,0,0.5,0,0.7,0c0.7,0.5,1.4,0.9,2.7,1.7c-2.6,0.7-4.2,3.6-6.3,0.4c0-0.3,0-0.6,0-0.9l0,0c0,0.3,0,0.5,0,0.8
		c-1.2,1.2-2.3,2.3-3.5,3.5l0,0c1-0.1,2.2-0.5,2.3,1.2c0.5,0.3,1,0.5,1.5,0.8c-0.1,0.2-0.3,0.4-0.4,0.7c-0.5-0.4-0.9-0.8-1.4-1.2
		c-0.7-0.5-1.3-1-2-1.5h-0.1c-1.1,1.4-2.3,2.8-3.5,4.3c-0.6,0.3-1.7,0.8-2.7,1.3l0,0c1.6,0,3.2,0,5.5,0.1c-2,2-5,1.8-5.8,0.5
		c-0.1-0.1,0.1-0.3,0.3-0.6l0,0l0.1-0.1c-1,0.6-2,1.1-2.9,1.9c-2.1,1.9-4.2,4-5.9,5.6c1.4,0,3.6,0,5.6,0c0.1-0.9,0.1-2,0.2-2
		c1.3-0.2,3.3-0.7,3.9-0.1C206.1,161.7,209.5,159,212.5,159.8z M219.5,145.6c-0.2,1.1-0.2,1.7-0.3,2.4c0,0.2,0,0.4,0,0.6
		c0,0.1,0,0.2,0.1,0.3c-0.1,0-0.1,0-0.2,0c-0.3,0.1-0.7,0.3-1,0.4c0-0.2-0.1-0.3-0.1-0.5c0.4,0,0.7,0,1.1,0.1h0.1c0-0.1,0-0.2,0-0.3
		c0-0.2-0.1-0.3-0.1-0.5c-0.9-0.4-1.7-0.7-3.3-1.4C217.5,146.2,218.4,145.9,219.5,145.6z M213.3,146.8c0.9,0.7,1.7,1.4,2.6,2.1
		c-0.2,0.2-0.4,0.5-0.5,0.7c-0.9-0.6-1.8-1.2-2.7-1.9C212.8,147.4,213,147.1,213.3,146.8z M212.3,156c-1.5-0.7-2.8-1.2-4.2-1.9
		C211.4,153.3,211.6,153.3,212.3,156z M207.2,150.4c0.3-0.3,0.6-0.6,0.9-0.9c0.2,0.4,0.4,0.7,0.6,1.1c0.7,0.2,1.4,0.5,2.1,0.7l0,0
		c0.1,0.2,0.2,0.5,0.3,0.7c-0.2-0.1-0.5-0.2-0.7-0.3c-0.7-0.2-1.4-0.5-2.1-0.7C208,150.8,207.6,150.6,207.2,150.4z M209.2,155.8
		c-0.4,0.4-0.6,0.7-0.7,0.6c-0.3-0.1-0.6-0.3-0.8-0.5C208.1,155.9,208.5,155.9,209.2,155.8z M200.8,156.9c-0.2,0.1-0.6-0.4-1.1-0.7
		c0.4-0.5,0.8-1.1,0.9-1.1c0.4,0.2,0.8,0.6,1.1,0.9C201.4,156.4,201.1,156.8,200.8,156.9z M203.5,156.1c0.1-0.2,0.2-0.5,0.4-0.7
		c0.4,0.2,0.8,0.5,1.2,0.7c-0.1,0.2-0.1,0.3-0.2,0.5C204.5,156.4,204,156.2,203.5,156.1z M205,159.2c0.6-0.4,0.9-0.6,1-0.6
		c0.3,0.1,0.6,0.3,0.9,0.5C206.4,159.2,205.9,159.2,205,159.2z"
      />
      <path
        class="st3"
        d="M223,146.8c1.6,1.8,3.5,1.5,4.6-0.9C226.1,146.6,224.7,148,223,146.8z"
      />
      <path
        class="st3"
        d="M218.1,155.4c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.1,0.1,0.2C217.9,155.4,218,155.4,218.1,155.4z"
      />
      <path
        class="st3"
        d="M462.2,74.1c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3-0.4,0.4-1.3-0.4-1.8c-0.4,0.4-0.6,0.5-0.6,1c0,0.1,0,0.3,0,0.4
		c0.1,0.4,0.2,0.9,0.5,1.8c0.3,0,0.5,0,0.8,0C462,74.9,462.1,74.5,462.2,74.1z"
      />
      <path
        class="st3"
        d="M227.1,116c0.4,0.1,0.9,0.1,1.3,0.2l0,0c-0.3-0.3-0.7-0.5-1-0.8c0,0.1,0.1,0.2,0.1,0.4c-0.2,0-0.4,0-0.5,0
		C227,115.8,227,115.9,227.1,116z"
      />
      <path
        class="st3"
        d="M215.1,117.6c-0.1-0.5-0.2-0.9-0.2-1.3c-0.3-0.2-0.6-0.4-1-0.5c-0.6-0.2-1.1-0.2-1.6-0.1
		C213.3,116.3,214.3,116.8,215.1,117.6z"
      />
      <path
        class="st3"
        d="M554.6,165.4c-0.2,0.4-0.3,0.8-0.6,1.1c0,0,0,0,0.1,0c1.3-0.1,1.9-0.5,2.9-2.1c0.4,0.2,0.7,0.5,1.1,0.7
		c0.1-0.3,0.1-0.7,0.1-1.1C556.4,163.5,555.3,163.4,554.6,165.4z"
      />
      <path
        class="st3"
        d="M468.7,188.1c0.2,0,0.5,0,0.7,0c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.5,0-0.7,0C468.6,188,468.6,188.1,468.7,188.1z
		"
      />
      <path
        class="st3"
        d="M441.4,176.4l-0.2-0.2C441.2,176.2,441.4,176.3,441.4,176.4z"
      />
      <path
        class="st3"
        d="M475.6,192.7c0.4-0.2,0.6-0.4,1.2-0.3c1.1,0.1,2.2-0.8,2.3-1.8c-2.5-0.2-5-0.5-7.5-0.8
		c-0.2,0.1-0.3,0.1-0.5-0.1c-0.2,0-0.5,0-0.7-0.1c-0.2,0-0.3,0-0.5,0c0,0,0.1,0,0.1-0.1c-0.4,0-0.8-0.1-1.2-0.1
		c0.3,0.4,0.3,0.9,0.2,1.5c-0.6,0.3-1.4-0.1-1.8,0.7c0.4,0.2,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.7,1.1,1.4c0.2-0.7,0.3-1.1,0.3-1.4
		c1-0.1,1.9-0.1,2.7,0.5C473.4,193.5,474.6,193.2,475.6,192.7z"
      />
      <path
        class="st3"
        d="M487.2,194.1c1.8-0.8,2.4-1.6,2.2-2.9c-1.5-0.1-2.9-0.3-4.4-0.3c-0.8,0-1.6-0.1-2.4-0.1
		c0.1,0.2,0.2,0.3,0.3,0.5c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5c0.2,0.7,0.5,1.3,1.3,1.8c-0.2,0.1-0.4,0.1-0.6,0.1
		c0.8,0.1,1.6,0.2,2.4,0.3c-0.1-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.2-0.3-0.3-0.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-1-1-2,0-3.4
		C486.3,194.5,486.7,194.3,487.2,194.1z"
      />
      <path
        class="st3"
        d="M491.3,182.5C491.3,182.4,491.3,182.4,491.3,182.5c-1.3,1.5-2.6,2.9-3.6,4.1c1-0.5,2.2-1.2,3.6-1.9
		C491.5,183.9,491.5,183.2,491.3,182.5z"
      />
      <path
        class="st3"
        d="M477.4,225.4c-0.5-0.6-1.4-1.1-2.5-1.3c-1.2,0.3-2.3,0.8-3.4,1.5c1.9,1.1,3.5,2.1,5.1,3.1
		c-2.7,0.7-4.8-1.2-7.6,0.2c-1.2,0.6-2.4-1.4-0.9-3l0,0c-0.6-0.4-1.4-1.4-1.8-1.3c-2.1,0.8-4,0.3-5.9-0.7c-0.5-0.3-1.3,0.1-2.4,0.2
		c2.4,1,4.5,1.8,6.5,2.6l0.1-0.1v0.1c0.7,0.2,1.4,0.5,2.2,0.7c-0.1,0.3-0.2,0.6-0.3,0.9c-0.6-0.2-1.2-0.5-1.7-0.7
		c-0.2,1.1-0.4,2.2-0.6,3.6c-1-0.4-1.7-0.7-2.4-1l0,0c-1.8,0.7-3.4,0.5-4.9-0.1c1,1,2.3,1.5,4,1.6c-0.3,1.2-0.4,2.4,0.3,3.5
		c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7c0.1-0.1,0.2-0.3,0.3-0.4c-1.3-0.4-2.6-0.9-3.9-1.3c0.1,0.1,0.1,0.3,0.1,0.5l0,0
		c0.1,0.2,0.1,0.5,0.2,0.7c-0.2-0.2-0.3-0.3-0.5-0.5c-1.1-0.3-2.3-0.6-3.4-1c0.1-0.3,0.2-0.6,0.3-0.9c0.8,0.1,1.7,0.2,2.5,0.3
		c1.7-1.6,3.1-0.5,4.7,0.2c0.1,0.1,0.3,0.1,0.5,0.2c0-0.2,0.1-0.5,0.1-0.7c1.2,0,2.3-0.1,3.3-0.5c-0.4-0.4-0.7-0.7-1.1-1.1
		c0.1-0.1,0.2-0.2,0.2-0.2c0.4,0.4,0.9,0.7,1.3,1.1c0.4-0.2,0.8-0.5,1.2-0.8l0,0c0.5-0.5,0.8-1.1,1-1.7
		C476.7,227,476.5,226.3,477.4,225.4z"
      />
      <path
        class="st3"
        d="M446.7,183.8c0.4,0.2,0.9,0.3,1.2,0.5c0.1,0.1,0.2,0.2,0.4,0.3c1.4,0.2,2.8,0.7,4.1,0.8
		c3.9,0.3,7.8,0.6,11.8,0.8c3.3,0.2,6.6,0.3,9.9,0.5c0.4-0.5,0.7-1.1,1-1.6c0.1-0.2,0.2-0.5,0.2-0.8c-0.5,0.6-0.9,1.1-1.6,1.9
		c-0.4-1.3-0.6-2.1-0.9-3c1,0.1,1.7,0.1,2.7,0.2c0.1-0.3,0.1-0.7,0.2-1c0.2-0.1,0.3-0.1,0.5-0.2c0.4-0.1,0.8-0.3,1.2-0.4
		c0,0.5-0.1,1-0.1,1.6c0.9,0.2,2.1-0.4,2.3,1.1c0,0-0.3,0.4-0.7,0.7l0,0h-0.1c-0.4-0.2-0.8-0.4-1.2-0.6c-0.2,0.2-0.3,0.3-0.3,0.5
		c-0.1,0.4,0.1,0.6,0.5,0.8l0,0c0.3,0.1,0.7,0.3,0.7,0.5s0.1,0.4,0.2,0.5c0.6,0,1.1,0.1,1.7,0.1c0-7.6,0-15,0-22.8
		c-0.5,0.6-0.8,1-1.1,1.4c-0.7-0.8-1.4-2.1-2.2-2.2c-2.2-0.1-4.4,0.2-6.6,0.4c0.1,0.6,0.2,1.1,0.3,1.7c1-0.9,2-1.4,2.9,0.1h0.1l0,0
		c0.5-0.5,1.1-1,1.6-1.5c0.2,0.2,0.5,0.4,0.7,0.7c-0.7,0.7-1.3,1.3-2,2c-0.1-0.4-0.2-0.8-0.4-1.2l0,0c0,0,0,0,0-0.1
		c-0.9,0-1.8,0.1-2.7,0.1c-1.5,0.6-3,1.2-4.5,1.8c-0.1-0.2-0.2-0.5-0.4-0.7c0.7-0.9,1.5-1.8,2.2-2.7c-0.1-0.3-0.2-0.6-0.3-0.9
		c-42,1.4-84.2-0.3-126.2,3.2c-1.4,4.9-1.5,9.3-0.2,13.8c8.8,0.3,17.4,0.6,26,0.9c0.7-1.7,1.3-3.2,2-4.7c0.3,0.1,0.6,0.2,0.9,0.3
		c-0.4,1.2-0.9,2.5-1.5,4.2c2.6,0.3,5,0.8,7.5,0.9c7.1,0.3,14.1,0.4,21.2,0.6c0.7,0,1.4,0,2.1-0.1c-0.6-1.7,0.7-1.3,1.3-1
		c1.7,0.7,3.2,0.9,5.2,0.9c5.5-0.1,10.9,1.2,16.4,1.6c5.4,0.4,10.8,0.4,16.2,0.5l0,0c-0.3-0.3-0.6-0.6-0.9-0.9
		c0.4,0.2,0.8,0.3,1.3,0.5c2.1,0.8,4,1.4,6.5,0.7c0.2-0.1,0.5-0.1,0.7-0.1c-0.1,0-0.2-0.1-0.3-0.1c0-0.2,0-0.4,0.1-0.8
		C446.5,183.7,446.6,183.8,446.7,183.8z M474.4,179.6c0.1,0.1,0.2,0.2,0.3,0.4C474.6,179.8,474.5,179.7,474.4,179.6
		c0.6-0.5,1.3-1.1,1.9-1.6c0.1,0.2,0.3,0.4,0.4,0.6c-0.7,0.4-1.4,0.9-2.1,1.3c-0.5,0.3-0.9,0.5-1.4,0.8c-0.7,0.5-1.4,0.9-2.1,1.4
		l0,0c-0.5,0.4-1,0.9-1.5,1.3c0.5,0.3,1,0.7,2,1.3c-1.3,0-2.1,0-3.3,0c0.4-0.7,0.7-1.1,1-1.6l0,0c0.5-0.5,1-0.9,1.5-1.4
		c0.7-0.4,1.5-0.9,2.2-1.3C473.6,180.2,474,179.9,474.4,179.6z M470.9,176.1c0.4-0.1,0.8-0.2,1.2-0.3c-0.3,0.2-0.5,0.5-0.8,0.7
		c-1.4,1.1-2.8,2.2-4.2,3.3c-0.2-0.3-0.4-0.5-0.5-0.8C468,178.1,469.4,177.1,470.9,176.1z M362,180.8c-0.3-0.3-0.5-0.6-0.8-0.8
		c0.8-0.7,1.7-1.5,2.5-2.2c0.2,0.2,0.4,0.4,0.6,0.7C363.6,179.2,362.8,180,362,180.8z M375.9,177.2l0.1,0.2h-0.2L375.9,177.2z
M379.2,179.9c-1.2,0.6-2.4,1.2-3.6,1.8c-0.2-0.4-0.3-0.7-0.5-1.1c1.2-0.3,2.5-0.7,3.7-1l0,0c0.2-0.1,0.5-0.2,0.7-0.3
		C379.5,179.5,379.3,179.7,379.2,179.9z M381.5,179.1c-0.2,0-0.3-0.2-0.5-0.3c0.2-0.1,0.4-0.3,0.5-0.3c0.2,0,0.3,0.2,0.5,0.3
		C381.8,178.9,381.7,179.1,381.5,179.1z M390.7,180.2c-0.1-0.2-0.1-0.5-0.2-0.7c0.7-0.2,1.4-0.4,2.2-0.5c0,0.2,0.1,0.4,0.1,0.6
		C392.1,179.8,391.4,180,390.7,180.2z M392.6,167.8L392.6,167.8c-0.2,0.1-0.4,0.2-0.6,0.2C392.1,168,392.3,167.9,392.6,167.8
		c1.4-0.9,2.9-1.7,4.4-2.5c0.1,0.3,0.3,0.7,0.4,1C395.8,166.8,394.2,167.3,392.6,167.8z M400.1,165c0.6,0.3,1.3,0.6,1.9,0.9
		c-0.1,0.2-0.2,0.4-0.3,0.6c-0.7-0.3-1.3-0.6-2-0.9C399.9,165.5,400,165.3,400.1,165z M399.2,171.4c-0.1-0.2-0.2-0.3-0.3-0.5
		c1.1-0.3,2.2-0.6,3.3-1c0.1,0.2,0.1,0.4,0.2,0.7C401.3,170.9,400.3,171.1,399.2,171.4z M402.6,180.4c-0.1-0.4-0.2-0.8-0.3-1.1
		c0.3,0.2,0.6,0.4,0.8,0.6C403,180.1,402.8,180.3,402.6,180.4z M406.7,168.6c-0.1,0-0.1,0-0.2,0c-0.3,0.2-0.6,0.4-0.8,0.5
		c-0.1-0.2-0.1-0.3-0.2-0.5c0.3,0,0.7,0,1-0.1C406.6,168.5,406.6,168.5,406.7,168.6c0-0.1,0.1-0.1,0.2-0.1c0.2-0.2,0.1-0.1,0,0l0,0
		C406.8,168.5,406.8,168.5,406.7,168.6z M410.5,167.4c-0.3,0.1-0.6,0.2-0.9,0.2c0-0.1-0.1-0.2-0.1-0.4c0.3-0.1,0.6-0.3,0.9-0.4
		C410.4,167.1,410.5,167.4,410.5,167.4z M413.2,166.3c-0.2,0-0.4-0.1-0.6-0.2c0.1-0.1,0.2-0.4,0.4-0.4c0.2,0,0.4,0.1,0.6,0.2
		C413.5,166.1,413.4,166.3,413.2,166.3z M415,164.9c0.6,0.2,1.1,0.5,1.7,0.7c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3
		c0.1,0.2,0.2,0.4,0.4,0.7c-0.2-0.1-0.4-0.3-0.6-0.4c-0.5-0.1-1.1-0.3-1.6-0.4C414.9,165.2,414.9,165.1,415,164.9z M418.8,169.4
		c-1.2,0.4-2.5,0.8-3.7,1.2c-0.1-0.4-0.1-0.8-0.2-1.2c1.2-0.1,2.4-0.3,3.6-0.4c1.2-0.4,2.3-0.9,3.5-1.3c0.1,0.3,0.2,0.5,0.2,0.8
		C421.1,168.8,420,169.1,418.8,169.4z M462.4,165.5c0,0.3,0.1,0.6,0.1,0.9c-1.1,0.2-2.2,0.5-3.3,0.7c-0.1-0.4-0.1-0.7-0.2-1.1
		C460.2,165.8,461.3,165.6,462.4,165.5z M456.4,184c0.6-1.1,1.2-2.2,1.8-3.2c0.5,0.4,0.9,0.8,1.4,1.2
		C458.5,182.6,457.4,183.3,456.4,184l-0.1,0.1l-0.1-0.1C456.3,184,456.3,184,456.4,184z M451.8,181.1L451.8,181.1L451.8,181.1
		c0.2-0.2,0.5-0.5,0.7-0.7c0.2-0.1,0.5-0.3,0.7-0.4c0-0.1,0.1-0.1,0.1-0.2c0.1-0.1,0.2-0.3,0.2-0.3s-0.1,0.2-0.1,0.4
		c-0.1,0-0.1,0.1-0.2,0.1c-0.2,0.2-0.3,0.4-0.5,0.6c-0.2,0.2-0.5,0.5-0.7,0.7c-0.2,0.3-0.5,0.7-0.7,1c-0.1-0.1-0.3-0.2-0.3-0.2
		C451.3,181.8,451.5,181.4,451.8,181.1z M424.4,182.7C424.4,182.7,424.3,182.7,424.4,182.7c-0.1,0.2-0.2,0.3-0.2,0.5
		c-0.1-0.1-0.2-0.2-0.3-0.3C424,182.8,424.1,182.8,424.4,182.7C424.3,182.7,424.3,182.7,424.4,182.7l0.2-0.2L424.4,182.7z
M438.8,179c0,0-0.1,0-0.2,0.1l-0.1,0.1l-0.1-0.1c0,0,0.1,0,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3C438.8,178.9,438.8,179,438.8,179z
M437.3,174.4L437.3,174.4c-0.2,0.2-0.5,0.5-0.7,0.7c-2.4,1.9-4.7,3.8-7.1,5.6l0,0c-0.3,0.2-0.6,0.3-0.9,0.5l0,0
		c-0.2,0.2-0.5,0.5-0.7,0.7l-0.1-0.1l0.1,0.1c-0.1,0-0.2,0-0.2,0.1c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.5-0.5,0.7-0.7l0,0
		c0.2-0.3,0.4-0.5,0.6-0.8c2.1-2.2,3.6-5.1,7-5.7c0.2-0.2,0.5-0.5,0.7-0.7c1.1-1.2,2.2-2.6,4.8-1.6
		C440,173.3,438.7,173.8,437.3,174.4z M444.3,177.1h-0.1c-0.9,0.9-1.8,1.9-2.7,2.8c-0.2-0.2-0.4-0.5-0.7-0.7c1.4-1.7,2.8-3.3,4.1-5
		l0,0c0,0,0,0,0-0.1c-0.4,0.1-0.8,0.2-1.1,0.3l0,0c-0.3,0.2-0.5,0.4-0.8,0.7c-0.3,0.2-0.5,0.4-0.8,0.6c-0.2,0.2-0.5,0.5-0.7,0.7
		s-0.5,0.5-0.7,0.7c-0.2,0.1-0.5,0.1-0.7,0.2c0.2-0.2,0.3-0.3,0.5-0.5l0,0l0,0c0.2-0.2,0.5-0.5,0.7-0.7l0,0c0.2-0.3,0.4-0.5,0.7-0.8
		l0,0c0.2-0.2,0.5-0.5,0.7-0.7s0.5-0.5,0.7-0.7c0.5-0.5,1-0.9,1.4-1.4c1.4-1.5,2.8-3,4.1-4.5c0.2,0.2,0.5,0.5,0.7,0.7
		c-1.5,1.3-3,2.6-4.6,4c-0.1-0.1-0.2-0.2-0.3-0.2c0.1,0.1,0.2,0.2,0.3,0.2c-0.1,0.4-0.2,0.8-0.2,1.2c0,0,0,0,0.1,0l-0.1,0.1l0.1-0.1
		c0,0,0,0-0.1,0.1c0.7-0.2,1.4-0.5,2-0.7c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1s0-0.1,0.1-0.2c0,0,0.1,0,0.2-0.1
		c-0.1,0.1-0.2,0.2-0.3,0.2v0.1h-0.1c-0.9,1.2-1.8,2.3-2.8,3.5l0.1-0.1C444.2,177,444.3,177,444.3,177.1c0.1,0,0.1,0,0.2,0
		c0,0,0,0.1,0.1,0.2C444.4,177.2,444.4,177.1,444.3,177.1z M445.7,179.2c-0.1-0.1-0.2-0.2-0.3-0.3
		C445.5,179,445.6,179.1,445.7,179.2c-0.2,0.2-0.5,0.3-0.7,0.5c0,0,0,0.1-0.1,0.1v-0.1l0.1-0.1c0.1-0.3,0.3-0.5,0.4-0.8
		c0.6-2.6,0.6-2.6,3.4-3C447.5,177.3,446.6,178.3,445.7,179.2z"
      />
      <path
        class="st3"
        d="M439,184.3c0.1-0.1,0.2-0.3,0.3-0.4C439.2,184.1,439.1,184.2,439,184.3L439,184.3z"
      />
      <path class="st3" d="M440.5,176.9l0.1,0.1L440.5,176.9z" />
      <path
        class="st3"
        d="M429.2,180.5c0.1,0.1,0.2,0.2,0.3,0.3l0,0C429.4,180.6,429.3,180.6,429.2,180.5z"
      />
      <path class="st3" d="M440.8,177.1l-0.1-0.1L440.8,177.1z" />
      <path
        class="st3"
        d="M281.4,177.5c0-0.4,0-0.8,0-1.2c-0.1,0-0.3,0.1-0.4,0.1C281.1,176.8,281.2,177.2,281.4,177.5z"
      />
      <path
        class="st3"
        d="M372,104.4c0.1,0,0.1-0.1,0.1-0.1c-0.7-0.4-1.3-0.8-2.1-0.9c-0.1,0-0.2,0-0.3,0c-0.4,0.1-0.9,0.2-1.3,0.3
		c0,0.1,0.1,0.1,0.1,0.2c0.1,0.2,0.2,0.4,0.3,0.5c-0.3,0.4-0.5,0.7-1,0.8c0.2,0.2,0.3,0.4,0.5,0.8c0,0.1,0.1,0.2,0.1,0.3
		c0.1-0.1,0.3-0.1,0.4-0.2c0.1,0,0.3-0.1,0.4-0.1l0,0c0.2-0.2,0.5-0.7,0.6-0.7s0.2,0,0.3,0c-0.2-0.1-0.4-0.2-0.6-0.4
		C370.8,104.5,371.5,104.3,372,104.4z"
      />
      <polygon class="st3" points="365.3,112.8 365.2,113 365.4,113 	" />
      <path
        class="st3"
        d="M117.5,166.2c0-0.1-0.1-0.2-0.1-0.3c-0.5,0.2-0.9,0.3-1.4,0.5C116.6,166.3,117.1,166.2,117.5,166.2z"
      />
      <path
        class="st3"
        d="M309.8,177L309.8,177c-0.5,0.5-0.9,1.2-1.8,2.4c1.4-0.9,2.2-1.4,3-1.9C310.5,177.4,310.1,177.2,309.8,177
		L309.8,177z"
      />
      <path
        class="st3"
        d="M470.9,196.7c-0.1,0-0.1-0.1-0.2-0.1c-0.5-0.3-0.8-0.7-0.9-1.3c-0.1-1.3-1.2-2.1-2.8-2
		c-1.7,0.2-2.4-0.9-3.7-1.2c0.6-0.7,0.9-1.2,1.9-1.5c0.1,0,0.1-0.1,0.2-0.1c0.5-0.1,0.9-0.4,1.3-0.7c0.2-0.1,0.4-0.2,0.5-0.4
		c-0.3,0-0.5-0.1-0.8-0.1c-6.4-0.4-12.7-0.8-19.1-1.2c0,0.1-0.1,0.1-0.1,0.2c-0.7,0.9-0.6,1.8,0.1,2.6c0.6,0.6,1.8,0.8,2.7,0.5
		c1.2-0.5,1.9-1.3,1.7-2.4v-0.1c0-0.1,0-0.1,0.1-0.2c0.5,0.1,0.9,0.3,0.7,0.8c0,0.1,0,0.1-0.1,0.2c-0.2,0.5-0.3,1-0.5,1.5
		c-0.3,0.6-0.6,1.3-0.8,1.9c-0.3,0.6-0.5,1.3-0.7,1.9c-0.6-0.6-0.4-1.7-1.6-2.1c-0.1,0.2-0.2,0.4-0.2,0.5c0.1,1.3,1.3,2.3,1.1,3.7
		c-0.1,0.4,0.8,0.5,1.4,0.2c0.2-0.1,0.4-0.4,0.6-0.7c0.3,0.1,0.7,0.2,1,0.4c1.2,0.6,2.3,0.5,3.4-0.2c1-0.7,1.4-1.6,1.1-2.5
		c-0.3-1.1-1.2-1.7-2.6-1.7c-0.2,0-0.4,0-0.5,0c0.7-2.1,2.1-3,4-2.5c0.3,0.1,0.7,0.3,0.8,0.5c0.3,1.1,1.2,1.7,2.6,1.9
		c-0.9,1.6-2,3.2-1.3,5c4.2,0,8.4,0.4,12.5,0.6C472.2,197.5,471.6,197.1,470.9,196.7z"
      />
      <path
        class="st3"
        d="M489.5,153.6c0.5,0,0.9,0,1.4,0l0,0c1.6-1.3,3-2.9,4.7-3.9c2.5-1.4,2.6-3,0.5-6c-0.4,0.9-0.7,1.5-0.9,2.2l0,0
		c1.6,1.6-0.4,1.9-1.1,2.4C492,149.6,489.9,150.9,489.5,153.6z"
      />
      <path
        class="st3"
        d="M471.5,221.8c-0.1-0.1-0.3-0.3-0.4-0.4c0,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.3,0.2,0.4,0.4
		C471.5,221.9,471.6,221.8,471.5,221.8z"
      />
      <path
        class="st3"
        d="M470.9,223.6c-0.6-0.2-1.2-0.3-1.9-0.5c-0.1,0.2-0.1,0.3-0.2,0.5c0.6,0.2,1.2,0.4,1.8,0.6
		C470.7,224,470.8,223.8,470.9,223.6z"
      />
      <path
        class="st3"
        d="M497.8,161c-0.7,0.2-1.3,0.3-1.9,0.5c-0.7,4-4.4,5-7.1,7.1l0,0c-0.9,1.7-1.8,3.4-2.9,5.3
		c0.9-0.3,1.5-0.4,2-0.5c0.1,0.1,0.3,0.3,0.4,0.4c0.3,2.8-2.7,2.5-3.7,4l0,0c-0.7,0.5-1.3,1.1-2,1.6c0.4,0.4,0.9,0.8,1.3,1.2
		c0.5-0.7,0.9-1.4,1.4-2.1l0,0c3-1.9,6.1-3.9,9.1-5.8l0.2,0.2l-0.2-0.2c0.1-0.1,0.3-0.1,0.4-0.2c-0.1,0.1-0.2,0.3-0.2,0.4
		c-2.4,2.6-4.8,5.2-7.2,7.7l0.1-0.1c0,0,0,0,0,0.1c0.4,0,0.8,0,1.3,0c0,0,0.1,0,0.1-0.1l0.1-0.1c0,0,0-0.1,0.1-0.1
		c0,0,0.1,0,0.2-0.1c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.1-0.1,0.2h-0.1c-0.4,0.3-0.7,0.6-1.1,0.9c-0.8,0.6-1.6,1.2-2.5,1.6
		c-0.2,0.1-0.8-0.6-1.2-1.1c-2.5,1.2-1.3,2.7-0.3,4.5c2.6-1.8,5-3.6,7.5-5.3c-0.1-1.1,0.2-2.2,0.4-3.2c0-0.1,0-0.1,0.1-0.2
		c0.1-0.3,0.2-0.6,0.3-1c0.4,0.3,0.9,0.6,1.3,0.9c1-0.7,2.1-1.3,3.9-0.3c-0.8,0.6-1.4,1.1-2.1,1.6c0.3,0.2,0.6,0.4,0.9,0.6
		c0.1,0.1,0.2,0.2,0.4,0.3c0.5-0.4,1.1-0.8,1.7-1.3C497.8,172.9,497.8,167,497.8,161z M488.9,172.9c-0.1-0.1-0.3-0.3-0.4-0.4
		C488.7,172.7,488.8,172.8,488.9,172.9c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1-0.1-0.3-0.3-0.4-0.4c0.2-0.2,0.5-0.5,0.7-0.7
		c1.4-1.5,2.9-3.1,4.3-4.6c0.3,0.3,0.6,0.7,0.9,1C492.2,170.3,490.6,171.6,488.9,172.9z"
      />
      <path
        class="st3"
        d="M538.7,165.6c0.5,0,1,0,1.6,0c-0.5-0.2-1-0.3-1.5-0.5C538.8,165.3,538.7,165.4,538.7,165.6z"
      />
      <path
        class="st3"
        d="M483.8,180.5c0,0.4,0,0.9,0,1.3c0.5-0.4,0.9-0.8,1.4-1.2C484.8,180.6,484.3,180.6,483.8,180.5z"
      />
      <path
        class="st3"
        d="M505.6,181.8c0.7,0.5,1,1.2,1.1,2s0,1.1-0.7,1.4c0.7,0.1,1.3,0.3,2,0.4c0-0.2,0.1-0.4,0.1-0.6l0,0
		c0.2-1.4-0.3-2.7-1.3-3.8c-0.5-0.5-0.4-1.1-0.2-1.7c0.2-0.6,0.4-1.1,0.6-1.7c0.3-0.1,1-0.2,1.1-0.4c0.1-0.4-0.1-0.8-0.2-1.3
		c-0.5,0.4-0.8,0.7-1.1,0.9c-0.1,0-0.2-0.1-0.2-0.1c-0.2-2-0.9-3.9-0.3-6c0.9,0.1,2,0.2,3.2,0.3l0,0l0,0h-0.1
		c1.5,0.4,1.1,1.7,1.4,2.6c0.5,0.1,1,0.4,1.3,0.3c1.2-0.4,1.7,0.1,2,0.9c0.1,0.2,0.7,0.4,0.3,0.7c-0.5,0.4,0.4,1.3-1.1,1.4
		c0.5,0.6,0.9,1.1,1.2,1.6c0.2,0.3,0.5,0.7,0.5,1.1c0,0.3-0.4,0.7-0.7,0.8c-0.6,0.2-0.8-0.2-0.9-0.6c-0.7,0.7-0.8,1.4-0.3,2.2
		c1-0.8,1.8,0.1,2.7,0c-0.2-0.2-0.4-0.4-0.8-0.7c1.1-0.4,2-0.7,3.4-1.2c-0.5,0.5-0.7,0.7-1,0.9c0,0,0,0.1,0.1,0.1
		c0.7-0.4,1.5-0.7,2.2-1.1c0,0.1,0.1,0.3,0.1,0.4c0.1,0.3,0.2,0.9,0.1,0.9c-0.7,0.2-0.6,1-1.2,1.2c-0.9,0.4-1.3,1.1-1.7,1.8
		c-0.5,0.7-0.9,1.2-1.9,1.4c0.2,0.2,0.4,0.4,0.5,0.5c1.8,0.1,3.7,0.2,5.6,0.1c-1.2-0.3-2.1-0.6-3.1-0.9c2.1-0.7,4.2-1.6,5.8,0.7
		c0.1,0.2,0.4,0.4,0.6,0.3c3.1-0.9,5.6,2.2,9,1.1c0-2.4,0-4.9,0-7.3c-0.1,0-0.1,0-0.2,0c-0.2,0.2-0.7,0.5-1.1,0.8
		c-0.7-0.5-1.3-1-1.9-1.4c0,0,0,0-0.1-0.1c0,0-0.1,0-0.1-0.1c0,0,0,0-0.1,0c-0.3,0.1-0.5,0.7-0.9,0.6c-0.1,0-0.2-0.1-0.3-0.2l0,0
		c-0.3,0-0.7-0.1-1-0.1c-0.2,0-0.4-0.1-0.6-0.1c-0.3,0.2-0.6,0.5-0.9,0.7c-0.5-0.2-1.1-0.4-1.7-0.7c-0.2,0.5-0.3,0.9-0.5,1.4
		c-0.6-0.2-1.1-0.3-1.5-0.4c0.2-0.1,0.4-0.2,0.7-0.4c-0.5-0.1-0.8-0.2-1.1-0.3V180c0.5-0.3,1.1-0.7,1.6-1c0.1-0.1,0.4,0.2,0.7,0.4
		c0.2-0.1,0.4-0.1,0.5-0.2c0.6-1.2,0.3-1.2,1.9-1.3c0.4,0,0.7-0.1,1.1-0.2c0.2,0.3,0.3,0.6,0.5,0.9c0.2,0.4,0.4,0.8,0.6,1.1l0,0
		c0.6-0.4,0.7-0.9,0.8-1.4c0-0.4-0.1-0.8-0.1-1.3c1,0.1,1.1,0.6,1.1,1.4c0.3-0.2,0.5-0.4,0.7-0.5s0.4-0.2,0.7-0.4
		c-0.6-0.5-0.4-1.3-0.1-1.9c0.2-0.4,0.7-0.7,1.2-1c0-2.5,0-5.1,0-7.8c-11.5-0.6-22.8-1.2-34.3-1.7c0,1,0,1.8,0,2.8
		c0.6-0.3,1.2-0.5,1.7-0.8l0.1-0.1h0.1l-0.1,0.1c0,0-0.1,0-0.1,0.1c-1.7,2.3-1.9,4.7-1.8,7.2c0.7-0.4,1.5-0.8,2.5-0.3
		c0.3,0.1,0.7,0,1.2,0c1.1,1.8,1.7,3.8,1.6,5.9C504.9,180.7,505,181.3,505.6,181.8z M520.2,180.2L520.2,180.2
		C520.2,180.2,520.2,180.2,520.2,180.2L520.2,180.2z"
      />
      <path
        class="st3"
        d="M128.4,169.8c0.7-0.2,1.5-0.3,2.2-0.5c-0.8,0-1.5,0-2.3,0C128.3,169.5,128.3,169.7,128.4,169.8z"
      />
      <path
        class="st3"
        d="M488.8,168.5c0.4-0.6,0.9-1.1,1.1-1.7c0.1-0.2-0.3-0.6-0.5-1C489.2,166.7,489,167.6,488.8,168.5z"
      />
      <path
        class="st3"
        d="M467.9,220.5c0.3,0.1,0.6,0.1,0.9,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.3-0.1-0.6-0.3-0.9-0.4
		C468,220.2,468,220.3,467.9,220.5z"
      />
      <path
        class="st3"
        d="M489.3,153.8c-0.5,0.2-1,0.3-1.6,0.5c0.1,0.2,0.2,0.4,0.3,0.6C488.5,154.5,488.9,154.1,489.3,153.8z"
      />
      <path
        class="st3"
        d="M497.3,150.5c-2.2,1.1-4.4,2.2-6.5,3.2c-1,1-2.1,1.9-3,2.9c-0.4,0.4-0.4,1.2-0.7,1.8c1.5-0.9,3-1.8,4.4-2.7
		c0.2,0.3,0.3,0.6,0.5,0.9c-1.5,0.8-3,1.5-4.5,2.3c-1.4,0.4-1.7,2.9-3.8,2.1l0,0c-0.5,0.9-1,1.8-1.5,2.6c0.2,0.1,0.4,0.3,0.6,0.4
		c0.5-0.5,1-1,1.5-1.6c0.3,0.4,0.6,0.7,0.8,1.1l0,0c0.5-0.3,0.9-0.5,1.4-0.8c0.3-0.2,0.5-0.3,0.8-0.4c0,0,0.2,0.1,0.2,0.2
		c-0.2,0.2-0.5,0.3-0.7,0.5c-0.4,0.3-0.9,0.5-1.3,0.8c-0.6,0.8-2.5,1.2-0.8,2.6l0,0c-0.5,0.6-0.9,1.2-1.5,2c3.9-1.4,4.2-1.7,4.4-4.1
		c0.4-0.3,0.8-0.5,1.2-0.8c0.1,0.1,0.2,0.2,0.3,0.4c-0.1-0.1-0.2-0.3-0.3-0.4c0.5-0.2,0.9-0.5,1.4-0.7c0.3-0.1,0.6-0.3,1-0.4
		c-0.2,0.2-0.4,0.5-0.7,0.7c-0.4,0.3-0.9,0.5-1.3,0.8c0.2,0.6,0.3,1.2,0.5,1.8l0,0c2.1-1.4,4.2-2.8,6.3-4.2
		c-1.3-0.1-2.5-0.3-4.6-0.5c2-1.7,1-5,5-5c-0.8,1.2-1.6,2.3-2.4,3.5C497.9,159.1,498.3,158.2,497.3,150.5z"
      />
      <path
        class="st3"
        d="M487,180.9c0.1,0.1,0.2,0.1,0.3,0.2c0-0.2,0-0.4,0.1-0.6l0,0C487.2,180.7,487.1,180.8,487,180.9z"
      />
      <path
        class="st3"
        d="M141.2,209.2c2.5,0.2,4.9-3,6.5,0.6c0-1,0-1.7,0-2.3C145.6,207.7,143.2,206.5,141.2,209.2z"
      />
      <path
        class="st3"
        d="M347.9,112.7C347.9,112.6,347.9,112.6,347.9,112.7c-1.6-0.7-1.5,0.2-1.4,1.3c0.2,0,0.5,0.1,0.7,0.1l-0.1-0.1
		h0.1C347.5,113.6,347.7,113.1,347.9,112.7L347.9,112.7z"
      />
      <path
        class="st3"
        d="M110.7,214.2c0.3-0.2,0.7-0.4,1-0.6c-0.5-0.4-1-0.8-1.4-1.2C110.4,213,110.5,213.6,110.7,214.2z"
      />
      <path
        class="st3"
        d="M41.8,226.1c0,0.2-0.1,0.3-0.2,0.4c0.6-0.1,1.2-0.2,1.8-0.3c1.1-0.7,2.3-1.4,4.1-2.6c-1.5-0.3-2.4-0.5-3.2-0.7
		l0.1,0.1h-0.1C43.5,224,42.6,225,41.8,226.1z"
      />
      <path
        class="st3"
        d="M67.5,217.5c-1.1-0.1-2.2-0.1-3.3-0.2c-0.1,0.1-0.3,0.1-0.4,0.2c-0.3,0.2-0.7,0.3-1,0.5
		C64,219.1,66.1,218.9,67.5,217.5z"
      />
      <path
        class="st3"
        d="M55.5,219.8c1.2,0.1,2.9,0.9,2.3-1.7c-0.9,0.3-1.8,0.6-2.7,0.9C55.2,219.3,55.4,219.5,55.5,219.8z"
      />
      <path
        class="st3"
        d="M162.6,189.8c0.3,0.5,0.5,0.9,0.8,1.4c0.4-0.1,0.9-0.2,1.8-0.5C164,190.3,163.3,190.1,162.6,189.8z"
      />
      <path
        class="st3"
        d="M558.5,157.3c-0.2,1-0.3,1.7-0.6,3c-0.4-1.2-0.6-1.8-0.9-2.4c-0.5,0.2-1.1,0.4-1.9,0.6
		c-0.2-1.4-0.4-2.6-0.5-3.9c-0.1,0-0.3,0-0.4,0c-0.1,1.6-0.2,3.1-0.4,5c-1.3-0.4-2.4-0.7-4.2-1.2c-0.2,0.6-0.7,1.8-1.2,3.5
		c0.1,0,0.2,0,0.3,0s0.1-0.1,0.2-0.1v0.1c2.3,0,4,0,5.7,0C558.7,161.8,558.7,161.8,558.5,157.3z"
      />
      <path
        class="st3"
        d="M161.4,191.7c0.5-0.2,1.1-0.3,1.6-0.5c-0.6,0-1.1,0.1-1.7,0.1C161.4,191.5,161.4,191.6,161.4,191.7z"
      />
      <path
        class="st3"
        d="M193.8,185.1c-0.3-0.5-0.5-1.4-1-1.5c-0.8-0.2-1.8-0.1-2.6-0.1c1,0.6,2.1,1.2,3.1,1.9
		C193.5,185.2,193.7,185.1,193.8,185.1z"
      />
      <path
        class="st3"
        d="M149.1,186.9L149.1,186.9c0.5,0.2,1,0.4,1.4,0.7c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.7,0.3,1,0.4
		c2.4,0.7,4.9,1.5,7.8,2.4c-0.7-0.7-1-1.2-1.4-1.6l0,0c1.3,0.2,2.7,0.5,4,0.7c-1.6-1.1-3.2-2.3-5.4-1.4l0,0c-0.5-0.2-1-0.5-1.5-0.7
		l0,0c-3-0.9-5.9-1.9-8.9-2.8C147.4,185.5,148.2,186.2,149.1,186.9L149.1,186.9L149.1,186.9z"
      />
      <path
        class="st3"
        d="M160.2,214.7c0.8,0.6,1.5,1.3,2.3,1.9c0.4-0.8,0.8-1.6,1.2-2.4c-1.1-0.2-2.2-0.3-3.3-0.5
		C160.4,214.1,160.3,214.4,160.2,214.7z"
      />
      <path
        class="st3"
        d="M170,224.7c-0.1-0.3-0.2-0.6-0.3-0.9c0,0.3-0.1,0.7-0.1,1C169.7,224.8,169.8,224.7,170,224.7z"
      />
      <path
        class="st3"
        d="M364.5,111.3h-0.1c0.1,0.1,0.1,0.2,0.2,0.2C364.5,111.4,364.5,111.3,364.5,111.3z"
      />
      <path
        class="st3"
        d="M203.6,187.6c-0.7,0.2-1.6,0.2-2,0.7c-0.2,0.3,0.1,1.7,0.4,1.8c1,0.2,2.1,0.1,3.8,0.1
		C204.7,188.9,204.1,188.2,203.6,187.6z"
      />
      <path
        class="st3"
        d="M150.5,227.3c-0.1,0.1-0.1,0.1-0.2,0.2C150.4,227.5,150.5,227.5,150.5,227.3
		C150.4,227.4,150.5,227.4,150.5,227.3z"
      />
      <path
        class="st3"
        d="M364.1,111.2c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.1,0,0.2,0,0.2C364,111.1,364.1,111.1,364.1,111.2z"
      />
      <path
        class="st3"
        d="M58.6,223L58.6,223c0.2-0.1,0.5-0.3,0.8-0.5c-0.3-0.1-0.6-0.2-0.9-0.2l0.1,0.1c0,0,0,0-0.1,0
		C58.5,222.5,58.5,222.8,58.6,223C58.5,223,58.5,223,58.6,223z"
      />
      <path
        class="st3"
        d="M164.7,227.9c0.7-0.2,1.4-0.4,2.1-0.7c-0.7-0.2-1.4-0.3-2.1-0.5C164.6,227.1,164.7,227.5,164.7,227.9z"
      />
      <path
        class="st3"
        d="M126.2,216.2c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.1,0-0.2,0C126.2,216,126.2,216.1,126.2,216.2z"
      />
      <path
        class="st3"
        d="M86,222.8c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0.1L86,222.8z"
      />
      <path
        class="st3"
        d="M151.3,216.6c2.1-0.5,4.2-1,6.4-1.5c0-0.1,0-0.2,0-0.3c-2.2,0-4.4,0-6.9,0c-0.4,0.2-1.2,0.8-2,1.3
		c0.8,0.2,1.6,0.3,2.4,0.5C151.1,216.6,151.2,216.6,151.3,216.6C151.2,216.6,151.3,216.6,151.3,216.6z"
      />
      <path
        class="st3"
        d="M80.5,223.7c2.4-3.2,6.3-2.9,9.7-4c-0.2,0.7-0.3,1.3-0.5,1.9c1.5-0.3,2.9-0.5,4.4-0.9c1.1-0.3,2-0.6,2.3,1
		c0,0.1,1.2,0,1.8,0c0.7-1.3,1.4-2.7,2.1-4c-0.2-0.1-0.3-0.3-0.5-0.4c-1.2,0.6-2.3,1.3-3.5,1.8c-1.5,0.7-2.5,0.3-2.4-1.6l0,0
		c-1.8,0.3-3.7,0.8-5.5,0.8C85.3,218.2,81.7,220.7,80.5,223.7L80.5,223.7L80.5,223.7z"
      />
      <path
        class="st3"
        d="M129.3,214.4C129.3,214.4,129.3,214.5,129.3,214.4L129.3,214.4C129.3,214.5,129.3,214.5,129.3,214.4
		c0.7-0.3,1.4-0.7,2.1-1.1c-0.2-0.4-0.5-0.8-0.7-1.2c-3,0.7-6,1.4-9,2c0,0.3,0.1,0.6,0.1,0.8c1.1-0.2,2.3-0.5,3.4-0.4
		c0.5,0,0.9,0.8,1.4,1.2c0.4-0.1,0.8-0.1,1.3-0.2c0.3-0.1,0.5-0.3,0.8-0.4c0,0,0-0.1,0.1-0.1C128.8,214.9,129,214.7,129.3,214.4z"
      />
      <path
        class="st3"
        d="M134.2,212.7c-0.2,0-0.3,0-0.5,0c0,0.3-0.1,0.6-0.1,0.9C133.8,213.4,134,213.1,134.2,212.7z"
      />
      <path
        class="st3"
        d="M528.3,65.2C528.3,65.2,528.4,65.2,528.3,65.2c0.3-0.5,0.5-1,0.8-1.4c0.1,0,0.1,0,0.2,0.1
		c-0.1,0-0.1,0-0.2-0.1c0.6-1.4,1.2-2.8,1.8-4.3c-0.1-0.1-0.2-0.1-0.2-0.2c0.1-0.1,0.2-0.2,0.4-0.2c0,0,0,0,0.1,0
		c0.1-0.2,0.1-0.3,0.2-0.5c-1.9,1.8-3.1,3.9-3.9,6.3C527.6,65.1,528,65.2,528.3,65.2z"
      />
      <path
        class="st3"
        d="M546,75.1c-0.4,0-0.8,0-1.2,0.1c0.4,0.2,0.8,0.4,1.2,0.6C546,75.6,546,75.3,546,75.1L546,75.1L546,75.1z"
      />
      <path
        class="st3"
        d="M485.8,112c-0.4-0.2-0.9-0.5-1.3-0.7c-0.9,1.6-1.8,3.2-2.7,4.8c-0.3-0.2-0.6-0.3-1-0.5
		c-0.4-1.1-0.8-2.2-1.6-4.3c-1,1.6-1.7,2.7-2,3.3c-2.9-0.4-5.8-0.8-9-1.3c0,1.5,0,2.5,0,3.5c1.8,0.5,3.7,0.9,5.5,1.4
		c-0.3-0.3-0.6-0.6-1.2-1.1c4.7-0.3,9.2-0.7,14.1-1C486.4,114.4,486.1,113.2,485.8,112z"
      />
      <path
        class="st3"
        d="M478.4,117.9c-0.4,0.3-0.6,0.9-0.8,1.4c-0.3,0.8-0.6,1.6-0.9,2.5c2.4-0.2,4.7-0.3,7.4-0.5
		c-0.4-1.3-0.7-2-1-2.7C481.4,119.9,480.1,116.8,478.4,117.9z"
      />
      <path
        class="st3"
        d="M545.3,69.1c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.3-0.5,0.5-0.8,0.8c-0.1,0-0.2-0.1-0.3-0.1c0.8,1,2.2,1.8,4.1,2.2
		c0-1.2,0-2.4,0-3.6C546.6,69.1,546.4,69.2,545.3,69.1z"
      />
      <path
        class="st3"
        d="M487.7,114.5c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.1-0.1-0.1C487.9,114.5,487.8,114.5,487.7,114.5z"
      />
      <path
        class="st3"
        d="M562.2,117.6c-0.4,0.1-0.7,0.1-1.1,0.2c0.9,3.2,3.2,1.5,5.2,1.5c-0.2-0.9-0.3-1.6-0.4-2.4
		c-0.4,0.3-0.9,0.5-1.2,0.9c-0.9,1.1-1.6,1-2.3-0.2c0,0,0,0,0,0.1C562.3,117.6,562.2,117.6,562.2,117.6z"
      />
      <path
        class="st3"
        d="M341.1,108.7c0.7-0.2,1.4-0.3,2-0.4c0.1-1.8,0.3-3.6,0.4-5.3c0-0.1-0.1-0.2-0.1-0.4c-0.5,0.1-1.1,0.2-1.8,0.3
		c0.2,0.7,0.8,1,1.4,1.2c-0.7,0.9-1.5,1.7-2,2.6C340.7,107.3,340.8,108,341.1,108.7z"
      />
      <path
        class="st3"
        d="M373.4,225.8L373.4,225.8c-0.3-0.2-0.6-0.3-0.8-0.5c-0.1,0.3-0.2,0.7-0.4,1C372.6,226.1,373,226,373.4,225.8z"
      />
      <path
        class="st3"
        d="M560.4,137.5c0,0.2,0,0.4-0.1,0.6l-0.1,0.1l0.1-0.2c0.2-0.2,0.4-0.4,0.6-0.6
		C560.6,137.5,560.5,137.5,560.4,137.5z"
      />
      <path
        class="st3"
        d="M566.7,115.9L566.7,115.9c0,0.1,0.1,0.1,0.2,0.1C566.8,116,566.8,115.9,566.7,115.9z"
      />
      <path
        class="st3"
        d="M568.3,118.5c0.1,0.1,0.2,0.2,0.3,0.2c0.2-0.3,0.5-0.6,0.7-1C568.9,118.1,568.6,118.3,568.3,118.5z"
      />
      <path
        class="st3"
        d="M486.3,129.7c-0.1,1.4-0.2,2.4-0.3,3.5c1.6,0.4,3.1,0.8,4.9,1.3c2-2.1,2-2.1,0.6-5.8c-1,1.4-1.7,2.5-2.7,3.9
		C488.1,131.8,487.4,130.9,486.3,129.7z"
      />
      <path
        class="st3"
        d="M552.5,140.3c0,0.2,0,0.4,0,0.5c0.1-0.1,0.1-0.3,0.2-0.4C552.7,140.4,552.6,140.3,552.5,140.3z"
      />
      <path
        class="st3"
        d="M506.6,91.3c0.4,0.7,1.8,1.2,2.8,1.1c0.7,0,1.4-1.1,2.1-1.7l0,0c-0.5-0.6-0.8-1.5-1.4-1.8
		c-0.9-0.5-2-0.6-3.1-0.8C506.8,89.2,506.2,90.5,506.6,91.3z"
      />
      <path
        class="st3"
        d="M446.1,96.9c0.1,0.1,0.2,0.2,0.4,0.4l0,0C446.4,97.1,446.2,97,446.1,96.9z"
      />
      <path
        class="st3"
        d="M414.5,99.1c0.4,0.1,0.7,0.3,1.1,0.4c-0.2,0.2-0.4,0.4-0.6,0.6c-0.2-0.3-0.4-0.6-0.7-0.9
		c-4.4,5.1-8.8,10.3-13.5,15.6c1.7,0.6,4-0.9,3.7,1.9c0.1,0,0.2,0,0.3,0.1c0,0,0,0.1,0,0.2c-0.1-0.1-0.2-0.2-0.3-0.3
		c-2.8-1.2-4.9,0-6.6,2.1c-1.2,1.5-2.5,3.1-4.1,5.1c1.6,0.3,2.9,0.6,4.3,0.9c0,0.8,0,1.9,0,3.5c-1.4-1-2.4-1.7-3.4-2.5
		c0,0.4-0.1,0.9-0.2,1.7c-0.8-0.7-1.4-1.2-2.1-1.9c-5.8,6.6-11.6,13.2-17.3,19.8c1,0.6,2.1,1.3,3.1,1.9c-0.4,0.7-0.9,1.3-1.2,1.9
		c-1-1.3-1.6-2.3-2.3-3.3c-1.1,2.4-4.2,3.6-3.7,6.9c0.1,0.7-1.9,1.6-3.6,2.9c5.7-0.3,10.7-0.5,15.8-0.8c0.1-0.3,0.2-0.5,0.3-0.8
		c-1-0.9-1.9-1.7-3.2-2.8c0.9-0.3,2.4-1.2,2.9-0.8c1.1,0.8,1.6,2.3,2.7,4.1c2.6-0.2,5.8-0.4,9.2-0.6c-0.2-1.2-0.4-1.9-0.5-2.7
		c-1.6,0.2-3.2,0.4-4.8,0.6c-1.4-0.1-2.8-0.3-4.4-0.5c1.3-2.4,2.5-2.1,3.6-0.3V151c0,0,0,0,0.1,0.1c1.9-0.5,3.8-2.8,5.9-0.3l0.3,0.1
		l0,0c0.8-0.4,1.6-0.9,2.4-1.3c0.1,0.3,0.3,0.6,0.4,0.8c-0.8,0.3-1.6,0.6-2.5,1c0.3,0.7,0.6,1.5,1.1,2.5c2.8,0,5.8,0,8.8,0
		c-0.8,0.3-1.7,0.8-2.5,0.8c-11.2,0.7-22.5,1.4-33.8,2.1c-9.2,0.6-18.4,1.4-27.9,2.1c0,1.7,0,3.2,0,5.1c2.7-0.3,5.7,2.1,7.9-1.5
		c1.7,1,3-3.3,4.7-0.2c1.5-1.7,2.1-4.6,5.2-2.4c0.4,0.3,1.6-0.5,2.4-0.8c-0.5,2.2-0.5,2.2-2.8,2.6l0,0c0.3,2.1,1.9,1.4,3,1.3
		c6.9-0.2,13.9-0.6,20.8-0.6c3.9,0,7.8,0.7,11.6,0.6c8.4-0.2,16.7-0.7,25-1.1c2.5-0.1,4.9-0.1,7.4-0.1c5.8,0,11.6,0,17.7,0
		c-0.9-1.1-1.7-1.9-2.4-2.7l0,0c-0.1-0.2-0.2-0.5-0.3-0.7c0.2,0.1,0.4,0.2,0.7,0.3c4.1,3.6,9,3.1,13.8,2.9c4.7-0.2,9.5-0.5,14.8-0.8
		c-1.7-1.9-2.9-3.3-4.1-4.7c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.2-0.3-0.3-0.4-0.5c0.2,0.1,0.5,0.1,0.7,0.2
		c0.4,0.2,1.2,0.6,1.2,0.5c1.3-1.8,3.4-1.2,5-1.8c-0.2-0.7-0.4-1.4-0.7-2.1c0.3-0.2,0.5-0.4,0.8-0.5c0.7,0.9,1.3,1.8,2.1,2.9
		c0.4-1.1,0.7-2.1,1-3.1c0.1,0,0.2,0.1,0.3,0.1c0,2.8,0,5.6,0,9c-1.8-1.1-3.2-1.9-5.2-3.2c1.4,3.3,3.5,3.4,5.7,3.1
		c2.1-0.2,3-1.3,3-3.5c0-2.7,1.3-5.5-0.6-8c-0.8,0.5-1.5,1.3-2.3,1.4c-7,0.5-14.1,1.1-21.1,1.4c-12.3,0.5-24.7,0.9-37,1.4
		c-4.7,0.2-9.4,0.4-14,0.6c3.9-0.4,7.8-1,11.8-1.3c4.4-0.4,8.9-0.5,13.6-1.1c-2.7-2.3-2.1-6.8-6-8.1c1.9-1.1,4-0.6,4.7,1.1
		c1,2.4,2,4.8,2.9,7.1c1.6,0,2.6,0,4.6,0c-1.4-1.3-2.3-2.1-3.2-2.9c1.9-1.7,2.8,0.6,4.1,1.1l-0.1-0.1h0.1c0.4-1.4,1.2-1.9,3.3-0.9
		c-1.5,0.4-2.4,0.7-3.3,0.9v0.1c0.8,0.6,1.5,1.8,2.3,1.8c6.3,0,12.6-0.3,19-0.5c1.2,0,2.4-0.4,3.7-0.6c0-0.3,0-0.7,0-1
		c-1.4-0.1-2.7-0.2-4.1-0.3c1.3-2.5,2.8-3.1,4.1-1.1c2.5,3.8,5.6,2.1,8.6,1.9c0.3,0,0.7-0.2,1.2-0.3c-0.3-0.7-0.7-1.3-1.1-2.3
		c0.9-0.2,1.6-0.4,1.9-0.5c-0.5-1.2-1-2.4-1.7-3.9c-0.4,0-1.2,0-2,0l0,0l0,0c-0.2,0.2-0.5,0.3-0.7,0.5c0,0,0,0.1-0.1,0.1l0,0l0,0
		l0,0l0,0l0,0c0.6,1.1,1.1,2.3,1.7,3.4c0.2,0.5,0.4,1,0.4,1.5c0,0.2-0.7,0.6-0.7,0.6c-1.7-2.1-3.6,0.2-5.7-0.7
		c0.9-0.7,1.8-1.4,3-2.3c-1-1.3-2-2.6-2.9-3.9c0.1-0.2,0.1-0.3,0.2-0.5c1.4,0.6,2.8,1.3,4.1,1.9l0,0c0,0,0.1,0,0.1-0.1
		c0.1-0.3,0.2-0.6,0.4-0.9l0,0c1.2-0.3,2.5-0.7,3.7-0.8c1.9-0.2,3.8-0.2,5.7-0.4c-0.6-1.3-1.2-2.6-1.8-4c-0.1,0.1-0.3,0.1-0.4,0.2
		c0,0.7,0,1.5,0,2.6c-1.9-1.7-2.2-4.9-5.4-4.3c-0.3,1.3-0.5,2.7-0.7,3.7c-1.4-1.5-3.8-3.2-3.5-4c1.4-3.8-2.3-2.9-3.5-4.2
		c-0.1-0.1-0.1-0.4-0.2-0.6c0,0,0,0-0.1,0s-0.2,0-0.2,0c-0.3,0.1-0.7,0.1-1,0.2c-0.2,0.4-0.4,0.8-0.8,1.7c-0.7-1.2-1.2-2-1.6-2.8
		c0.2-0.1,0.4-0.3,0.5-0.4c0.5,0.4,1.1,0.8,1.6,1.2c0.1,0.1,0.2,0.2,0.2,0.3c-0.1-0.1-0.2-0.2-0.2-0.3c0.4,0,0.8,0.1,1.3,0.1
		c0.1,0,0.2,0,0.3-0.1v0.1v-0.1l0,0c1.5-0.8,3-2.2,4.8-1.1c0.7,2.1-0.2,4.8,2.6,5.9c0.3-0.5,0.5-1.2,0.9-1.4c3.6-1.6,6.5,0,7.2,3.9
		c0.2,1.1,0.4,2.2,0.7,3.3c1.9,0.1,3.7,0.1,6.2,0.2c2.7-2.5,2.8-2.8,1.4-6.5c-2.8,0.4,0.6,5-3.4,4.5c-0.9-1.8-1.2-4.9-4.4-3.9
		c-1-1.6-1.6-3.5-2.8-4.2c-1.1-0.6-3,0.3-4.5,0.2c-0.8-0.1-1.6-1-2.7-1.8c1.7-0.9,3.9-0.3,3.8-2.7c0-2.2-1.1-3-3.6-3.1
		c1.7-1.8,3.2-1.6,4.4-0.8c1.2,0.8,2,2,0.9,3.7c5.2-0.3,3.4,4.5,5.2,7.2c1.7-1.8,4.2,1.1,5.9-1.2c0,0,0,0,0.1,0
		c-0.5-1.6-0.9-3.2-1.4-5c3.7-0.2,6.9-0.4,10-0.5c1.5-0.8,3.3-2.1,2.1-4.8c-2-0.2-4.1-0.8-4.8,2.3c-1.1-1.2-1.9-2.1-2.6-2.9
		c-0.7,1.5-1.4,2.9-2,4.3c-1.4-1.6-2.4-2.8-3.5-4.1c-0.3,0.1-0.7,0.3-1,0.4c0.5,3.1,0.9,6.3,1.4,9.5c-1.3-1.2-2.5-2.3-3.8-3.5
		c1.2-3.7,0.5-4.9-3.5-6c-0.2,0-0.2-0.8-0.2-1.2l0,0c-0.9-1.1-1.8-2.3-2.7-3.4l0,0c-1.4,1-2.8,2-4.1,2.9c-1-0.8-2.2-1.8-3.5-2.8
		c0.5-0.4,1.2-1,1.9-1.6l0,0c-1.1-1.4-1.7-3.4-4.2-2.8c0,0,0,0,0,0.1H464c-0.4,0.6-0.9,1.3-1.6,2.3c-0.7-2.5,0.5-2.3,1.6-2.3
		c0,0,0,0,0-0.1l0,0c0-0.2-0.1-0.5,0-0.6c2.1-1.8,10-2.6,12.4-1.4c3.2-2.1,3.2-2.1,6-0.2c-0.1-3.8-1.6-5-5.1-4.1
		c-0.2,1.5-1,1.5-2.1,0.7c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c-1.1,0.5-1.1,0.5-1.9-1.6c1.4-1.4,2.8-2.2,4,0.2l0,0
		c1.6-0.5,3.3-0.9,4.9-1.4c1.4,3.3,1.5,3.3,6.4,5.7l0,0h0.1c0.2-1.6,3.5-2.4,1.2-4.9c-0.8,0.7-1.5,1.4-2.1,1.8
		c-0.9-0.9-1.7-1.6-2.8-2.7c1.5-0.3,2.7-0.5,4.1-0.7c-1.1-1.1-2-2.1-3.3-3.5c0.9-0.1,1.8-0.4,2.7-0.4c1,0,2,0.3,3,0.5l0,0h0.1
		c1.3-2,5.1-3.1,6.5-1.7c1.2,1.2,1.9,2.7-0.2,3.8c1.8,0.3,3.5,0.6,5.7,0.9c-0.1,1.1-0.2,2.2-0.3,3.5c-1.4-1.3-2.3-2.1-3.2-3
		c-0.6,0.9-0.5,1.3-0.5,1.6c-0.2,0.8-0.5,1.5-0.7,2.2c-0.5-0.5-1.2-1-1.5-1.6c-0.4-0.8-0.4-1.8-0.6-2.7c-0.3-0.1-0.6-0.1-0.8-0.2
		c-0.7,1.1-1.5,2.3-2.2,3.4c-0.3-0.2-0.7-0.4-1-0.6c0.3-1.4,0.7-2.8,1-4.1c0.5-2.2-0.7-2-2-1.5l-0.1,0.1c0,0,0,0-0.1,0
		c0,0.9,0,1.8,0.1,2.7c0.1,0.6,0.3,1.2,0.5,1.7c0.3,1,0.4,2.2,0.8,3.1c0.7,1.8,1.6,3.5,0.2,6.2c-1-2.7-1.4-5.1-4.3-3.9v0.1
		c0,0,0,0-0.1,0c-0.2,1.2-0.4,2.3-0.7,3.5l0,0c0.7,0.4,1.3,1.1,2,1.2c1.5,0.2,3,0.1,4.5,0.1c0.3,0,0.7,0.1,1.2,0.3
		c0,1.2,0,2.5,0,3.6c1.2,0.7,2.3,1.4,3.8,2.3c0.7-1.7,1.4-3.2,2.3-5.2c-2.2,0-3.6,0-5,0c1.7-1.7,1.7-3.2,0.6-4.9
		c-0.2,0.2-0.4,0.5-0.6,0.7c-0.1-0.1-0.2-0.2-0.2-0.2c0.2-0.2,0.4-0.4,0.5-0.7c-0.6-0.4-1.3-0.9-1.9-1.3c2.3-1.5,3.6-1.4,3.9,0.9
		c0.4,2.6,2,3.4,3.9,4.4c1.7-1.1,2.4-2.8,1.6-4.5c-0.5-1-2.2-1.5-3.4-2.2c2-2,3.7-0.6,5.6,1.1c1-1.8,3.5-3.2,1.3-5.8
		c-1.1,0.2-2.1,0.4-3.4,0.6c1.4-2.7,2.5-3.1,4.5-1.7c0.9,0.6,1.4,1.1,2.2,0.1v-0.1c0.2-0.1,0.4-0.1,0.5-0.2
		c-0.2,0.1-0.3,0.1-0.5,0.2l0,0c0.3,1.3,0.5,2.6,0.8,3.9c0.1,0,0.2,0,0.3,0c0.1-1.4,0.2-2.9,0.2-4.3c0.2,0,0.3-0.1,0.5-0.1
		c0.2,0.4,0.5,0.9,0.4,0.8c1.3-1.9,2.7-3.9,4.1-6l0,0c0.5-0.5,0.9-0.9,1.4-1.4l0,0c-0.5-0.2-0.9-0.5-1.4-0.7l0,0
		c-0.5,0.2-1,0.4-1.5,0.7l0,0c0,0,0,0-0.1,0c-0.2,0.5-0.4,0.9-0.6,1.4v0.1h-0.1c-0.9,1.1-1.9,2.3-2.8,3.4c0,0,0,0,0.1,0.1
		c-0.1,0-0.1,0.1-0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2l0,0c-2-2.5-2.3-2.5-4.1-0.1c0,0.1,0.1,0.3,0.1,0.4c-0.2,0-0.3-0.1-0.5-0.1
		c-0.1-1.2-0.6-2.7-0.1-3.4c0.7-0.8,2.2-0.9,3.4-0.9c1.3,0,2.6,0.4,3.9,0.6l0,0l0,0c-0.2-0.4-0.4-0.7-0.7-1.3c0.5,0,0.9-0.1,1.3-0.1
		l0,0l0,0c-1-1.7-2-3.5-3.1-5.3c1.7-1.9,3.8-0.8,5.9-0.3l0,0c-0.5,1.6-0.9,3.3-1.4,4.9c0.4-0.1,0.9-0.3,1.3-0.4
		c0,0.4,0.1,0.7,0.1,1.1c2.3-4,4.7-7.9,7-11.9c0.7-1.2,1.1-2.7,2.9-2.9c0.8-1.9,1.6-3.7,2.5-5.8c-0.1,0-0.3-0.1-0.4-0.1
		c-0.4-0.1-1,0.1-1.4,0.2c-0.2,0.1-0.5,0.1-0.7,0.1c-1.2,1.6-2.3,3.2-3.5,4.9l0,0c-0.5,0.7-1,1.5-1.5,2.2c0-0.5,0-1,0-1.5
		c-1.1-0.9-2.2-1.9-3.4-2.9c1.1-2.1,2.3-2.4,6.2-1.2c0.3-0.5,0.6-1,0.9-1.6c-0.2-0.1-0.4-0.2-0.6-0.4c0.4-0.1,0.7-0.3,1.1-0.4
		c0.2-0.4,0.5-0.8,0.7-1.3c-6.9,1.2-13.2,2.1-19.4,3.3c-13,2.5-25.9,5.8-38.9,7.7c-17.4,2.6-34.4,7-51.5,10.7
		C416.7,96,415.3,97,414.5,99.1z M371.3,161.2c1.8-2.5,3.2-2.6,5.9,0C374.8,161.2,373.2,161.2,371.3,161.2z M389.7,160.8
		L389.7,160.8c-2.1,2.3-3.2,1.8-4.8-2.2C387,158.2,388.8,158.3,389.7,160.8C389.7,160.7,389.7,160.7,389.7,160.8L389.7,160.8z
M399,161.3c-0.6-0.3-1.3-0.6-1.9-0.9c0.2-0.4,0.3-0.7,0.5-1.1c0.6,0.4,1.2,0.9,1.8,1.3C399.2,160.9,399.1,161.1,399,161.3z
M463.4,155.7c0.2,0,0.3,0,0.5,0c0,0.9,0,1.8,0,2.7c-0.2,0-0.3,0-0.5,0C463.4,157.5,463.4,156.6,463.4,155.7z M458.1,159.4
		c-0.4-1.5-0.7-2.8-1-4C460.1,157.5,460.1,157.5,458.1,159.4z M454.7,154.2c0.5,0.7,1.1,1.4,1.6,2.2c0.2,0.6,0.5,1.3,0.7,1.9
		c-0.2,0.1-0.5,0.1-0.7,0.2c-0.1-0.6-0.2-1.2-0.3-1.8c-0.3,0.4-0.5,0.9-1,1.7c-0.4-1.6-0.7-2.7-1-3.8
		C454.2,154.5,454.5,154.3,454.7,154.2z M446.3,155.4c0.2-0.1,0.4-0.2,0.6-0.3c1.1,0.9,2.1,1.7,3.2,2.6l0,0c0.2,0.2,0.5,0.5,0.7,0.7
		c0.4,0.4,0.9,0.7,1.3,1.1c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5-0.4-1-0.7-1.4-1.1c-0.3-0.2-0.5-0.4-0.8-0.6c-0.5-0.2-1-0.3-1.8-0.6
		c0.7,1.3,1.3,2.4,2,3.8c-3.7-0.6-5.1-1.7-6.3-5.1c1.2,0.9,2.1,1.6,3.3,2.5C446.6,157.4,446.5,156.4,446.3,155.4z M435,155.1
		L435,155.1c0.8,0.2,1.5,0.3,2.3,0.5c2.4,1.3-0.1,2.2-0.7,3.9C436,157.8,435.5,156.5,435,155.1L435,155.1L435,155.1z M432.4,155.1
		c0.6,1.8,1.2,3.5,1.8,5.3c-0.3,0.1-0.5,0.2-0.8,0.3c-0.6-1.7-1.3-3.4-1.9-5.1C431.8,155.5,432.1,155.3,432.4,155.1z M424.4,156.7
		c-0.5,1.4-0.6,2.7-1.3,3.5c-0.9,1.1-1.9,1-1.5-0.9l0,0c-0.6-0.8-1.1-1.7-1.9-2.9C421.5,156.6,422.9,156.7,424.4,156.7z M414,161.8
		c-1.1-1.7-2.2-3.4-3.4-5.1C414,156.2,414.9,157.6,414,161.8z M405.4,157c0.7,1,1.5,2,2.2,3c-0.3,0.2-0.6,0.3-0.9,0.5
		c-0.5-1.1-1-2.2-1.6-3.3c-0.1-0.1-0.2-0.3-0.2-0.4C405.1,156.9,405.3,157,405.4,157z M422.4,108.7c-1-0.9-1.7-1.7-2.5-2.4
		c-0.8,0.5-1.4,0.9-2.5,1.6c0.1-1.7,0.2-2.7,0.3-4c-1-0.2-2-0.5-3.5-0.8C417.6,101.9,421.9,105,422.4,108.7z M431.2,112.3
		c2.1,0.9,4.5,4.4,4.7,6.3c-0.3-0.1-0.6-0.2-0.9-0.3c-0.1,1.6,0.2,3,2.1,3.4l0,0h0.1c0.2-0.7,0.3-1.4,0.6-2.1
		c0.3-0.9,1.3-1.8,1.1-2.5c-0.1-0.6-1.4-1-2.2-1.6c1.4-1.8,2.6-0.8,3.7,0.3c1.4-2.1,2.5-1.4,3.6,0.6c-0.6,0.1-0.9,0.2-1.2,0.2
		c-0.5,0.1-0.9,0.1-1.4,0.2c-0.2,0.9-0.3,1.8-0.5,2.5c2.1,0.3,4.2,0.6,6.2,0.9c0.6-0.1,1.3-0.2,1.9-0.4c0.3-0.3,0.6-0.5,0.9-0.8
		c0.3,0.2,0.6,0.3,0.9,0.5c-0.6,0.1-1.2,0.2-1.8,0.3c-0.6,0.6-1.2,1.1-1.9,1.7c0.1,0.5,0.2,1,0.3,1.5c-0.2-0.4-0.5-0.7-0.7-1.1
		c0.1-0.1,0.3-0.2,0.4-0.4c-0.1-0.4-0.2-0.7-0.2-1.1c-1.5,0.4-3.1,0.7-4.5,1.1c0.1,1.5,0.2,2.5,0.3,4c-3.1-3.8-3.2-3.9-5.6-3.8
		c0,0,0,0,0,0.1c0,0,0,0-0.1,0c0,0.6,0,1.3,0,2.2c-3.1-1.7-4.4-4.4-5.8-7c-0.8-1.5-1.5-3-2.4-4.8C429.4,112.3,430.4,112,431.2,112.3
		z M429.6,108.6c0.5,0,1-0.1,1.5-0.1c0,0.3,0,0.6,0,0.8c-0.5-0.1-0.9-0.1-1.4-0.2C429.6,109.1,429.6,108.8,429.6,108.6z
M452.7,129.5L452.7,129.5c0.1,0.1,0.1,0.1,0.1,0.2c2.2,0.7,3.6,1.8,2.5,4.4c-3.2-2-3.3-2.3-2.5-4.4l0,0
		C452.7,129.6,452.7,129.5,452.7,129.5c-1.3-1.3-2.5-2.6-3.8-4c1.7-1.2,2.4,0.1,3,1.2C452.3,127.5,452.4,128.5,452.7,129.5z
M452.1,122.2c0-0.6,0-1.3,0-1.9c0.1,0,0.3,0,0.4,0c0,0.6,0,1.3,0,1.9C452.4,122.2,452.2,122.2,452.1,122.2z M453.6,141
		c-1.3-1.5-2-2.3-2.7-3.2c-0.3-0.4-0.8-1.2-0.6-1.5c0.2-0.5,1.1-1.1,1.5-0.9c0.5,0.2,1,0.9,1.2,1.5C453.3,137.9,453.3,139,453.6,141
		z M447.3,139.3c-1.1-1-2.3-2-3.4-3.1C447.3,135.2,448,135.9,447.3,139.3z M442.4,127c2.5-2.5,2.8-2.5,5.6,0.1
		c-0.4,1-0.7,2.1-1.2,3.4c-0.8-1.5-1.3-2.6-1.9-3.7C444.1,126.9,443.4,126.9,442.4,127z M445,131.1c2.8-0.1,3.6,1.1,2.8,3.5
		C446.9,133.5,446,132.4,445,131.1z M434.9,127.6c0.1-0.4,0.2-0.9,0.2-1.3c1.9-0.1,3.8-0.3,5.8-0.4c-0.2,1.7-0.3,3-0.4,4.5
		C438.4,129.3,438.2,125.8,434.9,127.6z M437,132.6c0,0.1-0.2,0.2-0.4,0.4c-0.1-0.2-0.2-0.4-0.2-0.6c0-0.1,0.2-0.2,0.4-0.3
		C436.9,132.3,437,132.4,437,132.6z M429.9,124.8c-0.2-0.2-0.5-0.5-0.7-0.7c-0.6-0.6-1.1-1.3-1.7-1.9c0.1-0.3,0.1-0.6,0.2-0.8
		c1.1,0,2.6-0.4,3.3,0.1c0.9,0.6,1.1,2.1,1.7,3.2c-0.3,0.1-0.6,0.3-0.9,0.4c-0.4-0.7-0.8-1.5-1.3-2.2c-0.3,0.3-0.6,0.6-0.9,0.9
		C429.6,124.1,429.8,124.5,429.9,124.8z M420.8,133.4c2.4-1.7,3-1.3,3.6,2.7C423.1,135.2,422,134.3,420.8,133.4z M421.4,143.7
		c0.5,0,0.9,0,1.4,0c0,0.3,0,0.5,0,0.8c-0.5-0.1-1-0.1-1.4-0.2C421.3,144.3,421.3,143.7,421.4,143.7z M420.1,129.5
		c-0.4-0.1-0.7-0.1-1.1-0.2c0.2-0.6,0.3-1.3,0.7-1.8c0.2-0.2,0.9,0.1,1.7,0.2C420.9,128.4,420.5,129,420.1,129.5z M420.6,141.1
		c-0.2,0.1-0.3,0.3-0.5,0.4c-1.1-1.2-2.1-2.3-3.7-4c1.7-0.1,2.6-0.2,3.6-0.3C420.2,138.6,420.4,139.8,420.6,141.1z M417.8,122.3
		c-1.8-1.3-3.4-2.6-5.3-4c3,0,5.6,0,8.2,0c0,0,0,0,0-0.1h0.1c2.5-1.9,2.7-1.7,3.1,1.6c-1-0.5-2-1-3.1-1.6l0,0c0,0,0,0-0.1,0
		c0.2,2.5,0.5,5,0.7,7.5c-1.3-1.1-3.4-1.6-1.5-4c0.9-1.1,0-3-2.4-2.4C417.6,120.5,417.7,121.4,417.8,122.3z M417.5,125.6
		c-0.2,0.2-0.4,0.4-0.6,0.6c-1.3-1-2.5-2-4.1-3.2C416.2,121.9,417,123.6,417.5,125.6z M418.3,113.8c-1.2,1.6-1.9,2.7-2.9,4.1
		c-0.3-1.5-0.5-2.5-0.8-3.6C415.7,114.1,416.6,114,418.3,113.8z M417.8,109.6c0.8,0.1,1.6,0.3,2.5,0.5c-0.1,0.5-0.2,0.9-0.3,1.4
		c-0.8-0.2-1.6-0.5-2.4-0.8C417.5,110.6,417.7,109.6,417.8,109.6z M414.9,110.3c-0.7,2-1.6,2.1-4.1,0.5
		C412.3,110.6,413.6,110.5,414.9,110.3z M414.5,106.5c0.5-0.2,1-0.2,1.5-0.3c0,0.3,0.1,0.5,0.1,0.8c-0.5,0.1-1,0.2-1.6,0.4
		C414.5,107.1,414.4,106.5,414.5,106.5z M425.6,122.2c-0.7,0-1.7-0.2-2.3-0.1c-0.2,0.6-0.5,1.2-0.7,1.8c0,0.4,0,0.8,0,1.1
		c-0.1-0.2-0.1-0.4-0.2-0.7c0.1-0.2,0.1-0.3,0.2-0.5c0-0.6,0-1.3,0.4-1.6c0.1-0.1,0.2-0.1,0.4-0.2c0.1-0.3,0.3-0.7,0.4-1
		C424.3,121.5,424.9,121.8,425.6,122.2z M424.7,117.1c0.9-0.2,1.6-0.3,2.4-0.4c-0.3,1.2-0.5,2.2-0.8,3.7
		C425.7,119,425.3,118.2,424.7,117.1z M423,128.1c1-0.8,2-1.4,2.9-1.2c1.4,0.3,2.6,1.2,1.6,3.4C426.8,127.9,425.1,127.9,423,128.1z
M428.1,117c0.3-0.3,0.6-0.6,1-0.8c0.1,0,0.4,0.4,0.7,0.6c-0.3,0.3-0.5,0.6-0.9,1C428.5,117.4,428.3,117.2,428.1,117z M434,130.1
		c-1.2-0.7-2.5-1.6-3.9-2.5c-0.1-0.1-0.2-0.2-0.3-0.3C433,126.3,433.9,127,434,130.1z M435,134.7c-1-0.8-2-1.5-2.9-2.2
		C435.7,132.3,435.7,132.3,435,134.7z M434.8,135.8c0.4,0.8,0.8,1.7,1.1,2.5c-0.4,0.1-0.7,0.2-1.1,0.3c-0.3-0.8-0.7-1.6-1-2.4
		C434.2,136.1,434.5,135.9,434.8,135.8z M438,131.7c3.3,0,3.7,0.3,3.3,2.8v0.1c0.3,1.9,0.6,3.7,0.9,5.8c-1.6-0.8-2.7-3.4-5-0.9
		C438.1,136.6,441.1,134.5,438,131.7z M424.9,109.2c2.8-1.5,3.8-0.5,4.6,2.1C427.8,110.5,426.6,109.9,424.9,109.2z M426.9,115.2
		c-1.9-0.1-3.9-0.3-5.9-0.4c0,0.4,0.1,0.8,0.1,1.2c-0.5-0.2-1-0.4-1.4-0.6c0.3-0.3,0.7-0.6,1-0.9
		C423.7,111.8,426.1,112.2,426.9,115.2z M421.4,110.4c-0.1-0.2-0.1-0.4-0.2-0.6c0.5-0.2,1.1-0.4,1.6-0.7c0.1,0.3,0.2,0.6,0.3,0.9
		C422.5,110.2,422,110.3,421.4,110.4z M412.7,103.5c0.1,0.2,0.2,0.3,0.3,0.5c0,0-0.2,0.1-0.2,0.2c-0.1-0.2-0.2-0.4-0.3-0.5
		C412.5,103.6,412.6,103.6,412.7,103.5z M413.2,110c-2-0.7-3.4-1.3-4.9-1.8C410,108.3,412.6,105.5,413.2,110z M408.6,110.9
		c0.1,0.3,0.1,0.6,0.2,0.9c-1,0.4-2.1,0.8-3.1,1.2c-0.1-0.5-0.3-1-0.4-1.4C406.4,111.4,407.5,111.1,408.6,110.9z M407.3,116.1
		C407.4,116.1,407.4,116.1,407.3,116.1C407.4,116.2,407.4,116.2,407.3,116.1c0.5,0,0.9,0,1.4,0c0,0,0,0,0-0.1c0,0,0.1,0,0.1,0.1
		c0.5-0.2,0.9-0.4,1.4-0.6l0,0l0,0c0.6-0.3,1.2-0.5,1.8-0.8c0.1,0.2,0.2,0.4,0.3,0.6c-0.5,0.3-0.9,0.6-1.4,0.9c0,0,0,0,0.1,0.1
		l-0.1-0.1c-0.8,2.1-1.4,0.3-2.1-0.1l0,0l0,0c0,0.7,0,1.3,0,2c-0.1,0-0.3,0-0.4,0.1C408,117.5,407.7,116.8,407.3,116.1
		C407.4,116.2,407.4,116.2,407.3,116.1C407.4,116.2,407.4,116.2,407.3,116.1c-0.6,0-1.2,0-2.3,0
		C407.2,114.7,407.2,114.7,407.3,116.1z M408.7,119.6c2.3-1.1,2.3-1.1,3.4,1.8C411,120.9,409.9,120.3,408.7,119.6
		c0.3,0.7,0.4,1.3,0.7,2c-2,0-3.9,0.1-4.6-2.9C406.4,119.1,407.6,119.4,408.7,119.6z M403.5,121c1.2,2.7,2.7,3.4,5.7,2.9
		c1.3-0.2,2.9,1.2,4.4,1.9c-0.1,0.3-0.2,0.6-0.4,0.9c-0.6-0.1-1.1-0.1-1.7-0.2c0,0.2-0.1,0.5-0.1,0.7c2,0.2,4,0.5,6,0.7
		c-1.9,0.8-1.8,2.2-1.6,3.7c0,0,0,0.1,0.1,0.1c0,0,0,0,0,0.1c3.5,0.4,4.1,1.3,2.5,4.4c-0.9-1.6-1.7-3-2.5-4.4h-0.1v-0.1
		c-0.8-0.8-1.6-1.7-2.6-2.8c-0.7,0.6-1.4,1.2-2.3,2c-0.1-2.4-0.3-4.6-2.8-5.3c-0.2-0.1-0.8,0.9-1.2,1.3c-1.6-0.6-3.2-1.2-4.6-1.8
		c0.1-1.1,0.6-2.5,0.1-3.2c-0.6-0.8-2-0.9-3.6-1.5C400.9,119.3,402.6,119,403.5,121z M415.4,136.4c-3.4,0.2-3.4-1.8-3.6-3.6
		c0.2-0.2,0.5-0.4,0.7-0.5C413.4,133.6,414.3,134.8,415.4,136.4z M408.2,129.6c0,0-0.1,0-0.1,0.1l0,0c0,0.8,0,1.6,0,3
		c-1.8-1.3-3.3-2.3-4.7-3.4c0.1-0.2,0.2-0.5,0.3-0.7c1.5,0.4,2.9,0.7,4.4,1.1c0,0,0,0,0-0.1C408.1,129.6,408.2,129.6,408.2,129.6
		c0.5-0.3,1-0.5,1.6-0.8c0.1,0.3,0.1,0.5,0.2,0.8C409.4,129.6,408.8,129.6,408.2,129.6z M408.6,136.3c-0.8-1-1.6-1.9-2.7-3.2
		C408.8,133.4,408.8,133.4,408.6,136.3z M402.3,138.7c0.7,0,1.3-0.1,2-0.1c0,0.2-0.1,0.5-0.1,0.7c-0.6-0.1-1.1-0.2-1.7-0.3
		c0.7,1.5,1.3,3,2,4.4c-0.2,0.1-0.4,0.3-0.6,0.4c-1.2-1.5-2.4-2.9-3.8-4.6C401.1,139,401.7,138.8,402.3,138.7z M398.5,132.9
		c0.8,1.3,1.6,2.6,2.5,4.2C397.5,136.7,397.2,136.3,398.5,132.9z M403.2,132.6c0.8,1.1,1.7,2.3,2.7,3.6
		C403.2,135.8,402.7,135.3,403.2,132.6z M402.5,131.5c-2.1-0.3-4.2-0.6-6.2-1C400.3,128.5,401.3,128.7,402.5,131.5z M394.5,129.7
		c0.1,0.6,0.2,1.3,0.3,1.9c-0.3,0-0.6,0.1-0.9,0.1c-0.1-0.7-0.2-1.3-0.2-2C393.9,129.8,394.2,129.7,394.5,129.7z M393.5,133.8
		c0.8,1,1.6,1.9,2.4,2.9c-0.3,0.3-0.6,0.5-0.8,0.8c-1.5,0-2.3-0.9-2.6-2.3C392.4,134.8,393.1,134.2,393.5,133.8z M392.4,140.3
		c0,0.4,0.1,0.8,0.1,1.1c-0.7,0.1-1.3,0.2-2,0.2c0-0.4-0.1-0.8-0.1-1.3C391.1,140.4,391.8,140.3,392.4,140.3z M391.8,129.9
		c0.2,0.4,0.3,0.7,0.5,1.1c-0.8,0.3-1.5,0.6-2.3,0.9c-0.1-0.3-0.3-0.7-0.4-1C390.2,130.5,391,130.2,391.8,129.9z M375,154.2
		c-0.8-0.4-1.6-0.7-2.4-1.1c0.2-0.4,0.3-0.7,0.5-1.1c0.8,0.4,1.5,0.9,2.3,1.3C375.3,153.6,375.2,153.9,375,154.2z M379,154.7
		c-0.3,0.1-0.6,0.2-0.8,0.4c-0.6-1.3-1.2-2.7-1.8-4c0.3-0.1,0.6-0.2,0.8-0.4C378.2,151.9,379.2,153.1,379,154.7z M380.1,148.6
		c-0.1-0.1-0.2-0.1-0.2-0.2c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0.1,0.2,0.2,0.2,0.3C380.2,148.5,380.2,148.5,380.1,148.6z M381,146.3
		c-0.8,0-1.6,0-2.3,0c0-0.4,0-0.7,0-1.1c0.8,0.1,1.6,0.2,2.4,0.3C381.1,145.8,381,146,381,146.3z M387.4,146.6
		c-0.2-0.2-0.4-0.4-0.6-0.6c-3-0.1,0.7,2.1-1.2,2.6c-0.7-0.6-1.6-1.3-2.6-2c1.3-1.9,2.6-1.9,4.1-1c0.3,0.1,0.5,0.2,0.8,0.3
		C387.7,146.1,387.5,146.3,387.4,146.6z M385.5,140.2L385.5,140.2c-0.5,0-1,0-1.5,0c0,0-0.1,0-0.1,0.1c-0.8,1.6-2.2,2.2-3.6,2.6
		c-0.2-0.3-0.3-0.7-0.5-1c1.4-0.5,2.8-1.1,4.1-1.6l0.1-0.1C384.5,140.2,385,140.2,385.5,140.2L385.5,140.2c0.6,0.1,1.3,0.1,2.5,0.2
		C386.4,141.7,385.6,142.1,385.5,140.2z M388.8,138.8c-0.1-0.2-0.3-0.4-0.4-0.5c0.4,0,0.8-0.1,1.2-0.1c0,0,0.1,0,0.1-0.1
		c-1-0.9-2-1.9-3.2-3c1.1-0.2,2.4-0.5,4.2-0.8c-0.8,1.6,1.1,3-1,3.8l0.1,0.1h-0.1C389.3,138.4,389.1,138.6,388.8,138.8z
M397.2,148.8c-1.5-2.3-3.2-3.7-5.8-2.6c0.3,0.8,0.5,1.5,1,2.9c-1.3-1-2.1-1.5-3.3-2.4c0.8-0.8,1.3-2.1,2-2.2
		c2.3-0.3,4.6-0.1,6.4-0.1C397.4,146.1,397.3,147.3,397.2,148.8z M397,143c-0.6-0.9-1.1-1.7-1.7-2.7c1-0.1,1.6-0.1,2.1-0.1
		c-0.1-0.4-0.1-0.7-0.2-1.1c-1.4,0.1-2.8,0.3-4.2,0.4c0-0.3,0-0.7-0.1-1c1.5-0.4,3-0.8,4.6,0.2c0.7,0.8,1.3,1.5,2.1,2.4
		C398.7,141.8,398,142.3,397,143z M404.7,152.8c-0.5-0.6-1.1-1.3-1.6-1.9c-2.2,1.2-2.2,1.2-2.5-1.4c-0.1-0.7-0.8-1.3-0.8-1.9
		c-0.1-1,0.2-2.1,0.3-3.1c1,0.3,2,0.5,3,0.8c0,0,0,0,0.1-0.1h0.1c1.4-0.4,2.9-0.8,4.4-1.1c0.1,1.8,0.2,3,0.3,4.3
		c-0.7-2.4-2.8-2.6-4.6-3.1h-0.1l0,0c-0.7,0.7-1.3,1.4-2,2.1c0.7,1.1,1.5,2.3,2.2,3.4c0.7,0.4,1.5,0.8,2.2,1.3
		C405.2,152.3,404.9,152.5,404.7,152.8z M411.6,151.5L411.6,151.5c-0.4,0.1-0.6,0.1-0.9,0.2c-1.3-0.5-2.6-1.1-4.1-1.7
		c2.1-0.9,3.7-1.4,4.4,1.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3C411.2,151.5,411.4,151.5,411.6,151.5L411.6,151.5
		L411.6,151.5L411.6,151.5c-0.2-1.6,0.3-2.2,1.5-2c0.2,0.3,0.4,0.7,0.6,1C413.1,150.9,412.4,151.2,411.6,151.5L411.6,151.5z
M409.7,144.2c0-0.2,0.1-0.4,0.1-0.6c1.1,0.1,2.3,0.1,3.5,0.2c-0.2,1.6-0.3,2.9-0.4,4.5c-1.3-1.2-2.2-2-3.5-3.2c1.1,0,1.6,0,2.2,0
		C411,144.8,410.3,144.5,409.7,144.2z M409.6,139.5C409.6,139.5,409.5,139.5,409.6,139.5C409.5,139.6,409.5,139.5,409.6,139.5
		c-0.3,0.3-0.7,0.9-0.7,0.9c-1.1-0.6-2.2-1.3-3.5-2C408,135.8,408.3,138.8,409.6,139.5C409.5,139.5,409.5,139.5,409.6,139.5
		C409.5,139.5,409.5,139.5,409.6,139.5c0.7-2.1,2.5-2.3,4.2-1.9c2,0.5,2.3,2.2,1.8,5C414.4,138.6,411.7,139.8,409.6,139.5z
M415.5,143c0.3-0.1,0.5-0.2,0.8-0.3c0.4,0.7,1,1.3,1.3,2c0.3,0.6,0.2,1.2,0.4,2c-1.1-0.1-1.9-0.2-2.7-0.2
		C415.3,145.3,415.4,144.2,415.5,143z M417.9,152.1c-0.6-0.4-1.2-0.9-2.1-1.6c1-0.4,1.6-0.6,2.2-0.8c0.2,0.8,0.4,1.5,0.6,2.3
		C418.3,152,418.1,152.1,417.9,152.1z M422.4,145.3c0,1.1,0,2.1,0,3.4c-1.2-1.1-2.2-1.9-3.4-3.1
		C420.2,145.5,421.2,145.4,422.4,145.3z M425.3,150.6L425.3,150.6c0.1,0.3,0.2,0.5,0.3,0.8c-0.2-0.1-0.5-0.2-0.7-0.3
		c-1-0.3-2-0.6-3.6-1.1C423.2,149,424.4,148.7,425.3,150.6z M425.9,140.4c-0.1-0.3-0.2-0.7-0.3-1c-1-0.9-1.9-1.8-2.9-2.7
		c-0.3,0-0.6,0-0.9,0c0.2-0.1,0.3-0.3,0.5-0.4c0.1,0.1,0.3,0.3,0.4,0.4c0.7,0,1.4,0,2.2,0c0.3,1,0.5,1.8,0.7,2.7
		c0.2,0.2,0.3,0.3,0.5,0.5C426,140.1,425.9,140.2,425.9,140.4z M426.7,132.9c2.2-1,3.5-0.4,4,1.4c-0.2,0.3-0.4,0.6-0.5,0.9
		C429.1,134.4,427.9,133.6,426.7,132.9z M430.3,141c-0.9-1.8-1.6-3.2-2.5-5.1c2.2,0.2,4,0.4,4.3,2.4C432.2,139,431,139.9,430.3,141z
M435,142.9c0.7,1.7,1,2.5,1.3,3.3c-0.9,0.3-1.6,0.6-2.1,0.8c-0.7-1.6-1.4-3-2.1-4.5c4.2-0.7,8.5-0.8,12.8,0.9
		c-1.3,0.8-2.3,1.5-3.2,2.1C439.7,144.7,437.7,143.9,435,142.9z M442.8,150.4c-0.3-0.7-0.5-1.3-0.8-2.1c0.9-0.1,1.5-0.1,2.2-0.2
		c0.7,0,1.4,0,2.1,0c0,0.2,0.1,0.4,0.1,0.6C445.2,149.3,444.1,149.8,442.8,150.4z M447,143.8L447,143.8
		C447,143.7,447,143.7,447,143.8c0.8-2.1,2.1-1.8,3.8-0.7C449.6,143.3,448.3,143.5,447,143.8C447.1,143.7,447.1,143.7,447,143.8z
M447.9,150.8c-0.2-0.3-0.4-0.5-0.5-0.8c0-0.1,0.3-0.2,0.4-0.4c0.2,0.2,0.4,0.4,0.5,0.7C448.4,150.3,448.1,150.6,447.9,150.8z
M450.6,150.8c-0.7-1.1-1.1-1.7-1.7-2.6c1.2,0,2,0,3.1,0C451.5,149.1,451.2,149.7,450.6,150.8z M452.6,143.4
		c0.8-0.2,1.6-0.4,2.4-0.6c0.1,0.3,0.1,0.5,0.2,0.8c-0.7,0.2-1.5,0.5-2.2,0.7C452.8,144,452.7,143.7,452.6,143.4z M456.9,149
		c-1.1,0.1-2.2,0.2-3.3,0.4c-0.1-0.3-0.1-0.6-0.2-0.9c1.2,0,2.3,0,3.5,0C456.9,148.6,456.9,148.8,456.9,149z M465.8,140.2
		c-0.7-1.1-1.3-2-1.8-2.8c0,0.6,0,1.3,0,1.9c-0.3,0-0.5,0-0.8,0c0-0.9,0.1-1.8,0.1-2.6l0,0c-0.7-0.4-1.3-0.9-2.4-1.5
		C465,135,466,136.2,465.8,140.2z M462.9,144.2c-2-0.3-3.4-0.4-5.3-0.7C459.8,141.6,461.3,141,462.9,144.2z M459.9,139.7
		c-0.2,0-0.4-0.1-0.5-0.1c-1-1.4-2-2.9-3.1-4.5c0.7,0.1,2.5-0.1,2.9,0.5C459.8,136.7,459.7,138.3,459.9,139.7z M456,131.3
		c0.2-0.3,0.4-0.6,0.6-0.9c3.3-0.7,2.3,2.1,2.9,3.5C458.4,133.1,457.2,132.2,456,131.3z M466.5,128c-0.1-0.2-0.3-0.3-0.3-0.5
		s0.2-0.3,0.3-0.5c0.1,0.2,0.3,0.3,0.3,0.5C466.8,127.6,466.6,127.8,466.5,128z M466.5,123.5c1,0.3,1.6,2.2,2.4,3.5
		c-0.2,0.3-0.4,0.6-0.6,0.9c-2.4-4.2-4.2-0.6-6.1,0.1c-1.4-0.5-1.6-3.3-3.6-1.9c-0.1,0.1-0.1,0.2-0.2,0.2c0,0,0,0-0.1-0.1
		c-0.2,0.4-0.3,0.9-0.6,1.7c-0.7-1.1-1.1-1.8-1.5-2.4c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c-0.9,0.2-1.8,0.4-2.6,0.6
		c2.3-2.7,2.3-2.7,4.8,0.1l0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.7-0.8,1.3-1.8,2.2-2.2c0.4-0.2,1.5,1.2,2,1.6
		C464,124.7,465.5,123.2,466.5,123.5z M453.7,119.5c1,0,2-0.2,2.9,0.1c1.4,0.5,2.2,1.6,1.7,3c-1.5-0.9-2.9-1.7-4.3-2.5
		C453.9,119.9,453.8,119.7,453.7,119.5z M463.5,118.7c0,1.2,0,2.1,0,2.9c0.1,0.5,0.2,0.9,0.3,1.4c-0.2-0.3-0.5-0.7-0.7-1
		c-2.2,1.3-2.4-1.5-4-1.5c0-0.4,0-0.7,0-1.1C460.5,119.2,462,119,463.5,118.7z M461.2,111.9c0.1-1.7,0-3.5-3-1.9
		c1.1,2.3,2.3,4.6,3.4,6.9c-0.2,0.1-0.4,0.2-0.6,0.3c-0.7-0.9-1.5-1.7-2.4-2.8c-0.9,1.4-1.4,2.3-2,3.2c-3.4-2.5-3.4-2.5-5.8-1.4
		c0.3,0.7,0.6,1.5,1.1,2.7c-2.7-0.7-3.2-4.4-6.1-3.2c-0.1-0.2-0.3-0.3-0.4-0.5c0.1,0.2,0.3,0.3,0.4,0.5c-0.3,0.1-0.5,0.2-0.8,0.2
		c0.1-0.2,0.2-0.5,0.3-0.7c0.3-0.4,0.6-0.7,0.9-1.1l0,0V114c-1.1-0.8-2.1-1.7-3.2-2.5c-0.5,0.3-1,1-1.4,0.9c-1.7-0.5-3.4-1-3.9,1.1
		c-1.3-0.2-2.6-0.4-3.8-0.5c0.6-0.9,1.2-1.7,1.8-2.4l0,0l0,0c-0.9-0.7-1.9-1.5-2.8-2.2c0.1-0.3,0.3-0.6,0.4-0.9
		c0.9,0.3,2,0.3,2.7,0.9c0.3,0.2-0.2,1.4-0.3,2.2l0,0l0,0c1.1-0.4,2.2-0.8,3.3-1.2c-0.6-0.7-1.2-1.3-2-2.1c2.3-1.1,2.4,0.3,2.4,1.7
		c1,0.7,2,1.4,3,2.1c0.3-0.5,0.6-1.3,1-1.3c2.2-0.3,4.5-0.5,6.8-0.5c0.3,0,0.6,0.8,1.1,1.5c-4.4,0-4.4,0-5.1,3.4c0,0,0,0,0.1,0
		c0,0,0,0,0,0.1c2.7,0,5.5,0,8.2,0.1c2.5,0,3-0.7,2.6-3.9c-1.5,0.5-3,0.9-4.5,1.3c-0.2-0.7-0.4-1.5-0.6-2.5c1.5,0,2.6,0,3.8,0
		c-0.7-1.5-1.3-2.8-2-4.4c2.5-0.2,2.9,2.5,4.6,3.5c1.7-0.3,4.1-1.7,5,1.4C463.7,110.9,463.6,112.3,461.2,111.9z M433.2,98.8
		c2.9-1.8,3.6-1.6,3.9,1.6C435.8,99.8,434.5,99.3,433.2,98.8z M438.9,97.2c2-0.1,3.5-0.2,6-0.3c-0.5,1.6-0.9,2.7-1.4,4.2
		c1.4-0.6,2.4,0,3.1,1.7c-1.6,0-3.3,0-5,0c0,0.7,0,1.5,0,2.8c-1.6-1.3-2.6-2-3.6-2.8c0.1-0.2,0.1-0.5,0.2-0.7
		c1.1,0.2,2.1,0.4,3.2,0.5c0.8-0.8,1.5-1.3,2.1-1.6C441.6,99.5,440.5,98.5,438.9,97.2z M446.7,109.3c-1.5-1.1-2.6-2-4-3
		C446.3,105.1,446.4,105.2,446.7,109.3z M450,103.9c0.1,0.3,0.3,0.5,0.4,0.8l0.1,0.1l-0.1,0.1l0.1-0.1c0,0.1,0,0.1,0,0.2
		c0.4,0.7,0.9,1.5,1.3,2.2c-0.3,0.1-0.7,0.2-1,0.3c-0.1-0.8-0.2-1.7-0.3-2.5c0,0,0-0.1-0.1-0.1c0,0,0-0.1-0.1-0.1
		c-0.2-0.2-0.5-0.3-0.7-0.5c-0.9-1-1.7-2.1-2.7-3.3C449.8,100.6,449.8,100.6,450,103.9c-0.1,0.1-0.2,0.2-0.3,0.3
		C449.8,104.1,449.9,104,450,103.9z M450.6,101.3c0.1-0.2,0.2-0.4,0.3-0.5c1-0.2,2-0.3,3.1-0.5c0,0.9,0.1,1.7,0.1,2.9
		C452.8,102.5,451.7,101.9,450.6,101.3z M448.9,105.2l-0.1,0.6c-0.5,0-1.1,0-1.6-0.1c0-0.3,0-0.6,0-0.9
		C447.8,105,448.4,105.1,448.9,105.2z M455.3,101.1c1.9-1.9,3-1.2,4.3,0.9C457.9,101.6,456.7,101.4,455.3,101.1z M461.4,106.7
		c-1.6-0.6-2.8-1.1-4.5-1.8C460.7,104.2,460.7,104.2,461.4,106.7z M466.6,110.6c-2.7-1.1-3.1-2.6-1.1-4.8c-1.2-0.5-2.1-0.9-2.9-1.2
		c1.4-2.8-0.4-3.6-3-4.3c2.4-1.6,3.7-0.9,4.5,1.1c0.3,0.7,0.4,1.7,0.9,2.2C467.1,105.6,466.9,107.9,466.6,110.6z M471.7,110.5
		c-1.3-1.2-2.4-2.1-3.7-3.3c1-0.6,1.8-1,2.8-1.6c-0.6-0.7-1.2-1.4-2-2.2c0.9-0.3,1.4-0.4,2-0.6c0.3,0.6,0.7,1.1,0.8,1.7
		C471.7,106.4,471.7,108.3,471.7,110.5z M474.1,101.9c-0.9-0.8-1.9-1.6-3.1-2.6c-0.3,1-0.6,1.8-0.9,2.5c-1.6-0.6-3.1-1.2-4.6-1.8
		c-0.1,0-0.2,0-0.4,0c0-0.1,0.1-0.1,0.1-0.2c1-1.8,2.1-2.7,3.4-0.7c1.5-0.6,3-1.1,4.5-1.7c0.5,1.7,1,3,1.4,4.2
		C474.4,101.7,474.3,101.8,474.1,101.9z M489.5,99.7c-1-1.1-2-2.2-2.9-3.3l0.1-0.1l-0.1,0.1c-0.4,0.1-0.8,0.2-1.2,0.2
		c-0.1-0.1-0.3-0.3-0.4-0.4c0.1,0.1,0.3,0.3,0.4,0.4c-0.2,0.1-0.3,0.2-0.5,0.3c0-0.3,0.1-0.5,0.1-0.8c1.2-0.6,2.5-1.2,3.9-1.9
		c0.6,2.2,1,3.6,1.4,5.1C490,99.4,489.8,99.5,489.5,99.7z M514.4,77.3c2.2-0.7,4.6,1.6,4.8,3.9c0.1,0.9,0.1,1.8,0.1,2.2
		c1.3,0.7,2.4,1.2,3.4,1.7l0,0c-0.7,1.2-1.5,2.4-2.2,3.6c0-0.9,0-1.8,0-2.6c-0.3-0.2-0.6-0.4-0.9-0.6c-1.3,1.1-2.5,2.3-3.8,3.4
		c-0.8-1-1.8-2.2-2.7-3.4c1.6-0.3,4.3-0.6,4.3-1c0.2-2.3-1.4-3.8-3.6-4.5c-0.3,1.2-0.5,2.4-0.8,3.6c-1.7-1.1-3.1-2-4.9-3.1
		C510.3,79.3,512.3,77.9,514.4,77.3z M496.5,82.3c2.9,0.2,5.1-0.5,7.5-1.5c2-0.9,4,0.9,3.9,3.1c-0.1,0.9-0.4,1.7-0.7,2.6l0,0h-0.1
		c3.5-1.1,4.3-0.6,4.3,3c0,0.5,0,0.9,0,1.4c1.2,1.2,1,2.3,0.3,3.2c-2.6,0-4.8,0-7.1,0c-0.2,0.7-0.4,1.5-0.6,2.4
		c-0.2,0-0.5-0.1-0.7-0.1c0.1-1,0.1-2.1,0.4-3c0.9-2.7,0.2-3.8-2.8-4.5l0,0c-0.2,0.1-0.3,0.3-0.5,0.4c0-0.3,0.1-0.5,0.1-0.8
		c1.3-0.4,2.5-0.8,3.8-1.2c0.9-0.3,1.8-0.5,2.8-0.7c0,0,0,0,0-0.1c-0.9-1.3-1.8-2.6-2.7-3.8c-2.7-0.6-2.7,1.6-3.1,3.3
		c-1.8-0.7-3.4-1.2-5.5-2c0.8,2.7,0,3.9-2.1,4.5c-0.8-1-1.4-1.9-2-2.6c-1.6,0-2.9,0-4.1,0c0-0.4-0.1-0.8-0.1-1.2
		C490.5,83.8,493.6,82.1,496.5,82.3z M487.3,86.6c0,0.6,0.1,1.1,0.1,1.7c-0.2,0-0.4,0-0.6,0.1c-0.1-0.6-0.2-1.1-0.4-1.7
		C486.7,86.7,487,86.7,487.3,86.6z M481.7,86.5L481.7,86.5C481.7,86.4,481.7,86.5,481.7,86.5c1-0.7,2.1-1.3,3.5-2.3
		c0.2,2.1,0.3,3.3,0.5,4.6c-1.3-0.6-2.3-1.2-3.3-1.7l0.1,0.1c0,0,0,0-0.1-0.1c-0.1,0.5-0.1,1-0.2,1.6c-1.6-0.8-3-1.5-4.5-2.2
		C479.1,84.6,480.4,86.4,481.7,86.5z M471.1,87.5c2.4-1.5,3.9,0.3,5.3,1.8c-0.3,0.8-0.5,1.5-0.7,2c2.8,0,5.4,0,8,0
		c0.7,0,1.4-0.2,2-0.6c2.3-1.4,4.4-1.1,6.5,0.2c3.3-3.1,4.6-2.8,6.6,1.3c0.2,0.3,0.3,0.8,0.6,0.8c3.2,0.3,2.4,3.2,3.2,5
		c4.7,1.2,4.7,1.2,3.8,4.2c-1-0.8-1.8-1.9-2.7-2c-0.8-0.1-1.8,0.9-2.5,1.3c-0.5-2.3-0.9-4.6-1.4-7c-0.9,0.1-1.7,0.2-1.8,0.2
		c-0.7-1.7-1.4-3-2-4.4c-0.3,0-0.7-0.1-1-0.1c-0.9,1.4-1.8,2.7-2.7,4.1c0,0,0,0,0.1-0.1l-0.1,0.1c1.1,0,2.3,0,3.7,0
		c-0.1,1.2-0.1,2.2-0.2,3.3c-1.7-1-2.9-1.8-4.2-2.6c0,0,0,0-0.1,0.1V95c-0.5-0.9-0.9-1.8-1.4-2.7c-0.1,0.4-0.2,0.8-0.3,1.3
		c-2.4-2.5-2.4-2.5-6.4,0.3c0.1,1.4,0.3,2.7,0.4,4.1c0,1.1-0.1,2.2-0.1,3.3c0,0.1,0,0.1,0.1,0.1l0,0c0.2,1.1,0.5,2.3,0.8,3.8
		c-3.9-2.8-3.9-2.8-5.6,0.5c-1.2-0.8-2.3-1.5-3.5-2.3c0.1-0.3,0.1-0.7,0.2-1c2.7-0.3,5.3-0.7,8-1c0,0,0,0,0-0.1v-0.1
		c-0.6-1.9-2.7-3.4-1.7-5.9c0.1-0.3-1-1.5-1.8-1.7c-0.7-0.2-1.8,0-2.4,0.4c-0.6,0.5-0.9,1.4-1.3,2.1c-1.2-0.9-2.3-1.7-3.3-2.5l0,0
		l0,0l0,0l0,0c-0.2-0.4-0.6-1-0.6-1.1c1.8-1.4,0.8-2.7-0.2-3.9c-0.3,0.4-0.7,0.9-1,1.3C470.9,89,470.7,87.8,471.1,87.5z M475.2,98.1
		c2.7-2.2,4-0.4,5.8,1.4C478.3,101.5,477.3,98.6,475.2,98.1z M471.4,93.2c-1.4,0.5-2.3,0.7-3.1,1v0.1c0.4,0.5,0.7,1,1.1,1.5
		c-0.3,0.1-0.6,0.2-0.9,0.3c-0.1-0.6-0.1-1.2-0.2-1.7c0,0,0-0.1-0.1-0.1c-0.9,1-1.8,2.1-2.5,2.8c-1.6-1.2-2.6-1.9-3.6-2.7
		c0.2-0.2,0.4-0.7,0.6-0.7c2.1-0.5,4.3-1.1,6.5-1.4C469.8,92.1,470.5,92.7,471.4,93.2z M465.2,89c1.1-0.5,2.2-0.8,3.4-1.1
		c0.1,0.3,0.2,0.6,0.2,0.9c-0.7,0.4-1.3,0.8-2,1.2l0.1,0.2l-0.2-0.1c-0.6,0.1-1.1,0.3-1.7,0.4C465.1,90,465,89.1,465.2,89z
M461.6,89.4c0.4-0.5,1.3-0.5,2-0.7c0.1,0.2,0.2,0.5,0.3,0.7c-0.6,0.7-1.2,1.3-2.1,2.4C461.7,90.7,461.3,89.8,461.6,89.4z
M461.1,95.1c0.6,0.9,1.1,1.9,1.7,2.8c-0.3,0.2-0.6,0.4-1,0.6c-0.6-0.9-1.1-1.9-1.7-2.8C460.5,95.4,460.8,95.2,461.1,95.1z
M457.5,89.5c0.7-0.1,1.5,0.8,2.2,1.3c0.1,0.1-0.1,0.6-0.1,0.9c-1-0.4-1.9-0.7-2.8-1.1c-0.3,1.2-0.6,2-0.7,2.6
		c-2.1-0.8-3.7-1.4-5.9-2.2C453,90.4,455.2,89.8,457.5,89.5z M449.9,94.7c0.5,0.5,1.4,1.1,2,1c2.5-0.3,5-0.8,7.6-1.2
		c0.1,0.3,0.1,0.6,0.2,0.9c-1.2,0.8-2.3,1.6-3.7,2.5c-1.9-2.4-3.6-1.5-5,0.1c-1.7-0.3-3.1-0.5-4.5-0.8l0,0c-0.2,0.1-0.5,0.2-0.7,0.3
		c0.1-0.2,0.2-0.5,0.4-0.7c1-1.2,2-2.3,3-3.6C449.3,93.6,449.5,94.3,449.9,94.7z M444.8,93.5L444.8,93.5c0.1-0.1,0.1-0.1,0.2-0.1
		c0.5-0.4,0.9-0.9,1.4-1.3c0.2,0.3,0.3,0.6,0.5,0.8c-0.6,0.1-1.3,0.3-1.9,0.4C445,93.5,444.9,93.5,444.8,93.5
		C444.9,93.5,444.9,93.5,444.8,93.5c-0.1,0.7-0.1,1.4-0.2,2.1c-0.3,0-0.5-0.1-0.8-0.1C443.7,94.8,442,93.7,444.8,93.5z M442,92.6
		c0.2,0,0.4,0.2,0.6,0.3c-0.2,0.2-0.3,0.6-0.6,0.7c-0.2,0.1-0.5-0.2-1.1-0.3C441.5,92.9,441.7,92.7,442,92.6z M440,95.5
		c-1.1-0.2-2.1-0.4-3.7-0.7C439,93.1,439,93.1,440,95.5z M433.7,93.7c0.7,0.6,1.3,1.3,2,1.9c-0.2,0.2-0.4,0.4-0.5,0.6
		c-0.7-0.5-1.4-1.1-2.2-1.6C433.2,94.3,433.4,94,433.7,93.7z M436.3,105.1c-1.1-0.1-2.1-0.3-3.6-0.5
		C435,102.9,435,102.9,436.3,105.1z M428.8,96.6c0.2-0.8,0.7-1.6,1-2.4c0.3,0.1,0.6,0.2,0.9,0.3c-1.2,4.2,2.6,8.1,0.5,11.8
		c-1.7-0.2-3.2-0.5-4.6-0.7c0.1,0.4,0.3,0.8,0.6,1.8c-1.6-0.7-2.7-1.2-3.8-1.7c0.1-0.3,0.2-0.7,0.4-1c0.9,0.2,1.8,0.5,2.7,0.7
		c1.3-0.6,2.6-1.3,4.3-2.1c-0.8-1.3-1.7-2.6-2.2-3.5C428.6,98.6,428.6,97.6,428.8,96.6z M426.2,95.1c0.2,0.2,0.4,0.5,0.6,0.7
		c-0.6,0.5-1.2,0.9-1.9,1.4c-0.2-0.2-0.4-0.5-0.5-0.7C424.9,96.1,425.6,95.6,426.2,95.1z M422.2,95.5c1.4,1.8,2.9,3.5,4.3,5.3
		c0.3,0.3,0,1,0,1.6c-0.2-0.2-0.4-0.4-0.6-0.6c-0.8,0.7-1.5,1.3-2.7,2.3c-0.4-0.8-1.2-1.9-1-2.2c1.6-2.2,0.1-3.9-0.9-5.8
		C421.6,96,421.9,95.7,422.2,95.5z M421.5,101.1c-0.4,0.8-0.7,1.7-1.1,2.5c-0.4-0.2-0.8-0.3-1.1-0.5c0.5-0.8,0.9-1.6,1.4-2.5
		C421,100.8,421.2,101,421.5,101.1z M419.4,97.7c-0.6,0.1-1.2,0.2-1.9,0.3c-0.2,0.3-0.5,0.7-0.7,1c0.1-0.5,0.2-0.9,0.3-1.4
		c0.7-0.3,1.3-0.6,2-0.8C419.2,97.1,419.3,97.4,419.4,97.7z"
      />
      <path
        class="st3"
        d="M533.6,77.8c0.4-0.3,0.9-0.6,1.3-1c0,0,0,0,0-0.1c-0.1-0.1-0.1-0.2-0.2-0.2c-0.4-0.1-0.7-0.2-1.1-0.3
		c-0.3,0.6-0.6,1.1-1,1.6c0.2,0,0.4,0.1,0.6,0.1l0,0C533.4,77.9,533.5,77.8,533.6,77.8z"
      />
      <path
        class="st3"
        d="M444.6,34.2c-0.1-0.1-0.2-0.4-0.3-0.7c0-0.1-0.1-0.2-0.1-0.3h-0.1c-0.1,0-0.1,0-0.2,0c0,0.2-0.2,0.6-0.1,0.7
		c1,0.5,0.8,1.4,0.8,2.2c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3
		c-0.3-0.7-0.9-1-1.9-0.8c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7
		c1.7,0.6,1.7,0.6,3.5,0.2c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3
		c-0.2,0.2-0.3,0.5-0.5,0.7c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5
		c-0.1,0.2-0.4,0.4-0.6,0.5c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7
		c-0.8-0.5-1.4-1.1-2.4-1c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.2-0.9,0.1-1.3
		c0.1-0.2-0.1-0.6-0.2-1.1c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4
		c0.2-0.4,0.5-0.8,0.5-1.2s-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7
		c-0.1,0.2,0.1,0.6,0.2,0.6c0.5,0.1,0.6,0.3,0.6,0.6s-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1
		c-0.8-0.3-1.4,0-2,0.8c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1
		c0.3,0.3,0.5,0.5,0.7,0.8c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5
		c-0.5,1.1-0.5,2.1,1.3,2.6c-0.5,0.7-1,1.4-1.5,2.1c2.4-0.5,4.8-1,7.2-1.5c0.1,0,0.2-0.1,0.3-0.1h0.1c0.4-0.2,0.8-0.4,1.2-0.6
		c0.1,0.2,0.1,0.4,0.2,0.6c-0.5,0-0.9,0-1.4,0H457c-0.1,0-0.2,0-0.3,0.1c-0.6,0.2-1.1,0.5-1.7,0.7c0.3,0.8-0.7,1.6-0.7,2.5
		c0,0,0,0-0.1,0c0,0,0,0,0.1,0.1v-0.1c0.1,0.5,0.2,0.9,0.4,1.1c2.2-0.6,4.3-1.3,6.5-1.9c-2.2-3.8-4.3-7.4-6.4-11c0,0,0,0,0.1,0.1
		c1.6,1.5,3.2,3,4.8,4.5c-3.5-6-7.7-11.6-12.3-16.8c-0.1,0.5-0.2,0.9-0.3,1.4c-0.5-0.3-1.1-0.5-1.6-0.8
		C445.1,34.4,444.8,34.3,444.6,34.2z"
      />
      <path
        class="st3"
        d="M508.5,118.2c0-0.2,0-0.4,0-0.6l0,0c-0.1,0.1-0.2,0.3-0.3,0.4C508.3,118.1,508.4,118.1,508.5,118.2z"
      />
      <path
        class="st3"
        d="M474.1,157.3H474c0.1,0.1,0.1,0.2,0.2,0.2C474.1,157.4,474.2,157.3,474.1,157.3z"
      />
      <path
        class="st3"
        d="M464,137.4c-0.2-0.2-0.5-0.5-0.7-0.7C463.5,136.9,463.8,137.2,464,137.4L464,137.4z"
      />
      <path
        class="st3"
        d="M266.8,169c0.4,0.1,0.8,0.1,1.2,0.2c0.7-0.8,1.5-1.6,2.2-2.4c-0.1-0.1-0.2-0.3-0.2-0.4
		c-1.1,0.7-2.3,1.4-3.4,2.1C266.8,168.6,266.9,168.8,266.8,169z"
      />
      <path
        class="st3"
        d="M478.9,141.7c0.1,0.2,0.2,0.3,0.3,0.5c0.1-0.2,0.2-0.3,0.3-0.5C479.3,141.7,479.1,141.7,478.9,141.7z"
      />
      <path
        class="st3"
        d="M525.5,80.8c-0.1-0.5-0.3-1-0.7-2.2c-0.3,1.4-0.5,2.1-0.7,2.8C524.6,81.2,525.1,81,525.5,80.8z"
      />
      <path
        class="st3"
        d="M496.1,100c-0.2,0.1-0.4,0.1-0.6,0.2c0,1,0,1.9,0,2.9c0.9,0.1,1.6,0.2,2.4,0.3
		C497.3,102.3,496.7,101.1,496.1,100z"
      />
      <polygon class="st3" points="561.3,136.9 561.1,137.2 561.4,137.2 	" />
      <path
        class="st3"
        d="M276.5,139.2L276.5,139.2c0-0.3,0-0.6-0.1-0.9C275.9,138.6,275.9,138.7,276.5,139.2z"
      />
      <path
        class="st3"
        d="M560.8,164.6c0.1,0,0.2,0,0.4-0.1c0.3-0.7,0.6-1.3,1.7-1.7c0.7-0.2,1.3-0.8,1.9-1.3c0.3-0.3,0.6-0.7,0.9-1
		c0-0.3,0-0.6,0-0.9c-1.7,0-3.3,0-5.2,0c0,2.9,0,5.8,0,8.6c0.1,0,0.2,0,0.3,0v-0.1v0.1c0,0,0,0,0.1,0c0-0.7,0-1.5,0-2.2
		c0,0,0,0-0.1,0c0,0,0,0-0.1-0.1h0.1C560.8,165.5,560.8,165.1,560.8,164.6z M563.6,160.3c0,0.7,0.1,1.3,0.1,2c-0.2,0-0.4,0-0.6,0
		c0-0.7-0.1-1.3-0.1-2C563.2,160.3,563.4,160.3,563.6,160.3z M561.1,161.2c0.2,0,0.3,0,0.5,0.1c-0.1,0.4-0.1,0.9-0.2,1.3
		c-0.2,0-0.3,0-0.5-0.1C561,162.1,561.1,161.6,561.1,161.2z"
      />
      <path
        class="st3"
        d="M296.4,118.5c0.5-0.5,0.7-1.1,0.7-1.7c-0.3,0-0.5,0.1-0.8,0.1c-1.7,0-3.4,0-5.4,0c-0.1,0.4,0,0.9,0.3,1.3
		c0.2,0.4,0.5,0.7,0.8,1.1c0.8,0.1,1.7,0.1,2.7,0.2h0.1c-1-0.3-1.5-0.5-2.1-0.7c0-0.3,0.1-0.5,0.1-0.8
		C294,118.2,295.2,118.4,296.4,118.5z"
      />
      <path
        class="st3"
        d="M572.7,163.4c0.4,0.1,0.8,0.1,1.2,0.1c0.2-1.2,0.5-2.3,0.7-3.5c0.1,0,0.2,0,0.4,0c0.1,0.7,0.2,1.5,0.4,2.2
		c0.1-0.1,0.2-0.1,0.3-0.2c0.2-0.3,0.3-0.5,0.8-1.4c0.3,2.7,0.6,4.9,0.8,7c1.1,0.6,2.2,1.1,3.7,1.9c0.5-3.6,1-6.6,1.4-9.6
		c0.2,0,0.4,0,0.6,0c-0.2,2.9-0.3,5.9-0.5,8.8c0.2,0.1,0.4,0.2,0.7,0.3c0.3-0.6,0.9-1.1,0.9-1.7c0.1-2.1,0-4.2,0.1-6.4
		c0.1-2.3-1.2-2.5-3.1-2.2c-0.2,3.1-0.4,6.2-0.7,9.4c-0.3,0-0.6,0-0.9,0c-0.7-3-2.2-6-0.5-9.5c-2.1,0-4.2,0-6.6,0
		C572.5,160.4,572.6,161.9,572.7,163.4z"
      />
      <path
        class="st3"
        d="M270.7,150.6c0,0-0.1,0-0.2,0C270.6,150.6,270.7,150.6,270.7,150.6C270.7,150.7,270.7,150.6,270.7,150.6z"
      />
      <path
        class="st3"
        d="M564.1,166.1c0.1,0,0.2,0,0.2,0c0-0.2,0-0.4,0-0.6c0.7-0.5,1.2-0.3,1.5,0.3c-0.5,0.4-0.9,0.9-1.4,1.3
		c0,0.3,0,0.5,0,0.8c0,0,0,0.1,0.1,0.1c1,0.4,2.7-0.5,3.2-1.4v-0.1c0-0.1,0.1-0.2,0.1-0.3c0,0,0-0.1-0.1-0.1s-0.3,0-0.4,0
		c0-0.1,0-0.2,0-0.3c-0.1,0-0.1-0.1-0.2-0.1c0-0.2,0.1-0.3,0.2-0.5c0-1.6,0-3.3,0-4.9c-0.1,0-0.1,0.1-0.2,0.1
		c-0.3,1.7-0.6,3.4-0.9,5.1c-0.1,0-0.2,0-0.3,0c0-0.8-0.1-1.7-0.1-2.5c0,0.1-0.1,0.3-0.2,0.5c-1.6,0.2-2.7,1-3.4,2.2
		c0,0.1-0.2,0.1-0.3,0.1c0-0.2-0.1-0.2-0.1-0.3c0.4,1.2,0.7,2.4,1.2,4C563.5,167.9,563.8,167,564.1,166.1z"
      />
      <path
        class="st3"
        d="M251,131.8c-1,1-2.1,2.1-3.3,3.3c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3
		c0.7,1,0.6,1,2,1.2c0-0.1,0-0.2,0-0.3c-0.5-0.4-0.7-1.2-0.9-2c0-0.1,0.3-0.3,1-0.9c0.1,0.4,0.3,0.7,0.4,1.1
		c0.2-0.2,0.4-0.3,0.8-0.4c-0.1,0.4-0.4,0.9-0.5,1.2c0.1,0.2,0.2,0.5,0.3,0.8c1-1.2,1.4-1.7,2.1-2.4c1.4,2.3-0.5,2.5-1.4,2.8
		c-0.4,0.1-0.7,0.2-1,0.1c-0.1,0.3-0.1,0.6,0,0.8c0.5-0.1,1-0.1,1.6-0.2c0-0.1,0.1-0.1,0.1-0.2c0.8,0,1.7,0.3,2.3-0.6
		c0.3,0.2,0.5,0.3,0.7,0.5c0.8-0.1,1.6-0.2,2.4-0.3c0-0.8,3-1.3-0.6-2.3c1.8-0.5,2.7-0.7,3.7-1c0.6,0.9,1.1,1.8,2,3.3
		c0.6-1.4,1-2.4,1.4-3.3c0.2,0,0.4,0.1,0.5,0.1c0,0.6,0,1.3,0,1.9l-0.1,0.1l0.1-0.1c0,0.1,0.1,0.2,0.1,0.3c0.2-0.4,0.5-0.7,0.9-1.1
		c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7c0.1-0.2,0.3-0.4,0.5-0.6c-1.4,0.3-3.1,1.9-4.6,0l0,0V132
		c-0.7,0-1.5,0.3-2.1,0.1c-1-0.3-1.9-0.9-2.8-1.4l0,0c0,0,0,0-0.1,0c0.3,0.8,0.7,1.6,0.8,2c-1.7,0.3-3,0.6-4.2,0.8c0,0,0,0,0,0.1
		h-0.1c-0.1,0.1-0.2,0.3-0.4,0.4c-0.1-0.1-0.1-0.3-0.2-0.4c0.2,0,0.4,0,0.5,0c0,0,0-0.1,0.1-0.1c0,0,0,0,0.1,0
		c-0.5-2.9,1.3-3,3.4-2.8l0,0h0.1c0.3-0.3,0.7-0.8,1-0.8c1.8,0,4.4,1.3,3.8-2.4c0-0.1,0.8-0.5,1.2-0.4c0.5,0.1,1.2,0.7,1.2,0.9
		c-0.2,0.7-0.4,1.7-1,1.9c-1,0.5-2.3,0.6-1.3,2.2c0,0,0,0,0.1,0.1c0.3-0.3,0.6-0.9,0.9-0.9c1,0,2.1,0,3.1,0c0-0.1,0.1-0.1,0.1-0.2
		c0.1-0.3,0.3-0.6,0.4-0.9c-0.4,0-0.8-0.1-1.2-0.1c0.3-1.1,0.6-2,0.9-2.8c0.6-0.2,1.2-0.5,1.8-0.7c0.1,0.2,0.1,0.4,0.2,0.7
		c-0.6,0.1-1.2,0.2-1.8,0.3c0.2,0.2,0.4,0.4,0.6,0.6c0.4-0.3,0.8-0.4,1.2-0.3c0.9,0.2,1.4-0.3,1.9-0.6c-0.3-0.5-0.7-1-1.1-1.5
		c-0.6-0.1-3.3,0.1-4.6,0.2c0,0,0,0,0,0.1c0,0,0,0-0.1,0c-0.4,0-0.6,0-0.7,0c-2.5,0-5,0-7.5,0c-0.1,0.3-0.1,0.6-0.2,0.8
		c1.2,0.5,2.5,0.9,3.8,1.4c-0.6,1.8-2.2,1.5-3.5,0.9c-1.1-0.5-2.1-1.5-3.1-2.3c-0.2,0.2-0.3,0.4-0.5,0.6c0.4,1,0.8,1.9,1.6,3.7
		c-1.9-1.4-3.1-1.9-4.1-0.3c0.9,0.3,1.8,0.6,2.7,0.9c-0.1,0.3-0.1,0.6-0.2,1C253.7,132,252.4,131.9,251,131.8
		C251.1,131.7,251,131.8,251,131.8z M257.7,134.6c0,0.2,0,0.4,0.1,0.6c-0.7,0.1-1.3,0.3-2,0.4c0-0.3-0.1-0.6-0.1-0.9
		C256.3,134.7,257,134.6,257.7,134.6z"
      />
      <path
        class="st3"
        d="M293.7,127.8c0.2,0,0.3,0,0.6,0c0,0.3,0,0.6,0,0.9c1.6,0,3.2,0,4.8-0.2c-0.2-0.2-0.5-0.3-0.8-0.3
		c-0.4,0-0.8-0.4-1-0.7c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-0.8-0.2-1.4-0.7-2c-0.4,0.1-0.8,0.1-1.3,0.2l0.1,0.1
		c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7C291,127.4,292,127.8,293.7,127.8z"
      />
      <path
        class="st3"
        d="M552.8,166.8c0.3-0.7,0.5-1.4,0.8-2.2c-0.2-0.2-0.4-0.3-0.6-0.5c-0.5,0.5-0.9,0.9-1.4,1.4
		c0.2,0.2,0.4,0.5,0.6,0.7c-0.7,0.2-1.4,0.5-2,0.9c-0.4,0.6-0.7,1.1-1.1,1.7c0.6-0.3,1.1-0.6,1.5-0.9
		C551.6,167.4,552.1,167,552.8,166.8z"
      />
      <path
        class="st3"
        d="M344.6,103.8L344.6,103.8c0.1,0.1,0.2,0.1,0.3,0.1c0-0.9,0-1.9,0-2.8c-0.3,0.7-0.3,1.4-0.1,2.3
		c0,0.1,0,0.2,0.1,0.3l-0.1,0.1C344.7,103.8,344.7,103.8,344.6,103.8z"
      />
      <path
        class="st3"
        d="M549.2,167c0.2-0.1,0.5-0.2,0.7-0.4c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.4,0.1-0.8,0.2-1.2l0,0
		c-1.4,0.1-2.7,0.1-4.1,0.2c-0.7,0.2-1.4,0.3-2.4,0.5c0.2-0.2,0.3-0.3,0.4-0.4c-1.2,0.1-2.5,0.1-3.7,0.2c-1.1,1.5-2.1,3.1-3.2,4.5
		c-0.3,0.4-0.6,0.9-0.8,1.3c0.4,0,0.8,0,1.2,0c-0.5-0.4,0.8-0.9,0.1-1.3c0.4-0.4,0.7-0.8,1.1-1.3c0.8,0.3,1.1-0.1,1.4-0.6
		c1.2,0.7,0.9,1.7,0.4,2.8c-0.5,0.2-1.1,0.4-1.8,0.6c-0.2,0.5-0.5,1-0.7,1.5c0.1,0.5,0.3,0.9,0.5,1.2c0.6,0.7,1.7,0.9,3.5,0.9
		c0.4,0.4,0.7,0.8,1.1,1.1c0.2,0.1,0.3,0.2,0.5,0.3c1,0.4,2.3,0,2.7-1.1c0-0.1,0.1-0.2,0.1-0.4c-0.2,0.2-0.4,0.4-0.6,0.6
		c-0.1-0.9-0.1-1.7,0-2.4c0,0,0,0-0.1-0.1c-0.6-0.4-0.6-0.9-0.1-1.5c-0.6-0.1-1.1-0.3-1.7-0.4c-0.2,0.6-0.5,1.2-0.7,1.7
		c-0.2-0.2-0.4-0.4-0.6-0.7c-0.1,0.1-0.1,0.1-0.2,0.2c0.1-0.1,0.1-0.2,0.1-0.2l-0.1-0.1c0.2-0.4,0.3-0.7,0.5-1.1
		c-0.7,0.1-1.2,0.1-1.8,0.2c0.5-0.6,0.9-1.3,1.5-1.8c0.7-0.5,1.6-0.9,2.3-1.3c0-0.4-0.1-0.8,0.1-1c0.1-0.2,0.6-0.1,0.9-0.2
		c0.6-0.1,1.1-0.2,2-0.4C548.5,166.6,548.8,166.8,549.2,167z M541.9,173.6c0.2,0.2,0.4,0.4,0.6,0.6c-0.2,0.3-0.4,0.6-0.7,0.9
		c-0.2-0.1-0.4-0.3-0.5-0.4C541.5,174.3,541.7,173.9,541.9,173.6z M548.3,166.3c0,0-0.2,0.1-0.3,0.1c-0.1-0.1-0.2-0.3-0.3-0.4
		c0.2,0,0.3-0.1,0.5-0.1C548.3,166,548.3,166.1,548.3,166.3z"
      />
      <path
        class="st3"
        d="M125.9,184.1c1.4,0.3,2.7,0.7,4.1,1c2.2,0.6,4.4,2.1,6.7-0.1c0.4-0.4,1.9,0.3,3,0.2c-2.4-1.6-4.8-2.9-8-2.4
		c-1.7,0.3-3.4,0-5.1,0c-0.3,0.4-0.6,0.8-0.8,1.2l0,0C125.8,184.1,125.9,184.1,125.9,184.1z M132.1,183.3c0.5,0.3,1,0.5,1.5,0.8
		c0.4,0.1,0.8,0.2,1.2,0.3c-0.1,0.1-0.2,0.3-0.3,0.4c-0.3-0.2-0.6-0.5-0.8-0.7c-0.6-0.1-1.1-0.1-1.7-0.2
		C131.9,183.7,132,183.5,132.1,183.3z"
      />
      <path
        class="st3"
        d="M345.9,99.6c0,0.2,0,0.5,0,0.7c0.1,0,0.3-0.1,0.4-0.1c-0.1-0.2-0.2-0.5-0.3-0.7C346,99.5,346,99.6,345.9,99.6z
		"
      />
      <path
        class="st3"
        d="M571.3,162.9L571.3,162.9c0.1,0,0.1,0,0.2,0c-0.3-1.4-0.5-2.8-0.8-4.3c-0.8,0.2-1.5,0.3-2.2,0.4
		c0,0.3-0.1,0.6-0.5,0.8c-0.1,0-0.1,0.1-0.2,0.1c1,1.4,1.2,2.9,1,4.5c0.8-0.1,1.5-0.4,2.1-1C571,163.3,571.1,163.1,571.3,162.9z"
      />
      <path
        class="st3"
        d="M601.3,138.9c0,0.2,0,0.4,0,0.6l0,0c0.2-0.2,0.5-0.4,0.7-0.7l-0.1,0.1c0,0,0,0,0-0.1
		C601.8,138.8,601.6,138.9,601.3,138.9z"
      />
      <path
        class="st3"
        d="M573.8,164.1c-0.3,0-0.7,0-1,0c0,0.3,0.1,0.7,0.1,1.1c0.2,0,0.4,0.1,0.6,0.1
		C573.6,164.9,573.7,164.5,573.8,164.1z"
      />
      <path
        class="st3"
        d="M598,166.5c0-0.1,0.1-0.2,0.2-0.3c-0.1-2.3-0.3-4.6-0.4-6.9c-0.3,0.2-0.8,0.3-0.8,0.5c0.1,2.8,0.3,5.5,0.4,8.3
		c0.1-0.2,0.2-0.3,0.3-0.6S597.8,166.8,598,166.5z"
      />
      <path
        class="st3"
        d="M420.7,57.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1c0,0.1,0.1,0.2,0.1,0.2
		c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.5c0.2-0.1,0.4-0.1,0.7-0.2v-0.1c0.1,0,0.2,0,0.3,0c0.9-0.2,1.7-0.5,2.6-0.7l0,0
		c0.3-0.4,0.6-1,0.7-1.4c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1c-0.1-0.4-0.4-0.8-1-1.1
		C420.6,57.3,420.6,57.6,420.7,57.8z"
      />
      <path
        class="st3"
        d="M601.5,140.4c0-0.1-0.1-0.1-0.1-0.2c0,0.2,0,0.3,0,0.5C601.4,140.6,601.5,140.5,601.5,140.4z"
      />
      <path
        class="st3"
        d="M598.4,140.9c-0.2,0-0.5,0-0.7,0c-0.1,0-0.2-0.1-0.2-0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0.3,0.3,0.5,0.4,0.9
		C598.2,141.5,598.3,141.2,598.4,140.9z"
      />
      <path
        class="st3"
        d="M602.6,138.2c-0.2,0-0.3,0-0.5,0c0,0.2-0.1,0.4-0.1,0.6l0,0C602.2,138.6,602.4,138.4,602.6,138.2z"
      />
      <path
        class="st3"
        d="M602.9,137.9c-0.1,0.1-0.2,0.2-0.3,0.3l0,0l0,0C602.7,138.1,602.8,138,602.9,137.9z"
      />
      <path
        class="st3"
        d="M586.3,174.5c0.1,0,0.2-0.1,0.2-0.1c-2.8,0.1-5.6,0.2-8.5,0.1c-0.1,0.1-0.3,0.2-0.3,0.4
		c-0.1,0.2-0.1,0.5-0.1,1.1c0.6-0.4,0.9-0.7,1.2-0.8s0.7-0.2,1.1-0.3c0.1,0.3,0.2,0.6,0.3,0.9c0.2,0.5,0.5,0.8,0.9,1.1
		s0.9,0.4,1.6,0.4c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3
		C585.4,175,585.6,174.7,586.3,174.5z"
      />
      <path
        class="st3"
        d="M595.4,168.5c0.4,0.1,0.7,0.1,0.9,0.1c-0.3-3.1-0.6-6.1-0.9-9.1c-0.4,0-0.7-0.1-1.1-0.1
		c-2,1.7-0.4,4.2-0.8,6.4c0.5-0.3,0.8-0.5,1.7-1.2c-0.3,1.5-0.6,2.6-0.9,3.7C594.7,168.4,595,168.5,595.4,168.5z"
      />
      <path
        class="st3"
        d="M573.3,172.2c3.3,0.6,6.5,0.7,10-0.5c-2.8-3.2-6.1,0.5-8.2-1.3c0.6-0.8,1.3-1.7,2.1-2.7l0,0
		c-0.4-0.5-0.7-1-0.9-1.3c-1,0.8-2.2,1.8-3.6,3c-0.3-1.7-0.6-3.3-0.9-5c-0.2,0.1-0.4,0.3-0.6,0.5l0,0c-0.1,0.1-0.2,0.2-0.3,0.4
		c-0.8,1.2-0.2,2.4,1.6,3.5c-0.4,0.3-0.8,0.6-1.1,0.8c-0.1,0-0.3-0.1-0.3-0.1c-0.3-0.4-0.5-0.7-0.9-0.9c-0.1-0.1-0.3-0.2-0.5-0.3
		c-0.7-0.4-1.5-0.5-2.3-0.3c-1.1,0.2-1.8,0.7-2.4,1.4c-0.1,0.2-0.3,0.4-0.4,0.6c1.7,0,3.3,0,5,0c0,0.3-0.1,0.6-0.1,0.9
		c-1.6-0.3-3.3-0.6-4.9-0.9c0,0,0,0,0,0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2,0,0.6,0.1,0.8
		c1.9,0.2,3.8,0.3,5.7,0.4C571.1,172.1,572.2,172,573.3,172.2z"
      />
      <path
        class="st3"
        d="M563,179.5c0.7,0,1.4,0,2.1,0.1c1.5,0,4.1-0.4,4.4,0.2c0.2,0.4,0.5,0.8,0.8,1c0.4-0.5,0.7-1.1,1.1-1.6
		c-0.2,0-0.3-0.1-0.4-0.2c-0.2-0.2,0-0.6-0.1-1c0.5-0.1,0.9-0.2,1.3-0.2c1.1-0.1,1.9-0.3,2.6-0.8c0.2-0.1,0.3-0.2,0.4-0.4
		c0.3-0.3,0.5-0.6,0.6-0.9c0.2-0.4,0.2-0.9,0.1-1.4c-1.6-0.1-3.2-0.2-4.8-0.5c-1.1-0.2-2.2-0.2-3.3-0.2c-0.3,0.8-0.5,1.5-0.7,2.1
		c-1.1,0.4-2.1,0.9-3.2,1.4c-0.2-0.2-0.6-0.5-0.9-0.9c0.1-0.1,0.1-0.2,0.2-0.3c-0.3,0-0.5,0.1-0.8,0.1c-0.1-0.4-0.1-0.7-0.2-1.1
		c0.5-0.1,1-0.1,1.6-0.2c0,0,0,0,0-0.1c0-0.2,0-0.3-0.1-0.5c-0.1-0.1-0.1-0.2-0.2-0.3c-0.8,0.1-1.7,0.2-2.5,0.3
		c-0.1,0.2-0.2,0.3-0.2,0.5c-0.2,0.6-0.2,0.9-0.4,1.2c0.2,1.1,1.6,1.4,2.8,1.9c-1.1,0.5-1.8,0.8-2.5,1.1c0.5,0.1,1,0.2,1.5,0.3
		c0.2-0.1,0.4-0.3,0.7-0.4C562.9,179.2,563,179.3,563,179.5z M569.3,177.1c0.1,0,0.1,0.1,0.2,0.2c-0.2,0.1-0.4,0.2-0.5,0.3
		c-0.1-0.1-0.1-0.2-0.2-0.2C569,177.3,569.1,177.2,569.3,177.1z M565.7,177.2c0.6,0,1.2,0,1.8,0c0,0.1,0,0.3,0,0.4
		c-0.6,0-1.2,0-1.8,0C565.7,177.5,565.7,177.4,565.7,177.2z"
      />
      <path
        class="st3"
        d="M587.3,162.1c0.2,2.4,0.5,4.8,0.8,7.5c1.1,0,2.2,0,3.5,0c0.4-0.3,0.9-0.7,1.4-1.1c-0.3-2.7-0.6-5.5-0.9-8.2
		c-0.2,0-0.3,0-0.5,0c-0.1,1.4-0.2,2.8-0.3,4.2c-0.2,0-0.4,0-0.5,0c-0.1-1.5-0.2-3-0.4-4.8C587.8,158.9,587.2,160.1,587.3,162.1z"
      />
      <path
        class="st3"
        d="M589.6,172.6c0.1-0.1,0.3-0.1,0.4-0.2c0,0.1,0.1,0.2,0.1,0.2c0.6,0,1.3,0.1,1.9,0.1c0.2,0,0.3-0.1,0.5-0.1
		c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.1-0.4,0.2-0.7,0.2-1.1c-2.1-0.1-4.2,0-6.3,0.5
		C586.3,172,587.9,172.5,589.6,172.6z"
      />
      <polygon class="st3" points="466.5,70.7 466.4,70.7 466.5,71 	" />
      <polygon class="st3" points="466.4,66.6 466.4,66.8 466.6,66.8 	" />
      <path
        class="st3"
        d="M269.2,149.8c-0.2-0.1-0.3-0.1-0.5-0.2c0,0-0.1,0.1-0.2,0.2c0.2,0.1,0.3,0.1,0.5,0.2
		C269.1,149.9,269.1,149.8,269.2,149.8z"
      />
      <path
        class="st3"
        d="M466.4,53c0,0.1-0.1,0.2-0.1,0.3s0.1,0.2,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3C466.6,53.1,466.5,53,466.4,53z"
      />
      <polygon class="st3" points="461.6,79.8 461.4,79.9 461.6,80.1 	" />
      <path
        class="st3"
        d="M466.4,74.7c0.1,0,0.2-0.1,0.2-0.1c0-0.1-0.1-0.2-0.1-0.3c-0.1,0-0.2,0.1-0.2,0.1
		C466.3,74.5,466.3,74.6,466.4,74.7z"
      />
      <path
        class="st3"
        d="M413.8,93.3c0.2-0.9,0.3-1.7,0.5-2.8c-0.7,0.9-1.2,1.6-1.7,2.3c0.2,0.2,0.4,0.4,0.5,0.5
		C413.3,93.4,413.8,93.3,413.8,93.3z"
      />
      <path
        class="st3"
        d="M458.5,59.1c0,0-0.1,0.1-0.1,0.2c0.1,0,0.3,0.1,0.3,0.1c0.1-0.1,0.1-0.2,0.1-0.3
		C458.8,59.1,458.6,59,458.5,59.1z"
      />
      <polygon class="st3" points="461.2,58.4 461.2,58.6 461.5,58.5 	" />
      <polygon class="st3" points="460.8,84 460.8,83.8 460.6,83.9 	" />
      <path
        class="st3"
        d="M451.2,83c-0.9,0.9-1.7,1.9-3,3.3C451.3,86.2,451.2,84.6,451.2,83z"
      />
      <path
        class="st3"
        d="M437.8,87.6c0,0.2,0.2,0.4,0.4,0.5c0.1,0,0.5-0.2,0.5-0.3c0-0.2-0.1-0.5-0.3-1
		C438.1,87.1,437.9,87.3,437.8,87.6z"
      />
      <polygon class="st3" points="422.4,91.3 422.3,91.5 422.3,91.4 	" />
      <path
        class="st3"
        d="M235.9,253.5c-1,0.7-2,1.5-3,2.2c0.4,0.2,0.7,0.7,1,1c0.2-0.2,0.4-0.5,0.6-0.7c0.1-0.1,0.1-0.1,0.2-0.2
		c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0.1,0.1,0.1c0.1-0.1,0.2-0.2,0.3-0.4c0.3-0.6,0.5-1.1,0.8-1.7C236,253.7,236,253.6,235.9,253.5z"
      />
      <path
        class="st3"
        d="M451.6,82.6c-0.1,0-0.2,0-0.2,0.1c0,0,0,0.1,0,0.2C451.4,82.7,451.5,82.7,451.6,82.6z"
      />
      <path
        class="st3"
        d="M454.6,83.3c-0.1-0.1-0.2-0.2-0.3-0.3c0,0.2-0.1,0.4-0.1,0.5C454.3,83.5,454.4,83.4,454.6,83.3z"
      />
      <path
        class="st3"
        d="M454,83.8c-0.3,0.4-0.6,0.7-0.8,1.1c0.2,0.1,0.3,0.2,0.5,0.3C453.8,84.7,453.9,84.2,454,83.8z"
      />
      <path
        class="st3"
        d="M485,147.6c-0.1,0-0.3-0.1-0.4-0.1c-0.3,0.7-0.6,1.3-0.8,2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		C485,150.5,485,149,485,147.6z"
      />
      <path
        class="st3"
        d="M524,69.6c-0.2,0.2-0.5,0.5-0.7,0.7c0.1,0.1,0.3,0.2,0.4,0.2C523.8,70.3,523.9,69.9,524,69.6z"
      />
      <path
        class="st3"
        d="M355.8,163.1c0.4,0.1,0.8,0.3,1.2,0.4c0.1-0.1,0.1-0.3,0.2-0.4c-0.3-0.3-0.7-0.5-1-0.8
		C356,162.6,355.9,162.9,355.8,163.1z"
      />
      <path
        class="st3"
        d="M528.5,59.5L528.5,59.5c0.1,0,0.1-0.1,0.1-0.2C528.6,59.4,528.5,59.4,528.5,59.5z"
      />
      <path
        class="st3"
        d="M524.7,61.8c-1,2.7-2.4,5.2-3.1,8c2.9-3,5.1-6.5,6.8-10.3C526.5,59.3,525.4,59.9,524.7,61.8z"
      />
      <path
        class="st3"
        d="M483.7,149.5c-1.1,1.7-2.9,3.3-0.6,5.8C483.3,153.3,483.5,151.4,483.7,149.5z"
      />
      <path class="st3" d="M518.4,65.8l0.2,0.3L518.4,65.8z" />
      <path
        class="st3"
        d="M514.2,72.3c0.6-1.2,1.3-2.5,1.9-3.7c0.8-0.9,1.5-1.8,2.3-2.7l0,0c0.1-0.1,0.3-0.3,0.4-0.4
		c-0.1,0.2-0.1,0.4-0.2,0.7c-0.7,1-1.3,2-2,3c-0.8,1.1-1.5,2.3-2.3,3.4c2,0.6,3.3-0.2,4.3-1.9c1.7-3.2,3.4-6.3,5.5-10.2
		c-1.8,0.3-3.1,0.4-4.4,0.7c-2.7,0.7-5.4,1.5-8.1,2.1c-1.6,0.4-2.4,1.2-2.3,2.8c0.5-0.6,1-1.1,1.5-1.7c0.2,0.2,0.5,0.4,0.7,0.5
		c-1.2,1.6-2.5,3.1-3.7,4.7c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c-0.2,1.3-0.3,2.7-0.6,4.6C509.8,73.4,512,72.8,514.2,72.3z"
      />
      <path
        class="st3"
        d="M481.6,148.5c0.8-1.7,3-2.9,0.7-4.7c-1.6-1.3-2.8-0.7-3.8,1.4c-0.4-0.8-0.7-1.3-1.1-2.3
		c-0.8,0.6-1.5,1.2-2.3,1.8c0.7,0.6,1.2,1.4,2,1.8C478.6,147.3,480.1,147.8,481.6,148.5z"
      />
      <path
        class="st3"
        d="M474.4,150c0.9-0.1,1.9-0.2,2.8-0.3c0-0.3-0.1-0.5-0.1-0.8c-0.9,0.1-1.9,0.3-2.8,0.4
		C474.3,149.6,474.4,149.8,474.4,150z"
      />
      <path
        class="st3"
        d="M492.3,75.1L492.3,75.1c-0.2,0-0.5,0-0.7,0l0,0C491.8,75.2,492,75.1,492.3,75.1z"
      />
      <path
        class="st3"
        d="M481,78.7c-0.1,0.6-0.1,1.1-0.3,2.5c1.3-0.7,2.1-1.2,3-1.8C482.8,79.2,481.9,78.9,481,78.7L481,78.7z"
      />
      <path
        class="st3"
        d="M491.4,77.3c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.2-0.1,0.5-0.1,0.7C491.1,77.6,491.2,77.5,491.4,77.3z"
      />
      <polygon class="st3" points="504.6,75.4 504.8,75.4 504.6,75.1 	" />
      <path
        class="st3"
        d="M495.8,75.2c-0.8,0.5-1.6,0.9-2.3,1.4C495.2,77.3,495.9,76.8,495.8,75.2z"
      />
      <path
        class="st3"
        d="M501.5,76.3c0,0,0-0.1,0.1-0.2c-0.1,0-0.2,0.1-0.4,0.1C501.3,76.3,501.4,76.3,501.5,76.3z"
      />
      <path
        class="st3"
        d="M504.8,72.3c0-0.1-0.1-0.2-0.2-0.3c0,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.2,0.3
		C504.7,72.5,504.8,72.4,504.8,72.3z"
      />
      <path class="st3" d="M501.5,71.6l-0.1-0.1L501.5,71.6L501.5,71.6z" />
      <path
        class="st3"
        d="M472.5,72.8c-1.1,0.4-2.4,1.8-2.6,2.9c-0.4,2.2-0.1,4.6-0.1,7.5c2.6-0.9,4.8-1.6,6.9-2.4l0,0
		c1.7,0.6,1.7,0.6,2.3-2c0.1-0.4,0.3-0.9,0.4-1.3c-0.2,0.4-0.5,0.7-0.7,1.1c-0.4,0.3-0.8,0.6-1.3,0.8c0,0,0,0-0.1,0
		c1-2,2.1-3.9,3.1-5.9c0.4,0.1,0.7,0.3,1.1,0.4c-0.1,0.9-0.2,1.8-0.3,2.9c0.3-0.2,0.7-0.2,0.8-0.4c1-1.3,1.8-2.7,2.9-4
		c0.2-0.3,1-0.1,1.5-0.1c0,0,0,0,0-0.1c0.5-0.2,0.9-0.4,1.4-0.5v-0.1h0.1l-0.1,0.1h-0.1c-0.7,1.8-1.3,3.7-2,5.5
		c0.4-0.3,0.7-0.5,1.1-0.8c1.4-2.1,2.9-4.2,4.3-6.3l0,0c0.2-0.1,0.4-0.2,0.6-0.3c-0.1,0.2-0.2,0.4-0.3,0.7c-1.4,2.1-2.8,4.2-4.3,6.4
		c-0.2,0.7-0.5,1.5-0.7,2.2c0.2,0.1,0.4,0.3,0.6,0.4c0.5-0.7,0.9-1.3,1.4-2c0.7-0.9,0.4-3.1,2.6-2.2c0.9-1.7,1.8-3.3,2.7-5
		c0.3,0.1,0.6,0.3,0.9,0.4c-0.3,1.1-0.6,2.2-1,3.8c3.9-2.2,1.7-5.3,2.4-8.5c-3.5,0.9-6.5,1.6-9.4,2.4
		C482.2,69.7,477.3,71.1,472.5,72.8z M473.2,75.2c-0.2,0.1-0.4,0.2-0.6,0.3c0.1-0.2,0.3-0.3,0.4-0.5c0.2-0.4,0.3-0.7,0.5-1.1
		c0.1,0.1,0.4,0.3,0.4,0.4C473.7,74.5,473.4,74.9,473.2,75.2z"
      />
      <path
        class="st3"
        d="M491.5,70c0.1,0.1,0.2,0.2,0.3,0.3C491.7,70.3,491.6,70.2,491.5,70L491.5,70z"
      />
      <path
        class="st3"
        d="M337.8,163.1c0.1,0,0.1,0,0.2-0.1v-0.1C337.9,163,337.8,163.1,337.8,163.1z"
      />
      <path
        class="st3"
        d="M338.9,160.2c-0.3,0.8-0.5,1.7-0.8,2.5c0.5-0.7,1-1.4,1.5-2.1C339.4,160.4,339.2,160.3,338.9,160.2z"
      />
      <path
        class="st3"
        d="M337.7,159.2c-2.7,0-2.8,0-1.5,3.9c0.4-0.8,0.7-1.3,0.9-1.9C337.4,160.6,337.5,159.9,337.7,159.2z"
      />
      <path
        class="st3"
        d="M298.6,154.9c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.4,0.4-0.9,0.6-1.3C299.3,154.2,299,154.5,298.6,154.9z"
      />
      <path
        class="st3"
        d="M296.7,157.1c0.2-0.2,0.5-0.3,0.7-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.3,0.1-0.5,0.3-0.7,0.5
		C296.5,156.9,296.6,157,296.7,157.1z"
      />
      <path
        class="st3"
        d="M336.4,150.7c-0.1,0-0.2,0.1-0.2,0.1c0.2,0.2,0.3,0.4,0.5,0.7c0.1,0,0.1,0,0.2,0c-0.1,0-0.1,0-0.2-0.1
		C336.5,151.3,336.4,151,336.4,150.7z"
      />
      <path
        class="st3"
        d="M338.5,179.5c-0.5-3.1-0.9-6-1.4-9.2c-2.3,2.3-0.8,5.1-1,7.5C336,179.7,337.4,179.8,338.5,179.5z"
      />
      <path
        class="st3"
        d="M411.1,87.1c0,0.1,0,0.2,0.1,0.3c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.2-0.1-0.3C411.3,87,411.1,87,411.1,87.1z"
      />
      <path
        class="st3"
        d="M279.8,174.9c0.3-0.2,0.5-0.5,0.8-0.7c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2,0.3-0.5,0.5-0.7,0.8
		C279.7,174.8,279.7,174.9,279.8,174.9z"
      />
      <path
        class="st3"
        d="M260.2,144.4c0.2,0.2,0.4,0.4,0.6,0.5c0.2-0.3,0.5-0.7,0.7-1c-0.2-0.2-0.4-0.3-0.6-0.5
		C260.7,143.8,260.5,144.1,260.2,144.4z"
      />
      <path
        class="st3"
        d="M273.6,170.6c0,0.1,0,0.1,0,0.2C273.6,170.8,273.6,170.7,273.6,170.6c0.5-0.3,1.1-0.6,1.6-0.9
		c-0.2-0.2-0.4-0.4-0.5-0.6C274.3,169.6,274,170.1,273.6,170.6z"
      />
      <path
        class="st3"
        d="M276,163.3c0.3,4.1,0.7,8.2,1,12.3c0.2,0,0.5,0,0.7,0c0.2-4.8,0.4-9.7,0.6-14.9c-0.6,0.4-1.2,0.9-1.8,1.3
		l0.1,0.2l-0.1-0.2C276.3,162.5,276,162.9,276,163.3z"
      />
      <path
        class="st3"
        d="M263.1,141.1c0,0-0.1-0.1-0.1-0.2l0,0C263.1,141,263.1,141,263.1,141.1z"
      />
      <path
        class="st3"
        d="M294.5,159.2c0.2-0.1,0.5-0.3,0.7-0.4c-0.2-0.1-0.4-0.3-0.6-0.3s-0.3,0.2-0.5,0.4
		C294.2,159,294.4,159.2,294.5,159.2z"
      />
      <polygon class="st3" points="366.8,151.9 366.8,151.8 366.6,151.9 	" />
      <polygon class="st3" points="280.3,161.4 280.4,161.4 280.4,161.2 	" />
      <polygon class="st3" points="280.5,171.2 280.3,171.2 280.4,171.4 	" />
      <path
        class="st3"
        d="M336.4,168.9c0.2-0.9,0.4-1.7,0.6-2.6c-0.2,0-0.5-0.1-0.7-0.1c-0.1,0.9-0.2,1.8-0.3,2.7
		C336.1,168.8,336.3,168.9,336.4,168.9z"
      />
      <path
        class="st3"
        d="M404.8,106.3c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.2c0-0.1-0.1-0.1-0.1-0.2
		C404.9,106.1,404.8,106.2,404.8,106.3z"
      />
      <path
        class="st3"
        d="M391.1,125.3l-0.1,0.1L391.1,125.3c0-0.1,0-0.1,0.1-0.2C391.1,125.2,391.1,125.3,391.1,125.3z"
      />
      <path
        class="st3"
        d="M399.8,112c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.1-0.2-0.2
		C399.9,111.8,399.9,111.9,399.8,112z"
      />
      <path
        class="st3"
        d="M393.1,120.3c-0.2-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.5,0.8-0.8,1.2c0.2,0.1,0.4,0.3,0.6,0.4
		C392.7,121.2,392.9,120.8,393.1,120.3z"
      />
      <path
        class="st3"
        d="M394.2,118.2c0,0.3,0,0.6,0,0.9c0.1,0,0.2,0,0.2,0c0-0.3,0-0.6,0-0.9C394.3,118.2,394.2,118.2,394.2,118.2z"
      />
      <path
        class="st3"
        d="M403.8,92.1l-0.1,0.1L403.8,92.1c0-0.1,0-0.1,0.1-0.2C403.9,92,403.9,92,403.8,92.1z"
      />
      <path
        class="st3"
        d="M406.6,104.7c0-0.2,0-0.4,0-0.6c-0.1,0.1-0.3,0.3-0.4,0.4C406.3,104.6,406.5,104.7,406.6,104.7z"
      />
      <path
        class="st3"
        d="M369.6,148.2c-0.2-0.3-0.3-0.6-0.5-0.9l-0.1-0.1l0.1,0.1c0.1,0.3,0.2,0.7,0.2,1
		C369.5,148.3,369.6,148.3,369.6,148.2z"
      />
      <path
        class="st3"
        d="M235.4,256.4c0.6-0.2,1.1-0.8,1.2-1.3V255c0-0.1,0-0.3,0-0.4c-0.1-0.3-0.3-0.6-0.5-0.9
		c-0.2,0.6-0.3,1.3-0.5,1.9c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.2,0.2,0.3,0.3c-0.1,0.2-0.3,0.3-0.4,0.5
		C235.3,256.2,235.3,256.4,235.4,256.4z"
      />
      <path
        class="st3"
        d="M377.9,137.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2-0.1,0.2-0.1C378.1,137.5,378,137.4,377.9,137.3z"
      />
      <path
        class="st3"
        d="M373.8,143.6c-0.6-0.2-0.9-0.4-1.1-0.4c-0.2,0.1-0.5,0.4-0.6,0.7c0,0.1,0.3,0.5,0.3,0.5
		C372.7,144.3,373,144.1,373.8,143.6z"
      />
      <path
        class="st3"
        d="M370.7,145.9c0-0.2-0.1-0.4-0.1-0.5c-0.2,0.1-0.3,0.2-0.5,0.3c0.1,0.1,0.2,0.3,0.4,0.4
		C370.5,146.1,370.7,146,370.7,145.9z"
      />
      <path
        class="st3"
        d="M386.9,130.3c0,0.1,0,0.2,0,0.2C386.8,130.5,386.8,130.4,386.9,130.3c0.1,0,0.1-0.1,0.2-0.1
		C387,130.2,386.9,130.3,386.9,130.3z"
      />
      <path
        class="st3"
        d="M390.5,122.2c-0.2,0.6-0.5,1.2-0.7,1.8c0.2,0.1,0.4,0.1,0.6,0.2c0.2-0.6,0.5-1.2,0.7-1.8
		C390.8,122.4,390.6,122.3,390.5,122.2z"
      />
      <path
        class="st3"
        d="M379.3,136c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0.1,0.2,0.3,0.3,0.4c0.1-0.1,0.2-0.2,0.1-0.2
		C379.5,136.3,379.4,136.1,379.3,136z"
      />
      <path
        class="st3"
        d="M536.2,149.7c-0.2,0-0.3,0-0.5-0.1c0,0.5-0.1,1-0.1,1.6c0.1,0,0.2,0,0.2,0C536,150.8,536.1,150.2,536.2,149.7z
		"
      />
      <path
        class="st3"
        d="M265.6,140.2c0.5-0.4,1-0.9,1.5-1.3c-0.2-0.2-0.3-0.4-0.5-0.5c-0.4,0.5-0.9,1-1.3,1.5
		C265.4,139.9,265.5,140.1,265.6,140.2z"
      />
      <path
        class="st3"
        d="M565.9,144.5L565.9,144.5L565.9,144.5l-0.1,0.1L565.9,144.5z"
      />
      <path
        class="st3"
        d="M568.8,144.8c-0.3,1.8-0.5,2.9-0.6,3.9c1.4-0.1,2.8-0.4,2.6-2.3C570.7,145.9,569.7,145.5,568.8,144.8z"
      />
      <path
        class="st3"
        d="M567.7,135c-0.1,0.2-0.3,0.3-0.4,0.5c0.1,0.2,0.2,0.3,0.3,0.5c0.1-0.2,0.3-0.3,0.3-0.5
		C568,135.3,567.8,135.2,567.7,135z"
      />
      <path
        class="st3"
        d="M547.1,50.3c-0.1,0.2-0.2,0.4-0.3,0.7c0.1,0,0.2,0,0.3,0C547.1,50.8,547.1,50.6,547.1,50.3z"
      />
      <path
        class="st3"
        d="M570.3,157.7c1-0.2,1.9-0.3,2.9-0.5c-1,0-1.9,0-2.9,0C570.3,157.4,570.3,157.5,570.3,157.7z"
      />
      <path
        class="st3"
        d="M540,55.9c0,1.1-0.1,2.2-0.1,3.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2,0.1,0.4,0.2,0.6,0.3l0,0c0.2,0,0.3,0,0.5,0
		c0-0.7,0.1-1.3,0.1-2c-0.2,0.3-0.3,0.6-0.5,1C540.8,57,540.4,56.4,540,55.9z M541,57.7c0.1,0,0.1-0.1,0.2-0.1c0,0.1,0,0.1,0,0.2
		C541.1,57.8,541.1,57.7,541,57.7z"
      />
      <path
        class="st3"
        d="M573.2,148.9c0.1,0,0.2,0,0.3,0c0-7.3,0-14.6,0-21.9c-0.1,0-0.2,0-0.3,0C573.2,134.3,573.2,141.6,573.2,148.9z
		"
      />
      <path
        class="st3"
        d="M564.4,122.5c-0.5,0.4-0.9,0.9-1.4,1.3C564.4,124.4,564.4,123.5,564.4,122.5z"
      />
      <path
        class="st3"
        d="M563,145.1L563,145.1c0.2-0.2,0.5-0.4,0.7-0.6c-0.2,0-0.4,0-0.7,0C563.1,144.7,563.1,144.9,563,145.1z"
      />
      <path
        class="st3"
        d="M573.7,157.1c0.2,0,0.3,0,0.5,0c-0.1-0.1-0.1-0.2-0.2-0.4C574,156.9,573.9,157,573.7,157.1z"
      />
      <path
        class="st3"
        d="M561.8,141.5c0.1,0.1,0.2,0.2,0.4,0.4c0.7-0.6,1.3-1.3,2-1.9c-0.1-0.2-0.3-0.4-0.4-0.5
		C563.1,140.1,562.5,140.8,561.8,141.5z"
      />
      <path
        class="st3"
        d="M562.9,124c-0.6,0.9-1.3,1.8-1.9,2.7C562.7,126.5,562.9,125.3,562.9,124z"
      />
      <path
        class="st3"
        d="M571.5,152.6c-0.7-0.4-1.3-0.7-2-1.1l0,0c-0.8,0.9-1.6,1.8-2.7,3c-0.1-1.2-0.1-1.8-0.1-2.4l0,0
		c-1,2-2.4,0.1-3.8,0.5c0.7-1.9,1.3-3.4,1.8-5c-0.1,0-0.2-0.1-0.3-0.1c-0.9,1.3-1.9,2.6-3.1,4.3c-0.1-0.8-0.2-1.2-0.3-1.6
		c-0.5,1.3-1.1,2.6-1.6,4C566.2,155.8,570.4,155.1,571.5,152.6z"
      />
      <path
        class="st3"
        d="M563.1,144.4L563.1,144.4c0.2-0.2,0.5-0.4,0.7-0.7l0,0c2.1-2.6,2.7-2.7,3.6-0.7c1,0,2,0,3.2,0
		c0-2.7,0-5.7,0-8.8c-0.3,0-0.6-0.1-0.8-0.1c-0.1,1.3-0.3,2.5-0.5,3.8C566.2,138.5,563.4,141.3,563.1,144.4z"
      />
      <path
        class="st3"
        d="M544.4,56.1c0.3,0.5,0.6,0.9,1,1.4c0-0.3,0.1-0.7,0.1-1c-0.1,0-0.1-0.1-0.2-0.1
		C544.9,56.1,544.6,56.1,544.4,56.1z"
      />
      <path
        class="st3"
        d="M537.8,145.8c0.2,0.2,0.4,0.4,0.7,0.5c0.1-0.2,0.3-0.4,0.2-0.6c0-0.1-0.3-0.2-0.5-0.4
		C538.1,145.5,537.9,145.7,537.8,145.8z"
      />
      <path
        class="st3"
        d="M541.3,151.9c0,3.5,0,6.9,0,10.6c1,0.1,1.9,0.3,2.8,0.2c3.8,0,4.1-0.3,4.1-4c0-2.8,0-5.6,0-8.8
		c-2.4,0-5,0-7.6,0c0,0.1,0,0.2,0,0.3c2.2,0,4.4,0,6.8,0c0,3.4,0,6.4,0,9.4c-0.3,0.3-0.7,0.5-1,0.8c-0.4-0.8-0.8-1.6-1.1-2.3
		c-0.4,0.8-0.7,1.6-1.1,2.4c-0.3-0.1-0.7-0.1-1-0.2c0-1.4,0-2.7,0-4.1c-0.3,1.4-0.6,2.9-0.9,4.3c-0.1,0-0.3,0-0.4,0
		c0-2.9,0-5.7,0-8.6C541.7,151.9,541.5,151.9,541.3,151.9z"
      />
      <path
        class="st3"
        d="M545.4,157c0.5-0.4,1-0.9,1.5-1.3c-0.2-0.2-0.5-0.4-0.7-0.5C545.9,155.8,545.7,156.4,545.4,157z"
      />
      <path
        class="st3"
        d="M601.2,139.5L601.2,139.5L601.2,139.5C601.1,139.6,601.2,139.6,601.2,139.5z"
      />
      <path
        class="st3"
        d="M560.7,117.4c0.1,0.1,0.3,0.3,0.4,0.4C561,117.6,560.8,117.5,560.7,117.4L560.7,117.4z"
      />
      <path
        class="st3"
        d="M610.2,56.6c-0.5,0-1.1,0-1.4,0.2c-0.9,0.8-2.6,0.4-3.2,1.5c-0.2,0.4-0.2,0.9-0.1,1.3c0.1,0.3,0.4,0.6,0.8,0.7
		c0.2,0,0.4,0.1,0.6,0c0.8-0.2,1.4-0.1,2.1,0c0.3,0.1,0.6,0,0.9,0c0.5-0.1,0.9-0.4,1.4-0.6c-0.4,0.5-0.7,1-1.1,1.4
		c-1.1,1.3-1.4,2.8-1.4,4.3c-0.4,0.2-0.8,0.3-1.3,0.5c-0.1-0.4-0.2-0.8-0.2-1.1c-0.8-0.2-1.4-0.3-2.2-0.5c0.3-0.4,0.5-0.7,0.7-1
		c0.4,0.1,0.8,0.2,1.2,0.3c0.1-0.2,0.2-0.3,0.1-0.4c0-0.1-0.1-0.4-0.2-0.4c-1.3-0.2-1.2-1.9-2.7-2c-0.4,0-0.8-0.4-1-0.7
		c-0.4-0.5-0.7-1.1-1.1-1.7c-0.8-1-1.2-2.2-1.2-3.4c0-1.1-0.3-1.9-1.4-2.6c0.7-0.2,1.2-0.3,1.6-0.5c1.6-0.6,2.4-2.3,1.6-3.6
		c-0.6-1.2-2.4-1.6-3.9-1c-1.7,0.7-2.5,2.2-1.7,3.5c0.5,0.9,1.2,1.7,1.9,2.5c0.9,1,0.7,2.2-0.6,3c-1.5,0.9-2,1.6-1.7,2.7
		c0.3,1,1.2,1.4,3,1.3c0.2,0,0.3,0,0.6,0c0,0.5,0,1,0.1,1.5c0,0-0.1,0.1-0.1,0.3c-0.5-0.2-1.1-0.2-1.5-0.2c-0.5,0-1.1,0.2-1.6,0.5
		c-0.1,0.1-0.3,0.2-0.4,0.3c-0.2,0.1-0.4,0.2-0.5,0.4c0-0.2-0.1-0.4-0.1-0.5s0-0.2-0.1-0.3c-0.3-1.1-1-1.6-2.4-1.6
		c-0.4,0-0.7,0.1-1.1,0.1l0.1-0.1l0,0l0,0c-0.3,0.3-0.6,0.5-0.8,0.8c-0.4,0.4-0.6,0.8-0.6,1.2s0.2,0.8,0.5,1.2
		c0.2,0.3,0.5,0.5,0.8,0.7c0.8,0,1.6-0.1,2.3-0.4c0.2-0.1,0.5-0.2,0.7-0.4c0.1,0.4,0.2,0.8,0.2,1.2c0.1,0.7,0.2,1.4,0.4,2.1
		c0.3,1-0.1,2.2-0.2,3.5c-2-0.7-2.8-2.5-5-2.7c-0.5,0.9-1,1.7-1.5,2.7c-0.2,0.1-0.7,0.2-1.1,0.4c-0.1,0.1-0.2,0.4-0.2,0.6
		c0.3,0.7,0.9,0.5,1.5,0.3l0,0c0.3,0.1,0.5,0.2,0.8,0.2c-1.1,1.5-2.5,1.4-4,1.3c-0.2-0.2-0.3-0.5-0.5-0.7c-0.1-0.1-0.1-0.2-0.2-0.2
		c-0.1-0.2-0.3-0.5-0.4-0.7c-0.3-0.7-0.6-1.6-0.6-2.4c0-0.1,0-0.2,0-0.3c0-0.8-0.2-1.4-0.9-1.9c-0.2-0.2-0.4-0.4-0.6-0.6
		c-0.3-0.5-0.4-1-0.4-1.6c0.6-0.5,1.2-0.9,2.1-0.9c0.8,0,0.8,0,1.5-1.1c-0.8-0.3-1.5-0.7-2.4-1c-0.1-0.7-0.2-1.3-1.4-1.5
		c-0.9-0.1-1.6-0.8-2.7-1.3c-0.3,0.1-0.7,0.4-0.6,1c0.2,0.6,0.6,1.3,0.9,1.9c0.1,0,0.2-0.1,0.4-0.1c0-0.3,0-0.7-0.1-1.3
		c0.5,0.6,0.7,0.9,1.1,1.4c0.5,0,1.3-0.6,1.7,0.3c-0.1,0.1-0.3,0.3-0.5,0.4c-1.7,1.5-1.9,2.9-0.5,4.6c0.2,0.2,0.4,0.5,0.6,0.7
		c0.1,0.1,0.2,0.3,0.4,0.4c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.2-0.1,0.5-0.1,0.7c0,0.1-0.3,0.2-0.5,0.3c-0.7,0.4-0.7,0.4-0.1,1
		c0.2-0.2,0.5-0.3,0.9-0.5c0.1,0.6,0.2,1.2,0.3,1.8c0.2,1,0.3,2.1,0.5,3.1c-0.9,0-1.5,0.1-2.3,0.1c-0.1-0.3-0.2-0.6-0.4-1.1
		c-0.3,0.3-0.5,0.4-0.8,0.8c-0.3-0.6-0.5-1.2-0.8-1.9c-0.3,0-0.7-0.2-0.9-0.2c-0.9,0.3-1.2,0-1.8-0.5c-0.2-0.1-0.2-0.3-0.3-0.4
		c-0.1-0.3,0.2-0.7,0.1-1c0-0.1,0-0.1-0.1-0.2c0.2-0.2,0.3-0.3,0.3-0.4v-0.1c0-0.1,0-0.2,0-0.3c0,0,0,0,0-0.1s-0.1-0.1-0.2-0.2l0,0
		c-0.1-0.1-0.2-0.2-0.4-0.3l0,0c-0.1-0.1-0.3-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.3,0.3-0.6,0.5-1c0.3,0.1,0.6,0.2,1,0.3
		c0-0.5,0.1-1,0.1-1.4c-0.9-0.1-1.7-0.2-2.6-0.2c0.3,0.2,0.4,0.4,0.6,0.5c-0.4,0.5-1,0.6-1.7,0.6v-0.1h-0.1c0,0,0,0,0,0.1
		c-0.2,0.2-0.3,0.3-0.5,0.5c-0.7-0.6-0.9,0.2-1.4,0.4c-0.5-0.9,0-1.6,0.8-2.4c0.4-0.4,0.8-0.9,1.1-1.3l0,0c0.2-0.2,0.4-0.5,0.6-0.7
		c0.2-0.2,0.4-0.5,0.6-0.8c-0.1-0.1-0.2-0.2-0.4-0.4c-0.1-0.1-0.2-0.2-0.4-0.3c0-0.1,0.1-0.2,0.1-0.3c0.2-0.5,0.4-0.9,0.6-1.4
		c0.1-0.2,0.1-0.3,0.2-0.5c-0.2-0.1-0.5-0.1-0.9-0.2c0.6-0.8,1.4-1.3,2.2-1.2c0.9,0.2,1.4-0.4,2-0.7c0,0,0.1,0,0.1-0.1
		c0.9-0.3,0.9-1.1,0.2-1.6c-0.5-0.4-1.1-0.7-1.6-1.1c-0.9-0.8-2-1-3.2-0.9c-0.2,0-0.5,0-0.7,0.1c0,0.4,0.5,0.9-0.1,1.2
		c-0.1,0-0.3,0.1-0.5,0.1c-0.1-0.2-0.3-0.5-0.4-0.8c-0.1-0.2-0.2-0.4-0.4-0.5c-0.3-0.2-0.6-0.4-1.1-0.3c-0.8,0.1-1.1-0.3-1.5-0.6
		l-0.1-0.1c-0.6-0.5-1-0.5-1.6,0.2c-0.4,0.5-0.9,0.3-1.3,0.6c-0.1-0.6-0.1-0.8,0.2-1l0,0c0.1-0.1,0.3-0.2,0.5-0.3
		c-0.6-0.4-0.5-1.4-1.7-0.9c-0.1,0-0.3-0.2-0.3-0.3c-0.2-0.9-1.3-1.3-1.7-2.1c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3,0.4-0.7,0.7-1,1.1
		c-0.5-0.4-1-0.8-1.5-1.3c-0.5,0.3-1,0.5-1.4,0.8l0.1-0.1c0,0,0,0-0.1,0c0,0,0,0,0,0.1c-0.3,0.3-0.6,0.7-1,1c0.5,0.5,1,1,1.5,1.5
		c-0.4,0.8-0.8,1.6-1.2,2.5c-0.4-0.3-0.5-0.7-0.8-0.8c-0.4-0.1-0.8,0.1-1.5,0.3c0.3-1,0.5-1.9,0.8-3.1c-0.1-0.3-0.3-0.9-1.4-0.7
		c-0.3,0.1-0.7-0.4-1.1-0.7c0.5-0.3,0.9-0.6,1.3-0.8c0.2-0.1,0.4-0.2,0.5-0.3c-0.1-0.3-0.2-0.5-0.3-0.6c-0.3-0.4-0.6-0.3-1.6-0.1
		c0,0.2,0,0.3,0,0.5c0,0.1,0,0.3,0,0.4c0,0.1,0,0.1,0,0.2c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.7-0.2-1.2-0.3l0,0l0,0
		c0.1,0.2,0.1,0.3,0.2,0.5c0.1,0.2,0.2,0.5,0.2,0.7c-0.5,0.1-0.9,0.2-1.4,0.3c-0.4,0.1-0.8,0.4-1.5,0.7c0.3-0.6,0.5-1,0.6-1.3
		c-0.2-0.5-0.5-0.8-1.2-0.8c0,0.9,0.1,1.7,0.1,2.6c0.7,0,1.4-0.4,1.7,0.5c0.4-0.3,0.6-0.5,0.9-0.7c0,0.2,0,0.4,0,0.6
		c0,0.7,0.1,1.3,1.1,1.5c1-0.5,0.1-1,0.1-1.5c0.9,0,0.8,0.9,1.5,1.2c-0.5,0.4-0.9,0.7-1.3,1c0.1,0,0.2,0.1,0.4,0.1s0.3,0.1,0.5,0.1
		c-0.3,0.5-0.6,1-1,1.6c0.5,0.4,0.4,1.3,0.6,2c0.1,0.3-0.3,0.8-0.5,1.1c-0.2,0.2-0.5,0.4-0.9,0.7c-0.4-0.1-1-0.3-1.6-0.4
		c-0.3,0.3-0.5,0.6-0.8,0.9l0,0c-0.2,0.2-0.4,0.5-0.6,0.7v0.1c0.4,0.1,0.7,0.2,1.1,0.3c0.2,0.1,0.4,0.1,0.6,0.2
		c0.4,0.1,0.9,0.1,1.4-0.1c1.2,0.7,2-0.6,3.2-0.6c-0.2,0.3-0.4,0.6-0.6,0.9c-0.1,0.1-0.2,0.3-0.3,0.4c-0.1,0-0.2-0.1-0.3-0.1
		c-0.2-0.1-0.3-0.1-0.5-0.2c-0.3,0.2,0,0.8-0.9,0.6c-0.5-0.1-1,0.7-0.9,1.3c0,0.1,0,0.2,0.1,0.3c0.2,0.3,0.5,0.5,0.7,0.7
		c-0.1,0.4-0.4,0.9-0.4,1.3c0,0.1,0,0.2,0.1,0.3c0.1,0.2,0.3,0.4,0.6,0.5c0.1,0,0.2,0.1,0.3,0.1c0.2,0,0.5,0.1,0.6,0.3
		c0.7,1,0.6,1,2,1.2c-0.1-0.9-0.3-1.9,1.2-2.5c-0.2,0.6-0.7,1.4-0.5,1.8c0.3,0.6-0.4,1.2,0.2,1.8c-0.8,0.4-1.4,0.8-2.1,1.2
		c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.2,0.2,0.3c0.4-0.3,0.8-0.6,1.3-0.8c0.9-0.4,1.5-0.9,1.8-1.8
		c0.8,0,1.7,0.3,2.3-0.6c0.7,0.5,1.4,0.9,2,1.3c0.1-0.4,0.3-0.5,0.7-0.5c0.1,0,0.3,0,0.4,0c0.1,0,0.3,0,0.4,0c0.6,0,1.2,0,1.6-0.7
		c0.3,0.3,0.5,0.5,0.7,0.8c-0.3,0.2-0.7,0.4-1.2,0.8c0.8-0.1,1.2-0.1,1.7-0.1c-0.3,0.4-0.6,0.6-0.7,0.8c-0.7-0.1-1.3-0.2-1.9-0.4
		c-0.5-0.1-1-0.4-1.5-0.6c0,0.6,0,1.2,0,2.2c-0.6-0.6-0.9-0.8-1.1-1.1c-0.3,0.4-0.9,0.6-0.6,1.3c0.2,0.5,0,1.2-1,1.3
		c-0.2-0.3-0.4-0.5-0.6-0.8c-0.7,0.2-0.5,0.7-0.4,1.1c0,0.1,0.3,0.1,0.6,0.1c-0.8,0.4-1.6,0.8-2.5,1.3c0.2,0.2,0.3,0.4,0.6,0.7
		c-0.3,0.1-0.5,0.2-0.6,0.1c-0.6-0.3-0.6-0.8-0.2-1.3c-1-1.1-2.6-0.8-4-0.9c0-1,1.1-0.3,1.5-1c-0.5-0.1-1-0.2-1.6-0.3
		c0.1-0.1,0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.4,0.4-0.5c-0.3-0.1-0.6-0.3-0.8-0.5c-0.7-0.6-0.7-1.6-0.9-2.6c-0.8,0-1.9,0.5-2.4-0.1
		c0.1,4.7,0.5,4.9,5.9,6.8c2.3,0.8,3.3,1.8,3.2,4.5c-0.4,10.4-0.5,20.7-0.7,31.1c0,2.1,0.1,4.2,1.8,5.8l0,0c0.5,0.1,1,0.1,1.4,0.2
		c0.1,0,0.1,0,0.2,0l0,0c0.7-0.9,1.4-1.8,2.2-2.9c-1-0.3-1.7-0.6-2.7-0.9c1.1-0.8,1.9-1.8,2.4-1.7c1.8,0.5,3.6,1.3,5,2.4
		c0.6,0.4,0.1,2.1,0.2,3.2c0,0,0,0-0.1,0c0,2.1,0.8,4.6-0.1,6.1c-2.6,3.9-6,7.3-9.1,10.8c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1
		c0,0.5,0,0.9,0,1.4l0,0l0,0c1.1-0.5,2.2-1.1,3.3-1.6c-0.1-2,0.7-3.3,2.8-3.6c0.5-0.6,0.9-1.2,1.4-1.9c0.2,0.2,0.4,0.3,0.6,0.5
		c-0.5,0.6-1,1.2-1.5,1.8c-0.9,1.2-1.9,2.4-2.8,3.5c-0.7,1-1.4,1.9-2.1,2.9c-0.1,0.3-0.2,0.7-0.2,1c2.1-2.1,4.1-4.2,6.2-6.3
		c0.7-0.7,1.6-1.3,3-2.4c0.2-5.7,0.9-12.3,0.4-18.8c-0.4-5.8,1.2-10.8,4.2-15.3c1.9-3,4.8-5.4,7.6-7.7c2.5-1.9,4-1.5,6.5,0.7
		c-0.8,2.8-2.9,3.6-5.5,4.2c-6.9,1.6-9.3,4.6-9.5,11.8c-0.1,3.6-0.1,7.3-0.1,10.9c0,12.8,0,25.5,0,38.5c2.8,0,5.3,0.4,7.5-0.1
		c1.9-0.5,3.6-2.1,5.3-3.2c0.1,0.1,0.2,0.2,0.2,0.4c-0.6,0.9-1.2,1.9-2.3,3.6c1.8-0.3,2.8-0.5,3.8-0.6l0,0c-0.4-0.6-0.8-1.2-1.2-1.7
		c2.5-1.2,0.2-2.9,0.4-4.4c-3.1-2.3-3.1-2.3-1.4-4.7c0.6,1.4,1.2,2.8,1.9,4.2c2.3-0.1,0-2.1,1.3-2.1c1.7-0.5,3.4-1,5-1.5
		c-1-1.1-1.9-2.1-2.4-2.7c1.5-0.9,2.5-1.4,3.4-2c1.1-0.8,2-1.7,3-2.6v-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0.7-0.9,1.4-1.8,2-2.6
		c0.9,2.7-1.1,2.1-2,2.6c-0.1,0.1-0.2,0.2-0.3,0.4c0,0-0.1,0-0.1,0.1c-0.2,1.3-0.4,2.7-0.6,4c0.9-0.2,1.9-0.5,2.8-0.7
		c-0.1-0.1-0.2-0.3-0.1-0.5l0,0c0-0.3,0-0.6,0-1c0.2-0.2,0.5-0.5,0.7-0.7s0.5-0.5,0.7-0.7c0.9-1.8,1.7-3.5,3-6.1
		c1.7,3.9,3.2,7.4,4.8,11.2c-2.2,1.6-4.4,3.3-7.2,5.4c1.4,0.1,1.8,0.2,2.3,0.2c1.1-0.3,2.2-0.6,3.3-0.9c0.1,0.2,0.2,0.4,0.3,0.6
		c-0.4,0.6-0.9,1.2-1.3,1.7l0,0c0.5,0.7,0.9,1.5,1.4,2.2c0.3,0.6,0.6,1.2,0.9,1.9c-1,0.3-1.9,0.5-2.9,0.8c-0.1-0.2-0.2-0.4-0.3-0.6
		c0.5-0.7,0.9-1.5,1.4-2.2c-0.2-0.4-0.3-0.8-0.5-1.2c-0.9,1.1-1.8,2.3-2.7,3.4c-0.1-0.2-0.3-0.3-0.4-0.5c0.4-1.6,0.8-3.2,1.2-4.8
		c-1.1,0.4-2.2,0.7-3.9,1.3c0.9-2.2,1.4-3.7,2-5.1c-1.4,0-2.7,0-3.9,0c0.4,0.5,1.2,1.2,1,1.4c-1.1,1.9-2.4,3.6-3.5,5.2
		c0.8,0.3,2.3,0.3,2.7,0.9c1.4,2.4,3.6,3.2,6.2,3.5c-3.9,0.5-7.7,0.9-11.3-0.5l0,0c-1.4,0.2-2.7,0.5-4.8,0.8c2.3,0.6,3.8,1,5.2,1.4
		h0.1h0.1c3.6-1.6,7.1-0.5,10.7,0.1c0,0.3,0,0.5,0,0.8c-3.5-0.3-7.1-0.6-10.6-0.9H595c0,0,0,0-0.1,0c-1.1,0.3-2.3,0.6-3,0.8
		c1.5,0.3,3.4,0.7,5.3,1.2l0,0c0.2,0.2,0.7,0.5,0.7,0.6c-0.6,2.8,1.7,5,1.7,7.7c0,0.1,0.1,0.3,0.1,0.4l0,0c-0.1,0.1-0.1,0.1-0.2,0.2
		l0,0c0,0,0.1,0.1,0.2,0.1c-0.1,0.4-0.1,0.7-0.2,1c0.3,0.3,1,0.7,1.8,1.3c0-0.6,0-1.1,0-1.6c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8
		c0.2-0.1,0.5-0.2,0.6-0.2c0-0.2,0-0.4,0-0.6c-0.2-0.7-0.4-1.3-0.6-2c0.2,0,0.5-0.1,0.7-0.1c0.1,0.6,0.1,1.3,0.2,1.9
		c0.1,0.3,0.2,0.6,0.2,0.8c0.2,0.1,0.4,0.2,0.5,0.4s0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8
		c0,0.2,0.5,0.3,0.8,0.6c0.3-0.6,0.6-1.2,1.1-1.5c0-0.7,0-1.3,0-2c0.2,0,0.3,0,0.5,0c0,0.6,0,1.2,0,1.7c0.4-0.2,0.8-0.2,1.4-0.2
		c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3
		s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5c0.1-0.4,0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3
		c0.2-0.2,0.5-0.5,0.7-0.7c0.3-0.3,0.6-0.7,1-0.9h0.1V74V57.1c-0.5,0-1-0.1-1.4-0.4C610.6,56.6,610.4,56.5,610.2,56.6z M589.9,72.1
		L589.9,72.1C589.9,72,589.9,72,589.9,72.1C589.9,72,589.9,72.1,589.9,72.1z M572.8,57.5c0.1,0,0.2,0,0.3,0.1c0.1,0,0.1,0.1,0.2,0.1
		c-0.2,0.2-0.3,0.3-0.4,0.4c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1C572.6,57.6,572.7,57.5,572.8,57.5z M556.5,63.8
		c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0.1,0,0.3,0,0.4,0C556.5,63.6,556.5,63.8,556.5,63.8z M565.9,54.6L565.9,54.6h0.2
		H565.9z M567.7,70.1L567.7,70.1L567.7,70.1L567.7,70.1z M562.6,111c-0.7-0.5-1.5-0.9-2.2-1.4c0.1-0.2,0.3-0.5,0.4-0.7
		c0.7,0.5,1.5,0.9,2.2,1.4C562.9,110.5,562.7,110.8,562.6,111z M568.6,70.8c0.1-0.5,0.1-0.7,0.1-1s-0.2-0.5-0.5-1
		c0.7,0.1,1.2,0.2,1.6,0.3c-0.7,0.6,0.1,0.4,0.5,0.6C569.8,70,569.3,70.3,568.6,70.8z M597.1,126.7c-1,0.1-1.6,0.1-2.9,0.2
		c0.5-1,0.7-1.6,1.2-2.4C596,125.3,596.4,125.9,597.1,126.7z M581.8,145.3c-1,1-2.4,1.7-1.3,3.5c0.1,0.2-0.6,1.2-0.8,1.2
		c-0.6-0.1-1.5-0.4-1.7-0.8c-0.9-2.3-1.6-4.6-2.3-6.8c1.9-0.5,3.4-0.9,5.3-1.5c-1.4,1.3-2.4,2.2-3.4,3.2c0.2,0.2,0.4,0.5,0.6,0.7
		c1.1-0.9,2.2-1.8,3.4-2.7C583,144,583,144,581.8,145.3z M591.6,136.6L591.6,136.6c-0.1,0-0.1,0.1-0.2,0.1h-0.1
		c-0.9,1.2-1.8,2.5-2.7,3.7c0.2-2.9,0.3-2.9,2.7-3.7c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1-0.1s0.1-0.1,0.1-0.2
		C591.6,136.4,591.6,136.5,591.6,136.6z M602.9,133c-0.3-0.1-0.5-0.1-0.8-0.2c-0.2-1.2-0.3-2.4-0.5-3.6c-1.5,0.4-1.5,0.4-1.3,3.9
		c-1.5-0.8-3.8-0.4-4-3.3c-1,3.7-3.7,4.1-6.5,4.4c-0.9,0.1-2.3,0.6-2.6,1.3c-1.1,2.2-2.9,2.4-4.9,2.8c-3.7,0.7-5.6-0.3-7-4.3
		c-0.6-1.6,1.3-4.7,3.8-6c-1.9,2.7-1.9,4.8,1.6,5.5c-0.4,1-0.6,1.8-1.1,3.3c1.8-2,3-3.5,3.6-4.2c1.7,0.2,3,0.7,3.6,0.2
		c1.2-0.9,2.1-2.3,3.2-3.4c-0.6-0.4-1.5-1.3-1.6-1.2c-1.8,1.7-2.6-0.1-3.1-0.5c1.4-3,2.7-5.8,4-8.5c0.1-0.1,0.3-0.3,0.4-0.4
		c-0.1,0.1-0.3,0.3-0.4,0.4c-0.1-0.3-0.3-0.5-0.5-0.8h-0.1c-0.6,0.9-1.3,1.8-1.9,2.8c-0.2-0.1-0.4-0.2-0.6-0.3
		c0-0.8-0.1-1.6-0.1-2.4c-0.3-0.1-0.6-0.2-0.9-0.3c-0.4,1-0.9,2-1.3,3c-0.7,1.7-1.4,3.3-3.8,1.7c0.7-1.5,1.3-2.9,1.9-4.3
		c-0.1,0-0.2-0.1-0.3-0.1c-0.7,0.8-1.3,1.6-2,2.3c-0.2-0.1-0.3-0.2-0.5-0.3c0.2-1,0.5-1.9,0.6-2.4c-1.6-1.3-3-2.5-4.4-3.6
		c0.1-0.2,0.2-0.4,0.3-0.6c0.7,0.2,1.4,0.4,2.1,0.6c0.2,0.1,0.3,0.3,0.5,0.4c-0.2-0.1-0.3-0.3-0.5-0.4c0.3-0.4,0.6-0.8,0.9-1.2
		c-1.3-2,1.5-0.8,1.4-1.8c0.5,0.5,1,1.1,1.6,1.6l0,0c0.1,0.2,0.1,0.4,0.2,0.7c-0.1-0.1-0.3-0.3-0.4-0.4c-0.9,0-1.8-0.1-2.7-0.1
		c-0.2,0.5-0.3,1.1-0.5,1.6c0.3,1.2,0.7,1.6,1.7,0.4c0.3-0.3,1.5,0,2.3,0.1c0,0,0,0,0-0.1c0.4-0.3,0.9-0.7,1-0.7
		c1.7,1.1,3.1,1.9,4.4,2.8c0.4,0.2,0.7,0.6,1,0.8l0,0l0,0l0.1-0.1c0,0,0,0.1,0.1,0.1c0.3,0.1,0.6,0.2,0.9,0.4c1.1,2.1,2.5,4,5.6,3.2
		c-0.9,1.1-1.7,2.1-2.7,3.5c-0.3-1-0.5-1.5-0.7-2.3c-0.7,1.6-1.2,2.8-1.9,4.5c1.2-0.3,1.7-0.4,2.4-0.6c0.2,1.6,0.3,3.1,0.5,4.6
		c1.7-3.2,2.2-3.6,5.4-3.2c0.7,0.1,1.4-0.3,2-0.2c1.3,0.3,2.9,0.4,3.7,1.2C604.2,130,603.2,131.8,602.9,133z M611.7,59.2
		c0.1-0.1,0.3,0,0.4,0c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.3,0.1-0.4,0.2C611.6,59.4,611.6,59.3,611.7,59.2z"
      />
      <path
        class="st3"
        d="M483.1,176.7c0.8-0.9,1.6-1.8,2.3-2.7c-0.2-0.2-0.5-0.4-0.7-0.7c-0.9,0.8-1.7,1.6-2.6,2.4
		C482.4,176,482.7,176.4,483.1,176.7z"
      />
      <path
        class="st3"
        d="M545.2,157.7c0,0.1,0.1,0.1,0.1,0.2c0-0.2,0-0.4,0-0.6C545.3,157.4,545.2,157.6,545.2,157.7z"
      />
      <path
        class="st3"
        d="M559.5,125.4L559.5,125.4c1.1-1.2,2.2-2.3,3.3-3.5c-0.3-0.2-0.5-0.4-0.8-0.6
		C561.2,122.6,560.4,124,559.5,125.4z"
      />
      <path
        class="st3"
        d="M540.1,156.7c-0.1,0.1-0.1,0.1-0.2,0.2c0,0,0,0.1-0.1,0.1C539.9,156.9,540,156.8,540.1,156.7z"
      />
      <path
        class="st3"
        d="M539.9,152.5c0,0.3-0.1,0.6-0.1,0.9c0.2-0.3,0.4-0.5,0.5-0.8C540.2,152.6,540,152.6,539.9,152.5z"
      />
      <path
        class="st3"
        d="M546.4,152c0,0.1-0.1,0.2-0.1,0.3s0.1,0.1,0.1,0.2c0-0.1,0.1-0.2,0.1-0.2C546.5,152.2,546.4,152.1,546.4,152z"
      />
      <path
        class="st3"
        d="M549.8,151.9c0,0.3-0.1,0.6-0.1,1c0.1,0,0.2,0.1,0.3,0.1c0.1-0.3,0.2-0.6,0.3-0.9
		C550.3,152.1,550,152,549.8,151.9z"
      />
      <path
        class="st3"
        d="M542.8,151.9c-0.1,0.1-0.1,0.2-0.2,0.2c0.1,0.2,0.2,0.3,0.2,0.5c0.1-0.1,0.2-0.2,0.2-0.2
		C543,152.2,542.9,152,542.8,151.9z"
      />
      <path
        class="st3"
        d="M558.1,150.2c-0.2,0.1-0.5,0.1-0.7,0.2c0.3,1.4,0.6,2.8,0.9,4.2c0.2,0,0.3-0.1,0.5-0.1
		C558.6,153.1,558.3,151.7,558.1,150.2z"
      />
      <path
        class="st3"
        d="M553.5,151.5c0,0.1,0.1,0.2,0.1,0.4c0-0.2,0.1-0.3,0.1-0.3C553.6,151.5,553.5,151.5,553.5,151.5z"
      />
      <path
        class="st3"
        d="M544.7,152.3l0.1-0.2L544.7,152.3C544.7,152.2,544.7,152.3,544.7,152.3z"
      />
      <path
        class="st3"
        d="M542.5,147.1c1-0.2,1.6-0.4,2.2-0.5C544.1,145.2,544.1,145.2,542.5,147.1z"
      />
      <path
        class="st3"
        d="M561.2,157.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.2-0.1,0.3-0.1
		C561.5,157.5,561.3,157.4,561.2,157.4z"
      />
      <path
        class="st3"
        d="M541.5,145.6c-0.2-0.1-0.4-0.3-0.6-0.2c-0.2,0-0.5,0.2-0.9,0.4c0.5,0.3,0.7,0.5,1,0.6
		C541.2,146.2,541.3,145.9,541.5,145.6z"
      />
      <path
        class="st3"
        d="M474.4,129c0.1,0.2,0.2,0.3,0.3,0.5c0.4-0.2,0.8-0.3,1.2-0.5c-0.1-0.2-0.2-0.4-0.2-0.5
		C475.2,128.7,474.8,128.8,474.4,129z"
      />
      <path
        class="st3"
        d="M473.3,112.2c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1c0.1-0.1,0.2-0.2,0.2-0.3
		C473.5,112.2,473.4,112.1,473.3,112.2z"
      />
      <path
        class="st3"
        d="M523.1,95.2c-0.2-0.2-0.4-0.4-0.6-0.7c-0.2,0.4-0.3,0.7-0.5,1.1C522.4,95.5,522.8,95.3,523.1,95.2z"
      />
      <path
        class="st3"
        d="M524.1,91.4L524.1,91.4C524,91.9,524,91.7,524.1,91.4z"
      />
      <path
        class="st3"
        d="M524.1,91.4L524.1,91.4C523.9,91.8,524,91.6,524.1,91.4z"
      />
      <path
        class="st3"
        d="M506.4,146.5c6.6,0,13.2-0.1,19.8-0.2c1.4,0,2.8-0.3,4.3-0.8c-9-4.5-19-5.6-28.8-8.5c-1.6,2.6-3.7,5.1-2.3,7.6
		C500.6,147.2,503.9,146.5,506.4,146.5z"
      />
      <path
        class="st3"
        d="M494.4,144.5l0.1-0.1C494.5,144.4,494.5,144.4,494.4,144.5c0,0.1,0,0.1-0.1,0.2
		C494.4,144.6,494.4,144.5,494.4,144.5z"
      />
      <path
        class="st3"
        d="M498.9,136.5c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C499.1,136.7,499,136.6,498.9,136.5
		C499.1,136.5,499,136.4,498.9,136.5z"
      />
      <path
        class="st3"
        d="M502,135.6c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.2,0.1-0.2C502.1,135.5,502.1,135.5,502,135.6z"
      />
      <path
        class="st3"
        d="M482.6,165.5c0,0.1-0.1,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0.1c0-0.1,0-0.2,0-0.3S482.7,165.5,482.6,165.5z"
      />
      <path
        class="st3"
        d="M485.8,168.5c-1.2,1-2.3,2-3.5,3c0.2,0.3,0.4,0.5,0.7,0.8c1.2-1,2.3-2,3.5-3.1
		C486.2,169,486,168.7,485.8,168.5z"
      />
      <path
        class="st3"
        d="M487.1,144.2c-0.1,0-0.3,0-0.4,0c-0.1,1.5-0.2,3.1-0.4,4.6c0.3,0,0.5,0,0.8,0
		C487.1,147.3,487.1,145.8,487.1,144.2z"
      />
      <path
        class="st3"
        d="M488.5,146c1.1-1.3,1.8-2.1,2.7-3.2c-1.1-0.7-2-1.2-3.5-2.1C488.1,142.8,488.2,144.1,488.5,146z"
      />
      <path
        class="st3"
        d="M493.7,142.9c0.5,0,1,0,1.5,0v0.1l0,0c0.5-0.6,1-1.2,1.7-2.1c-0.8,0-1.3,0.1-1.8,0.1l0,0
		c-0.4,0.2-0.9,0.4-1.3,0.6c0.2,0,0.5,0,0.7,0l0,0c-0.3,0.3-0.5,0.5-0.8,0.8l0,0l0,0C493.8,142.5,493.8,142.7,493.7,142.9z"
      />
      <path
        class="st3"
        d="M491.5,144.6c-1.6,3-3.2,6-4.8,9C489.7,151.4,491.3,148.4,491.5,144.6z"
      />
      <path
        class="st3"
        d="M558.4,135.8c0,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3
		C558.6,135.9,558.5,135.9,558.4,135.8z"
      />
      <path
        class="st3"
        d="M551.8,144.9c0.3,0,0.5-0.1,0.8-0.1v-0.1c-0.3,0-0.5,0-0.8,0.1C551.8,144.8,551.8,144.9,551.8,144.9z"
      />
      <path
        class="st3"
        d="M548,147.5c3.8,0.9,7.4,1.9,11,0.3C554,145.6,551.2,145.5,548,147.5z"
      />
      <path
        class="st3"
        d="M560.9,131.2c0-0.1,0-0.1,0.1-0.2l0.1-0.1L561,131C560.9,131.1,560.9,131.2,560.9,131.2z"
      />
      <path
        class="st3"
        d="M548.9,142.8c-2.6-0.6-5.2-1.2-7.8-1.9c-0.2,0-0.5,0-0.7,0c-2.8-0.6-5.6-1.1-8.7-1.7c0.4,0.8,0.6,1.2,0.8,1.7
		c0,0,0,0,0.1,0l0.1,0.2l-0.2-0.1l0,0c-2.2-0.6-4.4-1.1-6.7-1.6c-0.8-0.2-1.6-0.2-2.5,0.1C531.5,142.8,540,143.7,548.9,142.8z"
      />
      <path
        class="st3"
        d="M561.5,128.8c0.1,0,0.2,0,0.2,0c0,0.5,0,1,0,1.4c1-1.1,2.1-2.2,3.1-3.4c-0.2-0.2-0.3-0.3-0.5-0.5
		c-0.9,0.8-1.8,1.6-2.6,2.4C561.7,128.8,561.6,128.8,561.5,128.8z"
      />
      <path
        class="st3"
        d="M496.4,61.8c0-0.8,0-1.6,0-2.4C496.2,60.2,496.1,61,496.4,61.8z"
      />
      <path
        class="st3"
        d="M558.8,131.7c0.5-0.6,0.9-1.3,1.4-1.9c-0.7,0.4-1.4,0.7-2.1,1.1C558.3,131.2,558.5,131.4,558.8,131.7z"
      />
      <polygon class="st3" points="507.1,135.5 507.1,135.7 507.3,135.6 	" />
      <path
        class="st3"
        d="M506,136.7c0.3,0.2,0.5,0.3,0.8,0.5c0.1-0.1,0.1-0.2,0.2-0.3C506.6,136.9,506.3,136.8,506,136.7z"
      />
      <path
        class="st3"
        d="M510.1,136.3c0-0.1-0.1-0.2-0.1-0.2c-0.2,0-0.4,0.1-0.6,0.1c0.1,0.1,0.1,0.2,0.2,0.2
		C509.7,136.4,509.9,136.4,510.1,136.3z"
      />
      <path
        class="st3"
        d="M504.5,136.5c0.4,0,0.7,0.1,1.1,0.1c-0.3-0.2-0.6-0.3-0.9-0.5C504.6,136.3,504.6,136.4,504.5,136.5z"
      />
      <polygon class="st3" points="516.9,136.3 517.1,136.4 517.1,136.2 	" />
      <path
        class="st3"
        d="M512.9,136.9c-0.2,0-0.4,0-0.7,0c0,0.1,0,0.2,0,0.2c0.2,0,0.4,0,0.7,0C512.9,137.1,512.9,136.9,512.9,136.9z"
      />
      <path
        class="st3"
        d="M515.5,137.6c-0.1,0-0.2,0-0.3,0c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0,0.2-0.1,0.3-0.1
		C515.6,137.7,515.5,137.6,515.5,137.6z"
      />
      <path
        class="st3"
        d="M383.4,130.4c0,0.4-0.1,0.8-0.1,1.2c0.2,0,0.3,0,0.5,0c0-0.4,0.1-0.8,0.1-1.2
		C383.7,130.4,383.6,130.4,383.4,130.4z"
      />
      <path
        class="st3"
        d="M79.1,295.9c-0.1-0.4-0.1-0.7-0.2-1.2c0.3,0.1,0.6,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0.1c0-0.1,0-0.3,0-0.4
		c-1.6,0.2-3.2,0.4-4.9,0.5c0,0-0.1,0-0.1,0.1C76.3,295.4,77.7,295.7,79.1,295.9z"
      />
      <path
        class="st3"
        d="M93.9,288.3c-1.1,0.2-2.2,0.4-3.3,0.7l0,0c-0.4,0.3-0.9,0.6-1.2,0.9c1,0.4,2,0.7,3.1,0.8l0.1-0.1
		c0.1-0.1,0.2-0.2,0.2-0.3c0.6-0.6,1.5-0.6,2.3-0.8c0.4,0.5,0.6,1,0.4,1.4c3.8,0,7.7-0.9,11.5,0.3c-1.7,0.3-3.4,0.5-5.2,0.7
		c0.4,0.2,0.7,0.5,1.2,1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.1,0,0.1,0.1,0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.2-0.1,0.6-0.3,0.6
		c-0.4,0.1-0.8,0-1.1,0c0,0,0,0-0.1,0c-1,0.6-1.5,1.5-2.3,2.2c-0.3,0.3-0.7,0.5-1.2,0.7c0.1-0.3,0.2-0.6,0.3-0.9
		c0.2-0.5,0.3-1,0.5-1.5c0.3-0.6,0.3-1.2,0.1-1.8c-1.6,0.2-3.3,0.4-4.9,0.6v0.1c-0.1,0.7,0,1.4,0,2.2c0,0.2,0,0.4,0,0.6
		c0.9-0.2,1.6-0.4,2.4-0.7c0,0.2,0,0.4,0,0.6c0,0.4,0,0.7,0,1.1c0.6-0.1,1.1-0.2,1.6-0.3c-0.2,0.7-0.3,1.5-0.6,2.5
		c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7c0,0.3,0.1,0.6,0.1,0.9v0.1c0.1,1.1,0.7,2,2,2.3c1.1,0.3,2.6-0.1,3.4-0.9
		c0.9-1,1.1-2,0.4-3c-0.1-0.2-0.2-0.3-0.4-0.5c0.9-0.9,2.3-0.7,3.4-1.2c0.5-0.6,1.1-1.2,1.3-1.8c0.3-0.8,0-1.6-0.7-2.2
		c-0.3-0.2-0.5-0.4-1-0.8c1,0.1,1.6,0.3,2.2,0.3s0.8-1,1.8-0.7c-0.1,0.4-0.2,0.8-0.3,1.2c0.3,0.3,0.5,0.6,0.9,0.9
		c0.2,0.1,0.5,0.2,0.8,0.1c1.3-0.2,1.3-0.2,1.6,0.7c0,0.1,0.1,0.2,0.2,0.3c0,0,0.1,0.1,0.2,0.2c0,0,0.1,0.1,0.2,0.1l0.1-0.1
		c0.1-0.3,0.3-0.5,0.4-0.8c0.1,0,0.1,0,0.2,0c0.4,0,0.8,0.1,1.3,0.1c0.3-0.3,0.7-0.5,1.1-0.8c0.2,0.1,0.3,0.2,0.4,0.3
		c0.7,1.3,0.7,1.3,2.2,1.2c0.3,0.6,0.6,1.2,0.9,1.9c1-1.1,2.2-0.5,3.2-1c0.3-0.1,0.9-0.1,1.2,0.1c0.2,0.2,0.5,0.3,0.8,0.4
		c0.6-0.4,1.3-0.8,1.9-1.1c0.4-0.2,0.9-0.5,1.3-0.7c-0.1-0.1-0.1-0.2-0.2-0.3c0.8-0.3,1.5-0.7,2.2-0.9c-0.5-0.2-1-0.3-1.4-0.6
		c-0.4-0.3-0.5-0.7-0.9-1.3c0.4,0,0.6,0,0.9,0.1s0.7,0.3,1,0.3c0.2,0,0.5-0.2,0.6-0.3c0.1-0.1,0.1-0.4-0.1-0.5
		c-0.3-0.3-0.6-0.5-0.9-0.7c0.1-0.3,0.2-0.6,0.3-1c-0.3-0.1-0.6-0.2-1.1-0.4c-0.1,0.9-0.7,1.4-1.6,1.2c-1-0.2-1.6,0.3-2.4,0.9
		c-0.5-0.4-1-0.7-1.6-1.1c-0.2,0.1-0.5,0.1-0.8,0.2c-0.2,0-0.3,0.1-0.5,0.1c0-0.3,0-0.4,0-0.6c-0.5,0-1.4,0.5-1-0.6
		c-1,0.8-1,0.8-3.6,0.8c0.3-0.4,0.6-0.8,0.9-1.1c-0.2-0.1-0.4-0.2-0.6-0.3c-0.3-0.2-0.6-0.4-0.9-0.7c0.4-1.2,0.4-1.2,1.8-1.8
		c0-0.3-0.1-0.7-0.2-1c-7.1,0.7-14.2,1.3-21.3,2c-0.1,0-0.1,0.1-0.2,0.1C94.5,288.2,94.2,288.3,93.9,288.3z"
      />
      <path
        class="st3"
        d="M75.6,299.6L75.6,299.6c-0.9,1.7-0.6,3.1,0.4,4.4c0.3,0.5,0.7,0.9,1.2,1.4c0.3,0.3,0.5,0.5,0.8,0.8
		c2.4,0.8,5,0.3,7.5-1.1l0,0c0.9,0.6,1.7,0.9,2.4,0.9c0.6,0,1.2-0.1,1.7-0.4c0.9-0.5,1.4-1.7,1.2-2.5c-0.3-1.1-1.4-1.6-3.5-1.5
		c-0.2-0.1-0.3-0.2-0.4-0.3c-0.3-0.3-0.4-0.6-0.5-0.9c0-0.2,0-0.4,0-0.6s0-0.5,0-0.7s-0.1-0.5-0.2-0.7c-0.1-0.1-0.1-0.2-0.2-0.3
		c-0.6,0.1-1.2,0-1.7-0.3c-3.2,0.3-6.5,0.7-9.7,1l0,0C75,298.9,75.2,299.2,75.6,299.6z"
      />
      <path
        class="st3"
        d="M368.5,204.6c0.1,0.2,0.1,0.3,0.1,0.5c0.2-0.1,0.4-0.1,0.6-0.2C369,204.9,368.7,204.8,368.5,204.6z"
      />
      <path
        class="st3"
        d="M113.6,283.8c0.4,0,0.8,0,1.3,0c0,0,0,0,0-0.1C114.4,283.6,114,283.6,113.6,283.8z"
      />
      <path
        class="st3"
        d="M101.3,276.7c0.1,0,0.1,0,0.2-0.1c0,0,0-0.1-0.1-0.1C101.3,276.6,101.3,276.6,101.3,276.7z"
      />
      <path
        class="st3"
        d="M91.4,291.7c-0.8-0.1-1.6-0.2-2.3-0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.4,0.2,0.9,0.4,1.6,0.4
		C91.1,291.9,91.3,291.8,91.4,291.7z"
      />
      <path
        class="st3"
        d="M367.1,204.5c0.4,0,0.9,0,1.3,0c-0.4-0.2-0.9-0.4-1.3-0.6C367.2,204.1,367.2,204.3,367.1,204.5z"
      />
      <path
        class="st3"
        d="M105.8,283.8c1.6,0,3.1,0,4.7,0c-0.4-0.6-0.9-0.6-2.5-0.4c0.8-0.6,0.6-1.3,0.3-1.7c-0.1,0-0.2,0-0.3,0
		c-0.1,0-0.1,0-0.2,0c-0.7,0.4-1.4,0.9-2,1.3C105.8,283.3,105.8,283.5,105.8,283.8z"
      />
      <path
        class="st3"
        d="M199.3,227.2C199.3,227.2,199.4,227.2,199.3,227.2c-0.4,0-0.8,0.1-1.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		c0.1,0.1,0.2,0.2,0.3,0.3c0,0.2,0,0.3-0.1,0.5c0.4,0,0.8-0.1,1.2-0.1C199.2,227.6,199.3,227.4,199.3,227.2
		C199.3,227.3,199.3,227.3,199.3,227.2L199.3,227.2z"
      />
      <path
        class="st3"
        d="M325.5,216.4c0.2,0,0.3,0,0.5,0.1c-0.2-0.4-0.4-0.9-0.6-1.3l0,0C325.4,215.6,325.4,216,325.5,216.4
		L325.5,216.4z"
      />
      <path
        class="st3"
        d="M171.9,293.6c-0.1-0.3-0.2-0.5-0.4-0.7c-0.7-1-2.3-1.7-4.6-1.8l0,0l0,0c0.1-0.7,0.3-1.5,0.4-2.2
		c0-0.1,0-0.1,0-0.2h0.1c0.9,0,1.7,0,2.6-0.2c0,0,0,0,0.1,0c2.4-0.5,4.1-2.3,4-4.4c-0.1-1.9-1.9-3.4-4.4-3.5c-0.6,0-1.2,0.1-1.8,0.1
		c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-0.8-1.1-1.4-1.4c-2.8,1.8-5.5,3.6-8.3,5.5c-0.1,0-0.2,0-0.3-0.1c-0.1,0-0.1,0-0.2-0.1
		c0.1,0,0.1,0,0.2,0.1c-2,0.8-4,1.5-6,2.3c0,0.6,0.1,1.1,0.1,1.7c0.1,0.1,0.2,0.1,0.3,0.2c0,0-0.1,0.1-0.1,0.2
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.1-0.9-0.2-1.4-0.3c-0.3-0.1-0.6-0.1-0.9-0.1c0,0-0.1,0-0.1,0.1c-1.4,0.9-2.8,1.8-4.1,2.7
		c0,0,0,0,0,0.1c-0.6,2,0.8,3.7,3.1,4c0.4,0,0.8,0,1.5,0.1c-0.8,1.6-1.1,3.1-0.1,4.5s2.5,2,4.5,2.1c-0.3,1.2-0.4,2.4,0.3,3.5
		c1.1,1.6,2.8,2.4,5,2.3c2.1-0.1,3.8-1.1,4.9-2.7c0.2-0.3,0.4-0.6,0.6-0.9c0.1-0.6,0.1-1.2,0.2-1.9c1.8,0,3.6-0.2,4.9-1.5l0,0
		c0.6-0.5,0.9-1.1,1.1-1.8c0.1-0.3,0.2-0.6,0.2-0.9c0-0.1,0-0.2,0-0.4C172,294.2,172,293.9,171.9,293.6z M156.9,289.9
		c-1.1,0-2.2,0.1-3.2,0.1c0-1,0-2,0-2.9c1.1,0.3,2.3,0.6,3.7,0.9C157.2,288.5,157,289.2,156.9,289.9z"
      />
      <path
        class="st3"
        d="M324.6,215.2c0.2,0,0.4,0,0.7,0c0,0,0,0,0-0.1c-0.2-0.2-0.4-0.4-0.6-0.6l0,0c0,0,0,0-0.1,0
		C324.6,214.7,324.6,215,324.6,215.2L324.6,215.2z"
      />
      <path
        class="st3"
        d="M262.3,196.8c-0.5-0.2-0.9-0.5-1.4-0.7l0,0C261.4,196.3,261.9,196.6,262.3,196.8z"
      />
      <path
        class="st3"
        d="M265.1,232.2c1.3-0.2,2.7-0.4,4-0.6C267.2,231.2,265.9,231.4,265.1,232.2z"
      />
      <path
        class="st3"
        d="M255.1,238.3c0.2-0.1,0.3-0.2,0.4-0.4c-0.3,0-0.7,0-1,0c0.1,0.1,0.1,0.2,0.2,0.4
		C254.9,238.3,255.1,238.3,255.1,238.3z"
      />
      <path
        class="st3"
        d="M235.7,252.2c0.1,0.3,0.2,0.6,0.3,0.9c0.1,0,0.1,0,0.2,0c-0.1-0.5,0-0.9,0.1-1.3
		C236.1,251.9,235.9,252,235.7,252.2z"
      />
      <path
        class="st3"
        d="M176.8,266.7c0.1,0,0.2-0.1,0.3-0.1C177,266.6,176.9,266.6,176.8,266.7C176.9,266.7,176.8,266.7,176.8,266.7z"
      />
      <path
        class="st3"
        d="M348.2,226.2c0.2-0.1,0.4-0.3,0.6-0.4c-0.4-0.1-0.7-0.1-1-0.2c0,0.3-0.1,0.5-0.1,0.8
		C347.8,226.3,348,226.3,348.2,226.2z"
      />
      <path
        class="st3"
        d="M181.8,268.1c-0.2-0.5-0.4-1-0.7-1.4c-1,0.7-2,1.3-3,1.9c-1.1,0.5-2.1,1.5-3.2,2.2c0.5,1.1,1.8,1.8,3.3,1.8
		c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3c0.3-0.5,0.3-1.1,0.2-1.8
		C181.9,268.5,181.8,268.3,181.8,268.1z"
      />
      <path
        class="st3"
        d="M181.6,244.9c0.1,1,2,2.4-0.5,3c-0.7,0.1-1.4,0.3-2.1,0.4c-0.1,0-0.2,0.1-0.2,0.1c-1.2,0.2-2.4,0.4-3.6,0.6
		c-0.1,0-0.1,0-0.2,0c-1.2,0.7-2.5,1.2-3.9,1.6l0,0c0.9,0.2,2.1-0.4,2.3,1.1l-0.1,0.1c0.6,0,1.2-0.1,1.8-0.1c0,0.3,0,0.5,0,0.8
		c-1.1,0-2.1,0-3.2,0c0-0.2,0-0.3,0-0.5c-0.2-0.1-0.3-0.2-0.5-0.2c-0.2,0.2-0.3,0.3-0.3,0.5c-0.1,0.4,0.1,0.6,0.5,0.8l0,0
		c0.3,0.1,0.7,0.3,0.7,0.5c0.1,0.5,0.3,0.9,0.7,1.2l0.1,0.1c0.5,0.3,1.1,0.5,1.8,0.6c0.1,0.1,0.1,0.2,0.2,0.3
		c0.3,0.6,0.6,1.2,0.9,1.7c0.2,0.3,0.4,0.7,0.6,1c0.8,1.3,1.2,2.7,1.1,4.1c0,0.5,0,1,0.1,1.5v0.1c0.5-0.3,1-0.6,1.5-0.9
		c0-0.5,0.2-0.9,0.6-1.5c0.2-0.1,0.6-0.3,1-0.5c2.2-0.9,2.7-1.9,2-3.8c0-0.1,0-0.2-0.1-0.4c1.4-0.9,0.6-1.9,0.4-2.9
		c0.6-0.6,1.1-1.1,1.6-1.6c0.4-1,0.6-2,0.2-2.9c-0.6-1.5-0.2-3,0.2-4.6c0-0.1,0-0.1,0.1-0.2c0-0.1,0.1-0.3,0.1-0.4
		c-1.1,0.1-2.2,0.2-3.3,0.2C182,244.9,181.8,244.9,181.6,244.9L181.6,244.9z"
      />
      <path
        class="st3"
        d="M165.1,275.6c-0.9-0.2-1.8-0.1-2.7,0.3c-0.1,0-0.2,0.1-0.3,0.1c-1.5,0.7-2.1,1.7-2.3,2.8
		C161.6,277.7,163.4,276.6,165.1,275.6z"
      />
      <path
        class="st3"
        d="M161.9,275c-0.7,0.5-1.3,0.9-2,1.4c0.7-0.2,1.2-0.5,1.7-1.1C161.8,275.2,161.9,275.1,161.9,275z"
      />
      <path
        class="st3"
        d="M199.7,257.4c2.4,0.9,2.4,0.9,3.4,2c0.3-0.2,0.9-0.5,0.9-0.7c0.1-1.1-0.2-2.1-1.3-2.8c0,0.3,0.1,0.6,0.1,0.9
		c0,0.1-0.3,0.3-0.5,0.5c-0.3-0.5-0.6-1.1-0.9-1.7c-0.3,0.1-0.6,0.2-0.8,0.3c-0.1,0-0.3,0.1-0.4,0.2c-0.3-0.2-0.6-0.5-1-0.9
		c0.7-0.2,1.3-0.7,2-1.4c0.1-0.1,0.2-0.2,0.3-0.4c0.3-0.3,0.3-0.8,0.4-1.1l0,0c0.2-1.4-0.3-2.7-1.3-3.8c-0.1-0.2-0.2-0.3-0.3-0.5
		c-0.4,0.3-0.7,0.6-1.1,0.9c0.1,0.1,0.1,0.2,0.2,0.2c0.7,0.5,1,1.2,1.1,2c0.1,0.9,0,1.1-0.9,1.5c-0.3,0.1-0.6,0.2-0.9,0.2
		c-0.4,0.4-0.9,0.8-1.3,1.2c0,0.1-0.1,0.1-0.1,0.2h-0.2h0.1l0.1-0.1c0.2-0.4,0.4-0.7,0.5-1.1c-1.2,0.1-1.3,0.1-1.8,1.2l0.1,0.1
		c1.1,0.9,2.1,1.2,2.9,1C198.6,256.5,198.8,257.1,199.7,257.4C199.6,257.4,199.7,257.4,199.7,257.4z"
      />
      <path
        class="st3"
        d="M179.7,237.7c0.1,0,0.2,0,0.3-0.1C179.9,237.7,179.8,237.7,179.7,237.7L179.7,237.7z"
      />
      <path
        class="st3"
        d="M127,286.5c1.1-0.9,1.1-1.8,0.8-2.7c-0.4-1.1-0.9-2.2-1-3.4c0-0.1,0-0.1,0-0.1c-0.4,0-0.8,0.1-1.2,0.1
		c0,0.3-0.2,0.6-0.4,1c0.2,0.1,0.4,0.1,0.6,0.2c0.2,0,0.3,0.1,0.5,0.2c0.3,0.6,0.4,1.3,0.5,2.1c0.3,0,0.5,0,0.8,0c0,0.4,0,0.8,0,1.2
		c-0.2,0-0.5,0.1-0.7,0.1C126.9,285.5,127,286,127,286.5z"
      />
      <path
        class="st3"
        d="M106.5,274.7c-0.3,0.3-0.6,0.6-0.9,0.8c0.1,0,0.2,0.1,0.3,0.1c0.2,0.1,0.4,0.2,0.7,0.3c0.1,0,0.2,0.1,0.3,0.1
		c0.1-0.3,0.1-0.6,0.2-1c0.5,0.1,1.1,0.1,1.8,0.2l0.1-0.1c-0.1-0.2-0.2-0.3-0.2-0.5c-0.9-0.1-1.5-0.1-2-0.2c0,0-0.1,0-0.1,0.1
		C106.6,274.7,106.5,274.7,106.5,274.7z"
      />
      <path
        class="st3"
        d="M118,280.8c-0.7,0-1.4,0.1-2.1,0.1c0.1,0,0.1,0.1,0.2,0.1C116.8,281.4,117.4,281.2,118,280.8z"
      />
      <path
        class="st3"
        d="M158,277.7c-1,0.7-2,1.4-3,2.1c-1.4,1.2-2.8,2.5-4.1,3.7c0.5,0,0.9-0.1,1.4-0.1v0.1c1.9-1.2,3.8-2.3,5.6-3.5
		c-0.1,0-0.3-0.1-0.4-0.1c0.1-0.5,0.3-1,0.4-1.6C157.9,278.1,157.9,277.9,158,277.7z"
      />
      <path
        class="st3"
        d="M142.6,260.7v0.1c0.2-0.2,0.4-0.3,0.5-0.5c-0.1-0.1-0.2-0.2-0.4-0.2C142.7,260.4,142.5,260.5,142.6,260.7z"
      />
      <path
        class="st3"
        d="M138.4,259.7c0-0.1,0-0.1,0-0.2c0,0,0,0,0-0.1c0-0.2,0-0.5,0-0.7l0,0c-0.1,0-0.1,0-0.2,0
		C138.2,259.1,138.3,259.4,138.4,259.7z"
      />
      <path
        class="st3"
        d="M241.7,189.9c0,0.1,0,0.2,0,0.3c0.5,0,0.9,0,1.4,0c0-0.1,0-0.2,0-0.3C242.7,189.9,242.2,189.9,241.7,189.9z"
      />
      <path
        class="st3"
        d="M64.6,261.6c2-0.9,4-1.7,6-2.6c-2.2,0.3-4.7,0-6.3,1.9C64.4,261.1,64.5,261.3,64.6,261.6z"
      />
      <path
        class="st3"
        d="M51,264.9c0.1,0.2,0.3,0.3,0.4,0.5c0.3-0.2,0.6-0.3,0.9-0.5c0.1-0.1-0.1-0.4-0.1-0.6
		C51.7,264.5,51.3,264.7,51,264.9z"
      />
      <polygon class="st3" points="87.2,253.6 87.3,253.3 87.1,253.3 	" />
      <path
        class="st3"
        d="M299.6,210.5L299.6,210.5c-0.3-0.2-0.5-0.4-0.8-0.7c-2-1.5-4-2.2-6.5-1.2c-0.8,0.4-1.9,0.2-2.8,0.2
		c-0.1,0-0.1,0-0.2,0.1c-1,0.2-2,0.3-3,0.5c-0.2,0.1-0.4,0.2-0.6,0.2c-0.9,0.5-1.7,0.9-2.6,1.4c0.7,0.3,1.4,0.6,2.9,1.3
		c-1.8,0-2.8,0-3.8,0c0,0,0,0,0,0.1l-0.1-0.1c0.3,1.3,0.6,2.6,0.7,4c0.1,1.5,0,3,0,4.5l0.1-0.1c0,1.3,0,2.5,0,3.8c0,0,0,0-0.1,0
		c-0.4,2.4,0,5.6-1.4,7c-2.8,2.7-4,5.6-4.3,9.2v-0.1l0,0c0.5-0.4,1-0.8,1.5-1.2c0.1,0.1,0.2,0.2,0.3,0.4c-0.6,0.8-1.1,1.6-1.7,2.5
		c-0.1,0.8-0.9,1.5-1.5,2.3c0.2,0,0.4,0.1,0.6,0.1c0.3,0,0.6,0,0.9-0.1c0.4-0.1,0.7-0.3,1-0.5c0.2-0.1,0.4-0.2,0.5-0.4
		c0.2-0.2,0.4-0.4,0.5-0.6c0-0.1,0-0.2,0-0.3c-0.1-0.5,0.1-0.8,0.8-1c0.3-0.1,0.5-0.6,0.8-0.9c0.1-0.2,0.4-0.5,0.5-0.4
		c1,0.3,1.5-0.6,2.4-0.8c0.6,1.2,1.6,0.3,2.6,0.3c0.4-0.8,0.3-1.3-0.5-1.7c-0.8,0-0.3,1.3-1.4,0.9c0.2-0.7,0.3-1.4,0.4-2
		c0.7-0.6,1.4-1.1,2.3-1.8c0.5,0.1,1.2,0.2,2,0.3c1.2,0.3,1.8,0.1,2.3-1c0.1-0.3,0.2-0.7,0.3-1.1c0.2-0.4,0.4-0.7,0.7-1
		c0.1,0,0.3,0,0.4,0.1c0,0.6,0,1.2,0,1.8c0,0.5-0.1,0.9-0.1,1.4v-0.1c-0.2,0.4-0.4,0.8-0.6,1.2c0,0,0,0.1-0.1,0.1h0.1
		c0.4-0.1,0.6-0.1,0.8-0.1c-0.1-0.4-0.2-0.8-0.2-1.2c0.3-0.4,0.6-0.9,1-1.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.3,0.2,0.5,0.2,0.7l0,0
		c-0.2,0.1-0.2,0.3,0.1,0.3c-0.1,0.5-0.2,0.9-0.3,1.3c-0.3,0.1-0.6,0.1-0.9,0.2c0.1,0.2,0.1,0.4,0.2,0.6l0,0l0,0l0,0c0,0,0,0,0,0.1
		c0,0,0,0,0.1,0c0.3,0.5,0.4,1.2,1,1.5c1.4,0.6,0.9,1.6,0.7,2.5c-1.1,0.4-2,0.3-2.9,0.1c-1.8-0.3-3.3,0.2-4.6,1.5l-0.1,0.1
		c-0.4,0.5-0.7,0.9-0.9,1.4c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1
		c0.1,0.1,0.2,0.1,0.3,0.2c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1,0.4,2,0.3,2.7-0.1c-0.1,0-0.3,0-0.4,0c-2.6,0-2.6-0.1-3.9-2.4
		c1.7,1,3.5,1.4,5.3,1.6c0.1-0.1,0.2-0.2,0.3-0.4c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.8,0.4-1.2c-0.9,0.2-1.8,0.4-2.7,0.6l-0.1,0.1
		l0.2-0.1c1.1-0.8,2.3-1.3,3.5-1.6l0,0c0.5-0.9,0.6-1.8,0.2-2.7c-0.1,0-0.3,0-0.4,0c0-0.1,0-0.2,0-0.4c0.1,0,0.2,0,0.3,0
		c-0.1-0.2,0-0.5,0.1-0.9c0.3,0.4,0.6,0.7,0.9,0.9c0.7,0,1.3,0,2,0c0,0.1,0,0.2,0,0.4c-0.5,0-1,0-1.5,0c1,0.8,2,1,4.1,1
		c-0.2,0.3-0.4,0.6-0.6,0.8c0.5-0.1,1-0.2,1.5-0.3c0.1,0.3,0.1,0.5,0.2,0.8c-0.7,0.2-1.5,0.3-2.2,0.5c-0.1,0.2-0.3,0.5-0.3,0.7
		c0,0.1,0,0.2-0.1,0.3c-0.2,1,0.1,2,0.6,2.8c1.6,0.1,3.1,0.3,4.6,1c0,0.3,0,0.7,0.1,1c0.7,0,1.4-0.2,2-0.4v0.1
		c0.2,0.1,0.5,0.1,0.7,0.1l0,0c0-0.2,0-0.4,0-0.6c0.3,0,0.7,0.1,1,0.1c0,0.1,0,0.2-0.1,0.2c0.6-0.4,1-1,0.8-1.6
		c-0.2-0.7-1-1.1-1.7-1c-0.1,0-0.2,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.2v-0.6h-0.1c0-0.1,0.1-0.2,0.1-0.3v-2.6V246v-0.4v-0.7
		c0.1-0.1,0.3-0.1,0.4-0.2c0.1-0.1,0.3-0.2,0.4-0.3c0.2-0.1,0.3-0.3,0.4-0.4c0.1-0.2,0.2-0.3,0.3-0.5c0,0,0,0,0-0.1
		c0.1-0.4,0.2-0.7,0.1-1.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.3-0.5-0.6-0.7l-0.1-0.1l-0.1-0.1c-0.1,0-0.1-0.1-0.2-0.1h-0.1
		c0,0,0,0,0-0.1c-0.1,0-0.2-0.1-0.3-0.1v-0.2c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.4-0.1,0.7-0.2,1.1c0.1,0,0.3,0,0.5-0.1v0.4v1.5v0.8
		c-0.9-0.1-1.8-0.3-2.6-0.4c-0.1,0-0.2,0-0.3,0c0.3-0.5,0.5-0.9,0.7-1.3c0.2-0.4,0.3-0.7,0.4-1.1l-0.1-0.1l0.1-0.1
		c0.1-0.5,0-0.9-0.1-1.3c-0.2-0.5-0.6-1-1.2-1.4c0,0,0,0-0.1,0c-0.4-0.3-1-0.6-1.6-1c-1.3-0.1-2.2,0.9-3.3,0.4
		c-0.8,1.2-0.8,1.2-2.1,1c0-0.2,0-0.4,0.1-0.6c0.6-0.8,0-1.4-0.5-1.9c-0.3-0.3-0.9-0.4-1.4-0.6c0-0.1,0-0.2-0.1-0.3l0,0l0,0
		c0.1-0.1,0.1-0.1,0.1-0.2c0.7-1.1,0.2-2.2-0.1-3.3c0.3-0.3,0.6-0.6,1-0.8c0.3-0.2,0.6-0.3,0.8-0.2c0.3,0,0.6,0.2,0.8,0.5
		c0.1,0.2,0.2,0.3,0.3,0.5c0.3,0.4,0.5,0.8,0.8,1.2c-0.1,0.2-0.4,0.5-0.4,0.8c0,0.2,0.5,0.3,0.8,0.6c0.6-1.2,1.3-2.2,3.1-1.9
		c-0.4,0.3-0.9,0.5-1.1,0.8c-0.2,0.5,0.3,1.1,1.1,1.5c0.3-0.3,0.7-0.6,1-0.9c0.2,0.1,0.5,0.2,0.8,0.3c0.1-0.2,0.3-0.2,0.3-0.3
		s0-0.1,0-0.2c0-0.2,0.1-0.4,0-0.6c-0.4-0.6-0.4-1.1-0.3-1.5s0.4-0.8,0.7-1.1c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.2,0.5-0.5,0.7-0.7
		c0.3-0.3,0.6-0.7,1-0.9c0.1,0,0.2,0,0.3,0v1.6c0.1,0.1,0.3,0.2,0.5,0.3s0.3,0.1,0.5,0.1c0.1,0,0.3,0,0.4,0
		c-0.1-1.6-0.2-3.1-0.7-4.5c-1.7-5.1-4.3-9.9-6.6-14.9c0.1-0.1,0.2-0.3,0.4-0.4c-0.1,0.1-0.2,0.3-0.4,0.4
		C300.1,210.9,299.8,210.7,299.6,210.5z M292.5,244.3c-0.6-0.2-1.2-0.3-1.7-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0.6,0.1,1.1,0.3,1.7,0.4
		C292.6,243.8,292.5,244,292.5,244.3z M304.1,244.1c0.3,0.1,0.5,0.3,0.8,0.4c-0.2,0.2-0.5,0.4-0.7,0.5c-0.3,0.2-0.5,0.4-0.8,0.5
		c0,0-0.2-0.2-0.3-0.4c0.3-0.1,0.6-0.2,0.9-0.3C304,244.6,304,244.4,304.1,244.1c-0.9,0.1-1.8,0-2.7,0c0-0.2,0.1-0.5,0.1-0.7
		C302.4,243.6,303.3,243.9,304.1,244.1z M301.7,240.7c0.3,0.1,0.5,0.4,0.7,0.6c-0.4,0-0.8,0-1.5,0
		C301.4,240.9,301.6,240.7,301.7,240.7z M297,241.4c0.3,0,0.5,0.3,0.7,0.4c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2-0.1-0.4-0.2-0.6-0.3
		C296.7,241.6,296.9,241.4,297,241.4z M294.5,237.5c0.1,0.2,0.1,0.4,0.2,0.5c-0.1,0-0.1,0-0.2,0.1c-0.1-0.2-0.1-0.4-0.2-0.5
		C294.3,237.6,294.4,237.6,294.5,237.5z M289.3,216c-0.4,0.2-0.9,0.5-1.3,0.7l0,0c-0.1,0.3-0.3,0.6-0.4,0.9
		c-0.1-0.1-0.4-0.3-0.4-0.3c0.1-0.3,0.3-0.5,0.5-0.8c0.4-0.3,0.9-0.6,1.3-0.9c1.4-0.5,2.7-1,4.1-1.6c1.3-0.5,2.6-1.1,3.9-1.7l0,0
		c0.9,0,1.7,0,2.6,0c0.1,0.3,0.1,0.5,0.2,0.8C296.5,214.8,292.8,215.1,289.3,216z"
      />
      <polygon class="st3" points="93.3,251.3 93.3,251.3 93.2,251.4 	" />
      <path
        class="st3"
        d="M83.4,251.9c0.1,0,0.1,0,0.1-0.1C83.5,251.8,83.5,251.9,83.4,251.9L83.4,251.9z"
      />
      <path
        class="st3"
        d="M46.2,266.5c0.6,0.1,1.1,0.3,1.7,0.4c0.1-0.4,0.3-0.8,0.6-1.5c-0.9,0.3-1.6,0.5-2.3,0.7
		C46.2,266.1,46.2,266.3,46.2,266.5z"
      />
      <path
        class="st3"
        d="M287.7,216.5c0,0,0.1,0.1,0.2,0.2C287.8,216.7,287.7,216.5,287.7,216.5z"
      />
      <path
        class="st3"
        d="M68.3,256.7c0.2-0.2,0.5-0.4,0.7-0.6c-0.4-0.1-0.7-0.2-1.1-0.3C68,256.1,68.1,256.4,68.3,256.7z"
      />
      <path
        class="st3"
        d="M72.1,239.7v0.1c0.1-0.1,0.1-0.1,0.2-0.2C72.2,239.7,72.1,239.7,72.1,239.7z"
      />
      <path
        class="st3"
        d="M32.3,194.9c-0.2-0.1-0.3-0.1-0.5-0.2c0.1,0.2,0.1,0.3,0.2,0.5C32,195.1,32.1,195,32.3,194.9z"
      />
      <path
        class="st3"
        d="M13,274.2c0.1,0.1,0.2,0.2,0.3,0.2c0,0,0.1-0.1,0.1-0.2c-0.1,0-0.2-0.1-0.2-0.1
		C13.2,274.2,13.1,274.2,13,274.2z"
      />
      <path
        class="st3"
        d="M66.5,244.7l-0.1,0.1c0.1-0.1,0.2-0.1,0.3-0.2C66.6,244.7,66.5,244.6,66.5,244.7z"
      />
      <path
        class="st3"
        d="M12.6,275.6c0,0,0,0.1,0,0.2c0.3,0,0.6,0,0.8-0.1c0-0.1,0-0.1,0-0.2C13.2,275.6,12.9,275.6,12.6,275.6z"
      />
      <path
        class="st3"
        d="M429.3,204.2c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0.1-0.3,0.2-0.5,0.2c0.1,0,0.2,0.2,0.3,0.1
		C429,204.4,429.1,204.3,429.3,204.2z"
      />
      <path
        class="st3"
        d="M33,271.1c0.2-0.4,0.3-0.8,0.5-1.2c-0.6-0.2-1.1-0.4-1.7-0.6C31.2,270.5,31.6,271.1,33,271.1z"
      />
      <path
        class="st3"
        d="M276.5,242.1c0.1-0.1,0.3-0.2,0.5-0.1c0.1-0.4,0.1-0.8,0.2-1.2l0,0C276.9,241.1,276.7,241.6,276.5,242.1z"
      />
      <path
        class="st3"
        d="M308.1,223.2h-0.3c0,0.2,0.1,0.4,0.1,0.6C308,223.6,308,223.4,308.1,223.2z"
      />
      <path
        class="st3"
        d="M289.3,201.2c0,0.1,0.1,0.3,0.1,0.5h0.2h0.2l0,0C289.6,201.5,289.5,201.3,289.3,201.2z"
      />
      <path
        class="st3"
        d="M289.8,201.7l0.1,0.1C289.9,201.7,289.8,201.7,289.8,201.7L289.8,201.7z"
      />
      <path
        class="st3"
        d="M308.5,225.7c0,0.1,0,0.2,0.1,0.3c0.1,0,0.2-0.1,0.2-0.1c0-0.1,0-0.2-0.1-0.3
		C308.7,225.7,308.6,225.7,308.5,225.7z"
      />
      <path
        class="st3"
        d="M136.4,236.2c0.2,0.2,0.4,0.4,0.6,0.5c0.3-0.5,0.7-0.9,1-1.4c-0.2-0.1-0.3-0.2-0.5-0.4
		C137.1,235.4,136.7,235.8,136.4,236.2z"
      />
      <path
        class="st3"
        d="M327,228.3c-1.4,0.2-2.9,0.4-4.3,0.6c-0.1,0.1-0.2,0.3-0.3,0.4c-0.5,0.9,0.1,1.8,1.2,1.7c0.1,0,0.1,0,0.2,0
		c0.6-0.1,1.2-0.2,1.8-0.4c0.3-0.1,0.5-0.1,0.8-0.2c0.2,0,0.4-0.1,0.6-0.1c0,0.1,0,0.1,0,0.2c0.1,0.4,0.1,0.9,0.3,1.2
		c1.5,0.1,2.9,0.2,4.4,0.3c0,0.3,0,0.7,0,1l0,0c0.3,0,0.5,0.1,0.7,0.1c0.4,0,0.8-0.1,1.1-0.3c-0.2-0.4-0.3-0.7-0.4-1.1
		C331.5,227.6,331.5,227.6,327,228.3z"
      />
      <path
        class="st3"
        d="M300.1,251.3c0.4,0.4,0.8,0.7,1.4,0.9c0.1,0,0.1,0,0.2-0.1c0-0.2,0-0.5,0-0.7
		C301.1,251.4,300.6,251.3,300.1,251.3z"
      />
      <path
        class="st3"
        d="M140.3,234.5c0.1-0.1-0.1-0.4-0.1-0.6c-0.2,0.1-0.4,0.2-0.5,0.4c-0.1,0.1,0.1,0.3,0.1,0.5
		C140,234.7,140.2,234.7,140.3,234.5z"
      />
      <path
        class="st3"
        d="M290,201.8c0,0.2,0.1,0.3,0.1,0.5c0.2,0,0.4-0.1,0.6-0.1C290.5,202.1,290.2,202,290,201.8z"
      />
      <path
        class="st3"
        d="M102.8,248.6c0.1,0.1,0.2,0.2,0.2,0.4c0.4-0.2,0.8-0.4,1.1-0.7c-0.1-0.2-0.3-0.3-0.4-0.5
		C103.4,248.1,103.1,248.3,102.8,248.6z"
      />
      <path
        class="st3"
        d="M95.4,250.9c0.2,0.2,0.4,0.3,0.7,0.5c0.3-0.5,0.6-1,0.8-1.5c-0.1-0.1-0.3-0.2-0.4-0.3
		C96.1,250,95.7,250.4,95.4,250.9z"
      />
      <path
        class="st3"
        d="M90.3,253.2c0.1,0,0.2,0,0.3-0.1c0,0,0-0.1,0.1-0.2c-0.1,0-0.2-0.1-0.3-0.1C90.4,253,90.4,253.1,90.3,253.2z"
      />
      <path
        class="st3"
        d="M124.6,241.5c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0.1-0.2,0.1-0.3s-0.1-0.1-0.2-0.2
		C124.6,241.3,124.6,241.4,124.6,241.5z"
      />
      <path
        class="st3"
        d="M298.4,206.7L298.4,206.7c-0.3-0.3-0.5-0.5-0.7-0.7C297.9,206.2,298.2,206.5,298.4,206.7L298.4,206.7z"
      />
      <path
        class="st3"
        d="M328.3,233.7c0.2,0.3,0.5,0.5,0.9,0.6c0.2,0,0.3,0,0.5,0c0.6,0,1-0.3,1.4-0.8c0.1-0.1,0.2-0.1,0.3-0.2
		C330.3,233.4,329.3,233.5,328.3,233.7z"
      />
      <path
        class="st3"
        d="M273.1,203.8L273.1,203.8c0.2-0.1,0.3-0.2,0.4-0.4C273.3,203.4,273.2,203.6,273.1,203.8z"
      />
      <path
        class="st3"
        d="M203.6,141.9c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.3,0.3
		C203.4,142.1,203.5,142,203.6,141.9z"
      />
      <path
        class="st3"
        d="M190.6,149.8c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.2,0.1,0.3,0.1C190.6,150,190.6,149.9,190.6,149.8z"
      />
      <path class="st3" d="M198.6,225.1l0.1,0.1L198.6,225.1z" />
      <path
        class="st3"
        d="M212.1,126.8c0.9-1.5,1.5-2.5,2.2-3.7c-0.9,0.3-1.9,0.6-2.8,0.8C211.6,124.8,211.8,125.6,212.1,126.8z"
      />
      <path
        class="st3"
        d="M193,150.5c-0.1-0.1-0.2-0.2-0.3-0.3c0,0-0.1,0.1-0.2,0.2c0.1,0.1,0.1,0.1,0.2,0.2
		C192.9,150.6,193,150.6,193,150.5z"
      />
      <path
        class="st3"
        d="M191.9,146.2c0.2,0,0.4,0.1,0.6,0c0.1,0,0.2-0.2,0.1-0.3c-0.1-0.1-0.4-0.3-0.4-0.3
		C192.1,145.9,192,146.1,191.9,146.2z"
      />
      <polygon class="st3" points="208.8,143.4 208.9,143.6 209,143.4 	" />
      <path
        class="st3"
        d="M194.6,146.1c-0.3,0.3-0.5,0.7-0.7,1.1c0.2,0.1,0.5,0.2,0.7,0.3c0.2-0.4,0.4-0.9,0.6-1.3
		C195,146.2,194.7,146,194.6,146.1z"
      />
      <path
        class="st3"
        d="M195.9,151.2c0.4,0,0.8,0,1.3,0c0-0.1,0-0.1,0-0.2c-0.4,0-0.9,0-1.3,0C195.8,151.1,195.8,151.2,195.9,151.2z"
      />
      <path
        class="st3"
        d="M188,146.8c0.8,0,1.6,0,2.3,0c0-0.2,0-0.5,0-0.7c-0.8-0.1-1.5-0.2-2.3-0.3C188.1,146.2,188.1,146.5,188,146.8z
		"
      />
      <path
        class="st3"
        d="M183.5,148.1c0.2,1.1,0.3,1.5,0.3,1.9c2.3-0.2,3.2-1.4,2.3-4.2c-2.3,1.7-4.4,3.4-6.5,5l0,0
		c0,1.4,0,2.8-0.1,4.3C180.7,153,181.9,150.8,183.5,148.1z"
      />
      <path
        class="st3"
        d="M179.5,150.8c-0.2,0-0.5,0-0.7-0.1l0,0C179,150.8,179.2,150.8,179.5,150.8z"
      />
      <path
        class="st3"
        d="M546.5,204.5c-0.8-0.1-1.6-0.3-2.4-0.4c-0.1,0-0.2,0-0.3,0c-0.1,0.1-0.2,0.1-0.3,0.2c-0.2,0.5,0.6,1.5,1.1,1.4
		c0.9-0.3,1.5,0.1,2.1,0.5c0.4,0,0.9,0.1,1.3,0.1C547.8,205.4,547.5,204.8,546.5,204.5z"
      />
      <path
        class="st3"
        d="M541,205.4l0.1-0.1c-0.1-0.3-0.1-0.7-0.2-1.1c0.1-0.1,0.3-0.2,0.5-0.3c-0.7,0-1.4,0-2.1,0
		c0.1,0.2,0.2,0.3,0.2,0.5C539.6,205.1,540,205.2,541,205.4z"
      />
      <path
        class="st3"
        d="M168.9,162.6c0,0,0.3-0.2,0.7-0.5c0.3-1.9,0.7-3.8,1.1-6.2c-0.8,0.9-1.3,1.5-1.9,2.1l0,0
		C168.9,159.6,168.9,161.3,168.9,162.6z"
      />
      <path
        class="st3"
        d="M178.6,150.9c-0.6,0.8-1.2,1.6-1.7,2.4c0.3,0.2,0.6,0.3,0.9,0.5C178.1,152.8,178.4,151.8,178.6,150.9z"
      />
      <path
        class="st3"
        d="M166.8,166.5c0-2.5,0-5.1,0-7.6c-0.1,0-0.3,0-0.4,0c0,2.6,0,5.1,0,7.7C166.5,166.6,166.6,166.6,166.8,166.5z"
      />
      <path
        class="st3"
        d="M173,155.2c-0.2-0.1-0.3-0.1-0.5-0.2c-1,2.4-1.9,4.8-2.9,7.1c0,0,0,0,0.1,0c-0.3,1.5-0.6,3-1,4.5
		c0.2,0.1,0.5,0.2,0.7,0.2C170.6,163,171.8,159.1,173,155.2z"
      />
      <path
        class="st3"
        d="M253.7,148.1c-1.5,0.4-2.4,0.6-3.7,0.9C251.9,151.3,252.5,149.9,253.7,148.1z"
      />
      <path
        class="st3"
        d="M246.4,154.9c-1.3,0-2.6,0-3.6,0c0.8,0.1,2.2,0.3,3.5,0.5C246.3,155.2,246.3,155,246.4,154.9z"
      />
      <polygon class="st3" points="242.6,157 242.9,156.8 242.6,156.7 	" />
      <path
        class="st3"
        d="M234.5,165.5c-0.3,0-0.6,0-0.9-0.1c0,1.9,0,3.9,0,5.8c0.2,0,0.4,0,0.6,0c-0.1-1-0.2-1.9-0.2-2.9
		C234,167.4,234.3,166.4,234.5,165.5z"
      />
      <path
        class="st3"
        d="M234.3,161.8c-0.3-0.1-0.9-0.2-0.9-0.2c-0.2,0.4-0.2,0.9-0.3,1.3c0.2,0.1,0.5,0.2,0.7,0.3
		C233.9,162.7,234.1,162.2,234.3,161.8z"
      />
      <path
        class="st3"
        d="M248.7,155.2c0,0-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1
		C248.9,155.4,248.8,155.3,248.7,155.2z"
      />
      <path
        class="st3"
        d="M248.6,146.3c0.2,0,0.4,0,0.5,0c0-0.5-0.1-1-0.1-1.5c-0.1,0-0.3,0-0.4,0C248.6,145.3,248.6,145.8,248.6,146.3z
		"
      />
      <path
        class="st3"
        d="M249.6,147.8c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C249.5,147.7,249.6,147.8,249.6,147.8z"
      />
      <path
        class="st3"
        d="M183.1,160.1c1.1-0.1,2-0.3,3.5-0.5c-0.3-3-0.6-5.8-1-9.2c-2.3,2-3.2,4.8-6.2,4.7c-0.2,0.9-0.5,1.8-0.7,2.7
		c0,0,0,0,0.1,0l-0.1,0.1l0,0c-0.5,0.2-1,0.3-1.5,0.5c-0.2-1.2-0.5-2.2-0.7-3.2c-1.2,3.4-2.3,6.8-3.5,10.3c-0.4-0.1-0.8-0.3-1.2-0.4
		c1.3-3.5,2.6-7.1,3.9-10.6l0,0c-0.2-0.4-0.3-0.8-0.5-1.2c-0.3,0-0.5-0.1-0.8-0.1c-1.3,4.7-2.5,9.4-4,14.8c4.6-0.9,8.3-1.7,12.1-2.4
		C182.9,163.6,183,162,183.1,160.1z M177,163.4c-0.1,0.3-0.2,0.6-0.3,0.9c0,0-0.1,0-0.1,0.1c-0.1,0.3-0.1,0.6-0.2,0.8
		c-0.1-0.1-0.3-0.2-0.4-0.3c0.2-0.2,0.4-0.3,0.6-0.5v-0.1C176.8,164,176.9,163.7,177,163.4c0.5-1.4,1.1-2.8,1.6-4.3l0,0
		c0.1-0.4,0.1-0.7,0.2-1.1c0-0.1,0-0.1,0-0.2l0.1-0.1c0,0.1,0,0.2,0,0.3c0,0.4,0.1,0.9,0.1,1.3C178.3,160.8,177.7,162.1,177,163.4z"
      />
      <path
        class="st3"
        d="M220.6,130.3L220.6,130.3c0,0.1-0.1,0.2-0.1,0.2C220.5,130.4,220.6,130.4,220.6,130.3L220.6,130.3z"
      />
      <path
        class="st3"
        d="M212.8,120.5c-0.9-0.3-1.7-0.6-3.1-1c0.7,1.8,1.2,3.1,1.7,4.4C211.9,122.7,212.4,121.6,212.8,120.5z"
      />
      <path
        class="st3"
        d="M221.3,125.7c0,1,0,2.1,0,3.1c0.4,0.2,0.7,0.4,1.1,0.6C223.4,127.5,223.4,127.5,221.3,125.7z"
      />
      <path
        class="st3"
        d="M212.9,120.4c0.2-0.8,0.4-1.5,0.7-2.3c-0.4,0-0.7,0-1.1-0.1C212.6,118.8,212.7,119.6,212.9,120.4z"
      />
      <polygon class="st3" points="219.3,156.3 219.2,156.5 219.2,156.5 	" />
      <path
        class="st3"
        d="M220.5,153.3c0.6-0.3,1.2-0.6,1.9-0.9c-0.1-0.2-0.2-0.3-0.3-0.5c-0.6,0.3-1.2,0.5-1.9,0.8
		C220.3,152.8,220.4,153,220.5,153.3z"
      />
      <path
        class="st3"
        d="M206,170.4c0-3,0-5.9,0-8.9c-0.2,0-0.4,0-0.6,0c0.2,2.9,0.3,5.9,0.5,8.8C205.9,170.3,205.9,170.3,206,170.4z"
      />
      <polygon class="st3" points="211,141.6 211.2,141.5 211,141.3 	" />
      <path
        class="st3"
        d="M185,143c-0.2-0.1-0.4-0.2-0.5-0.2c-0.2,0.1-0.3,0.3-0.4,0.5c0.2,0.1,0.4,0.2,0.6,0.2
		C184.9,143.4,185,143.1,185,143z"
      />
      <path
        class="st3"
        d="M222.7,228.6c-0.1,0.1-0.3,0.2-0.5,0.2c0.1,0.1,0.2,0.2,0.3,0.3C222.5,228.9,222.6,228.8,222.7,228.6
		C222.7,228.7,222.7,228.7,222.7,228.6L222.7,228.6z"
      />
      <polygon class="st3" points="198.9,133.4 199,133.6 199.1,133.5 	" />
      <path
        class="st3"
        d="M224.1,227.9c0-0.2,0-0.4,0.1-0.6c0,0,0,0-0.1,0c-0.2,0.2-0.4,0.4-0.6,0.6c0,0,0,0,0,0.1
		C223.6,227.9,223.9,227.9,224.1,227.9L224.1,227.9z"
      />
      <path
        class="st3"
        d="M51.6,163.7c0-0.3,0-0.6-0.1-0.8c-0.9,0-1.9,0-2.8,0.1c-2.1,0.3-4.2,0.8-6.3,1.2c-0.2,0.8-0.8,1.5-1.6,1.9
		c-0.3,0.2-0.5,0.3-0.7,0.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.9,0,1.9,0.2,2.8,0.4c0.5,0.1,1.3,0.8,1.4,0.7c2.9-2.6,6.3-1,9.4-1.3
		c0.9-0.1,1.8-0.2,2.7-0.3c-0.2-1.2-0.8-1.9-2.5-1.8c-0.6,0-1.2,0.1-1.9,0.1C51.7,164.2,51.6,164,51.6,163.7z"
      />
      <path
        class="st3"
        d="M48.8,161.6c0.7,0,1.4,0,2.1,0c-0.3-0.4-0.7-0.8-1.2-1.1c-1.2-0.9-2.7-0.5-4,0c-1,0.3-1.8,0.8-2.3,1.5
		C45.1,161.8,46.9,161.6,48.8,161.6z"
      />
      <path
        class="st3"
        d="M228.6,223.2c-0.2,0.2-0.5,0.5-0.7,0.7c-0.1,0.6-0.2,1.3-0.3,1.9l0,0c0.2,0,0.5,0,0.7,0
		c0.7-0.9,1.4-1.9,2.1-2.8c0,0,0,0,0.1-0.1c0-0.4,0-0.9,0-1.7C229.7,222,229.1,222.6,228.6,223.2z"
      />
      <path
        class="st3"
        d="M178.9,130L178.9,130c-0.1,0.9-0.7,1.4-1.5,1.9c-0.3,0.2-0.5,0.3-0.8,0.5c0,0.2,0.1,0.3,0.1,0.5
		c3.2-0.6,6.3,0.7,7,2.6c0.3,0.8,0,1.8,0,2.8c-0.8-0.4-1.3-0.7-1.8-0.9c-0.3,2.3-0.6,4.4-1,6.6c2.4-1.2,3.4-3.3,3.7-6.1
		c1.3,0,2.4,0,4.1,0c-0.2-1.4-0.4-3.1-0.6-4.9c1.9,1,2.2,1.4,2,3.1c-0.1,1.3-0.3,2.5-0.5,3.8c0.4-0.1,0.8-0.3,1.2-0.4l0,0
		c-1.3-2.1,0.7-2,2.1-3.5c0,2.2,0,3.5,0,4.9h0.1l0,0c0.9,1.1,1.8,1.6,2.8,0c0,0,0,0,0.1,0c-0.3-1.7,0.5-3.4,2-4.1
		c-1,0.1-2.1,0.1-3.6,0.2c1.6-2.1,3-4.1,4.5-6.1c-1.2-0.3-2.1-0.5-3.5-0.9c0.6-1.5,1.1-2.9,1.7-4.6c-0.1,0-0.2-0.1-0.3-0.1
		c-1-0.5-2-0.1-2.5,0.9c-0.2,0.4-0.3,0.9-0.5,1.3s-0.6,0.9-1,1.4c0.2,0.3,0.3,0.5,0.4,0.7c-0.2,0.1-0.4,0.2-0.6,0.3
		c0-0.3,0.1-0.6,0.1-1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.4-1.6-0.4-1.8,1.2-5.9c0,0,0,0-0.1,0c-0.4,0.3-0.7,0.4-0.8,0.6
		c-0.2,0.5-0.2,1-0.4,1.5s-0.6,1-0.9,1.7c-0.3-0.5-0.5-0.8-0.8-1.2c-0.6,1.5-0.7,2.8,0,4c-0.2,0.2-0.4,0.5-0.7,0.6
		c-0.4,0.3-0.8,0.5-1.2,0.6c-0.8,0.2-1.3-0.1-1.8-1.1c-0.2-0.4-0.4-0.7-0.6-1.1c-0.1-0.1-0.2-0.3-0.2-0.4c-0.1,0-0.2-0.1-0.2-0.1
		c0.1,2.4-1.3,3.5-3.1,3.9C181.4,131.4,180.1,130.7,178.9,130z M194.6,132.1c-0.5,1.4-0.9,2.6-1.5,4
		C190.8,133.2,190.9,132.9,194.6,132.1z"
      />
      <path
        class="st3"
        d="M138.4,101.5c-0.1-0.2-0.3-0.6-0.4-1c-0.1,0-0.2,0-0.3,0c0,0.2-0.2,0.6-0.1,0.7c1,0.5,0.8,1.4,0.8,2.2
		c-1.5,0.7-2.9,0.1-4.4,0.4c0.8,0.3,1.6,0.5,2.3,0.7c0.1,0.8,0.2,1.6,0.3,2.4c-0.4,0.2-0.8,0.2-1.1-0.3c-0.3-0.7-0.9-1-1.9-0.8
		c-0.6,0.8,0,1.4,0.5,2.1c-0.3,0.3-0.6,0.6-1,1c0.3,0.3,0.5,0.6,0.9,1c1.2-1.1,1.4-1.2,2.6-0.7c1.7,0.6,1.7,0.6,3.5,0.2
		c0.3,0.7,0.6,1.3,0.9,2.1c0.5,0,1.2,0.1,2.1,0.2c-0.5,0.4-0.8,0.6-1.3,1c0.8,0,1.6-0.5,1.8,0.3c-0.2,0.2-0.3,0.5-0.5,0.7
		c0.1,0,0.1,0.1,0.2,0.1c0.3-0.2,0.7-0.5,1.1-0.8c0.9,0.3,1.8,0.6,2.7,0.9c0.2,0.1,0.3,0.4,0.3,0.5c-0.1,0.2-0.4,0.4-0.6,0.5
		c-0.2,0-0.4-0.1-0.7-0.2c-0.6,1.2,0.9,1.8,0.9,2.9c-0.8,0.2-1.2,1.4-2.5,1c0.5-0.6,1-1.1,1.5-1.7c-0.8-0.5-1.4-1.1-2.4-1
		c-0.1,0.5-0.2,1-0.4,1.6c0,0.1,0,0.1,0,0.2c-0.2-0.3-0.3-0.6-0.4-0.9c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.2-0.1-0.6-0.2-1.1
		c-0.6,0.3-1.1,0.6-1.7,0.9c-0.4-0.4-0.7-0.8-1-1.1c-0.2-0.1-0.4-0.1-0.6-0.2c-0.4-0.1-0.8-0.3-1.2-0.4c0.2-0.4,0.5-0.8,0.5-1.2
		c0-0.4-0.2-0.8-1-0.9c-0.2,0-0.4-0.3-0.7-0.6c-0.1-0.1-0.2-0.3-0.3-0.4c-0.2,0.2-0.6,0.4-0.7,0.7c-0.1,0.2,0.1,0.6,0.2,0.6
		c0.5,0.1,0.6,0.3,0.6,0.6c0,0.3-0.1,0.7,0.1,0.9c0.1,0.1-0.4,0.7-0.6,1.1c-0.1-0.1-0.2-0.1-0.3-0.1c-0.8-0.3-1.4,0-2,0.8
		c0.4,0.2,0.7,0.3,1.1,0.5c0.6,0.3,1.2,0.5,1.8,0.8c0,0.3,0,0.6,0.1,0.9c0.2,1.5,1.2,1.9,3.5,1.7l0.1,0.1c0.3,0.3,0.5,0.5,0.7,0.8
		c1.2,0,1-1.5,2.3-1.4c0.1,0,0.1,0,0.2,0c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.2-0.2,0.3-0.2,0.5c-0.5,1.1-0.5,2.1,1.3,2.6
		c-0.5,0.8-1,1.5-1.5,2.2c0.4,0.5,1.1,0.6,1.7,0.4c0.2,0,0.3-0.1,0.5-0.2c0.6-0.2,1.2-0.4,1.8-0.7c0,0,0,0,0.1,0
		c-0.1-0.1-0.2-0.1-0.3-0.2c0.3-1.2,0.2-3.1,0.9-3.5c1.4-0.8,2.9,0.1,3.5,1.8c0,0.1,0,0.2,0.1,0.3c-0.2,0.1-0.3,0.3-0.5,0.4
		c0.2-0.1,0.3-0.3,0.5-0.4c0.1,0.2,0.2,0.5,0.3,0.7c-0.2-0.1-0.5-0.2-0.7-0.3c-0.9-0.1-1.7-0.2-2.6-0.3c-0.1,0-0.1,0-0.2-0.1
		c0.1,0,0.1,0,0.2,0.1c1.4,1.7,1.7,3.5,0.8,4.9c0.4,0.2,1,0.3,1.9,0.3c-0.7,0.3-1.1,0.7-1.4,1.1c1,0.8,1.1,2,0,3.4
		c-0.1,0.1-0.2,0.3-0.2,0.5c0.3,0,0.5,0,0.8,0.1c0.4-0.4,0.8-0.7,1.2-1.1c0.2,0.2,0.3,0.4,0.5,0.6c0.1-0.4,0.2-0.9,0.3-1.4
		c0.1,0,0.2,0,0.3,0c0.8,0,1.6,0.1,2.6,0.1c-0.3,0.5-0.5,0.9-0.7,1.2c0.2-0.1,0.3-0.1,0.5-0.2l0,0c0.1-0.1,0.3-0.1,0.4-0.2
		c-0.1,0.2-0.2,0.4-0.3,0.4c-0.1,0.1-0.2,0.1-0.4,0c-0.1,0-0.2,0-0.2-0.1c-0.2,0.1-0.4,0.3-0.6,0.4c-0.3,0.3-0.5,0.6-0.6,1
		c0,0,0,0.1-0.1,0.1c0.3,0.3,0.6,0.7,0.8,1c1.7-1.6,3.7-2.6,4.3-4.9c0-0.2,0.5-0.2,1.1-0.2l-0.1-0.1c0.4,0,0.7,0,1.1,0
		c0,0,0,0,0-0.1c1.1-0.2,2.2-0.3,3.5-0.5c-0.1,1.4-0.1,2.3-0.2,3.1c0.8-0.6,1.5-1.2,2.3-1.8v-0.1l0,0c-1.8-1.6-3.7-3.2-5.9-5.2
		c0.4-1.2,0.5-3-2.8-2.9c0,0.9,0,1.7,0,2.5c-0.2,0.1-0.4,0.1-0.6,0.2c-0.6-1.2-1.2-2.3-1.9-3.5c-0.5,0.7-1.1,1.5-1.6,2.2
		c-0.3-0.1-0.5-0.2-0.8-0.3c1.3-1.6-2.4-3.3,0.1-5.2c0.5,0.7,0.9,1.1,1.2,1.6l0,0c0.2-0.3,0.4-0.5,0.6-0.8c1.1-0.2,2.3-0.4,3.4-0.6
		c0,0.3,0,0.6,0,0.9c-1,0.1-2,0.1-3,0.2c-0.1-0.1-0.3-0.3-0.4-0.4c0.1,0.1,0.3,0.3,0.4,0.4c-0.2,0.2-0.5,0.4-0.7,0.7
		c0.2,0.4,0.4,0.8,0.6,1.2c1.4-0.4,2.8-0.7,3.6-1c0.6-1.6,1-2.9,1.6-4.2h-0.1c-0.2,0.1-0.3,0.2-0.4,0.4c-0.5,0.5-1.1,1.1-2.2,0.4
		c0.5-0.6,1-1.3,1.6-2c-0.1-0.2-0.2-0.6-0.3-0.9c-0.1-0.7-0.3-1.2-1.5-1.1c-0.4,0.1-0.9-0.3-1.4-0.6c0.2-0.6,0.4-1.1,0.6-1.5
		c-0.7-0.5-1,0.3-1.5,0.4l0,0c0,0.1,0,0.3,0,0.4c-0.1-0.1-0.2-0.2-0.3-0.3l0,0c-0.5-0.3-0.9-0.6-1.4-0.9c-0.2,0.1-0.4,0.1-0.6,0.2
		c-0.5,0.1-0.9,0.3-1.5,0.4c0-0.8,0-1.5-0.1-2.2c-0.2-0.9-1.1-0.9-2-0.9c0.6-0.8,0.7-1.6,0.5-2.4c-0.7-0.6-1.3-0.1-2,0
		c-0.2-0.2-0.4-0.5-0.6-0.7c-1.5,0.3-2.4-0.1-3.2-1.2c-0.5-0.7-1.5-1.1-2.4-1.6c-0.1,0.5-0.2,1-0.3,1.5
		C140,102.3,139.3,101.9,138.4,101.5z M151.5,129.3L151.5,129.3h0.1H151.5z M151.9,126.9c-0.1,0.1-0.1,0.2-0.2,0.2
		c0-0.1,0-0.2,0-0.3C151.7,126.9,151.8,126.9,151.9,126.9z"
      />
      <path
        class="st3"
        d="M114.4,124.3c0,0.3,0.1,0.6,0.1,0.8c0,0.4,0.1,0.8,0.1,1.2c-1.8,0.2-2.2,0.2-2.6,1.2c-0.1,0.3-0.3,0.6-0.4,1.1
		c0,0.1,0.1,0.2,0.1,0.2c0.7,1.1,2,1.3,3.4,1.2c0,0.2,0,0.4,0,0.6c0,1.5-0.1,3-0.1,4.5c0.5,0.6,1,1.2,1.4,1.8c0-0.1,0-0.1-0.1-0.2
		c-0.2-1.9-0.4-3.9-0.6-5.9c0-0.2,0-0.4-0.1-0.6c0.9,0.1,1.7,0.1,2.4-0.3c0.2-0.1,0.4-0.3,0.5-0.4c0.3-0.4,0.6-1,0.7-1.4
		c0-0.5-0.1-0.9-0.5-1.2c-0.6-0.5-1.6-0.6-3.2-0.5c-0.2-0.3-0.2-0.7-0.3-1.1C115.2,125,115,124.6,114.4,124.3z"
      />
      <path
        class="st3"
        d="M176.9,241c0,0.1-0.1,0.2-0.1,0.3l0.1-0.1C177,241.2,176.9,241.1,176.9,241z"
      />
      <path
        class="st3"
        d="M178.8,240c0.4,0,0.8-0.1,1.3-0.1c0-0.2,0-0.4,0.1-0.6l0,0C179.7,239.5,179.3,239.7,178.8,240L178.8,240z"
      />
      <path
        class="st3"
        d="M178.6,240.4c0,0.1,0.1,0.2,0.2,0.2c0-0.2,0-0.5,0-0.7l0,0C178.7,240.1,178.6,240.3,178.6,240.4z"
      />
      <path
        class="st3"
        d="M60,310.1c-0.9,0.2-1.9,0.5-2.8,0.7c-0.7,0.2-1.5,0.4-2.2,0.7c-1,0.3-2,0.6-3,0.9c-0.9,0.9-1.2,2.2-0.6,3.2
		c0.6,1.1,2.2,1.8,3.7,1.6c1-0.1,1.9-0.7,2.5-1.3c0.3-0.4,0.6-0.7,0.7-1.2c0.1-0.2,0.1-0.5,0.2-0.7c0.1-0.4,0.1-0.8,0.2-1.2
		c-0.2,0-0.5,0.1-0.5,0.1c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1-0.2-0.2-0.4-0.3-0.6h0.1c0.5-0.2,0.9-0.3,1.3-0.5c0.8-0.3,1.4-0.8,1.7-1.4
		C60.5,309.9,60.2,309.9,60,310.1L60,310.1z"
      />
      <path
        class="st3"
        d="M57.1,310.7L57.1,310.7c0.9-0.2,1.8-0.4,2.7-0.6c-2.2-0.3-4.4-0.6-6.6-0.8c0,0.1,0,0.2,0,0.3l0,0
		c0,0.6,0.1,1.1,0.1,1.7c-0.4,0.3-0.8,0.5-1.1,0.8c-0.1,0-0.1,0.1-0.1,0.1c1-0.3,1.9-0.6,2.9-0.8v0.1v-0.1
		C55.7,311.1,56.4,310.9,57.1,310.7z"
      />
      <path class="st3" d="M210.8,217.9l-0.1,0.2l0,0L210.8,217.9z" />
      <path
        class="st3"
        d="M209.7,219.1c-1.8,1.5-3.6,3-5.4,4.6l0,0l0,0c0.9-0.3,1.8-0.6,2.6-0.9C207.9,221.5,208.8,220.3,209.7,219.1z"
      />
      <path
        class="st3"
        d="M200.5,133.3c0-0.1-0.1-0.2-0.1-0.3c-0.1,0-0.2,0.1-0.2,0.1c0,0.1,0.1,0.2,0.1,0.3
		C200.4,133.4,200.5,133.3,200.5,133.3z"
      />
      <path
        class="st3"
        d="M192.3,168.5L192.3,168.5c0.3,0.7,0.5,1.8,0.9,1.9c3.3,0.5,6.7,0.7,10.6,1.1c0-3.5,0-6.6,0-9.7
		c-6.1,0-12.4,0-18.7,0c0,0.3,0,0.6-0.1,0.9c5.7,0.4,11.5,0,16.9,1.9c-3,0.4-6.2-1.2-8.9,1.2l0,0c-0.4-0.4-0.8-1.2-1.3-1.2
		c-2.3-0.1-4.6-0.1-7.3-0.1c0.1,1.6,0.1,2.9,0.2,4.2c0.2,0,0.5,0.1,0.7,0.1c0.4-0.7,0.9-1.5,1.3-2.2c0.2,0,0.5,0,0.7,0l0,0
		c-0.3,0-0.5,0-0.8,0c0.2-0.2,0.5-0.5,0.7-0.7c0,0,0,0,0.1-0.1c0,0,0,0,0,0.1c0,0.2,0,0.5,0,0.7c0.2-0.2,0.4-0.5,0.6-0.7
		c0,0,0,0,0.1-0.1c0.4-0.2,0.8-0.4,1.9-1c-1,1.7-1.6,2.7-2.3,3.8c0.2,0.2,0.3,0.4,0.5,0.6c1.4-0.9,2.7-1.8,4.1-2.7l0,0
		c0,0.5,0,0.9,0,1.4c0.4,0,0.9-0.1,1.3-0.1c1.4-0.5,2.8-1,4.2-1.6c0.1,0.3,0.2,0.6,0.3,0.9c-1.4,0.3-2.9,0.6-4.3,0.9
		C193.2,168.1,192.8,168.3,192.3,168.5z"
      />
      <path
        class="st3"
        d="M192.2,168.5c0-0.2,0-0.3,0-0.5c-0.1,0.1-0.1,0.2-0.2,0.3C192.1,168.3,192.2,168.4,192.2,168.5z"
      />
      <path
        class="st3"
        d="M547.6,206.3c0.2,0,0.3,0,0.5,0c0,0,0,0,0-0.1C547.9,206.3,547.7,206.3,547.6,206.3z"
      />
      <path
        class="st3"
        d="M192.4,157.8c3.2-0.8,5.6-2.8,7.5-5.4c-1.8,0.9-3.7,1.8-5.5,2.7l0,0c0.3-0.5,0.5-1,1.2-2.2
		c-2.8,0.4-5.2,0.7-7.6,1c0,0.3,0,0.7,0,1c1.3,0.5,2.5,1.1,3.8,1.6l0,0c0.4,0,0.9-0.1,1.3-0.1l0,0
		C192.8,156.9,192.6,157.3,192.4,157.8z"
      />
      <path
        class="st3"
        d="M545.1,202.7c-0.1-0.1-0.2-0.3-0.2-0.4c-0.3,0.1-0.5,0.2-0.7,0.3C544.5,202.6,544.8,202.6,545.1,202.7z"
      />
      <path
        class="st3"
        d="M542.5,202c-0.1,0.1-0.2,0.3-0.3,0.5c0.5,0,1,0.1,1.5,0.1C543.4,202.3,543.4,201.7,542.5,202z"
      />
      <path
        class="st3"
        d="M201.8,159.4c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1,0,0.2-0.1C202,159.5,201.9,159.4,201.8,159.4z"
      />
      <path
        class="st3"
        d="M203.6,146.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1,0.1-0.1,0.2-0.2,0.3C203.2,146.4,203.4,146.5,203.6,146.5z"
      />
      <path
        class="st3"
        d="M201.3,135.7c0.7,0.8,1.4,1.5,2.2,2.3c0.1-0.1,0.3-0.2,0.4-0.4c-0.7-0.8-1.5-1.5-2.2-2.3
		C201.5,135.5,201.4,135.6,201.3,135.7z"
      />
      <path
        class="st3"
        d="M200.7,139.8c0,0.3,0.1,0.6,0.1,0.9c0.1,0,0.2-0.1,0.3-0.1C201,140.3,200.9,140.1,200.7,139.8z"
      />
      <path
        class="st3"
        d="M203.4,144.3c1,0.2,2,0.3,3,0.5c0-0.3,0.1-0.6,0.1-0.9c-1,0-2.1,0-3.1,0C203.5,144,203.5,144.1,203.4,144.3z"
      />
      <path
        class="st3"
        d="M250.6,153.5c0,0.1-0.1,0.2-0.1,0.2c0,0.1,0.1,0.1,0.1,0.2C250.6,153.8,250.6,153.7,250.6,153.5z"
      />
      <path
        class="st3"
        d="M207.6,141.1c0,0-0.1-0.4-0.2-0.6c-0.3,0.1-0.6,0.2-0.9,0.3c0.1,0.3,0.2,0.5,0.2,0.6
		C207,141.3,207.3,141.3,207.6,141.1z"
      />
      <path
        class="st3"
        d="M488.2,120.8c0.6-0.2,1.5-0.1,2.1,0.2c1.7,0.9,3.2,0.3,3.7-1.1c0.3-0.8-1.1-2.1-2-3.6c-0.9,1.3-1.3,2-1.8,2.8
		c-2.5-2.4-2.5-2.4-5-1.1C485.4,119.8,485.2,121.9,488.2,120.8z"
      />
      <path
        class="st3"
        d="M190.1,198.3c0,0-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1,0,0.2-0.1,0.3-0.1
		C190.3,198.5,190.2,198.4,190.1,198.3z"
      />
      <path
        class="st3"
        d="M189.2,194c-1.5-0.2-3-0.4-4.5-0.6c0,0.2-0.1,0.5-0.1,0.7c1.5,0.2,3,0.3,4.5,0.5
		C189.1,194.4,189.1,194.2,189.2,194z"
      />
      <polygon class="st3" points="184.3,191.4 184.4,191.6 184.6,191.5 	" />
      <path
        class="st3"
        d="M477.1,213.5c0,0.2,0.1,0.4,0.1,0.6c-1.1,0.1-2.3,0.2-3.4,0.2c0-0.2-0.1-0.3-0.1-0.5c0.8-0.2,1.5-0.3,2.3-0.5
		h-0.1c-0.6,0-1.2,0.1-1.8,0.1c0.2-1,0.6-2.1,0.5-3c-0.1-0.6-1-1.2-1.7-1.6c-1.3-0.8-2.7-0.9-4.2-0.2c-0.1,0-0.2,0.1-0.3,0.1
		c-1.8,0.9-2.4,2.1-2.3,3.5c0,0.4,0,0.7,0.1,1.1c-0.9-0.3-1.7-0.5-2.5-0.7c0.1-0.5,0.3-1,0.4-1.6s0.3-1.1,0.4-1.7
		c1.4-0.1,2.6-0.5,3.5-1.4c0.3-0.4,0.6-0.7,0.7-1.1c0.2-0.6,0.2-1.2,0.1-1.8c0.1,0,0.1,0,0.2,0c0-0.1,0-0.2-0.1-0.3
		c0.5,0,0.9,0,1.4,0c1.1-0.2,2.1-0.5,3.1-0.8c1.3-0.4,2-1.3,2.3-2.4c0,0,0,0,0-0.1c-3.8-0.2-7.6-0.4-11.4-0.7c0,0.7,0.1,1.4,0.1,2.2
		c-1.3,0.5-2.5,1.3-3,2.8l-0.1-0.1v0.1c-0.4,0.1-0.7,0.1-1.1,0.2c0-0.2,0-0.4,0-0.6c0.2,0,0.5,0,0.7,0c-0.2-0.2-0.4-0.5-0.6-0.7
		c-0.1,0-0.3-0.1-0.4,0c-1.7,0.6-2.9,0.4-3.8-0.7c-0.1-0.2-0.2-0.4-0.4-0.5c-1.2-1.3-3.4-1.5-5.1-0.5c-1.6,1-2.1,2.8-1.1,4.2
		c0.2,0.3,0.5,0.5,0.8,0.8c-0.4,1.4-1,2.9-0.7,4.4c0.1,0.4,0.2,0.7,0.4,1.1c-1.3,0.7-2.3,1.5-2.2,2.8h0.1c0.7,0.1,1.5,0.3,2,0
		c1.5-0.9,2.7-0.4,3.8,0.3c1.5-0.1,3-0.3,4.6-0.4c0,0.2,0,0.3,0,0.5c1.8-0.2,3.1,0.3,4.2,1.7c0.9,1.1,2.3,2.8,3.7,1.3
		c1.8-2.1,3.7-1.6,5.8-1.5c2.2,0.1,4.6,1.6,6.4-1.1c0.1-0.2,1.1,0,1.6,0.2h0.1c0-0.1,0-0.3,0-0.4C480.2,215.2,478.9,214,477.1,213.5
		z M465.9,204.7c0.2,0.1,0.4,0.2,0.6,0.2c-0.1,0.1-0.2,0.2-0.2,0.2c-0.2,0-0.4-0.1-0.6-0.2C465.8,204.9,465.9,204.8,465.9,204.7z
M453.3,206.2c0.8,0,1.7,0,2.5,0c0,0.1,0,0.2,0,0.4c-0.8,0-1.7,0-2.5,0C453.3,206.4,453.3,206.3,453.3,206.2z M451.7,206.2
		c0.1,0.1,0.2,0.2,0.2,0.3c-0.1,0.2-0.3,0.5-0.4,0.7c-0.1-0.1-0.3-0.2-0.5-0.4C451.2,206.6,451.4,206.4,451.7,206.2z M450.1,210.7
		c2.3-1.5,4.5-2.9,7-0.6C454.8,210.4,452.5,210.5,450.1,210.7z M459.1,208.8l-0.1-0.1c-0.2,0-0.5-0.1-0.7-0.1
		c0.1-0.1,0.1-0.2,0.2-0.3c0.2,0.1,0.4,0.3,0.6,0.4C459,208.7,459.1,208.7,459.1,208.8c0.1,0,0.2,0,0.3,0c1.1,0,2.3,0,3.4,0
		c-0.1,0.3-0.1,0.7-0.2,1c-1.1-0.3-2.1-0.7-3.2-1C459.2,208.8,459.1,208.8,459.1,208.8z M466.7,214.5c-1.6,0-3.3,0-4.9,0
		c0-0.4,0-0.7,0-1.1c1.7,0.1,3.3,0.2,5,0.3C466.7,213.9,466.7,214.2,466.7,214.5z M470.7,208.7c0-0.1-0.1-0.3-0.1-0.4
		c0.1,0,0.1,0,0.2,0c0,0.1,0.1,0.1,0.1,0.2C470.9,208.6,470.8,208.7,470.7,208.7z"
      />
      <path
        class="st3"
        d="M180.8,202.7c0.6,0.1,1.2,0.2,2,0.4c-0.6-0.7-1-1-1.3-1.4C181.3,202,181.1,202.4,180.8,202.7z"
      />
      <path
        class="st3"
        d="M181.6,201.7c1.2,0.2,2.4,0.5,3.7,0.7l0,0c0.6-0.1,1.4-0.5,1.6-0.3c2.1,1.8,3.5,0.6,5.4-1.3
		c-1.4-0.2-2.3-0.3-3.1-0.4c-1.1-0.1-2.3,0.4-2.7-1.5c-0.1-0.6-2.6-0.6-4.1-0.9C182,199.5,181.8,200.6,181.6,201.7z"
      />
      <path
        class="st3"
        d="M190.8,208.9c-0.2-0.3-0.4-0.6-0.6-1c-0.7,0.6-1.4,1.2-2,1.8c0.1,0.2,0.2,0.4,0.4,0.6
		C189.2,209.8,190,209.3,190.8,208.9z"
      />
      <path
        class="st3"
        d="M185.8,207.4c0.3,0.2,0.6,0.5,0.8,0.7c0.7-0.7,1.3-1.3,2-2c-0.4-0.3-0.7-0.6-1.1-0.9
		C186.9,205.9,186.4,206.7,185.8,207.4z"
      />
      <path
        class="st3"
        d="M27.9,179.6c0-0.1,0-0.3,0.1-0.4c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1c-0.2,0.3-0.4,0.7-0.6,1
		c0.2,0.1,0.4,0.2,0.5,0.3l0,0l0,0c0.1,0,0.1,0.1,0.2,0.1C27.8,180.3,27.8,180,27.9,179.6z"
      />
      <path
        class="st3"
        d="M190.1,206.1c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.2,0,0.2,0C190,206.2,190.1,206.2,190.1,206.1z"
      />
      <path
        class="st3"
        d="M452.9,223.9c0.1,0,0.1-0.1,0.2-0.1c0.1,0.2,0.3,0.4,0.4,0.5c0.5,0.2,1,0.4,1.6,0.5c0.4,0,0.8,0,1.4,0.1
		c-0.8-0.6-1.6-1.3-2.4-1.9l0,0c-0.7,0-1.3-0.1-2-0.1C452.3,223.3,452.6,223.6,452.9,223.9z"
      />
      <path
        class="st3"
        d="M456.5,201.1c0.1,1.2,1.4,2.1,2.9,2.2c1.6,0.1,3-0.8,3.5-2.2c0-0.1,0.1-0.2,0.1-0.4c-2.2-0.1-4.3-0.3-6.5-0.4
		C456.5,200.6,456.4,200.9,456.5,201.1z"
      />
      <path
        class="st3"
        d="M458.6,218.4c0.4-0.1,0.9-0.2,1.5-0.3c-0.6-0.2-1-0.4-1.6-0.6C458.5,217.8,458.5,218.1,458.6,218.4
		L458.6,218.4z"
      />
      <path
        class="st3"
        d="M456,218.1c0.8,0.5,1.3,0.6,2.5,0.4c-0.4-0.1-0.9-0.2-1.3-0.3C456.8,218,456.4,218,456,218.1z"
      />
      <path
        class="st3"
        d="M452.4,220c-0.2,0.3-0.3,0.6-0.4,0.9v0.1c0.7,0.7,1.4,1.3,2.1,2c1.8-0.1,3.7-0.2,5.8-0.3c0-0.7,0-1.5,0-2.2
		c-0.5-0.3-1.1-0.1-2,0.6c-0.6,0.5-2.1,0.2-3.1,0C453.9,220.8,453.2,220.4,452.4,220z"
      />
      <path
        class="st3"
        d="M457.8,226c-0.4-0.4-0.9-0.7-1.3-1.1c-0.4,0.8-0.7,1.7-0.7,2.5c1.3,0.3,2.6,0.8,3.9,1.2
		C459.1,227.8,458.6,226.8,457.8,226z"
      />
      <path
        class="st3"
        d="M169.5,196.7c0.1,0.7,0.1,1.1,0.1,1.5c0.2,0,0.4,0.1,0.6,0.1c-0.1,0.1-0.1,0.2-0.2,0.3
		c-0.1-0.2-0.2-0.3-0.4-0.5c-0.6-0.1-1.3-0.2-1.9-0.3c2.3,2,2.8,2.2,5.2,1.7c-0.4-0.1-0.7-0.1-1.1-0.2c0-0.1,0-0.2,0-0.4
		c0.4-0.1,0.8-0.1,1.1-0.2C171.9,198.2,170.8,197.5,169.5,196.7z"
      />
      <path
        class="st3"
        d="M432.5,223.7c-0.1,0.2-0.2,0.4-0.3,0.6c0.8,0.2,1.7,0.5,2.5,0.7v-0.1c-0.3-0.3-0.6-0.5-0.9-0.7
		c0.1-0.3,0.2-0.6,0.3-0.9c0,0,0,0-0.1-0.1c-0.3-0.1-0.6-0.2-1-0.4c-0.1,0.1-0.1,0.2-0.2,0.3C432.7,223.4,432.6,223.6,432.5,223.7z"
      />
      <path
        class="st3"
        d="M413.6,211.6c0.1,0,0.2,0,0.3,0c-0.1,0-0.1-0.1-0.2-0.1C413.7,211.5,413.6,211.6,413.6,211.6z"
      />
      <path
        class="st3"
        d="M166.2,195.2c-1.6-0.5-3.2-1.1-4.7-1.6c-0.1,0.2-0.2,0.4-0.2,0.6c1.5,0.6,3.1,1.2,4.6,1.8
		C166,195.7,166.1,195.5,166.2,195.2z"
      />
      <path
        class="st3"
        d="M162.6,196.5c0.1,0,0.2,0,0.3-0.1c0-0.1,0-0.2-0.1-0.2s-0.2,0-0.3,0.1C162.6,196.4,162.6,196.5,162.6,196.5z"
      />
      <path
        class="st3"
        d="M165.7,197.1c-0.2,0-0.4,0-0.6,0.1c0.1,0,0.2,0.1,0.3,0.1C165.5,197.3,165.6,197.2,165.7,197.1z"
      />
      <path
        class="st3"
        d="M411.3,208.4c-0.3,0-0.7,0.1-1,0.1c0.1,0.1,0.3,0.2,0.4,0.3C410.9,208.6,411.1,208.5,411.3,208.4z"
      />
      <path
        class="st3"
        d="M179.9,191.4c0,0.1,0.1,0.2,0.1,0.3c0.4-0.2,0.8-0.3,1.3-0.5C180.8,191.3,180.4,191.4,179.9,191.4z"
      />
      <path
        class="st3"
        d="M413.1,208.8c0-0.2,0.1-0.4,0.1-0.6c-0.5,0.1-0.9,0.1-1.4,0.2c0.1,0,0.1,0.1,0.2,0.1c0.2,0.1,0.4,0.2,0.7,0.3
		C412.9,208.7,413,208.7,413.1,208.8z"
      />
      <path
        class="st3"
        d="M175.2,199.3c-1.1-0.2-1.6-0.3-2-0.3c0,0.2,0,0.4,0,0.6C173.6,199.5,174,199.5,175.2,199.3z"
      />
      <path
        class="st3"
        d="M23.6,180.7L23.6,180.7c-0.2-0.4-0.2-0.7-0.4-1c-0.1,0.3-0.2,0.6-0.3,0.9C23.1,180.6,23.3,180.7,23.6,180.7z"
      />
      <path
        class="st3"
        d="M457.7,198.5c-0.2,0.1-0.3,0.3-0.5,0.4c0.5,0,1-0.1,1.6-0.1c0-0.1,0-0.2,0-0.3
		C458.4,198.5,458.1,198.5,457.7,198.5z"
      />
      <path
        class="st3"
        d="M27.3,181.2c0-0.2,0-0.4,0.1-0.7l0,0c-0.2-0.1-0.4-0.2-0.5-0.3c-0.1,0.1-0.2,0.2-0.2,0.4
		c-0.1,0.2-0.2,0.3-0.2,0.4C26.7,181.1,27,181.2,27.3,181.2L27.3,181.2z"
      />
      <path class="st3" d="M311.7,199l0.1-0.1l0,0L311.7,199z" />
      <path
        class="st3"
        d="M461.6,229.8c0,0.1,0,0.2,0,0.2h0.1C461.7,229.9,461.7,229.9,461.6,229.8z"
      />
      <polygon class="st3" points="176.8,213.5 176.7,213.3 176.5,213.4 	" />
      <path
        class="st3"
        d="M466.8,222.9c-1.2-0.4-2.4-0.8-3.5-1.2c-0.1,0.3-0.1,0.6-0.2,0.9c-0.1,0-0.2,0-0.3,0v0.1
		c1.3,0.3,2.6,0.6,3.9,0.9C466.6,223.4,466.7,223.1,466.8,222.9z"
      />
      <path
        class="st3"
        d="M479.1,218.7c0.2,0.1,0.4,0.1,0.7,0.2c0.1-0.2,0.2-0.4,0.3-0.6c-0.3,0-0.6,0-0.9,0
		C479.1,218.3,479.1,218.5,479.1,218.7z"
      />
      <path
        class="st3"
        d="M178,200.6c-0.7-0.3-1.1-0.4-1.5-0.6c0.2,0.3,0.3,0.6,0.5,0.9C177.1,200.9,177.4,200.7,178,200.6z"
      />
      <path
        class="st3"
        d="M171.2,205.6c-0.2,0-0.4-0.1-0.6-0.1c0,0-0.1,0.1-0.1,0.2c0.2,0,0.4,0.1,0.6,0.1
		C171.1,205.8,171.1,205.7,171.2,205.6z"
      />
      <path
        class="st3"
        d="M173.6,206.4c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3,0.1-0.5,0.1c0.1,0.2,0.1,0.4,0.3,0.5
		C173.2,206.5,173.4,206.4,173.6,206.4z"
      />
      <path
        class="st3"
        d="M182.4,208.9C182.4,208.9,182.3,208.9,182.4,208.9c-0.4-0.3-0.7-0.7-1.1-0.9c-0.1-0.1-0.5,0.4-0.7,0.6
		c0.4,0.3,0.8,0.6,1.2,0.9l0,0c-1,1-2,2-3,3c0,0.2,0,0.4,0,0.5c1.4-0.4,2.8-0.9,4.3-1.3C182.8,210.8,182.6,209.8,182.4,208.9z"
      />
      <path
        class="st3"
        d="M174.5,208.9c-1.4,0.3-2.7,0.5-4.1,0.8c-0.1,0.4-0.2,0.8-0.4,1.1c1,0.7,2.1,1.5,3.1,2.2l0,0
		c0.2-0.9,0.5-1.9,0.7-2.8l0,0l0,0c-0.6,0.4-1.2,0.9-2.1,1.5c0.8-1.9,0.8-1.9,2.1-1.5l0,0C174.1,209.8,174.3,209.3,174.5,208.9z"
      />
      <path
        class="st3"
        d="M484,201.9c0.6-0.2,1.3-0.3,2.4-0.6c-1.8-0.2-3.5-0.3-5.2-0.5c-0.4,0.7-0.6,1.4-0.4,2.2
		c0.3,1.4,1.8,2.3,3.5,2.2c0.3,0,0.6,0,1-0.1c0.3-0.1,0.5-0.2,0.8-0.3c0.7-0.3,1.3-0.8,1.7-1.4c0.1-0.1,0.1-0.2,0.2-0.3
		c0.1-0.2,0.1-0.3,0.1-0.5c-1.4,0-2.7,0-4.1,0C484,202.4,484,202.1,484,201.9z"
      />
      <path
        class="st3"
        d="M63.6,179.4c-0.1,0-0.1-0.1-0.2-0.1c0,0.1,0.1,0.1,0.1,0.2C63.5,179.5,63.6,179.4,63.6,179.4z"
      />
      <path
        class="st3"
        d="M184.8,209.1c-0.7,1-1.2,1.8-1.7,2.6c0.4,0.4,0.8,0.9,1.7,1.8C184.8,211.7,184.8,210.6,184.8,209.1z"
      />
      <path
        class="st3"
        d="M483,200.1c0.2,0,0.4,0.1,0.6,0.1c0-0.1,0-0.2,0-0.4c-0.1,0-0.2-0.1-0.3,0C483.2,199.9,483.1,200,483,200.1z"
      />
      <path
        class="st3"
        d="M177.4,210.9c0.7-0.3,1.3-0.5,2-0.8c-0.4-0.5-0.8-1-1.3-1.4c-0.8-0.6-1.5-2-2.7-0.6l0,0
		C175.5,208.4,177.3,210.9,177.4,210.9l-0.1,0.2L177.4,210.9z"
      />
      <path
        class="st3"
        d="M180.3,194.4c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1s-0.1,0.1-0.2,0.1
		C180.1,194.4,180.2,194.5,180.3,194.4z"
      />
      <path
        class="st3"
        d="M35.5,170.1c0.2,0.5,0.6,0.8,1,1c0.4,0,0.8-0.1,1.2-0.1c-0.2-0.2-0.2-0.5-0.4-1.2
		C36.7,169.9,36.2,170,35.5,170.1z"
      />
      <path
        class="st3"
        d="M190.2,206c2.3,0.8,2.3,0.8,4.9-0.9C193.1,204.7,191.5,204.3,190.2,206z"
      />
      <path
        class="st3"
        d="M178.8,187.6c0.7-0.6,1.3-1.2,2.3-2.1c-2.2,0-3.8,0-5.9,0C176.7,186.4,177.8,187,178.8,187.6z"
      />
      <path
        class="st3"
        d="M353.6,209.5c0.5,0.2,0.9,0.5,1.4,0.7l0,0C354.5,210,354.1,209.8,353.6,209.5z"
      />
      <path
        class="st3"
        d="M31,183.4c0.1-0.1,0.3-0.2,0.4-0.3c-0.1,0-0.3-0.1-0.5-0.1C30.9,183.1,30.9,183.2,31,183.4
		C30.9,183.3,30.9,183.3,31,183.4C30.9,183.4,30.9,183.4,31,183.4z"
      />
      <path
        class="st3"
        d="M180.2,205.1c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C180.1,205,180.1,205.1,180.2,205.1z"
      />
      <path
        class="st3"
        d="M179.2,197.1c0.6,0.1,1.1,0.1,1.7,0.2c0-0.2,0.1-0.4,0.1-0.6c-0.5-0.1-1.1-0.3-1.6-0.4
		C179.3,196.5,179.3,196.8,179.2,197.1z"
      />
      <path
        class="st3"
        d="M155.7,194.6c1.3,0,2.7,0,4.1,0c-0.4-0.6-0.7-1.3-1.2-2.2c-1,0.4-1.9,0.8-2.9,1.2
		C155.6,193.9,155.6,194.2,155.7,194.6z"
      />
      <path
        class="st3"
        d="M179.1,198.2c-1-0.5-2.1-0.9-3.1-1.4c-0.1,0.3-0.2,0.5-0.3,0.8c1.1,0.4,2.1,0.8,3.2,1.2
		C178.9,198.6,179,198.4,179.1,198.2z"
      />
      <path
        class="st3"
        d="M176.4,190c-2.6-1-5.3-2-7.9-3c-0.1,0.2-0.2,0.4-0.2,0.7c2.6,1,5.3,2.1,7.9,3.1
		C176.2,190.5,176.3,190.2,176.4,190z"
      />
      <path
        class="st3"
        d="M173,196.3c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.1
		C173.1,196.4,173.1,196.3,173,196.3z"
      />
      <path
        class="st3"
        d="M54.1,169.8c0.4-0.4,0.8-0.8,1.2-1.2c0,0,0,0,0-0.1c-2.2,0-4.5,0-6.7,0l0,0c-3.4,0.3-6.8,0.6-10.2,1
		c0,0.4,0,0.7,0.1,1.1c0,0.1,0,0.2,0.1,0.3l0,0C43.8,170.6,49,170.2,54.1,169.8z"
      />
      <path
        class="st3"
        d="M170.8,194.7c-0.6,0.1-1.1,0.1-1.7,0.2c0,0.1,0.1,0.3,0.1,0.4C169.7,195.1,170.2,194.9,170.8,194.7z"
      />
      <path
        class="st3"
        d="M177.2,195c-1.4-0.7-2.7-1.4-4.1-2c-0.2,0.4-0.4,0.7-0.5,1.1c1.5,0.5,2.9,1,4.4,1.5
		C177,195.3,177.1,195.1,177.2,195z"
      />
      <path
        class="st3"
        d="M313.8,194.5c0-0.2,0.1-0.4,0.2-0.6l0,0l0,0c-0.2,0.1-0.5,0.2-0.7,0.3C313.4,194.4,313.6,194.5,313.8,194.5z"
      />
      <path
        class="st3"
        d="M163.7,207.3c0.9-0.3,1.9-0.3,2.9-0.5c0.1-0.3,0.1-0.6,0.2-0.9c-1.1-0.4-2.3-0.9-3.4-1.3c-0.3,0.4-0.6,1-0.9,1
		c-1.3,0.1-2.7,0.1-4,0.2c1.7,0.4,2.8,2.3,4.3,2.9C163,208.2,163.2,207.5,163.7,207.3z"
      />
      <path
        class="st3"
        d="M401,227.3c0,0,0-0.1-0.1-0.1c-0.2-0.2-0.5-0.3-0.7-0.5c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.5,0,1,0,1.5
		c0,0.2,0,0.4,0,0.6c0.8-0.2,1.5-0.4,2.4-0.6l0,0l0.1-0.1l-0.1,0.1C401.9,227.7,401.5,227.5,401,227.3z"
      />
      <path
        class="st3"
        d="M107,161.9c0.7,0.1,1.4,0.1,2.1,0.2c0-0.2,0-0.3,0-0.5c-0.7,0-1.4,0-2,0C107.1,161.7,107.1,161.8,107,161.9z"
      />
      <path
        class="st3"
        d="M179,140.9c-0.1,0.2-0.2,0.3-0.3,0.5c0.2-0.1,0.3-0.1,0.5-0.2C179.2,141.1,179.1,141,179,140.9z"
      />
      <path
        class="st3"
        d="M100.6,161.8c0.7,0,1.5,0,2.2,0c0-0.1,0-0.1,0-0.2c-0.7,0-1.5,0-2.2,0C100.6,161.7,100.6,161.8,100.6,161.8z"
      />
      <path
        class="st3"
        d="M113.6,161.9c0-0.1,0-0.1,0-0.2c-0.5,0-1.1,0-1.6,0c0,0.1,0,0.1,0,0.2C112.5,161.9,113,161.9,113.6,161.9z"
      />
      <path
        class="st3"
        d="M397.9,224.1c-0.5-0.5-1-1-1.5-1.4s-1.1-0.8-1.6-1.2c-0.5,0.2-1,0.4-1.6,0.6c0,0,0.1,0,0.1,0.1
		c0.5,0.4,0.8,0.8,1.2,1.2c0.1,0.1,0.1,0.1,0.2,0.2c0.3,0.3,0.6,0.5,0.9,0.7c0.4,0.2,0.9,0.4,1.6,0.4
		C397.3,224.6,397.6,224.3,397.9,224.1z"
      />
      <path
        class="st3"
        d="M121,158.5c1,0.2,1.9,0.4,2.9,0.6c0.1-0.3,0.1-0.5,0.2-0.8c-0.9-0.3-1.9-0.6-2.8-1
		C121.2,157.8,121.1,158.1,121,158.5z"
      />
      <polygon class="st3" points="170.8,140.4 170.7,140.1 170.6,140.4 	" />
      <path
        class="st3"
        d="M204.1,120.9c-0.1,0-0.1,0.1-0.2,0.1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.2-0.2-0.4-0.3-0.6-0.5
		c-0.1,0.3-0.2,0.7-0.3,1c0,0.1,0,0.1-0.1,0.2c0.1,0,0.1,0,0.2,0c-0.3,0.9-0.5,1.7-0.8,2.7c-0.1,0-0.2,0-0.2,0.1
		c-0.1,0.2-0.2,0.5-0.2,0.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.7,0.3-1.3,0.6-1.6,1.5c-0.6-0.1-1.1-0.1-1.7-0.2c0.7,1.2,1.2,2.1,1.7,2.8
		c0.4,0.6,1.1,1,1.6,1.5c0.3-0.7,0.6-1.3,0.9-2c0.7,1,0.7,2.1,1,3.1c0.2,1,0.7,2,1.1,3c0.7-1.2,1.3-2.2,2.2-3.8
		c0.2,1.8,0.4,2.9,0.6,4.3c1.2-1.2,2.2-2.1,3.1-2.9l0.1,0.1l-0.2-0.1c-1-0.9-2-1.7-3.6-3c1.8-0.9,3-1.5,4.2-2.1
		c-0.1-0.2-0.1-0.3-0.2-0.5c-1,0.2-2,0.5-3,0.7c-0.2-0.2-0.3-0.5-0.5-0.7c0.6-0.4,1.6-0.7,1.9-1.3c0.8-1.4,0.2-3.8-0.9-5.7
		c-0.4,0.4-0.8,0.8-1.2,1.3c-0.2-0.1-0.4-0.1-0.5-0.2c-0.2-0.1-0.4-0.1-0.5-0.2C205.1,120.4,204.6,120.6,204.1,120.9z M205.2,128
		c-0.2-0.1-0.5-0.1-0.5-0.3c-0.1-0.1,0-0.4,0.1-0.6c0.2,0.1,0.5,0.2,0.7,0.3C205.4,127.6,205.3,127.8,205.2,128z M207.5,131.4
		c0.1,0.1,0.2,0.2,0.2,0.2c0,0.2-0.1,0.4-0.2,0.5c-0.1-0.1-0.2-0.2-0.3-0.3C207.3,131.7,207.4,131.5,207.5,131.4z"
      />
      <path
        class="st3"
        d="M401.9,224.5c0.1,0.1,0.3,0.3,0.4,0.4l-0.1-0.3C402.1,224.6,402,224.6,401.9,224.5z"
      />
      <path
        class="st3"
        d="M177.8,139.4c0.3-0.1,0.6-0.3,0.8-0.4c0.1-1.1,0.3-2.2,0.4-3.3c-0.6-0.3-1.2-0.6-2.6-1.4
		C176.9,136.4,177.3,137.9,177.8,139.4z"
      />
      <polygon class="st3" points="163.7,144.8 163.5,144.7 163.5,144.9 	" />
      <polygon class="st3" points="172,140.9 172.1,141.2 172.2,140.9 	" />
      <path
        class="st3"
        d="M152.7,208.6c-0.2-0.2-0.5-0.3-0.7-0.5c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c0.1,0.2,0.1,0.4,0,0.6
		C152.2,208.7,152.4,208.6,152.7,208.6z"
      />
      <path
        class="st3"
        d="M66.9,220.9c-0.1,0-0.1,0-0.2,0c0,0,0,0.1,0,0.2C66.8,221.1,66.8,221,66.9,220.9z"
      />
      <path
        class="st3"
        d="M103.4,166.9c0.1,0,0.3-0.2,0.4-0.2c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0.1-0.3,0.2-0.4,0.3
		C103.2,166.8,103.3,166.9,103.4,166.9z"
      />
      <path class="st3" d="M98.8,172.8l-0.1-0.1L98.8,172.8L98.8,172.8z" />
      <path
        class="st3"
        d="M401.5,223.9L401.5,223.9c-0.1,0-0.1,0-0.2,0c-0.1,0.1-0.1,0.2-0.2,0.2c-0.1,0.1-0.2,0.2-0.3,0.3
		c0.3,0,0.5,0,0.8,0l0,0C401.6,224.2,401.5,224,401.5,223.9z"
      />
      <path class="st3" d="M401.9,224.5c0,0-0.1,0-0.1-0.1L401.9,224.5z" />
      <path
        class="st3"
        d="M121.7,212.2c0.4,0,0.8-0.1,1.2-0.1c0-0.1,0-0.1,0-0.2c-0.4,0-0.8,0-1.2,0C121.7,212,121.7,212.1,121.7,212.2z
		"
      />
      <path
        class="st3"
        d="M108.1,173.2c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C108,173.1,108,173.2,108.1,173.2z"
      />
      <path
        class="st3"
        d="M13,226.3c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.2,0.2-0.3,0.2C12.8,226.3,12.9,226.3,13,226.3z"
      />
      <path
        class="st3"
        d="M72.6,217.8c-0.1-0.3-0.3-0.6-0.4-0.9c-0.5,0.4-1,0.8-1.5,1.1C71.3,218,72,217.9,72.6,217.8z"
      />
      <path
        class="st3"
        d="M81,219.4c0.7-0.4,1.5-0.9,2.2-1.3c-0.9,0-1.7,0.1-2.6,0.1C80.8,218.7,80.9,219.1,81,219.4z"
      />
      <path
        class="st3"
        d="M118.6,212.8c0.3,0,0.6,0,0.9,0c0-0.1,0-0.2-0.1-0.2c-0.3,0-0.5,0-0.8,0C118.6,212.7,118.6,212.7,118.6,212.8z
		"
      />
      <path
        class="st3"
        d="M106.8,216.2c-0.1,0-0.3,0.1-0.5,0.1c0.2,0,0.3,0.1,0.4,0.1C106.8,216.4,106.8,216.3,106.8,216.2z"
      />
      <path
        class="st3"
        d="M99.5,167.4C99.5,167.4,99.5,167.5,99.5,167.4c0.3,0.1,0.7,0.1,1,0.1c0-0.1-0.1-0.1-0.1-0.2
		C100.1,167.3,99.8,167.4,99.5,167.4z"
      />
      <path
        class="st3"
        d="M95.8,217.8c0.4-0.2,0.8-0.4,1.2-0.6c-0.1-0.1-0.3-0.3-0.4-0.4c-0.3,0.2-0.6,0.5-1,0.7
		C95.7,217.5,95.8,217.6,95.8,217.8z"
      />
      <path
        class="st3"
        d="M402.5,228c0,0.2,0,0.3,0,0.5c0,0.4,0,0.7,0,1.1c0.4-0.1,0.8-0.2,1.1-0.2c-0.2-0.2-0.4-0.4-0.7-0.6
		C402.8,228.6,402.7,228.3,402.5,228L402.5,228z"
      />
      <path
        class="st3"
        d="M101.9,173.4c0-0.2,0-0.4,0.1-0.6c-1,0-2,0-3,0C99.9,173,100.9,173.2,101.9,173.4z"
      />
      <path
        class="st3"
        d="M181.2,219.3c0.7-1.4,0.7-1.4-1.9-2.5C180,217.8,180.6,218.5,181.2,219.3z"
      />
      <path
        class="st3"
        d="M142.4,179.2L142.4,179.2C142.6,179.3,142.5,179.3,142.4,179.2z"
      />
      <path
        class="st3"
        d="M439.6,199c0.7-0.1,1.4-0.1,2.2-0.2c0-0.1,0-0.2,0-0.3c-0.8,0-1.5,0-2.3,0C439.5,198.6,439.6,198.8,439.6,199z
		"
      />
      <path
        class="st3"
        d="M139.9,180.3c0.3,0,0.6,0,0.9,0c0-0.1,0-0.1,0-0.2c-0.3,0-0.6,0-0.9,0C139.9,180.2,139.9,180.2,139.9,180.3z"
      />
      <path
        class="st3"
        d="M329.4,188.1c0.3,0,0.6,0,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.3,0-0.6,0-0.9,0.1C329.4,188,329.4,188,329.4,188.1z"
      />
      <path
        class="st3"
        d="M366.9,192.4c0,0,0.1-0.1,0.1-0.2c-0.2,0-0.4-0.1-0.6-0.1c0,0-0.1,0.1-0.1,0.2
		C366.5,192.3,366.7,192.3,366.9,192.4z"
      />
      <path
        class="st3"
        d="M137.6,179.6c0,0,0-0.1,0-0.2c-0.1,0-0.2,0-0.3,0c0,0.1,0,0.1,0,0.2C137.4,179.6,137.5,179.6,137.6,179.6z"
      />
      <path
        class="st3"
        d="M142.8,180.8c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2,0,0.3-0.1
		C142.9,180.9,142.8,180.8,142.8,180.8z"
      />
      <path
        class="st3"
        d="M609.5,176.2c0,0.1,0.1,0.1,0.1,0.2c-1.4-0.2-3,0-3.4-0.5c-1.3-2.2-3.4-1.3-4.4-0.7c-1.3,0.8-1.9,0.6-3,0.1
		c-0.7-0.3-1.6-0.4-2.4-0.5c-0.4,0-0.7-0.1-1.1-0.1c-0.7,0.3-1.4,0.7-2,1.3l-0.1,0.1c-0.4,0.5-0.7,0.9-0.9,1.4
		c-0.3,0.9-0.2,1.8,0.3,2.7c0.3,0.5,0.7,1,0.9,1.5c0.1,0.3,0.1,0.6,0,1c-0.1,0.2,0.2,0.5,0.5,0.7l0.1,0.1c0.1,0.1,0.2,0.1,0.3,0.2
		c0.2,0.1,0.3,0.2,0.5,0.3s0.4,0.2,0.5,0.2c1.7,0.7,3.4,0.1,4-1.3c0.1-0.3,0.2-0.7,0.2-1.1c0-0.5,0.1-0.9,0.5-1.3
		c0.3-0.3,0.6-0.7,0.8-1c0.6-1,0.6-2,0.1-3c-0.1-0.2,0-0.5,0.1-1c1.7,1.9,2.4,2.2,5.4,2.2c-0.3,0.3-0.5,0.6-0.7,1
		c0,0.1-0.1,0.1-0.1,0.2c-0.3,0.5-0.5,0.9-0.6,1.4c0,0.1,0,0.2-0.1,0.3c-0.3,1.8,0.6,3.6,2.7,4.4c1.4,0.6,3,0.6,4.4,0.1v-8.4
		c-0.8-0.1-1.6-0.2-2.4-0.4C609.6,176.2,609.6,176.2,609.5,176.2z M596.3,182.8c-0.4,0-0.7-0.1-1.1-0.2c0.1-0.2,0.1-0.5,0.2-0.7
		c0.4,0.1,0.8,0.1,1.3,0.2C596.5,182.3,596.4,182.8,596.3,182.8z M597.3,181.1c0-0.1,0-0.3,0-0.4c0.6,0,1.1,0,1.7,0
		c0,0.1,0,0.3,0,0.4C598.4,181.1,597.8,181.1,597.3,181.1z M606.8,182c-0.2-0.2-0.3-0.4-0.5-0.6c0.5-0.2,1-0.4,1.5-0.7
		c0.1,0.2,0.2,0.4,0.2,0.6C607.7,181.6,607.2,181.8,606.8,182z"
      />
      <polygon class="st3" points="157.6,184.5 157.6,184.3 157.4,184.5 	" />
      <path
        class="st3"
        d="M164,193c0.1,0,0.2,0,0.3-0.1c0-0.1-0.1-0.2-0.1-0.2c-0.1,0-0.2,0.1-0.3,0.1C164,192.9,164,193,164,193z"
      />
      <path
        class="st3"
        d="M142.7,184.8c0.1,0,0.1,0,0.2,0C142.8,184.8,142.8,184.8,142.7,184.8s-0.1,0-0.2-0.1
		C142.6,184.7,142.7,184.8,142.7,184.8z"
      />
      <path
        class="st3"
        d="M156,181.7c0.1,0,0.2,0,0.2-0.1s0-0.2-0.1-0.2s-0.2,0-0.2,0C155.9,181.6,155.9,181.7,156,181.7z"
      />
      <path
        class="st3"
        d="M168.2,208.8L168.2,208.8c-1.9,1.4-3.7,1-5.6,0l0,0c-1.3,0.8-2.7,1.5-4.3,2.4c2.4,0,4.4,0.3,6.3-0.1
		C165.9,210.9,167,209.6,168.2,208.8z"
      />
      <path
        class="st3"
        d="M176.5,222.8c-0.1,0-0.2,0-0.3,0.1l0,0C176.3,222.8,176.4,222.8,176.5,222.8z"
      />
      <path
        class="st3"
        d="M404.5,212.3c-0.3-0.2-0.6-0.4-0.9-0.5c0,0.1-0.1,0.2-0.1,0.3C403.8,212.2,404.2,212.2,404.5,212.3z"
      />
      <path
        class="st3"
        d="M408.6,214.2c0-0.1,0-0.3,0-0.4c-0.6-0.1-1.1-0.2-1.7-0.3c0,0.2-0.1,0.5-0.1,0.7
		C407.5,214.2,408.1,214.2,408.6,214.2z"
      />
      <path
        class="st3"
        d="M414,215.1c0.1-0.3,0.1-0.6,0.2-0.9c-0.5-0.1-1-0.1-1.5-0.1c0,0-0.1,0.5-0.1,0.6
		C413.1,214.8,413.5,214.9,414,215.1z"
      />
      <path
        class="st3"
        d="M404.3,204.9c0.1-0.1,0.2-0.1,0.2-0.2c-0.4,0-0.9,0-1.3,0c0.3,0.2,0.6,0.3,0.8,0.4
		C404.1,205,404.2,205,404.3,204.9z"
      />
      <path
        class="st3"
        d="M411.7,195.5c-1.4,0-2.7,0-4.1,0c1.3,0.3,2.7,0.5,4,0.8C411.6,196,411.7,195.7,411.7,195.5z"
      />
      <path
        class="st3"
        d="M417.9,217.9L417.9,217.9c0.1,0.2,0.2,0.3,0.2,0.3S418.1,218.1,417.9,217.9L417.9,217.9L417.9,217.9z"
      />
      <path
        class="st3"
        d="M403.2,226.5C403.2,226.5,403.1,226.5,403.2,226.5C403.1,226.5,403.1,226.5,403.2,226.5
		c-0.3-0.2-0.5-0.5-0.8-0.7l0,0l0,0c0,0,0,0,0-0.1c-0.7-0.2-1.4-0.5-2.1-0.7c0,0,0,0,0,0.1l0,0l0,0c0,0,0,0-0.1-0.1l0,0
		c0.1,0.4,0.2,0.8,0.3,1.2l0,0c0.1,0.3,0.3,0.6,0.4,0.8l0.1,0.1l0,0c0.5,0.2,0.9,0.5,1.4,0.7l0,0l0,0l0,0v0.1
		c0.2,0.2,0.5,0.3,0.7,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3c0.2,0.2,0.5,0.5,0.7,0.7l0,0l0,0c0,0,0,0,0.1,0
		c0,0,0,0,0,0.1c0.2,0.2,0.5,0.3,0.7,0.5c0.8,0.7,1.5,1.5,2.3,2.2c0.5-0.4,1-0.5,1.5-0.6c-0.8-0.7-1.7-1.4-2.5-2.1
		c-0.3-0.2-0.5-0.6-0.7-0.9l-0.1,0.1c-0.3,0.3-0.7,0.5-1.2,0.7c0.1-0.3,0.2-0.6,0.3-0.9c0.1-0.3,0.2-0.6,0.3-0.9c0,0,0-0.1-0.1-0.1
		c0,0-0.1,0-0.1-0.1C404.1,227,403.6,226.8,403.2,226.5z"
      />
      <path
        class="st3"
        d="M401.3,234.4c0.1,1.1,0.7,2,2,2.3c1.1,0.3,2.6-0.1,3.4-0.9c0.9-0.9,1.1-1.9,0.5-2.9c-0.9-0.9-1.8-1.8-2.7-2.7
		c-0.2-0.1-0.3-0.3-0.5-0.4c-0.1,0.6-0.3,1.3-0.5,2.1c-0.6,0.3-1.4,0.6-2.3,1c0,0.2,0,0.4,0.1,0.7
		C401.3,233.7,401.3,234,401.3,234.4C401.3,234.3,401.3,234.4,401.3,234.4z"
      />
      <path
        class="st3"
        d="M175.7,223c-0.3,0.1-0.7,0.2-1,0.3c0.1,0.1,0.1,0.2,0.2,0.3C175.2,223.4,175.5,223.2,175.7,223z"
      />
      <path
        class="st3"
        d="M441,206c-0.1,0-0.2,0.1-0.3,0.1l0,0c-0.7,0.3-1.4,0.5-2,0.8c0,0.2,0,0.4,0,0.6c0.1-0.1,0.3-0.2,0.4-0.3
		c0.3,0.2,0.5,0.4,0.8,0.5c0.7-0.1,1.3-0.2,2-0.3C442.1,207,441.8,206.6,441,206z"
      />
      <path
        class="st3"
        d="M148.8,227.6c0-0.2-0.1-0.3-0.2-0.5c-0.2,0.2-0.4,0.3-0.5,0.5c0.2,0.1,0.3,0.2,0.5,0.2
		C148.6,227.7,148.8,227.6,148.8,227.6z"
      />
      <path
        class="st3"
        d="M433,217.1c0,0.1,0,0.1,0,0.2c0.1-0.2,0.2-0.3,0.3-0.5C433.3,216.9,433.1,217,433,217.1z"
      />
      <path
        class="st3"
        d="M434,216.6c-0.1,0-0.2,0-0.2,0C433.9,216.7,434,216.7,434,216.6C434,216.7,434,216.7,434,216.6z"
      />
      <path
        class="st3"
        d="M440.6,205.9l0.1,0.1C440.6,206,440.6,205.9,440.6,205.9z"
      />
      <path
        class="st3"
        d="M168.7,212.3c-0.1-0.2-0.1-0.5-0.2-0.7c-1.2,0.2-2.3,0.4-3.5,0.6c0.1,0.4,0.2,0.9,0.3,1.3
		C166.5,213.1,167.6,212.7,168.7,212.3z"
      />
      <path
        class="st3"
        d="M160.4,195.6c-0.2-0.3-0.4-0.6-0.6-0.9c0.1,0.3,0.2,0.7,0.3,1C160.2,195.7,160.3,195.7,160.4,195.6z"
      />
      <polygon class="st3" points="605.8,134.9 605.9,134.9 605.8,134.7 	" />
      <path
        class="st3"
        d="M607.2,141.4c-0.1,0.2-0.1,0.3-0.2,0.5c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0.1-0.3,0.2-0.5
		C607.4,141.5,607.2,141.4,607.2,141.4z"
      />
      <path
        class="st3"
        d="M283.1,166.7c-0.2-0.1-0.4-0.2-0.6-0.4c0,0.1-0.1,0.2-0.1,0.3c0.2,0.1,0.3,0.2,0.5,0.3
		C283,166.9,283.1,166.7,283.1,166.7z"
      />
      <path
        class="st3"
        d="M598.4,147.5c-0.1-0.2-0.2-0.3-0.2-0.5c-0.3,0.3-0.7,0.6-1,0.9C597.6,147.7,598,147.6,598.4,147.5z"
      />
      <path
        class="st3"
        d="M158.3,166.5c1.5,0.3,2.3-0.4,2-2.3c-0.3-1.7-0.7-3.4-0.9-4.5C159.1,161.6,158.7,164,158.3,166.5z"
      />
      <path
        class="st3"
        d="M581.4,113.4l0.2-0.2C581.5,113.3,581.4,113.4,581.4,113.4z"
      />
      <path
        class="st3"
        d="M161.7,166.8c0.3-0.4,0.8-0.7,1-1.1c0.1-0.2-0.3-0.6-0.5-0.9c-0.2,0-0.5,0-0.7,0
		C161.5,165.5,161.6,166.2,161.7,166.8z"
      />
      <polygon class="st3" points="595.9,146.7 596.1,146.7 596,146.4 	" />
      <path
        class="st3"
        d="M157.6,160.1c0.1-0.2,0.3-0.3,0.4-0.5C157.9,159.7,157.8,159.9,157.6,160.1l-0.1,0.1L157.6,160.1z"
      />
      <path
        class="st3"
        d="M585.5,168.8c0.2,0,0.5,0,0.7-0.1c-0.2-2.1-0.5-4.2-0.7-6.3C585.5,164.6,585.5,166.7,585.5,168.8z"
      />
      <path
        class="st3"
        d="M583.5,156c0,0.1,0,0.2,0,0.2c0.6,0,1.1,0,1.7,0v-0.1C584.6,156,584,156,583.5,156z"
      />
      <path
        class="st3"
        d="M582.6,157.4c-0.6,0-1.2,0-1.9,0c0,0.1,0,0.1,0,0.2c0.6,0,1.2,0,1.9,0C582.6,157.6,582.6,157.5,582.6,157.4z"
      />
      <path
        class="st3"
        d="M591.9,152.4c-0.2-0.4-0.3-0.9-0.5-1.3c0.1,0.5,0.1,0.9,0.2,1.4C591.7,152.4,591.8,152.4,591.9,152.4z"
      />
      <path
        class="st3"
        d="M585.9,158c1.3,0.2,2.6,0.4,3.9,0.5c0-0.2,0.1-0.4,0.1-0.6c-1.3-0.3-2.6-0.5-3.9-0.8
		C585.9,157.4,585.9,157.7,585.9,158z"
      />
      <path
        class="st3"
        d="M128.7,172.5c4.5,1.6,9,3.3,13.5,4.9c0.5,0.2,1.3-0.5,2-0.5c0.5,0,0.9,0.6,1.4,0.9c1.1-0.2,2.3-0.4,3.3-0.6
		c1.3,0.9,2.5,1.8,3.8,2.7l0,0c2.5-0.3,4.9-0.6,7.8-0.9c-1.1,0.7-1.9,1.2-3.2,2c1.7,0.1,2.8,0.2,3.9,0.3c0.1,0,0.1,0,0.2,0
		c1.9,0,3.8,0,5.7,0c0-0.1,0-0.3,0-0.4c-1.3-0.1-2.5-0.1-3.8-0.2c0.8-0.4,1.6-0.8,2.9-1.6c-2.9-0.3-4.9-2.4-7.8-1.2
		c-0.4,0.2-1.2-0.7-1.8-1.1c0.1-0.2,0.2-0.5,0.4-0.7c-3.4-0.2-6.9-0.4-10.5-0.6c0.6-0.3,1.2-0.6,2.1-1.1c-2.4-0.8-4.5-2.3-7.1-0.3
		c0.4,0.4,0.7,0.8,1.2,1.4c-4.7-1.3-9.2-2.5-13.7-3.7C128.9,172,128.8,172.2,128.7,172.5z"
      />
      <path
        class="st3"
        d="M591.4,150.7c0.2-0.7,0.4-1.4,0.6-2.5C590.4,149.9,590.3,149.9,591.4,150.7z"
      />
      <path
        class="st3"
        d="M141.8,160.7c-0.4,2-0.7,3.6-1,5.3C142.4,165.8,142.4,165.8,141.8,160.7z"
      />
      <path
        class="st3"
        d="M141.6,157.7c0,0.1,0,0.2-0.1,0.3c0.1,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3
		C141.8,157.8,141.7,157.8,141.6,157.7z"
      />
      <path
        class="st3"
        d="M130,158.6c0-0.1,0-0.1,0-0.2C130,158.5,130,158.6,130,158.6c0,0.1,0,0.1-0.1,0.2
		C130,158.8,130,158.7,130,158.6z"
      />
      <path
        class="st3"
        d="M133.9,158.1h-0.1c0,0.4,0.1,0.9,0.1,1.3c0,0,0,0,0.1,0C133.9,159,133.9,158.6,133.9,158.1z"
      />
      <path
        class="st3"
        d="M151,159.7c-0.4,2.2-0.8,4.4-1.2,6.6l0,0c1.8,0.3,3.6,0.5,5.7,0.9c0.2-2.7-2.7-4.1-3.6-6.1c0,1.4,0,2.8,0,4.1
		c-0.2,0-0.5,0-0.7,0c0-1.8,0-3.7,0-5.5C151.2,159.7,151.1,159.7,151,159.7z"
      />
      <path
        class="st3"
        d="M126.1,171.3c-0.1,0.1-0.1,0.2-0.2,0.4c0.3,0.1,0.7,0.2,1,0.3C126.6,171.8,126.3,171.6,126.1,171.3z"
      />
      <path
        class="st3"
        d="M117.4,168.9c0,0.1,0.1,0.2,0.1,0.4c2-0.1,4-0.3,5.4-0.4C121.5,168.9,119.5,168.9,117.4,168.9z"
      />
      <path
        class="st3"
        d="M122,173.4c-0.4-0.2-0.9-0.4-1.3-0.6c0,0.2-0.1,0.3-0.1,0.5C121.1,173.3,121.5,173.3,122,173.4z"
      />
      <path
        class="st3"
        d="M128.5,165L128.5,165c-0.9-1.9-1.8-3.8-2.6-5.3c0,1-0.1,2.6,0,4.1C126.1,165.4,127,166,128.5,165z"
      />
      <path
        class="st3"
        d="M147.8,156c-1,0-2.1,0-3.1,0c0,0.1,0,0.1,0,0.2c1,0,2.1,0,3.1,0C147.8,156.1,147.8,156.1,147.8,156z"
      />
      <path
        class="st3"
        d="M600,171.7c0.1,0.1,0.1,0.1,0.2,0.2c0.8,0.4,1,0.9,0.9,1.4c1.1,0,2.2,0.1,3.3,0.1c2,0.1,3.8,0.3,5,2.7
		c0.3-0.4,0.5-0.8,0.7-1.2c0.5-1,0.6-1.9,0.3-2.6c-0.1-0.3-0.3-0.5-0.5-0.8C606.6,172.1,603.3,172,600,171.7z"
      />
      <path
        class="st3"
        d="M147.1,166.1c1,0.1,1.8,0.2,2.6,0.2C148.8,165,148,164.8,147.1,166.1z"
      />
      <polygon class="st3" points="577.2,155.5 577.5,155.4 577.2,155.3 	" />
      <path
        class="st3"
        d="M143.7,162.3c0,1.3,0,2.5,0,3.8C144.4,165.9,144.5,164.1,143.7,162.3z"
      />
      <path
        class="st3"
        d="M607.5,169.8c-0.5-0.1-1,0.1-1.5,0.3c0.6,0.3,1.3,0.5,2.2,0.6c0.5,0.1,0.9,0.3,1.4,0.5
		c-0.1-0.1-0.2-0.2-0.4-0.4c0,0,0,0-0.1,0C608.7,170.5,608.1,170.2,607.5,169.8z"
      />
      <path
        class="st3"
        d="M132.1,165.8c2.2,0.2,4.3,0.4,7.1,0.7c-2.3-1.4-4-2.5-5.8-3.6C133.2,163.4,132.8,164.3,132.1,165.8z"
      />
      <path
        class="st3"
        d="M592.8,147.1c0.1,0,0.2-0.1,0.2-0.1c0-0.1-0.1-0.1-0.1-0.2C592.9,146.9,592.9,147,592.8,147.1z"
      />
      <path
        class="st3"
        d="M529.9,152.8L529.9,152.8C530,152.6,530,152.7,529.9,152.8z"
      />
      <path class="st3" d="M527,158.4c0,0,0,0.1-0.1,0.1L527,158.4z" />
      <path
        class="st3"
        d="M529.5,158.3c0.5-1.4,1-2.9,1.6-4.3c-0.8,1.3-1.6,2.6-2.4,3.9C528.9,158,529.2,158.1,529.5,158.3z"
      />
      <path
        class="st3"
        d="M526.9,158.5l0.1-0.1C526.9,158.4,526.9,158.4,526.9,158.5z"
      />
      <path
        class="st3"
        d="M526.9,158.5C526.8,158.6,526.8,158.6,526.9,158.5L526.9,158.5z"
      />
      <path
        class="st3"
        d="M322.6,199c0-0.2-0.1-0.3-0.1-0.5c0.6-0.2,1.1-0.4,2.1-0.7c-2.7-1.6-5.3-1.2-7.8-0.7c-1.6,0.3-3.1,0.9-4.6,1.4
		c0,0.2-0.1,0.3-0.3,0.4c0.1,0.5,0.2,0.9,0.2,1.4c0,0.4,0,0.8,0,1.3c0.3,0.2,0.5,0.4,0.8,0.6c1.3,0.1,2.6,0.2,4,0.3c0,0,0,0,0-0.1
		c0.7-0.2,1.4-0.5,2.1-0.7c0.1,0,0.2,0,0.3-0.1c2.2-0.8,4.4-1.7,6.3-2.4C324.8,199.2,323.7,199.1,322.6,199z M315.6,199.5
		c0-0.2,0-0.3,0-0.5c1.5,0,3,0,4.6,0c0,0.2,0,0.3,0,0.5C318.6,199.5,317.1,199.5,315.6,199.5z"
      />
      <path
        class="st3"
        d="M540.3,159.9c-0.2,0-0.3-0.1-0.4-0.1c-0.1,0.1-0.1,0.3-0.1,0.3c-1.9,1.1-3.4,1.1-4.1-1.5c0,1.5,0,2.9,0,4.6
		c1.5-0.3,2.9-0.6,4.4-0.9C540.2,161.5,540.3,160.7,540.3,159.9z"
      />
      <path
        class="st3"
        d="M326.6,197.8c0,0.1,0,0.1,0,0.2c0.3,0,0.6,0,0.9-0.1c0-0.1,0-0.1,0-0.2C327.2,197.8,326.9,197.8,326.6,197.8z"
      />
      <path
        class="st3"
        d="M589.7,123c0.1-0.2,0.1-0.3,0.1-0.4c0,0-0.1,0-0.2-0.1C589.6,122.7,589.6,122.8,589.7,123z"
      />
      <path
        class="st3"
        d="M533.8,150.2c0-1.5-1-1.9-2.4-1.9c-9.3,0.2-18.6,0.4-27.9,0.6c-1.6,0-3.4-0.2-4.2,1.9l0,0
		c7.2-1.5,7.2-1.5,7.2,5.9c0,2.2,0,4.5,0,7c2.1,0,4.2,0,6.4,0c-1.9-0.2-3.7-0.3-5.5-0.5c0-0.2,0-0.5,0.1-0.7c0.6-0.3,1.1-0.7,1.7-1
		l0,0c0-0.3,0-0.6,0-0.9c-0.1-0.6-0.2-1.2-0.5-2.6c-0.6,1.4-0.9,2-1.2,2.7c0-3.7,0-7.3,0-11c2.7,0.1,5.2-1.1,6.6,1.7
		c0.4-0.3,0.7-0.5,1.4-1.1c0,4.5,0,8.7,0,13.4c0.2,0,0.4,0,0.6,0c0-3.3,0-6.8,0-10.3c0-2.3,0.6-3.8,3.4-3.6c1.5,0.1,3-0.4,4.7-0.6
		c0.2,0.9,0.6,1.7,0.6,2.4c0,3.5,0.1,7-0.1,10.6c-0.1,0.9-1,1.8-1.4,2.5c0.3,0,1.3,0,2.3,0c0-4.8,0-9.7,0-14.7
		c0.8-0.1,1.5-0.4,2.3-0.4c4.6-0.1,5.3,0.6,5.4,5.2c0,2,0,4,0,6c0,4,0,4-4.3,4.5c1.7,0,3,0,4.7,0
		C533.9,160.2,533.9,155.2,533.8,150.2z"
      />
      <path
        class="st3"
        d="M537,167.9c-0.2,0.4-0.5,0.7-0.7,1.1c0.4-0.3,0.7-0.5,1.1-0.8C537.2,168.1,537.1,168,537,167.9z"
      />
      <polygon class="st3" points="526.5,156 526.7,155.9 526.6,155.6 	" />
      <path
        class="st3"
        d="M509.8,161.2c-0.1-0.1-0.3-0.2-0.4-0.4c0.1,0.1,0.1,0.2,0.1,0.4H509.8z"
      />
      <polygon class="st3" points="588.8,126.5 589,126.5 588.9,126.3 	" />
      <path
        class="st3"
        d="M511.5,158.5C511.5,158.6,511.4,158.6,511.5,158.5C511.4,158.6,511.4,158.6,511.5,158.5
		C511.4,158.6,511.5,158.6,511.5,158.5z"
      />
      <path
        class="st3"
        d="M505.5,156.7c-0.3-0.1-0.6-0.2-0.9-0.2c-0.5,1.7-1.1,3.4-1.6,5.2C505.8,161.8,505.8,161.8,505.5,156.7z"
      />
      <path
        class="st3"
        d="M499.9,162.6c0-1.4,0-2.7,0-4.1c-0.1,0-0.2,0-0.3,0c0,1.4,0,2.7,0,4.1C499.7,162.6,499.8,162.6,499.9,162.6z"
      />
      <polygon class="st3" points="504.5,163.3 504.3,163.2 504.3,163.4 	" />
      <path
        class="st3"
        d="M581.3,116.7c0.2-0.3,0.4-0.7,0.6-1c-0.3,0.3-0.6,0.5-0.9,0.8C581.2,116.5,581.2,116.6,581.3,116.7z"
      />
      <path
        class="st3"
        d="M566.9,123.8c0.1,0.1,0.2,0.2,0.3,0.4c0.6-0.5,1.1-1.1,2.3-2.2c-1.3,0.3-1.8,0.5-2.3,0.6
		C567.2,123,567,123.4,566.9,123.8z"
      />
      <path
        class="st3"
        d="M503.6,155.8c0,0.1,0,0.1-0.1,0.2C503.6,155.9,503.6,155.9,503.6,155.8C503.7,155.8,503.7,155.7,503.6,155.8
		C503.7,155.7,503.7,155.8,503.6,155.8z"
      />
      <path
        class="st3"
        d="M542.7,70.6l0.2,0.1v-0.2C542.8,70.5,542.8,70.6,542.7,70.6z"
      />
      <path
        class="st3"
        d="M567.3,122.5c0.2-0.8,0.5-1.6,0.7-2.5C566.7,120.6,565.7,121.2,567.3,122.5z"
      />
      <path
        class="st3"
        d="M518.2,159.4c-1.6,0.9-1,2-0.2,3.6c1.8-3.2,3.3-6,4.8-8.7l0,0c0-1,0.1-2,0.2-3.5c-1.1,1.6-2,2.9-2.9,4.2l0,0
		C520.5,156.9,519.8,158.4,518.2,159.4z"
      />
      <path
        class="st3"
        d="M523.1,158.5c-0.4,0-0.8,0.1-1.1,0.1c-0.1,0-0.1,0-0.2-0.1c0.1,0,0.1,0,0.2,0.1c0.3,0.2,0.5,0.4,0.8,0.6
		C522.9,159,523,158.7,523.1,158.5z"
      />
      <polygon class="st3" points="583.2,117.8 583.3,117.5 583.1,117.5 	" />
      <path
        class="st3"
        d="M522.3,162.7c0.1-0.4,0.2-0.9,0.3-1.3c-0.1,0-0.2-0.1-0.3-0.1c-0.2,0.4-0.5,0.8-0.7,1.2
		C521.9,162.6,522.1,162.7,522.3,162.7z"
      />
      <path
        class="st3"
        d="M505.2,152.5c-0.1,0.3-0.1,0.6-0.2,0.9c0.2-0.2,0.4-0.5,0.6-0.7C505.5,152.7,505.4,152.6,505.2,152.5z"
      />
      <path
        class="st3"
        d="M522.4,156.8c0.1-0.1,0.2-0.2,0.4-0.3c0-0.6,0-1.1,0-1.7c0,0.5-0.1,1-0.1,1.6
		C522.6,156.5,522.5,156.7,522.4,156.8z"
      />
      <path
        class="st3"
        d="M532.2,163.4c0-2.5,0-4.7,0-7.4c-1.2,1.8-2.1,3.3-3,4.7c0,0,0,0,0,0.1c0,0,0,0,0-0.1c-0.1-0.2-0.3-0.4-0.4-0.5
		c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0.1c-0.6,0.6-1.2,1.1-1.7,1.7c0.6,0.4,1.2,1,1.9,1.1C529.7,163.7,530.8,163.5,532.2,163.4z"
      />
      <path
        class="st3"
        d="M510.6,162.1c0.3-0.4,0.5-0.8,0.8-1.2c-0.4,0.2-0.8,0.4-1.2,0.6C510.3,161.6,510.4,161.9,510.6,162.1z"
      />
      <path
        class="st3"
        d="M196.3,197.7c-0.2,0-0.4,0.1-0.5,0.2c0.2,0.1,0.3,0.1,0.5,0.2c0.1-0.1,0.2-0.2,0.3-0.3
		C196.5,197.7,196.4,197.7,196.3,197.7z"
      />
      <path
        class="st3"
        d="M198.6,202c0,0.1-0.1,0.2-0.1,0.3c0.1,0,0.2,0,0.3-0.1c0,0,0-0.1,0.1-0.2C198.7,202,198.7,202,198.6,202z"
      />
      <path
        class="st3"
        d="M200.8,195.1c1.1,0.3,2.2,0.6,3.3,1c-0.5-1.8-2-1.3-3-1.8C201,194.6,200.9,194.9,200.8,195.1z"
      />
      <path
        class="st3"
        d="M199,205c0.3-0.2,0.5-0.5,0.7-0.7c-0.2-0.1-0.3-0.2-0.6-0.4c-0.2,0.2-0.5,0.4-0.7,0.6
		C198.7,204.7,199,205,199,205z"
      />
      <path
        class="st3"
        d="M205,196.9c-0.6,1.7,0.3,2,2.3,1.9C206.3,198,205.6,197.5,205,196.9z"
      />
      <path
        class="st3"
        d="M73.1,179.6c-0.3,0-0.6,0.1-1,0.2C72.5,179.8,72.8,179.7,73.1,179.6z"
      />
      <path
        class="st3"
        d="M308.6,200.5c1.1-0.9,2.1-1.7,3.1-2.5c1.9-0.7,3.9-1.4,6-2.2c-1.3-0.3-2.5-0.5-3.6-0.8c-1.7,0.3-3.4,0.7-5.1,1
		v0.1c-0.1,0-0.2,0-0.3,0c-2.4,0.2-4.9,0.4-7.2,0.6c0,0,0.2,0.4,0.4,0.8l0,0l0,0c0,0,0,0,0.1,0c0.5,0.2,0.9,0.4,1.4,0.6
		C305.3,199,307.1,199.8,308.6,200.5z"
      />
      <path
        class="st3"
        d="M537.7,180.6c-0.4,1-0.9,2.1-1.3,3.2c0.2,0,0.3,0,0.5,0.1c0.2-0.4,0.4-0.9,0.6-1.3
		C536.8,181.9,537.9,181.2,537.7,180.6z"
      />
      <path
        class="st3"
        d="M195.5,186.5c1.2-0.1,2.4-0.2,3.6-0.4c-1.2-0.3-2.4-0.5-3.5-0.8C195.6,185.7,195.6,186.1,195.5,186.5z"
      />
      <path
        class="st3"
        d="M76.8,180.3C76.8,180.2,76.8,180.2,76.8,180.3c-0.2-0.1-0.5-0.1-0.6,0.1l0,0c0.2,0.1,0.3,0.2,0.5,0.2
		C76.7,180.5,76.8,180.4,76.8,180.3z"
      />
      <path
        class="st3"
        d="M189.4,187.5c0.9,0,1.7-0.1,3.2-0.2c-1.1-0.8-1.8-1.3-2.8-1.9C189.7,186.3,189.6,186.9,189.4,187.5z"
      />
      <path
        class="st3"
        d="M536.1,174.4c0-0.7,0-1.3,0-1.9c-0.2,0.6-0.3,1.2-0.3,1.8C535.9,174.3,536,174.3,536.1,174.4z"
      />
      <path
        class="st3"
        d="M197.6,192.4c0.8,0,1.7,0,2.5,0c0-0.1,0-0.2,0-0.3c-0.8,0-1.7,0-2.5,0C197.6,192.2,197.6,192.3,197.6,192.4z"
      />
      <path
        class="st3"
        d="M538.4,184.2L538.4,184.2c-1.2,2.7,0.9,1.7,2,1.9c0.7-1.5,1.3-2.9,1.9-4.3c0,0,0,0,0-0.1
		c-0.2,0.1-0.5,0.2-0.6,0.3s-0.2,0.3-0.4,0.4c-0.6-0.1-1-0.6-1.5-0.8c-0.4-0.1-0.8-0.2-1.3,0c0,0.3,0,0.6,0,0.8
		c-0.1,0.6-0.3,1.1-0.7,1.5c0.2,0,0.3,0,0.5,0.1L538.4,184.2c-0.1-0.1-0.1-0.2-0.1-0.2c0.4-0.3,0.9-0.6,1.3-0.8
		c0.2-0.1,0.5-0.1,0.7-0.2c-0.2,0.1-0.4,0.2-0.5,0.4C539.3,183.7,538.8,183.9,538.4,184.2z"
      />
      <polygon class="st3" points="199.6,188.7 199.8,188.8 199.7,188.6 	" />
      <path
        class="st3"
        d="M198.7,210.9c0-0.1,0.1-0.1,0.1-0.2C198.8,210.7,198.7,210.7,198.7,210.9C198.7,210.8,198.7,210.8,198.7,210.9
		z"
      />
      <path
        class="st3"
        d="M195.6,209c-0.1,0-0.3,0-0.4,0c0.1,0.1,0.2,0.2,0.3,0.4C195.5,209.2,195.5,209.1,195.6,209z"
      />
      <path
        class="st3"
        d="M509.2,192.1c0.3-0.2,0.9-0.5,0.9-0.7s0-0.3,0-0.5c-0.9-0.1-1.8-0.2-2.7-0.3
		C508.3,191.1,508.5,191.3,509.2,192.1z"
      />
      <path
        class="st3"
        d="M198.6,211.1c-1.8,0-3.6,0-5.5,0C195.8,213.1,195.8,213.2,198.6,211.1z"
      />
      <path
        class="st3"
        d="M499.7,175.7c0.1,0.5,0.1,1,0.2,1.6c0.1,0,0.2,0.1,0.3,0.1c1-0.8,1.1-1.1,0.7-1.5
		C500.6,175.5,500.4,175.5,499.7,175.7z"
      />
      <path
        class="st3"
        d="M183.8,219.4c0-0.1,0-0.1,0.1-0.2C183.8,219.3,183.8,219.4,183.8,219.4L183.8,219.4L183.8,219.4z"
      />
      <path
        class="st3"
        d="M185.5,216.4c1.4-1.3,3.8,0.1,4.9-2c0.3-0.5,1.9-0.4,2.9-0.6c-2.2-2-4.4-2.4-6.8-1.4c0,0.9-0.1,1.8-0.1,2.7
		c-1.2,0.1-2.4,0.3-3.6,0.4c0,0.3,0,0.6,0,0.9C183.7,216.5,185,216.9,185.5,216.4z"
      />
      <path
        class="st3"
        d="M195.1,208.2c-0.4,0-0.8,0-2,0c1.1,0.4,1.5,0.5,1.9,0.7C195,208.6,195.1,208.4,195.1,208.2z"
      />
      <path
        class="st3"
        d="M205.1,201.9c0.5,1.1,1,1.9,1.4,2.7C207,202.6,207,202.6,205.1,201.9z"
      />
      <path
        class="st3"
        d="M70.9,182.3c-0.4-0.1-0.8-0.3-1.2-0.4c0,0.2,0.1,0.4,0.1,0.6C70.1,182.4,70.5,182.4,70.9,182.3z"
      />
      <path
        class="st3"
        d="M196.6,205.1v0.1c0.1-0.1,0.1-0.2,0.2-0.3C196.7,205,196.6,205.1,196.6,205.1z"
      />
      <path
        class="st3"
        d="M195.3,208.1c1.1,0.2,2.2,0.3,3.7,0.5c0.1-0.2,0.4-0.8,0.8-1.7c1.4,0,3,0,4.5,0c0-0.2,0-0.4,0-0.6
		c-0.4-0.2-0.7-0.4-1.3-0.8c1.3-0.4,2.4-0.7,3.5-1c-1-0.5-1.9-1.2-3-1.5c-0.9-0.3-2.7-0.7-1.4,1.4c0.3-0.2,0.5-0.4,0.8-0.6
		c0.1,0.1,0.1,0.2,0.2,0.4c-0.3,0.1-0.7,0.1-1,0.2C199.9,205.8,197.6,206.9,195.3,208.1z"
      />
      <path
        class="st3"
        d="M506.7,187.2c-0.1,0-0.1,0-0.2,0v0.1C506.5,187.3,506.6,187.2,506.7,187.2z"
      />
      <path
        class="st3"
        d="M505.1,189.4c0.1,0.2,0.2,0.4,0.4,0.5C505.3,189.7,505.2,189.5,505.1,189.4z"
      />
      <path
        class="st3"
        d="M196.4,205.6l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C196.3,205.6,196.3,205.6,196.4,205.6z"
      />
      <path
        class="st3"
        d="M178.4,184c2.7,0.3,5.4,0.7,8.1,1c0.1-0.4,0.1-0.8,0.2-1.3c-2.7-0.3-5.4-0.6-8-0.9
		C178.5,183.2,178.4,183.6,178.4,184z"
      />
      <path
        class="st3"
        d="M152.6,180.5c0-0.2,0-0.4,0-0.7c-0.4,0.1-0.9,0.2-1.7,0.3C151.8,180.3,152.2,180.4,152.6,180.5z"
      />
      <path
        class="st3"
        d="M189.4,187.6c-2.2-2.3-3.3-2.4-7.8-0.4c5.1,4.4,10.8,6.6,17.6,6.7c-1.4-1.2-4.4,0.6-4.1-2.7l0,0l0,0l0,0l0,0
		c-0.8,0-1.5,0-2.3,0c0.1-0.3,0.1-0.6,0.2-0.9c0.7,0.3,1.4,0.6,2.1,0.9l0,0l0,0c0.7-0.2,1.5-0.3,2.4-0.5c-2.2-2.3-5.8-2.8-7.6-1.2
		c-0.4,0.4-0.9,0.7-1.4,1c0.1-0.7,0.2-1.3,0.3-2C188.9,188.1,189.2,187.8,189.4,187.6z"
      />
      <path
        class="st3"
        d="M173,180.9c0.2,0.1,0.5,0.2,0.7,0.4c-0.1-0.3-0.2-0.5-0.3-0.8C173.4,180.6,173.2,180.7,173,180.9z"
      />
      <polygon class="st3" points="169.8,179.5 170.2,179.5 170.1,179.4 	" />
      <path
        class="st3"
        d="M153.8,180.8c-0.3-0.1-0.6-0.1-0.9-0.2c0.3,0.2,0.5,0.3,0.8,0.5C153.7,181,153.7,180.9,153.8,180.8z"
      />
      <path
        class="st3"
        d="M164.5,183.1c2.5,1.5,5,2.4,7.9,1h0.1c1.2,0.3,2.4,0.5,3.6,0.8c0.1-0.3,0.1-0.6,0.2-0.9
		c-0.6-0.2-1.2-0.3-1.8-0.5l0,0c0-0.2,0-0.5,0-0.7l0,0c1.2-0.2,2.4-0.4,3.6-0.6c-1.3-1.8-2.8-1.6-4.3-0.8c0,0.2,0,0.4,0,0.7l0,0
		c-3.1,0.1-6.2,0.1-9.3,0.2C164.5,182.5,164.5,182.8,164.5,183.1z"
      />
      <polygon class="st3" points="160.6,175.1 160.4,175.3 160.7,175.3 	" />
      <path
        class="st3"
        d="M162.9,175.8c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.3-0.1,0.4-0.2
		C163.1,175.8,163,175.8,162.9,175.8z"
      />
      <path
        class="st3"
        d="M138,172.3c-1.1,0-2.1,0-3.2,0c0,0.1,0.1,0.2,0.1,0.2c1,0,2.1,0,3.1,0C138,172.4,138,172.4,138,172.3z"
      />
      <path
        class="st3"
        d="M556.6,179.8L556.6,179.8c0.1,0.1,0.1,0.1,0.2,0.2C556.7,179.9,556.7,179.8,556.6,179.8z"
      />
      <path
        class="st3"
        d="M558,181c0-0.6,0.1-1.2,0.1-1.8c-0.4,0.1-0.8,0.3-1.1,0.4l0,0c0,0.1-0.1,0.2-0.1,0.3c0.1,0.4,0.3,0.8,0.4,1.2
		C557.4,181.1,557.7,181.1,558,181z"
      />
      <path
        class="st3"
        d="M538,172.1c0.1-0.1,0.1-0.3,0.2-0.4c0-0.1-0.2-0.2-0.5-0.2C537.7,171.8,537.5,172.2,538,172.1z"
      />
      <path
        class="st3"
        d="M536.8,201.2C536.9,201.2,536.9,201.2,536.8,201.2C536.9,201.1,536.9,201.1,536.8,201.2L536.8,201.2z"
      />
      <path
        class="st3"
        d="M612,20.2c-1.4,0.3-2.6,1.4-3.6,3c-0.3-0.3-0.6-0.6-0.9-0.9c-0.3,0.3-0.5,0.5-0.7,0.6
		c-0.3,0.4-0.1,0.6,0.7,1.2c0.2-0.1,0.4-0.2,0.7-0.4l0,0c0.1,0.3,0.1,0.6,0.2,1.1c-0.4,0.1-0.7,0.1-1,0.1c-2.2,0-4.4,2.1-3.9,4.2
		c0.1,0.3,0.2,0.6,0.4,0.8c0.6,0.9,1.5,1.4,2.7,1.5c0.2,0,0.5,0,0.7,0c0.1,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0v0.1c0,0.5-0.1,1-0.1,1.5
		c0,0.1,0,0.2,0,0.3c-0.4,0-0.7,0.1-1.1,0.1c-0.2,0-0.4,0-0.5,0c-0.5,0.1-0.9,0.2-1.3,0.4c-2,0.9-2.9,3-2,4.5
		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.1-0.7-0.2-1.1-0.3c-1.5-0.4-3.1,0.3-3.8,1.4c-0.1,0.2-0.2,0.3-0.2,0.5c-0.4,1.1,0.1,2.2,1.2,2.7
		c1.3,0.6,2.9,0.2,4-0.8l0.1-0.1c0.9-0.9,0.5-1.8,0.3-2.7c1.3,0.3,2.6,0.7,4.4,0.2c-0.6,1.4-0.3,2.5,0.3,3.5
		c0.3,0.1,0.6,0.2,0.9,0.3c0.9,0.4,1.9,0.5,2.9,0.3v-4v-3.2v-4.3v-1v-1.7v-6.5V22v-1.4L612,20.2C612.1,20.1,612,20.1,612,20.2z"
      />
      <path
        class="st3"
        d="M417.6,237.3c0.2,0.1,0.3,0.3,0.5,0.4l0,0c0.1,0.2,0.3,0.4,0.4,0.6c-0.2-0.1-0.4-0.3-0.6-0.4
		c-0.4,0-0.9-0.1-1.3-0.1c0,0,0,0,0.1,0.1l0,0l0,0c0,0,0,0-0.1,0c0.1,0.2,0.2,0.4,0.2,0.6c0.6,0.9,1.2,1.8,1.8,2.7
		c0.1,0.1,0.2,0.2,0.2,0.3l0,0c-0.1-0.1-0.1-0.2-0.2-0.3c-0.7-0.8-1.4-1.6-2.1-2.3l0,0c-0.2-0.3-0.4-0.5-0.6-0.8
		c-0.1-0.2-0.3-0.4-0.4-0.5c-0.2,0.1-0.5,0.1-0.7,0.2c-0.2,0.1-0.4,0.2-0.7,0.2c0.1-0.2,0.1-0.3,0.1-0.5c0.2-1.1-0.4-2-1.2-2.7
		c-0.1-0.1-0.3-0.1-0.4-0.2c-0.5-0.1-0.9-0.2-1.5-0.2c0.1-0.2,0.2-0.4,0.3-0.6c-0.5-0.4-1-0.8-1.5-1.2c0,0.1-0.1,0.2-0.1,0.3
		c-0.1,0.5,0.2,1.1,0.3,1.5c-0.7,0.4-1.2,0.6-1.7,0.9c-0.9,0.7-1.7,1.4-2.6,2.1c-0.6,0.5-0.4,1.2,0.3,1.3c0.3,0,0.5,0.1,0.7,0.2
		c0.1,0,0.1,0,0.2,0c0.2-0.1,0.3-0.1,0.5-0.2l0.2-0.1l-0.2,0.2c-0.2,0-0.4,0.1-0.5,0.1s-0.1,0-0.2,0.1c0.5,0.2,0.8,0.5,1.2,0.8
		c0.5,0.4,1,0.6,1.5,0.7c0.7,0.1,1.4,0,2.2-0.2c0.3-0.1,0.6-0.2,1-0.4c0,0.6,0,1.1,0.1,1.6c0.3,1.4,1.8,2.3,3.4,2.2
		c0.3,0,0.6,0,0.9-0.1c-0.1-0.2-0.2-0.4-0.4-0.5h-0.1c0-0.1-0.1-0.1-0.1-0.2c-0.2-0.2-0.4-0.3-0.6-0.5c-0.3-0.2-0.5-0.4-0.8-0.7
		c-1-1.2-1.9-2.3-2.9-3.5l0,0c-0.5-0.5-0.9-1-1.4-1.4l0,0c-0.1-0.2-0.1-0.5-0.2-0.7c0.2,0.2,0.3,0.3,0.5,0.5c0.5,0.4,1,0.9,1.5,1.3
		c1,1.1,2,2.3,2.9,3.4l0,0c0.2,0.3,0.4,0.5,0.6,0.8l0,0c0.1,0.2,0.3,0.5,0.4,0.7c0.1,0,0.1,0.1,0.2,0.1l-0.1,0.1l0.1-0.1
		c0,0,0,0,0,0.1c0.5,0,0.8,0.1,1.2,0.3c1.4-0.6,2.3-1.8,2.3-3.1c0-0.1,0-0.2,0-0.4C419.9,238.4,418.9,237.6,417.6,237.3z"
      />
      <path
        class="st3"
        d="M416.9,233.6c0.1-0.1,0.3-0.3,0.4-0.4c0.7-1,0.7-2-0.1-2.9c-0.1-0.1-0.2-0.2-0.4-0.3c-0.8-0.6-1.9-0.8-3.1-0.5
		c-0.5,0.1-0.9,0.3-1.3,0.4c-0.4,0.6-0.7,1.2-1,1.6c-0.3-0.1-0.6-0.2-0.9-0.3c0.4,0.3,0.8,0.5,1.2,0.8c1,0.9,1.9,1.7,2.9,2.6
		C415.5,234.5,416.3,234.2,416.9,233.6z"
      />
      <path
        class="st3"
        d="M411.7,232.9c-0.1-0.2-0.2-0.4-0.1-0.6c0,0.1-0.1,0.3-0.1,0.4C411.4,232.8,411.5,232.8,411.7,232.9
		C411.6,232.9,411.6,232.9,411.7,232.9C411.6,232.9,411.6,232.9,411.7,232.9z"
      />
      <path
        class="st3"
        d="M412.5,234.3c0.1,0.1,0.3,0.1,0.4,0.2c0.1,0,0.3,0,0.4,0c-0.6-0.5-1.1-1.1-1.7-1.6l0,0l0,0l0,0c0,0,0,0-0.1,0
		c0,0.1,0,0.2,0,0.3C411.9,233.6,412.2,233.9,412.5,234.3z"
      />
      <path
        class="st3"
        d="M416.5,237.8L416.5,237.8C416.5,237.8,416.6,237.8,416.5,237.8c-0.2-0.2-0.3-0.4-0.5-0.5h-0.1l0,0
		c0.1,0.1,0.1,0.2,0.1,0.4C416.2,237.7,416.4,237.8,416.5,237.8L416.5,237.8L416.5,237.8z"
      />
      <path
        class="st3"
        d="M393,254c0-0.3-0.1-0.6-0.1-0.9c-0.6-0.1-1-0.2-1.4-0.2c-0.7,0-1.5,0-2.2,0c-0.2-0.3-0.4-0.6-0.6-0.9l-0.1-0.1
		c-0.5-0.5-1.4-0.6-2-0.2c-0.4,0.2-0.6,0.5-0.8,0.7c-0.1,0.1-0.2,0.3-0.2,0.4c0.2,0.2,0.3,0.4,0.3,0.7s0,0.6,0,0.8
		c0.2,0.2,0.3,0.3,0.6,0.5c0.1,0,0.1,0.1,0.2,0.2c-0.4,0.4-0.6,0.6-0.8,0.8c0,0.4,0,0.7-0.1,1.1c0.1,0.2,0.2,0.4,0.3,0.7
		c0.3,0.5,0.6,1,0.8,1.4c2.9,0.2,2.9,0.2,3.8-0.9c0.6,0,1.3,0.1,2,0.1c0-0.1,0-0.2,0-0.3c0-0.2,0-0.4,0-0.5c0-0.2-0.1-0.6,0-0.6
		c0.7-0.3,0.5-0.8,0.4-1.2C393.2,255,393.1,254.5,393,254z"
      />
      <path
        class="st3"
        d="M476.6,203.8c-2.4,0.6-3.5,2-3.1,4c0.3,1.8,2.5,2.8,4.6,2.3c2.2-0.5,3.6-2.3,3.2-4.1c0-0.2-0.1-0.3-0.2-0.5
		s-0.2-0.4-0.3-0.5c-0.1-0.2-0.3-0.4-0.5-0.5c-0.6-0.5-1.3-0.8-2.1-0.9C477.7,203.6,477.1,203.6,476.6,203.8z M475.7,205.2
		c0,0-0.2,0.1-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.4c0.2-0.1,0.4-0.1,0.6-0.2C475.7,204.8,475.7,205,475.7,205.2z"
      />
      <path
        class="st3"
        d="M485.9,211.1c-0.6-1.2-2.2-1.9-3.9-1.6c-2,0.4-3.4,2.1-3.1,3.8c0.3,1.5,2.4,2.6,4.3,2.2
		c1.5-0.3,2.6-1.3,2.9-2.5c0.1-0.4,0.1-0.8,0.1-1.2C486.1,211.6,486,211.3,485.9,211.1z M482.4,213.8c-0.5-0.1-0.9-0.2-1.4-0.2
		c0-0.1,0-0.3,0.1-0.4c0.5,0.1,0.9,0.1,1.4,0.2C482.4,213.4,482.4,213.6,482.4,213.8z"
      />
      <path
        class="st3"
        d="M408.3,241.1c-0.1-0.1-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.3-0.6-0.4c-0.7-0.3-1.3-0.3-2-0.1c-0.1,0-0.1,0-0.2,0.1
		c-0.7,0.3-1.3,0.9-1.8,1.8c-0.4,0.1-0.9,0.1-1.2,0.3c-0.1,0-0.1,0.1-0.2,0.1c2,0.3,3.9,0.6,5.9,0.9c0,0.1,0,0.2,0,0.3
		c0.2-0.2,0.3-0.3,0.5-0.5c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0.1-0.2,0.1-0.4,0.1-0.6c0-0.1,0-0.2,0-0.3s0-0.3-0.1-0.4
		C408.6,241.6,408.5,241.3,408.3,241.1z"
      />
      <path
        class="st3"
        d="M401.2,243.5C401.2,243.5,401.1,243.4,401.2,243.5c-0.6-0.1-1.1-0.2-1.6-0.3c0-0.2,0.1-0.3,0.1-0.5
		c-0.3-0.1-0.7-0.1-1,0c-0.4,0.1-0.8,0.4-1.1,0.8c-0.1,0.1-0.1,0.2-0.1,0.2c-0.3,0.6,0,1.3,0.7,1.6c0.3,0.1,0.6,0.2,0.9,0.2
		c0.2,0,0.3,0,0.5-0.1c0.1,0,0.3-0.1,0.4-0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.1c0.3,0.4,0.6,0.7,0.9,1
		c0.8-0.8,1.5-1.5,2.2-2.2c0.4,0.2,0.8,0.4,1.2,0.5c0.9,0.3,1.6,0.3,2.3,0C405.3,244.1,403.3,243.8,401.2,243.5L401.2,243.5z"
      />
      <path
        class="st3"
        d="M482.5,196.8c0.1-0.3,0.1-0.7,0-1.1c-0.2-0.9-1.1-1.6-2.2-1.8c-0.5-0.1-1.1-0.1-1.7,0
		c-1.4,0.3-2.3,1.3-2.5,2.3c-0.1,0.3-0.1,0.6,0,0.9c0.1,0.4,0.3,0.7,0.5,0.9c1.6,0,3.1,0.2,4.7,0.4
		C481.9,198,482.3,197.4,482.5,196.8z"
      />
      <path
        class="st3"
        d="M454.2,270c-1.4,0.2-2.4,1.1-2.6,2.1h5.9c0-0.1,0-0.2,0-0.3C457.3,270.6,455.8,269.8,454.2,270z"
      />
      <path
        class="st3"
        d="M551.7,169.9c0.4,0.2,0.7,0.3,1.1,0.5c0-0.6-0.4-0.8-0.7-1C551.9,169.6,551.8,169.8,551.7,169.9
		C551.7,170,551.7,169.9,551.7,169.9z"
      />
      <path
        class="st3"
        d="M558.4,171.5c0-0.5,0-1,0.1-1.5c-0.5,0-1-0.1-1.5-0.1c-0.1,0-0.1,0-0.2,0c-0.2,0-0.3,0-0.5,0
		c-0.4,0.6-0.7,1.3-0.5,1.7c0,0.1,0,0.2,0.1,0.3c0,0,0.1,0,0.1-0.1c0.1,0.3,0.1,0.5,0.1,0.7c1.1-0.2,1.8-0.4,2.2-0.7
		C558.4,171.7,558.4,171.6,558.4,171.5z"
      />
      <path
        class="st3"
        d="M551.7,170c0.1-0.2,0.2-0.5,0.3-0.7c-0.6-0.6-1.4-0.5-2.2-0.2c-0.4,0.1-0.7,0.3-1.1,0.5
		c-0.1,0.2-0.2,0.3-0.3,0.5c0.1,0.4,0.1,0.8,0.1,1.2c0.3,0.4,0.8,0.7,1.5,0.8l0,0C550.4,171.3,550.9,170.6,551.7,170z"
      />
      <path
        class="st3"
        d="M553.9,170.6c0.1-0.2,0.3-0.4,0.4-0.5c-0.3,0.1-0.7,0.3-1.1,0.6C553.4,170.6,553.7,170.6,553.9,170.6z"
      />
      <path
        class="st3"
        d="M537.4,224.8c-0.2,0-0.3-0.1-0.5-0.1c-0.6-0.1-1.1-0.1-1.5-0.6c-0.1-0.2-0.4-0.4-0.7-0.4s-0.7,0-1,0.2
		c-0.2,0.1-0.2,0.4-0.2,0.7c1.6,0.2,3.2,0.4,4.8,0.7C538.1,225.1,537.8,224.9,537.4,224.8z"
      />
      <path
        class="st3"
        d="M535.2,226.6c-0.5-0.1-0.9-0.2-1.4-0.3c-0.1,0.1-0.1,0.3-0.1,0.4c-0.3,1.3,0.5,2.3,2,2.6
		c0.7,0.1,1.4,0,1.9-0.3C536.7,227.9,536.1,226.9,535.2,226.6z"
      />
      <path
        class="st3"
        d="M493.2,185.5c0.3-0.3,0.6-0.7,0.9-1c-0.4,0-0.7,0-1,0.1c-0.1,0.2-0.2,0.3-0.3,0.5
		C492.9,185.2,493.1,185.3,493.2,185.5z"
      />
      <path
        class="st3"
        d="M494.5,187.3c0.4,0,0.8,0,1.3,0c0-0.1,0-0.2,0-0.2C495.4,187.1,495,187.1,494.5,187.3
		C494.5,187.2,494.5,187.3,494.5,187.3z"
      />
      <path
        class="st3"
        d="M500.9,191.1c-0.9,0.1-1.8,0.2-2.8,0.3c0-0.3,0-0.6-0.1-0.9c0.8,0,1.6,0,2.5,0l0,0c-0.1-0.4-0.7-0.8-1.2-1
		c-0.1,0-0.3-0.1-0.4-0.1c-1.5,0.1-3,0.3-4.3,0.9c-0.1,0.1-0.3,0.1-0.4,0.2c0,0.3,0.1,0.7,0.2,1c0.3,0.5,1,0.7,1.9,0.5
		c0.4-0.1,0.8-0.2,1.3-0.3c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0,0.8-0.1,1.1-0.1c0.3,0,0.7,0.2,1.1,0.4c0.4-0.5,0.8-1,1.2-1.6
		C501.4,191.5,501.1,191.3,500.9,191.1z"
      />
      <path
        class="st3"
        d="M529.9,226.5c0.1-0.2,0.1-0.4,0.1-0.6c-0.3,0-0.6-0.1-0.9-0.1l0,0C529.4,226,529.6,226.3,529.9,226.5z"
      />
      <path
        class="st3"
        d="M532.1,227.2c-0.2-0.1-0.5-0.3-0.7-0.3c-0.4-0.1-0.8-0.2-1.2-0.2c0.2,0.1,0.3,0.3,0.5,0.4
		c-0.1,0.1-0.2,0.2-0.3,0.4c0.1-0.1,0.2-0.2,0.3-0.4c0.3,0.2,0.7,0.4,1,0.7c-0.4-0.1-0.9-0.2-1.3-0.3c-0.1,0.1-0.2,0.1-0.2,0.2
		c0,0.1,0,0.3,0,0.3c1,0.4,2,0.7,3.1,1.1C533.2,228.4,532.8,227.7,532.1,227.2z"
      />
      <path
        class="st3"
        d="M528.8,223.8c-0.4,0.4-0.6,0.8-0.6,1.1c0,0.2,0,0.4,0.1,0.5c0.3,0.1,0.6,0.3,0.9,0.4l-0.1-0.1h0.1
		c0.2-0.3,0.5-0.6,0.7-1C529.6,224.4,529.3,224.1,528.8,223.8z"
      />
      <path
        class="st3"
        d="M529.5,229.9c0.5,0.4,1.1,0.8,1.6,1.2c0,0,0.1,0,0.1,0.1c0.5,0.1,0.9-0.1,1.1-0.4c0.1-0.2,0.1-0.3,0.2-0.5
		c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0.1-0.1,0.1-0.1s0.1-0.1,0.1-0.2c-1.2,0-2.4-0.3-3.6-0.5C529.3,229.7,529.4,229.8,529.5,229.9z"
      />
      <path
        class="st3"
        d="M399.6,241.7c0.3,0,0.7,0,1.1-0.1c1-0.2,1.8-0.8,2.1-1.6l0,0c-1.3,0.5-2.7,0.9-4,1.4c0.2,0.1,0.4,0.2,0.7,0.2
		C399.5,241.7,399.6,241.7,399.6,241.7z"
      />
      <path
        class="st3"
        d="M399.9,237.2c-1.5,0.3-2.5,1.4-2.4,2.7c0,0.2,0.1,0.4,0.2,0.6c1.7-0.4,3.4-0.7,5.2-1.1c0-0.2,0-0.3,0-0.5
		C402.8,237.8,401.3,237,399.9,237.2z"
      />
      <path
        class="st3"
        d="M494.2,196.5c-0.4-1.1-1.5-1.6-2.8-1.5c-1,0.1-2,0.9-2.3,1.7c-0.4,1,0.1,2,1.1,2.5c1.1,0.5,2.2,0.3,3.2-0.5
		c0.5-0.4,1-0.8,1.7-1.3C494.2,197.5,494.4,196.9,494.2,196.5z"
      />
      <path
        class="st3"
        d="M396.2,232.6c0.3,0.3,0.6,0.5,1,0.6c0.5,0.2,1.2,0.2,1.8,0c0.5-0.1,1-0.4,1.3-0.7c0,0,0.1,0,0.1-0.1
		c0.7-0.8,0.8-2,0.2-2.7l0,0c-0.6-0.8-1.9-1-3.1-0.6c-0.5,0.2-1,0.4-1.4,0.7c-0.1,0.4-0.3,0.8-0.4,1.1
		C395.7,231.5,395.8,232.1,396.2,232.6z"
      />
      <path
        class="st3"
        d="M396.8,247c-0.2-0.2-0.4-0.4-0.7-0.4c-0.6,0-1.2,0.2-1.9,0.3c-0.6-1.5-1.3-1.9-2.8-1.6c-0.3,0.1-0.6,0.2-1,0.4
		c0.4,0.3,0.6,0.5,0.9,0.7c-0.5,0.5-1,1-1.5,1.5c-0.1,0.1-0.1,0.1-0.2,0.2c0.5,0.4,0.8,0.7,1.2,0.9c0.8,0.3,1.6,0.1,2.9-0.8
		c1.3,1,1.8,1.1,2.6,0.6C397.1,248.2,397.3,247.5,396.8,247z"
      />
      <path
        class="st3"
        d="M578.4,181.2c-1.1-0.1-2.1-0.3-3.2-0.7c0-0.3,0.1-0.5,0.1-0.8c1.4,0.1,2.8,0.3,4.1,0.5
		c0.1-0.2,0.2-0.3,0.3-0.5c0-0.1,0.1-0.3,0.1-0.4c0-0.2,0-0.3,0-0.5c-0.2-1.2-1.6-2-3-1.7c-0.1,0-0.1,0-0.1,0
		c-1.2,0.3-2.1,1.3-2,2.4c0,0.1,0,0.1,0,0.2c0.1,0.9,1,1.6,2,1.7c0.3,0,0.7,0,1,0C577.9,181.4,578.1,181.4,578.4,181.2
		C578.4,181.3,578.4,181.2,578.4,181.2z"
      />
      <path
        class="st3"
        d="M310.7,243.6c-0.4,0.1-0.8,0.3-1.1,0.5c-0.1,0.1-0.2,0.2-0.3,0.3c-0.2,0.2-0.3,0.4-0.5,0.6
		c0.1,0.5,0.2,1,0.3,1.5c-0.2,0-0.3,0-0.5,0c0.3,0.8,1,1.3,1.9,1.4c0.3,0,0.6,0,0.9,0c0.5-0.1,0.9-0.3,1.2-0.5
		c0.1-0.1,0.3-0.2,0.4-0.3c0.4-0.4,0.7-1,0.6-1.5c0-0.1,0-0.2,0-0.3C313.4,244,312,243.3,310.7,243.6z"
      />
      <path
        class="st3"
        d="M396.1,229.7C396.1,229.7,396.1,229.8,396.1,229.7C396.1,229.8,396.1,229.8,396.1,229.7
		C396.1,229.7,396.2,229.7,396.1,229.7L396.1,229.7z"
      />
      <path
        class="st3"
        d="M394.8,228.6c-0.1-0.4-0.1-0.9-0.3-1.3c-0.4-1.1-2.4-1.5-3.5-0.7c-0.4,0.3-0.8,0.9-0.8,1.5c0,0.1,0,0.2,0,0.2
		c0,0.1,0,0.3,0.1,0.4c0.1,0.3,0.2,0.5,0.4,0.6c0.1,0.1,0.3,0.2,0.4,0.3c0.3,0.1,0.6,0.3,0.9,0.3c0.2,0,0.4,0,0.6,0l0,0
		c0.3,0,0.6,0,0.8,0.1c1,0.4,1.8,0.2,2.7-0.3c0.1-0.2,0.2-0.4,0.3-0.7C395.8,228.9,395.3,228.7,394.8,228.6z"
      />
      <path
        class="st3"
        d="M555.5,197.6c0.2-0.3,0.4-0.6,0.6-0.9c0.4-0.1,0.7-0.1,0.9-0.1c0-0.1,0-0.1,0-0.2c-0.4-0.1-0.9-0.2-1.3-0.2
		l0.1-0.1c0.3,0,0.5,0,0.8-0.1c0-0.1,0-0.2,0-0.3c-1.3,0-2.6-0.1-3.9-0.1c-0.2,0-0.4,0.1-0.5,0.1c-1.2,0.3-1.7,0.6-1.9,1.2
		c-0.1,0.4,0,0.8,0.1,1.5c0.5,0,0.9,0,1.4,0c0.1,0,0.1,0,0.2,0c0,0.2,0.1,0.4,0.1,0.7c0.8-0.2,1.4-0.5,2.1-0.5
		C555,198.3,555.3,198.1,555.5,197.6z"
      />
      <path
        class="st3"
        d="M512.7,202.8c0.5-0.4,0.9-0.9,0.8-1.1c-0.1-0.2-0.2-0.3-0.2-0.5c-1,0.3-2.1,0.5-3.1,0.5c0.2,0.4,0.3,0.7,0.6,1
		c0.1,0.1,0.2,0.1,0.2,0.2h0.1C511.6,203,512.1,202.9,512.7,202.8z"
      />
      <path
        class="st3"
        d="M513.7,199.9c0.5-0.9,0.4-1.1-0.8-1.7c-0.5,0.3-0.9,0.8-1.4,0.9c-0.9,0.1-1.4,0.6-2,1.2c0,0.1,0.1,0.2,0.1,0.3
		c1.2,0.2,2.4,0.4,3.6,0.6C513.2,200.7,513.5,200.3,513.7,199.9z"
      />
      <path
        class="st3"
        d="M414.1,244.4c-0.5-0.6-1.4-0.9-2.3-0.7c-0.1,0-0.3,0.1-0.4,0.1c-1,0.4-1.6,1.4-1.4,2.3
		c0.3,1.1,1.5,1.6,2.8,1.3c1.2-0.3,1.9-1.3,1.7-2.3C414.4,244.9,414.3,244.6,414.1,244.4z"
      />
      <path
        class="st3"
        d="M555.9,215.2c0.5-0.2,1-0.4,1.5-0.6c0.1-0.1,0.2-0.1,0.3-0.2c0.3-0.2,0.4-0.4,0.5-0.7c-0.7,0-1.4,0-2.1,0
		c0-0.2,0-0.3,0-0.5c0.8,0,1.5,0,2.3,0c0-0.2,0-0.4-0.1-0.7c-0.1-0.4-0.4-0.7-0.9-0.9c-1.6-0.5-3.7,0.8-3.6,2.3c0,0.5,0.3,1-0.1,1.7
		C554.6,215.5,555.3,215.4,555.9,215.2z"
      />
      <path
        class="st3"
        d="M316.5,238.8c-0.3-0.1-0.6-0.2-1-0.2c0,0.1,0,0.1,0,0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-1.3,0.3-2.1,1.3-1.9,2.3
		s1.3,1.6,2.5,1.3c0.6-0.1,1.2-0.4,1.5-0.8c0.3-0.4,0.5-0.9,0.4-1.4C317.5,239.5,317.1,239,316.5,238.8z"
      />
      <path
        class="st3"
        d="M584.4,201.2c0.2,0,0.5,0,0.7,0c-0.1-1-0.4-1.7-1-2.1c-0.2-0.2-0.4-0.3-0.7-0.4c-0.1,0-0.3-0.1-0.4-0.1
		c-0.3-0.1-0.6-0.1-1-0.1c-1.4,0.1-2.4,0.8-2.7,1.8c-0.1,0.3-0.2,0.6-0.2,0.9c1.4,0,2.7-0.1,4.2-0.1
		C583.7,201.2,584.1,201.2,584.4,201.2z"
      />
      <path
        class="st3"
        d="M309.6,239.2c0.1,0,0.1,0,0.2,0c1.2-0.3,2-1.3,1.7-2.3l0,0c-0.2-0.8-1.1-1.4-2.1-1.3c0,0.7-0.1,1.4-0.1,2.1
		c0,0.6,0,1.1-0.2,1.6C309.3,239.2,309.4,239.2,309.6,239.2z"
      />
      <path
        class="st3"
        d="M307.7,236.8c0.1,0,0.3-0.1,0.4-0.1c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1,0-0.1,0.1-0.1,0.2
		C307.7,236.4,307.7,236.6,307.7,236.8z"
      />
      <path
        class="st3"
        d="M307.1,237.9L307.1,237.9C307.1,238,307.1,238,307.1,237.9c0.1-0.4,0.3-0.9,0.4-1.4c-0.1,0.1-0.2,0.2-0.3,0.4
		C307.1,237.2,307,237.5,307.1,237.9z"
      />
      <path
        class="st3"
        d="M506.5,197c0,0.1-0.1,0.2,0,0.3c0.1,0.4,0.2,0.8,0.4,1.1c0.2,0.4,0.6,0.8,1.3,0.5c0.6-0.2,0.6-0.6,0.5-1.1
		c0-0.4-0.2-0.9,0-1.2c1.3-1.5,0.5-2.6-0.5-3.7C506.7,194.2,505.5,195.3,506.5,197z"
      />
      <path
        class="st3"
        d="M321.2,234.5L321.2,234.5v-0.1c-0.4-0.6-1-0.8-1.8-0.8c-0.6,0.1-1.2,0.3-1.4,0.7c-0.1,0.1-0.1,0.3-0.2,0.4
		c-0.1,0.7-0.6,1-1,1.4c-0.1,0.1-0.1,0.1-0.2,0.2c0.3,0.5,0.4,0.7,0.6,0.9s0.5,0.2,1,0.3c0.2-0.1,0.3-0.3,0.5-0.4
		c0.1-0.1,0.2-0.2,0.4-0.3c0.1,0.3,0.1,0.4,0.2,0.5c0.1-0.1,0.3-0.2,0.4-0.3s0.2-0.1,0.2-0.2c0.3-0.2,0.6-0.4,0.9-0.6
		C321.4,235.7,321.5,235,321.2,234.5z M318.5,234.9c0-0.1,0-0.3,0-0.4c0.7,0,1.4,0,2.1,0c0,0.1,0,0.3,0,0.4
		C319.9,234.9,319.2,234.9,318.5,234.9z"
      />
      <path
        class="st3"
        d="M471.1,236.5c-1.2,0.3-1.9,1.4-1.6,2.4c0.3,0.9,1.4,1.4,2.5,1.1c1.2-0.3,2-1.4,1.7-2.3
		C473.4,236.8,472.1,236.2,471.1,236.5z M473.3,238.8c-1-0.3-2-0.7-3.1-1c0.1-0.3,0.2-0.6,0.3-0.9c1,0.4,2,0.7,3,1.1
		C473.5,238.2,473.4,238.5,473.3,238.8z"
      />
      <path
        class="st3"
        d="M601.7,187.1L601.7,187.1c0.6-0.1,1.1-0.4,1.4-0.7s0.4-0.6,0.5-1c-0.3,0-0.7,0-1-0.1c0-0.1,0-0.3,0-0.4
		c0.4,0,0.7,0,1.1-0.1c-0.2-0.9-1.2-1.5-2.4-1.3c-0.2,0-0.3,0.1-0.5,0.1c-0.8,0.3-1.4,1.1-1.3,2c0,0.2,0.1,0.3,0.1,0.4
		C599.9,186.8,600.8,187.3,601.7,187.1z"
      />
      <polygon class="st3" points="562.9,183.8 563.2,183.7 562.8,183.6 	" />
      <path
        class="st3"
        d="M559.5,184.3L559.5,184.3c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.3,0,0.4,0c0-0.1,0-0.1,0-0.2
		C559.9,184.3,559.7,184.3,559.5,184.3L559.5,184.3z"
      />
      <path
        class="st3"
        d="M501.9,180.6c-0.6-0.3-1.1-0.3-1.7-0.1c0,1,0,2-0.2,2.9c0.3,0.1,0.7,0.1,1.2,0.1c0.2,0,0.4,0.1,0.5,0.2l0,0
		c0.3,0.2,0.5,0.3,0.7,0.3s0.4-0.2,0.7-0.8c-0.1-0.1-0.2-0.1-0.3-0.2l0,0c-0.1-0.1-0.3-0.2-0.4-0.3
		C502.8,181.5,502.7,181,501.9,180.6z"
      />
      <path
        class="st3"
        d="M585.9,184.3c0,0.4,0.4,0.8,0.9,0.6c0.4-0.2,0.8-0.4,1.1-0.6C587.3,184.3,586.6,184.3,585.9,184.3z"
      />
      <path
        class="st3"
        d="M589.4,183.3c0.5-0.4,0.5-1,0.1-1.4c-0.2-0.2-0.3-0.4-0.5-0.5s-0.4-0.2-0.6-0.4c-0.6,0-1.2,0-1.7,0
		c-0.2,0.7-0.3,1.4-0.5,2.2c0.6,0.3,1.2,0.6,1.9,1C588.5,184,589,183.7,589.4,183.3z"
      />
      <path
        class="st3"
        d="M554.4,174.2c0-0.1-0.1-0.2-0.1-0.2c0-0.1-0.1-0.2-0.2-0.3c-0.9,1-1.6,1.7-2.3,2.5c-0.1-0.1-0.2-0.2-0.3-0.2
		c0,0.1-0.1,0.2-0.1,0.2c-0.2,0.6,0.3,1,0.9,1.4c0.5,0.3,1.1,0.1,1.5-0.2c0.2-0.1,0.4-0.3,0.6-0.4c0.2-0.5,0.3-1.1,0.4-1.6
		C554.6,174.9,554.5,174.5,554.4,174.2z"
      />
      <path
        class="st3"
        d="M567.3,186.9L567.3,186.9L567.3,186.9c0.2-0.1,0.2-0.1,0.3-0.1c-0.5-0.3-1.1-0.5-1.8-0.4
		c-0.1,0-0.2,0.1-0.3,0.1c-0.2,0.1-0.4,0.2-0.6,0.3c0.8,0.1,1.5,0.1,2.2,0.2C567.1,186.9,567.2,186.9,567.3,186.9L567.3,186.9z"
      />
      <path
        class="st3"
        d="M566.5,189.7L566.5,189.7c0.6-0.1,1-0.5,1.3-0.9s0.4-0.8,0.3-1.1l0,0c-0.1-0.3-0.2-0.5-0.5-0.7
		c-0.1,0-0.2,0-0.3,0l-0.1,0.1c-0.1,0-0.2,0-0.2,0c-1,0.2-1.9,0.5-2.9,0.7c-0.1,0.2-0.1,0.5,0,0.7c0,0.2,0.1,0.3,0.2,0.4
		C564.7,189.5,565.6,189.9,566.5,189.7z"
      />
      <path
        class="st3"
        d="M553.5,186c0,0.1,0,0.3,0,0.4c0.3,0.1,0.6,0.2,0.8,0.2C554.1,186.3,553.9,186.1,553.5,186z"
      />
      <path
        class="st3"
        d="M347.4,265c-1.1,0.3-1.8,1.2-1.5,2c0.2,0.8,1.2,1.3,2.2,1.1c1.1-0.2,1.9-1.1,1.7-2
		C349.5,265.2,348.5,264.8,347.4,265z"
      />
      <path
        class="st3"
        d="M341.2,272.2h0.4c0-0.1,0-0.3-0.1-0.4C341.4,271.9,341.3,272,341.2,272.2z"
      />
      <path
        class="st3"
        d="M343.7,271.1c-0.1,0-0.3,0-0.4,0V271c-0.1,0-0.3,0-0.4,0c-0.5,0.1-0.9,0.4-1.2,0.7c0,0.2,0,0.3,0,0.5h3.3
		C344.8,271.6,344.3,271.2,343.7,271.1z"
      />
      <path
        class="st3"
        d="M446.2,208.7c-0.3-0.1-0.7-0.1-1,0c-0.8,0.2-1.4,0.8-1.6,1.4c0,0.1,0,0.3,0,0.4c0,0.3,0.2,0.5,0.4,0.7
		c0.5,0.4,1.2,0.6,1.9,0.4c0.9-0.2,1.5-0.9,1.5-1.7c0-0.1,0-0.2,0-0.3C447.2,209.3,446.8,208.9,446.2,208.7z"
      />
      <path
        class="st3"
        d="M327.2,237.6c-0.3-0.7-1.2-1.1-2.1-0.9c-1,0.2-1.7,1.1-1.5,1.9c0,0,0,0.1,0.1,0.1s0.2,0,0.3,0
		c0,0.1,0,0.2,0,0.3h-0.1c0.3,0.4,0.7,0.6,1.3,0.7c0.2,0,0.4,0,0.6-0.1c0.3-0.1,0.5-0.2,0.7-0.3c-0.2-0.1-0.4-0.1-0.6-0.2
		c0.1-0.3,0.1-0.6,0.2-0.9c0.4,0.1,0.7,0.1,1.1,0.2c0.1-0.2,0.1-0.5,0.1-0.7C327.3,237.8,327.2,237.7,327.2,237.6z"
      />
      <path
        class="st3"
        d="M314.6,230.8c-0.3-0.1-0.5-0.2-0.9-0.3c-0.2,0-0.4,0-0.6,0c-0.9,0.2-1.6,1-1.5,1.8c0.1,0.9,1,1.4,2.1,1.2
		c0.4-0.1,0.7-0.2,0.9-0.4c0.2-0.1,0.4-0.3,0.5-0.5c0.2-0.3,0.2-0.6,0.2-0.9C315.2,231.3,315,231,314.6,230.8z M314.1,232.3
		c-0.5-0.3-0.9-0.6-1.4-0.9c0.1-0.2,0.2-0.3,0.3-0.5c0.5,0.3,0.9,0.5,1.4,0.8C314.3,231.9,314.2,232.1,314.1,232.3z"
      />
      <path
        class="st3"
        d="M482,222.6c-0.2,0-0.4,0-0.6,0c0.1,0.1,0.1,0.2,0.2,0.2c0.2,0,0.4,0,0.5,0C482.1,222.8,482.1,222.6,482,222.6z
		"
      />
      <path
        class="st3"
        d="M586.2,187.6c-0.1-0.7-1.4-1.2-2.3-1c-0.9,0.2-1.5,1-1.4,1.8s1,1.3,1.9,1.2
		C585.5,189.3,586.4,188.4,586.2,187.6z"
      />
      <path
        class="st3"
        d="M531.3,210.5c-0.1-0.2-0.2-0.4-0.3-0.6c-1,0-2.1,0.1-3.1,0.1c0.8,1.3,0.8,1.3,2.3,1.4
		C531,211.5,531.5,211.1,531.3,210.5z"
      />
      <path
        class="st3"
        d="M528.4,208.7c-0.1,0.1-0.1,0.3-0.2,0.4c0.4,0,0.7-0.1,1.1-0.1C529,208.9,528.8,208.8,528.4,208.7
		C528.5,208.6,528.5,208.7,528.4,208.7z"
      />
      <path
        class="st3"
        d="M529.8,208.9c0.4-0.1,0.8-0.1,1.3-0.1c-0.1-0.4-0.4-0.6-0.6-0.9C529.5,208.1,529.6,208.5,529.8,208.9z"
      />
      <path
        class="st3"
        d="M526.8,233.8c-0.7,0.2-1.3,0.6-2,0.9c-0.1,0.4,0,0.7,0.1,1c0.2,0.4,0.5,0.8,1,1.1c0.9-0.4,1.6-0.8,2.3-1.1
		c0.2-0.1,0.4-0.2,0.6-0.4c0.2-0.2,0.4-0.4,0.4-0.8c-0.4-0.2-0.8-0.5-1.3-0.7C527.5,233.7,527.1,233.7,526.8,233.8z"
      />
      <path
        class="st3"
        d="M579.1,197.4c0.4,0.1,0.8,0.2,1.2,0.1c0.1,0,0.3-0.1,0.4-0.1c0.4-0.2,0.7-0.5,0.8-0.9c0.1-0.3,0.1-0.6,0-0.9
		c-0.2-0.7-1.1-1.1-2-0.9c0,0,0,0-0.1,0c-0.3,0.1-0.6,0.3-0.8,0.5s-0.3,0.4-0.4,0.7c-0.1,0.3-0.1,0.5,0,0.8
		C578.4,197,578.7,197.3,579.1,197.4z"
      />
      <path
        class="st3"
        d="M592.6,220.9c0-0.2-0.2-0.4-0.3-0.6c-0.4-0.3-0.9-0.5-1.5-0.4c-0.1,0-0.2,0-0.3,0.1c-0.7,0.2-1.1,0.8-1.1,1.4
		c0.7-0.1,1.5-0.1,2.2-0.2c0,0.3-0.1,0.5-0.1,0.8c-0.6,0-1.2,0.1-1.7,0.1c0.3,0.3,0.8,0.5,1.4,0.5
		C591.9,222.5,592.7,221.6,592.6,220.9z"
      />
      <path
        class="st3"
        d="M519.2,248c-0.5-0.1-1.1-0.1-1.6-0.1c-0.8,0-1.5,0-2.3,0.1c-0.7,0.1-1.5,0.1-2.3,0.2c-0.1,0-0.2,0-0.3,0
		c0.2,0.2,0.4,0.3,0.6,0.5c0.9,0.6,1.8,0.9,2.8,0.8c0.3,0,0.6-0.1,0.9-0.2C517.8,249,518.5,248.6,519.2,248z"
      />
      <path
        class="st3"
        d="M585.9,222.4c-0.8,0.1-1.6,0.1-2.4,0.2c-0.2,0.2-0.4,0.5-0.4,0.7s0,0.4,0,0.5c0.1,0.5,0.7,0.8,1.3,0.9
		c0.2,0,0.5,0.1,0.8,0c0.9-0.2,1.4-1,1.3-1.7C586.3,222.8,586.1,222.6,585.9,222.4z"
      />
      <path
        class="st3"
        d="M417.8,247.4c-0.9,0.2-1.4,1-1.2,1.8c0.1,0.4,0.4,0.6,0.7,0.8c0.3,0.1,0.7,0.2,1.1,0.1c0.5-0.1,1-0.5,1.2-0.9
		c0.1-0.3,0.2-0.5,0.1-0.8C419.6,247.6,418.7,247.2,417.8,247.4z"
      />
      <path
        class="st3"
        d="M519.2,249.9L519.2,249.9c0.2,0.5,0.3,0.9,0.5,1.3c-0.3,0-0.6-0.1-0.9-0.1C518.9,250.7,519,250.3,519.2,249.9
		C519.1,249.9,519.1,249.9,519.2,249.9c-0.4-0.2-0.8-0.3-1.3-0.1c-0.8,0.2-1.3,0.9-1.2,1.6c0.1,0.7,1,1.2,1.9,1s1.4-1,1.3-1.7
		C519.7,250.3,519.5,250.1,519.2,249.9z"
      />
      <path
        class="st3"
        d="M602.2,189.6c-0.8,0-1.6,0.3-2,1.2c0.3,0.3,0.5,0.7,0.8,0.9c0.6,0.4,1.2,0.3,1.9-0.1c0.5-0.3,0.8-0.6,0.7-1.2
		C603.5,189.9,603,189.6,602.2,189.6z"
      />
      <path
        class="st3"
        d="M546.1,187.3c0.2,0,0.5,0,0.7,0v-0.1l0,0c-0.2,0-0.4,0-0.7,0V187.3z"
      />
      <path
        class="st3"
        d="M317.9,228c0.8-0.2,1.3-0.8,1.2-1.4c-0.1-0.7-1-1.1-1.8-0.9c-0.7,0.2-1.3,0.8-1.2,1.4
		C316.3,227.8,317,228.2,317.9,228z"
      />
      <path
        class="st3"
        d="M306.7,269.4c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1v2.3c0.1,0,0.3,0,0.4,0h0.1c0.5-0.1,0.8-0.4,1-0.7
		c-0.2,0-0.3,0-0.5,0c0-0.2,0.1-0.3,0.1-0.5c0.2,0,0.3,0,0.5,0c0-0.1,0-0.2,0-0.3C307.7,269.8,307.2,269.5,306.7,269.4z"
      />
      <path
        class="st3"
        d="M306.2,269.4c0.1,0,0.1,0,0.2-0.1C306.3,269.4,306.2,269.3,306.2,269.4L306.2,269.4z"
      />
      <path
        class="st3"
        d="M306.8,259.6c0.5-0.3,0.9-0.9,0.8-1.3c-0.1-0.3-0.3-0.5-0.6-0.7c-0.1,0-0.1-0.1-0.2-0.1c-0.2,0-0.3-0.1-0.5,0
		c-0.1,0.1-0.1,0.3-0.2,0.4v0.2v1.6c0.1,0,0.2,0,0.3,0C306.6,259.7,306.7,259.6,306.8,259.6z"
      />
      <path
        class="st3"
        d="M565.8,190.2c-0.1,0-0.3,0.1-0.4,0.1c-0.4,0.2-0.7,0.6-0.8,1c0,0.1,0,0.2,0,0.4c0.1,0.6,0.7,1.1,1.3,0.9
		c0.6-0.1,1.1-0.6,1.4-1.1c0.1-0.2,0.2-0.5,0.2-0.7s-0.2-0.4-0.5-0.5C566.5,190.2,566.1,190.1,565.8,190.2z"
      />
      <path
        class="st3"
        d="M324,269.6C323.9,269.6,323.9,269.6,324,269.6c-0.2,0.1-0.4,0.1-0.5,0.2c-1,0.4-1.4,1-1.3,1.8
		c0,0.2,0.1,0.4,0.1,0.6h0.5h0.3c0.6-0.2,1-0.4,1.2-0.7C324.6,271,324.5,270.4,324,269.6L324,269.6z"
      />
      <path
        class="st3"
        d="M584.5,218.4c-1.4,0.1-2.6,0.3-4,0.4c0.7,1.2,1.1,1.5,2.2,1.3C583.7,219.9,584.3,219.4,584.5,218.4z"
      />
      <path
        class="st3"
        d="M592.9,225.1c-0.8,0.2-1.2,0.8-1,1.5c0.2,0.6,0.8,0.9,1.5,0.7s1.1-0.8,1-1.3
		C594.3,225.3,593.5,225,592.9,225.1z"
      />
      <path
        class="st3"
        d="M519,238L519,238c-0.2,0-0.3,0-0.5,0c-0.7,0.1-1.2,0.7-1.2,1.3c0,0.4,0.4,0.7,0.8,0.9c0.2,0.1,0.5,0.1,0.8,0
		c0.2-0.1,0.4-0.2,0.6-0.3c-0.2,0-0.4-0.1-0.5-0.1c0-0.1,0-0.2,0-0.3c0.3,0,0.6,0,0.9,0c0.1-0.2,0.1-0.4,0.1-0.5
		C519.8,238.4,519.5,238.1,519,238z"
      />
      <path
        class="st3"
        d="M322.5,243.7c0.2-0.5,0-0.9-0.5-1.1c-0.9-0.4-1.5,0.1-2,0.6c0,0.7,0.3,1.3,1.2,1.4
		C321.7,244.6,322.3,244.3,322.5,243.7z"
      />
      <path
        class="st3"
        d="M522.5,245c-0.7,0.3-0.9,0.7-0.8,1.7c0.5,0,0.9,0,1.3-0.1c0.7-0.2,1.3-0.5,1.9-1.1c-0.4-0.4-0.8-0.6-1.2-0.7
		S522.9,244.8,522.5,245z"
      />
      <path
        class="st3"
        d="M489.4,206.7c-0.5,0.1-0.9,0.6-1,1c0,0.1,0,0.2,0,0.3c0.2,0.5,0.9,0.9,1.6,0.7c0.1,0,0.2-0.1,0.3-0.2
		c0.5-0.3,0.7-0.7,0.6-1.2S490.1,206.5,489.4,206.7z"
      />
      <path
        class="st3"
        d="M567.3,201.5C567.2,201.5,567.2,201.5,567.3,201.5c-0.2,0.1-0.2,0.1-0.3,0.2c-0.2,0.3-0.2,0.8,0.1,1.3
		c0.3,0.4,0.8,0.6,1.4,0.3c0.4-0.2,0.7-0.4,1.2-0.7c-0.2-0.3-0.3-0.4-0.4-0.6C568.8,201.4,567.9,201.2,567.3,201.5z"
      />
      <path
        class="st3"
        d="M589.5,198.6c0-0.2-0.2-0.3-0.3-0.4c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2-0.1-0.5-0.1-0.7,0
		c-0.4,0.1-0.6,0.3-0.8,0.6c-0.1,0.2-0.2,0.5-0.1,0.8c0.2,0.5,0.8,0.8,1.4,0.7c0.5-0.1,1-0.6,1-1
		C589.5,198.8,589.5,198.7,589.5,198.6z"
      />
      <path
        class="st3"
        d="M464.1,242c-0.5,0.1-0.9,0.5-1,0.9c0,0.1,0,0.3,0,0.4c0.1,0.6,0.8,0.9,1.5,0.7c0.1,0,0.2-0.1,0.3-0.1
		c0.5-0.2,0.9-0.8,0.8-1.2C465.6,242.2,464.8,241.9,464.1,242z"
      />
      <path
        class="st3"
        d="M503.1,198.5c-0.4,0.5-0.7,1.1-1.1,1.6h-0.1c0.4,0,0.8,0,1.3,0.1c0.2-0.2,0.3-0.3,0.5-0.5
		C504.1,199.1,504.1,198.7,503.1,198.5z"
      />
      <path
        class="st3"
        d="M501.7,201.8c0.2-0.2,0.3-0.4,0.5-0.5c-0.3,0-0.6,0-0.9,0C501.5,201.4,501.6,201.6,501.7,201.8z"
      />
      <path
        class="st3"
        d="M525.2,204c-0.2-0.3-0.4-0.6-0.5-1c-0.5,0.1-1,0.2-1.4,0.3c-0.1,0.1-0.1,0.2-0.2,0.3c0.1,0.1,0.1,0.1,0.1,0.2
		c0.1,0.1,0.1,0.2,0.2,0.2c0.6,0,1.3,0.1,1.9,0.1C525.3,204.1,525.2,204.1,525.2,204z"
      />
      <path
        class="st3"
        d="M524.4,202c0-0.1,0-0.2,0-0.3c0-0.2-0.4-0.4-0.7-0.7c0.1,0.5,0.1,0.8,0.1,1C523.9,202,524.2,202,524.4,202z"
      />
      <path
        class="st3"
        d="M392.1,252.2c0.6-0.1,1.1-0.6,1-1.1c-0.1-0.6-0.7-1-1.4-0.9c-0.6,0.1-1.1,0.7-1,1.2
		C390.7,252,391.4,252.4,392.1,252.2z"
      />
      <path
        class="st3"
        d="M611.5,218.4c-0.7,0.1-1.2,0.7-1.1,1.3c0.1,0.5,0.8,0.8,1.4,0.7c0.1,0,0.2,0,0.3-0.1v-1.9
		C611.9,218.4,611.7,218.4,611.5,218.4z"
      />
      <path
        class="st3"
        d="M497.4,181.7c0-0.1-0.1-0.1-0.1-0.2c-0.6,0.5-1.2,1-1.8,1.6c0,0,0,0,0,0.1c0.5-0.2,1-0.4,1.5-0.6
		C497.1,182.2,497.3,181.9,497.4,181.7z"
      />
      <path
        class="st3"
        d="M539.8,218.1c-0.2,0.1-0.4,0.5-0.4,0.8c0,0.5,0.4,0.8,1,0.9c0.6,0,1.2-0.1,1.4-0.9c-0.3-0.3-0.6-0.6-1.1-0.9
		C540.6,217.9,540.1,217.9,539.8,218.1z"
      />
      <path
        class="st3"
        d="M538.9,204.7c-0.4,0.2-0.9,0.2-1.3,0.4c0.6,0.1,1.2,0.1,1.9,0.2C539.4,205.1,539.2,204.9,538.9,204.7z"
      />
      <path
        class="st3"
        d="M539.2,206.4c-0.5,0-1.1-0.1-1.6-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.5,0,0.9,0,1.2,0
		C539.1,206.5,539.1,206.4,539.2,206.4z"
      />
      <path
        class="st3"
        d="M394.1,242.1c0.1,0.2,0.2,0.3,0.3,0.4c1.2-0.8,1.7-1,2.1-0.4c0.3-0.3,0.4-0.7,0.3-1.3
		c-0.5,0.2-0.9,0.3-1.3,0.5c-0.3,0.1-0.5,0.2-0.8,0.4C394.6,241.7,394.4,241.9,394.1,242.1L394.1,242.1z"
      />
      <path
        class="st3"
        d="M472.8,235.3c0.1-0.2,0.3-0.3,0.4-0.4c-0.3-0.1-0.6-0.2-0.8-0.3C472.4,234.8,472.6,235,472.8,235.3z"
      />
      <path
        class="st3"
        d="M473,232.5c-0.1,0.1-0.2,0.2-0.3,0.3c0.2,0.1,0.5,0.1,0.8,0.2C473.3,232.9,473.2,232.7,473,232.5z"
      />
      <path
        class="st3"
        d="M555.4,253.5c-0.2,0.2-0.3,0.3-0.5,0.5c0.2,0.7,0.5,1.4,0.8,2.1c0.1-1.3,0.2-2.6,0.3-4
		c-0.5,0.3-0.7,0.5-0.9,0.6C555.3,253,555.3,253.3,555.4,253.5z"
      />
      <path
        class="st3"
        d="M535.4,206.5c0-0.1,0-0.2,0-0.3c-0.1,0-0.2,0-0.4,0C535.2,206.2,535.3,206.4,535.4,206.5z"
      />
      <path
        class="st3"
        d="M535.6,204.8c-0.1,0-0.1,0.1-0.2,0.1c0.1,0,0.1,0,0.2,0C535.5,204.9,535.6,204.8,535.6,204.8z"
      />
      <path
        class="st3"
        d="M507.6,192.3c-0.5-0.1-0.8-0.3-1.1-0.3c-0.6-0.1-0.9,0.3-1.1,0.7s-0.1,0.8,0.3,0.9c0.4,0.1,0.9,0,1.3-0.2
		C507.3,193.1,507.4,192.7,507.6,192.3z"
      />
      <path
        class="st3"
        d="M509.6,176c0.3-0.4,0.6-0.8,0.9-1.2c-0.4-0.1-0.9,0.2-0.9-0.3c-0.6,0.1-1.1,0.2-1.7,0.4
		C508.3,175.8,508.3,175.8,509.6,176z"
      />
      <path
        class="st3"
        d="M380.8,259.6c1-0.6,1.8-1.1,2.7-1.6C381.9,257.4,381.3,257.7,380.8,259.6z"
      />
      <path
        class="st3"
        d="M334.1,269.4c1.5-0.5,1.7-0.8,1.2-1.9C334.1,268.2,334.1,268.2,334.1,269.4z"
      />
      <path
        class="st3"
        d="M517.7,201.7c-0.1-0.3-0.3-0.6-0.5-0.9c-0.1-0.1-0.6-0.1-0.8,0c-0.1,0.1-0.3,0.4-0.2,0.5
		c0,0.3,0.1,0.4,0.3,0.6c0.2,0,0.5-0.1,0.7-0.1C517.3,201.8,517.5,201.8,517.7,201.7z"
      />
      <path
        class="st3"
        d="M522,227.6c0,0.5,0.5,0.8,1.1,0.7s0.9-0.4,0.9-0.8c0-0.1,0-0.2-0.1-0.4c-0.6,0.2-1.2,0.2-1.8,0.1
		C522,227.4,522,227.5,522,227.6z"
      />
      <path
        class="st3"
        d="M523.9,211c-0.2-0.2-0.4-0.3-0.8-0.5c-0.4,0.9-0.4,1.4,0.2,1.7c0.2,0.1,0.6,0.3,1,0.4
		C524.4,212,524.4,211.4,523.9,211z"
      />
      <path
        class="st3"
        d="M557.8,215.9c-0.3,0.2-0.5,0.5-0.5,0.8c-0.1,0.4,0.7,0.7,1.2,0.5c0.1-0.1,0.2-0.2,0.3-0.3
		c0.2-0.2,0.3-0.4,0.6-0.6c-0.6-0.2-1-0.6-1.3-0.5C557.9,215.8,557.9,215.8,557.8,215.9z"
      />
      <path
        class="st3"
        d="M538.3,230.9c-0.3,0.5-0.5,0.8-0.6,1.1c0,0.1,0,0.1-0.1,0.2c0,0.1,0,0.2,0.1,0.3c0.2,0.2,0.7,0.3,1,0.2
		c0.6-0.1,0.9-0.5,0.7-0.9C539.4,231.5,538.9,231.3,538.3,230.9z"
      />
      <path
        class="st3"
        d="M533.8,206c-0.8-0.1-1.5-0.1-2.3-0.2c0,0,0.1,0,0.1,0.1l0,0c0.5,0.2,1.1,0.4,1.8,0.6
		C533.6,206.4,533.8,206.2,533.8,206z"
      />
      <path
        class="st3"
        d="M542.3,213.6c-0.3-0.5-0.6-0.9-0.8-1.4c-0.3,0-0.6,0-0.9,0c-0.3,0.1-0.6,0.1-0.9,0.2
		C540.7,212.8,540.8,214.1,542.3,213.6z"
      />
      <path
        class="st3"
        d="M422.2,242.7c-0.3,0.2-0.6,0.5-0.7,0.8c-0.1,0.4,0.5,0.7,1,0.6c0.5-0.1,0.9-0.5,0.8-0.9
		C423.2,242.8,422.6,242.5,422.2,242.7z"
      />
      <path
        class="st3"
        d="M335.9,235.4c-0.1,0-0.3-0.1-0.4-0.1c-0.4,0-0.8,0.4-0.8,0.7l0,0c0.2,0.2,0.3,0.4,0.5,0.6
		c0.1,0.1,0.3,0.2,0.4,0.2c0.8-0.3,1-0.7,0.8-1.1C336.3,235.6,336.1,235.5,335.9,235.4z"
      />
      <path
        class="st3"
        d="M334.8,236.2l0.1,0.1c-0.1-0.1-0.1-0.2-0.2-0.3l0,0C334.7,236.1,334.7,236.2,334.8,236.2z"
      />
      <path
        class="st3"
        d="M458.5,237.3c-0.1,0.1-0.2,0.3-0.1,0.3c0.1,0.2,0.3,0.4,0.7,0.6c0.1,0.1,0.2,0.2,0.4,0.3c0,0,0-0.1,0.1-0.1
		c0-0.1,0.1-0.1,0.1-0.2C459.1,238,458.8,237.6,458.5,237.3z"
      />
      <path
        class="st3"
        d="M593.4,208.5c0.4,0.4,0.5,1,1.1,1.2c0.2,0,0.5,0,0.7,0.1c0.1,0,0.1,0,0.2,0
		C594.8,208.3,594.8,208.3,593.4,208.5z"
      />
      <path
        class="st3"
        d="M380.6,249.7c0.2-0.2,0.3-0.5,0.5-0.7c-0.2-0.1-0.3-0.2-0.5-0.3h-0.1c-0.1-0.1-0.3-0.1-0.4-0.1
		c-0.2,0-0.4,0.3-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.2c0.6,0.2,1,0.5,1.2,0.4C380.5,249.8,380.6,249.8,380.6,249.7z"
      />
      <path
        class="st3"
        d="M527.5,205.6c-0.3,0-0.6,0-1-0.1c-0.1,0.3-0.1,0.7,0.4,0.9h-0.1c0,0,0,0,0,0.1l0,0c0.1,0.1,0.3,0.1,0.4,0.2
		C527.6,206.2,527.6,205.8,527.5,205.6z"
      />
      <path
        class="st3"
        d="M541.6,214.8c-0.3,0.3-0.5,0.6-0.5,0.8c0,0,0,0,0,0.1c0,0.3,0.4,0.6,1.2,0.9
		C542.7,215.8,542.3,215.3,541.6,214.8z"
      />
      <path
        class="st3"
        d="M539.4,211.4c-0.2-0.2-0.5-0.5-0.8-0.8c-0.1,0-0.3,0.1-0.4,0.1v0.1c-0.1,0.2,0,0.4,0,0.6
		C538.6,211.4,539,211.4,539.4,211.4z"
      />
      <path
        class="st3"
        d="M546.6,196c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.4,0.1-0.9,0.2c0.5,0.6,0.4,1.4,1.5,1.4l0,0c0,0,0,0,0.1,0l0,0
		C547.3,196.9,546.1,196.5,546.6,196z"
      />
      <path
        class="st3"
        d="M510.6,186c0.3,0,0.6,0.1,0.9,0.1c-0.2-0.6-0.5-1.2-0.8-2.1c0,0.1-0.1,0.2-0.1,0.3c-0.2,0.5-0.6,0.8-0.3,1.3
		C510.4,185.7,510.5,185.9,510.6,186z"
      />
      <path
        class="st3"
        d="M557.2,207c0.4,0,0.8,0.1,1.1,0.1c0-0.1,0.1-0.1,0.1-0.2c0-0.1-0.4-0.3-0.9-0.5
		C557.5,206.7,557.3,206.8,557.2,207z"
      />
      <path
        class="st3"
        d="M556.5,167.9c-0.4-0.1-0.7-0.2-1.2-0.3c-0.3,0.4-0.6,0.8-0.8,1.1c0.1,0.1,0.1,0.1,0.2,0.2
		c0.5-0.2,1-0.4,1.5-0.7C556.3,168.1,556.4,168,556.5,167.9z"
      />
      <path
        class="st3"
        d="M384.8,264.2c-0.2,0.2-0.5,0.5-0.4,0.7c0,0.2,0.4,0.3,0.8,0.6c0.2-0.4,0.5-0.7,0.4-0.9
		C385.5,264.4,385.1,264.3,384.8,264.2z"
      />
      <path
        class="st3"
        d="M611.2,162.9c-0.3,0.1-0.5,0.5-0.6,0.8c0,0.1,0.5,0.3,0.9,0.4c0.3-0.3,0.6-0.6,0.6-0.8
		C612,163,611.7,162.7,611.2,162.9z"
      />
      <path
        class="st3"
        d="M514,183.5c-0.6-0.1-1.1-0.7-1.8,0.1C513.2,184.3,513.2,184.3,514,183.5z"
      />
      <path
        class="st3"
        d="M385,258.8c-0.1-0.2-0.2-0.4-0.3-0.6c-0.1-0.2-0.1-0.4-0.2-0.6c-0.3,0.4-0.7,0.6-0.6,0.8
		c0.1,0.3,0.5,0.4,0.8,0.6C384.8,259,384.9,258.9,385,258.8z"
      />
      <path
        class="st3"
        d="M512.8,177.8c0.7-0.4,0.4-1,0.4-1.5C512,176.7,512,176.8,512.8,177.8z"
      />
      <path
        class="st3"
        d="M558.2,174c-0.8,1-1.3,1.7-1.2,2.5C557.5,175.9,558.4,175.4,558.2,174z"
      />
      <path
        class="st3"
        d="M533.7,212.8c-0.2,0-0.4,0-0.6,0.1c-0.2,0.2-0.3,0.3-0.5,0.5c0.3,0.1,0.6,0.4,0.8,0.3c0.3-0.1,0.5-0.4,0.6-0.7
		C534,212.9,533.8,212.9,533.7,212.8z"
      />
      <path
        class="st3"
        d="M539.5,177.9c-0.4,0.4-0.8,0.8-1.1,1.2c0.7,0.5,1.1-0.3,1.7-0.3c0.1-0.2,0.1-0.4,0.2-0.6
		C540,178.1,539.7,178,539.5,177.9z"
      />
      <path
        class="st3"
        d="M547.9,190.7c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0,0.1,0,0.1,0c0.5,0,0.9,0,1.2-0.2
		s0.5-0.4,0.6-0.8C548.7,190,548.3,190.3,547.9,190.7z"
      />
      <path
        class="st3"
        d="M352.3,260.1c-0.2,0-0.3,0.4-0.4,0.6c0.3,0.1,0.5,0.3,0.8,0.3c0.1,0,0.3-0.3,0.6-0.7
		C352.9,260.2,352.6,260.1,352.3,260.1z"
      />
      <path
        class="st3"
        d="M318.1,260c0.2-0.2,0.3-0.3,0.4-0.5c-0.1,0-0.1,0-0.2-0.1c0.1-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0.1,0
		c0.1-0.4,0.1-0.7-0.3-1.1C317.6,258.7,317.6,259.2,318.1,260z"
      />
      <path
        class="st3"
        d="M532.8,223.6c0-0.1,0.1-0.2,0.1-0.3c0.1-0.3,0.1-0.5,0-0.7s-0.4-0.4-0.9-0.5l0,0l0,0c0,0,0,0,0,0.1
		c0,0.4,0,0.7,0.2,0.9C532.2,223.3,532.4,223.4,532.8,223.6z"
      />
      <path
        class="st3"
        d="M420.5,234.3c-0.2,0.4-0.6,0.7-0.5,0.9s0.5,0.3,0.8,0.4c0.1,0,0.5-0.4,0.4-0.6
		C421.1,234.8,420.8,234.6,420.5,234.3z"
      />
      <path
        class="st3"
        d="M494.8,199.7c0.1,0,0.3,0,0.4,0c0-0.1-0.1-0.2-0.1-0.3C495,199.5,494.9,199.6,494.8,199.7z"
      />
      <path
        class="st3"
        d="M583.9,205.9c0.3,0,0.6,0,0.9,0.1c-0.1-0.5-0.3-0.5-1.2-0.5C583.7,205.6,583.8,205.8,583.9,205.9z"
      />
      <path
        class="st3"
        d="M564.4,210.5c0.9,0,1.6,0.1,2.2,0.1c-0.5-0.3-0.9-0.5-1.3-0.8C565,210.1,564.8,210.2,564.4,210.5z"
      />
      <path
        class="st3"
        d="M533.9,175.3c-0.1,0.1-0.2,0.1-0.2,0.2c0.1,0.1,0.2,0.1,0.2,0.2C533.9,175.6,533.9,175.5,533.9,175.3z"
      />
      <path
        class="st3"
        d="M396.6,249.9c0.1,0.1,0.2,0.2,0.3,0.3l0,0c0.5-0.4,1.1-0.7,1.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2
		c-0.1-0.1-0.2-0.2-0.3-0.2C397.7,249.1,397.2,249.5,396.6,249.9z"
      />
      <path
        class="st3"
        d="M555.2,178.9c0.1-0.1,0-0.3-0.2-0.5c-0.1,0.2-0.3,0.5-0.5,0.7C554.8,179.2,555,179.2,555.2,178.9z"
      />
      <path
        class="st3"
        d="M562.3,218.7c0.1,0.8,0.1,0.8,0.9,1.3C563.1,219.5,563.1,219,562.3,218.7z"
      />
      <path
        class="st3"
        d="M511.9,253.8c0,0.7,0.2,1.1,1,1.7C513,254.5,512.7,254.1,511.9,253.8z"
      />
      <path
        class="st3"
        d="M537.1,177L537.1,177c-0.2,0.1-0.3,0.3-0.5,0.7c0.7-0.1,1.3-0.2,1.8-0.8C537.7,176.9,537.3,176.9,537.1,177z"
      />
      <path
        class="st3"
        d="M518.4,219.7c-0.3,0.4-0.5,0.6-0.6,0.9c0,0.1,0.4,0.3,0.6,0.4c0.2-0.2,0.5-0.5,0.6-0.7
		C519,220.1,518.6,220,518.4,219.7z"
      />
      <path
        class="st3"
        d="M388,261.3c0.2,0.1,0.5,0.4,0.7,0.3c0.2,0,0.4-0.3,0.7-0.6c-0.3-0.2-0.7-0.4-0.8-0.4
		C388.4,260.8,388.2,261.1,388,261.3z"
      />
      <path
        class="st3"
        d="M595.2,203.3c-0.2-0.2-0.5-0.3-0.7-0.5c-0.2,0.2-0.5,0.4-0.4,0.5c0.2,0.2,0.4,0.4,0.8,0.6
		C595,203.6,595.3,203.4,595.2,203.3z"
      />
      <path
        class="st3"
        d="M557.3,192.6c-0.1,0.7,0.3,1,1.2,1.2C558.3,193.1,558.2,192.6,557.3,192.6z"
      />
      <path
        class="st3"
        d="M611.8,174c0.1,0,0.2,0,0.3,0v-1c0,0,0,0-0.1,0C612,173.3,611.9,173.6,611.8,174z"
      />
      <path
        class="st3"
        d="M541.1,207.2c-0.3-0.5-0.7-0.7-1.6-0.4c0.4,0.3,0.8,0.5,1.2,0.8C540.9,207.4,541,207.3,541.1,207.2z"
      />
      <path
        class="st3"
        d="M353.3,270.5c0.2-0.5,0.4-1,0.7-1.6C352.9,269.7,352.9,269.7,353.3,270.5z"
      />
      <path
        class="st3"
        d="M578.9,184.5c0.1,0,0.1-0.1,0.3-0.2c-0.3,0-0.6,0-0.9,0C578.4,184.4,578.7,184.5,578.9,184.5z"
      />
      <path
        class="st3"
        d="M522.3,206.1c0.1,0,0.3,0.1,0.5,0.1c-0.2-0.2-0.3-0.4-0.5-0.6c-0.1-0.1-0.3-0.3-0.4-0.5c-0.1,0-0.2,0-0.3,0
		C521.7,205.7,521.8,205.9,522.3,206.1z"
      />
      <path
        class="st3"
        d="M547.6,179.1c-0.1,0.1-0.1,0.1-0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.2s0.1-0.1,0.2-0.1c0.3-0.2,0.6-0.4,0.8-0.6
		c0.1-0.1-0.2-0.3-0.3-0.5C548.1,178.6,547.8,178.9,547.6,179.1z"
      />
      <path
        class="st3"
        d="M546.8,168.4c-0.2,0.3-0.5,0.6-0.4,0.7c0.1,0.2,0.4,0.2,0.6,0.4c0.2-0.2,0.4-0.4,0.4-0.6
		C547.4,168.7,547.1,168.6,546.8,168.4z"
      />
      <path
        class="st3"
        d="M338.1,235.2c-0.4-0.2-0.7-0.3-1-0.4c0,0.1-0.1,0.2-0.2,0.2l0,0c-0.1,0.1-0.2,0.3-0.1,0.4
		c0.1,0.2,0.4,0.3,0.7,0.3C337.6,235.8,337.8,235.5,338.1,235.2z"
      />
      <path
        class="st3"
        d="M380.8,261.6c-0.2,0-0.4,0.4-0.4,0.5c0,0.2,0.4,0.3,0.7,0.5c0.2-0.3,0.4-0.6,0.4-0.7
		C381.4,261.7,381,261.5,380.8,261.6z"
      />
      <path
        class="st3"
        d="M323.1,233.4c0.1-0.1-0.2-0.4-0.4-0.7c-0.4,0.4-0.6,0.7-0.9,1c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0,0.2,0,0.2,0l0,0
		c0.1-0.1,0.3-0.1,0.4-0.2C323,233.6,323.1,233.5,323.1,233.4z"
      />
      <path
        class="st3"
        d="M335.5,255.1c0.8-0.2,0.9-0.5,0.6-1.2C335.5,254.2,335.2,254.5,335.5,255.1z"
      />
      <path
        class="st3"
        d="M515,186.5c0-0.1,0.1-0.2,0.1-0.4c-0.2,0-0.4,0.1-0.6,0.1c0,0.1,0,0.2-0.1,0.2
		C514.7,186.5,514.8,186.5,515,186.5z"
      />
      <path
        class="st3"
        d="M515.8,208.7c0.1,0,0.3,0,0.4,0c0.1-0.4,0.2-0.8,0.4-1.1c-0.2,0-0.4,0-0.6-0.1
		C515.9,207.9,515.9,208.3,515.8,208.7z"
      />
      <path
        class="st3"
        d="M540.1,229.5c-0.2,0-0.4,0-0.6,0c0.2,0.2,0.4,0.4,0.7,0.6c0-0.2,0-0.3-0.1-0.4
		C540.1,229.6,540.1,229.6,540.1,229.5z"
      />
      <path
        class="st3"
        d="M395.8,253.5c-0.2,0.3-0.5,0.5-0.4,0.6c0.1,0.2,0.4,0.3,0.6,0.4c0.1-0.2,0.4-0.3,0.4-0.5
		C396.3,253.8,396.1,253.7,395.8,253.5z"
      />
      <path
        class="st3"
        d="M488.4,213.8c0.6-0.2,1.1-0.5,0.7-1.3C488.8,213.1,488.6,213.5,488.4,213.8z"
      />
      <path
        class="st3"
        d="M509.4,172.5c0.3-0.1,0.5-0.2,0.9-0.4c-0.2-0.3-0.3-0.6-0.5-0.8C509.1,171.5,509.2,171.9,509.4,172.5z"
      />
      <path
        class="st3"
        d="M508.3,173.9c-0.3,0-0.5,0-0.7,0.1s-0.3,0.3-0.5,0.6C507.8,174.6,508.2,174.6,508.3,173.9z"
      />
      <path
        class="st3"
        d="M490.3,191.7c0.4,0.2,0.8,0.4,1.5,0.8C491.5,191.7,491.1,191.6,490.3,191.7z"
      />
      <path
        class="st3"
        d="M519.7,222.4c0.1,0,0.2,0,0.4,0c0.1-0.4,0.1-0.8,0.2-1.2c-0.1,0-0.3,0-0.4,0
		C519.8,221.7,519.7,222.1,519.7,222.4z"
      />
      <path
        class="st3"
        d="M558.9,187.1c0.4,0,0.7-0.1,1.1-0.1c-0.3,0-0.6,0-0.9,0C559,187,558.9,187,558.9,187.1z"
      />
      <path
        class="st3"
        d="M320.2,244.9c-0.1,0.1-0.2,0.1-0.3,0.2c0.2,0.2,0.4,0.4,0.5,0.6c0,0,0.1-0.1,0.2-0.2l0.1-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C320.4,245.1,320.3,245,320.2,244.9z"
      />
      <path
        class="st3"
        d="M523.3,208.5c-0.4,0-0.7-0.1-0.9,0s-0.3,0.3-0.3,0.5c0,0.1,0.3,0.3,0.5,0.3C522.7,209.2,522.9,209,523.3,208.5
		z"
      />
      <path
        class="st3"
        d="M351.1,253c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.3,0.2,0.6,0.4c0.1-0.3,0.3-0.4,0.3-0.6
		C351.5,253.1,351.2,253,351.1,253z"
      />
      <path
        class="st3"
        d="M337.1,270.5c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.3,0.7-0.6,1-0.9c-0.1-0.1-0.1-0.1-0.2-0.2
		C337.8,269.9,337.5,270.2,337.1,270.5z"
      />
      <path
        class="st3"
        d="M560.3,188.6c-0.2,0.5,0,0.7,0.4,0.9c0.1,0,0.2,0.1,0.3,0.1c0.1-0.2,0-0.3,0-0.5
		C560.9,188.9,560.7,188.7,560.3,188.6z"
      />
      <path
        class="st3"
        d="M596,188.8c-0.1-0.4-0.3-0.8,0.3-0.9c-0.2,0-0.5,0-1-0.1C595.6,188.3,595.8,188.5,596,188.8z"
      />
      <path
        class="st3"
        d="M385.1,252c0-0.1-0.4-0.3-0.5-0.3c0,0-0.1,0-0.1,0.1c0.2,0.2,0.3,0.3,0.5,0.4
		C385.1,252.2,385.1,252.1,385.1,252z"
      />
      <path
        class="st3"
        d="M556.9,178.5c0,0-0.1-0.1-0.1-0.3c-0.4,0.1-0.7,0.3-1.1,0.5C556.2,179.2,556.6,178.8,556.9,178.5z"
      />
      <path
        class="st3"
        d="M373.6,256.2c-0.3-0.3-0.5-0.5-0.7-0.7C372.7,256.2,372.7,256.2,373.6,256.2z"
      />
      <path
        class="st3"
        d="M578.5,197.8c-0.1,0.1-0.2,0.1-0.3,0.2l0.1,0.1c0.2,0.2,0.3,0.4,0.5,0.6l0,0c0.1,0,0.1-0.1,0.2-0.1l0.1-0.1
		C578.9,198.3,578.7,198.1,578.5,197.8C578.5,197.9,578.5,197.8,578.5,197.8z"
      />
      <path
        class="st3"
        d="M398.7,225c0-0.1-0.1-0.1-0.1-0.2c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.2-0.3,0.3-0.3,0.5c0,0,0.3,0.1,0.4,0.2
		C398.5,225.2,398.7,225.1,398.7,225z"
      />
      <path
        class="st3"
        d="M527.7,244.2c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0,0.2-0.2,0.3-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C528,243.9,527.8,244.1,527.7,244.2z"
      />
      <path
        class="st3"
        d="M343.1,238.8c-0.3-0.1-0.5-0.2-0.7-0.2c-0.1,0-0.2,0.2-0.3,0.3c0.2,0.1,0.3,0.2,0.5,0.2
		C342.8,239.1,342.9,239,343.1,238.8z"
      />
      <path
        class="st3"
        d="M389.2,267.4c0,0.1,0,0.2,0.1,0.3c0-0.1,0.1-0.1,0.1-0.2C389.3,267.4,389.2,267.4,389.2,267.4z"
      />
      <path
        class="st3"
        d="M510.7,181.9c-0.1,0.2-0.3,0.3-0.4,0.5l0,0l0,0c-0.2,0-0.5,0-0.7-0.1c0,0.2-0.1,0.4-0.2,0.8
		c0.3-0.2,0.5-0.3,0.6-0.4v0.1l0,0c0.1,0.2,0.1,0.4,0.2,0.6C511.3,182.5,511.3,182.5,510.7,181.9z"
      />
      <path
        class="st3"
        d="M511.6,175.6l0.2,0.1c0.1-0.1,0.3-0.3,0.4-0.4c-0.2-0.1-0.3-0.1-0.4-0.2C511.8,175.3,511.7,175.4,511.6,175.6z
		"
      />
      <path
        class="st3"
        d="M558.7,189.6c0.1,0.1,0.1,0.1,0.2,0.2c0.3-0.2,0.5-0.3,0.8-0.5c-0.1-0.1-0.2-0.1-0.2-0.2
		C559.2,189.2,558.9,189.4,558.7,189.6z"
      />
      <path
        class="st3"
        d="M399.2,250.5c0.1,0.1,0.3,0.3,0.5,0.3c0.1,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.5-0.2-0.7-0.1
		C399.4,250.2,399.2,250.4,399.2,250.5z"
      />
      <path
        class="st3"
        d="M609.2,214.6c0.2,0.1,0.3,0.3,0.5,0.2c0.2,0,0.3-0.3,0.5-0.5c-0.3-0.1-0.4-0.2-0.5-0.1
		C609.5,214.3,609.4,214.4,609.2,214.6z"
      />
      <path
        class="st3"
        d="M552.2,173.3c0.1-0.1,0.1-0.3,0.2-0.4c-0.2,0.1-0.3,0.2-0.5,0.3c0,0.1,0.1,0.1,0.1,0.2
		C552.1,173.4,552.1,173.4,552.2,173.3z"
      />
      <path
        class="st3"
        d="M316.5,229c0,0,0.3-0.1,0.3-0.2c-0.1-0.2-0.2-0.3-0.3-0.4c-0.2,0.1-0.3,0.2-0.4,0.2
		C316.2,228.8,316.4,228.9,316.5,229z"
      />
      <path
        class="st3"
        d="M506.6,211c0.1,0,0.2,0,0.2,0c0.1-0.2,0.2-0.4,0.4-0.7c-0.1,0-0.3-0.1-0.4-0.1
		C506.7,210.5,506.6,210.7,506.6,211z"
      />
      <path
        class="st3"
        d="M605.6,205.1c-0.1,0.2-0.2,0.3-0.3,0.5c0,0.1,0.2,0.1,0.4,0.3c0.1-0.3,0.2-0.4,0.2-0.6
		C606,205.2,605.8,205.2,605.6,205.1z"
      />
      <path
        class="st3"
        d="M543.3,178.7c-0.1,0.1-0.2,0.1-0.3,0.2c0.3,0,0.5,0.1,0.6,0c0.2,0,0.4-0.2,0.5-0.5c0-0.1,0.1-0.2,0.1-0.3
		c-0.2,0.1-0.3,0.2-0.5,0.3C543.6,178.5,543.4,178.6,543.3,178.7z"
      />
      <path
        class="st3"
        d="M541.6,179.2c-0.3,0.2-0.6,0.3-0.9,0.5c0,0.1,0.1,0.1,0.1,0.2c0.3-0.1,0.6-0.2,0.9-0.3
		C541.6,179.5,541.6,179.3,541.6,179.2z"
      />
      <path
        class="st3"
        d="M520.6,213.3c0.1,0,0.2,0,0.3,0c0-0.2,0-0.5,0-0.7c-0.1,0-0.2,0-0.3,0C520.6,212.8,520.6,213,520.6,213.3z"
      />
      <path
        class="st3"
        d="M611.2,169.7c0,0.3,0,0.6,0,0.9C611.6,170.3,611.7,170,611.2,169.7z"
      />
      <path
        class="st3"
        d="M611.1,170.7L611.1,170.7c0.1-0.1,0.1-0.1,0.1-0.1l0,0C611.1,170.6,611.1,170.7,611.1,170.7z"
      />
      <path
        class="st3"
        d="M331.6,262.5c0.1,0.3,0.2,0.6,0.4,0.9c0.1-0.1,0.2-0.1,0.4-0.2c-0.2-0.3-0.3-0.5-0.5-0.8
		C331.7,262.4,331.6,262.4,331.6,262.5z"
      />
      <path
        class="st3"
        d="M551.2,182.2c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.3-0.2,0.4-0.3c-0.1-0.1-0.1-0.2-0.2-0.2
		C551.4,182.1,551.3,182.2,551.2,182.2z"
      />
      <path
        class="st3"
        d="M505.5,184.7c0.1,0,0.2,0,0.2,0c0.1-0.2,0.1-0.4,0.2-0.6c-0.1,0-0.3,0-0.4-0.1
		C505.6,184.3,505.5,184.5,505.5,184.7z"
      />
      <path
        class="st3"
        d="M389.8,249.7c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.1,0.4,0.2,0.6c0.1,0,0.2,0,0.3-0.1
		C389.9,250.1,389.8,249.9,389.8,249.7z"
      />
      <path
        class="st3"
        d="M571.5,179.1c-0.1,0-0.1,0.1-0.2,0.1l0,0c0,0,0,0,0.1,0C571.5,179.2,571.5,179.1,571.5,179.1z"
      />
      <path
        class="st3"
        d="M571.9,178.5c-0.1,0.2-0.3,0.4-0.4,0.6c0.2-0.1,0.4-0.3,0.6-0.4C572.1,178.6,572,178.6,571.9,178.5z"
      />
      <path
        class="st3"
        d="M507.4,263.8c0-0.1,0-0.2,0-0.2c-0.1,0-0.1,0-0.3,0C507.3,263.6,507.4,263.7,507.4,263.8z"
      />
      <path
        class="st3"
        d="M399.3,234.2c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1,0.2-0.3,0.3-0.2,0.4c0,0.1,0.2,0.1,0.4,0.1
		C399.2,234.4,399.3,234.2,399.3,234.2z"
      />
      <path
        class="st3"
        d="M535.3,247.1c0.2,0.1,0.4,0.1,0.6,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.2,0-0.4-0.1-0.6-0.1
		C535.4,246.9,535.3,247,535.3,247.1z"
      />
      <path
        class="st3"
        d="M569.3,165.5c0,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.3-0.2-0.4-0.2
		C569.5,165.3,569.3,165.4,569.3,165.5z"
      />
      <path
        class="st3"
        d="M609.5,168.1l0.2-0.2c0-0.1-0.2-0.2-0.3-0.4c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.2-0.1,0.3
		S609.3,168.1,609.5,168.1C609.5,168.1,609.5,168.1,609.5,168.1z"
      />
      <path
        class="st3"
        d="M519.9,211.4c-0.2,0-0.4,0-0.6-0.1c0.1,0.1,0.2,0.3,0.4,0.4C519.7,211.6,519.8,211.5,519.9,211.4z"
      />
      <path
        class="st3"
        d="M612.1,165v-0.5c-0.1,0.1-0.2,0.2-0.3,0.3C611.9,164.9,612,164.9,612.1,165z"
      />
      <path
        class="st3"
        d="M508.3,201.8c0.2,0,0.3,0.1,0.5,0c0,0,0.1,0,0.1-0.1C508.7,201.8,508.6,201.8,508.3,201.8
		C508.4,201.8,508.3,201.8,508.3,201.8z"
      />
      <path
        class="st3"
        d="M610.5,165.7c0,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.3-0.2,0.3-0.3s-0.1-0.2-0.4-0.5
		C610.6,165.4,610.5,165.6,610.5,165.7z"
      />
      <path
        class="st3"
        d="M511,213.4c0.1,0,0.2,0,0.3,0c0.1-0.2,0.2-0.4,0.3-0.7c-0.1,0-0.2,0-0.4,0C511.1,212.9,511.1,213.2,511,213.4z
		"
      />
      <path
        class="st3"
        d="M433.2,229.6c0.2,0.2,0.4,0.5,0.6,0.8C434.1,229.6,433.6,229.7,433.2,229.6z"
      />
      <path
        class="st3"
        d="M433.2,229.6C433.2,229.6,433.2,229.5,433.2,229.6c-0.1-0.1-0.1-0.1-0.1-0.1l0,0
		C433.1,229.6,433.2,229.6,433.2,229.6z"
      />
      <path
        class="st3"
        d="M490.1,216c-0.2,0.1-0.3,0.2-0.5,0.4c0.1,0.1,0.2,0.2,0.3,0.2c0.1-0.1,0.3-0.3,0.4-0.4
		C490.3,216.2,490.1,216.1,490.1,216z"
      />
      <path
        class="st3"
        d="M519.2,211.3L519.2,211.3c-0.1-0.1-0.1-0.1-0.1-0.1L519.2,211.3C519.2,211.3,519.2,211.3,519.2,211.3z"
      />
      <path
        class="st3"
        d="M519,210.7c0.1,0.2,0.1,0.3,0.2,0.5c0-0.2,0.1-0.3,0.1-0.5C519.2,210.7,519.1,210.7,519,210.7z"
      />
      <path
        class="st3"
        d="M550.4,193.2l0.1,0.1c0.1,0.1,0.2,0.2,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2l0.1-0.1H551c-0.1,0-0.2,0-0.4,0
		C550.5,193.2,550.4,193.2,550.4,193.2z"
      />
      <path
        class="st3"
        d="M504.3,206.9c0.1,0,0.2,0,0.3,0l0.1-0.1c0,0-0.1-0.1-0.2-0.2C504.4,206.8,504.3,206.8,504.3,206.9z"
      />
      <path
        class="st3"
        d="M396.6,244.9c0.1,0.1,0.2,0.1,0.4,0.2c0-0.1,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.4-0.1
		C396.7,244.7,396.6,244.9,396.6,244.9z"
      />
      <path
        class="st3"
        d="M509.8,173.9c0,0.2-0.1,0.3-0.1,0.5c0.2-0.1,0.3-0.2,0.5-0.3C510.1,174.1,509.9,174,509.8,173.9z"
      />
      <path
        class="st3"
        d="M544.8,223.3l0.1,0.1c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.1-0.2-0.2C544.9,223.2,544.9,223.2,544.8,223.3z"
      />
      <path
        class="st3"
        d="M597.1,188.2c0,0.1,0,0.1,0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.2-0.2-0.2-0.3
		C597.2,188.3,597.1,188.3,597.1,188.2z"
      />
      <path
        class="st3"
        d="M364.8,245.2C364.8,245.2,364.8,245.3,364.8,245.2c-0.1,0.1-0.1,0.1-0.1,0.2h0.1
		C364.8,245.3,364.8,245.2,364.8,245.2z"
      />
      <path
        class="st3"
        d="M364.9,244.8c0,0.1,0,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.3-0.3C365.1,244.8,365,244.8,364.9,244.8z"
      />
      <path
        class="st3"
        d="M543.8,179.5c0.2-0.1,0.4-0.1,0.6-0.2v-0.1c-0.2,0-0.4,0-0.6,0C543.8,179.3,543.8,179.4,543.8,179.5z"
      />
      <path
        class="st3"
        d="M414.9,210c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1
		C415,209.8,415,209.9,414.9,210z"
      />
      <path
        class="st3"
        d="M373.3,243.5c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.1C373.4,243.3,373.4,243.4,373.3,243.5z"
      />
      <path
        class="st3"
        d="M598.7,188.8c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2
		C598.7,188.9,598.7,188.9,598.7,188.8z"
      />
      <path
        class="st3"
        d="M611,171.2c0-0.2,0.1-0.4,0.1-0.5c-0.1,0.1-0.3,0.3-0.4,0.4C610.8,171.2,610.9,171.2,611,171.2z"
      />
      <path
        class="st3"
        d="M468.4,243.4C468.4,243.4,468.4,243.5,468.4,243.4c0.1,0.1,0.2,0.2,0.2,0.2s0,0,0.1,0s0.1-0.1,0.2-0.1
		c-0.1-0.1-0.2-0.2-0.3-0.2C468.5,243.3,468.4,243.3,468.4,243.4z"
      />
      <path
        class="st3"
        d="M557.9,187.1c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2,0-0.3,0C557.8,187,557.9,187.1,557.9,187.1z"
      />
      <path
        class="st3"
        d="M368.7,253.7c0.1,0,0.2,0.2,0.3,0.1c0.1,0,0.2-0.2,0.3-0.2c-0.1-0.1-0.2-0.2-0.3-0.2
		C368.9,253.4,368.8,253.6,368.7,253.7z"
      />
      <path
        class="st3"
        d="M515.5,199.5c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.1-0.2-0.2-0.2
		C515.7,199.4,515.6,199.4,515.5,199.5z"
      />
      <path
        class="st3"
        d="M501.9,205.6c0,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.3,0.1-0.4c0,0-0.2,0-0.4-0.1
		C501.8,205.4,501.8,205.5,501.9,205.6z"
      />
      <path
        class="st3"
        d="M604.1,188.2c-0.1,0-0.1,0.2-0.1,0.3l0,0c0.1,0,0.2,0,0.2,0s0-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2
		C604.3,188.2,604.2,188.2,604.1,188.2z"
      />
      <path
        class="st3"
        d="M598.1,189.7c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.2,0.3c0.1-0.1,0.2-0.1,0.2-0.2
		C598.2,189.8,598.2,189.7,598.1,189.7z"
      />
      <path
        class="st3"
        d="M599.9,215.4c0.1,0,0.2,0,0.3,0c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2-0.1-0.3-0.1
		C600,215.1,600,215.3,599.9,215.4z"
      />
      <path
        class="st3"
        d="M555.2,199c0.1-0.1,0.1-0.2,0.2-0.3c-0.1,0-0.2,0.1-0.4,0.1C555,198.9,555.1,198.9,555.2,199z"
      />
      <path
        class="st3"
        d="M346.1,243.9c-0.1,0-0.2-0.1-0.2-0.1c0,0.1,0,0.2,0,0.3c0.1,0,0.2,0,0.2,0C346.2,244.1,346.2,244,346.1,243.9z
		"
      />
      <path
        class="st3"
        d="M537.4,176C537.4,176.1,537.4,176.1,537.4,176c0,0.1,0.1,0.1,0.1,0.1L537.4,176C537.6,176,537.5,176,537.4,176
		z"
      />
      <path
        class="st3"
        d="M548.1,173.1c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3-0.1C548.2,173,548.1,173.1,548.1,173.1z"
      />
      <path
        class="st3"
        d="M565.1,174.1c0,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C565.1,174,565.1,174.1,565.1,174.1z"
      />
      <path
        class="st3"
        d="M504,180.1c0,0.1,0,0.1,0,0.2c0.1,0,0.1,0,0.2-0.1v-0.1C504.1,180.1,504.1,180.1,504,180.1z"
      />
      <path
        class="st3"
        d="M420.8,229.6l-0.1-0.1c-0.1,0-0.2,0.1-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1C420.6,229.7,420.7,229.6,420.8,229.6z"
      />
      <path
        class="st3"
        d="M316.9,248.9l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2l-0.1-0.1C317.1,248.8,317,248.8,316.9,248.9z"
      />
      <path
        class="st3"
        d="M513.2,176.1C513.2,176.1,513.1,176.2,513.2,176.1c0,0.1,0,0.1,0,0.1l0,0C513.2,176.2,513.2,176.2,513.2,176.1
		z"
      />
      <path
        class="st3"
        d="M513.2,175.8v0.1c0,0.1,0,0.1,0,0.2c0-0.1,0.1-0.1,0.1-0.2C513.3,175.9,513.2,175.8,513.2,175.8z"
      />
      <path
        class="st3"
        d="M507,173.5l-0.1,0.1c0.1,0.1,0.2,0.1,0.2,0.1c0.1,0,0.2-0.1,0.2-0.2C507.3,173.5,507.1,173.5,507,173.5z"
      />
      <path
        class="st3"
        d="M450.3,225.3c0.1,0,0.1,0.1,0.2,0.1c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1C450.5,225.2,450.4,225.3,450.3,225.3z"
      />
      <path
        class="st3"
        d="M428,230.5c0,0.1,0.1,0.2,0.2,0.2c0-0.1,0.1-0.1,0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C428.1,230.5,428,230.5,428,230.5z"
      />
      <path
        class="st3"
        d="M510.5,242.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.1-0.1,0.2-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
		C510.5,242.7,510.5,242.8,510.5,242.8z"
      />
      <path
        class="st3"
        d="M487.4,218.6c0.1,0,0.2,0.1,0.2,0.1c0.1,0,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C487.5,218.5,487.5,218.5,487.4,218.6z"
      />
      <path
        class="st3"
        d="M495,193.3c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.1,0.2
		C494.9,193.4,495.1,193.4,495,193.3z"
      />
      <path
        class="st3"
        d="M532,209.8c0,0.2,0,0.3,0.1,0.5c0.1,0,0.1,0,0.2,0c0-0.1-0.1-0.3-0.1-0.4C532.1,209.8,532,209.8,532,209.8z"
      />
      <path
        class="st3"
        d="M394.3,240c0,0.1-0.1,0.2-0.1,0.3c0,0,0.1,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2C394.5,240.1,394.4,240,394.3,240z"
      />
      <path
        class="st3"
        d="M542.2,208.4c0,0.1,0.2,0.1,0.2,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C542.3,208.2,542.2,208.3,542.2,208.4z"
      />
      <path
        class="st3"
        d="M560.5,192.3c0,0.1,0.1,0.1,0.1,0.2l0.1-0.1C560.7,192.4,560.7,192.3,560.5,192.3
		C560.6,192.2,560.6,192.3,560.5,192.3z"
      />
      <path
        class="st3"
        d="M546.4,194.8c0.1,0,0.2,0,0.3,0l0,0c0,0,0-0.1,0.1-0.1c-0.1,0-0.2,0-0.3,0
		C546.5,194.7,546.5,194.7,546.4,194.8C546.4,194.7,546.4,194.8,546.4,194.8z"
      />
      <path
        class="st3"
        d="M501.4,204.9c0,0,0.2,0,0.2,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C501.5,204.7,501.4,204.8,501.4,204.9z
		"
      />
      <path
        class="st3"
        d="M331.4,241.4c0,0.1,0,0.1,0,0.2v0.1l0.1,0.1l0.1-0.1c0,0,0-0.1-0.1-0.1C331.4,241.5,331.4,241.5,331.4,241.4z"
      />
      <path
        class="st3"
        d="M468.1,242.8c0,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.1-0.1-0.2-0.1S468,242.7,468.1,242.8z"
      />
      <path
        class="st3"
        d="M573.8,179.6l0.1-0.1c-0.1,0-0.2-0.1-0.3-0.1l-0.1,0.1C573.6,179.5,573.7,179.6,573.8,179.6z"
      />
      <path
        class="st3"
        d="M522.3,216.5c0.1,0,0.2,0,0.2,0v-0.1c0,0-0.1-0.1-0.2-0.1C522.3,216.4,522.3,216.5,522.3,216.5z"
      />
      <path
        class="st3"
        d="M544.3,222.6c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C544.4,222.5,544.4,222.5,544.3,222.6z"
      />
      <path
        class="st3"
        d="M584,178.4c-0.1,0-0.2,0.1-0.3,0.1c0.1,0,0.1,0.1,0.1,0.1c0.1,0,0.2-0.1,0.3-0.1L584,178.4z"
      />
      <path
        class="st3"
        d="M528.7,215.5v-0.1h-0.1C528.6,215.4,528.6,215.4,528.7,215.5C528.6,215.5,528.7,215.5,528.7,215.5z"
      />
      <path
        class="st3"
        d="M529.2,216.1c-0.1,0-0.2,0-0.3,0C529,216.1,529,216.1,529.2,216.1C529.1,216.2,529.2,216.1,529.2,216.1z"
      />
      <path
        class="st3"
        d="M357,254.6l0.1,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2,0-0.3,0C357.1,254.5,357.1,254.6,357,254.6z"
      />
      <path
        class="st3"
        d="M504.7,196.8c0,0,0.1,0,0.1,0.1c0-0.1,0-0.2,0.1-0.3c0,0-0.1,0-0.1-0.1C504.7,196.7,504.7,196.8,504.7,196.8z"
      />
      <path
        class="st3"
        d="M358.9,229.2c0-0.1-0.1-0.1-0.1-0.2l-0.1,0.1c0,0.1,0.1,0.1,0.1,0.2C358.9,229.2,358.9,229.2,358.9,229.2z"
      />
      <path
        class="st3"
        d="M585.8,205.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C586.1,205.6,586,205.6,585.8,205.7
		C585.8,205.6,585.8,205.7,585.8,205.7z"
      />
      <path
        class="st3"
        d="M569.6,184.7c0.1,0.2,0.3,0.4,0.4,0.5c0.9-0.3,1.8-0.3,2.8,0c0.6-0.3,1-0.7,1.2-1.4c0-0.2,0.1-0.3,0.1-0.5
		c0-0.1,0-0.1,0.1-0.2c-1.6,0.3-3.3,0.6-4.8,0.9C569.4,184.3,569.5,184.5,569.6,184.7z"
      />
      <path
        class="st3"
        d="M580.7,181.4c0,0.1,0,0.1,0,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.3,0-0.4c0,0-0.1,0-0.1-0.1
		C580.8,181.4,580.7,181.4,580.7,181.4z"
      />
      <path
        class="st3"
        d="M567.4,211.2c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.2-0.1-0.3-0.1C567.3,211,567.3,211.1,567.4,211.2z"
      />
      <polygon class="st3" points="366.3,255 366.4,255 366.3,254.9 	" />
      <path
        class="st3"
        d="M510.7,198.5c-0.1,0-0.1,0-0.2,0.1c0.1,0,0.1,0,0.2,0s0.1-0.1,0.2-0.1C510.8,198.5,510.7,198.4,510.7,198.5z"
      />
      <path
        class="st3"
        d="M403.3,246.8c-0.1,0-0.2,0.1-0.3,0.2l0.1,0.1c0.1,0,0.1-0.1,0.2-0.1h0.1C403.4,246.8,403.4,246.8,403.3,246.8
		C403.4,246.8,403.3,246.7,403.3,246.8z"
      />
      <path
        class="st3"
        d="M575.4,184.7l0.1,0.1c0-0.1,0.1-0.2,0.1-0.2s-0.1-0.1-0.2-0.1C575.4,184.6,575.3,184.7,575.4,184.7z"
      />
      <path
        class="st3"
        d="M308.2,243.9C308.2,243.9,308.3,243.8,308.2,243.9C308.3,243.8,308.3,243.8,308.2,243.9
		c0.1-0.1,0.1-0.1,0.1-0.1s0,0,0-0.1C308.2,243.7,308.2,243.7,308.2,243.9C308.1,243.8,308.2,243.9,308.2,243.9z"
      />
      <path
        class="st3"
        d="M395.6,225.2c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C395.7,225.1,395.6,225.1,395.6,225.2z"
      />
      <path
        class="st3"
        d="M331.4,236.1l-0.1-0.1c0,0.1,0,0.1,0,0.2C331.4,236.1,331.4,236.1,331.4,236.1z"
      />
      <path
        class="st3"
        d="M319.1,237.5L319.1,237.5L319.1,237.5c0-0.1,0.1-0.1,0.1-0.2l0,0l0,0C319.1,237.4,319.1,237.4,319.1,237.5z"
      />
      <path
        class="st3"
        d="M502.9,197.5c0-0.1,0-0.1,0-0.2C502.9,197.4,502.9,197.5,502.9,197.5l-0.1,0.1L502.9,197.5z"
      />
      <path
        class="st3"
        d="M351.2,228.7c0,0-0.1,0-0.1-0.1c0,0.1-0.1,0.1-0.1,0.2h0.1C351.2,228.7,351.2,228.7,351.2,228.7z"
      />
      <polygon class="st3" points="552.2,193.3 552.1,193.2 552.1,193.3 	" />
      <polygon class="st3" points="499.6,194.4 499.8,194.3 499.7,194.2 	" />
      <path
        class="st3"
        d="M396.3,227.6c-0.1,0-0.2,0-0.3-0.1c0,0,0,0,0,0.1C396.1,227.6,396.2,227.6,396.3,227.6z"
      />
      <polygon class="st3" points="546.2,183.9 546.3,184 546.4,183.9 	" />
      <path
        class="st3"
        d="M578.4,176.7c0-0.1,0-0.1,0-0.2c-0.1,0-0.1,0.1-0.2,0.1C578.3,176.6,578.3,176.6,578.4,176.7z"
      />
      <path
        class="st3"
        d="M578.4,176.4L578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4C578.4,176.5,578.4,176.5,578.4,176.4
		c0.1-0.1,0.2-0.2,0.3-0.4l0,0C578.6,176.2,578.5,176.3,578.4,176.4z"
      />
      <path
        class="st3"
        d="M578.7,176.1L578.7,176.1C578.8,176.1,578.8,176.1,578.7,176.1C578.8,176,578.7,176.1,578.7,176.1z"
      />
      <path
        class="st3"
        d="M578.8,175.8c0,0.1,0,0.1-0.1,0.2c0.1,0,0.2-0.1,0.2-0.1S578.9,175.9,578.8,175.8z"
      />
      <path
        class="st3"
        d="M552.4,181.1L552.4,181.1C552.3,181.2,552.4,181.2,552.4,181.1C552.4,181.2,552.4,181.1,552.4,181.1z"
      />
      <polygon class="st3" points="610.6,167.2 610.6,167.1 610.5,167.1 	" />
      <path
        class="st3"
        d="M547,197.5c-0.1,0-0.2,0-0.3,0c0,0.1,0.1,0.1,0.1,0.2C547,197.6,547,197.5,547,197.5z"
      />
      <path
        class="st3"
        d="M506.1,206.7l0.1,0.1l0.1-0.1l-0.1-0.1C506.2,206.6,506.1,206.6,506.1,206.7z"
      />
      <path
        class="st3"
        d="M352.1,240.6c0,0.1,0,0.1,0,0.2l0.1-0.1C352.2,240.6,352.2,240.6,352.1,240.6z"
      />
      <path
        class="st3"
        d="M500.4,189.4c0,0,0.1,0,0.1,0.1l0.1-0.1c0,0,0,0-0.1,0C500.5,189.4,500.5,189.4,500.4,189.4
		C500.5,189.4,500.4,189.4,500.4,189.4z"
      />
      <path
        class="st3"
        d="M596.6,187.8c-0.1,0-0.2,0-0.3,0C596.4,187.9,596.5,187.9,596.6,187.8c0.1,0.1,0.3,0.2,0.4,0.3l0.1,0.1
		c0-0.1,0-0.1-0.1-0.2C596.9,188,596.7,187.9,596.6,187.8z"
      />
      <path
        class="st3"
        d="M514.5,186.2L514.5,186.2C514.6,186.2,514.6,186.2,514.5,186.2C514.6,186.3,514.6,186.2,514.5,186.2
		C514.5,186.2,514.5,186.2,514.5,186.2z"
      />
      <polygon class="st3" points="348.4,242.8 348.5,242.8 348.5,242.7 	" />
      <path
        class="st3"
        d="M596.4,189.2L596.4,189.2C596.5,189.2,596.5,189.2,596.4,189.2c-0.1-0.1-0.2-0.2-0.4-0.3c0,0,0-0.1-0.1-0.1
		c0,0.1,0,0.1,0,0.2C596.1,189,596.3,189.1,596.4,189.2z"
      />
      <path
        class="st3"
        d="M515.4,185.5C515.5,185.4,515.5,185.4,515.4,185.5L515.4,185.5C515.4,185.4,515.4,185.4,515.4,185.5z"
      />
      <path
        class="st3"
        d="M546.7,200.2l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C546.6,200.1,546.7,200.2,546.7,200.2z"
      />
      <path
        class="st3"
        d="M540.2,178.9c0,0-0.1-0.1-0.2-0.1l0,0l0,0C540.1,178.9,540.2,178.9,540.2,178.9z"
      />
      <path
        class="st3"
        d="M555.4,198.6c0.1,0,0.1-0.1,0.2-0.1c-0.1,0-0.1,0-0.2-0.1C555.4,198.5,555.4,198.6,555.4,198.6z"
      />
      <path
        class="st3"
        d="M447.6,195.9l0.1,0.1l0.1-0.1l-0.1-0.1C447.7,195.8,447.6,195.8,447.6,195.9z"
      />
      <path
        class="st3"
        d="M546.1,172.7l0.1-0.1l-0.1-0.1l-0.1,0.1C546.1,172.7,546.1,172.7,546.1,172.7z"
      />
      <path
        class="st3"
        d="M569.2,167.4c0,0-0.1-0.1-0.2-0.1c0,0.1,0,0.2,0.1,0.2C569.1,167.4,569.2,167.4,569.2,167.4z"
      />
      <path
        class="st3"
        d="M507.4,179.4c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C507.5,179.3,507.4,179.4,507.4,179.4z"
      />
      <polygon class="st3" points="509.8,177.4 509.8,177.3 509.7,177.4 	" />
      <path
        class="st3"
        d="M526.9,206.5l0.1,0.1C526.9,206.6,526.9,206.5,526.9,206.5L526.9,206.5z"
      />
      <path
        class="st3"
        d="M527,206.7C527,206.7,527,206.6,527,206.7L527,206.7c0.1,0,0.3,0,0.4-0.1l0,0l0,0
		C527.2,206.6,527.1,206.7,527,206.7z"
      />
      <path
        class="st3"
        d="M420.9,230.3l-0.1,0.1l0.1,0.1l0.1-0.1C421,230.4,421,230.4,420.9,230.3z"
      />
      <polygon class="st3" points="391.4,238.8 391.5,238.7 391.4,238.7 	" />
      <polygon class="st3" points="487.9,219.4 488,219.4 488,219.3 	" />
      <path
        class="st3"
        d="M541.9,207.8l0.1-0.1c-0.1,0-0.2,0.1-0.3,0.1C541.8,207.8,541.9,207.8,541.9,207.8z"
      />
      <path
        class="st3"
        d="M598.2,198.4l0.1,0.1l0.1-0.1l-0.1-0.1C598.2,198.3,598.2,198.3,598.2,198.4z"
      />
      <polygon class="st3" points="376.1,247.5 376.2,247.4 376.1,247.4 	" />
      <path
        class="st3"
        d="M598.8,199l-0.1,0.1l0.1,0.1l0.1-0.1C598.9,199.1,598.8,199,598.8,199z"
      />
      <path
        class="st3"
        d="M566.8,210.6L566.8,210.6C566.7,210.6,566.7,210.7,566.8,210.6c0.1,0.1,0.3,0.2,0.4,0.3c0,0,0,0,0.1,0v-0.1
		C567.1,210.8,566.9,210.7,566.8,210.6z"
      />
      <path
        class="st3"
        d="M350.2,267.4c0.1,0,0.1,0,0.2,0.1v-0.1l-0.1-0.1C350.3,267.3,350.3,267.4,350.2,267.4z"
      />
      <path
        class="st3"
        d="M531.1,231.3L531.1,231.3c0.1-0.1,0.1-0.1,0.1-0.1l0,0L531.1,231.3z"
      />
      <path
        class="st3"
        d="M603.1,221.6c0,0.1,0,0.2-0.1,0.3C603.1,221.7,603.1,221.7,603.1,221.6c0.1,0,0.1-0.1,0.1-0.1
		C603.1,221.5,603.1,221.5,603.1,221.6L603.1,221.6z"
      />
      <path
        class="st3"
        d="M509.9,248.8l0.1,0.1l0.1-0.1C510,248.7,510,248.7,509.9,248.8C509.9,248.7,509.9,248.7,509.9,248.8z"
      />
      <path
        class="st3"
        d="M535.5,246.4l-0.1-0.1l-0.1,0.1l0.1,0.1C535.5,246.5,535.5,246.5,535.5,246.4z"
      />
      <polygon class="st3" points="500,266.3 500.1,266.3 500.1,266.2 	" />
      <path
        class="st3"
        d="M534.3,200.7c0.1-0.1,0.1-0.2,0.2-0.2l0,0l0,0C534.4,200.5,534.3,200.6,534.3,200.7z"
      />
      <path
        class="st3"
        d="M364.9,77.4c0.3,0,0.7,0,1.1-0.1c-0.7-0.7-1.6-1.2-2.3-1.9C364.1,76.1,364.5,76.7,364.9,77.4z"
      />
      <path
        class="st3"
        d="M367,67.4c-0.4,0.9-0.4,2,0,3.5c-0.7,0-1.2-0.1-1.7-0.1c-1.2,0.1-2.2,0.6-2.9,1.3c1.5,1.6,3,3.1,4.6,4.7
		c1.4-0.7,2.3-1.9,2.2-3.2c0-0.4-0.2-0.9-0.3-1.4c2.8,0.2,4.6-0.3,5.7-1.6c0.1-0.2,0.3-0.4,0.4-0.6c0.2-0.4,0.3-0.7,0.4-1.1
		c0.2-0.9-0.1-1.8-0.7-2.5c-0.2-0.2-0.4-0.5-0.7-0.7c-0.5-0.4-1.2-0.6-1.9-0.7c-1-0.1-2,0-2.9,0.4c-0.1,0.1-0.2,0.1-0.4,0.2
		c-0.4,0.2-0.7,0.4-0.9,0.6C367.6,66.6,367.3,66.9,367,67.4C367.1,67.4,367,67.4,367,67.4z"
      />
      <path
        class="st3"
        d="M433.6,69.5c0-0.1,0-0.3,0-0.4c-0.1,0-0.1,0-0.2,0C433.5,69.2,433.6,69.4,433.6,69.5z"
      />
      <path
        class="st3"
        d="M437.1,69.5c0.1,0.1,0.2,0.3,0.2,0.2C437.3,69.7,437.2,69.6,437.1,69.5c-0.1,0-0.1,0-0.2-0.1
		C437,69.4,437,69.5,437.1,69.5z"
      />
      <path
        class="st3"
        d="M431.8,71.8c-0.1,0.2-0.2,0.4-0.1,0.6c0,0.1,0,0.2,0,0.2c0.2,0.7,0.9,1.1,1.7,1.1c0.1-1,0.1-2,0.2-3.1
		C432.7,70.9,432,71.3,431.8,71.8z"
      />
      <path
        class="st3"
        d="M435.4,70h-0.1c0,0.7,0,1.3,0,2h0.1c0-0.3,0-0.7-0.1-1.1h0.1C435.4,70.6,435.4,70.3,435.4,70z"
      />
      <path
        class="st3"
        d="M437.4,66.4c-0.2,0-0.4-0.1-0.5-0.1c0.2,0.2,0.4,0.4,0.6,0.7C437.5,66.8,437.5,66.6,437.4,66.4z"
      />
      <path
        class="st3"
        d="M426.1,67.2c1.5-0.5,3-1,4.6-1.5c0-0.1,0-0.2,0.1-0.2c0.2,0,0.3,0.1,0.4,0.1c0.3-0.1,0.6-0.2,0.9-0.3
		c-0.3-0.6-0.6-1.3-0.9-1.9c-0.5-0.1-0.9-0.2-1.4-0.2c-0.2,0-0.4-0.1-0.6-0.1c-0.7-0.1-1.2,0.4-1.3,1.2l0,0c0,0.5-0.4,0.6-0.7,0.8
		c-0.5,0.3-0.9,0.7-1,1.1C426,66.5,426,66.8,426.1,67.2z"
      />
      <path
        class="st3"
        d="M439.3,69.2c1.3,0.4,2.6,0.8,4,1.2c0-0.4,0.1-0.5,0-0.6c-0.5-0.9-1.2-1.6-1.1-2.8c0-0.4-0.2-0.7-0.6-0.9
		c-0.8,0.3-1.6,0.5-2.5,0.8C439.3,67.7,439.3,68.4,439.3,69.2z"
      />
      <path
        class="st3"
        d="M319.4,111c-0.2-0.5-0.5-0.9-0.9-1.2c-0.8,0.3-0.8,1,0,2.4C318.8,111.8,319.1,111.4,319.4,111z"
      />
      <path
        class="st3"
        d="M310.8,113.1c0.6,0.7,1.2,1.5,1.7,2.3c0,0.1,0.1,0.1,0.2,0.2c0.5,0.7,1.2,1,2.3,0.9c0.4-0.1,0.9-0.1,1.4-0.3
		c-0.1-2.3-0.2-4.5-0.3-6.8c0-0.2,0-0.4,0-0.7c-2.1-0.3-4.2,0.5-5.2,2.4C310.3,111.7,310.2,112.4,310.8,113.1
		C310.7,113,310.7,113.1,310.8,113.1z"
      />
      <path
        class="st3"
        d="M389,54.7c0.4,2,2.4,3.1,4.8,2.6c0.6-0.1,1.2-0.3,1.6-0.6l-0.1-0.1c-0.6-0.8-1-1.8-1.5-2.7l0,0
		c-1-0.9-2.1-1.9-3.1-2.8C389.4,52,388.7,53.4,389,54.7z"
      />
      <path
        class="st3"
        d="M394.6,50.5c-0.2-0.1-0.5-0.1-0.7-0.1c0.4,0.4,0.9,0.9,1.3,1.3C395,51.2,394.8,50.8,394.6,50.5z"
      />
      <path
        class="st3"
        d="M394.7,53.9C394.7,53.8,394.7,53.8,394.7,53.9c-0.2,0-0.4,0-0.5,0C394.4,53.9,394.5,53.9,394.7,53.9z"
      />
      <path
        class="st3"
        d="M501.1,44c0.2-0.8,0.3-1.6,0.1-2.3c-0.2-0.8-0.5-1.7-0.7-2.5c-0.4,0.2-0.8,0.6-1,1c0.3,1.1,0.6,2.2,0.9,3.3
		C500.6,43.7,500.8,43.9,501.1,44z"
      />
      <path
        class="st3"
        d="M506.2,42.6L506.2,42.6c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0.2-0.3,0.2-0.7,0.2-1
		c-0.3,0.5-0.6,1.1-0.7,1.8c0.1-0.1,0.1-0.2,0.2-0.2C506.1,42.7,506.2,42.7,506.2,42.6z"
      />
      <path
        class="st3"
        d="M494.7,53.6c0.4,0.6,0.6,1,0.1,1.7s0,1.3,0.4,1.8c0.3,0.3,0.6,0.7,1.2,0.7c0-1.7,0-3.5,0-5.2
		c-0.2-0.3-0.5-0.6-0.9-0.9c-0.6,0.1-1.2,0.2-1.8,0.3C494,52.5,494.3,53,494.7,53.6z"
      />
      <path
        class="st3"
        d="M488.1,47.7c0.3-0.2,0.5-0.4,0.7-0.6c0.2,0.4,0.2,0.9,0.5,1.1c0.6,0.4,1,0.7,1.2,1.2c0.8-0.2,1.6-0.4,2.4-0.7
		c0,0,0,0-0.1,0c-1.3-0.2-2.1-0.8-2.4-1.7c-0.1-0.3-0.2-0.6-0.3-0.8c-0.7,0.2-1.4,0.4-2.1,0.6C488,47.1,488,47.4,488.1,47.7z"
      />
      <path
        class="st3"
        d="M493.8,50.5c0.1,0.1,0.1,0.2,0.2,0.4c0.1-0.1,0.3-0.3,0.4-0.4C494.2,50.4,494,50.4,493.8,50.5z"
      />
      <path
        class="st3"
        d="M487,42.7c0.1,0.2,0.2,0.4,0.2,0.6c0.1,0.3,0.1,0.6,0,0.9c0.7-0.2,1.3-0.5,2-0.7c-0.1-0.9-0.8-1.5-1.5-2.2
		c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1-0.1c0,0,0,0.1-0.1,0.1C486.9,41.7,486.7,42.2,487,42.7z"
      />
      <path
        class="st3"
        d="M498.2,56.5h0.1c0-0.4,0.2-0.8,0-1c0-0.1,0-0.1-0.1-0.2C498.2,55.7,498.2,56.1,498.2,56.5z"
      />
      <path
        class="st3"
        d="M394.7,60.6c0.6,1.5,2.4,2.4,4.3,2c0.2,0,0.4-0.1,0.6-0.2c-1.2-1.7-2.4-3.4-3.6-5.1
		C394.8,58.2,394.3,59.5,394.7,60.6z"
      />
      <path
        class="st3"
        d="M402.7,58.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1,0-0.2,0-0.3,0c-0.1-0.1-0.2-0.2-0.3-0.3c0.2,0.3,0.4,0.6,0.6,0.9
		c0-0.1,0-0.1,0-0.1C402.4,58.4,402.5,58.3,402.7,58.2z"
      />
      <path
        class="st3"
        d="M375.1,77.8c-0.3-1.8-2.3-2.8-4.4-2.4c-1.5,0.3-2.5,1.2-2.9,2.3c1.6,1.7,3.1,2.1,5.4,1.2
		c0.6-0.3,1.3-0.5,1.9-0.7C375.1,78,375.1,77.9,375.1,77.8z"
      />
      <path
        class="st3"
        d="M537,68.5c0.2,0,0.4,0,0.6,0.1c0.1-0.3,0.2-0.6,0.2-0.9l0,0c0-0.3,0.1-0.6,0.1-0.9c0-0.1,0-0.1,0-0.2
		c-0.1,0-0.1-0.1-0.2-0.1c-0.2-0.1-0.4-0.2-0.5-0.4C537.1,66.9,537,67.7,537,68.5z"
      />
      <path
        class="st3"
        d="M534.2,67.5c-0.8-0.1-1.2-0.1-1.6-0.1c0,0.5,0,0.9,0,1.4C533.1,68.4,533.5,68,534.2,67.5z"
      />
      <path
        class="st3"
        d="M532.1,67.3l0.2-0.1l0.3,0.1c0.2-0.7,0.4-1.3,0.7-2c-0.1,0-0.2,0.1-0.3,0.1C532.7,66.1,532.4,66.7,532.1,67.3z
		"
      />
      <path
        class="st3"
        d="M402.9,56.4c0.8,0.9,1.9,1.1,3.1,1c1.5-0.3,3.5-2.3,3.5-3.4c0-0.7-0.4-1.3-1.2-1.5c-0.7-0.2-1.5-0.4-2.3-0.4
		c-1.3-0.1-2.4,0.4-3.2,1.4C402.1,54.3,402.1,55.5,402.9,56.4z"
      />
      <path
        class="st3"
        d="M603.9,43.3c-0.6,0.4-1.1,0.9-1.3,1.6c-0.5,1.5,0.6,3,2.4,3.3c1.5,0.3,3.5-0.8,4-2.2c0-0.1,0.1-0.2,0.1-0.4
		c0.1-0.9-0.5-1.5-0.7-2.3c-0.5-0.2-0.9-0.4-1.4-0.5C605.9,42.5,604.8,42.8,603.9,43.3z"
      />
      <path
        class="st3"
        d="M608.3,43.3C608.4,43.3,608.4,43.4,608.3,43.3C608.4,43.4,608.4,43.3,608.3,43.3
		C608.4,43.3,608.4,43.3,608.3,43.3L608.3,43.3z"
      />
      <path
        class="st3"
        d="M400.4,65.8c0.3,1.2,1.6,1.9,3.1,1.9c-0.9-1.3-1.8-2.5-2.7-3.8C400.4,64.6,400.2,65.2,400.4,65.8z"
      />
      <path
        class="st3"
        d="M406.8,64.4c0-0.2-0.1-0.3-0.2-0.5c-0.3-0.7-1.1-1.2-2-1.4c0.1,0.1,0.2,0.3,0.3,0.4c0.6,0.9,1.2,1.8,1.8,2.7
		C406.8,65.3,406.9,64.8,406.8,64.4z"
      />
      <path
        class="st3"
        d="M410.1,57.6c-1.7,0.4-2.8,1.8-2.6,3.2c0,0.3,0.2,0.5,0.3,0.7c0.3,0.3,0.7,0.7,1,1c0.6,0.3,1.5,0.4,2.3,0.3
		c1.8-0.4,3-1.8,2.6-3.3C413.6,58.1,411.9,57.2,410.1,57.6z"
      />
      <path
        class="st3"
        d="M526.5,48.9c1.7-0.4,2.8-1.9,2.5-3.3c-0.3-1.4-2-2.2-3.7-1.9l0,0h-0.1c-0.3,0.1-0.5,0.2-0.8,0.3
		c-0.1,0.1-0.3,0.1-0.4,0.2c-1,0.6-1.5,1.6-1.3,2.7C523,48.4,524.8,49.3,526.5,48.9z"
      />
      <path
        class="st3"
        d="M396.2,67.3c-0.1,0-0.2,0-0.3,0c-0.5,0.1-1,0.3-1.4,0.6c-0.9,0.6-1.4,1.6-1.1,2.6c0.1,0.4,0.3,0.7,0.6,1
		c1.9-0.4,3.7-0.8,5.5-1.2c0.1-0.4,0.2-0.8,0.1-1.2C399.3,67.9,397.8,67.1,396.2,67.3z"
      />
      <path
        class="st3"
        d="M343,90.9c-0.7,0.3-1.2,1-1.2,1.7c0.6-0.2,1.4-0.5,2.5-0.8C343.8,91.3,343.4,91,343,90.9z"
      />
      <path
        class="st3"
        d="M347.8,93.3c-0.1-0.1-0.2-0.2-0.3-0.4c0,0.2-0.1,0.4-0.1,0.6c0.1,0,0.3,0,0.4,0
		C347.8,93.5,347.8,93.4,347.8,93.3z"
      />
      <path
        class="st3"
        d="M345.1,94.5c0.2,0.2,0.4,0.3,0.5,0.5c0-0.3,0-0.6-0.1-0.9c-0.2,0-0.4,0-0.6,0.1
		C345.1,94.2,345.1,94.3,345.1,94.5z"
      />
      <path
        class="st3"
        d="M416,63.6c-1.2,0.1-2.1,0.7-2.6,1.6c-0.1,0.1-0.1,0.3-0.2,0.5c0.5,0,1-0.1,1.6-0.3c1.1-0.4,2.2-0.7,3.2-1
		c-0.1-0.1-0.1-0.1-0.1-0.2C417.5,63.7,416.8,63.5,416,63.6z"
      />
      <path
        class="st3"
        d="M415.4,68.1c0.2,0,0.4,0,0.6,0c0.3,0,0.6-0.1,0.9-0.2c0.6-0.2,1.1-0.6,1.4-1.1c-0.6,0.2-1.2,0.5-1.8,0.7
		C416.2,67.7,415.8,67.8,415.4,68.1z"
      />
      <path
        class="st3"
        d="M531.6,43.7c0.8,0.3,1.7,0.3,2.5-0.1c0.3-0.1,0.6-0.3,0.9-0.5c0.9-0.8,1.2-1.9,0.7-2.8
		c-0.1-0.1-0.2-0.3-0.3-0.4c-1.7,1-3.4,1.6-5.3,2C530.2,42.7,530.8,43.4,531.6,43.7z"
      />
      <path
        class="st3"
        d="M333.1,65.9c0.8,0.6,1.6,1.3,2.4,1.9c-0.1,0.1-0.3,0.3-0.4,0.4c0.1-0.1,0.3-0.3,0.4-0.4
		c0.1,0.2,0.2,0.5,0.3,0.7c-0.2-0.1-0.5-0.2-0.7-0.3c-1-0.5-2-1-2.9-1.5c-0.4,0.5-0.7,1.1-0.6,1.8c0,0.1,0.1,0.1,0.1,0.2
		c0.6,0.5,1.1,1,1.7,1.5c0.5,0.1,1,0.2,1.6,0.1c1.4-0.3,2.5-1.7,2.3-2.9c-0.2-1.2-1.8-2-3.2-1.7C333.6,65.7,333.3,65.8,333.1,65.9z"
      />
      <path
        class="st3"
        d="M401.2,77.8c0.1,0,0.3,0,0.4,0c1-0.1,1.8-0.5,2.3-1.1C403,77.1,402.1,77.5,401.2,77.8L401.2,77.8z"
      />
      <path
        class="st3"
        d="M399.3,74.5c-0.2,0.3-0.3,0.6-0.3,0.9c1.6-0.5,3.2-0.9,4.8-1.4c-0.1-0.1-0.2-0.2-0.3-0.3c-0.8-0.6-2-0.6-3-0.2
		h-0.1c-0.2,0.1-0.4,0.2-0.6,0.4C399.6,74.1,399.4,74.3,399.3,74.5z"
      />
      <path
        class="st3"
        d="M408.5,68.5c0.8,1.2,1.5,2.4,2.3,3.7c0.3-0.2,0.5-0.5,0.6-0.8c0.2-0.4,0.2-0.8,0.1-1.2
		c-0.2-0.9-1.1-1.5-2.1-1.6C409.1,68.4,408.8,68.4,408.5,68.5z"
      />
      <path
        class="st3"
        d="M341.2,76.4c0.5-0.2,1.1-0.4,0.7-1c0-0.1,0.2-0.4,0.3-0.4c1.1-0.2,0.7-0.8,0.7-1.2c-0.3-1.4-1.8-2.1-3.3-1.6
		c-1,0.3-1.8,1-2,1.8c1,0.9,2,1.7,3,2.6C340.8,76.5,341,76.5,341.2,76.4z"
      />
      <path
        class="st3"
        d="M339.3,76.4c-0.5-0.4-1-0.9-1.5-1.3c0,0.1-0.1,0.2-0.1,0.2c0.2,0.3,0.4,0.6,0.8,0.8
		C338.8,76.2,339.1,76.3,339.3,76.4z"
      />
      <path
        class="st3"
        d="M365.4,66.6c1.6-0.3,2.6-1.5,2.4-2.8c-0.2-1.2-1.6-1.9-3.1-1.7c-1.5,0.3-2.6,1.5-2.4,2.8
		C362.6,66.1,363.9,66.9,365.4,66.6z"
      />
      <path
        class="st3"
        d="M552.3,7.7c0.1,0.7,0.8,1,1.6,1c1.2,0.1,2.3-0.3,3.2-1c0.7-0.6,0.9-1.6,0.5-2.3c-0.7-1.1-1.1-1.3-2.9-0.9
		c-0.3,0.2-1.1,0.4-1.7,0.9C552.1,6,552.1,6.9,552.3,7.7z"
      />
      <path
        class="st3"
        d="M602.2,54.4c0,0.1,0,0.1,0,0.2c0.2,1.2,1.6,1.9,3.1,1.6c1.4-0.3,2.4-1.5,2.2-2.6c-0.2-1.2-1.5-2-3-1.7
		c-1,0.2-1.7,0.8-2.1,1.5C602.2,53.7,602.2,54.1,602.2,54.4z"
      />
      <path
        class="st3"
        d="M517,37.1c0.6-0.1,1.2-0.1,1.7-0.2c0.2,0,0.4-0.1,0.6-0.1c0.5-0.2,0.8-0.5,1-0.9c-2,0.7-4,1.3-6,1.9
		c0.1,0.2,0.2,0.4,0.5,0.7c0.2,0.1,0.3,0.2,0.5,0.3c0.1,0,0.3,0,0.4-0.1C516.7,38.4,517.1,37.8,517,37.1z"
      />
      <path
        class="st3"
        d="M519.9,33.9c-0.2-0.2-0.4-0.3-0.7-0.4c-0.2-0.1-0.4-0.1-0.7-0.1l0,0c-0.5,0-1,0.2-1.5,0.4
		c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0.1-0.1,0.2-0.2,0.3c0,0.1-0.1,0.2-0.1,0.3C517.3,34.7,518.6,34.3,519.9,33.9
		C520,34,520,33.9,519.9,33.9z"
      />
      <path
        class="st3"
        d="M404,80c-0.1,0-0.2,0.1-0.3,0.1c0.4,0.7,0.8,1.5,1.3,2.2s1.3,0.8,2.2,0.7c0.3-0.1,0.5-0.2,0.7-0.3
		c0-1,0.1-2.1,0.2-3.1c-0.3-0.2-0.7-0.3-1.1-0.5c0-0.4,0.3-0.9-0.4-1.1c-0.9-0.2-1.4,0.1-2.3,1.3c0.2,0.3,0.5,0.6,0.7,0.9
		c-0.1,0.1-0.1,0.1-0.2,0.2C404.6,80.2,404.3,80.1,404,80z"
      />
      <path
        class="st3"
        d="M324.6,93.5L324.6,93.5l-0.1,0.1c-0.2,1.2-0.4,2.5-0.7,3.7c0.5,0.1,1.1,0,1.8-0.4c0.3-0.2,0.6-0.4,0.9-0.7
		c0.2-0.2,0.4-0.3,0.6-0.5c-0.2-0.3-0.3-0.7-0.5-1.1s-0.4-0.7-0.6-1.1c-0.3-0.4-0.7-0.5-0.4-1.1c0.2-0.4-0.2-0.8-0.8-0.8
		c-0.5,0-0.9,0.2-1,0.5C324.1,92.6,324.3,93.1,324.6,93.5L324.6,93.5z"
      />
      <path
        class="st3"
        d="M323.7,95.3c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.2,0,0.3c0.1,0.1,0.1,0.1,0.2,0.2
		C323.6,95.4,323.7,95.3,323.7,95.3z"
      />
      <path
        class="st3"
        d="M374.1,109.8c0.3,0.6,0.5,1.4,0.8,2.5c0.2-0.3,0.4-0.7,0.4-1.1c0-0.1,0-0.2,0-0.3
		C375.2,110.3,374.6,110.1,374.1,109.8z"
      />
      <path
        class="st3"
        d="M373.7,113.2c0.2-0.1,0.4-0.2,0.5-0.3c-0.7-0.4-1.5-0.7-2.1-1.1c0,0.1,0,0.1,0,0.2
		C372.4,112.4,372.9,112.8,373.7,113.2z"
      />
      <path
        class="st3"
        d="M371.8,107.4c0.1,0.3,0.1,0.7,0.2,1c0.9,0.1,1.5,0.4,1.9,1.1c0.1-0.1,0.2-0.1,0.2-0.2l0.1-0.1
		c0.4-0.5,0.3-0.7-0.1-1.3l-0.1-0.1c0-0.1-0.1-0.2,0-0.2c0.6-0.4,0.1-0.8-0.1-1c-0.3-0.2-0.6-0.4-1-0.5c0.1,0.4,0.2,0.8,0.3,1.2
		c-0.5-0.3-1-0.6-1.5-0.9c-0.1,0.1-0.1,0.3-0.1,0.4C371.7,106.8,371.8,107.1,371.8,107.4z"
      />
      <path
        class="st3"
        d="M377.1,100.6c0.4-0.1,0.9-0.2,1.3-0.3c0,0,0,0-0.1,0h-0.1c-0.2,0-0.4-0.1-0.6-0.1
		C377.4,100.3,377.3,100.5,377.1,100.6z"
      />
      <path
        class="st3"
        d="M375,102.6c0.4,0.1,0.8,0.2,1.2,0.2c0.4,0.1,0.7,0.2,1,0.3l0,0c0.1,0,0.3,0.1,0.4,0.1c0.8,0.4,1.6,0.5,2.4,0
		c1,1.3,1,1.3,2.6,1c0-0.1,0.1-0.3,0.1-0.4c-0.3-0.3-0.6-0.5-0.9-0.8c0.4-0.2,0.8-0.3,1.1-0.3l0,0c0,0,0,0-0.1,0
		c-0.7-0.1-1.3-0.3-2-0.4c-0.1-0.4-0.3-0.7-0.5-1c-1.6,0.3-3.3,0.7-4.9,1C375.2,102.4,375.1,102.4,375,102.6z"
      />
      <path
        class="st3"
        d="M540.7,38.6c0.3-0.1,0.6-0.2,0.8-0.3c-0.6-1.2-1.3-2.4-1.9-3.6c-0.3,0.1-0.6,0.2-0.8,0.3
		c0.6,1.2,1.1,2.4,1.6,3.6C540.5,38.6,540.6,38.6,540.7,38.6z"
      />
      <path
        class="st3"
        d="M557.6,32.1V32c-1.1,0.6-2.2,1.2-3.2,1.8c0.4,0.1,0.7,0.2,1.1,0.3c0.5,0.1,1,0.3,1.4,0.6
		c0.1,0.1,0.6-0.1,0.8-0.2c0.1-0.1,0.2-0.5,0.1-0.5c-0.2-0.2-0.3-0.4-0.3-0.5C557.4,33,557.5,32.6,557.6,32.1z"
      />
      <path
        class="st3"
        d="M414.5,78.1c0.4-0.1,0.8-0.2,1.1-0.5c0.1-0.1,0.3-0.3,0.4-0.4s0.1-0.2,0.2-0.2c0.2-0.4,0.3-0.8,0.2-1.2
		c-0.1-0.5-0.5-0.9-1.1-1.1c-0.1,0-0.1,0-0.2-0.1C414.6,75.3,414.5,76.5,414.5,78.1z"
      />
      <path
        class="st3"
        d="M412.4,77c0-1.3,0.1-2.5,0-3.8c-0.2,0-0.5,0-0.9,0c0.4,0.9,0.8,1.6,0.6,2.5C412.1,76.1,412.2,76.5,412.4,77z"
      />
      <path
        class="st3"
        d="M545.7,44.3c0.4-0.1,0.7-0.2,1-0.4c0-0.2,0-0.4,0-0.5c-0.6-0.4-1.2-0.8-1.8-1.2c-0.2,0.1-0.3,0.3-0.5,0.4
		c0.3,0.6,0.6,1.2,0.9,1.8C545.4,44.3,545.6,44.3,545.7,44.3z"
      />
      <path
        class="st3"
        d="M572.7,21.7c-0.6,0.2-1.2,0.6-1.7,1c-0.7,0.6-0.8,1.5-0.3,2.1s1.8,0.9,2.6,0.6s1.5-0.7,2.2-1.1
		c-0.2-1.1-0.5-1.6-0.9-2.2C574.1,21.6,573.4,21.5,572.7,21.7z"
      />
      <path
        class="st3"
        d="M432.2,42.7c0.7,0.2,1.5,0.4,2.2,0.4c0.5,0,1-0.2,1.5-0.4c0.3-0.1,0.5-0.4,0.8-0.6c1.1-0.8,1.2-1.5,0.5-2.6
		c-0.4,0.2-1,0.7-1.3,0.6c-1.6-0.4-2.8,0.1-3.9,1.2c-0.2,0.2-0.5,0.3-0.8,0.4C431.4,42.2,431.6,42.6,432.2,42.7z"
      />
      <path
        class="st3"
        d="M371.3,60.9c0.3-0.1,0.6-0.2,0.9-0.4s0.5-0.4,0.6-0.6c-1-0.9-1.9-1.7-2.9-2.6c-0.1,0-0.2,0.1-0.3,0.1
		c0.8,1,1.6,1.9,2.5,2.9l0,0c-1-0.8-2-1.6-3-2.4c-0.4,0.5-0.7,1.1-0.5,1.6C368.7,60.6,370,61.2,371.3,60.9z"
      />
      <path
        class="st3"
        d="M388.4,50.2c0.3-0.1,0.7-0.2,0.9-0.4c-1-0.9-1.9-1.8-2.9-2.7c-0.6,0.5-0.9,1.2-0.7,1.9
		C386,49.8,387.2,50.4,388.4,50.2z"
      />
      <path
        class="st3"
        d="M592.6,58.8c-0.8-0.6-1.6-0.1-2.5,0.1c-0.3-1.3-1.7-0.7-2.7-1c-0.3,0.4-0.5,0.8-0.8,1.1c0.8,0.7,1.6,1.3,2.3,2
		c0.5,0,1-0.2,1.4-0.1c0.8,0.3,1.6,0.1,2.4-0.1C592.9,60.1,593.4,59.4,592.6,58.8z"
      />
      <path
        class="st3"
        d="M374.7,64.2c0.1,0.3,0.4,0.5,0.6,0.7c0.5,0.3,1.1,0.5,1.8,0.3c0.1,0,0.2-0.1,0.3-0.1c-0.4-0.4-0.8-0.9-1.2-1.3
		l0,0c-0.5-0.4-1-0.8-1.5-1.2c-0.2,0.3-0.3,0.7-0.3,1.1C374.5,63.9,374.6,64,374.7,64.2z"
      />
      <path
        class="st3"
        d="M378.5,62c-0.2-0.1-0.3-0.3-0.6-0.4c0.1,0.2,0.3,0.3,0.4,0.5C378.4,62.1,378.5,62.1,378.5,62z"
      />
      <path
        class="st3"
        d="M376.9,63.1c-0.2,0-0.4,0-0.6,0c0,0.2,0,0.4,0,0.6C376.5,63.5,376.7,63.3,376.9,63.1z"
      />
      <path
        class="st3"
        d="M401.3,87.2c0.3-0.3,0.6-0.7,0.7-1c0-0.2,0.1-0.4,0-0.6c-0.2-1.1-1.3-1.7-2.6-1.5c-1,0.2-1.8,0.9-1.9,1.7
		c0,0.2,0,0.3,0,0.5c0.1,0.7,0.6,1.2,1.3,1.4C399.7,87.6,400.5,87.4,401.3,87.2L401.3,87.2z"
      />
      <path
        class="st3"
        d="M559.6,28.6c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.1-0.1,0.2c0.1,0,0.2,0.2,0.2,0.1
		C559.5,28.9,559.6,28.7,559.6,28.6z"
      />
      <path
        class="st3"
        d="M561.9,34.2c0.6-1.2,0.6-1.2-0.5-2.5c0.9-0.9,0.9-1,0.6-1.4l-0.1-0.1c-1.1,0.3-2.1,0.7-3.1,1.2
		c0.5,0.3,1.1,0.5,2,0.6C560.5,33,560.8,33.8,561.9,34.2z"
      />
      <path
        class="st3"
        d="M592.4,54.4c0.1,0.2,0.1,0.5,0.3,0.7c0.7,1,2.6,1.2,3.5,0.3c0.9-0.8,0.9-2,0.1-2.7c-0.9-0.7-2.2-0.6-3.1,0.2
		c-0.4,0.3-0.8,0.7-1.2,1.1C592.1,54.1,592.3,54.2,592.4,54.4z"
      />
      <path
        class="st3"
        d="M332.5,81.6c1.2-0.3,2-1.2,1.9-2.2c-0.2-0.9-1.4-1.6-2.5-1.4c-0.3,0.1-0.6,0.2-0.9,0.3l0,0
		c-0.7,0.5-1.2,1.3-1.1,2C330.1,81.2,331.3,81.8,332.5,81.6z"
      />
      <path
        class="st3"
        d="M383.9,59c0.3,1.4,1.4,2,3.4,1.8c-0.4-1.6-0.1-3.4-0.8-5C384.4,56.6,383.6,57.6,383.9,59z"
      />
      <path
        class="st3"
        d="M335.8,86.6c0.2,0.9,1.5,1.6,2.6,1.3c1.3-0.3,2.1-1.3,1.8-2.4c-0.3-1-1.3-1.5-2.6-1.2
		C336.4,84.7,335.6,85.7,335.8,86.6z"
      />
      <path
        class="st3"
        d="M350.8,90C350.9,90,350.9,90,350.8,90c0.1,0,0.1-0.1,0.2-0.1c0.6-0.2,1.2-0.4,1.7-0.6c0.2-0.2,0.3-0.3,0.4-0.6
		c0-0.1,0.1-0.1,0.1-0.2c0.2-0.6-0.1-1.1-0.4-1.4c-1.1,0.6-2.1,1.3-3,2.4c0.1,0.2,0.2,0.5,0.3,0.7C350.3,90.2,350.6,90.1,350.8,90z"
      />
      <path
        class="st3"
        d="M390.9,62.6c-1.2,0.2-2,1.3-1.8,2.3c0.2,0.9,1.5,1.5,2.5,1.2c1.1-0.3,1.9-1.3,1.7-2.2
		C393.2,62.9,392,62.4,390.9,62.6z"
      />
      <path
        class="st3"
        d="M571.1,44.5C571.1,44.5,571.1,44.4,571.1,44.5c-0.2-0.4-0.3-0.6-0.4-0.9c-0.7,0.4-1.4,0.8-2,1.2
		c0.2-0.5,0.5-0.8,0.8-1.1c0.4-0.4,0.8-0.8,0.3-1.2c-0.4-0.3-0.9,0-1.3,0.3c-0.3,0.3-0.6,0.5-0.9,0.8c-0.4-0.2-0.7-0.3-1.6-0.6
		c0.6,1.2,0.3,2-0.5,2.7c-0.3,0.3-0.2,0.7-0.4,1.4c0.9-0.5,1.5-0.7,2.2-1.1c0.2,0.2,0.4,0.5,0.6,0.7
		C569.1,45.7,569.3,44.4,571.1,44.5L571.1,44.5z"
      />
      <path
        class="st3"
        d="M308.4,65.8c-0.7-0.4-1.4-1-2.2-1.1v1.7c0.6,0.3,1.1,0.6,1.7,0.9C308.3,66.8,308.5,66.3,308.4,65.8z"
      />
      <path
        class="st3"
        d="M576.7,54.6c1.1-0.7,2.1-1.3,3.1-2c-0.4-0.5-0.7-1-1-1.5c-0.3-0.4-0.5-0.8-0.8-1.2c-0.4,0.1-0.8,0.3-1.1,0.5
		c-0.2,0.1-0.4,0.3-0.5,0.4c-0.1,0.2-0.2,0.3-0.1,0.5c0.4,0.8-0.2,1.5-0.5,2.2l0,0C576.2,54,576.4,54.3,576.7,54.6z"
      />
      <path
        class="st3"
        d="M394.9,82.6C394.9,82.6,395,82.6,394.9,82.6c0.5,0.2,1.1,0.1,1.7-0.2c-0.6-0.9-0.3-2.1-0.9-3
		c-0.3,0-0.7,0-1,0.1v0.1c-0.4,0.6-1,1.1-1.4,1.7c0.1,0.1,0.1,0.2,0.2,0.4c0.3,0.3,0.6,0.6,0.9,0.9
		C394.5,82.4,394.7,82.5,394.9,82.6z"
      />
      <path
        class="st3"
        d="M376.8,71.6c-0.1,0-0.3,0.1-0.4,0.2c-0.8,0.5-1.4,0.5-2.2,0.4c-0.2,0-0.4,0.1-0.9,0.3c1,0.7,1.9,1.4,2.9,2
		c0.2,0.1,0.5,0.2,0.8,0.2c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.5-0.2s0.4-0.2,0.5-0.4c0.6-0.6,0.7-1.3,0.2-1.8
		C378.1,71.8,377.4,71.5,376.8,71.6z"
      />
      <path
        class="st3"
        d="M367.4,102.4c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.2-0.5-0.4-0.8-0.5C367.2,101.8,367.3,102.1,367.4,102.4z"
      />
      <path
        class="st3"
        d="M364.4,104.5c0.1,0.1,0.2,0.3,0.3,0.4c0.5,0.4,1.2,0.5,2,0.2c0-0.4-0.3-0.7-0.6-1c-0.3,0.1-0.6,0.1-0.9,0.2
		C364.9,104.4,364.6,104.4,364.4,104.5z"
      />
      <path
        class="st3"
        d="M449.2,60.7c0.7-0.2,1.4-0.4,2.1-0.6c0,0,0-0.1,0.1-0.1c0.2-0.3,0.5-0.5,1-0.7c0.2-0.1,0.5-0.2,0.7-0.2
		c-0.6-0.5-1.1-1-1.6-1.5l-0.1-0.1c-0.7,0.5-1.3,0.8-1.8,1.3c-0.2,0.1-0.2,0.3-0.3,0.4c-0.1,0.3,0.1,0.7,0.2,1
		C449.6,60.2,449.4,60.4,449.2,60.7C449.2,60.6,449.2,60.6,449.2,60.7z"
      />
      <path
        class="st3"
        d="M542,51.8c-0.3,0.3-0.4,0.8-0.3,1.2c0,0.2,0.1,0.4,0.2,0.6C541.9,53,542,52.4,542,51.8z"
      />
      <path
        class="st3"
        d="M543.8,54.2c1-0.2,1.7-1.1,1.6-1.9c-0.1-0.6-0.7-1-1.4-1.1c-0.1,0-0.3,0-0.4,0c-0.1,0.2-0.2,0.4-0.2,0.6
		c-0.1,0.9,0,1.7,0.2,2.4C543.6,54.2,543.7,54.2,543.8,54.2z"
      />
      <path
        class="st3"
        d="M497.9,31.9c0.1,0,0.3-0.1,0.4-0.1c-0.3-0.9-0.5-1.7-0.8-2.6c-0.2,0-0.4,0-0.6,0.1c-0.1,0-0.2,0.1-0.4,0.1
		c0.2,0.9,0.5,1.7,0.7,2.6C497.4,31.9,497.6,31.9,497.9,31.9z"
      />
      <path
        class="st3"
        d="M557.8,38.3c-0.2-0.8-1.2-1.3-2.2-1.1s-1.7,1.1-1.5,1.9c0.2,0.8,1.2,1.2,2.1,1C557.3,39.8,558,39.1,557.8,38.3
		z"
      />
      <path
        class="st3"
        d="M442.8,32.9c0.2-0.1,0.4-0.2,0.5-0.4c0.3-0.2,0.6-0.4,1-0.7c0.4,0.9,1.2,1.3,2.3,1.4c0,0,0,0,0.1-0.1
		c-0.8-0.8-1.6-1.7-2.4-2.5c-0.2,0.2-0.4,0.4-0.5,0.6c-0.6-0.1-1.1-0.2-1.8-0.4c0.2,0.3,0.5,0.7,0.7,1l0,0c-0.4-0.4-0.8-0.8-1.1-1.1
		c-0.1,0-0.1,0-0.1,0C441.4,32,441.8,32.5,442.8,32.9z"
      />
      <path
        class="st3"
        d="M580.5,54.6c0.1,0.3,0.2,0.6,0,0.8c-1,1.3-0.4,2.1,0.8,2.9c0.1-0.1,0.2-0.2,0.2-0.3l0.1-0.1
		c0.6-0.6,1.4-1.2,1-1.9c-0.1-0.2-0.2-0.5-0.2-0.8c-0.1-0.4-0.1-0.8-0.3-1.1s-0.5-0.6-1.2-0.7C580.4,54.3,580.4,54.2,580.5,54.6z"
      />
      <path
        class="st3"
        d="M426.1,75.6c-1,0.2-1.6,0.9-1.6,1.7c0,0.1,0,0.2,0.1,0.3c0.2,0.6,0.9,1,1.6,1c0.1,0,0.3,0,0.4,0
		c1-0.2,1.7-1.1,1.5-1.9C428,75.9,427.1,75.4,426.1,75.6z"
      />
      <path
        class="st3"
        d="M364.9,59.3c0.9-0.2,1.6-1,1.6-1.7c-0.1-0.8-1.1-1.4-2.1-1.2c-0.9,0.2-1.6,0.9-1.6,1.7
		C362.9,58.9,363.9,59.5,364.9,59.3z"
      />
      <path
        class="st3"
        d="M606.6,20.3c0.4,0.5,1.1,0.8,1.9,0.7c0.9-0.2,1.6-1,1.5-1.8c-0.1-0.3-0.2-0.6-0.5-0.8
		c-0.4-0.3-0.9-0.4-1.5-0.4c-1,0.1-1.8,1.1-1.6,1.9C606.5,20.1,606.6,20.2,606.6,20.3z"
      />
      <path
        class="st3"
        d="M331.8,95.7c0.2,0.1,0.3,0.1,0.5,0.2c-0.2-0.2-0.3-0.5-0.5-0.7c-0.6,0.1-1,0.1-1.4,0.3
		c-0.3,0.1-0.6,0.3-0.8,0.4c0,0.7-0.1,1.3-0.1,1.9c0.3,0.2,0.6,0.4,1,0.4C330.9,97.3,331.3,96.5,331.8,95.7z"
      />
      <path
        class="st3"
        d="M332.4,96.2L332.4,96.2c-0.2,0.5-0.4,1-0.6,1.6C332.4,97.4,332.7,96.8,332.4,96.2z"
      />
      <path
        class="st3"
        d="M586.2,66.1c0.9,0.5,0,1.4,0.5,1.9c1.5,0.6,1.5,0.6,2.9-0.2c0.1-0.5,0.2-1.1,0.3-1.5c-0.8-0.9-2.2-0.3-3-0.9
		C586.6,65.2,585.9,65.9,586.2,66.1z"
      />
      <path
        class="st3"
        d="M417.5,82.2c0.1,0.6,0.5,1,1.1,1.2c0.6-0.1,1.1-0.2,1.7-0.4c0.5-0.3,0.8-0.9,0.6-1.4c-0.1-0.3-0.2-0.5-0.4-0.7
		c-0.4-0.4-1-0.6-1.6-0.5C418.1,80.6,417.4,81.4,417.5,82.2z"
      />
      <path
        class="st3"
        d="M541.1,31c-0.1,0-0.2,0-0.2,0l0,0c0.1,0.2,0.2,0.4,0.3,0.7C541.1,31.5,541.1,31.3,541.1,31z"
      />
      <path
        class="st3"
        d="M348.8,68.6c0.7,0.6,1.6,0.7,2.6,0.4c-1-0.9-2-1.9-3-2.8l0,0C347.7,67.1,348,67.9,348.8,68.6z"
      />
      <path
        class="st3"
        d="M329.6,92.8c0,0.1,0,0.2,0,0.3c0.2,0,0.3,0,0.5,0C329.9,92.9,329.8,92.9,329.6,92.8z"
      />
      <path
        class="st3"
        d="M357.4,75.3c0-0.1,0-0.2,0-0.3c-0.8-0.8-1.5-1.6-2.3-2.4c-0.2,0-0.4-0.1-0.7-0.1
		C353.6,74.5,354.6,75.5,357.4,75.3z"
      />
      <path
        class="st3"
        d="M382.9,60.9c-0.2-0.7-1-1.1-1.9-0.9c-0.2,0-0.3,0.1-0.4,0.2c0.7,0.7,1.4,1.3,2,2
		C382.8,61.8,383,61.3,382.9,60.9z"
      />
      <path
        class="st3"
        d="M400.7,50.4c0.9-0.2,1.4-1,1.3-1.7s-0.9-1.2-1.8-1c-1,0.2-1.6,0.9-1.5,1.7C398.8,50.2,399.7,50.6,400.7,50.4z"
      />
      <path
        class="st3"
        d="M379.1,108.3c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.3,0.3-0.5c-0.1-0.1-0.1-0.2-0.2-0.2
		C379.4,107.9,379.2,108.1,379.1,108.3z"
      />
      <path
        class="st3"
        d="M375.8,109.5c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0c0.5,0,1.1,0,1.6,0h0.1c-0.2-0.4-0.4-0.8-0.6-1.1
		c-0.1-0.1-0.3-0.3-0.4-0.4c0.1,0.1,0.3,0.3,0.4,0.4c-0.2,0.1-0.5,0.2-0.7,0.3c0.1-0.2,0.2-0.5,0.3-0.7c0-0.1,0.1-0.2,0.1-0.3
		c-0.2,0.2-0.4,0.3-0.6,0.5c-0.5,0.3-0.8,0.7-0.6,1.2l0,0l0,0c-0.1,0.2-0.1,0.4-0.1,0.6C375.5,109.4,375.8,109.5,375.8,109.5z"
      />
      <path
        class="st3"
        d="M411.6,51.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.3,0.3c0.3,0.3,0.9,0.5,1.4,0.4c0.7-0.1,1.2-0.6,1.4-1.1
		c0.1-0.2,0.1-0.4,0-0.6c0-0.1,0-0.1-0.1-0.2c-0.1-0.2-0.2-0.4-0.4-0.5l0,0c-0.4-0.3-0.9-0.4-1.4-0.3
		C412,49.8,411.4,50.5,411.6,51.3z"
      />
      <path
        class="st3"
        d="M410.4,47.7L410.4,47.7c1-0.2,1.5-0.9,1.4-1.6c0-0.1,0-0.2-0.1-0.3c-0.2-0.6-0.9-0.9-1.7-0.8
		c-0.9,0.1-1.6,1-1.5,1.7C408.6,47.5,409.5,47.9,410.4,47.7z"
      />
      <path
        class="st3"
        d="M553.7,56.9c-0.7-1.1-2-1.5-3.3-1.9c-0.1,0-0.2,0-0.3,0c0,0.5,0,1.1,0,1.6c0.6,0,1,0.1,1.4,0.6
		C552.3,58.2,552.8,58,553.7,56.9z"
      />
      <path
        class="st3"
        d="M334.2,97.7c0.4,0.3,0.9,0.7,1.4,1c0.2-0.7,0.4-1.5,0.7-2.3c-0.1,0-0.2,0-0.3,0
		C335,96.5,334.4,96.9,334.2,97.7z"
      />
      <path
        class="st3"
        d="M337.3,97.2c0,0.5-0.1,1.2-0.1,1.8c0.6-0.5,0.8-1,0.5-1.7c0-0.1-0.1-0.2-0.2-0.2
		C337.4,97.1,337.3,97.1,337.3,97.2z"
      />
      <path
        class="st3"
        d="M440.1,31c-0.2-0.8-1.3-0.8-2.3-0.5c-0.4,1.2-0.3,2.3,0.5,3.3C439.9,33,440.4,32,440.1,31z"
      />
      <path
        class="st3"
        d="M577.5,26.5c0.6,0.3,1.3,0.2,1.8-0.3c0.4-0.3,0.7-0.7,1-1.2c-1.1-1-1.6-1.1-2.4-0.8c-0.4,0.2-0.7,0.4-0.9,0.7
		c0,0.1-0.1,0.2-0.2,0.3c0,0.1,0,0.2,0,0.2l0,0c0,0.1,0.1,0.2,0.1,0.3C577.1,26.2,577.3,26.4,577.5,26.5z"
      />
      <path
        class="st3"
        d="M345.1,81.5c0.2,0.2,0.5,0.5,0.7,0.7l0,0c-0.2,0-0.4,0-0.7,0c0.1,0.2,0.2,0.4,0.3,0.6c0.2,0,0.5,0,0.9-0.1
		c0.1,0,0.2,0,0.3,0c-0.7-1.1-1.4-2.2-2.2-3.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.2,0.3-0.3,0.4C344.5,80.1,344.8,80.9,345.1,81.5
		L345.1,81.5z"
      />
      <path
        class="st3"
        d="M345.1,82.1c0-0.2,0-0.4,0-0.6c-0.2,0-0.4,0-0.6,0C344.7,81.7,344.9,81.9,345.1,82.1z"
      />
      <path
        class="st3"
        d="M343.7,80.8C343.6,80.8,343.6,80.8,343.7,80.8c-0.1-0.1-0.1-0.1-0.2-0.2c0,0.2,0,0.4,0,0.6
		C343.5,81.1,343.6,80.9,343.7,80.8z"
      />
      <path
        class="st3"
        d="M459.1,74.5c-0.3,0.1-0.7,0.2-1,0.2c0.3,0.1,0.6,0.1,0.9,0.2C459,74.8,459.1,74.7,459.1,74.5z"
      />
      <path
        class="st3"
        d="M460.4,72c-1-0.7-1.2-0.7-1.7,0.2c-0.2,0.4-0.7,0.4-0.9,0.7c-0.3,0.3-0.7,0.7-0.7,1c0,0.1,0,0.2,0.1,0.2
		c0.8-0.2,1.5-0.4,2.3-0.7c0.2-0.3,0.4-0.6,0.6-0.9C460.2,72.4,460.3,72.2,460.4,72z"
      />
      <path
        class="st3"
        d="M377,81.6c-0.4,0.1-0.7,0.4-0.9,0.6l0,0c0.6-0.2,1.2-0.4,1.8-0.6C377.6,81.6,377.3,81.6,377,81.6z"
      />
      <path
        class="st3"
        d="M602,33.8c0.8-0.1,1.4-0.8,1.3-1.5c-0.1-0.7-0.9-1.1-1.7-1c-0.8,0.2-1.3,0.8-1.3,1.4
		C600.4,33.4,601.1,33.9,602,33.8z"
      />
      <path
        class="st3"
        d="M561.6,44.5c-0.7,0-1.1,0.4-0.8,0.9s0.5,0.9,0.4,1.4c0,0.2,0.4,0.5,0.9,1c0.1-0.7,0.2-1.1,0.3-1.5
		c0.3,0.2,0.6,0.4,0.8,0.6l0,0c0.7-1.5,0.4-2.1-1.1-2.2C561.9,44.5,561.8,44.5,561.6,44.5z"
      />
      <path
        class="st3"
        d="M439.9,78.1c0.1,0,0.2,0,0.3-0.1c0-0.1,0.1-0.3,0-0.5c0-0.3-0.2-0.5-0.4-0.7C439.8,77.3,439.9,77.7,439.9,78.1
		z"
      />
      <polygon class="st3" points="367.3,93.3 367.5,93.5 367.5,93.2 	" />
      <path
        class="st3"
        d="M348.8,80.7c0.1-1.6-0.4-2.1-2.6-2.4C346,80.2,346.7,80.8,348.8,80.7z"
      />
      <path
        class="st3"
        d="M343.3,100.2c0.1-0.1,0.2-0.2,0.3-0.2c0.1-0.1,0.2-0.2,0.3-0.2c0-0.6,0.1-1.1,0.1-1.7
		c-0.3-0.2-0.7-0.3-1.2-0.2c-0.7,0.1-1.1,0.5-1.2,1.1C341.5,99.7,342.3,100,343.3,100.2z"
      />
      <path
        class="st3"
        d="M563.8,25.1c-0.2,0.3-0.4,0.5-0.5,0.7c0.2-0.1,0.5-0.2,0.7-0.3C564,25.3,563.9,25.2,563.8,25.1z"
      />
      <path
        class="st3"
        d="M445.2,68.9c0.6,0.1,1.4-0.2,2-0.4c0.1-0.8,0.1-1.5,0.2-2.3c-0.6,0.3-1.2,0.5-1.7,0.8
		c-0.6,0.2-1.1,0.5-1.7,0.7C444.4,68.2,444.7,68.8,445.2,68.9z"
      />
      <path
        class="st3"
        d="M429.9,82.6c0.4,0.5,0.7,0.8,1.1,1c0.5,0.3,1,0.3,1.5-0.1c0.1-0.1,0.2-0.2,0.3-0.3c0-0.4,0.1-0.8,0.1-1.1
		c-0.1-0.1-0.1-0.2-0.2-0.3c-0.5-0.5-1.2-0.4-2.1,0.2C430.4,82.2,430.1,82.4,429.9,82.6z"
      />
      <path
        class="st3"
        d="M315.1,117.4c-0.3,0.1-0.7,0.6-0.6,0.8c0.1,0.4,0.2,0.8,0.4,1.2c0.2,0.5,0.5,0.9,1.3,1.2
		c0.1-0.2,0.1-0.4,0.2-0.5c0-0.8-0.1-1.5-0.1-2.3c0,0,0,0-0.1-0.1C315.9,117.5,315.4,117.3,315.1,117.4z"
      />
      <path
        class="st3"
        d="M326.4,101.8c-0.1-0.6-0.9-1-1.6-0.8c-0.4,0.1-0.7,0.3-1,0.6c0.8,0.3,1.7,0.6,2.5,0.8
		C326.4,102.2,326.5,102,326.4,101.8z"
      />
      <path
        class="st3"
        d="M372,97.5c0.1,0.1,0.2,0.1,0.3,0.2c0.3-0.5,0.5-1.1,0.8-1.7c0.1,0.9,0.2,1.5,0.3,2c0.2,0,0.4-0.1,0.5-0.1
		c0.2-0.1,0.3-0.1,0.5-0.2c0-0.1,0-0.1-0.1-0.2c-0.5-1.5-1-1.7-2.9-1.6C371,96.6,371.4,97.1,372,97.5z"
      />
      <path
        class="st3"
        d="M568.1,14.1c0.6-0.1,1.2-0.1,1.8-0.2c1.1-0.1,2.3-0.2,3.5-0.3c-1.5-1.2-3-1.3-4.3-0.5
		C568.8,13.4,568.5,13.7,568.1,14.1z"
      />
      <path
        class="st3"
        d="M415.8,70.3c-0.3,0.1-0.5,0.2-0.7,0.4c0.5-0.1,0.9-0.3,1.4-0.4C416.3,70.2,416.1,70.2,415.8,70.3z"
      />
      <path
        class="st3"
        d="M393,83.3c0-0.2-0.2-0.4-0.4-0.6c-0.1,0.6-0.1,1.1-0.1,1.7C392.9,84.1,393.1,83.8,393,83.3z"
      />
      <path
        class="st3"
        d="M550.4,45c0.5-0.3,1-0.6,1.5-0.9c0.4,0.5,1,0.4,1.6,0c-0.5-0.9-1.4-1-2.5-1c-0.6,0-0.9,0.2-1.2,0.5
		c0,0.4,0,0.8,0,1.2C550,44.9,550.1,45,550.4,45z"
      />
      <path
        class="st3"
        d="M509.3,39.9c0,0.1,0.1,0.3,0.3,0.4c0.3,0.3,0.8,0.4,1.3,0.4c0.2,0,0.5-0.1,0.7-0.3c0.4-0.3,0.6-0.7,0.6-1.1
		c-0.1-0.3-0.3-0.5-0.6-0.7c-0.4,0.1-0.7,0.2-1.1,0.3c-0.3,0.1-0.6,0.2-0.9,0.3C509.3,39.5,509.2,39.7,509.3,39.9z"
      />
      <path
        class="st3"
        d="M513.3,41.8L513.3,41.8c-0.4,0.1-0.5,0.3-0.7,0.4c0.6-0.1,1.1-0.3,1.7-0.4C513.9,41.7,513.6,41.6,513.3,41.8z"
      />
      <path
        class="st3"
        d="M416.2,44.4c0.2-0.1,0.4-0.2,0.5-0.3c-0.5-0.6-1-1.1-1.4-1.7c-0.5,0.3-0.8,0.8-0.7,1.2
		C414.7,44.3,415.5,44.7,416.2,44.4z"
      />
      <path
        class="st3"
        d="M568.9,12.5c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.5-0.9-0.9-1.5-0.8c-0.7,0.1-1.3,0.9-1.1,1.4
		C567.5,12.4,568.2,12.7,568.9,12.5z"
      />
      <path
        class="st3"
        d="M322.2,108.1C322.3,108.1,322.3,108,322.2,108.1c-0.5-1.2-0.9-0.8-1.3-0.4C321.3,108,321.8,108.2,322.2,108.1z
		"
      />
      <path
        class="st3"
        d="M416.6,55.8c0.1,0.2,0.3,0.4,0.5,0.6c0.3,0.1,0.7,0.2,1,0.1c0.7-0.2,1.2-0.8,1-1.3c-0.1-0.3-0.4-0.6-0.8-0.7
		c-0.2-0.1-0.5-0.1-0.7-0.1c-0.1,0-0.2,0-0.3,0.1c-0.4,0.2-0.7,0.5-0.8,0.8C416.6,55.4,416.6,55.6,416.6,55.8z"
      />
      <path
        class="st3"
        d="M333.5,41.7c-0.3-0.3-0.7-0.4-1.1-0.3c-0.7,0.1-1.2,0.7-1.1,1.3v0.1C332,42.4,332.8,42,333.5,41.7z"
      />
      <path
        class="st3"
        d="M445.4,59.1c0.2,0.2,0.3,0.3,0.5,0.5c0.7,0,1.1-0.3,1-0.8c0-0.1-0.1-0.2-0.1-0.3
		C446.4,58.7,445.9,58.9,445.4,59.1z"
      />
      <path
        class="st3"
        d="M445.3,57.1c0.2,0,0.3-0.1,0.5-0.1c0,0,0,0-0.1-0.1C445.6,57,445.4,57.1,445.3,57.1z"
      />
      <path
        class="st3"
        d="M451.9,66.6c-0.1-0.1-0.2-0.1-0.4-0.2c-0.2-0.1-0.5-0.1-0.7-0.1l0,0c-0.5,0.1-1,0.4-1,1c0,0.4,0.1,0.8,0.7,0.9
		c0.6,0,1.2-0.1,1.7-0.1C452.4,67.5,452.4,66.9,451.9,66.6z"
      />
      <path
        class="st3"
        d="M405.8,29c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.3,0.3-0.4,0.5c0,0,0,0,0,0.1C405.5,29.3,405.7,29.2,405.8,29z"
      />
      <path
        class="st3"
        d="M552,64.9c0-0.1,0-0.1-0.1-0.2c-0.2-0.5-1-1-1.4-0.9c-0.1,0-0.1,0-0.2,0.1c0,0.6,0,1.3,0,1.9
		c0.2,0.1,0.5,0.2,0.8,0.2C551.7,65.9,552.1,65.3,552,64.9z"
      />
      <path
        class="st3"
        d="M384,54.7c0.7-0.1,1.2-0.7,1.1-1.3c-0.1-0.5-0.7-0.8-1.3-0.7c-0.7,0.1-1.2,0.7-1.1,1.3
		C382.7,54.5,383.4,54.8,384,54.7z"
      />
      <path
        class="st3"
        d="M514.8,40.7c1.2-0.2,1.5-1.1,0.6-2c-0.5,0.2-1.1,0.4-1.6,0.7c-0.2,0.2-0.4,0.8-0.2,0.9
		C513.8,40.6,514.4,40.8,514.8,40.7z"
      />
      <path
        class="st3"
        d="M452.3,68.1c0.2,0.2,0.4,0.5,0.7,0.6c0.5,0.1,0.9,0.2,1.1,0.6s0.7,0.5,1.2,0.2c0.4-0.2,0.4-0.9-0.1-1.2
		c-0.5-0.3-1.1-0.6-1.7-0.9C453.1,67.6,452.7,67.9,452.3,68.1z"
      />
      <path
        class="st3"
        d="M390.7,110.3c0.3-0.3,0.7-0.7,0.9-1c-0.2-0.4-0.4-0.8-0.7-1.1c-0.2,0-0.4,0-0.4,0.1l-0.1,0.1
		c-0.4,0.3-0.8,0.7-0.9,1.1c0.3,0,0.6,0,1,0c-0.1,0.3-0.2,0.5-0.3,0.8C390.2,110.2,390.4,110.2,390.7,110.3z"
      />
      <path
        class="st3"
        d="M331.3,61.8c-0.4-0.2-0.8-0.4-1.1-0.5c-0.1,0.7-0.2,1.4-0.3,2.1C330.6,62.8,331.1,62.3,331.3,61.8z"
      />
      <path
        class="st3"
        d="M546,67c0.3,0.1,0.7-0.2,1.1-0.3c-0.9-1.8-1-1.8-2.6-1C544.9,66.2,545.2,66.8,546,67z"
      />
      <path
        class="st3"
        d="M443,83.1L443,83.1c-0.1,0.2-0.2,0.5-0.1,0.7c0.1-0.3,0.2-0.7,0.4-1C443.2,82.8,443.1,82.9,443,83.1z"
      />
      <path
        class="st3"
        d="M445.4,82.9c-0.1,0-0.3-0.1-0.4-0.1c-0.4,0.5-0.7,1.1-1.1,1.6C444.5,84.3,444.9,83.9,445.4,82.9z"
      />
      <path
        class="st3"
        d="M309,117.4c0,0.1-0.1,0.3-0.1,0.4c0.2,0.6,0.4,1.2,0.1,1.9c-0.2,0.6,0.5,0.7,1,0.7c0.1-0.5,0.2-0.8,0.3-1.2
		c0-0.2,0-0.3,0-0.5c0-0.6-0.3-1-0.8-1.3c-0.2-0.1-0.3-0.2-0.5-0.3C309,117.3,309,117.4,309,117.4z"
      />
      <path
        class="st3"
        d="M354.7,86.3c-0.2,0.1-0.4,0.2-0.6,0.2c0.2,0,0.4,0,0.7-0.1C354.7,86.5,354.7,86.4,354.7,86.3z"
      />
      <path
        class="st3"
        d="M354,85.2c-0.3-0.2-0.7-0.3-1.4-0.4c0,0.3,0,0.6,0.1,0.8C353.1,85.4,353.5,85.3,354,85.2z"
      />
      <path
        class="st3"
        d="M552.8,3.5c0.7-0.1,1.3-0.8,1.2-1.2c-0.2-0.5-0.6-0.7-1.2-0.7c-0.6,0-1,0.5-1,0.9
		C551.8,3.2,552.3,3.6,552.8,3.5z"
      />
      <path
        class="st3"
        d="M442.2,36c0.7-0.8,0.6-1.4,0-2c-0.9,0.1-1.5,0.5-1.5,1.2C440.7,36,441.5,35.9,442.2,36z"
      />
      <path
        class="st3"
        d="M436.3,34.9c0.5-0.1,0.8-0.6,0.7-1.3c-0.1-0.6-0.7-1-1.2-0.8c-0.5,0.1-0.9,0.8-0.8,1.3
		C435.2,34.6,435.8,35,436.3,34.9z"
      />
      <path
        class="st3"
        d="M388.6,104.3c-0.2,0.2-0.4,0.3-0.6,0.5c0.3-0.1,0.5-0.2,0.8-0.3C388.8,104.4,388.7,104.4,388.6,104.3z"
      />
      <path
        class="st3"
        d="M387.9,106.7c0.3-0.2,0.5-0.4,0.6-0.5c-0.4-0.2-0.8-0.4-1.3-0.6C387.2,105.9,387.4,106.2,387.9,106.7z"
      />
      <path
        class="st3"
        d="M486.5,37.9c-0.7-0.4-1.2,0-1.8,0.7c0.5,0.4,1,0.8,1.5,1.3C487.2,38.7,487.2,38.3,486.5,37.9z"
      />
      <path
        class="st3"
        d="M517.6,40.1c-0.7,0.1-1.2,0.5-1.4,1.2c1-0.2,2-0.5,2.9-0.7C518.7,40.1,518.3,40,517.6,40.1z"
      />
      <path
        class="st3"
        d="M396.7,96.5c0,0.1,0,0.2,0.1,0.3c0.7-0.1,1.4-0.3,2.1-0.4v-0.1c0-0.1-0.1-0.2-0.1-0.3
		c-0.2-0.3-0.5-0.4-0.9-0.3s-0.7,0.3-0.9,0.5C396.8,96.2,396.7,96.3,396.7,96.5z"
      />
      <path
        class="st3"
        d="M595.4,44.6c-0.6,0.1-1.1,0.6-1,1.1c0.1,0.4,0.7,0.7,1.2,0.6c0.5-0.1,0.9-0.6,0.9-1.1
		C596.5,44.9,595.9,44.5,595.4,44.6z"
      />
      <path
        class="st3"
        d="M565.3,16.8c0.7-0.3,1-0.8,0.9-1.5c-1.1,0-2,0.2-2.6,1.1C564.1,16.9,564.7,17,565.3,16.8z"
      />
      <path
        class="st3"
        d="M399,89.6c0.1,0.2,0.3,0.4,0.7,0.7c0.2-0.1,0.3-0.2,0.4-0.2c0.2-0.1,0.3-0.2,0.5-0.3c0.5-0.4,0.5-0.7-0.1-1
		C400,88.9,399.5,89.2,399,89.6z"
      />
      <path
        class="st3"
        d="M570.3,21c-0.1-0.5-0.8-0.8-1.4-0.6c-0.5,0.2-0.9,0.7-0.7,1.2c0.1,0.4,0.7,0.7,1.3,0.6
		C570,22,570.4,21.5,570.3,21z"
      />
      <path
        class="st3"
        d="M494.1,41.8c-0.1-0.1-0.1-0.2-0.2-0.3s-0.3-0.1-0.4-0.1c-0.5-0.1-1,0.5-0.9,1l0,0
		C493.1,42.1,493.6,42,494.1,41.8z"
      />
      <path
        class="st3"
        d="M484.4,45.1c-0.1,0-0.1,0.1-0.2,0.1c0.2-0.1,0.3-0.1,0.5-0.2C484.6,45.1,484.5,45.1,484.4,45.1z"
      />
      <path
        class="st3"
        d="M507.5,35.8c0.1,0.5,0.6,0.8,1.1,0.6c0.4-0.2,0.7-0.6,1.3-1c-0.6-0.3-1-0.6-1.5-0.7
		C507.9,34.7,507.4,35.3,507.5,35.8z"
      />
      <path
        class="st3"
        d="M493,54.7c0.2-0.8,0.2-1.5-1-2.2c0.1,1.1-0.8,2.1,0.3,3.1C492.6,55.2,492.9,54.9,493,54.7z"
      />
      <path
        class="st3"
        d="M567.7,50c-0.1,0-0.1-0.1-0.2-0.1c-0.4-0.3-0.8-0.4-1.3,0.2l0,0c0.4,0.8,0.8,1.7,1.2,2.5
		c0.1-0.1,0.3-0.1,0.4-0.2c-0.4-0.5-0.6-0.9,0-1.5C568.2,50.6,568,50.3,567.7,50z"
      />
      <path
        class="st3"
        d="M356.4,91.7c0.2,0.3,0.7,0.5,1.1,0.5c0.3,0,0.5-0.2,0.7-0.4c0.1-0.2,0.2-0.4,0.2-0.6c-0.1-0.2-0.3-0.4-0.6-0.5
		c-0.4,0.2-0.9,0.3-1.3,0.5C356.4,91.4,356.3,91.6,356.4,91.7z"
      />
      <path
        class="st3"
        d="M585,53.7c0.2-0.3,0.4-0.7,0.7-1c0.2-0.2,0.5-0.4,0.8-0.6c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.4-0.6-0.7-1
		c-0.2,0.3-0.4,0.5-0.6,0.8c-0.6,0.6-1.2,1.1-0.8,1.9C584.6,53.6,584.8,53.7,585,53.7z"
      />
      <path
        class="st3"
        d="M476.2,34.4c-0.2-0.9-0.8-1.4-2.1-1.1C474.6,34.8,474.9,34.9,476.2,34.4z"
      />
      <path
        class="st3"
        d="M482.4,62.8c0.1,0.5,0.3,0.7,0.4,0.9c0.1,0.1,0.1,0.1,0.2,0.1c0.2,0.1,0.3,0,0.6-0.1c0.6-0.2,0.7-0.6,0.6-1
		C484.1,62.2,483.6,62.3,482.4,62.8z"
      />
      <path
        class="st3"
        d="M413.4,36.4C413.3,36.4,413.3,36.4,413.4,36.4c0.1,0.2,0.2,0.4,0.4,0.5C413.7,36.8,413.6,36.6,413.4,36.4z"
      />
      <path
        class="st3"
        d="M454.9,66.3c-0.4,0.2-0.7,0.5-0.3,0.9c0.3,0.3,0.7,0.5,1.2,0.2s0.7-0.7,0.6-1.4
		C455.8,66.1,455.3,66.2,454.9,66.3z"
      />
      <path
        class="st3"
        d="M421.1,43.6c-0.3-0.7-0.8-1-1.5-1c-0.1,0-0.1,0-0.2,0c0.2,0.4,0.5,0.8,0.8,1.2
		C420.4,43.8,420.7,43.7,421.1,43.6z"
      />
      <path
        class="st3"
        d="M592.7,66.6c0.1-0.6-0.2-0.9-1.1-1c-0.2,0.6-0.4,1.2-0.7,2.2C592,67.5,592.6,67.2,592.7,66.6z"
      />
      <path
        class="st3"
        d="M552.4,14.9c0.3-0.5,0.7-0.8,0.7-1.2s-0.3-0.6-0.9-0.5c-0.6,0.1-1.1,0.7-0.9,1
		C551.5,14.5,551.9,14.6,552.4,14.9z"
      />
      <path
        class="st3"
        d="M570.7,51.1c0.6-0.6,0.9,0.3,1.4,0.1c0.7-0.6,0.3-1-0.2-1.5c-0.4,0.1-0.6,0.1-0.9,0.2c-0.1,0-0.1,0-0.2,0
		c-0.4,0.1-0.5,0.3-0.5,0.5c0,0.1,0,0.2,0,0.3C570.3,50.9,570.6,51,570.7,51.1z"
      />
      <path
        class="st3"
        d="M553.3,39.5c0.1-0.3,0.1-0.7-0.1-0.9c-0.4-0.5-0.9-0.4-1.9,0.4c0.4,0.3,0.7,0.6,1,0.7
		C552.6,39.7,553.2,39.6,553.3,39.5z"
      />
      <path
        class="st3"
        d="M435.6,62.5c0.3-0.1,0.7-0.5,0.8-0.7c0.1-0.4-0.4-0.7-1.1-0.6c-0.1,0.2-0.5,0.4-0.5,0.7
		C434.5,62.2,435.1,62.7,435.6,62.5z"
      />
      <path
        class="st3"
        d="M307.3,106.1c0.1-0.1,0.1-0.3,0.1-0.4c0-0.5-0.5-0.6-1.1-0.5c-0.1,0-0.2,0.1-0.2,0.1s0,0,0,0.1v1.2
		c0.2,0.1,0.5,0.3,0.7,0.5C307.1,106.6,307.2,106.3,307.3,106.1z"
      />
      <path
        class="st3"
        d="M308.3,53.6c-0.2,0.1-0.3,0.2-0.5,0.4c0.3-0.2,0.6-0.3,1-0.5C308.6,53.5,308.5,53.5,308.3,53.6z"
      />
      <path
        class="st3"
        d="M308.7,55c0.3-0.1,0.4-0.2,0.5-0.3c-0.2,0.1-0.5,0.2-0.7,0.3C308.6,55.1,308.6,55.1,308.7,55z"
      />
      <path
        class="st3"
        d="M492.8,47.8c0.6,0.3,1,0,1.5-0.6c-0.6-0.6-0.6-0.6-1.5-0.7C492.4,46.9,492.2,47.4,492.8,47.8z"
      />
      <path
        class="st3"
        d="M557.6,48.4c0.1,0.7,0.2,1.1,0.1,1.4c0,0.1,0,0.1,0,0.2c0,0.5,0.4,0.6,0.9,0.7l0,0c0.2,0,0.5,0.1,0.7,0.1
		c0-0.5-0.3-0.9-0.7-1.3C558.3,49.2,557.9,48.8,557.6,48.4z"
      />
      <path
        class="st3"
        d="M582,58.4c-0.1,0.2,0.1,0.6,0.3,0.7c0.9,0.3,1.1-0.3,1.4-0.9C582.6,57.8,582.1,57.8,582,58.4z"
      />
      <path
        class="st3"
        d="M445.3,29.3c-0.1,0-0.1-0.1-0.2-0.1C445.2,29.3,445.2,29.3,445.3,29.3C445.3,29.4,445.3,29.3,445.3,29.3z"
      />
      <path
        class="st3"
        d="M581.3,72.4c-0.2,0.3-0.5,0.6-0.6,0.9c0,0.1,0.2,0.2,0.4,0.3c0-0.1,0-0.1,0.1-0.2c0.1,0,0.2,0.1,0.3,0.1
		c0.5-0.1,1.1,0,1.4-0.7C582.5,72.5,581.9,72.4,581.3,72.4z"
      />
      <path
        class="st3"
        d="M425.4,39.5c0-0.5,0.2-0.9,0-1.1c-0.4-0.3-1-0.5-1.6,0C423.9,39.1,424.5,39.3,425.4,39.5z"
      />
      <path
        class="st3"
        d="M485.7,42.4c0.2-0.4,0.5-0.7,0.4-1c-0.1-0.1-0.2-0.2-0.4-0.3c-0.5-0.2-1.3,0.1-1.3,0.5c0,0.1,0,0.2,0,0.2
		C484.5,42.3,485.2,42.2,485.7,42.4z"
      />
      <path
        class="st3"
        d="M483.3,51.5c0.2-0.2,0.3-0.4,0.5-0.6c0.2-0.3,0.4-0.5,0-0.8c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.8,0.4-1.2,0.9
		c0.3,0.2,0.6,0.4,0.9,0.6C483.1,51.5,483.2,51.5,483.3,51.5z"
      />
      <path
        class="st3"
        d="M433.5,49.9c-0.1,0-0.2,0-0.3,0.1c0.1,0.1,0.3,0.3,0.4,0.4l0,0c0.2,0.2,0.3,0.3,0.5,0.5c0,0,0,0,0.1,0
		c0.1-0.1,0.3-0.4,0.2-0.5c0,0,0,0-0.1-0.1C434,50.1,433.8,49.9,433.5,49.9z"
      />
      <path
        class="st3"
        d="M432.6,50.1c0.1,0.1,0.1,0.1,0.2,0.2c0-0.1,0-0.2,0-0.3C432.8,50.1,432.7,50.1,432.6,50.1z"
      />
      <path
        class="st3"
        d="M433.5,51L433.5,51c0-0.2,0-0.4,0-0.6c-0.2,0-0.4,0-0.6,0C433.1,50.6,433.3,50.8,433.5,51z"
      />
      <path
        class="st3"
        d="M565.7,31c0,0.2,0.5,0.6,0.8,0.6s0.6-0.4,1.1-0.8c-0.5-0.2-0.9-0.6-1.2-0.5C566.1,30.4,565.7,30.8,565.7,31z"
      />
      <path
        class="st3"
        d="M434.5,36.4c0.3,0.3,0.7,0.6,1.1,0.9c0.2-0.1,0.3-0.3,0.5-0.4c-0.2-0.4-0.3-0.9-0.6-1.3
		c-0.1-0.1-0.7-0.1-0.9,0C434.4,35.8,434.4,36.2,434.5,36.4z"
      />
      <path
        class="st3"
        d="M587.7,61.8c0.4,0.3,0.3,1.1,1.2,0.7c0.7-0.3,0.2-0.8,0-1.2c0-0.1,0-0.2-0.1-0.2
		C588.4,61.2,587.8,61.2,587.7,61.8z"
      />
      <path
        class="st3"
        d="M561.3,49.6c-0.3-0.8-1.4-0.5-1.9-1l0,0l0,0C559.1,49.5,559.5,49.8,561.3,49.6z"
      />
      <path
        class="st3"
        d="M427.8,33.2c0.3-1.1,0.3-1.1-1.3-1.4C426.6,32.5,426.8,33,427.8,33.2z"
      />
      <path
        class="st3"
        d="M572.9,52.2L572.9,52.2c0.2,0.2,0.7,0.3,0.9,0.2c0.5-0.4,0.1-0.7-0.2-1c-0.1-0.1-0.1-0.1-0.2-0.2
		c-0.1,0-0.2-0.1-0.3-0.2C572.1,51.5,572.5,51.9,572.9,52.2z"
      />
      <path
        class="st3"
        d="M537.9,12c0.1-0.1,0.2-0.2,0.2-0.3c0-0.7,0-1.4-0.7-1.8c0,0.4-0.1,0.9-0.1,1.3C537.5,11.5,537.7,11.7,537.9,12
		z"
      />
      <path
        class="st3"
        d="M307.2,85.8c-0.1,0-0.1-0.1-0.2-0.1c-0.1,0.2-0.2,0.5-0.3,0.6C306.9,86.2,307,86,307.2,85.8z"
      />
      <path
        class="st3"
        d="M330.6,86.4c0.1,0.3,0.2,0.6,0.4,1c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1,0-0.2-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2
		C330.8,86.4,330.7,86.4,330.6,86.4z"
      />
      <path
        class="st3"
        d="M380.5,106.3c0.1,0,0.1,0.1,0.3,0.1c0.1-1-0.2-1.4-1.2-1.8c0.3,0.3,0.7,0.6,0.6,0.9c0,0.1-0.1,0.2-0.1,0.3
		C380.2,106,380.3,106.2,380.5,106.3z"
      />
      <path
        class="st3"
        d="M552.9,27.5c-0.2,0.1-0.5,0.5-0.4,0.7c0,0.4,0.5,0.5,1,0.3l0,0c0.1-0.3,0.1-0.6,0.2-0.9
		C553.4,27.5,553.1,27.5,552.9,27.5z"
      />
      <path
        class="st3"
        d="M408,84.2c-0.2-0.1-0.5-0.1-0.7,0c-0.1,0-0.2,0.4-0.1,0.5c0.2,0.4,0.5,0.6,0.9,0.5
		C407.9,84.8,408,84.5,408,84.2z"
      />
      <path
        class="st3"
        d="M429.5,53.3c0.1,0.1,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.3,0c-0.1-0.2-0.2-0.4-0.4-0.7
		C429.6,53.1,429.6,53.2,429.5,53.3z"
      />
      <path
        class="st3"
        d="M310.9,134.2c-0.1-0.2-0.2-0.4-0.2-0.7c-0.1-0.1-0.2-0.1-0.3-0.1c-0.2,0.1-0.6,0.5-0.5,0.7c0,0,0,0.1,0.1,0.1
		l0,0c0.1,0.1,0.4,0.2,0.6,0.3C310.7,134.4,310.8,134.3,310.9,134.2z"
      />
      <path
        class="st3"
        d="M460.6,32.6c0.4-0.5,0.8-0.9,0.2-1.4C459.8,32,459.8,32,460.6,32.6z"
      />
      <path
        class="st3"
        d="M472.3,49L472.3,49c-0.1-0.1-0.2-0.2-0.3-0.3c0,0,0,0-0.1,0.1s-0.2,0.2-0.3,0.3c-0.2,0.2-0.3,0.4-0.3,0.5
		c0.3-0.1,0.7-0.2,1-0.3C472.5,49.2,472.4,49.1,472.3,49z"
      />
      <path
        class="st3"
        d="M441.1,71.8c0-0.1,0-0.2,0-0.2c-0.5-0.2-1-0.4-1.7-0.6c0,0.2,0,0.4,0,0.6c0.1,0.2,0.3,0.4,0.6,0.4
		C440.4,72,440.8,71.9,441.1,71.8z"
      />
      <path
        class="st3"
        d="M424.1,40.6c-0.1-0.5-0.4-0.7-1-0.6c0.3,0.3,0.6,0.5,0.9,0.8C424.1,40.7,424.1,40.6,424.1,40.6z"
      />
      <path
        class="st3"
        d="M564.6,49.6c0.1,0.1,0.1,0.2,0.2,0.4c0.1,0,0.2-0.1,0.3-0.1l0,0c-0.1-1.1-0.1-1.1-1.2-1.5
		C564.2,48.8,564.4,49.2,564.6,49.6z"
      />
      <path
        class="st3"
        d="M509.6,50.2C509.6,50.1,509.6,50.1,509.6,50.2c-0.6-0.5-0.7-1.1-1.7-1c0.2,0.5,0.3,0.8,0.5,0.9
		C508.6,50.2,508.9,50.2,509.6,50.2z"
      />
      <path
        class="st3"
        d="M551.7,40.8C551.7,40.8,551.6,40.8,551.7,40.8c-0.1,0-0.2,0-0.2,0.1c-0.2,0.4-0.2,0.6,0.1,0.8
		c0.2,0.1,0.4,0.3,0.8,0.5c0-0.3,0-0.5,0-0.7C552.2,41.3,552,41,551.7,40.8z"
      />
      <path
        class="st3"
        d="M481.7,46.1c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.1-0.1-0.3-0.2-0.5c-0.4,0.3-0.8,0.5-1.2,0.8
		c0.1,0.2,0.2,0.4,0.3,0.6C481.3,46.3,481.5,46.2,481.7,46.1z"
      />
      <path
        class="st3"
        d="M508.5,15.7c-0.4-0.2-0.5-0.3-0.8-0.3c-0.2,0-0.4,0-0.9,0.1c0.3,0.5,0.5,0.8,0.7,1.3
		C507.9,16.3,508.1,16.1,508.5,15.7z"
      />
      <path
        class="st3"
        d="M400.3,70.3c0.2,0,0.3-0.1,0.5-0.1c0-0.1,0.1-0.1,0.1-0.2c0.2-0.2,0.4-0.5,0.5-0.7h-0.1
		c-0.1,0-0.2-0.1-0.3-0.1C400.2,69.6,400.1,69.7,400.3,70.3z"
      />
      <path
        class="st3"
        d="M430.7,43.7c-0.1-0.3-0.4-0.5-0.7-0.9c-0.3,0.4-0.6,0.7-0.6,0.7c0.2,0.3,0.5,0.4,0.8,0.7
		C430.4,44.1,430.8,43.9,430.7,43.7z"
      />
      <path
        class="st3"
        d="M438.7,29.6c0.2,0,0.5-0.5,0.8-0.7c0,0,0.1,0,0.1-0.1c-0.4-0.1-0.8-0.3-1.3-0.4C438,29.1,438,29.5,438.7,29.6z
		"
      />
      <path
        class="st3"
        d="M429.7,74.5c0.2,0.2,0.5,0.4,0.8,0.4c0.1,0,0.3-0.3,0.7-0.7c-0.5-0.1-0.8-0.3-1.2-0.3
		C430,73.9,429.7,74.4,429.7,74.5z"
      />
      <path
        class="st3"
        d="M555.3,45.3c-0.3-0.4-0.6-0.8-1.2-1.4c-0.1,0.6-0.3,0.9-0.2,1.1C554.2,45.3,554.4,45.8,555.3,45.3z"
      />
      <path
        class="st3"
        d="M338.9,102c0.1-0.1,0.2-0.2,0.2-0.3c0.2-0.4,0.1-0.7-0.2-1.1c-0.2,0.2-0.3,0.4-0.3,0.5
		C338.4,101.5,338.5,101.6,338.9,102L338.9,102z"
      />
      <path
        class="st3"
        d="M373,91.5c0-0.6-0.3-0.9-0.8-1c-0.2,0-0.3-0.1-0.5-0.1c0,0.3,0,0.5,0,0.6C371.9,91.5,372.4,91.6,373,91.5z"
      />
      <path
        class="st3"
        d="M428.6,27.1c0.4-0.9-0.2-1.1-1-1.3C427.5,26.5,427.6,27.1,428.6,27.1z"
      />
      <path
        class="st3"
        d="M442.6,80.2c0.1-0.1,0.2-0.2,0.3-0.3c0-0.1-0.1-0.1-0.1-0.2c-0.2,0.1-0.4,0.2-0.6,0.3l0,0l0,0l0,0
		C442.3,80.1,442.4,80.1,442.6,80.2z"
      />
      <path
        class="st3"
        d="M489.6,55.1c0.2,0.2,0.5,0.3,0.8,0.3c0.2,0,0.4-0.3,0.6-0.5c-0.3-0.2-0.6-0.3-1-0.6
		C489.7,54.7,489.5,55,489.6,55.1z"
      />
      <path
        class="st3"
        d="M579.8,65.8c0.4-1.2,0.4-1.2-0.9-1.7C579.2,64.7,579.4,65.1,579.8,65.8z"
      />
      <path
        class="st3"
        d="M592.1,52.1c-0.2-0.3-0.4-0.6-0.8-1.1C590.8,51.9,591.2,52.1,592.1,52.1z"
      />
      <path
        class="st3"
        d="M579.2,67.3c0.1,0.1,0.2,0.2,0.3,0.3c0.5-0.1,1.2-0.1,1.5-0.8c-0.4-0.1-0.7-0.2-0.9-0.2
		C579.8,66.8,579.5,67.1,579.2,67.3z"
      />
      <path
        class="st3"
        d="M490.8,53c-0.2-0.1-0.5-0.2-0.6-0.2h-0.1c-0.2,0.2-0.4,0.4-0.5,0.7c0,0.1,0.3,0.2,0.6,0.4
		C490.5,53.5,490.6,53.2,490.8,53z"
      />
      <path
        class="st3"
        d="M330.6,109.7c0.2,0,0.4,0,0.6,0c-0.1-0.1-0.2-0.2-0.3-0.2C330.8,109.5,330.7,109.6,330.6,109.7z"
      />
      <path
        class="st3"
        d="M440.6,57.2c0.3,0.2,0.6,0.3,0.8,0.3c0.1-0.1,0.3-0.1,0.4-0.2c0,0,0-0.1,0.1-0.3c-1-0.3-1.1-0.3-1.3,0
		C440.7,57.1,440.6,57.2,440.6,57.2z"
      />
      <path
        class="st3"
        d="M494.7,12.8c0.2-0.1,0.4-0.4,0.3-0.5c-0.1-0.2-0.4-0.3-0.7-0.4c-0.2,0.3-0.4,0.5-0.4,0.6
		C494,12.8,494.3,12.9,494.7,12.8z"
      />
      <path
        class="st3"
        d="M444.4,71.1c0.3,0,0.7,0,1,0.1c0-0.2,0.1-0.3,0.1-0.5c-0.3,0-0.7-0.1-1-0.1C444.5,70.7,444.5,70.9,444.4,71.1z
		"
      />
      <path
        class="st3"
        d="M436.7,42.7c-0.2,0.5-0.3,0.9,0.4,1c0.1,0,0.4-0.1,0.4-0.2C437.7,43,437.4,42.8,436.7,42.7z"
      />
      <path
        class="st3"
        d="M463.3,31.8c0.1-0.3,0.3-0.5,0.4-0.8c0-0.1-0.3-0.2-0.6-0.4c-0.1,0.4-0.3,0.7-0.3,0.9
		C462.7,31.7,463.1,31.7,463.3,31.8z"
      />
      <path
        class="st3"
        d="M475.7,38c-0.2,0.2-0.4,0.5-0.5,0.7l0.4,0.2c0.3-0.2,0.5-0.4,0.8-0.7C476.1,38.1,475.7,38,475.7,38z"
      />
      <path
        class="st3"
        d="M440.8,48.6c-0.2-0.1-0.4-0.2-0.7-0.2c-0.2,0-0.4,0.2-0.7,0.4c0.2,0.1,0.4,0.3,0.6,0.3c0.1,0,0.2,0,0.3,0
		c0.1,0,0.3,0,0.4-0.1C440.8,49,440.9,48.6,440.8,48.6L440.8,48.6z"
      />
      <path
        class="st3"
        d="M313.9,102.2c-0.1-0.5-0.1-0.9-0.2-1.2c-0.2,0.1-0.5,0.1-0.7,0.2C312.9,101.5,313.1,101.8,313.9,102.2z"
      />
      <path
        class="st3"
        d="M578.6,66.3c-0.4-0.4-0.8-0.6-1.6,0.1C577.7,66.6,578.1,67.1,578.6,66.3z"
      />
      <path
        class="st3"
        d="M390.6,102.6c0.2-0.1,0.3-0.3,0.6-0.6c-0.4-0.1-0.7-0.2-0.8-0.1c-0.1,0-0.1,0.1-0.1,0.2
		C390.4,102.2,390.5,102.4,390.6,102.6L390.6,102.6z"
      />
      <path
        class="st3"
        d="M393.2,99.7c0.3-0.3,0.5-0.6,0.7-0.9C393,99.1,393,99.1,393.2,99.7z"
      />
      <path
        class="st3"
        d="M470.3,43.1c0.8-0.6,0.8-0.6,0.5-0.9c-0.2-0.1-0.5-0.1-0.9-0.3C470.1,42.5,470.2,42.8,470.3,43.1z"
      />
      <path
        class="st3"
        d="M476.5,52.8c0.4-0.5,0.8-0.9,0.6-1.6C476.4,51.7,476.1,52.2,476.5,52.8z"
      />
      <path
        class="st3"
        d="M573.7,8.7c-0.2-0.3-0.4-0.6-0.6-1c-0.2,0.1-0.3,0.2-0.5,0.2c0.2,0.3,0.5,0.6,0.7,0.9
		C573.5,8.8,573.6,8.7,573.7,8.7z"
      />
      <path
        class="st3"
        d="M465.3,41.6c0.2-0.2,0.4-0.3,0.7-0.6c-0.4-0.1-0.6-0.2-0.8-0.2c-0.2,0.1-0.4,0.3-0.4,0.5
		C464.9,41.4,465.1,41.5,465.3,41.6z"
      />
      <path
        class="st3"
        d="M559,42.8c-0.2,0.1-0.4,0.3-0.6,0.5c0,0.1,0.2,0.2,0.5,0.4c0.3-0.3,0.4-0.5,0.6-0.7
		C559.3,43,559.1,42.8,559,42.8z"
      />
      <path
        class="st3"
        d="M392.4,106c0.3,0.2,0.6,0.3,1,0.6c0-0.5-0.2-0.8-0.5-0.9c-0.1-0.1-0.3-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.3,0.3
		C392.3,105.9,392.3,105.9,392.4,106z"
      />
      <path
        class="st3"
        d="M578.6,71.1c-0.5,0.5-0.5,0.9,0,1.3C579.2,71.9,579,71.5,578.6,71.1z"
      />
      <path
        class="st3"
        d="M571.1,37.1c0.1-0.2,0.2-0.5,0.2-0.7c0-0.1-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.5,0.5c0,0.1,0.2,0.3,0.3,0.4
		C570.8,37.1,571,37.1,571.1,37.1z"
      />
      <path
        class="st3"
        d="M544.1,64c-0.3-0.1-0.5-0.2-0.8-0.3h0.1c0,0,0,0-0.1,0c0-0.2-0.1-0.5-0.1-0.7c-0.2-0.1-0.4-0.2-0.6-0.2
		c0.2,0.7,0.4,1.3,0.5,1.8C543.3,64.7,543.5,64.5,544.1,64z"
      />
      <path
        class="st3"
        d="M541.5,61.8c-0.2,0-0.4-0.1-0.6,0c-0.2,0.3-0.5,0.6-0.7,0.9c-0.5,0.9,0.1,1.7,1.2,1.7
		C541.4,63.5,541.4,62.6,541.5,61.8z"
      />
      <path
        class="st3"
        d="M339.4,104.1c0-0.2-0.3-0.3-0.6-0.5l0,0c-0.2,0.3-0.3,0.5-0.3,0.7c0,0.1,0.4,0.3,0.5,0.3
		C339.1,104.5,339.4,104.2,339.4,104.1z"
      />
      <path
        class="st3"
        d="M401.4,32.3c-0.3-0.1-0.6-0.2-0.8-0.2c-0.1,0.2-0.1,0.3-0.2,0.5c0.2,0.1,0.5,0.1,0.7,0.2
		C401.2,32.7,401.3,32.5,401.4,32.3z"
      />
      <path
        class="st3"
        d="M356,81.6c-0.3,0.3-0.6,0.5-0.8,0.8c0,0,0.1,0.2,0.3,0.4c0.3-0.4,0.6-0.7,0.8-1
		C356.2,81.8,356.1,81.7,356,81.6z"
      />
      <path
        class="st3"
        d="M553,48.3c0,0.8,0.8,0.6,1.2,0.8C554,48.6,553.7,48.2,553,48.3z"
      />
      <path
        class="st3"
        d="M411.5,65c0.1-0.5-0.1-0.7-0.8-0.8c0,0.1,0.1,0.1,0.1,0.2l0.1,0.1C411.1,64.8,411.3,64.9,411.5,65z"
      />
      <path
        class="st3"
        d="M548,62.2c-0.4,0.2-0.6,0.4-0.7,1c0.3-0.2,0.5-0.4,0.7-0.5C548,62.5,548,62.3,548,62.2z"
      />
      <path
        class="st3"
        d="M434.3,46.9C434.3,46.9,434.4,46.9,434.3,46.9c0.1-0.1,0.1-0.1,0.1-0.1C434.4,46.8,434.4,46.8,434.3,46.9
		L434.3,46.9z"
      />
      <path
        class="st3"
        d="M434.4,46.8c0.6-0.1,1.1-0.2,1.7-0.4C435.3,46,435.3,46,434.4,46.8z"
      />
      <path
        class="st3"
        d="M382,100.9C382,100.9,381.9,100.9,382,100.9C381.9,100.9,381.9,101,382,100.9L382,100.9z"
      />
      <path
        class="st3"
        d="M417.6,79.7c-0.2,0.1-0.4,0.1-0.6,0.2c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.1,0.1,0.1,0.2,0.2
		c0.3-0.2,0.6-0.3,0.9-0.5C417.7,79.9,417.6,79.8,417.6,79.7z"
      />
      <path
        class="st3"
        d="M334.9,108.2c-0.2,0.2-0.2,0.4,0,0.6C334.9,108.6,334.9,108.4,334.9,108.2z"
      />
      <path
        class="st3"
        d="M568.4,48c0.2,0.7,0.2,0.9,0.6,1c0.1,0,0.2,0.1,0.4,0.1c-0.1-0.1-0.2-0.2-0.3-0.3
		C569,48.6,568.8,48.4,568.4,48z"
      />
      <path
        class="st3"
        d="M474.7,47.9c0.2-0.1,0.4-0.3,0.7-0.6c-0.2,0-0.3-0.1-0.4-0.1c-0.2-0.1-0.3-0.1-0.4-0.1
		c-0.2,0.2-0.3,0.4-0.4,0.6c0,0,0.1,0,0.1,0.1C474.5,47.9,474.7,47.9,474.7,47.9z"
      />
      <path
        class="st3"
        d="M481.7,61.1C481.7,61.1,481.7,61,481.7,61.1h-0.1C481.7,61.1,481.7,61.1,481.7,61.1L481.7,61.1z"
      />
      <path
        class="st3"
        d="M482.6,61.7c0.1,0,0.3-0.3,0.3-0.4c-0.1-0.6-0.7-0.3-1.1-0.3C481.8,61.5,481.9,61.8,482.6,61.7z"
      />
      <path
        class="st3"
        d="M484.1,60c-0.1,0.2-0.3,0.5-0.4,0.7c0.2,0,0.4,0.1,0.4,0.1c0.2-0.2,0.3-0.4,0.5-0.6
		C484.4,60.1,484.2,60,484.1,60z"
      />
      <path
        class="st3"
        d="M362.4,84.9c0.1,0,0.2,0,0.4,0c0.2,0,0.5-0.1,0.7-0.2c0-0.1,0-0.2,0-0.2c-0.4,0-0.8,0-1.3,0.1
		c-0.1,0-0.2,0-0.2,0l0,0c0,0.1,0,0.2,0,0.3C362,84.9,362.2,84.9,362.4,84.9z"
      />
      <path
        class="st3"
        d="M589.5,56.6c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3,0.2-0.7,0.4-1,0.6c0.1,0.1,0.1,0.2,0.2,0.2
		C588.7,56.9,589.1,56.8,589.5,56.6z"
      />
      <path
        class="st3"
        d="M539.8,60.8c0.1,0.3,0.4,0.5,0.9,0.7c-0.1-0.7-0.3-1-0.9-1.1C539.8,60.5,539.8,60.7,539.8,60.8z"
      />
      <path
        class="st3"
        d="M384.6,112.2c0.4,0.2,0.8,0.5,1.1-0.1c0-0.1-0.1-0.2-0.1-0.2C385.3,112,384.9,112.1,384.6,112.2z"
      />
      <path
        class="st3"
        d="M559.4,35.6c-0.1-0.4-0.1-0.8-1.1-0.9c0.3,0.5,0.5,0.8,0.7,1.1C559.1,35.8,559.3,35.7,559.4,35.6z"
      />
      <path
        class="st3"
        d="M382,110.3c0.2,0.1,0.5,0.2,0.7-0.2c0,0,0-0.1,0.1-0.1c-0.2-0.1-0.4-0.2-0.6-0.2s-0.4,0-0.5,0.1
		C381.8,110.1,381.9,110.2,382,110.3z"
      />
      <path
        class="st3"
        d="M573.8,46c-0.1,0-0.2,0-0.4,0c-0.1,0.3-0.1,0.7-0.2,1c0.1,0,0.2,0,0.4,0C573.7,46.6,573.8,46.3,573.8,46z"
      />
      <path
        class="st3"
        d="M557.2,51.5c0.1,0,0.1-0.1,0.2-0.1c-0.2-0.3-0.3-0.6-0.5-0.9c-0.1,0-0.2,0.1-0.3,0.1
		C556.9,50.9,557,51.2,557.2,51.5z"
      />
      <path
        class="st3"
        d="M588,64.5c0,0.1-0.1,0.2-0.1,0.3c0.3,0,0.6,0.1,0.9,0.1c0-0.1,0.1-0.2,0.1-0.3C588.6,64.7,588.3,64.6,588,64.5
		z"
      />
      <path
        class="st3"
        d="M436.4,47.2c0,0.2-0.1,0.4-0.1,0.7c0.5-0.5,0.7-1,0-1.3C436.3,46.7,436.4,46.9,436.4,47.2z"
      />
      <path
        class="st3"
        d="M473.7,44.5c-0.1-0.1-0.3-0.4-0.4-0.3c-0.2,0-0.3,0.2-0.6,0.4c0.2,0.2,0.4,0.3,0.4,0.3
		C473.4,44.8,473.5,44.6,473.7,44.5z"
      />
      <path
        class="st3"
        d="M484.1,21.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.1,0.1-0.1,0.2-0.2,0.3C483.7,21.2,483.9,21.2,484.1,21.1z"
      />
      <path
        class="st3"
        d="M523.7,50.5c0.2-0.3,0.5-0.5,0.7-0.8c0,0,0,0,0.1-0.1l0.1-0.1c-0.1,0-0.2-0.1-0.2-0.1c-0.3,0.3-0.7,0.6-1,1
		C523.4,50.4,523.6,50.4,523.7,50.5z"
      />
      <path
        class="st3"
        d="M483.7,55.6c0.3-0.1,0.5-0.2,0.8-0.3c-0.1-0.3-0.2-0.5-0.3-0.7C483.6,54.8,483.5,55.2,483.7,55.6z"
      />
      <path
        class="st3"
        d="M484.1,54.6c0-0.1,0.1-0.1,0.1-0.2C484.2,54.4,484.2,54.5,484.1,54.6L484.1,54.6L484.1,54.6z"
      />
      <path
        class="st3"
        d="M533.9,63.5c-0.1,0.2-0.2,0.3-0.2,0.5l0,0c0,0,0-0.1,0.1-0.1C533.8,63.8,533.8,63.6,533.9,63.5z"
      />
      <path
        class="st3"
        d="M464.8,75.3c-0.1,0.3-0.2,0.4-0.1,0.5l0.1,0.1C464.8,75.7,464.8,75.5,464.8,75.3z"
      />
      <path
        class="st3"
        d="M407.8,88.5c0-0.2,0.1-0.4,0.1-0.6C407.6,88.3,407.6,88.4,407.8,88.5z"
      />
      <path
        class="st3"
        d="M479.9,46.8c0-0.3,0-0.7,0-1c-0.1,0-0.2,0-0.3,0c-0.1,0.4-0.1,0.8-0.2,1.1C479.6,46.9,479.7,46.8,479.9,46.8z"
      />
      <path
        class="st3"
        d="M553.4,42.1c0.2-0.2,0.5-0.4,0.7-0.6c-0.1-0.1-0.1-0.1-0.2-0.2c-0.2,0.1-0.5,0.3-0.7,0.4
		C553.1,41.8,553.3,42,553.4,42.1z"
      />
      <path
        class="st3"
        d="M485.9,57.7c-0.1,0.1-0.2,0.2-0.3,0.4l0.3,0.2c0.1,0,0.1-0.1,0.2-0.1c0.1-0.1,0.2-0.2,0.3-0.3
		c-0.2-0.2-0.3-0.3-0.4-0.4C486,57.5,486,57.6,485.9,57.7z"
      />
      <path
        class="st3"
        d="M585.7,48.6c0.1-0.1,0.2-0.1,0.3-0.2c-0.2-0.2-0.4-0.4-0.6-0.6h-0.1c-0.1,0-0.1,0.1-0.2,0.1c0,0,0,0.1,0.1,0.1
		C585.4,48.2,585.5,48.4,585.7,48.6z"
      />
      <path
        class="st3"
        d="M594.9,58.4c0.4,0.2,0.6,0.3,1,0.4C595.6,58.3,595.6,58.3,594.9,58.4z"
      />
      <path
        class="st3"
        d="M447.9,59c0.2,0,0.4-0.2,0.6-0.3c-0.2-0.2-0.4-0.3-0.5-0.3c-0.2,0.1-0.4,0.3-0.6,0.5
		C447.6,58.9,447.7,59.1,447.9,59z"
      />
      <path
        class="st3"
        d="M576.8,0.6c-0.1-0.2-0.3-0.4-0.4-0.6H576l0,0c0.2,0.2,0.3,0.5,0.5,0.7C576.6,0.7,576.7,0.6,576.8,0.6z"
      />
      <path
        class="st3"
        d="M387.2,99.9L387.2,99.9c-0.1,0-0.3,0-0.4,0c0,0.1,0.1,0.2,0.1,0.3c0.1,0,0.2-0.1,0.3-0.1h0.1
		C387.3,100,387.3,100,387.2,99.9z"
      />
      <path
        class="st3"
        d="M450.9,35.8c-0.1,0-0.2-0.1-0.3-0.1c0,0,0,0.1,0.1,0.1C450.7,35.8,450.8,35.8,450.9,35.8z"
      />
      <path
        class="st3"
        d="M430.1,30.7c0-0.1-0.2-0.3-0.3-0.3c-0.1,0-0.4,0.2-0.3,0.2c0.1,0.2,0.2,0.3,0.4,0.5
		C430,30.9,430.2,30.8,430.1,30.7z"
      />
      <path
        class="st3"
        d="M433.2,27c0.2-0.4-0.1-0.6-0.7-0.7c0.2,0.3,0.3,0.6,0.4,0.8C432.9,27.1,433.2,27,433.2,27z"
      />
      <path
        class="st3"
        d="M339.5,93c-0.1,0-0.2,0-0.3,0l0,0C339.3,93.1,339.4,93.1,339.5,93C339.5,93.1,339.5,93.1,339.5,93z"
      />
      <path
        class="st3"
        d="M333.8,95.5c0-0.2,0.1-0.3,0.1-0.5c-0.1,0-0.2-0.1-0.3-0.1h-0.1c0,0.2,0,0.4,0,0.6
		C333.6,95.5,333.7,95.5,333.8,95.5z"
      />
      <path
        class="st3"
        d="M538.9,77.7c0.3-0.1,0.5-0.2,0.8-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.3,0.1-0.6,0.2-0.9,0.4
		C538.8,77.5,538.9,77.7,538.9,77.7z"
      />
      <path
        class="st3"
        d="M557.5,73.4c0.6-0.3,1-0.5,1.4-0.6C558.3,72.6,557.8,72.6,557.5,73.4z"
      />
      <path
        class="st3"
        d="M538.1,64.5c0-0.1,0-0.3,0-0.4c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.3,0.2c0.1,0,0.1,0.1,0.2,0.1
		C537.9,64.4,538,64.5,538.1,64.5z"
      />
      <path
        class="st3"
        d="M469.9,36.4c-0.2,0-0.4-0.1-0.5-0.1c-0.1,0.1-0.2,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1
		C469.7,36.7,469.8,36.5,469.9,36.4z"
      />
      <path
        class="st3"
        d="M462.1,8.8c0.1,0,0.1-0.2,0.1-0.3c-0.1,0-0.2-0.1-0.3,0c-0.1,0-0.1,0.2-0.1,0.3C461.8,8.7,462,8.8,462.1,8.8z"
      />
      <path
        class="st3"
        d="M596,40.6c-0.1,0-0.3,0-0.4-0.1c-0.1,0.2-0.1,0.5-0.2,0.7c0.1,0,0.2,0,0.3,0C595.7,41.1,595.8,40.8,596,40.6z"
      />
      <path
        class="st3"
        d="M502.3,1.3c0.1-0.2,0.2-0.3,0.3-0.5c0,0-0.1-0.1-0.3-0.2c-0.1,0.2-0.2,0.3-0.3,0.5
		C501.9,1.1,502.2,1.2,502.3,1.3z"
      />
      <path
        class="st3"
        d="M477.4,44.4c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0.2-0.2,0.4-0.3,0.6c0.1,0,0.1,0,0.2,0.1
		C477.1,44.9,477.2,44.6,477.4,44.4z"
      />
      <path
        class="st3"
        d="M453.5,57.8c0.2,0,0.5,0,0.7,0c-0.1-0.1-0.3-0.3-0.4-0.4C453.7,57.6,453.6,57.7,453.5,57.8z"
      />
      <path
        class="st3"
        d="M459.7,37.3c0.1,0,0.3-0.2,0.3-0.3s-0.2-0.2-0.2-0.3c-0.1,0.1-0.3,0.2-0.5,0.3l-0.1,0.1c0.2,0,0.3,0.1,0.4,0.1
		C459.7,37.3,459.7,37.3,459.7,37.3z"
      />
      <path
        class="st3"
        d="M434.1,30.3c0.1-0.1,0.2-0.2,0.4-0.3c-0.2-0.1-0.4-0.1-0.5-0.2c0,0.1-0.1,0.3-0.1,0.4
		C433.9,30.2,434.1,30.3,434.1,30.3z"
      />
      <path
        class="st3"
        d="M610.7,15.7c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.1,0.2,0.3,0.4,0.4,0.6
		C610.6,15.7,610.7,15.7,610.7,15.7z"
      />
      <path
        class="st3"
        d="M550.4,38.4c-0.1,0-0.2-0.1-0.3-0.1s-0.1,0-0.2-0.1c0,0.1-0.1,0.3-0.1,0.4c0.1,0,0.1,0.1,0.2,0.1
		C550.1,38.7,550.2,38.6,550.4,38.4z"
      />
      <path
        class="st3"
        d="M578.7,61.5c-0.2-0.2-0.4-0.4-0.6-0.6c-0.1,0-0.1,0.1-0.2,0.1c0.2,0.2,0.3,0.5,0.5,0.7
		C578.5,61.7,578.6,61.6,578.7,61.5z"
      />
      <path
        class="st3"
        d="M440.3,29.6C440.3,29.5,440.3,29.5,440.3,29.6c-0.2-0.3-0.4-0.5-0.7-0.7C439.7,29.2,439.7,29.6,440.3,29.6z"
      />
      <path
        class="st3"
        d="M569.4,35c-0.1,0-0.1,0-0.2,0c0,0.2,0,0.3,0,0.5c0,0.1,0,0.2,0,0.2s0,0,0.1,0s0.2,0,0.3,0
		C569.5,35.5,569.5,35.3,569.4,35C569.5,35,569.5,35,569.4,35C569.5,35,569.4,35,569.4,35z"
      />
      <path
        class="st3"
        d="M435.1,48.1c0-0.1,0-0.1-0.1-0.1c0,0-0.1,0-0.1-0.1V48C435,48.1,435,48.1,435.1,48.1z"
      />
      <path
        class="st3"
        d="M435.8,48.6c-0.3-0.2-0.5-0.3-0.7-0.5C435.2,48.4,435.1,48.8,435.8,48.6z"
      />
      <path
        class="st3"
        d="M518.4,14c0.1-0.2,0.2-0.3,0.2-0.4c0-0.1-0.2-0.1-0.2-0.1c-0.1,0.1-0.3,0.2-0.3,0.2
		C518,13.8,518.2,13.8,518.4,14z"
      />
      <path
        class="st3"
        d="M580.5,51.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.2,0.2-0.2,0.3
		c0.1,0,0.1,0.1,0.2,0.1C580.1,51.5,580.3,51.4,580.5,51.2L580.5,51.2z"
      />
      <path
        class="st3"
        d="M452.3,63c0-0.1-0.2-0.1-0.3-0.1h-0.1c-0.1,0.1-0.2,0.2-0.2,0.3s0.2,0.2,0.4,0.4
		C452.2,63.2,452.4,63.1,452.3,63z"
      />
      <path
        class="st3"
        d="M437.7,48.6c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.4-0.3c-0.2-0.1-0.3-0.2-0.5-0.2
		C437.9,48.3,437.8,48.5,437.7,48.6z"
      />
      <path
        class="st3"
        d="M467.2,27.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1,0-0.3-0.1-0.4-0.1c0,0-0.2,0.2-0.1,0.2
		C466.9,27.3,467,27.4,467.2,27.5z"
      />
      <path
        class="st3"
        d="M382.4,106.7c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.2,0.2
		C382.2,106.9,382.3,106.8,382.4,106.7z"
      />
      <path
        class="st3"
        d="M531.1,47c0.1,0.1,0.3,0.1,0.4,0.1h0.1c-0.2-0.1-0.5-0.2-0.7-0.4C531,46.8,531,46.9,531.1,47z"
      />
      <path
        class="st3"
        d="M561.3,17.5c-0.1-0.1-0.2,0-0.3-0.1c0,0.1,0,0.2-0.1,0.3c0.1,0,0.2,0,0.3,0C561.2,17.7,561.3,17.6,561.3,17.5z
		"
      />
      <path
        class="st3"
        d="M477.5,24.5c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2c0,0,0.1,0.1,0.1,0.2
		C477.3,24.6,477.4,24.6,477.5,24.5z"
      />
      <path
        class="st3"
        d="M530.7,46.6C530.7,46.6,530.8,46.6,530.7,46.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0-0.1
		C530.8,46.6,530.8,46.6,530.7,46.6z"
      />
      <path
        class="st3"
        d="M530,46.5c0.2,0,0.5,0.1,0.7,0.1c-0.2-0.1-0.4-0.3-0.6-0.4C530.1,46.3,530.1,46.4,530,46.5z"
      />
      <path
        class="st3"
        d="M464.7,28.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.1-0.2,0.2s0.1,0.1,0.1,0.2
		C464.5,29,464.6,28.9,464.7,28.8z"
      />
      <path
        class="st3"
        d="M537.3,9.3c-0.1,0-0.1,0-0.2,0c0.1,0.1,0.1,0.2,0.2,0.4C537.3,9.6,537.3,9.5,537.3,9.3z"
      />
      <path
        class="st3"
        d="M537.4,9.9C537.4,9.9,537.4,9.8,537.4,9.9c0-0.1,0-0.1,0-0.2C537.3,9.8,537.3,9.8,537.4,9.9L537.4,9.9z"
      />
      <path
        class="st3"
        d="M432.9,36.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.3,0.2,0.4,0.3
		C432.7,36.5,432.8,36.4,432.9,36.3z"
      />
      <path
        class="st3"
        d="M576.2,63.1c0,0.4,0.1,0.7,0.1,0.9C576.8,63.8,576.4,63.5,576.2,63.1z"
      />
      <path
        class="st3"
        d="M574.1,50.8c0.1-0.1,0.1-0.2,0.1-0.2c-0.1,0-0.2,0-0.3,0s0,0.2-0.1,0.2C573.9,50.8,574,50.8,574.1,50.8z"
      />
      <path
        class="st3"
        d="M430.6,69.8c0,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0.1,0.3,0.1l0.1-0.1C430.8,69.8,430.7,69.8,430.6,69.8z"
      />
      <path
        class="st3"
        d="M491.9,57.1c0-0.1,0-0.2-0.1-0.4c0,0-0.1,0-0.1,0.1C491.8,56.9,491.8,57,491.9,57.1z"
      />
      <path
        class="st3"
        d="M479.5,41.2c-0.1-0.1-0.1-0.2-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c0,0.1,0,0.2,0,0.2
		C479.3,41.3,479.4,41.3,479.5,41.2z"
      />
      <path
        class="st3"
        d="M582.9,74c0.1,0,0.2-0.2,0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1,0.1-0.3,0.2-0.4,0.2
		C582.7,73.9,582.8,74,582.9,74z"
      />
      <path
        class="st3"
        d="M492.7,57.4c-0.2,0-0.4-0.1-0.6-0.1c0.1,0.1,0.3,0.3,0.4,0.4C492.5,57.6,492.6,57.5,492.7,57.4z"
      />
      <path
        class="st3"
        d="M492.1,57.3C492,57.3,492,57.2,492.1,57.3c-0.1-0.1-0.1-0.1-0.1-0.2v0.1C492,57.3,492,57.3,492.1,57.3z"
      />
      <path
        class="st3"
        d="M381.3,75.7c0.1,0,0.2,0,0.2-0.1v-0.1c0,0,0,0-0.1,0.1L381.3,75.7z"
      />
      <path
        class="st3"
        d="M380.8,76c0.2-0.1,0.3-0.2,0.5-0.3c-0.2,0.1-0.4,0.1-0.6,0.2C380.7,75.9,380.7,75.9,380.8,76z"
      />
      <path
        class="st3"
        d="M466,46.3l0.1,0.1l0.1-0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1-0.1-0.2-0.2-0.3-0.1C466.2,46,466,46.1,466,46.3
		C466,46.2,466,46.3,466,46.3z"
      />
      <path
        class="st3"
        d="M555.9,46.2c0.1-0.1,0.2-0.1,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2C556,45.9,555.9,46.1,555.9,46.2
		C555.8,46.1,555.8,46.2,555.9,46.2z"
      />
      <path
        class="st3"
        d="M427,41.5c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.2,0-0.3c0-0.1-0.2,0-0.3-0.1C427.1,41.4,427,41.5,427,41.5z"
      />
      <path
        class="st3"
        d="M427,63.7c-0.1,0-0.3-0.1-0.4-0.1s-0.1,0.2-0.2,0.3c0.1,0,0.3,0.1,0.4,0.1S426.9,63.9,427,63.7z"
      />
      <path
        class="st3"
        d="M526.1,22.6c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.3,0.3,0.4C526.1,23,526.1,22.8,526.1,22.6z"
      />
      <path
        class="st3"
        d="M387,95.2c0.1,0,0.2,0,0.4,0.1c0-0.1,0.1-0.2,0.1-0.3l-0.2-0.1C387.2,95,387.1,95.1,387,95.2z"
      />
      <path
        class="st3"
        d="M581.3,43.7c-0.1,0-0.2,0-0.2,0c0,0.2,0,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0C581.2,44,581.2,43.9,581.3,43.7z"
      />
      <path
        class="st3"
        d="M540.5,67.4c0.1,0,0.2,0,0.3,0.1c0-0.1,0.1-0.2,0.1-0.2S540.7,67.2,540.5,67.4
		C540.6,67.2,540.6,67.4,540.5,67.4z"
      />
      <path
        class="st3"
        d="M447.5,70.2c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.2-0.2,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.1
		C447.7,70.1,447.6,70.1,447.5,70.2z"
      />
      <path
        class="st3"
        d="M472.6,36.2h-0.1c0,0.1-0.1,0.2-0.1,0.2c0.1,0,0.2,0,0.2,0C472.5,36.4,472.6,36.3,472.6,36.2z"
      />
      <path
        class="st3"
        d="M547.6,64.8c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1,0-0.2,0.1-0.3,0.1c0.1,0.1,0.2,0.2,0.3,0.2
		C547.4,64.9,547.5,64.8,547.6,64.8z"
      />
      <path
        class="st3"
        d="M577,42.2c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2C577.1,42.1,577,42.2,577,42.2
		z"
      />
      <path
        class="st3"
        d="M594.6,38.6c0.1-0.1,0.2-0.1,0.2-0.2c0-0.1-0.1-0.1-0.1-0.2c-0.1,0.1-0.2,0.1-0.3,0.2
		C594.4,38.5,594.5,38.6,594.6,38.6z"
      />
      <path
        class="st3"
        d="M456.7,69.9c0-0.1,0.1-0.2,0.1-0.3c0-0.1-0.1-0.1-0.2-0.2l0,0l0,0c0,0,0,0,0,0.1l0,0l0,0
		c-0.1,0.1-0.2,0.3-0.3,0.4l0,0C456.4,69.9,456.5,69.9,456.7,69.9z"
      />
      <path
        class="st3"
        d="M447,56.4L447,56.4C446.9,56.3,446.9,56.3,447,56.4C446.9,56.4,446.9,56.5,447,56.4
		C447,56.4,447,56.4,447,56.4z"
      />
      <path
        class="st3"
        d="M448,55.2c-0.1,0-0.2,0.1-0.3,0.2c0.1,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C448.1,55.3,448.1,55.2,448,55.2z"
      />
      <path
        class="st3"
        d="M489.6,42.2c0.1,0.1,0.1,0.1,0.2,0.1c0.1-0.1,0.1-0.1,0.2-0.2c-0.1,0-0.2,0-0.3,0
		C489.6,42.1,489.5,42.2,489.6,42.2z"
      />
      <path
        class="st3"
        d="M382.1,73.7l-0.1-0.1l-0.1,0.1c0,0.1,0.1,0.1,0.2,0.2C382.1,73.9,382.1,73.8,382.1,73.7z"
      />
      <path
        class="st3"
        d="M381.6,75.2c-0.1,0-0.1,0.1-0.1,0.1c0,0.1,0,0.1,0,0.2C381.6,75.4,381.6,75.4,381.6,75.2
		C381.6,75.3,381.6,75.2,381.6,75.2z"
      />
      <path
        class="st3"
        d="M418.2,53.4c-0.1,0-0.2-0.1-0.2-0.1c-0.1,0-0.1,0.1-0.2,0.2c0.1,0,0.2,0,0.3,0
		C418.1,53.5,418.2,53.4,418.2,53.4z"
      />
      <path
        class="st3"
        d="M438.8,47.8c0,0-0.1,0-0.1,0.1V48c0,0,0.1,0,0.2,0C438.9,47.9,438.8,47.9,438.8,47.8z"
      />
      <path
        class="st3"
        d="M477.4,58c0.1,0,0.2,0,0.3,0l0.1-0.1c-0.1,0-0.2,0-0.3,0C477.5,57.9,477.5,58,477.4,58z"
      />
      <path
        class="st3"
        d="M454.8,63.3c-0.1,0-0.1,0-0.1,0.1c0,0,0,0.1,0.1,0.1C454.7,63.4,454.8,63.4,454.8,63.3L454.8,63.3z"
      />
      <path
        class="st3"
        d="M446.1,46.1c0,0.1,0.1,0.3,0.1,0.4c0.1-0.1,0.1-0.3,0.2-0.4C446.2,46.1,446.1,46.1,446.1,46.1z"
      />
      <path
        class="st3"
        d="M567.9,39.9L567.9,39.9C567.9,39.8,567.8,39.8,567.9,39.9h-0.2l0,0C567.7,40,567.8,40,567.9,39.9
		C567.9,40,567.9,40,567.9,39.9z"
      />
      <path
        class="st3"
        d="M469.4,40.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0C469.5,40.3,469.4,40.4,469.4,40.4z"
      />
      <path
        class="st3"
        d="M581.2,74.1c0.1-0.1,0.1-0.3,0.2-0.4c-0.1,0-0.2,0-0.3,0.1C581.1,73.8,581.1,74,581.2,74.1z"
      />
      <path
        class="st3"
        d="M581.3,73.7C581.3,73.7,581.4,73.7,581.3,73.7C581.4,73.6,581.3,73.6,581.3,73.7
		C581.3,73.6,581.3,73.6,581.3,73.7C581.3,73.6,581.3,73.7,581.3,73.7z"
      />
      <path
        class="st3"
        d="M597.1,35C597.1,35.1,597,35.1,597.1,35c-0.1,0.2-0.1,0.3-0.1,0.3S597,35.2,597.1,35
		C597.1,35.1,597.1,35.1,597.1,35z"
      />
      <path
        class="st3"
        d="M597.2,34.7c0,0.1-0.1,0.3-0.1,0.4c0.1-0.1,0.2-0.2,0.2-0.3C597.3,34.7,597.2,34.7,597.2,34.7z"
      />
      <path
        class="st3"
        d="M425.1,73.7c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0.1,0.3,0.1C425.1,73.9,425.1,73.8,425.1,73.7z"
      />
      <path
        class="st3"
        d="M579.3,73.1L579.3,73.1c0.2,0,0.2,0,0.3-0.1c-0.1,0-0.1-0.1-0.2-0.1C579.4,72.9,579.3,73,579.3,73.1z"
      />
      <path
        class="st3"
        d="M494.3,60.1l0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1C494.2,59.9,494.2,60,494.3,60.1z"
      />
      <path
        class="st3"
        d="M560.1,45.6c0,0.1,0.1,0.2,0.1,0.2l0.1-0.1C560.2,45.6,560.2,45.5,560.1,45.6
		C560.1,45.5,560.1,45.6,560.1,45.6z"
      />
      <path
        class="st3"
        d="M551.5,47.7c0.1,0,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0
		C551.6,47.6,551.6,47.6,551.5,47.7z"
      />
      <path
        class="st3"
        d="M383.4,110.7c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C383.4,110.7,383.4,110.7,383.4,110.7z"
      />
      <path
        class="st3"
        d="M415.8,78.5L415.8,78.5C415.8,78.5,415.8,78.6,415.8,78.5c0,0.1,0.1,0.2,0.1,0.2s0,0,0.1,0c0,0,0,0,0.1,0
		l0.1-0.1C416.1,78.5,416,78.5,415.8,78.5C415.9,78.5,415.9,78.5,415.8,78.5z"
      />
      <path
        class="st3"
        d="M339.8,64.1L339.8,64.1C339.8,64.2,339.9,64.2,339.8,64.1C339.9,64.2,339.8,64.1,339.8,64.1z"
      />
      <path
        class="st3"
        d="M526.3,23.3l-0.1-0.1c0,0,0,0,0-0.1v0.1C526.2,23.3,526.2,23.3,526.3,23.3z"
      />
      <path
        class="st3"
        d="M526.6,23.6c-0.1-0.1-0.2-0.2-0.3-0.3c0.1,0.1,0.1,0.2,0.2,0.4L526.6,23.6z"
      />
      <path
        class="st3"
        d="M377.8,87.8c0,0,0,0.1-0.1,0.1C377.7,87.9,377.8,87.9,377.8,87.8c0.1,0,0.2,0,0.3,0
		C378,87.8,378,87.7,377.8,87.8C377.8,87.7,377.8,87.8,377.8,87.8z"
      />
      <path
        class="st3"
        d="M377.6,88.1h0.1c0,0,0,0,0-0.1C377.7,88,377.7,88,377.6,88.1C377.6,88,377.6,88,377.6,88.1z"
      />
      <path
        class="st3"
        d="M377.3,88.4c0.1-0.1,0.2-0.2,0.3-0.3c-0.2,0.1-0.3,0.1-0.5,0.2C377.2,88.3,377.2,88.3,377.3,88.4z"
      />
      <path
        class="st3"
        d="M554.7,15.6c-0.1,0-0.2,0-0.3,0.1c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.2-0.1,0.3-0.2
		C554.8,15.6,554.8,15.6,554.7,15.6z"
      />
      <path
        class="st3"
        d="M382.9,109.9c0,0,0,0.1-0.1,0.2l0,0c0,0,0,0,0.1,0C382.9,110,382.9,110,382.9,109.9z"
      />
      <path
        class="st3"
        d="M534.9,76.2c-0.1,0.1-0.1,0.2-0.2,0.3c0.1-0.1,0.3-0.1,0.4-0.2C535.1,76.3,535,76.2,534.9,76.2z"
      />
      <path
        class="st3"
        d="M534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6C534.7,76.5,534.7,76.5,534.7,76.6
		C534.6,76.5,534.7,76.5,534.7,76.6L534.7,76.6L534.7,76.6z"
      />
      <path
        class="st3"
        d="M466.3,30.5c0,0-0.1-0.1-0.2-0.1c0,0.1-0.1,0.2,0,0.3l0.1,0.1C466.2,30.7,466.3,30.6,466.3,30.5z"
      />
      <path
        class="st3"
        d="M333.3,58.6c-0.1,0-0.2,0-0.3,0l-0.1,0.1c0.1,0,0.2,0,0.3,0C333.2,58.7,333.2,58.6,333.3,58.6z"
      />
      <path
        class="st3"
        d="M583.5,46.9c-0.1-0.1-0.1-0.1-0.1-0.2l-0.1,0.1C583.3,46.9,583.4,46.9,583.5,46.9
		C583.4,46.9,583.4,46.9,583.5,46.9z"
      />
      <path
        class="st3"
        d="M583.8,65.3c0,0.1,0.1,0.1,0.1,0.2c0.1-0.1,0.1-0.1,0.2-0.2c0-0.1-0.1-0.1-0.2-0.2
		C583.9,65.1,583.8,65.2,583.8,65.3z"
      />
      <path
        class="st3"
        d="M555.1,71c-0.2,0-0.4,0.1-0.6,0.1v0.1C554.7,71.2,554.9,71.1,555.1,71L555.1,71z"
      />
      <path
        class="st3"
        d="M334.1,58c-0.1-0.1-0.2-0.1-0.3-0.2c0,0.1,0.1,0.2,0.1,0.4C334,58.1,334,58,334.1,58z"
      />
      <path
        class="st3"
        d="M333.7,57.8C333.7,57.8,333.7,57.7,333.7,57.8c-0.1-0.1-0.1-0.1-0.1-0.1S333.7,57.7,333.7,57.8L333.7,57.8z"
      />
      <path
        class="st3"
        d="M402.8,40.6c-0.1-0.1-0.2-0.1-0.2-0.2c0,0.1,0.1,0.2,0.1,0.3C402.7,40.6,402.7,40.6,402.8,40.6z"
      />
      <path
        class="st3"
        d="M402.5,40.4L402.5,40.4l-0.1-0.1C402.4,40.3,402.4,40.3,402.5,40.4C402.5,40.3,402.5,40.4,402.5,40.4z"
      />
      <path
        class="st3"
        d="M479.1,22.8c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1,0.1c0,0.1,0.1,0.2,0.2,0.2C479,22.9,479,22.9,479.1,22.8z"
      />
      <path
        class="st3"
        d="M375.1,107.2L375.1,107.2c0,0.1,0,0.2,0.1,0.2v-0.1C375.2,107.3,375.2,107.3,375.1,107.2z"
      />
      <path
        class="st3"
        d="M576,62.8C576,62.8,576.1,62.7,576,62.8C576,62.7,575.9,62.7,576,62.8C575.9,62.7,575.9,62.7,576,62.8
		L576,62.8z"
      />
      <path
        class="st3"
        d="M426,33.8c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.3L426,33.8z"
      />
      <path
        class="st3"
        d="M534.7,61.3L534.7,61.3C534.6,61.3,534.6,61.3,534.7,61.3C534.6,61.4,534.7,61.4,534.7,61.3z"
      />
      <path
        class="st3"
        d="M550.4,68C550.5,68,550.5,68,550.4,68c0.1,0,0.2-0.1,0.2-0.2c0,0-0.1-0.1-0.2-0.1
		C550.4,67.7,550.4,67.8,550.4,68C550.4,67.9,550.4,67.9,550.4,68z"
      />
      <path
        class="st3"
        d="M463.7,77.4C463.7,77.3,463.7,77.4,463.7,77.4c-0.1,0.1,0,0.2,0,0.2l0.1-0.1C463.8,77.4,463.7,77.4,463.7,77.4
		z"
      />
      <path
        class="st3"
        d="M574.4,53.5c0,0.1,0.1,0.1,0.2,0.2v-0.1C574.6,53.4,574.5,53.4,574.4,53.5C574.5,53.4,574.4,53.4,574.4,53.5z"
      />
      <path
        class="st3"
        d="M546,60.3L546,60.3c-0.1,0-0.2,0.1-0.2,0.2c0,0,0.1,0,0.1,0.1C545.9,60.4,546,60.3,546,60.3z"
      />
      <path
        class="st3"
        d="M592.2,57.7c0-0.1,0.1-0.2,0.1-0.3l-0.1-0.1C592.2,57.4,592.1,57.5,592.2,57.7
		C592.1,57.6,592.2,57.6,592.2,57.7z"
      />
      <path
        class="st3"
        d="M413.2,29.9L413.2,29.9c0,0.1,0,0.1,0.1,0.1C413.2,30,413.2,30,413.2,29.9z"
      />
      <path
        class="st3"
        d="M385.9,101.8c0-0.1,0.1-0.1,0.1-0.2l0,0c-0.1,0-0.2,0.1-0.2,0.1C385.7,101.8,385.8,101.8,385.9,101.8
		C385.8,101.9,385.8,101.8,385.9,101.8z"
      />
      <path
        class="st3"
        d="M489.7,6.9C489.6,6.9,489.6,6.9,489.7,6.9c-0.1,0.1-0.1,0.2-0.1,0.2C489.7,7.1,489.7,7.1,489.7,6.9L489.7,6.9z
		"
      />
      <path
        class="st3"
        d="M332.4,107.4c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.1-0.1c0,0,0.1,0,0.1-0.1c0,0,0,0,0-0.1
		C332.5,107.4,332.5,107.3,332.4,107.4C332.4,107.3,332.4,107.3,332.4,107.4z"
      />
      <path
        class="st3"
        d="M461,7.8c-0.1,0-0.2-0.1-0.3-0.1c0,0.1,0.1,0.2,0.1,0.4C460.9,8,460.9,7.9,461,7.8z"
      />
      <path
        class="st3"
        d="M371.4,22.2c0-0.1-0.1-0.1-0.2-0.2c-0.1,0.1-0.2,0.2-0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.2
		C371.4,22.4,371.4,22.3,371.4,22.2z"
      />
      <path
        class="st3"
        d="M324.5,109.4C324.5,109.4,324.5,109.5,324.5,109.4c-0.1,0.1-0.1,0.1-0.1,0.2c0.1,0,0.1,0,0.2-0.1
		C324.6,109.5,324.6,109.5,324.5,109.4z"
      />
      <path
        class="st3"
        d="M445.9,83.5c0.1-0.1,0.2-0.1,0.3-0.2l-0.1-0.1c-0.1,0-0.2,0-0.3,0.1C445.9,83.4,445.9,83.5,445.9,83.5z"
      />
      <path
        class="st3"
        d="M308.3,140.4c-0.1,0.1-0.1,0.1-0.2,0.2l0,0l0,0l0,0l0,0C308.2,140.6,308.2,140.5,308.3,140.4z"
      />
      <path
        class="st3"
        d="M583.7,74.2L583.7,74.2h-0.2H583.7C583.6,74.3,583.7,74.3,583.7,74.2z"
      />
      <path
        class="st3"
        d="M306.5,133.3c0,0,0-0.1,0.1-0.1v-0.1c0,0-0.1,0-0.1,0.1V133.3z"
      />
      <path
        class="st3"
        d="M306.8,133l-0.1-0.1c0,0.1-0.1,0.2-0.1,0.2C306.7,133.1,306.7,133,306.8,133z"
      />
      <path
        class="st3"
        d="M589.7,67.8C589.7,67.8,589.6,67.8,589.7,67.8L589.7,67.8L589.7,67.8C589.6,67.8,589.7,67.8,589.7,67.8z"
      />
      <path
        class="st3"
        d="M383.1,112.7L383.1,112.7c0.1,0.1,0.1,0,0.2,0C383.2,112.7,383.1,112.7,383.1,112.7z"
      />
      <path
        class="st3"
        d="M383.1,112.8C383,112.8,383,112.8,383.1,112.8C383,112.8,383,112.9,383.1,112.8
		C383,112.9,383,112.9,383.1,112.8L383.1,112.8z"
      />
      <path
        class="st3"
        d="M560.9,73.2L560.9,73.2C560.8,73.4,560.8,73.3,560.9,73.2C560.8,73.3,560.8,73.3,560.9,73.2z"
      />
      <path
        class="st3"
        d="M376.5,112C376.6,112,376.6,112,376.5,112c0.1-0.1,0-0.2,0-0.2C376.5,111.9,376.4,111.9,376.5,112
		C376.4,112,376.5,112,376.5,112z"
      />
      <path
        class="st3"
        d="M383.9,109.7c0,0,0.1,0,0.1,0.1l0.1-0.1l-0.1-0.1C384,109.6,383.9,109.6,383.9,109.7z"
      />
      <path
        class="st3"
        d="M586.7,64.7c0.1,0,0.1,0.1,0.2,0.1c0-0.1,0-0.2,0.1-0.3l0,0C586.9,64.6,586.8,64.7,586.7,64.7z"
      />
      <path
        class="st3"
        d="M555.6,71.6L555.6,71.6c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0,0,0.1,0l0,0C555.7,71.6,555.6,71.6,555.6,71.6z"
      />
      <path
        class="st3"
        d="M587,64.6L587,64.6c0-0.1,0.1-0.2,0.1-0.3C587.1,64.4,587,64.5,587,64.6z"
      />
      <polygon class="st3" points="579.7,63.5 579.8,63.5 579.7,63.4 	" />
      <path
        class="st3"
        d="M576.1,64.3c0-0.1,0.1-0.2,0.1-0.2l0,0l0,0C576.2,64.2,576.2,64.2,576.1,64.3z"
      />
      <path
        class="st3"
        d="M385.5,104.8c0,0.1,0.1,0.1,0.1,0.2c0-0.1,0.1-0.1,0.1-0.2C385.7,104.8,385.6,104.8,385.5,104.8z"
      />
      <path
        class="st3"
        d="M385.3,104.7c0.1,0,0.1,0,0.2,0.1v-0.1C385.4,104.7,385.3,104.7,385.3,104.7z"
      />
      <path
        class="st3"
        d="M314.5,119.6c0,0.1-0.1,0.1-0.1,0.2h0.1l0.1-0.1C314.6,119.7,314.6,119.6,314.5,119.6z"
      />
      <path
        class="st3"
        d="M579.6,61.7C579.6,61.7,579.6,61.8,579.6,61.7l-0.1,0.2L579.6,61.7L579.6,61.7L579.6,61.7z"
      />
      <polygon class="st3" points="576.8,62 576.8,61.9 576.7,62 	" />
      <path
        class="st3"
        d="M389.8,99.6C389.7,99.5,389.7,99.5,389.8,99.6c-0.1-0.1-0.1-0.1-0.1-0.1s0,0,0,0.1
		C389.7,99.5,389.7,99.5,389.8,99.6z"
      />
      <path
        class="st3"
        d="M389.4,99.4c0.1,0,0.1,0,0.2,0c0,0,0,0,0-0.1C389.5,99.4,389.5,99.4,389.4,99.4z"
      />
      <polygon class="st3" points="372.4,103.1 372.4,103 372.3,103.1 	" />
      <polygon class="st3" points="338.7,108.3 338.7,108.2 338.6,108.2 	" />
      <polygon class="st3" points="394,92.2 394,92.1 393.9,92.1 	" />
      <polygon class="st3" points="459.4,77.3 459.5,77.3 459.5,77.2 	" />
      <path
        class="st3"
        d="M580.7,49.8c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C580.6,49.9,580.6,49.9,580.7,49.8z"
      />
      <path
        class="st3"
        d="M407.9,87.1c0,0.1,0,0.1-0.1,0.2v-0.1C407.9,87.2,407.9,87.1,407.9,87.1z"
      />
      <path
        class="st3"
        d="M541.7,56.5c0-0.1,0-0.1,0-0.2c-0.1,0.1-0.1,0.1-0.2,0.2C541.6,56.4,541.7,56.5,541.7,56.5z"
      />
      <polygon class="st3" points="462,73.6 462.1,73.7 462.1,73.6 	" />
      <path
        class="st3"
        d="M541.8,56.1L541.8,56.1C541.7,56.1,541.7,56.1,541.8,56.1c-0.1,0.1-0.1,0.1-0.1,0.2l0,0
		C541.7,56.2,541.8,56.1,541.8,56.1z"
      />
      <path
        class="st3"
        d="M381.7,90.4l0.1,0.1l0.1-0.1l-0.1-0.1C381.7,90.3,381.7,90.4,381.7,90.4z"
      />
      <polygon class="st3" points="552.4,48.2 552.3,48.1 552.2,48.1 	" />
      <path
        class="st3"
        d="M596.5,36.4c-0.1,0-0.2,0-0.2,0.1c0,0,0.1,0,0.1,0.1C596.4,36.5,596.4,36.4,596.5,36.4z"
      />
      <path
        class="st3"
        d="M493.1,57c0-0.1,0.1-0.2,0.1-0.3C493.1,56.9,493.1,56.9,493.1,57c-0.2,0.1-0.3,0.2-0.4,0.3l0,0c0,0,0,0,0.1,0
		C492.8,57.3,493,57.2,493.1,57z"
      />
      <path
        class="st3"
        d="M484.6,58.7c0,0-0.1,0-0.1-0.1l-0.1,0.1l0.1,0.1L484.6,58.7z"
      />
      <polygon class="st3" points="481.5,59.1 481.4,59.1 481.5,59.2 	" />
      <path
        class="st3"
        d="M488.8,55.6c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C488.7,55.7,488.8,55.6,488.8,55.6z"
      />
      <polygon class="st3" points="560.3,39.2 560.3,39.3 560.4,39.2 	" />
      <path
        class="st3"
        d="M514.7,46.3C514.7,46.3,514.6,46.3,514.7,46.3c-0.1,0-0.1,0-0.1,0.1C514.6,46.3,514.6,46.3,514.7,46.3z"
      />
      <path
        class="st3"
        d="M380.7,75.1c0,0-0.1,0-0.1,0.1v0.1C380.5,75.2,380.6,75.2,380.7,75.1C380.6,75.1,380.6,75.1,380.7,75.1z"
      />
      <path
        class="st3"
        d="M380.7,75c0,0,0,0.1-0.1,0.1C380.7,75.1,380.7,75.1,380.7,75L380.7,75z"
      />
      <path
        class="st3"
        d="M400.6,67.9c0-0.1,0-0.1,0-0.2h-0.1c0,0-0.1,0.1,0,0.1C400.5,67.9,400.5,67.9,400.6,67.9z"
      />
      <polygon class="st3" points="333.4,82.4 333.6,82.4 333.4,82.3 	" />
      <path
        class="st3"
        d="M434.7,49.5h0.1l0.1-0.1l-0.1-0.1C434.7,49.4,434.7,49.5,434.7,49.5z"
      />
      <path
        class="st3"
        d="M575.6,17.7c-0.1,0-0.2,0-0.2,0.1l0.1,0.1C575.6,17.8,575.6,17.7,575.6,17.7z"
      />
      <polygon class="st3" points="438.4,47 438.3,47.1 438.4,47.1 	" />
      <polygon class="st3" points="445.9,44.9 446,44.9 446,44.8 	" />
      <polygon class="st3" points="548.7,22.2 548.6,22.3 548.7,22.3 	" />
      <path
        class="st3"
        d="M434.3,47.1L434.3,47.1C434.3,46.9,434.3,46.9,434.3,47.1C434.2,47,434.3,47,434.3,47.1z"
      />
      <path
        class="st3"
        d="M421.4,49.6C421.3,49.6,421.3,49.6,421.4,49.6C421.3,49.5,421.3,49.6,421.4,49.6
		C421.3,49.6,421.3,49.6,421.4,49.6z"
      />
      <path
        class="st3"
        d="M575.8,13c0,0-0.1,0-0.2-0.1c0,0.1,0,0.1,0.1,0.2C575.7,13,575.7,13,575.8,13z"
      />
      <path
        class="st3"
        d="M376.5,53.5h-0.1v0.1l0.1,0.1C376.5,53.7,376.5,53.6,376.5,53.5z"
      />
      <path
        class="st3"
        d="M412.9,42.9l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C412.8,43,412.8,42.9,412.9,42.9z"
      />
      <path class="st3" d="M465.4,30.3l-0.1-0.1l-0.1,0.1l0.1,0.1L465.4,30.3z" />
      <polygon class="st3" points="427.4,38.2 427.3,38.3 427.4,38.3 	" />
      <polygon class="st3" points="445.3,33.7 445.5,33.7 445.4,33.6 	" />
      <path
        class="st3"
        d="M463.2,29.2l-0.1-0.1l-0.1,0.1c0,0,0.1,0,0.1,0.1C463.2,29.2,463.2,29.2,463.2,29.2z"
      />
      <path
        class="st3"
        d="M402.2,40.2L402.2,40.2c0.1,0.1,0.1,0.1,0.2,0.1C402.3,40.2,402.3,40.2,402.2,40.2z"
      />
      <path
        class="st3"
        d="M462,25.3l0.1-0.1v-0.1l-0.1,0.1C462.1,25.2,462,25.3,462,25.3z"
      />
      <path
        class="st3"
        d="M524.3,179.8c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0.1-0.1,0.1-0.1,0.1-0.2c-0.1,0-0.2,0-0.3,0.1
		C524.5,179.7,524.4,179.7,524.3,179.8z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: "TrackCover_c2",
  props: ["fill"],
};
</script>
